(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("h358J", function(module, exports) {

$parcel$export(module.exports, "_", function () { return g; });
$parcel$export(module.exports, "g", function () { return b; });
$parcel$export(module.exports, "P", function () { return P; });
$parcel$export(module.exports, "at", function () { return D; });
$parcel$export(module.exports, "a7", function () { return j; });
$parcel$export(module.exports, "V", function () { return B; });
$parcel$export(module.exports, "a0", function () { return _; });
$parcel$export(module.exports, "$", function () { return G; });
$parcel$export(module.exports, "W", function () { return q; });
$parcel$export(module.exports, "U", function () { return $; });
$parcel$export(module.exports, "ae", function () { return Q; });
$parcel$export(module.exports, "a2", function () { return et; });
$parcel$export(module.exports, "e", function () { return pt; });
$parcel$export(module.exports, "a1", function () { return vt; });
$parcel$export(module.exports, "av", function () { return St; });
$parcel$export(module.exports, "G", function () { return kt; });
$parcel$export(module.exports, "Y", function () { return Et; });
$parcel$export(module.exports, "m", function () { return Rt; });
$parcel$export(module.exports, "Z", function () { return Lt; });
$parcel$export(module.exports, "r", function () { return jt; });
$parcel$export(module.exports, "L", function () { return Gt; });
$parcel$export(module.exports, "ap", function () { return qt; });
$parcel$export(module.exports, "M", function () { return ie; });
$parcel$export(module.exports, "v", function () { return ne; });
$parcel$export(module.exports, "a3", function () { return se; });
$parcel$export(module.exports, "o", function () { return ae; });
$parcel$export(module.exports, "az", function () { return le; });
$parcel$export(module.exports, "B", function () { return he; });
$parcel$export(module.exports, "ag", function () { return Re; });
$parcel$export(module.exports, "c", function () { return Le; });
$parcel$export(module.exports, "h", function () { return Oe; });
$parcel$export(module.exports, "X", function () { return je; });
$parcel$export(module.exports, "ao", function () { return Ie; });
$parcel$export(module.exports, "T", function () { return ze; });
$parcel$export(module.exports, "I", function () { return Ue; });
$parcel$export(module.exports, "af", function () { return Ke; });
$parcel$export(module.exports, "s", function () { return ei; });
$parcel$export(module.exports, "j", function () { return li; });
$parcel$export(module.exports, "f", function () { return di; });
$parcel$export(module.exports, "au", function () { return ui; });
$parcel$export(module.exports, "z", function () { return pi; });
$parcel$export(module.exports, "N", function () { return mi; });
$parcel$export(module.exports, "u", function () { return yi; });
$parcel$export(module.exports, "d", function () { return Si; });
$parcel$export(module.exports, "x", function () { return ki; });
$parcel$export(module.exports, "l", function () { return Ai; });
$parcel$export(module.exports, "a4", function () { return Mi; });
$parcel$export(module.exports, "n", function () { return Fi; });
$parcel$export(module.exports, "ay", function () { return Hi; });
$parcel$export(module.exports, "ai", function () { return Ui; });
$parcel$export(module.exports, "O", function () { return Wi; });
$parcel$export(module.exports, "R", function () { return Yi; });
$parcel$export(module.exports, "p", function () { return _i; });
$parcel$export(module.exports, "k", function () { return Xi; });
$parcel$export(module.exports, "K", function () { return $i; });
$parcel$export(module.exports, "F", function () { return Zi; });
$parcel$export(module.exports, "H", function () { return Qi; });
$parcel$export(module.exports, "A", function () { return Ln; });
$parcel$export(module.exports, "t", function () { return On; });
$parcel$export(module.exports, "a6", function () { return Dn; });
$parcel$export(module.exports, "D", function () { return jn; });
$parcel$export(module.exports, "J", function () { return Nn; });
$parcel$export(module.exports, "E", function () { return sr; });
$parcel$export(module.exports, "a5", function () { return ar; });
$parcel$export(module.exports, "w", function () { return lr; });
$parcel$export(module.exports, "a8", function () { return kr; });
$parcel$export(module.exports, "aa", function () { return Or; });
$parcel$export(module.exports, "a9", function () { return Hr; });
$parcel$export(module.exports, "ab", function () { return _r; });
$parcel$export(module.exports, "ac", function () { return Vr; });
$parcel$export(module.exports, "ad", function () { return Qr; });
$parcel$export(module.exports, "ax", function () { return io; });
$parcel$export(module.exports, "i", function () { return Ao; });
$parcel$export(module.exports, "aj", function () { return Eo; });
$parcel$export(module.exports, "al", function () { return Mo; });
$parcel$export(module.exports, "S", function () { return Po; });
$parcel$export(module.exports, "Q", function () { return Ro; });
$parcel$export(module.exports, "b", function () { return Ua; });
$parcel$export(module.exports, "a", function () { return Wa; });
$parcel$export(module.exports, "ar", function () { return Ga; });
$parcel$export(module.exports, "aq", function () { return qa; });
$parcel$export(module.exports, "ah", function () { return Va; });
$parcel$export(module.exports, "ak", function () { return Ka; });
$parcel$export(module.exports, "am", function () { return Za; });
$parcel$export(module.exports, "aw", function () { return Ja; });
$parcel$export(module.exports, "as", function () { return nl; });
$parcel$export(module.exports, "an", function () { return hl; });
$parcel$export(module.exports, "y", function () { return Pd; });
$parcel$export(module.exports, "q", function () { return zp; });
$parcel$export(module.exports, "C", function () { return Eg; });
var t = "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e = Object.defineProperty, i = (t, i, n)=>(((t, i, n)=>{
        i in t ? e(t, i, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
        }) : t[i] = n;
    })(t, "symbol" != typeof i ? i + "" : i, n), n);
const n = {
    stringify: (t)=>`${t}`,
    parse: (t)=>parseFloat(t)
}, r = {
    stringify: (t)=>t.name,
    parse: (e, i)=>{
        const n = typeof window < "u" && e in window ? window[e] : typeof t < "u" && e in t ? t[e] : void 0;
        return "function" == typeof n ? n.bind(i) : void 0;
    }
}, o = {
    stringify: (t)=>JSON.stringify(t),
    parse: (t)=>JSON.parse(t)
}, s = {
    string: {
        stringify: (t)=>t,
        parse: (t)=>t
    },
    number: n,
    boolean: {
        stringify: (t)=>t ? "true" : "false",
        parse: (t)=>/^[ty1-9]/i.test(t)
    },
    function: r,
    json: o
}, a = Symbol.for("r2wc.render"), l = Symbol.for("r2wc.connected"), h = Symbol.for("r2wc.context"), c = Symbol.for("r2wc.props");
function d(t, e, n) {
    var r, o, d;
    e.props || (e.props = t.propTypes ? Object.keys(t.propTypes) : []);
    const p = (Array.isArray(e.props) ? e.props.slice() : Object.keys(e.props)).filter((t)=>"container" !== t), f = {}, g = {}, m = {};
    for (const t of p){
        f[t] = Array.isArray(e.props) ? "string" : e.props[t];
        const i = u(t);
        g[t] = i, m[i] = t;
    }
    class b extends HTMLElement {
        constructor(){
            super(), i(this, r, !0), i(this, o), i(this, d, {}), i(this, "container"), e.shadow ? this.container = this.attachShadow({
                mode: e.shadow
            }) : this.container = this, this[c].container = this.container;
            for (const t of p){
                const e = g[t], i = this.getAttribute(e), n = f[t], r = s[n];
                i && null != r && r.parse && (this[c][t] = r.parse(i, this));
            }
        }
        static get observedAttributes() {
            return Object.keys(m);
        }
        connectedCallback() {
            this[l] = !0, this[a]();
        }
        disconnectedCallback() {
            this[l] = !1, this[h] && n.unmount(this[h]), delete this[h];
        }
        attributeChangedCallback(t, e, i) {
            const n = m[t], r = f[n], o = s[r];
            n in f && null != o && o.parse && (this[c][n] = o.parse(i, this), this[a]());
        }
        [(r = l, o = h, d = c, a)]() {
            this[l] && (this[h] ? n.update(this[h], this[c]) : this[h] = n.mount(this.container, t, this[c]));
        }
    }
    for (const t of p){
        const e = g[t], i = f[t];
        Object.defineProperty(b.prototype, t, {
            enumerable: !0,
            configurable: !0,
            get () {
                return this[c][t];
            },
            set (n) {
                this[c][t] = n;
                const r = s[i];
                if (null != r && r.stringify) {
                    const t = r.stringify(n);
                    this.getAttribute(e) !== t && this.setAttribute(e, t);
                }
            }
        });
    }
    return b;
}
function u(t = "") {
    return t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function p(t, e, i, n = {}) {
    return d(t, n, {
        mount: function(t, n, r) {
            const o = e.createElement(n, r);
            if ("createRoot" in i) {
                const e = i.createRoot(t);
                return e.render(o), {
                    container: t,
                    root: e,
                    ReactComponent: n
                };
            }
            if ("render" in i) return i.render(o, t), {
                container: t,
                ReactComponent: n
            };
            throw new Error("Invalid ReactDOM instance provided.");
        },
        unmount: function({ container: t, root: e }) {
            e ? e.unmount() : "unmountComponentAtNode" in i && i.unmountComponentAtNode(t);
        },
        update: function({ container: t, root: n, ReactComponent: r }, o) {
            const s = e.createElement(r, o);
            n ? n.render(s) : "render" in i && i.render(s, t);
        }
    });
}
function f(t, e) {
    void 0 === e && (e = {});
    var i = e.insertAt;
    if (t && "undefined" != typeof document) {
        var n = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
        r.type = "text/css", "top" === i && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = t : r.appendChild(document.createTextNode(t));
    }
}
f(".rc-slider {\n  position: relative;\n  width: 100%;\n  height: 14px;\n  padding: 5px 0;\n  border-radius: 6px;\n  touch-action: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider * {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background-color: #e9e9e9;\n  border-radius: 6px;\n}\n.rc-slider-track,\n.rc-slider-tracks {\n  position: absolute;\n  height: 4px;\n  background-color: #abe2fb;\n  border-radius: 6px;\n}\n.rc-slider-track-draggable {\n  z-index: 1;\n  box-sizing: content-box;\n  background-clip: content-box;\n  border-top: 5px solid rgba(0, 0, 0, 0);\n  border-bottom: 5px solid rgba(0, 0, 0, 0);\n  transform: translateY(-5px);\n}\n.rc-slider-handle {\n  position: absolute;\n  z-index: 1;\n  width: 14px;\n  height: 14px;\n  margin-top: -5px;\n  background-color: #fff;\n  border: solid 2px #96dbfa;\n  border-radius: 50%;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  cursor: grab;\n  opacity: 0.8;\n  user-select: none;\n  touch-action: pan-x;\n}\n.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: #57c5f7;\n  box-shadow: 0 0 0 5px #96dbfa;\n}\n.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging-delete {\n  opacity: 0;\n}\n.rc-slider-handle:focus {\n  outline: none;\n  box-shadow: none;\n}\n.rc-slider-handle:focus-visible {\n  border-color: #2db7f5;\n  box-shadow: 0 0 0 3px #96dbfa;\n}\n.rc-slider-handle-click-focused:focus {\n  border-color: #96dbfa;\n  box-shadow: unset;\n}\n.rc-slider-handle:hover {\n  border-color: #57c5f7;\n}\n.rc-slider-handle:active {\n  border-color: #57c5f7;\n  box-shadow: 0 0 5px #57c5f7;\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n.rc-slider-mark {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  width: 100%;\n  font-size: 12px;\n}\n.rc-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  color: #999;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.rc-slider-mark-text-active {\n  color: #666;\n}\n.rc-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n.rc-slider-dot {\n  position: absolute;\n  bottom: -2px;\n  width: 8px;\n  height: 8px;\n  vertical-align: middle;\n  background-color: #fff;\n  border: 2px solid #e9e9e9;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.rc-slider-dot-active {\n  border-color: #96dbfa;\n}\n.rc-slider-dot-reverse {\n  margin-right: -4px;\n}\n.rc-slider-disabled {\n  background-color: #e9e9e9;\n}\n.rc-slider-disabled .rc-slider-track {\n  background-color: #ccc;\n}\n.rc-slider-disabled .rc-slider-handle,\n.rc-slider-disabled .rc-slider-dot {\n  background-color: #fff;\n  border-color: #ccc;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.rc-slider-disabled .rc-slider-mark-text,\n.rc-slider-disabled .rc-slider-dot {\n  cursor: not-allowed !important;\n}\n.rc-slider-vertical {\n  width: 14px;\n  height: 100%;\n  padding: 0 5px;\n}\n.rc-slider-vertical .rc-slider-rail {\n  width: 4px;\n  height: 100%;\n}\n.rc-slider-vertical .rc-slider-track {\n  bottom: 0;\n  left: 5px;\n  width: 4px;\n}\n.rc-slider-vertical .rc-slider-track-draggable {\n  border-top: 0;\n  border-right: 5px solid rgba(0, 0, 0, 0);\n  border-bottom: 0;\n  border-left: 5px solid rgba(0, 0, 0, 0);\n  transform: translateX(-5px);\n}\n.rc-slider-vertical .rc-slider-handle {\n  position: absolute;\n  z-index: 1;\n  margin-top: 0;\n  margin-left: -5px;\n  touch-action: pan-y;\n}\n.rc-slider-vertical .rc-slider-mark {\n  top: 0;\n  left: 18px;\n  height: 100%;\n}\n.rc-slider-vertical .rc-slider-step {\n  width: 4px;\n  height: 100%;\n}\n.rc-slider-vertical .rc-slider-dot {\n  margin-left: -2px;\n}\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  display: block !important;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.rc-slider-tooltip-zoom-down-leave {\n  display: block !important;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-play-state: paused;\n}\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n  animation-name: rcSliderTooltipZoomDownIn;\n  animation-play-state: running;\n}\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n  animation-name: rcSliderTooltipZoomDownOut;\n  animation-play-state: running;\n}\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  transform: scale(0, 0);\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.rc-slider-tooltip-zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    transform: scale(0, 0);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1, 1);\n    transform-origin: 50% 100%;\n  }\n}\n@keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    transform: scale(1, 1);\n    transform-origin: 50% 100%;\n  }\n  100% {\n    transform: scale(0, 0);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n}\n.rc-slider-tooltip {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  visibility: visible;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-tooltip * {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-tooltip-hidden {\n  display: none;\n}\n.rc-slider-tooltip-placement-top {\n  padding: 4px 0 8px 0;\n}\n.rc-slider-tooltip-inner {\n  min-width: 24px;\n  height: 24px;\n  padding: 6px 2px;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  background-color: #6c6c6c;\n  border-radius: 6px;\n  box-shadow: 0 0 4px #d9d9d9;\n}\n.rc-slider-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  bottom: 4px;\n  left: 50%;\n  margin-left: -4px;\n  border-width: 4px 4px 0;\n  border-top-color: #6c6c6c;\n}\n");
function g() {
    return g = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)({}).hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, g.apply(null, arguments);
}
f("@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Display:wght@400;500&family=Noto+Sans:wght@400;600;800&display=swap');\r\n\r\n.cb-container {\r\n  padding: 22px 24px;\r\n  font-family: 'Noto Sans Display', Helvetica, sans-serif;\r\n  color: #101d40;\r\n  background-color: #fff;\r\n}\r\n.cb-container.cb-small {\r\n  padding: 16px 18px;\r\n}\r\n\r\n.cb-container p,\r\n.cb-container ul {\r\n  margin: 0px;\r\n}\r\n\r\n.cb-title {\r\n  font-family: Helvetica, sans-serif;\r\n  font-weight: 800;\r\n  letter-spacing: -0.764px;\r\n  font-size: 18px;\r\n  line-height: 22px;\r\n}\r\n\r\n.cb-title.cb-font-loaded {\r\n  font-family: 'Noto Sans', Helvetica, sans-serif;\r\n  letter-spacing: unset;\r\n}\r\n\r\n.cb-container.cb-small .cb-title {\r\n  letter-spacing: 0.098px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  line-height: 18px;\r\n}\r\n\r\n.cb-container.cb-small .cb-title.cb-font-loaded {\r\n  letter-spacing: unset;\r\n}\r\n\r\n.cb-subtitle {\r\n  font-family: Helvetica, sans-serif;\r\n  letter-spacing: 0.21px;\r\n  font-weight: 500;\r\n  font-size: 17px;\r\n  line-height: 22px;\r\n  color: #586179;\r\n}\r\n\r\n.cb-subtitle.cb-font-loaded {\r\n  font-family: 'Noto Sans Display', Helvetica, sans-serif;\r\n  letter-spacing: unset;\r\n}\r\n\r\n.cb-container.cb-small .cb-subtitle {\r\n  letter-spacing: 0.098px;\r\n  font-size: 15px;\r\n  line-height: 18px;\r\n}\r\n\r\n.cb-container.cb-small .cb-subtitle.cb-font-loaded {\r\n  letter-spacing: unset;\r\n}\r\n\r\n.cb-tool {\r\n  width: 44px;\r\n  height: 44px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #ffffff;\r\n  border: 1px solid #dee3e9;\r\n  transition: border 150ms;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n.cb-tool svg {\r\n  fill: #156df9;\r\n}\r\n.cb-tool:hover,\r\n.cb-tool:focus {\r\n  border: 1px solid #156df9;\r\n}\r\n.cb-tool {\r\n  margin-left: 8px;\r\n}\r\n.cb-tool.cb-small {\r\n  margin-left: 4px;\r\n}\r\n.cb-container.cb-small .cb-tool,\r\n.cb-toolbox.cb-small .cb-tool {\r\n  width: 36px;\r\n  height: 36px;\r\n  margin-bottom: 4px;\r\n}\r\n.cb-toolbox .cb-tool {\r\n  margin-bottom: 8px;\r\n}\r\n.cb-tool.cb-disabled {\r\n  cursor: default;\r\n}\r\n.cb-tool.cb-disabled:hover,\r\n.cb-tool.cb-disabled:focus {\r\n  border: 1px solid #dee3e9;\r\n}\r\n.cb-tool.cb-disabled svg {\r\n  fill: #dee3e9;\r\n}\r\n\r\n.cb-floating {\r\n  font-family: 'Noto Sans', Helvetica, sans-serif;\r\n  font-size: 14px;\r\n  line-height: 18px;\r\n  border: 1px solid #dee3e9;\r\n  border-radius: 4px;\r\n  color: #586179;\r\n  background-color: #ffffffe6;\r\n  z-index: 701;\r\n}\r\n\r\n.cb-tooltip {\r\n  padding: 5px 8px;\r\n  max-width: 300px;\r\n}\r\n.cb-tooltip p,\r\n.cb-tooltip ul {\r\n  margin: 0px;\r\n}\r\n\r\n.cb-footer {\r\n  font-family: Helvetica, sans-serif;\r\n  letter-spacing: 0.44px;\r\n  font-size: 14px;\r\n  line-height: 18px;\r\n  color: #586179;\r\n}\r\n\r\n.cb-footer.cb-font-loaded {\r\n  font-family: 'Noto Sans', Helvetica, sans-serif;\r\n  letter-spacing: unset;\r\n}\r\n\r\n.cb-container.cb-small .cb-footer {\r\n  letter-spacing: 0.34px;\r\n  font-size: 13px;\r\n  line-height: 16px;\r\n}\r\n\r\n.cb-container.cb-small .cb-footer.cb-font-loaded {\r\n  letter-spacing: unset;\r\n}\r\n\r\n.cb-footer p {\r\n  padding-top: 5px;\r\n}\r\n.cb-footer p:first-of-type {\r\n  padding-top: 10px;\r\n}\r\n\r\n.cb-controls {\r\n  padding: 10px 16px 16px 16px;\r\n}\r\n.cb-controls.cb-small {\r\n  padding: 10px;\r\n}\r\n.cb-controls-separator {\r\n  height: 1px;\r\n  background-color: #dee3e9;\r\n  margin: 0px 24px;\r\n}\r\n.cb-controls-separator.cb-small {\r\n  margin: 0px 18px;\r\n}\r\n\r\n.cb-control {\r\n  font-family: 'Noto Sans', Helvetica, sans-serif;\r\n  font-size: 14px;\r\n  flex: 1;\r\n  padding: 5px 8px;\r\n  min-width: 200px;\r\n}\r\n.cb-control-standalone {\r\n  font-family: 'Noto Sans', Helvetica, sans-serif;\r\n  font-size: 14px;\r\n  flex: 1;\r\n  min-width: 200px;\r\n}\r\n\r\n.cb-control-label {\r\n  color: #586179;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  margin-bottom: 4px;\r\n  line-height: 1;\r\n}\r\n\r\n.cb-control .cb-star-container,\r\n.cb-control-standalone .cb-star-container {\r\n  max-height: 21px;\r\n  max-height: 21px;\r\n  cursor: pointer;\r\n  padding: 0px 0px 0px 10px;\r\n  padding: 0px 0px 0px 10px;\r\n}\r\n.cb-control .cb-star-container svg,\r\n.cb-control-standalone .cb-star-container svg {\r\n  fill: #586179;\r\n}\r\n.cb-control .cb-star-container:hover svg,\r\n.cb-control-standalone .cb-star-container:hover svg {\r\n  fill: #156df9;\r\n}\r\n.cb-control-select-magnifying-glass {\r\n  width: 16px;\r\n  max-height: 16px;\r\n}\r\n.cb-control-select-magnifying-glass:hover svg {\r\n  fill: #586179b3 !important;\r\n}\r\n\r\n.cb-control-select-option-multi {\r\n  padding: 4px 7px;\r\n}\r\n\r\n.cb-control-select-option-multi-standalone {\r\n  padding: 8px 17px;\r\n}\r\n\r\n.cb-control-select-option-multi-check {\r\n  width: 21px;\r\n  height: 21px;\r\n  padding: 1px 0px 0px 1px;\r\n  border: 1px solid #c2cbd6;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n}\r\n.cb-control-select-option-multi:hover .cb-control-select-option-multi-check,\r\n.cb-control-select-option-multi:hover .cb-control-select-option-multi-check,\r\n.cb-control-select-option-multi-standalone:hover\r\n  .cb-control-select-option-multi-check {\r\n  transition: border-color 150ms;\r\n  border-color: #156df9;\r\n}\r\n\r\n.cb-control .rc-slider-handle-dragging,\r\n.cb-control-standalone .rc-slider-handle-dragging {\r\n  box-shadow: 0px 0px 4px 2px #156df9 !important;\r\n}\r\n\r\n.cb-control .rc-slider-horizontal,\r\n.cb-control-standalone .rc-slider-horizontal {\r\n  padding: 5px 0px;\r\n}\r\n\r\n.cb-control-standalone .rc-slider-horizontal {\r\n  padding: 16px 0px;\r\n}\r\n\r\n@keyframes cb-rotate {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.cb-spinner-animation {\r\n  animation: cb-rotate 600ms infinite linear;\r\n}\r\n\r\n.cb-frequency-button {\r\n  height: 35px;\r\n  padding: 0px 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #586179;\r\n  background-color: #ffffff;\r\n  border: 1px solid #dee3e9;\r\n  border-radius: 4px;\r\n  transition: border 150ms;\r\n  margin-right: 8px;\r\n  cursor: pointer;\r\n}\r\n.cb-frequency-button:hover {\r\n  border: 1px solid #156df9;\r\n}\r\n.cb-frequency-button-selected,\r\n.cb-frequency-button-selected:hover {\r\n  color: #ffffff;\r\n  background-color: #156df9;\r\n}\r\n");
var m = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function b(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function y(t) {
    if (t.__esModule) return t;
    var e = t.default;
    if ("function" == typeof e) {
        var i = function t() {
            return this instanceof t ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        i.prototype = e.prototype;
    } else i = {};
    return Object.defineProperty(i, "__esModule", {
        value: !0
    }), Object.keys(t).forEach(function(e) {
        var n = Object.getOwnPropertyDescriptor(t, e);
        Object.defineProperty(i, e, n.get ? n : {
            enumerable: !0,
            get: function() {
                return t[e];
            }
        });
    }), i;
}
var x, v, w, C, S, k = {
    exports: {}
};
function A() {
    if (v) return x;
    v = 1;
    return x = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function E() {
    if (C) return w;
    C = 1;
    var t = A();
    function e() {}
    function i() {}
    return i.resetWarningCache = e, w = function() {
        function n(e, i, n, r, o, s) {
            if (s !== t) {
                var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw a.name = "Invariant Violation", a;
            }
        }
        function r() {
            return n;
        }
        n.isRequired = n;
        var o = {
            array: n,
            bigint: n,
            bool: n,
            func: n,
            number: n,
            object: n,
            string: n,
            symbol: n,
            any: n,
            arrayOf: r,
            element: n,
            elementType: n,
            instanceOf: r,
            node: n,
            objectOf: r,
            oneOf: r,
            oneOfType: r,
            shape: r,
            exact: r,
            checkPropTypes: i,
            resetWarningCache: e
        };
        return o.PropTypes = o, o;
    };
}
function M() {
    return S || (S = 1, k.exports = E()()), k.exports;
}
var T, P = b(M()), R = {
    exports: {}
}, L = React;
var O = (T || (T = 1, (()=>{
    var t = {
        181: (t, e, i)=>{
            var n = /^\s+|\s+$/g, r = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt, l = "object" == typeof i.g && i.g && i.g.Object === Object && i.g, h = "object" == typeof self && self && self.Object === Object && self, c = l || h || Function("return this")(), d = Object.prototype.toString, u = Math.max, p = Math.min, f = function() {
                return c.Date.now();
            };
            function g(t) {
                var e = typeof t;
                return !!t && ("object" == e || "function" == e);
            }
            function m(t) {
                if ("number" == typeof t) return t;
                if (function(t) {
                    return "symbol" == typeof t || function(t) {
                        return !!t && "object" == typeof t;
                    }(t) && "[object Symbol]" == d.call(t);
                }(t)) return NaN;
                if (g(t)) {
                    var e = "function" == typeof t.valueOf ? t.valueOf() : t;
                    t = g(e) ? e + "" : e;
                }
                if ("string" != typeof t) return 0 === t ? t : +t;
                t = t.replace(n, "");
                var i = o.test(t);
                return i || s.test(t) ? a(t.slice(2), i ? 2 : 8) : r.test(t) ? NaN : +t;
            }
            t.exports = function(t, e, i) {
                var n, r, o, s, a, l, h = 0, c = !1, d = !1, b = !0;
                if ("function" != typeof t) throw new TypeError("Expected a function");
                function y(e) {
                    var i = n, o = r;
                    return n = r = void 0, h = e, s = t.apply(o, i);
                }
                function x(t) {
                    var i = t - l;
                    return void 0 === l || i >= e || i < 0 || d && t - h >= o;
                }
                function v() {
                    var t = f();
                    if (x(t)) return w(t);
                    a = setTimeout(v, function(t) {
                        var i = e - (t - l);
                        return d ? p(i, o - (t - h)) : i;
                    }(t));
                }
                function w(t) {
                    return a = void 0, b && n ? y(t) : (n = r = void 0, s);
                }
                function C() {
                    var t = f(), i = x(t);
                    if (n = arguments, r = this, l = t, i) {
                        if (void 0 === a) return function(t) {
                            return h = t, a = setTimeout(v, e), c ? y(t) : s;
                        }(l);
                        if (d) return a = setTimeout(v, e), y(l);
                    }
                    return void 0 === a && (a = setTimeout(v, e)), s;
                }
                return e = m(e) || 0, g(i) && (c = !!i.leading, o = (d = "maxWait" in i) ? u(m(i.maxWait) || 0, e) : o, b = "trailing" in i ? !!i.trailing : b), C.cancel = function() {
                    void 0 !== a && clearTimeout(a), h = 0, n = l = r = a = void 0;
                }, C.flush = function() {
                    return void 0 === a ? s : w(f());
                }, C;
            };
        },
        858: (t, e, i)=>{
            var n = "Expected a function", r = /^\s+|\s+$/g, o = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, a = /^0o[0-7]+$/i, l = parseInt, h = "object" == typeof i.g && i.g && i.g.Object === Object && i.g, c = "object" == typeof self && self && self.Object === Object && self, d = h || c || Function("return this")(), u = Object.prototype.toString, p = Math.max, f = Math.min, g = function() {
                return d.Date.now();
            };
            function m(t) {
                var e = typeof t;
                return !!t && ("object" == e || "function" == e);
            }
            function b(t) {
                if ("number" == typeof t) return t;
                if (function(t) {
                    return "symbol" == typeof t || function(t) {
                        return !!t && "object" == typeof t;
                    }(t) && "[object Symbol]" == u.call(t);
                }(t)) return NaN;
                if (m(t)) {
                    var e = "function" == typeof t.valueOf ? t.valueOf() : t;
                    t = m(e) ? e + "" : e;
                }
                if ("string" != typeof t) return 0 === t ? t : +t;
                t = t.replace(r, "");
                var i = s.test(t);
                return i || a.test(t) ? l(t.slice(2), i ? 2 : 8) : o.test(t) ? NaN : +t;
            }
            t.exports = function(t, e, i) {
                var r = !0, o = !0;
                if ("function" != typeof t) throw new TypeError(n);
                return m(i) && (r = "leading" in i ? !!i.leading : r, o = "trailing" in i ? !!i.trailing : o), function(t, e, i) {
                    var r, o, s, a, l, h, c = 0, d = !1, u = !1, y = !0;
                    if ("function" != typeof t) throw new TypeError(n);
                    function x(e) {
                        var i = r, n = o;
                        return r = o = void 0, c = e, a = t.apply(n, i);
                    }
                    function v(t) {
                        var i = t - h;
                        return void 0 === h || i >= e || i < 0 || u && t - c >= s;
                    }
                    function w() {
                        var t = g();
                        if (v(t)) return C(t);
                        l = setTimeout(w, function(t) {
                            var i = e - (t - h);
                            return u ? f(i, s - (t - c)) : i;
                        }(t));
                    }
                    function C(t) {
                        return l = void 0, y && r ? x(t) : (r = o = void 0, a);
                    }
                    function S() {
                        var t = g(), i = v(t);
                        if (r = arguments, o = this, h = t, i) {
                            if (void 0 === l) return function(t) {
                                return c = t, l = setTimeout(w, e), d ? x(t) : a;
                            }(h);
                            if (u) return l = setTimeout(w, e), x(h);
                        }
                        return void 0 === l && (l = setTimeout(w, e)), a;
                    }
                    return e = b(e) || 0, m(i) && (d = !!i.leading, s = (u = "maxWait" in i) ? p(b(i.maxWait) || 0, e) : s, y = "trailing" in i ? !!i.trailing : y), S.cancel = function() {
                        void 0 !== l && clearTimeout(l), c = 0, r = h = o = l = void 0;
                    }, S.flush = function() {
                        return void 0 === l ? a : C(g());
                    }, S;
                }(t, e, {
                    leading: r,
                    maxWait: e,
                    trailing: o
                });
            };
        },
        694: (t, e, i)=>{
            var n = i(925);
            function r() {}
            function o() {}
            o.resetWarningCache = r, t.exports = function() {
                function t(t, e, i, r, o, s) {
                    if (s !== n) {
                        var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw a.name = "Invariant Violation", a;
                    }
                }
                function e() {
                    return t;
                }
                t.isRequired = t;
                var i = {
                    array: t,
                    bigint: t,
                    bool: t,
                    func: t,
                    number: t,
                    object: t,
                    string: t,
                    symbol: t,
                    any: t,
                    arrayOf: e,
                    element: t,
                    elementType: t,
                    instanceOf: e,
                    node: t,
                    objectOf: e,
                    oneOf: e,
                    oneOfType: e,
                    shape: e,
                    exact: e,
                    checkPropTypes: o,
                    resetWarningCache: r
                };
                return i.PropTypes = i, i;
            };
        },
        556: (t, e, i)=>{
            t.exports = i(694)();
        },
        925: (t)=>{
            t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }
    }, e = {};
    function i(n) {
        var r = e[n];
        if (void 0 !== r) return r.exports;
        var o = e[n] = {
            exports: {}
        };
        return t[n](o, o.exports, i), o.exports;
    }
    i.n = (t)=>{
        var e = t && t.__esModule ? ()=>t.default : ()=>t;
        return i.d(e, {
            a: e
        }), e;
    }, i.d = (t, e)=>{
        for(var n in e)i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, {
            enumerable: !0,
            get: e[n]
        });
    }, i.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (t) {
            if ("object" == typeof window) return window;
        }
    }(), i.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), i.r = (t)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    };
    var n = {};
    (()=>{
        i.r(n), i.d(n, {
            LazyLoadComponent: ()=>Q,
            LazyLoadImage: ()=>dt,
            trackWindowScroll: ()=>I
        });
        const t = L;
        var e = i.n(t), r = i(556);
        function o() {
            return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
        }
        function s(t) {
            return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, s(t);
        }
        function a(t, e) {
            var i = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), i.push.apply(i, n);
            }
            return i;
        }
        function l(t, e, i) {
            return (e = h(e)) in t ? Object.defineProperty(t, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = i, t;
        }
        function h(t) {
            var e = function(t, e) {
                if ("object" != s(t) || !t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var n = i.call(t, "string");
                    if ("object" != s(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == s(e) ? e : e + "";
        }
        function c(t, e, i) {
            return e = u(e), function(t, e) {
                if (e && ("object" == s(e) || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return function(t) {
                    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t;
                }(t);
            }(t, d() ? Reflect.construct(e, i || [], u(t).constructor) : e.apply(t, i));
        }
        function d() {
            try {
                var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (t) {}
            return (d = function() {
                return !!t;
            })();
        }
        function u(t) {
            return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, u(t);
        }
        function p(t, e) {
            return p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                return t.__proto__ = e, t;
            }, p(t, e);
        }
        var f = function(t) {
            t.forEach(function(t) {
                t.isIntersecting && t.target.onVisible();
            });
        }, g = {}, m = function(t) {
            function i(t) {
                var e;
                if (function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, i), (e = c(this, i, [
                    t
                ])).supportsObserver = !t.scrollPosition && t.useIntersectionObserver && o(), e.supportsObserver) {
                    var n = t.threshold;
                    e.observer = function(t) {
                        return g[t] = g[t] || new IntersectionObserver(f, {
                            rootMargin: t + "px"
                        }), g[t];
                    }(n);
                }
                return e;
            }
            var n, r;
            return function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && p(t, e);
            }(i, t), n = i, r = [
                {
                    key: "componentDidMount",
                    value: function() {
                        this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function() {
                        this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "getPlaceholderBoundingBox",
                    value: function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition, e = this.placeholder.getBoundingClientRect(), i = this.placeholder.style, n = parseInt(i.getPropertyValue("margin-left"), 10) || 0, r = parseInt(i.getPropertyValue("margin-top"), 10) || 0;
                        return {
                            bottom: t.y + e.bottom + r,
                            left: t.x + e.left + n,
                            right: t.x + e.right + n,
                            top: t.y + e.top + r
                        };
                    }
                },
                {
                    key: "isPlaceholderInViewport",
                    value: function() {
                        if ("undefined" == typeof window || !this.placeholder) return !1;
                        var t = this.props, e = t.scrollPosition, i = t.threshold, n = this.getPlaceholderBoundingBox(e), r = e.y + window.innerHeight, o = e.x, s = e.x + window.innerWidth, a = e.y;
                        return Boolean(a - i <= n.bottom && r + i >= n.top && o - i <= n.right && s + i >= n.left);
                    }
                },
                {
                    key: "updateVisibility",
                    value: function() {
                        this.isPlaceholderInViewport() && this.props.onVisible();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var t = this, i = this.props, n = i.className, r = i.height, o = i.placeholder, s = i.style, h = i.width;
                        if (o && "function" != typeof o.type) return e().cloneElement(o, {
                            ref: function(e) {
                                return t.placeholder = e;
                            }
                        });
                        var c = function(t) {
                            for(var e = 1; e < arguments.length; e++){
                                var i = null != arguments[e] ? arguments[e] : {};
                                e % 2 ? a(Object(i), !0).forEach(function(e) {
                                    l(t, e, i[e]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : a(Object(i)).forEach(function(e) {
                                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
                                });
                            }
                            return t;
                        }({
                            display: "inline-block"
                        }, s);
                        return void 0 !== h && (c.width = h), void 0 !== r && (c.height = r), e().createElement("span", {
                            className: n,
                            ref: function(e) {
                                return t.placeholder = e;
                            },
                            style: c
                        }, o);
                    }
                }
            ], r && function(t, e) {
                for(var i = 0; i < e.length; i++){
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, h(n.key), n);
                }
            }(n.prototype, r), Object.defineProperty(n, "prototype", {
                writable: !1
            }), n;
        }(e().Component);
        m.propTypes = {
            onVisible: r.PropTypes.func.isRequired,
            className: r.PropTypes.string,
            height: r.PropTypes.oneOfType([
                r.PropTypes.number,
                r.PropTypes.string
            ]),
            placeholder: r.PropTypes.element,
            threshold: r.PropTypes.number,
            useIntersectionObserver: r.PropTypes.bool,
            scrollPosition: r.PropTypes.shape({
                x: r.PropTypes.number.isRequired,
                y: r.PropTypes.number.isRequired
            }),
            width: r.PropTypes.oneOfType([
                r.PropTypes.number,
                r.PropTypes.string
            ])
        }, m.defaultProps = {
            className: "",
            placeholder: null,
            threshold: 100,
            useIntersectionObserver: !0
        };
        const b = m;
        var y = i(181), x = i.n(y), v = i(858), w = i.n(v), C = function(t) {
            var e = getComputedStyle(t, null);
            return e.getPropertyValue("overflow") + e.getPropertyValue("overflow-y") + e.getPropertyValue("overflow-x");
        };
        const S = function(t) {
            if (!(t instanceof HTMLElement)) return window;
            for(var e = t; e && e instanceof HTMLElement;){
                if (/(scroll|auto)/.test(C(e))) return e;
                e = e.parentNode;
            }
            return window;
        };
        function k(t) {
            return k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, k(t);
        }
        var A = [
            "delayMethod",
            "delayTime"
        ];
        function E() {
            return E = Object.assign ? Object.assign.bind() : function(t) {
                for(var e = 1; e < arguments.length; e++){
                    var i = arguments[e];
                    for(var n in i)({}).hasOwnProperty.call(i, n) && (t[n] = i[n]);
                }
                return t;
            }, E.apply(null, arguments);
        }
        function M(t) {
            var e = function(t, e) {
                if ("object" != k(t) || !t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var n = i.call(t, "string");
                    if ("object" != k(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == k(e) ? e : e + "";
        }
        function T(t, e, i) {
            return e = O(e), P(t, R() ? Reflect.construct(e, i || [], O(t).constructor) : e.apply(t, i));
        }
        function P(t, e) {
            if (e && ("object" == k(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return function(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }(t);
        }
        function R() {
            try {
                var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (t) {}
            return (R = function() {
                return !!t;
            })();
        }
        function O(t) {
            return O = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, O(t);
        }
        function D(t, e) {
            return D = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                return t.__proto__ = e, t;
            }, D(t, e);
        }
        var j = function() {
            return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
        }, N = function() {
            return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
        };
        const I = function(t) {
            var i = function(i) {
                function n(t) {
                    var i;
                    if (function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, n), (i = T(this, n, [
                        t
                    ])).useIntersectionObserver = t.useIntersectionObserver && o(), i.useIntersectionObserver) return P(i);
                    var r = i.onChangeScroll.bind(i);
                    return "debounce" === t.delayMethod ? i.delayedScroll = x()(r, t.delayTime) : "throttle" === t.delayMethod && (i.delayedScroll = w()(r, t.delayTime)), i.state = {
                        scrollPosition: {
                            x: j(),
                            y: N()
                        }
                    }, i.baseComponentRef = e().createRef(), i;
                }
                var r, s;
                return function(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e && D(t, e);
                }(n, i), r = n, s = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.addListeners();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.removeListeners();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || S(this.baseComponentRef.current) !== this.scrollElement && (this.removeListeners(), this.addListeners());
                        }
                    },
                    {
                        key: "addListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = S(this.baseComponentRef.current), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }), window.addEventListener("resize", this.delayedScroll, {
                                passive: !0
                            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }));
                        }
                    },
                    {
                        key: "removeListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
                        }
                    },
                    {
                        key: "onChangeScroll",
                        value: function() {
                            this.useIntersectionObserver || this.setState({
                                scrollPosition: {
                                    x: j(),
                                    y: N()
                                }
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var i = this.props, n = (i.delayMethod, i.delayTime, function(t, e) {
                                if (null == t) return {};
                                var i, n, r = function(t, e) {
                                    if (null == t) return {};
                                    var i = {};
                                    for(var n in t)if (({}).hasOwnProperty.call(t, n)) {
                                        if (e.indexOf(n) >= 0) continue;
                                        i[n] = t[n];
                                    }
                                    return i;
                                }(t, e);
                                if (Object.getOwnPropertySymbols) {
                                    var o = Object.getOwnPropertySymbols(t);
                                    for(n = 0; n < o.length; n++)i = o[n], e.indexOf(i) >= 0 || ({}).propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
                                }
                                return r;
                            }(i, A)), r = this.useIntersectionObserver ? null : this.state.scrollPosition;
                            return e().createElement(t, E({
                                forwardRef: this.baseComponentRef,
                                scrollPosition: r
                            }, n));
                        }
                    }
                ], s && function(t, e) {
                    for(var i = 0; i < e.length; i++){
                        var n = e[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, M(n.key), n);
                    }
                }(r.prototype, s), Object.defineProperty(r, "prototype", {
                    writable: !1
                }), r;
            }(e().Component);
            return i.propTypes = {
                delayMethod: r.PropTypes.oneOf([
                    "debounce",
                    "throttle"
                ]),
                delayTime: r.PropTypes.number,
                useIntersectionObserver: r.PropTypes.bool
            }, i.defaultProps = {
                delayMethod: "throttle",
                delayTime: 300,
                useIntersectionObserver: !0
            }, i;
        };
        function B(t) {
            return B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, B(t);
        }
        function F(t) {
            var e = function(t, e) {
                if ("object" != B(t) || !t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var n = i.call(t, "string");
                    if ("object" != B(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == B(e) ? e : e + "";
        }
        function z(t, e, i) {
            return e = U(e), function(t, e) {
                if (e && ("object" == B(e) || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return function(t) {
                    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t;
                }(t);
            }(t, H() ? Reflect.construct(e, i || [], U(t).constructor) : e.apply(t, i));
        }
        function H() {
            try {
                var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (t) {}
            return (H = function() {
                return !!t;
            })();
        }
        function U(t) {
            return U = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, U(t);
        }
        function W(t, e) {
            return W = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                return t.__proto__ = e, t;
            }, W(t, e);
        }
        var Y = function(t) {
            function i(t) {
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, i), z(this, i, [
                    t
                ]);
            }
            var n, r;
            return function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && W(t, e);
            }(i, t), n = i, r = [
                {
                    key: "render",
                    value: function() {
                        return e().createElement(b, this.props);
                    }
                }
            ], function(t, e) {
                for(var i = 0; i < e.length; i++){
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, F(n.key), n);
                }
            }(n.prototype, r), Object.defineProperty(n, "prototype", {
                writable: !1
            }), n;
        }(e().Component);
        const _ = I(Y);
        function X(t) {
            return X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, X(t);
        }
        function G(t) {
            var e = function(t, e) {
                if ("object" != X(t) || !t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var n = i.call(t, "string");
                    if ("object" != X(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == X(e) ? e : e + "";
        }
        function q(t, e, i) {
            return e = $(e), function(t, e) {
                if (e && ("object" == X(e) || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return function(t) {
                    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t;
                }(t);
            }(t, V() ? Reflect.construct(e, i || [], $(t).constructor) : e.apply(t, i));
        }
        function V() {
            try {
                var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (t) {}
            return (V = function() {
                return !!t;
            })();
        }
        function $(t) {
            return $ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, $(t);
        }
        function K(t, e) {
            return K = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                return t.__proto__ = e, t;
            }, K(t, e);
        }
        var Z = function(t) {
            function i(t) {
                var e;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, i), e = q(this, i, [
                    t
                ]);
                var n = t.afterLoad, r = t.beforeLoad, o = t.scrollPosition, s = t.visibleByDefault;
                return e.state = {
                    visible: s
                }, s && (r(), n()), e.onVisible = e.onVisible.bind(e), e.isScrollTracked = Boolean(o && Number.isFinite(o.x) && o.x >= 0 && Number.isFinite(o.y) && o.y >= 0), e;
            }
            var n, r;
            return function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && K(t, e);
            }(i, t), n = i, r = [
                {
                    key: "componentDidUpdate",
                    value: function(t, e) {
                        e.visible !== this.state.visible && this.props.afterLoad();
                    }
                },
                {
                    key: "onVisible",
                    value: function() {
                        this.props.beforeLoad(), this.setState({
                            visible: !0
                        });
                    }
                },
                {
                    key: "render",
                    value: function() {
                        if (this.state.visible) return this.props.children;
                        var t = this.props, i = t.className, n = t.delayMethod, r = t.delayTime, s = t.height, a = t.placeholder, l = t.scrollPosition, h = t.style, c = t.threshold, d = t.useIntersectionObserver, u = t.width;
                        return this.isScrollTracked || d && o() ? e().createElement(b, {
                            className: i,
                            height: s,
                            onVisible: this.onVisible,
                            placeholder: a,
                            scrollPosition: l,
                            style: h,
                            threshold: c,
                            useIntersectionObserver: d,
                            width: u
                        }) : e().createElement(_, {
                            className: i,
                            delayMethod: n,
                            delayTime: r,
                            height: s,
                            onVisible: this.onVisible,
                            placeholder: a,
                            style: h,
                            threshold: c,
                            width: u
                        });
                    }
                }
            ], function(t, e) {
                for(var i = 0; i < e.length; i++){
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, G(n.key), n);
                }
            }(n.prototype, r), Object.defineProperty(n, "prototype", {
                writable: !1
            }), n;
        }(e().Component);
        Z.propTypes = {
            afterLoad: r.PropTypes.func,
            beforeLoad: r.PropTypes.func,
            useIntersectionObserver: r.PropTypes.bool,
            visibleByDefault: r.PropTypes.bool
        }, Z.defaultProps = {
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            useIntersectionObserver: !0,
            visibleByDefault: !1
        };
        const Q = Z;
        function J(t) {
            return J = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, J(t);
        }
        var tt = [
            "afterLoad",
            "beforeLoad",
            "delayMethod",
            "delayTime",
            "effect",
            "placeholder",
            "placeholderSrc",
            "scrollPosition",
            "threshold",
            "useIntersectionObserver",
            "visibleByDefault",
            "wrapperClassName",
            "wrapperProps"
        ];
        function et(t, e) {
            var i = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var n = Object.getOwnPropertySymbols(t);
                e && (n = n.filter(function(e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })), i.push.apply(i, n);
            }
            return i;
        }
        function it(t) {
            for(var e = 1; e < arguments.length; e++){
                var i = null != arguments[e] ? arguments[e] : {};
                e % 2 ? et(Object(i), !0).forEach(function(e) {
                    nt(t, e, i[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : et(Object(i)).forEach(function(e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
                });
            }
            return t;
        }
        function nt(t, e, i) {
            return (e = ot(e)) in t ? Object.defineProperty(t, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[e] = i, t;
        }
        function rt() {
            return rt = Object.assign ? Object.assign.bind() : function(t) {
                for(var e = 1; e < arguments.length; e++){
                    var i = arguments[e];
                    for(var n in i)({}).hasOwnProperty.call(i, n) && (t[n] = i[n]);
                }
                return t;
            }, rt.apply(null, arguments);
        }
        function ot(t) {
            var e = function(t, e) {
                if ("object" != J(t) || !t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var n = i.call(t, "string");
                    if ("object" != J(n)) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(t);
            return "symbol" == J(e) ? e : e + "";
        }
        function st(t, e, i) {
            return e = lt(e), function(t, e) {
                if (e && ("object" == J(e) || "function" == typeof e)) return e;
                if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
                return function(t) {
                    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return t;
                }(t);
            }(t, at() ? Reflect.construct(e, i || [], lt(t).constructor) : e.apply(t, i));
        }
        function at() {
            try {
                var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (t) {}
            return (at = function() {
                return !!t;
            })();
        }
        function lt(t) {
            return lt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, lt(t);
        }
        function ht(t, e) {
            return ht = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
                return t.__proto__ = e, t;
            }, ht(t, e);
        }
        var ct = function(t) {
            function i(t) {
                var e;
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, i), (e = st(this, i, [
                    t
                ])).state = {
                    loaded: !1
                }, e;
            }
            var n, r;
            return function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), e && ht(t, e);
            }(i, t), n = i, r = [
                {
                    key: "onImageLoad",
                    value: function() {
                        var t = this;
                        return this.state.loaded ? null : function(e) {
                            t.props.onLoad(e), t.props.afterLoad(), t.setState({
                                loaded: !0
                            });
                        };
                    }
                },
                {
                    key: "getImg",
                    value: function() {
                        var t = this.props, i = (t.afterLoad, t.beforeLoad, t.delayMethod, t.delayTime, t.effect, t.placeholder, t.placeholderSrc, t.scrollPosition, t.threshold, t.useIntersectionObserver, t.visibleByDefault, t.wrapperClassName, t.wrapperProps, function(t, e) {
                            if (null == t) return {};
                            var i, n, r = function(t, e) {
                                if (null == t) return {};
                                var i = {};
                                for(var n in t)if (({}).hasOwnProperty.call(t, n)) {
                                    if (e.indexOf(n) >= 0) continue;
                                    i[n] = t[n];
                                }
                                return i;
                            }(t, e);
                            if (Object.getOwnPropertySymbols) {
                                var o = Object.getOwnPropertySymbols(t);
                                for(n = 0; n < o.length; n++)i = o[n], e.indexOf(i) >= 0 || ({}).propertyIsEnumerable.call(t, i) && (r[i] = t[i]);
                            }
                            return r;
                        }(t, tt));
                        return e().createElement("img", rt({}, i, {
                            onLoad: this.onImageLoad()
                        }));
                    }
                },
                {
                    key: "getLazyLoadImage",
                    value: function() {
                        var t = this.props, i = t.beforeLoad, n = t.className, r = t.delayMethod, o = t.delayTime, s = t.height, a = t.placeholder, l = t.scrollPosition, h = t.style, c = t.threshold, d = t.useIntersectionObserver, u = t.visibleByDefault, p = t.width;
                        return e().createElement(Q, {
                            beforeLoad: i,
                            className: n,
                            delayMethod: r,
                            delayTime: o,
                            height: s,
                            placeholder: a,
                            scrollPosition: l,
                            style: h,
                            threshold: c,
                            useIntersectionObserver: d,
                            visibleByDefault: u,
                            width: p
                        }, this.getImg());
                    }
                },
                {
                    key: "getWrappedLazyLoadImage",
                    value: function(t) {
                        var i = this.props, n = i.effect, r = i.height, o = i.placeholderSrc, s = i.width, a = i.wrapperClassName, l = i.wrapperProps, h = this.state.loaded, c = h ? " lazy-load-image-loaded" : "", d = h || !o ? {} : {
                            backgroundImage: "url(".concat(o, ")"),
                            backgroundSize: "100% 100%"
                        };
                        return e().createElement("span", rt({
                            className: a + " lazy-load-image-background " + n + c,
                            style: it(it({}, d), {}, {
                                color: "transparent",
                                display: "inline-block",
                                height: r,
                                width: s
                            })
                        }, l), t);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var t = this.props, e = t.effect, i = t.placeholderSrc, n = t.visibleByDefault, r = t.wrapperClassName, o = t.wrapperProps, s = this.getLazyLoadImage();
                        return (e || i) && !n || r || o ? this.getWrappedLazyLoadImage(s) : s;
                    }
                }
            ], r && function(t, e) {
                for(var i = 0; i < e.length; i++){
                    var n = e[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, ot(n.key), n);
                }
            }(n.prototype, r), Object.defineProperty(n, "prototype", {
                writable: !1
            }), n;
        }(e().Component);
        ct.propTypes = {
            onLoad: r.PropTypes.func,
            afterLoad: r.PropTypes.func,
            beforeLoad: r.PropTypes.func,
            delayMethod: r.PropTypes.string,
            delayTime: r.PropTypes.number,
            effect: r.PropTypes.string,
            placeholderSrc: r.PropTypes.string,
            threshold: r.PropTypes.number,
            useIntersectionObserver: r.PropTypes.bool,
            visibleByDefault: r.PropTypes.bool,
            wrapperClassName: r.PropTypes.string,
            wrapperProps: r.PropTypes.object
        }, ct.defaultProps = {
            onLoad: function() {},
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            delayMethod: "throttle",
            delayTime: 300,
            effect: "",
            placeholderSrc: null,
            threshold: 100,
            useIntersectionObserver: !0,
            visibleByDefault: !1,
            wrapperClassName: ""
        };
        const dt = ct;
    })(), R.exports = n;
})()), R.exports), D = function() {
    return !0;
}, j = {
    "@@functional/placeholder": !0
};
function N(t) {
    return null != t && "object" == typeof t && !0 === t["@@functional/placeholder"];
}
function I(t) {
    return function e(i) {
        return 0 === arguments.length || N(i) ? e : t.apply(this, arguments);
    };
}
function B(t) {
    return function e(i, n) {
        switch(arguments.length){
            case 0:
                return e;
            case 1:
                return N(i) ? e : I(function(e) {
                    return t(i, e);
                });
            default:
                return N(i) && N(n) ? e : N(i) ? I(function(e) {
                    return t(e, n);
                }) : N(n) ? I(function(_e) {
                    return t(i, _e);
                }) : t(i, n);
        }
    };
}
var F = B(function(t, e) {
    return Number(t) + Number(e);
});
function z(t, e) {
    var i;
    e = e || [];
    var n = (t = t || []).length, r = e.length, o = [];
    for(i = 0; i < n;)o[o.length] = t[i], i += 1;
    for(i = 0; i < r;)o[o.length] = e[i], i += 1;
    return o;
}
function H(t, e) {
    switch(t){
        case 0:
            return function() {
                return e.apply(this, arguments);
            };
        case 1:
            return function(t) {
                return e.apply(this, arguments);
            };
        case 2:
            return function(t, i) {
                return e.apply(this, arguments);
            };
        case 3:
            return function(t, i, n) {
                return e.apply(this, arguments);
            };
        case 4:
            return function(t, i, n, r) {
                return e.apply(this, arguments);
            };
        case 5:
            return function(t, i, n, r, o) {
                return e.apply(this, arguments);
            };
        case 6:
            return function(t, i, n, r, o, s) {
                return e.apply(this, arguments);
            };
        case 7:
            return function(t, i, n, r, o, s, a) {
                return e.apply(this, arguments);
            };
        case 8:
            return function(t, i, n, r, o, s, a, l) {
                return e.apply(this, arguments);
            };
        case 9:
            return function(t, i, n, r, o, s, a, l, h) {
                return e.apply(this, arguments);
            };
        case 10:
            return function(t, i, n, r, o, s, a, l, h, c) {
                return e.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}
function U(t, e, i) {
    return function() {
        for(var n = [], r = 0, o = t, s = 0, a = !1; s < e.length || r < arguments.length;){
            var l;
            s < e.length && (!N(e[s]) || r >= arguments.length) ? l = e[s] : (l = arguments[r], r += 1), n[s] = l, N(l) ? a = !0 : o -= 1, s += 1;
        }
        return !a && o <= 0 ? i.apply(this, n) : H(Math.max(0, o), U(t, n, i));
    };
}
var W = B(function(t, e) {
    return 1 === t ? I(e) : H(t, U(t, [], e));
}), Y = I(function(t) {
    return W(t.length, function() {
        var e = 0, i = arguments[0], n = arguments[arguments.length - 1], r = Array.prototype.slice.call(arguments, 0);
        return r[0] = function() {
            var t = i.apply(this, z(arguments, [
                e,
                n
            ]));
            return e += 1, t;
        }, t.apply(this, r);
    });
});
function _(t) {
    return function e(i, n, r) {
        switch(arguments.length){
            case 0:
                return e;
            case 1:
                return N(i) ? e : B(function(e, n) {
                    return t(i, e, n);
                });
            case 2:
                return N(i) && N(n) ? e : N(i) ? B(function(e, i) {
                    return t(e, n, i);
                }) : N(n) ? B(function(e, n) {
                    return t(i, e, n);
                }) : I(function(e) {
                    return t(i, n, e);
                });
            default:
                return N(i) && N(n) && N(r) ? e : N(i) && N(n) ? B(function(e, i) {
                    return t(e, i, r);
                }) : N(i) && N(r) ? B(function(e, i) {
                    return t(e, n, i);
                }) : N(n) && N(r) ? B(function(e, n) {
                    return t(i, e, n);
                }) : N(i) ? I(function(e) {
                    return t(e, n, r);
                }) : N(n) ? I(function(e) {
                    return t(i, e, r);
                }) : N(r) ? I(function(_e) {
                    return t(i, n, _e);
                }) : t(i, n, r);
        }
    };
}
var X = _(function(t, e, i) {
    var n = i.length;
    if (t >= n || t < -n) return i;
    var r = (n + t) % n, o = z(i);
    return o[r] = e(i[r]), o;
}), G = Array.isArray || function(t) {
    return null != t && t.length >= 0 && "[object Array]" === Object.prototype.toString.call(t);
};
function q(t, e, i) {
    return function() {
        if (0 === arguments.length) return i();
        var n = arguments[arguments.length - 1];
        if (!G(n)) {
            for(var r = 0; r < t.length;){
                if ("function" == typeof n[t[r]]) return n[t[r]].apply(n, Array.prototype.slice.call(arguments, 0, -1));
                r += 1;
            }
            if (function(t) {
                return null != t && "function" == typeof t["@@transducer/step"];
            }(n)) return e.apply(null, Array.prototype.slice.call(arguments, 0, -1))(n);
        }
        return i.apply(this, arguments);
    };
}
function V(t) {
    return t && t["@@transducer/reduced"] ? t : {
        "@@transducer/value": t,
        "@@transducer/reduced": !0
    };
}
var $ = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(t) {
        return this.xf["@@transducer/result"](t);
    }
}, K = function() {
    function t(t, e) {
        this.xf = e, this.f = t, this.all = !0;
    }
    return t.prototype["@@transducer/init"] = $.init, t.prototype["@@transducer/result"] = function(t) {
        return this.all && (t = this.xf["@@transducer/step"](t, !0)), this.xf["@@transducer/result"](t);
    }, t.prototype["@@transducer/step"] = function(t, e) {
        return this.f(e) || (this.all = !1, t = V(this.xf["@@transducer/step"](t, !1))), t;
    }, t;
}();
function Z(t) {
    return function(e) {
        return new K(t, e);
    };
}
var Q = B(q([
    "all"
], Z, function(t, e) {
    for(var i = 0; i < e.length;){
        if (!t(e[i])) return !1;
        i += 1;
    }
    return !0;
}));
function J(t) {
    for(var e, i = []; !(e = t.next()).done;)i.push(e.value);
    return i;
}
function tt(t, e, i) {
    for(var n = 0, r = i.length; n < r;){
        if (t(e, i[n])) return !0;
        n += 1;
    }
    return !1;
}
function et(t, e) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
var it = "function" == typeof Object.is ? Object.is : function(t, e) {
    return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
}, nt = Object.prototype.toString, rt = function() {
    return "[object Arguments]" === nt.call(arguments) ? function(t) {
        return "[object Arguments]" === nt.call(t);
    } : function(t) {
        return et("callee", t);
    };
}(), ot = !({
    toString: null
}).propertyIsEnumerable("toString"), st = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
], at = function() {
    return arguments.propertyIsEnumerable("length");
}(), lt = function(t, e) {
    for(var i = 0; i < t.length;){
        if (t[i] === e) return !0;
        i += 1;
    }
    return !1;
}, ht = "function" != typeof Object.keys || at ? I(function(t) {
    if (Object(t) !== t) return [];
    var e, i, n = [], r = at && rt(t);
    for(e in t)!et(e, t) || r && "length" === e || (n[n.length] = e);
    if (ot) for(i = st.length - 1; i >= 0;)et(e = st[i], t) && !lt(n, e) && (n[n.length] = e), i -= 1;
    return n;
}) : I(function(t) {
    return Object(t) !== t ? [] : Object.keys(t);
}), ct = I(function(t) {
    return null === t ? "Null" : void 0 === t ? "Undefined" : Object.prototype.toString.call(t).slice(8, -1);
});
function dt(t, e, i, n) {
    var r = J(t);
    function o(t, e) {
        return ut(t, e, i.slice(), n.slice());
    }
    return !tt(function(t, e) {
        return !tt(o, e, t);
    }, J(e), r);
}
function ut(t, e, i, n) {
    if (it(t, e)) return !0;
    var r = ct(t);
    if (r !== ct(e)) return !1;
    if ("function" == typeof t["fantasy-land/equals"] || "function" == typeof e["fantasy-land/equals"]) return "function" == typeof t["fantasy-land/equals"] && t["fantasy-land/equals"](e) && "function" == typeof e["fantasy-land/equals"] && e["fantasy-land/equals"](t);
    if ("function" == typeof t.equals || "function" == typeof e.equals) return "function" == typeof t.equals && t.equals(e) && "function" == typeof e.equals && e.equals(t);
    switch(r){
        case "Arguments":
        case "Array":
        case "Object":
            if ("function" == typeof t.constructor && "Promise" === function(t) {
                var e = String(t).match(/^function (\w*)/);
                return null == e ? "" : e[1];
            }(t.constructor)) return t === e;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (typeof t != typeof e || !it(t.valueOf(), e.valueOf())) return !1;
            break;
        case "Date":
            if (!it(t.valueOf(), e.valueOf())) return !1;
            break;
        case "Error":
            return t.name === e.name && t.message === e.message;
        case "RegExp":
            if (t.source !== e.source || t.global !== e.global || t.ignoreCase !== e.ignoreCase || t.multiline !== e.multiline || t.sticky !== e.sticky || t.unicode !== e.unicode) return !1;
    }
    for(var o = i.length - 1; o >= 0;){
        if (i[o] === t) return n[o] === e;
        o -= 1;
    }
    switch(r){
        case "Map":
            return t.size === e.size && dt(t.entries(), e.entries(), i.concat([
                t
            ]), n.concat([
                e
            ]));
        case "Set":
            return t.size === e.size && dt(t.values(), e.values(), i.concat([
                t
            ]), n.concat([
                e
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            return !1;
    }
    var s = ht(t);
    if (s.length !== ht(e).length) return !1;
    var a = i.concat([
        t
    ]), l = n.concat([
        e
    ]);
    for(o = s.length - 1; o >= 0;){
        var h = s[o];
        if (!et(h, e) || !ut(e[h], t[h], a, l)) return !1;
        o -= 1;
    }
    return !0;
}
var pt = B(function(t, e) {
    return ut(t, e, [], []);
});
function ft(t, e) {
    return function(t, e, i) {
        var n, r;
        if ("function" == typeof t.indexOf) switch(typeof e){
            case "number":
                if (0 === e) {
                    for(n = 1 / e; i < t.length;){
                        if (0 === (r = t[i]) && 1 / r === n) return i;
                        i += 1;
                    }
                    return -1;
                }
                if (e != e) {
                    for(; i < t.length;){
                        if ("number" == typeof (r = t[i]) && r != r) return i;
                        i += 1;
                    }
                    return -1;
                }
                return t.indexOf(e, i);
            case "string":
            case "boolean":
            case "function":
            case "undefined":
                return t.indexOf(e, i);
            case "object":
                if (null === e) return t.indexOf(e, i);
        }
        for(; i < t.length;){
            if (pt(t[i], e)) return i;
            i += 1;
        }
        return -1;
    }(e, t, 0) >= 0;
}
function gt(t, e) {
    for(var i = 0, n = e.length, r = Array(n); i < n;)r[i] = t(e[i]), i += 1;
    return r;
}
function mt(t) {
    return '"' + t.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0").replace(/"/g, '\\"') + '"';
}
var bt = function(t) {
    return (t < 10 ? "0" : "") + t;
}, yt = "function" == typeof Date.prototype.toISOString ? function(t) {
    return t.toISOString();
} : function(t) {
    return t.getUTCFullYear() + "-" + bt(t.getUTCMonth() + 1) + "-" + bt(t.getUTCDate()) + "T" + bt(t.getUTCHours()) + ":" + bt(t.getUTCMinutes()) + ":" + bt(t.getUTCSeconds()) + "." + (t.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
};
function xt(t, e, i) {
    for(var n = 0, r = i.length; n < r;)e = t(e, i[n]), n += 1;
    return e;
}
function vt(t) {
    return "[object Object]" === Object.prototype.toString.call(t);
}
var wt = function() {
    function t(t, e) {
        this.xf = e, this.f = t;
    }
    return t.prototype["@@transducer/init"] = $.init, t.prototype["@@transducer/result"] = $.result, t.prototype["@@transducer/step"] = function(t, e) {
        return this.f(e) ? this.xf["@@transducer/step"](t, e) : t;
    }, t;
}();
function Ct(t) {
    return function(e) {
        return new wt(t, e);
    };
}
var St = B(q([
    "fantasy-land/filter",
    "filter"
], Ct, function(t, e) {
    return vt(e) ? xt(function(i, n) {
        return t(e[n]) && (i[n] = e[n]), i;
    }, {}, ht(e)) : function(t, e) {
        for(var i = 0, n = e.length, r = []; i < n;)t(e[i]) && (r[r.length] = e[i]), i += 1;
        return r;
    }(t, e);
})), kt = B(function(t, e) {
    var i;
    return St((i = t, function() {
        return !i.apply(this, arguments);
    }), e);
});
function At(t, e) {
    var i = function(i) {
        var n = e.concat([
            t
        ]);
        return ft(i, n) ? "<Circular>" : At(i, n);
    }, n = function(t, e) {
        return gt(function(e) {
            return mt(e) + ": " + i(t[e]);
        }, e.slice().sort());
    };
    switch(Object.prototype.toString.call(t)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + gt(i, t).join(", ") + "))";
        case "[object Array]":
            return "[" + gt(i, t).concat(n(t, kt(function(t) {
                return /^\d+$/.test(t);
            }, ht(t)))).join(", ") + "]";
        case "[object Boolean]":
            return "object" == typeof t ? "new Boolean(" + i(t.valueOf()) + ")" : t.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(t.valueOf()) ? i(NaN) : mt(yt(t))) + ")";
        case "[object Map]":
            return "new Map(" + i(Array.from(t)) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return "object" == typeof t ? "new Number(" + i(t.valueOf()) + ")" : 1 / t == -1 / 0 ? "-0" : t.toString(10);
        case "[object Set]":
            return "new Set(" + i(Array.from(t).sort()) + ")";
        case "[object String]":
            return "object" == typeof t ? "new String(" + i(t.valueOf()) + ")" : mt(t);
        case "[object Undefined]":
            return "undefined";
        default:
            if ("function" == typeof t.toString) {
                var r = t.toString();
                if ("[object Object]" !== r) return r;
            }
            return "{" + n(t, ht(t)).join(", ") + "}";
    }
}
var Et = I(function(t) {
    return At(t, []);
}), Mt = B(function(t, e) {
    if (t === e) return e;
    function i(t, e) {
        if (t > e != e > t) return e > t ? e : t;
    }
    var n = i(t, e);
    if (void 0 !== n) return n;
    var r = i(typeof t, typeof e);
    if (void 0 !== r) return r === typeof t ? t : e;
    var o = Et(t), s = i(o, Et(e));
    return void 0 !== s && s === o ? t : e;
}), Tt = function() {
    function t(t, e) {
        this.xf = e, this.f = t;
    }
    return t.prototype["@@transducer/init"] = $.init, t.prototype["@@transducer/result"] = $.result, t.prototype["@@transducer/step"] = function(t, e) {
        return this.xf["@@transducer/step"](t, this.f(e));
    }, t;
}(), Pt = function(t) {
    return function(e) {
        return new Tt(t, e);
    };
}, Rt = B(q([
    "fantasy-land/map",
    "map"
], Pt, function(t, e) {
    switch(Object.prototype.toString.call(e)){
        case "[object Function]":
            return W(e.length, function() {
                return t.call(this, e.apply(this, arguments));
            });
        case "[object Object]":
            return xt(function(i, n) {
                return i[n] = t(e[n]), i;
            }, {}, ht(e));
        default:
            return gt(t, e);
    }
})), Lt = Number.isInteger || function(t) {
    return (t | 0) === t;
};
function Ot(t) {
    return "[object String]" === Object.prototype.toString.call(t);
}
function Dt(t, e) {
    var i = t < 0 ? e.length + t : t;
    return Ot(e) ? e.charAt(i) : e[i];
}
var jt = B(function(t, e) {
    if (null != e) return Lt(t) ? Dt(t, e) : e[t];
}), Nt = B(function(t, e) {
    return Rt(jt(t), e);
}), It = I(function(t) {
    return !!G(t) || !!t && "object" == typeof t && !Ot(t) && (0 === t.length || t.length > 0 && t.hasOwnProperty(0) && t.hasOwnProperty(t.length - 1));
}), Bt = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";
function Ft(t, e, i) {
    return function(n, r, o) {
        if (It(o)) return t(n, r, o);
        if (null == o) return r;
        if ("function" == typeof o["fantasy-land/reduce"]) return e(n, r, o, "fantasy-land/reduce");
        if (null != o[Bt]) return i(n, r, o[Bt]());
        if ("function" == typeof o.next) return i(n, r, o);
        if ("function" == typeof o.reduce) return e(n, r, o, "reduce");
        throw new TypeError("reduce: list must be array or iterable");
    };
}
function zt(t, e, i) {
    for(var n = 0, r = i.length; n < r;){
        if ((e = t["@@transducer/step"](e, i[n])) && e["@@transducer/reduced"]) {
            e = e["@@transducer/value"];
            break;
        }
        n += 1;
    }
    return t["@@transducer/result"](e);
}
var Ht = B(function(t, e) {
    return H(t.length, function() {
        return t.apply(e, arguments);
    });
});
function Ut(t, e, i) {
    for(var n = i.next(); !n.done;){
        if ((e = t["@@transducer/step"](e, n.value)) && e["@@transducer/reduced"]) {
            e = e["@@transducer/value"];
            break;
        }
        n = i.next();
    }
    return t["@@transducer/result"](e);
}
function Wt(t, e, i, n) {
    return t["@@transducer/result"](i[n](Ht(t["@@transducer/step"], t), e));
}
var Yt = Ft(zt, Wt, Ut), _t = function() {
    function t(t) {
        this.f = t;
    }
    return t.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    }, t.prototype["@@transducer/result"] = function(t) {
        return t;
    }, t.prototype["@@transducer/step"] = function(t, e) {
        return this.f(t, e);
    }, t;
}();
function Xt(t) {
    return new _t(t);
}
var Gt = _(function(t, e, i) {
    return Yt("function" == typeof t ? Xt(t) : t, e, i);
}), qt = I(function(t) {
    return function() {
        return t;
    };
}), Vt = function() {
    function t(t, e) {
        this.xf = e, this.f = t, this.any = !1;
    }
    return t.prototype["@@transducer/init"] = $.init, t.prototype["@@transducer/result"] = function(t) {
        return this.any || (t = this.xf["@@transducer/step"](t, !1)), this.xf["@@transducer/result"](t);
    }, t.prototype["@@transducer/step"] = function(t, e) {
        return this.f(e) && (this.any = !0, t = V(this.xf["@@transducer/step"](t, !0))), t;
    }, t;
}();
function $t(t) {
    return function(e) {
        return new Vt(t, e);
    };
}
var Kt = B(q([
    "any"
], $t, function(t, e) {
    for(var i = 0; i < e.length;){
        if (t(e[i])) return !0;
        i += 1;
    }
    return !1;
})), Zt = I(function(t) {
    return W(Gt(Mt, 0, Nt("length", t)), function() {
        for(var e = 0, i = t.length; e < i;){
            if (t[e].apply(this, arguments)) return !0;
            e += 1;
        }
        return !1;
    });
});
function Qt(t, e, i) {
    for(var n = i.next(); !n.done;)e = t(e, n.value), n = i.next();
    return e;
}
function Jt(t, e, i, n) {
    return i[n](t, e);
}
var te = Ft(xt, Jt, Qt), ee = B(function(t, e) {
    return "function" == typeof e["fantasy-land/ap"] ? e["fantasy-land/ap"](t) : "function" == typeof t.ap ? t.ap(e) : "function" == typeof t ? function(i) {
        return t(i)(e(i));
    } : te(function(t, i) {
        return z(t, Rt(i, e));
    }, [], t);
}), ie = B(function(t, e) {
    return z(e, [
        t
    ]);
}), ne = I(function(t) {
    for(var e = ht(t), i = e.length, n = [], r = 0; r < i;)n[r] = t[e[r]], r += 1;
    return n;
}), re = _(function(t, e, i) {
    var n = t(e), r = t(i);
    return n < r ? -1 : n > r ? 1 : 0;
}), oe = I(function(t) {
    return W(t.length, t);
});
function se(t, e, i) {
    if (Lt(t) && G(i)) {
        var n = [].concat(i);
        return n[t] = e, n;
    }
    var r = {};
    for(var o in i)r[o] = i[o];
    return r[t] = e, r;
}
var ae = I(function(t) {
    return null == t;
}), le = _(function t(e, i, n) {
    if (0 === e.length) return i;
    var r = e[0];
    if (e.length > 1) {
        var o = !ae(n) && et(r, n) && "object" == typeof n[r] ? n[r] : Lt(e[1]) ? [] : {};
        i = t(Array.prototype.slice.call(e, 1), i, o);
    }
    return se(r, i, n);
}), he = _(function(t, e, i) {
    return le([
        t
    ], e, i);
});
function ce(t) {
    var e = Object.prototype.toString.call(t);
    return "[object Function]" === e || "[object AsyncFunction]" === e || "[object GeneratorFunction]" === e || "[object AsyncGeneratorFunction]" === e;
}
var de = B(function(t, e) {
    var i = W(t, e);
    return W(t, function() {
        return xt(ee, Rt(i, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
}), ue = I(function(t) {
    return de(t.length, t);
});
var pe = "@@transducer/init", fe = "@@transducer/step", ge = "@@transducer/result", me = function() {
    function t(t) {
        this.xf = t;
    }
    return t.prototype[pe] = $.init, t.prototype[ge] = $.result, t.prototype[fe] = function(t, e) {
        var i = this.xf[fe](t, e);
        return i["@@transducer/reduced"] ? function(t) {
            return {
                "@@transducer/value": t,
                "@@transducer/reduced": !0
            };
        }(i) : i;
    }, t;
}(), be = function() {
    function t(t) {
        this.xf = new me(t);
    }
    return t.prototype[pe] = $.init, t.prototype[ge] = $.result, t.prototype[fe] = function(t, e) {
        return It(e) ? Yt(this.xf, t, e) : zt(this.xf, t, [
            e
        ]);
    }, t;
}();
function ye(t) {
    return function(e) {
        return Pt(t)(function(t) {
            return new be(t);
        }(e));
    };
}
var xe = B(q([
    "fantasy-land/chain",
    "chain"
], ye, function(t, e) {
    return "function" == typeof e ? function(i) {
        return t(e(i))(i);
    } : function(t) {
        for(var e, i, n, r = [], o = 0, s = t.length; o < s;){
            if (It(t[o])) for(n = 0, i = (e = t[o]).length; n < i;)r[r.length] = e[n], n += 1;
            else r[r.length] = t[o];
            o += 1;
        }
        return r;
    }(Rt(t, e));
}));
function ve(t) {
    return new RegExp(t.source, t.flags ? t.flags : (t.global ? "g" : "") + (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.sticky ? "y" : "") + (t.unicode ? "u" : "") + (t.dotAll ? "s" : ""));
}
function we(t, e, i) {
    if (i || (i = new Ce), function(t) {
        var e = typeof t;
        return null == t || "object" != e && "function" != e;
    }(t)) return t;
    var n = function(e) {
        var n = i.get(t);
        if (n) return n;
        for(var r in i.set(t, e), t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = we(t[r], !0, i));
        return e;
    };
    switch(ct(t)){
        case "Object":
            return n(Object.create(Object.getPrototypeOf(t)));
        case "Array":
            return n(Array(t.length));
        case "Date":
            return new Date(t.valueOf());
        case "RegExp":
            return ve(t);
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "BigInt64Array":
        case "BigUint64Array":
            return t.slice();
        default:
            return t;
    }
}
var Ce = function() {
    function t() {
        this.map = {}, this.length = 0;
    }
    return t.prototype.set = function(t, e) {
        var i = this.hash(t), n = this.map[i];
        n || (this.map[i] = n = []), n.push([
            t,
            e
        ]), this.length += 1;
    }, t.prototype.hash = function(t) {
        var e = [];
        for(var i in t)e.push(Object.prototype.toString.call(t[i]));
        return e.join();
    }, t.prototype.get = function(t) {
        if (this.length <= 180) for(var e in this.map)for(var i = this.map[e], n = 0; n < i.length; n += 1){
            if ((o = i[n])[0] === t) return o[1];
        }
        else {
            var r = this.hash(t);
            if (i = this.map[r]) for(n = 0; n < i.length; n += 1){
                var o;
                if ((o = i[n])[0] === t) return o[1];
            }
        }
    }, t;
}(), Se = I(function(t) {
    return null != t && "function" == typeof t.clone ? t.clone() : we(t);
}), ke = ue(I(function(t) {
    return !t;
}));
function Ae(t, e) {
    return function() {
        return e.call(this, t.apply(this, arguments));
    };
}
function Ee(t, e) {
    return function() {
        var i = arguments.length;
        if (0 === i) return e();
        var n = arguments[i - 1];
        return G(n) || "function" != typeof n[t] ? e.apply(this, arguments) : n[t].apply(n, Array.prototype.slice.call(arguments, 0, i - 1));
    };
}
var Me = _(Ee("slice", function(t, e, i) {
    return Array.prototype.slice.call(i, t, e);
})), Te = I(Ee("tail", Me(1, 1 / 0)));
function Pe() {
    if (0 === arguments.length) throw new Error("pipe requires at least one argument");
    return H(arguments[0].length, Gt(Ae, arguments[0], Te(arguments)));
}
var Re = I(function(t) {
    return Ot(t) ? t.split("").reverse().join("") : Array.prototype.slice.call(t, 0).reverse();
});
function Le() {
    if (0 === arguments.length) throw new Error("compose requires at least one argument");
    return Pe.apply(this, Re(arguments));
}
var Oe = I(function(t) {
    return Dt(0, t);
});
function De(t) {
    return t;
}
var je = I(De), Ne = B(function(t, e) {
    if (G(t)) {
        if (G(e)) return t.concat(e);
        throw new TypeError(Et(e) + " is not an array");
    }
    if (Ot(t)) {
        if (Ot(e)) return t + e;
        throw new TypeError(Et(e) + " is not a string");
    }
    if (null != t && ce(t["fantasy-land/concat"])) return t["fantasy-land/concat"](e);
    if (null != t && ce(t.concat)) return t.concat(e);
    throw new TypeError(Et(t) + ' does not have a method named "concat" or "fantasy-land/concat"');
}), Ie = I(function(t) {
    return H(Gt(Mt, 0, Rt(function(t) {
        return t[0].length;
    }, t)), function() {
        for(var e = 0; e < t.length;){
            if (t[e][0].apply(this, arguments)) return t[e][1].apply(this, arguments);
            e += 1;
        }
    });
}), Be = B(function(t, e) {
    return null == e || e != e ? t : e;
}), Fe = _(function(t, e, i) {
    var n = t(e), r = t(i);
    return n > r ? -1 : n < r ? 1 : 0;
}), ze = function() {
    function t() {
        this._nativeSet = "function" == typeof Set ? new Set : null, this._items = {};
    }
    return t.prototype.add = function(t) {
        return !He(t, !0, this);
    }, t.prototype.has = function(t) {
        return He(t, !1, this);
    }, t;
}();
function He(t, e, i) {
    var n, r = typeof t;
    switch(r){
        case "string":
        case "number":
            return 0 === t && 1 / t == -1 / 0 ? !!i._items["-0"] || (e && (i._items["-0"] = !0), !1) : null !== i._nativeSet ? e ? (n = i._nativeSet.size, i._nativeSet.add(t), i._nativeSet.size === n) : i._nativeSet.has(t) : r in i._items ? t in i._items[r] || (e && (i._items[r][t] = !0), !1) : (e && (i._items[r] = {}, i._items[r][t] = !0), !1);
        case "boolean":
            if (r in i._items) {
                var o = t ? 1 : 0;
                return !!i._items[r][o] || (e && (i._items[r][o] = !0), !1);
            }
            return e && (i._items[r] = t ? [
                !1,
                !0
            ] : [
                !0,
                !1
            ]), !1;
        case "function":
            return null !== i._nativeSet ? e ? (n = i._nativeSet.size, i._nativeSet.add(t), i._nativeSet.size === n) : i._nativeSet.has(t) : r in i._items ? !!ft(t, i._items[r]) || (e && i._items[r].push(t), !1) : (e && (i._items[r] = [
                t
            ]), !1);
        case "undefined":
            return !!i._items[r] || (e && (i._items[r] = !0), !1);
        case "object":
            if (null === t) return !!i._items.null || (e && (i._items.null = !0), !1);
        default:
            return (r = Object.prototype.toString.call(t)) in i._items ? !!ft(t, i._items[r]) || (e && i._items[r].push(t), !1) : (e && (i._items[r] = [
                t
            ]), !1);
    }
}
var Ue = B(function(t, e) {
    for(var i = [], n = 0, r = t.length, o = e.length, s = new ze, a = 0; a < o; a += 1)s.add(e[a]);
    for(; n < r;)s.add(t[n]) && (i[i.length] = t[n]), n += 1;
    return i;
}), We = _(function(t, e, i) {
    var n = Array.prototype.slice.call(i, 0);
    return n.splice(t, e), n;
});
var Ye = B(function t(e, i) {
    if (null == i) return i;
    switch(e.length){
        case 0:
            return i;
        case 1:
            return function(t, e) {
                if (null == e) return e;
                if (Lt(t) && G(e)) return We(t, 1, e);
                var i = {};
                for(var n in e)i[n] = e[n];
                return delete i[t], i;
            }(e[0], i);
        default:
            var n = e[0], r = Array.prototype.slice.call(e, 1);
            return null == i[n] ? function(_t1, e) {
                if (Lt(_t1) && G(e)) return [].concat(e);
                var i = {};
                for(var n in e)i[n] = e[n];
                return i;
            }(n, i) : he(n, t(r, i[n]), i);
    }
}), _e = B(function(t, e) {
    return Ye([
        t
    ], e);
}), Xe = function() {
    function t(t, e) {
        this.xf = e, this.n = t;
    }
    return t.prototype["@@transducer/init"] = $.init, t.prototype["@@transducer/result"] = $.result, t.prototype["@@transducer/step"] = function(t, e) {
        return this.n > 0 ? (this.n -= 1, t) : this.xf["@@transducer/step"](t, e);
    }, t;
}();
function Ge(t) {
    return function(e) {
        return new Xe(t, e);
    };
}
var qe = B(q([
    "drop"
], Ge, function(t, e) {
    return Me(Math.max(0, t), 1 / 0, e);
})), Ve = function() {
    function t(t, e) {
        this.xf = e, this.n = t, this.i = 0;
    }
    return t.prototype["@@transducer/init"] = $.init, t.prototype["@@transducer/result"] = $.result, t.prototype["@@transducer/step"] = function(t, e) {
        this.i += 1;
        var i = 0 === this.n ? t : this.xf["@@transducer/step"](t, e);
        return this.n >= 0 && this.i >= this.n ? V(i) : i;
    }, t;
}();
function $e(t) {
    return function(e) {
        return new Ve(t, e);
    };
}
var Ke = B(q([
    "take"
], $e, function(t, e) {
    return Me(0, t < 0 ? 1 / 0 : t, e);
}));
function Ze(t, e) {
    for(var i = e.length - 1; i >= 0 && t(e[i]);)i -= 1;
    return Me(0, i + 1, e);
}
var Qe = function() {
    function t(t, e) {
        this.f = t, this.retained = [], this.xf = e;
    }
    return t.prototype["@@transducer/init"] = $.init, t.prototype["@@transducer/result"] = function(t) {
        return this.retained = null, this.xf["@@transducer/result"](t);
    }, t.prototype["@@transducer/step"] = function(t, e) {
        return this.f(e) ? this.retain(t, e) : this.flush(t, e);
    }, t.prototype.flush = function(t, e) {
        return t = Yt(this.xf, t, this.retained), this.retained = [], this.xf["@@transducer/step"](t, e);
    }, t.prototype.retain = function(t, e) {
        return this.retained.push(e), t;
    }, t;
}();
function Je(t) {
    return function(e) {
        return new Qe(t, e);
    };
}
var ti = B(q([], Je, Ze)), ei = I(function(t) {
    return Dt(-1, t);
}), ii = B(function(t, e) {
    return t || e;
}), ni = B(function(t, e) {
    return ce(t) ? function() {
        return t.apply(this, arguments) || e.apply(this, arguments);
    } : ue(ii)(t, e);
});
var ri = I(function(t) {
    return null != t && "function" == typeof t["fantasy-land/empty"] ? t["fantasy-land/empty"]() : null != t && null != t.constructor && "function" == typeof t.constructor["fantasy-land/empty"] ? t.constructor["fantasy-land/empty"]() : null != t && "function" == typeof t.empty ? t.empty() : null != t && null != t.constructor && "function" == typeof t.constructor.empty ? t.constructor.empty() : G(t) ? [] : Ot(t) ? "" : vt(t) ? {} : rt(t) ? function() {
        return arguments;
    }() : function(t) {
        var e = Object.prototype.toString.call(t);
        return "[object Uint8ClampedArray]" === e || "[object Int8Array]" === e || "[object Uint8Array]" === e || "[object Int16Array]" === e || "[object Uint16Array]" === e || "[object Int32Array]" === e || "[object Uint32Array]" === e || "[object Float32Array]" === e || "[object Float64Array]" === e || "[object BigInt64Array]" === e || "[object BigUint64Array]" === e;
    }(t) ? t.constructor.from("") : void 0;
}), oi = B(function t(e, i) {
    if (!vt(i) && !G(i)) return i;
    var n, r, o, s = i instanceof Array ? [] : {};
    for(r in i)o = typeof (n = e[r]), s[r] = "function" === o ? n(i[r]) : n && "object" === o ? t(n, i[r]) : i[r];
    return s;
}), si = function() {
    function t(t, e) {
        this.xf = e, this.f = t, this.found = !1;
    }
    return t.prototype["@@transducer/init"] = $.init, t.prototype["@@transducer/result"] = function(t) {
        return this.found || (t = this.xf["@@transducer/step"](t, void 0)), this.xf["@@transducer/result"](t);
    }, t.prototype["@@transducer/step"] = function(t, e) {
        return this.f(e) && (this.found = !0, t = V(this.xf["@@transducer/step"](t, e))), t;
    }, t;
}();
function ai(t) {
    return function(e) {
        return new si(t, e);
    };
}
var li = B(q([
    "find"
], ai, function(t, e) {
    for(var i = 0, n = e.length; i < n;){
        if (t(e[i])) return e[i];
        i += 1;
    }
})), hi = function() {
    function t(t, e) {
        this.xf = e, this.f = t, this.idx = -1, this.found = !1;
    }
    return t.prototype["@@transducer/init"] = $.init, t.prototype["@@transducer/result"] = function(t) {
        return this.found || (t = this.xf["@@transducer/step"](t, -1)), this.xf["@@transducer/result"](t);
    }, t.prototype["@@transducer/step"] = function(t, e) {
        return this.idx += 1, this.f(e) && (this.found = !0, t = V(this.xf["@@transducer/step"](t, this.idx))), t;
    }, t;
}();
function ci(t) {
    return function(e) {
        return new hi(t, e);
    };
}
var di = B(q([], ci, function(t, e) {
    for(var i = 0, n = e.length; i < n;){
        if (t(e[i])) return i;
        i += 1;
    }
    return -1;
})), ui = B(Ee("forEach", function(t, e) {
    for(var i = e.length, n = 0; n < i;)t(e[n]), n += 1;
    return e;
})), pi = I(function(t) {
    for(var e = {}, i = 0; i < t.length;)e[t[i][0]] = t[i][1], i += 1;
    return e;
}), fi = B(function(t, e) {
    return t > e;
}), gi = B(function(t, e) {
    if (0 === t.length || ae(e)) return !1;
    for(var i = e, n = 0; n < t.length;){
        if (ae(i) || !et(t[n], i)) return !1;
        i = i[t[n]], n += 1;
    }
    return !0;
}), mi = B(function(t, e) {
    return gi([
        t
    ], e);
}), bi = _(function(t, e, i) {
    return W(Math.max(t.length, e.length, i.length), function() {
        return t.apply(this, arguments) ? e.apply(this, arguments) : i.apply(this, arguments);
    });
}), yi = B(ft), xi = Me(0, -1);
var vi = "function" == typeof Object.assign ? Object.assign : function(t) {
    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
    for(var e = Object(t), i = 1, n = arguments.length; i < n;){
        var r = arguments[i];
        if (null != r) for(var o in r)et(o, r) && (e[o] = r[o]);
        i += 1;
    }
    return e;
}, wi = B(function(t, e) {
    return W(t + 1, function() {
        var i = arguments[t];
        if (null != i && ce(i[e])) return i[e].apply(i, Array.prototype.slice.call(arguments, 0, t));
        throw new TypeError(Et(i) + ' does not have a method named "' + e + '"');
    });
}), Ci = B(function(t, e) {
    return e instanceof t || null != e && (e.constructor === t || "Object" === t.name && "object" == typeof e);
}), Si = I(function(t) {
    return null != t && pt(t, ri(t));
}), ki = wi(1, "join");
var Ai = I(function(t) {
    return null != t && function(t) {
        return "[object Number]" === Object.prototype.toString.call(t);
    }(t.length) ? t.length : NaN;
}), Ei = _(function(t, e, i) {
    return X(t, qt(e), i);
});
function Mi(t, e) {
    for(var i = e, n = 0; n < t.length; n += 1){
        if (null == i) return;
        var r = t[n];
        i = Lt(r) ? Dt(r, i) : i[r];
    }
    return i;
}
var Ti = B(function(t, e) {
    return t < e;
}), Pi = B(function(t, e) {
    return e.match(t) || [];
}), Ri = Gt(F, 0), Li = I(function(t) {
    return vi.apply(null, [
        {}
    ].concat(t));
}), Oi = _(function(t, e, i) {
    var n, r = {};
    for(n in i = i || {}, e = e || {})et(n, e) && (r[n] = et(n, i) ? t(n, e[n], i[n]) : e[n]);
    for(n in i)et(n, i) && !et(n, r) && (r[n] = i[n]);
    return r;
}), Di = _(function t(e, i, n) {
    return Oi(function(i, n, r) {
        return vt(n) && vt(r) ? t(e, n, r) : e(i, n, r);
    }, i, n);
}), ji = B(function(t, e) {
    return Di(function(t, e, i) {
        return i;
    }, t, e);
}), Ni = B(function(t, e) {
    return vi({}, e, t);
}), Ii = B(function(t, e) {
    return vi({}, t, e);
}), Bi = _(function(t, e, i) {
    var n = i.length, r = i.slice(), o = t < 0 ? n + t : t, s = e < 0 ? n + e : e, a = r.splice(o, 1);
    return o < 0 || o >= i.length || s < 0 || s >= i.length ? i : [].concat(r.slice(0, s)).concat(a).concat(r.slice(s, i.length));
}), Fi = B(Dt), zi = B(function(t, e) {
    for(var i = {}, n = {}, r = 0, o = t.length; r < o;)n[t[r]] = 1, r += 1;
    for(var s in e)n.hasOwnProperty(s) || (i[s] = e[s]);
    return i;
}), Hi = B(Mi), Ui = _(function(t, e, i) {
    return Be(t, Mi(e, i));
}), Wi = B(function(t, e) {
    for(var i = {}, n = 0; n < t.length;)t[n] in e && (i[t[n]] = e[t[n]]), n += 1;
    return i;
}), Yi = B(function(t, e) {
    return z([
        t
    ], e);
}), _i = _(function(t, e, i) {
    return pt(t, jt(e, i));
}), Xi = _(function(t, e, i) {
    return Be(t, jt(e, i));
}), Gi = B(function(t, e) {
    return t.map(function(t) {
        return jt(t, e);
    });
}), qi = U(4, [], function(t, e, i, n) {
    var r = Xt(function(i, n) {
        return t(i, n) ? e(i, n) : V(i);
    });
    return Yt(r, i, n);
}), Vi = B(function(t, e) {
    var i = Number(e);
    if (i < 0 || isNaN(i)) throw new RangeError("n must be a non-negative number");
    for(var n = 0, r = Array(i); n < i;)r[n] = t(n), n += 1;
    return r;
}), $i = _(function(t, e, i) {
    return i.replace(t, e);
}), Ki = B(function(t, e) {
    return Array.prototype.slice.call(e, 0).sort(t);
}), Zi = B(function(t, e) {
    return Array.prototype.slice.call(e, 0).sort(function(e, i) {
        var n = t(e), r = t(i);
        return n < r ? -1 : n > r ? 1 : 0;
    });
}), Qi = wi(1, "split"), Ji = B(function(t, e) {
    return [
        Me(0, t, e),
        Me(t, Ai(e), e)
    ];
});
var tn, en, nn, rn, on, sn, an, ln, hn, cn, dn, un, pn, fn, gn, mn, bn, yn, xn, vn, wn, Cn, Sn, kn, An, En, Mn, Tn, Pn = B(function(t, e) {
    if (!function(t) {
        return "[object RegExp]" === Object.prototype.toString.call(t);
    }(t)) throw new TypeError("\u2018test\u2019 requires a value of type RegExp as its first argument; received " + Et(t));
    return ve(t).test(e);
}), Rn = wi(0, "toLowerCase"), Ln = I(function(t) {
    var e = [];
    for(var i in t)et(i, t) && (e[e.length] = [
        i,
        t[i]
    ]);
    return e;
}), On = wi(0, "toUpperCase"), Dn = xe(De), jn = _(function(t, e, i) {
    return t(i) ? e(i) : i;
}), Nn = B(function(t, e) {
    for(var i = new ze, n = 0; n < t.length; n += 1)i.add(t[n]);
    return kt(i.has.bind(i), e);
});
function In() {
    if (en) return tn;
    return en = 1, tn = function(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e);
    }, tn;
}
function Bn() {
    if (sn) return on;
    sn = 1;
    var t = function() {
        if (rn) return nn;
        rn = 1;
        var t = "object" == typeof m && m && m.Object === Object && m;
        return nn = t;
    }(), e = "object" == typeof self && self && self.Object === Object && self, i = t || e || Function("return this")();
    return on = i;
}
function Fn() {
    if (un) return dn;
    un = 1;
    var t = function() {
        if (cn) return hn;
        cn = 1;
        var t = /\s/;
        return hn = function(e) {
            for(var i = e.length; i-- && t.test(e.charAt(i)););
            return i;
        }, hn;
    }(), e = /^\s+/;
    return dn = function(i) {
        return i ? i.slice(0, t(i) + 1).replace(e, "") : i;
    };
}
function zn() {
    if (fn) return pn;
    fn = 1;
    var t = Bn().Symbol;
    return pn = t;
}
function Hn() {
    if (vn) return xn;
    vn = 1;
    var t = zn(), e = function() {
        if (mn) return gn;
        mn = 1;
        var t = zn(), e = Object.prototype, i = e.hasOwnProperty, n = e.toString, r = t ? t.toStringTag : void 0;
        return gn = function(t) {
            var e = i.call(t, r), o = t[r];
            try {
                t[r] = void 0;
                var s = !0;
            } catch (t) {}
            var a = n.call(t);
            return s && (e ? t[r] = o : delete t[r]), a;
        };
    }(), i = function() {
        if (yn) return bn;
        yn = 1;
        var t = Object.prototype.toString;
        return bn = function(e) {
            return t.call(e);
        };
    }(), n = t ? t.toStringTag : void 0;
    return xn = function(t) {
        return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : n && n in Object(t) ? e(t) : i(t);
    };
}
function Un() {
    if (kn) return Sn;
    kn = 1;
    var t = Hn(), e = Cn ? wn : (Cn = 1, wn = function(t) {
        return null != t && "object" == typeof t;
    });
    return Sn = function(i) {
        return "symbol" == typeof i || e(i) && "[object Symbol]" == t(i);
    };
}
function Wn() {
    if (Tn) return Mn;
    Tn = 1;
    var t = In(), e = function() {
        if (ln) return an;
        ln = 1;
        var t = Bn();
        return an = function() {
            return t.Date.now();
        };
    }(), i = function() {
        if (En) return An;
        En = 1;
        var t = Fn(), e = In(), i = Un(), n = /^[-+]0x[0-9a-f]+$/i, r = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
        return An = function(a) {
            if ("number" == typeof a) return a;
            if (i(a)) return NaN;
            if (e(a)) {
                var l = "function" == typeof a.valueOf ? a.valueOf() : a;
                a = e(l) ? l + "" : l;
            }
            if ("string" != typeof a) return 0 === a ? a : +a;
            a = t(a);
            var h = r.test(a);
            return h || o.test(a) ? s(a.slice(2), h ? 2 : 8) : n.test(a) ? NaN : +a;
        };
    }(), n = Math.max, r = Math.min;
    return Mn = function(o, s, a) {
        var l, h, c, d, u, p, f = 0, g = !1, m = !1, b = !0;
        if ("function" != typeof o) throw new TypeError("Expected a function");
        function y(t) {
            var e = l, i = h;
            return l = h = void 0, f = t, d = o.apply(i, e);
        }
        function x(t) {
            var e = t - p;
            return void 0 === p || e >= s || e < 0 || m && t - f >= c;
        }
        function v() {
            var t = e();
            if (x(t)) return w(t);
            u = setTimeout(v, function(t) {
                var e = s - (t - p);
                return m ? r(e, c - (t - f)) : e;
            }(t));
        }
        function w(t) {
            return u = void 0, b && l ? y(t) : (l = h = void 0, d);
        }
        function C() {
            var t = e(), i = x(t);
            if (l = arguments, h = this, p = t, i) {
                if (void 0 === u) return function(t) {
                    return f = t, u = setTimeout(v, s), g ? y(t) : d;
                }(p);
                if (m) return clearTimeout(u), u = setTimeout(v, s), y(p);
            }
            return void 0 === u && (u = setTimeout(v, s)), d;
        }
        return s = i(s) || 0, t(a) && (g = !!a.leading, c = (m = "maxWait" in a) ? n(i(a.maxWait) || 0, s) : c, b = "trailing" in a ? !!a.trailing : b), C.cancel = function() {
            void 0 !== u && clearTimeout(u), f = 0, l = p = h = u = void 0;
        }, C.flush = function() {
            return void 0 === u ? d : w(e());
        }, C;
    }, Mn;
}
var Yn, _n, Xn = b(Wn());
var Gn = function() {
    if (_n) return Yn;
    _n = 1;
    var t = Wn(), e = In();
    return Yn = function(i, n, r) {
        var o = !0, s = !0;
        if ("function" != typeof i) throw new TypeError("Expected a function");
        return e(r) && (o = "leading" in r ? !!r.leading : o, s = "trailing" in r ? !!r.trailing : s), t(i, n, {
            leading: o,
            maxWait: n,
            trailing: s
        });
    };
}(), qn = b(Gn);
function Vn({ skipOnMount: t = !1, refreshMode: e, refreshRate: i = 1e3, refreshOptions: n, handleWidth: r = !0, handleHeight: o = !0, targetRef: s, observerOptions: a, onResize: l } = {}) {
    const h = React.useRef(t), c = ((t)=>{
        const e = React.useRef(t);
        return React.useEffect(()=>{
            e.current = t;
        }), React.useMemo(()=>(...t)=>{
                var i;
                return null === (i = e.current) || void 0 === i ? void 0 : i.call(e, ...t);
            }, []);
    })(l), [d, u] = React.useState({
        width: void 0,
        height: void 0
    }), { refProxy: p, refElement: f } = ((t)=>{
        const [e, i] = React.useState((null == t ? void 0 : t.current) || null);
        t && setTimeout(()=>{
            t.current !== e && i(t.current);
        }, 0);
        const n = React.useMemo(()=>new Proxy((t)=>{
                t !== e && i(t);
            }, {
                get: (t, i)=>"current" === i ? e : t[i],
                set: (t, e, n)=>("current" === e ? i(n) : t[e] = n, !0)
            }), [
            e
        ]);
        return {
            refProxy: n,
            refElement: e,
            setRefElement: i
        };
    })(s), { box: g } = a || {}, m = React.useCallback((t)=>{
        if (!r && !o) return;
        if (h.current) return void (h.current = !1);
        t.forEach((t)=>{
            const e = ((t, e)=>"border-box" === e ? {
                    width: t.borderBoxSize[0].inlineSize,
                    height: t.borderBoxSize[0].blockSize
                } : "content-box" === e ? {
                    width: t.contentBoxSize[0].inlineSize,
                    height: t.contentBoxSize[0].blockSize
                } : {
                    width: t.contentRect.width,
                    height: t.contentRect.height
                })(t, g);
            u((i)=>((t, e)=>r && t.width !== e.width || o && t.height !== e.height)(i, e) ? (null == c || c({
                    width: e.width,
                    height: e.height,
                    entry: t
                }), e) : i);
        });
    }, [
        r,
        o,
        h,
        g
    ]), b = React.useCallback(((t, e, i, n)=>{
        switch(e){
            case "debounce":
                return Xn(t, i, n);
            case "throttle":
                return qn(t, i, n);
            default:
                return t;
        }
    })(m, e, i, n), [
        m,
        e,
        i,
        n
    ]);
    return React.useEffect(()=>{
        let t;
        return f ? (t = new window.ResizeObserver(b), t.observe(f, a)) : (d.width || d.height) && (null == c || c({
            width: null,
            height: null,
            entry: null
        }), u({
            width: void 0,
            height: void 0
        })), ()=>{
            var e, i, n;
            null === (e = null == t ? void 0 : t.disconnect) || void 0 === e || e.call(t), null === (n = (i = b).cancel) || void 0 === n || n.call(i);
        };
    }, [
        b,
        f
    ]), Object.assign({
        ref: p
    }, d);
}
var $n, Kn = {
    exports: {}
};
var Zn, Qn = ($n || ($n = 1, Zn = Kn, function(t) {
    if ("function" != typeof e) {
        var e = function(t) {
            return t;
        };
        e.nonNative = !0;
    }
    const i = e("plaintext"), n = e("html"), r = e("comment"), o = /<(\w*)>/g, s = /<\/?([^\s\/>]+)/;
    function a(t, e, i) {
        return h(t = t || "", l(e = e || [], i = i || ""));
    }
    function l(t, n) {
        return t = function(t) {
            let i = new Set;
            if ("string" == typeof t) {
                let e;
                for(; e = o.exec(t);)i.add(e[1]);
            } else e.nonNative || "function" != typeof t[e.iterator] ? "function" == typeof t.forEach && t.forEach(i.add, i) : i = new Set(t);
            return i;
        }(t), {
            allowable_tags: t,
            tag_replacement: n,
            state: i,
            tag_buffer: "",
            depth: 0,
            in_quote_char: ""
        };
    }
    function h(t, e) {
        if ("string" != typeof t) throw new TypeError("'html' parameter must be a string");
        let o = e.allowable_tags, s = e.tag_replacement, a = e.state, l = e.tag_buffer, h = e.depth, d = e.in_quote_char, u = "";
        for(let e = 0, p = t.length; e < p; e++){
            let p = t[e];
            if (a === i) "<" === p ? (a = n, l += p) : u += p;
            else if (a === n) switch(p){
                case "<":
                    if (d) break;
                    h++;
                    break;
                case ">":
                    if (d) break;
                    if (h) {
                        h--;
                        break;
                    }
                    d = "", a = i, l += ">", o.has(c(l)) ? u += l : u += s, l = "";
                    break;
                case '"':
                case "'":
                    d = p === d ? "" : d || p, l += p;
                    break;
                case "-":
                    "<!-" === l && (a = r), l += p;
                    break;
                case " ":
                case "\n":
                    if ("<" === l) {
                        a = i, u += "< ", l = "";
                        break;
                    }
                    l += p;
                    break;
                default:
                    l += p;
            }
            else a === r && (">" === p ? ("--" == l.slice(-2) && (a = i), l = "") : l += p);
        }
        return e.state = a, e.tag_buffer = l, e.depth = h, e.in_quote_char = d, u;
    }
    function c(t) {
        let e = s.exec(t);
        return e ? e[1].toLowerCase() : null;
    }
    a.init_streaming_mode = function(t, e) {
        let i = l(t = t || [], e = e || "");
        return function(t) {
            return h(t || "", i);
        };
    }, Zn.exports ? Zn.exports = a : t.striptags = a;
}(Kn.exports)), Kn.exports), Jn = b(Qn);
const tr = {
    line: "Line",
    bar: "Bar",
    row: "Row",
    stackedBar: "StackedBar",
    stackedRow: "StackedRow",
    stackedArea: "StackedArea",
    map: "Map",
    symbol: "Symbol",
    scatter: "Scatter",
    radar: "Radar",
    pie: "Pie"
}, er = [
    tr.map,
    tr.pie,
    tr.stackedBar,
    tr.stackedRow,
    tr.radar
], ir = {
    percent: {
        value: "percent",
        label: "Percent"
    },
    normal: {
        value: "normal",
        label: "Normal"
    }
}, nr = {
    csv: {
        value: "csv",
        label: "CSV"
    },
    dotStat: {
        value: "dotStat",
        label: ".Stat"
    },
    dotStatSnapshot: {
        value: "dotStatSnapshot",
        label: ".Stat snapshot"
    }
}, rr = {
    none: {
        value: "none",
        label: "None (data order)"
    },
    categoriesLabel: {
        value: "categoriesLabel",
        label: "Categories label"
    },
    categoriesCode: {
        value: "categoriesCode",
        label: "Categories code"
    },
    seriesValue: {
        value: "seriesValue",
        label: "Series value"
    }
}, or = {
    asc: {
        value: "asc",
        label: "Ascending"
    },
    desc: {
        value: "desc",
        label: "Descending"
    }
}, sr = {
    none: {
        value: "none",
        label: "None (options order)"
    },
    label: {
        value: "label",
        label: "Label"
    }
}, ar = {
    normal: {
        value: "normal",
        label: "Choropleth"
    },
    bubble: {
        value: "bubble",
        label: "Bubble"
    },
    point: {
        value: "point",
        label: "Point"
    }
}, lr = {
    timeSlider: {
        value: "timeSlider",
        label: "Time slider"
    },
    select: {
        value: "select",
        label: "Variable select"
    },
    selectChart: {
        value: "selectChart",
        label: "Chart select"
    },
    reusableControl: {
        value: "reusableControl",
        label: "Reusable control"
    },
    missingReusableControl: {
        value: "missingReusableControl",
        label: "Missing reusable control"
    }
}, hr = {
    value: "quinquennial",
    label: "Quinquennial",
    dotStatId: "A5"
}, cr = {
    value: "yearly",
    label: "Yearly",
    dotStatId: "A"
}, dr = {
    value: "quarterly",
    label: "Quarterly",
    dotStatId: "Q"
}, ur = {
    value: "monthly",
    label: "Monthly",
    dotStatId: "M"
}, pr = {
    point: {
        value: ".",
        label: "Point"
    },
    comma: {
        value: ",",
        label: "Comma"
    }
}, fr = ("undefined" != typeof __CHART_BUILDER_API_URL_OVERRIDE ? __CHART_BUILDER_API_URL_OVERRIDE : null) || "https://oecdch.art", gr = "dotStatInfo", mr = "tooManyDataPoint", br = "empty", yr = {
    generic: React.createElement("span", {
        style: {
            textAlign: "center"
        }
    }, "An error occured.", React.createElement("br", null), "Please refresh the page."),
    noData: React.createElement("span", {
        style: {
            textAlign: "center"
        }
    }, "No data available for the current selection."),
    underEmbargo: React.createElement("span", {
        style: {
            textAlign: "center"
        }
    }, "Not yet available")
};
var xr, vr = {
    exports: {}
}, wr = vr.exports;
var Cr, Sr = (xr || (xr = 1, function(t) {
    var e, i;
    e = "undefined" != typeof window ? window : wr, i = function(t) {
        var e = {};
        function i(e, i, n, r) {
            !e.hasOwnProperty(i) && (e[i] = r.apply(null, n), t && "function" == typeof CustomEvent && t.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
                detail: {
                    path: i,
                    module: e[i]
                }
            })));
        }
        return i(e, "Core/Globals.js", [], function() {
            var e, i;
            return (i = e || (e = {})).SVG_NS = "http://www.w3.org/2000/svg", i.product = "Highcharts", i.version = "11.4.8", i.win = void 0 !== t ? t : {}, i.doc = i.win.document, i.svg = i.doc && i.doc.createElementNS && !!i.doc.createElementNS(i.SVG_NS, "svg").createSVGRect, i.userAgent = i.win.navigator && i.win.navigator.userAgent || "", i.isChrome = i.win.chrome, i.isFirefox = -1 !== i.userAgent.indexOf("Firefox"), i.isMS = /(edge|msie|trident)/i.test(i.userAgent) && !i.win.opera, i.isSafari = !i.isChrome && -1 !== i.userAgent.indexOf("Safari"), i.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(i.userAgent), i.isWebKit = -1 !== i.userAgent.indexOf("AppleWebKit"), i.deg2rad = 2 * Math.PI / 360, i.hasBidiBug = i.isFirefox && 4 > parseInt(i.userAgent.split("Firefox/")[1], 10), i.marginNames = [
                "plotTop",
                "marginRight",
                "marginBottom",
                "plotLeft"
            ], i.noop = function() {}, i.supportsPassiveEvents = function() {
                let t = !1;
                if (!i.isMS) {
                    let e = Object.defineProperty({}, "passive", {
                        get: function() {
                            t = !0;
                        }
                    });
                    i.win.addEventListener && i.win.removeEventListener && (i.win.addEventListener("testPassive", i.noop, e), i.win.removeEventListener("testPassive", i.noop, e));
                }
                return t;
            }(), i.charts = [], i.composed = [], i.dateFormats = {}, i.seriesTypes = {}, i.symbolSizes = {}, i.chartCount = 0, e;
        }), i(e, "Core/Utilities.js", [
            e["Core/Globals.js"]
        ], function(t) {
            let e, { charts: i, doc: n, win: r } = t;
            function o(e, i, n, s) {
                let a = i ? "Highcharts error" : "Highcharts warning";
                32 === e && (e = `${a}: Deprecated member`);
                let l = u(e), h = l ? `${a} #${e}: www.highcharts.com/errors/${e}/` : e.toString();
                if (void 0 !== s) {
                    let t = "";
                    l && (h += "?"), C(s, function(e, i) {
                        t += `\n - ${i}: ${e}`, l && (h += encodeURI(i) + "=" + encodeURI(e));
                    }), h += t;
                }
                k(t, "displayError", {
                    chart: n,
                    code: e,
                    message: h,
                    params: s
                }, function() {
                    if (i) throw Error(h);
                    r.console && -1 === o.messages.indexOf(h) && console.warn(h);
                }), o.messages.push(h);
            }
            function s(t, e) {
                return parseInt(t, e || 10);
            }
            function a(t) {
                return "string" == typeof t;
            }
            function l(t) {
                let e = Object.prototype.toString.call(t);
                return "[object Array]" === e || "[object Array Iterator]" === e;
            }
            function h(t, e) {
                return !(!t || "object" != typeof t || e && l(t));
            }
            function c(t) {
                return h(t) && "number" == typeof t.nodeType;
            }
            function d(t) {
                let e = t && t.constructor;
                return !(!h(t, !0) || c(t) || !e || !e.name || "Object" === e.name);
            }
            function u(t) {
                return "number" == typeof t && !isNaN(t) && t < 1 / 0 && t > -1 / 0;
            }
            function p(t) {
                return null != t;
            }
            function f(t, e, i) {
                let n, r = a(e) && !p(i), o = (e, i)=>{
                    p(e) ? t.setAttribute(i, e) : r ? (n = t.getAttribute(i)) || "class" !== i || (n = t.getAttribute(i + "Name")) : t.removeAttribute(i);
                };
                return a(e) ? o(i, e) : C(e, o), n;
            }
            function g(t) {
                return l(t) ? t : [
                    t
                ];
            }
            function m(t, e) {
                let i;
                for(i in t || (t = {}), e)t[i] = e[i];
                return t;
            }
            function b() {
                let t = arguments, e = t.length;
                for(let i = 0; i < e; i++){
                    let e = t[i];
                    if (null != e) return e;
                }
            }
            function y(t, e) {
                m(t.style, e);
            }
            function x(t) {
                return Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
            }
            function v(t, e) {
                return t > 1e14 ? t : parseFloat(t.toPrecision(e || 14));
            }
            (o || (o = {})).messages = [], Math.easeInOutSine = function(t) {
                return -0.5 * (Math.cos(Math.PI * t) - 1);
            };
            let w = Array.prototype.find ? function(t, e) {
                return t.find(e);
            } : function(t, e) {
                let i, n = t.length;
                for(i = 0; i < n; i++)if (e(t[i], i)) return t[i];
            };
            function C(t, e, i) {
                for(let n in t)Object.hasOwnProperty.call(t, n) && e.call(i || t[n], t[n], n, t);
            }
            function S(t, e, i) {
                function n(e, i) {
                    let n = t.removeEventListener;
                    n && n.call(t, e, i, !1);
                }
                function r(i) {
                    let r, o;
                    t.nodeName && (e ? (r = {})[e] = !0 : r = i, C(r, function(t, e) {
                        if (i[e]) for(o = i[e].length; o--;)n(e, i[e][o].fn);
                    }));
                }
                let o = "function" == typeof t && t.prototype || t;
                if (Object.hasOwnProperty.call(o, "hcEvents")) {
                    let t = o.hcEvents;
                    if (e) {
                        let o = t[e] || [];
                        i ? (t[e] = o.filter(function(t) {
                            return i !== t.fn;
                        }), n(e, i)) : (r(t), t[e] = []);
                    } else r(t), delete o.hcEvents;
                }
            }
            function k(e, i, r, o) {
                if (r = r || {}, n.createEvent && (e.dispatchEvent || e.fireEvent && e !== t)) {
                    let t = n.createEvent("Events");
                    t.initEvent(i, !0, !0), r = m(t, r), e.dispatchEvent ? e.dispatchEvent(r) : e.fireEvent(i, r);
                } else if (e.hcEvents) {
                    r.target || m(r, {
                        preventDefault: function() {
                            r.defaultPrevented = !0;
                        },
                        target: e,
                        type: i
                    });
                    let t = [], n = e, o = !1;
                    for(; n.hcEvents;)Object.hasOwnProperty.call(n, "hcEvents") && n.hcEvents[i] && (t.length && (o = !0), t.unshift.apply(t, n.hcEvents[i])), n = Object.getPrototypeOf(n);
                    o && t.sort((t, e)=>t.order - e.order), t.forEach((t)=>{
                        !1 === t.fn.call(e, r) && r.preventDefault();
                    });
                }
                o && !r.defaultPrevented && o.call(e, r);
            }
            C({
                map: "map",
                each: "forEach",
                grep: "filter",
                reduce: "reduce",
                some: "some"
            }, function(e, i) {
                t[i] = function(t) {
                    return o(32, !1, void 0, {
                        [`Highcharts.${i}`]: `use Array.${e}`
                    }), Array.prototype[e].apply(t, [].slice.call(arguments, 1));
                };
            });
            let A = function() {
                let t = Math.random().toString(36).substring(2, 9) + "-", i = 0;
                return function() {
                    return "highcharts-" + (e ? "" : t) + i++;
                };
            }();
            return r.jQuery && (r.jQuery.fn.highcharts = function() {
                let e = [].slice.call(arguments);
                if (this[0]) return e[0] ? (new t[a(e[0]) ? e.shift() : "Chart"](this[0], e[0], e[1]), this) : i[f(this[0], "data-highcharts-chart")];
            }), {
                addEvent: function(e, i, n, r = {}) {
                    let o = "function" == typeof e && e.prototype || e;
                    Object.hasOwnProperty.call(o, "hcEvents") || (o.hcEvents = {});
                    let s = o.hcEvents;
                    t.Point && e instanceof t.Point && e.series && e.series.chart && (e.series.chart.runTrackerClick = !0);
                    let a = e.addEventListener;
                    a && a.call(e, i, n, !!t.supportsPassiveEvents && {
                        passive: void 0 === r.passive ? -1 !== i.indexOf("touch") : r.passive,
                        capture: !1
                    }), s[i] || (s[i] = []);
                    let l = {
                        fn: n,
                        order: "number" == typeof r.order ? r.order : 1 / 0
                    };
                    return s[i].push(l), s[i].sort((t, e)=>t.order - e.order), function() {
                        S(e, i, n);
                    };
                },
                arrayMax: function(t) {
                    let e = t.length, i = t[0];
                    for(; e--;)t[e] > i && (i = t[e]);
                    return i;
                },
                arrayMin: function(t) {
                    let e = t.length, i = t[0];
                    for(; e--;)t[e] < i && (i = t[e]);
                    return i;
                },
                attr: f,
                clamp: function(t, e, i) {
                    return t > e ? t < i ? t : i : e;
                },
                clearTimeout: function(t) {
                    p(t) && clearTimeout(t);
                },
                correctFloat: v,
                createElement: function(t, e, i, r, o) {
                    let s = n.createElement(t);
                    return e && m(s, e), o && y(s, {
                        padding: "0",
                        border: "none",
                        margin: "0"
                    }), i && y(s, i), r && r.appendChild(s), s;
                },
                crisp: (t, e = 0, i)=>{
                    let n = e % 2 / 2, r = i ? -1 : 1;
                    return (Math.round(t * r - n) + n) * r;
                },
                css: y,
                defined: p,
                destroyObjectProperties: function(t, e, i) {
                    C(t, function(n, r) {
                        n !== e && n?.destroy && n.destroy(), (n?.destroy || !i) && delete t[r];
                    });
                },
                diffObjects: function(t, e, i, n) {
                    let r = {};
                    return function t(e, r, o, s) {
                        let a = i ? r : e;
                        C(e, function(i, c) {
                            if (!s && n && n.indexOf(c) > -1 && r[c]) {
                                i = g(i), o[c] = [];
                                for(let e = 0; e < Math.max(i.length, r[c].length); e++)r[c][e] && (void 0 === i[e] ? o[c][e] = r[c][e] : (o[c][e] = {}, t(i[e], r[c][e], o[c][e], s + 1)));
                            } else h(i, !0) && !i.nodeType ? (o[c] = l(i) ? [] : {}, t(i, r[c] || {}, o[c], s + 1), 0 !== Object.keys(o[c]).length || "colorAxis" === c && 0 === s || delete o[c]) : (e[c] !== r[c] || c in e && !(c in r)) && "__proto__" !== c && "constructor" !== c && (o[c] = a[c]);
                        });
                    }(t, e, r, 0), r;
                },
                discardElement: function(t) {
                    t && t.parentElement && t.parentElement.removeChild(t);
                },
                erase: function(t, e) {
                    let i = t.length;
                    for(; i--;)if (t[i] === e) {
                        t.splice(i, 1);
                        break;
                    }
                },
                error: o,
                extend: m,
                extendClass: function(t, e) {
                    let i = function() {};
                    return m(i.prototype = new t, e), i;
                },
                find: w,
                fireEvent: k,
                getClosestDistance: function(t, e) {
                    let i, n, r, o = !e;
                    return t.forEach((t)=>{
                        if (t.length > 1) for(r = t.length - 1; r > 0; r--)(n = t[r] - t[r - 1]) < 0 && !o ? (e?.(), e = void 0) : n && (void 0 === i || n < i) && (i = n);
                    }), i;
                },
                getMagnitude: x,
                getNestedProperty: function(t, e) {
                    let i = t.split(".");
                    for(; i.length && p(e);){
                        let t = i.shift();
                        if (void 0 === t || "__proto__" === t) return;
                        if ("this" === t) {
                            let t;
                            return h(e) && (t = e["@this"]), t ?? e;
                        }
                        let n = e[t];
                        if (!p(n) || "function" == typeof n || "number" == typeof n.nodeType || n === r) return;
                        e = n;
                    }
                    return e;
                },
                getStyle: function t(e, i, n) {
                    let o;
                    if ("width" === i) {
                        let i = Math.min(e.offsetWidth, e.scrollWidth), n = e.getBoundingClientRect && e.getBoundingClientRect().width;
                        return n < i && n >= i - 1 && (i = Math.floor(n)), Math.max(0, i - (t(e, "padding-left", !0) || 0) - (t(e, "padding-right", !0) || 0));
                    }
                    if ("height" === i) return Math.max(0, Math.min(e.offsetHeight, e.scrollHeight) - (t(e, "padding-top", !0) || 0) - (t(e, "padding-bottom", !0) || 0));
                    let a = r.getComputedStyle(e, void 0);
                    return a && (o = a.getPropertyValue(i), b(n, "opacity" !== i) && (o = s(o))), o;
                },
                inArray: function(t, e, i) {
                    return o(32, !1, void 0, {
                        "Highcharts.inArray": "use Array.indexOf"
                    }), e.indexOf(t, i);
                },
                insertItem: function(t, e) {
                    let i, n = t.options.index, r = e.length;
                    for(i = t.options.isInternal ? r : 0; i < r + 1; i++)if (!e[i] || u(n) && n < b(e[i].options.index, e[i]._i) || e[i].options.isInternal) {
                        e.splice(i, 0, t);
                        break;
                    }
                    return i;
                },
                isArray: l,
                isClass: d,
                isDOMElement: c,
                isFunction: function(t) {
                    return "function" == typeof t;
                },
                isNumber: u,
                isObject: h,
                isString: a,
                keys: function(t) {
                    return o(32, !1, void 0, {
                        "Highcharts.keys": "use Object.keys"
                    }), Object.keys(t);
                },
                merge: function() {
                    let t, e = arguments, i = {}, n = function(t, e) {
                        return "object" != typeof t && (t = {}), C(e, function(i, r) {
                            "__proto__" !== r && "constructor" !== r && (!h(i, !0) || d(i) || c(i) ? t[r] = e[r] : t[r] = n(t[r] || {}, i));
                        }), t;
                    };
                    !0 === e[0] && (i = e[1], e = Array.prototype.slice.call(e, 2));
                    let r = e.length;
                    for(t = 0; t < r; t++)i = n(i, e[t]);
                    return i;
                },
                normalizeTickInterval: function(t, e, i, n, r) {
                    let o, s = t, a = t / (i = b(i, x(t)));
                    for(!e && (e = r ? [
                        1,
                        1.2,
                        1.5,
                        2,
                        2.5,
                        3,
                        4,
                        5,
                        6,
                        8,
                        10
                    ] : [
                        1,
                        2,
                        2.5,
                        5,
                        10
                    ], !1 === n && (1 === i ? e = e.filter(function(t) {
                        return t % 1 == 0;
                    }) : i <= .1 && (e = [
                        1 / i
                    ]))), o = 0; o < e.length && (s = e[o], (!r || !(s * i >= t)) && (r || !(a <= (e[o] + (e[o + 1] || e[o])) / 2))); o++);
                    return v(s * i, -Math.round(Math.log(.001) / Math.LN10));
                },
                objectEach: C,
                offset: function(t) {
                    let e = n.documentElement, i = t.parentElement || t.parentNode ? t.getBoundingClientRect() : {
                        top: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    };
                    return {
                        top: i.top + (r.pageYOffset || e.scrollTop) - (e.clientTop || 0),
                        left: i.left + (r.pageXOffset || e.scrollLeft) - (e.clientLeft || 0),
                        width: i.width,
                        height: i.height
                    };
                },
                pad: function(t, e, i) {
                    return Array((e || 2) + 1 - String(t).replace("-", "").length).join(i || "0") + t;
                },
                pick: b,
                pInt: s,
                pushUnique: function(t, e) {
                    return 0 > t.indexOf(e) && !!t.push(e);
                },
                relativeLength: function(t, e, i) {
                    return /%$/.test(t) ? e * parseFloat(t) / 100 + (i || 0) : parseFloat(t);
                },
                removeEvent: S,
                replaceNested: function(t, ...e) {
                    let i, n;
                    do for (n of (i = t, e))t = t.replace(n[0], n[1]);
                    while (t !== i);
                    return t;
                },
                splat: g,
                stableSort: function(t, e) {
                    let i, n, r = t.length;
                    for(n = 0; n < r; n++)t[n].safeI = n;
                    for(t.sort(function(t, n) {
                        return 0 === (i = e(t, n)) ? t.safeI - n.safeI : i;
                    }), n = 0; n < r; n++)delete t[n].safeI;
                },
                syncTimeout: function(t, e, i) {
                    return e > 0 ? setTimeout(t, e, i) : (t.call(0, i), -1);
                },
                timeUnits: {
                    millisecond: 1,
                    second: 1e3,
                    minute: 6e4,
                    hour: 36e5,
                    day: 864e5,
                    week: 6048e5,
                    month: 24192e5,
                    year: 314496e5
                },
                uniqueKey: A,
                useSerialIds: function(t) {
                    return e = b(t, e);
                },
                wrap: function(t, e, i) {
                    let n = t[e];
                    t[e] = function() {
                        let t = arguments, e = this;
                        return i.apply(this, [
                            function() {
                                return n.apply(e, arguments.length ? arguments : t);
                            }
                        ].concat([].slice.call(arguments)));
                    };
                }
            };
        }), i(e, "Core/Chart/ChartDefaults.js", [], function() {
            return {
                alignThresholds: !1,
                panning: {
                    enabled: !1,
                    type: "x"
                },
                styledMode: !1,
                borderRadius: 0,
                colorCount: 10,
                allowMutatingData: !0,
                ignoreHiddenSeries: !0,
                spacing: [
                    10,
                    10,
                    15,
                    10
                ],
                resetZoomButton: {
                    theme: {},
                    position: {}
                },
                reflow: !0,
                type: "line",
                zooming: {
                    singleTouch: !1,
                    resetButton: {
                        theme: {
                            zIndex: 6
                        },
                        position: {
                            align: "right",
                            x: -10,
                            y: 10
                        }
                    }
                },
                width: null,
                height: null,
                borderColor: "#334eff",
                backgroundColor: "#ffffff",
                plotBorderColor: "#cccccc"
            };
        }), i(e, "Core/Color/Palettes.js", [], function() {
            return {
                colors: [
                    "#2caffe",
                    "#544fc5",
                    "#00e272",
                    "#fe6a35",
                    "#6b8abc",
                    "#d568fb",
                    "#2ee0ca",
                    "#fa4b42",
                    "#feb56a",
                    "#91e8e1"
                ]
            };
        }), i(e, "Core/Time.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { win: i } = t, { defined: n, error: r, extend: o, isNumber: s, isObject: a, merge: l, objectEach: h, pad: c, pick: d, splat: u, timeUnits: p } = e, f = t.isSafari && i.Intl && i.Intl.DateTimeFormat.prototype.formatRange, g = t.isSafari && i.Intl && !i.Intl.DateTimeFormat.prototype.formatRange;
            class m {
                constructor(t){
                    this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = i.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(t);
                }
                get(t, e) {
                    if (this.variableTimezone || this.timezoneOffset) {
                        let i = e.getTime(), n = i - this.getTimezoneOffset(e);
                        e.setTime(n);
                        let r = e["getUTC" + t]();
                        return e.setTime(i), r;
                    }
                    return this.useUTC ? e["getUTC" + t]() : e["get" + t]();
                }
                set(t, e, i) {
                    if (this.variableTimezone || this.timezoneOffset) {
                        if ("Milliseconds" === t || "Seconds" === t || "Minutes" === t && this.getTimezoneOffset(e) % 36e5 == 0) return e["setUTC" + t](i);
                        let n = this.getTimezoneOffset(e), r = e.getTime() - n;
                        e.setTime(r), e["setUTC" + t](i);
                        let o = this.getTimezoneOffset(e);
                        return r = e.getTime() + o, e.setTime(r);
                    }
                    return this.useUTC || f && "FullYear" === t ? e["setUTC" + t](i) : e["set" + t](i);
                }
                update(t = {}) {
                    let e = d(t.useUTC, !0);
                    this.options = t = l(!0, this.options, t), this.Date = t.Date || i.Date || Date, this.useUTC = e, this.timezoneOffset = e && t.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = e && !(!t.getTimezoneOffset && !t.timezone);
                }
                makeTime(t, e, i, n, r, o) {
                    let s, a, l;
                    return this.useUTC ? (s = this.Date.UTC.apply(0, arguments), a = this.getTimezoneOffset(s), s += a, a !== (l = this.getTimezoneOffset(s)) ? s += l - a : a - 36e5 !== this.getTimezoneOffset(s - 36e5) || g || (s -= 36e5)) : s = new this.Date(t, e, d(i, 1), d(n, 0), d(r, 0), d(o, 0)).getTime(), s;
                }
                timezoneOffsetFunction() {
                    let t = this, e = this.options, i = e.getTimezoneOffset;
                    return this.useUTC ? e.timezone ? (t)=>{
                        try {
                            let i = `shortOffset,${e.timezone || ""}`, [n, r, o, a, l = 0] = (m.formatCache[i] = m.formatCache[i] || Intl.DateTimeFormat("en", {
                                timeZone: e.timezone,
                                timeZoneName: "shortOffset"
                            })).format(t).split(/(GMT|:)/).map(Number), h = -3600000 * (o + l / 60);
                            if (s(h)) return h;
                        } catch (t) {
                            r(34);
                        }
                        return 0;
                    } : this.useUTC && i ? (t)=>6e4 * i(t.valueOf()) : ()=>6e4 * (t.timezoneOffset || 0) : (t)=>6e4 * new Date(t.toString()).getTimezoneOffset();
                }
                dateFormat(e, i, r) {
                    if (!n(i) || isNaN(i)) return t.defaultOptions.lang && t.defaultOptions.lang.invalidDate || "";
                    e = d(e, "%Y-%m-%d %H:%M:%S");
                    let s = this, a = new this.Date(i), l = this.get("Hours", a), u = this.get("Day", a), p = this.get("Date", a), f = this.get("Month", a), g = this.get("FullYear", a), m = t.defaultOptions.lang, b = m && m.weekdays, y = m && m.shortWeekdays;
                    return h(o({
                        a: y ? y[u] : b[u].substr(0, 3),
                        A: b[u],
                        d: c(p),
                        e: c(p, 2, " "),
                        w: u,
                        b: m.shortMonths[f],
                        B: m.months[f],
                        m: c(f + 1),
                        o: f + 1,
                        y: g.toString().substr(2, 2),
                        Y: g,
                        H: c(l),
                        k: l,
                        I: c(l % 12 || 12),
                        l: l % 12 || 12,
                        M: c(this.get("Minutes", a)),
                        p: l < 12 ? "AM" : "PM",
                        P: l < 12 ? "am" : "pm",
                        S: c(this.get("Seconds", a)),
                        L: c(Math.floor(i % 1e3), 3)
                    }, t.dateFormats), function(t, n) {
                        for(; -1 !== e.indexOf("%" + n);)e = e.replace("%" + n, "function" == typeof t ? t.call(s, i) : t);
                    }), r ? e.substr(0, 1).toUpperCase() + e.substr(1) : e;
                }
                resolveDTLFormat(t) {
                    return a(t, !0) ? t : {
                        main: (t = u(t))[0],
                        from: t[1],
                        to: t[2]
                    };
                }
                getTimeTicks(t, e, i, r) {
                    let s, a, l, h, c = this, u = c.Date, f = [], g = {}, m = new u(e), b = t.unitRange, y = t.count || 1;
                    if (r = d(r, 1), n(e)) {
                        c.set("Milliseconds", m, b >= p.second ? 0 : y * Math.floor(c.get("Milliseconds", m) / y)), b >= p.second && c.set("Seconds", m, b >= p.minute ? 0 : y * Math.floor(c.get("Seconds", m) / y)), b >= p.minute && c.set("Minutes", m, b >= p.hour ? 0 : y * Math.floor(c.get("Minutes", m) / y)), b >= p.hour && c.set("Hours", m, b >= p.day ? 0 : y * Math.floor(c.get("Hours", m) / y)), b >= p.day && c.set("Date", m, b >= p.month ? 1 : Math.max(1, y * Math.floor(c.get("Date", m) / y))), b >= p.month && (c.set("Month", m, b >= p.year ? 0 : y * Math.floor(c.get("Month", m) / y)), a = c.get("FullYear", m)), b >= p.year && (a -= a % y, c.set("FullYear", m, a)), b === p.week && (h = c.get("Day", m), c.set("Date", m, c.get("Date", m) - h + r + (h < r ? -7 : 0))), a = c.get("FullYear", m);
                        let t = c.get("Month", m), o = c.get("Date", m), d = c.get("Hours", m);
                        e = m.getTime(), (c.variableTimezone || !c.useUTC) && n(i) && (l = i - e > 4 * p.month || c.getTimezoneOffset(e) !== c.getTimezoneOffset(i));
                        let u = m.getTime();
                        for(s = 1; u < i;)f.push(u), b === p.year ? u = c.makeTime(a + s * y, 0) : b === p.month ? u = c.makeTime(a, t + s * y) : !l || b !== p.day && b !== p.week ? l && b === p.hour && y > 1 ? u = c.makeTime(a, t, o, d + s * y) : u += b * y : u = c.makeTime(a, t, o + s * y * (b === p.day ? 1 : 7)), s++;
                        f.push(u), b <= p.hour && f.length < 1e4 && f.forEach(function(t) {
                            t % 18e5 == 0 && "000000000" === c.dateFormat("%H%M%S%L", t) && (g[t] = "day");
                        });
                    }
                    return f.info = o(t, {
                        higherRanks: g,
                        totalRange: b * y
                    }), f;
                }
                getDateFormat(t, e, i, n) {
                    let r = this.dateFormat("%m-%d %H:%M:%S.%L", e), o = "01-01 00:00:00.000", s = {
                        millisecond: 15,
                        second: 12,
                        minute: 9,
                        hour: 6,
                        day: 3
                    }, a = "millisecond", l = a;
                    for(a in p){
                        if (t === p.week && +this.dateFormat("%w", e) === i && r.substr(6) === o.substr(6)) {
                            a = "week";
                            break;
                        }
                        if (p[a] > t) {
                            a = l;
                            break;
                        }
                        if (s[a] && r.substr(s[a]) !== o.substr(s[a])) break;
                        "week" !== a && (l = a);
                    }
                    return this.resolveDTLFormat(n[a]).main;
                }
            }
            return m.formatCache = {}, m;
        }), i(e, "Core/Defaults.js", [
            e["Core/Chart/ChartDefaults.js"],
            e["Core/Globals.js"],
            e["Core/Color/Palettes.js"],
            e["Core/Time.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { isTouchDevice: o } = e, { fireEvent: s, merge: a } = r, l = {
                colors: i.colors,
                symbols: [
                    "circle",
                    "diamond",
                    "square",
                    "triangle",
                    "triangle-down"
                ],
                lang: {
                    loading: "Loading...",
                    months: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    shortMonths: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    weekdays: [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    decimalPoint: ".",
                    numericSymbols: [
                        "k",
                        "M",
                        "G",
                        "T",
                        "P",
                        "E"
                    ],
                    resetZoom: "Reset zoom",
                    resetZoomTitle: "Reset zoom level 1:1",
                    thousandsSep: " "
                },
                global: {
                    buttonTheme: {
                        fill: "#f7f7f7",
                        padding: 8,
                        r: 2,
                        stroke: "#cccccc",
                        "stroke-width": 1,
                        style: {
                            color: "#333333",
                            cursor: "pointer",
                            fontSize: "0.8em",
                            fontWeight: "normal"
                        },
                        states: {
                            hover: {
                                fill: "#e6e6e6"
                            },
                            select: {
                                fill: "#e6e9ff",
                                style: {
                                    color: "#000000",
                                    fontWeight: "bold"
                                }
                            },
                            disabled: {
                                style: {
                                    color: "#cccccc"
                                }
                            }
                        }
                    }
                },
                time: {
                    Date: void 0,
                    getTimezoneOffset: void 0,
                    timezone: void 0,
                    timezoneOffset: 0,
                    useUTC: !0
                },
                chart: t,
                title: {
                    style: {
                        color: "#333333",
                        fontWeight: "bold"
                    },
                    text: "Chart title",
                    align: "center",
                    margin: 15,
                    widthAdjust: -44
                },
                subtitle: {
                    style: {
                        color: "#666666",
                        fontSize: "0.8em"
                    },
                    text: "",
                    align: "center",
                    widthAdjust: -44
                },
                caption: {
                    margin: 15,
                    style: {
                        color: "#666666",
                        fontSize: "0.8em"
                    },
                    text: "",
                    align: "left",
                    verticalAlign: "bottom"
                },
                plotOptions: {},
                legend: {
                    enabled: !0,
                    align: "center",
                    alignColumns: !0,
                    className: "highcharts-no-tooltip",
                    events: {},
                    layout: "horizontal",
                    itemMarginBottom: 2,
                    itemMarginTop: 2,
                    labelFormatter: function() {
                        return this.name;
                    },
                    borderColor: "#999999",
                    borderRadius: 0,
                    navigation: {
                        style: {
                            fontSize: "0.8em"
                        },
                        activeColor: "#0022ff",
                        inactiveColor: "#cccccc"
                    },
                    itemStyle: {
                        color: "#333333",
                        cursor: "pointer",
                        fontSize: "0.8em",
                        textDecoration: "none",
                        textOverflow: "ellipsis"
                    },
                    itemHoverStyle: {
                        color: "#000000"
                    },
                    itemHiddenStyle: {
                        color: "#666666",
                        textDecoration: "line-through"
                    },
                    shadow: !1,
                    itemCheckboxStyle: {
                        position: "absolute",
                        width: "13px",
                        height: "13px"
                    },
                    squareSymbol: !0,
                    symbolPadding: 5,
                    verticalAlign: "bottom",
                    x: 0,
                    y: 0,
                    title: {
                        style: {
                            fontSize: "0.8em",
                            fontWeight: "bold"
                        }
                    }
                },
                loading: {
                    labelStyle: {
                        fontWeight: "bold",
                        position: "relative",
                        top: "45%"
                    },
                    style: {
                        position: "absolute",
                        backgroundColor: "#ffffff",
                        opacity: .5,
                        textAlign: "center"
                    }
                },
                tooltip: {
                    enabled: !0,
                    animation: {
                        duration: 300,
                        easing: (t)=>Math.sqrt(1 - Math.pow(t - 1, 2))
                    },
                    borderRadius: 3,
                    dateTimeLabelFormats: {
                        millisecond: "%A, %e %b, %H:%M:%S.%L",
                        second: "%A, %e %b, %H:%M:%S",
                        minute: "%A, %e %b, %H:%M",
                        hour: "%A, %e %b, %H:%M",
                        day: "%A, %e %b %Y",
                        week: "Week from %A, %e %b %Y",
                        month: "%B %Y",
                        year: "%Y"
                    },
                    footerFormat: "",
                    headerShape: "callout",
                    hideDelay: 500,
                    padding: 8,
                    shape: "callout",
                    shared: !1,
                    snap: o ? 25 : 10,
                    headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>',
                    pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
                    backgroundColor: "#ffffff",
                    borderWidth: void 0,
                    shadow: !0,
                    stickOnContact: !1,
                    style: {
                        color: "#333333",
                        cursor: "default",
                        fontSize: "0.8em"
                    },
                    useHTML: !1
                },
                credits: {
                    enabled: !0,
                    href: "https://www.highcharts.com?credits",
                    position: {
                        align: "right",
                        x: -10,
                        verticalAlign: "bottom",
                        y: -5
                    },
                    style: {
                        cursor: "pointer",
                        color: "#999999",
                        fontSize: "0.6em"
                    },
                    text: "Highcharts.com"
                }
            };
            l.chart.styledMode = !1;
            let h = new n(l.time);
            return {
                defaultOptions: l,
                defaultTime: h,
                getOptions: function() {
                    return l;
                },
                setOptions: function(t) {
                    return s(e, "setOptions", {
                        options: t
                    }), a(!0, l, t), (t.time || t.global) && (e.time ? e.time.update(a(l.global, l.time, t.global, t.time)) : e.time = h), l;
                }
            };
        }), i(e, "Core/Color/Color.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { isNumber: i, merge: n, pInt: r } = e;
            class o {
                static parse(t) {
                    return t ? new o(t) : o.None;
                }
                constructor(e){
                    let i, n, r, s;
                    this.rgba = [
                        NaN,
                        NaN,
                        NaN,
                        NaN
                    ], this.input = e;
                    let a = t.Color;
                    if (a && a !== o) return new a(e);
                    if ("object" == typeof e && void 0 !== e.stops) this.stops = e.stops.map((t)=>new o(t[1]));
                    else if ("string" == typeof e) {
                        if (this.input = e = o.names[e.toLowerCase()] || e, "#" === e.charAt(0)) {
                            let t = e.length, i = parseInt(e.substr(1), 16);
                            7 === t ? n = [
                                (16711680 & i) >> 16,
                                (65280 & i) >> 8,
                                255 & i,
                                1
                            ] : 4 === t && (n = [
                                (3840 & i) >> 4 | (3840 & i) >> 8,
                                (240 & i) >> 4 | 240 & i,
                                (15 & i) << 4 | 15 & i,
                                1
                            ]);
                        }
                        if (!n) for(r = o.parsers.length; r-- && !n;)(i = (s = o.parsers[r]).regex.exec(e)) && (n = s.parse(i));
                    }
                    n && (this.rgba = n);
                }
                get(t) {
                    let e = this.input, r = this.rgba;
                    if ("object" == typeof e && void 0 !== this.stops) {
                        let i = n(e);
                        return i.stops = [].slice.call(i.stops), this.stops.forEach((e, n)=>{
                            i.stops[n] = [
                                i.stops[n][0],
                                e.get(t)
                            ];
                        }), i;
                    }
                    return r && i(r[0]) ? "rgb" === t || !t && 1 === r[3] ? "rgb(" + r[0] + "," + r[1] + "," + r[2] + ")" : "a" === t ? `${r[3]}` : "rgba(" + r.join(",") + ")" : e;
                }
                brighten(t) {
                    let e = this.rgba;
                    if (this.stops) this.stops.forEach(function(e) {
                        e.brighten(t);
                    });
                    else if (i(t) && 0 !== t) for(let i = 0; i < 3; i++)e[i] += r(255 * t), e[i] < 0 && (e[i] = 0), e[i] > 255 && (e[i] = 255);
                    return this;
                }
                setOpacity(t) {
                    return this.rgba[3] = t, this;
                }
                tweenTo(t, e) {
                    let n = this.rgba, r = t.rgba;
                    if (!i(n[0]) || !i(r[0])) return t.input || "none";
                    let o = 1 !== r[3] || 1 !== n[3];
                    return (o ? "rgba(" : "rgb(") + Math.round(r[0] + (n[0] - r[0]) * (1 - e)) + "," + Math.round(r[1] + (n[1] - r[1]) * (1 - e)) + "," + Math.round(r[2] + (n[2] - r[2]) * (1 - e)) + (o ? "," + (r[3] + (n[3] - r[3]) * (1 - e)) : "") + ")";
                }
            }
            return o.names = {
                white: "#ffffff",
                black: "#000000"
            }, o.parsers = [
                {
                    regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/,
                    parse: function(t) {
                        return [
                            r(t[1]),
                            r(t[2]),
                            r(t[3]),
                            parseFloat(t[4], 10)
                        ];
                    }
                },
                {
                    regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/,
                    parse: function(t) {
                        return [
                            r(t[1]),
                            r(t[2]),
                            r(t[3]),
                            1
                        ];
                    }
                }
            ], o.None = new o(""), o;
        }), i(e, "Core/Animation/Fx.js", [
            e["Core/Color/Color.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { parse: n } = t, { win: r } = e, { isNumber: o, objectEach: s } = i;
            class a {
                constructor(t, e, i){
                    this.pos = NaN, this.options = e, this.elem = t, this.prop = i;
                }
                dSetter() {
                    let t = this.paths, e = t && t[0], i = t && t[1], n = this.now || 0, r = [];
                    if (1 !== n && e && i) {
                        if (e.length === i.length && n < 1) for(let t = 0; t < i.length; t++){
                            let s = e[t], a = i[t], l = [];
                            for(let t = 0; t < a.length; t++){
                                let e = s[t], i = a[t];
                                o(e) && o(i) && ("A" !== a[0] || 4 !== t && 5 !== t) ? l[t] = e + n * (i - e) : l[t] = i;
                            }
                            r.push(l);
                        }
                        else r = i;
                    } else r = this.toD || [];
                    this.elem.attr("d", r, void 0, !0);
                }
                update() {
                    let t = this.elem, e = this.prop, i = this.now, n = this.options.step;
                    this[e + "Setter"] ? this[e + "Setter"]() : t.attr ? t.element && t.attr(e, i, null, !0) : t.style[e] = i + this.unit, n && n.call(t, i, this);
                }
                run(t, e, i) {
                    let n = this, o = n.options, s = function(t) {
                        return !s.stopped && n.step(t);
                    }, l = r.requestAnimationFrame || function(t) {
                        setTimeout(t, 13);
                    }, h = function() {
                        for(let t = 0; t < a.timers.length; t++)a.timers[t]() || a.timers.splice(t--, 1);
                        a.timers.length && l(h);
                    };
                    t !== e || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date, this.start = t, this.end = e, this.unit = i, this.now = this.start, this.pos = 0, s.elem = this.elem, s.prop = this.prop, s() && 1 === a.timers.push(s) && l(h)) : (delete o.curAnim[this.prop], o.complete && 0 === Object.keys(o.curAnim).length && o.complete.call(this.elem));
                }
                step(t) {
                    let e, i, n = +new Date, r = this.options, o = this.elem, a = r.complete, l = r.duration, h = r.curAnim;
                    return o.attr && !o.element ? e = !1 : t || n >= l + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), h[this.prop] = !0, i = !0, s(h, function(t) {
                        !0 !== t && (i = !1);
                    }), i && a && a.call(o), e = !1) : (this.pos = r.easing((n - this.startTime) / l), this.now = this.start + (this.end - this.start) * this.pos, this.update(), e = !0), e;
                }
                initPath(t, e, i) {
                    let n, r, s, a, l = t.startX, h = t.endX, c = i.slice(), d = t.isArea, u = d ? 2 : 1, p = e && i.length > e.length && i.hasStackedCliffs, f = e && e.slice();
                    if (!f || p) return [
                        c,
                        c
                    ];
                    function g(t, e) {
                        for(; t.length < r;){
                            let i = t[0], n = e[r - t.length];
                            if (n && "M" === i[0] && ("C" === n[0] ? t[0] = [
                                "C",
                                i[1],
                                i[2],
                                i[1],
                                i[2],
                                i[1],
                                i[2]
                            ] : t[0] = [
                                "L",
                                i[1],
                                i[2]
                            ]), t.unshift(i), d) {
                                let e = t.pop();
                                t.push(t[t.length - 1], e);
                            }
                        }
                    }
                    function m(t) {
                        for(; t.length < r;){
                            let e = t[Math.floor(t.length / u) - 1].slice();
                            if ("C" === e[0] && (e[1] = e[5], e[2] = e[6]), d) {
                                let i = t[Math.floor(t.length / u)].slice();
                                t.splice(t.length / 2, 0, e, i);
                            } else t.push(e);
                        }
                    }
                    if (l && h && h.length) {
                        for(s = 0; s < l.length; s++){
                            if (l[s] === h[0]) {
                                n = s;
                                break;
                            }
                            if (l[0] === h[h.length - l.length + s]) {
                                n = s, a = !0;
                                break;
                            }
                            if (l[l.length - 1] === h[h.length - l.length + s]) {
                                n = l.length - s;
                                break;
                            }
                        }
                        void 0 === n && (f = []);
                    }
                    return f.length && o(n) && (r = c.length + n * u, a ? (g(f, c), m(c)) : (g(c, f), m(f))), [
                        f,
                        c
                    ];
                }
                fillSetter() {
                    a.prototype.strokeSetter.apply(this, arguments);
                }
                strokeSetter() {
                    this.elem.attr(this.prop, n(this.start).tweenTo(n(this.end), this.pos), void 0, !0);
                }
            }
            return a.timers = [], a;
        }), i(e, "Core/Animation/AnimationUtilities.js", [
            e["Core/Animation/Fx.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { defined: i, getStyle: n, isArray: r, isNumber: o, isObject: s, merge: a, objectEach: l, pick: h } = e;
            function c(t) {
                return s(t) ? a({
                    duration: 500,
                    defer: 0
                }, t) : {
                    duration: t ? 500 : 0,
                    defer: 0
                };
            }
            function d(e, i) {
                let n = t.timers.length;
                for(; n--;)t.timers[n].elem !== e || i && i !== t.timers[n].prop || (t.timers[n].stopped = !0);
            }
            return {
                animate: function(e, i, h) {
                    let c, u, p, f, g = "";
                    s(h) || (f = arguments, h = {
                        duration: f[2],
                        easing: f[3],
                        complete: f[4]
                    }), o(h.duration) || (h.duration = 400), h.easing = "function" == typeof h.easing ? h.easing : Math[h.easing] || Math.easeInOutSine, h.curAnim = a(i), l(i, function(o, s) {
                        d(e, s), p = new t(e, h, s), u = void 0, "d" === s && r(i.d) ? (p.paths = p.initPath(e, e.pathArray, i.d), p.toD = i.d, c = 0, u = 1) : e.attr ? c = e.attr(s) : (c = parseFloat(n(e, s)) || 0, "opacity" !== s && (g = "px")), u || (u = o), "string" == typeof u && u.match("px") && (u = u.replace(/px/g, "")), p.run(c, u, g);
                    });
                },
                animObject: c,
                getDeferredAnimation: function(t, e, n) {
                    let r = c(e), o = n ? [
                        n
                    ] : t.series, a = 0, l = 0;
                    return o.forEach((t)=>{
                        let n = c(t.options.animation);
                        a = s(e) && i(e.defer) ? r.defer : Math.max(a, n.duration + n.defer), l = Math.min(r.duration, n.duration);
                    }), t.renderer.forExport && (a = 0), {
                        defer: Math.max(0, a - l),
                        duration: Math.min(a, l)
                    };
                },
                setAnimation: function(t, e) {
                    e.renderer.globalAnimation = h(t, e.options.chart.animation, !0);
                },
                stop: d
            };
        }), i(e, "Core/Renderer/HTML/AST.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { SVG_NS: i, win: n } = t, { attr: r, createElement: o, css: s, error: a, isFunction: l, isString: h, objectEach: c, splat: d } = e, { trustedTypes: u } = n, p = u && l(u.createPolicy) && u.createPolicy("highcharts", {
                createHTML: (t)=>t
            }), f = p ? p.createHTML("") : "", g = function() {
                try {
                    return !!(new DOMParser).parseFromString(f, "text/html");
                } catch (t) {
                    return !1;
                }
            }();
            class m {
                static filterUserAttributes(t) {
                    return c(t, (e, i)=>{
                        let n = !0;
                        -1 === m.allowedAttributes.indexOf(i) && (n = !1), -1 !== [
                            "background",
                            "dynsrc",
                            "href",
                            "lowsrc",
                            "src"
                        ].indexOf(i) && (n = h(e) && m.allowedReferences.some((t)=>0 === e.indexOf(t))), n || (a(33, !1, void 0, {
                            "Invalid attribute in config": `${i}`
                        }), delete t[i]), h(e) && t[i] && (t[i] = e.replace(/</g, "&lt;"));
                    }), t;
                }
                static parseStyle(t) {
                    return t.split(";").reduce((t, e)=>{
                        let i = e.split(":").map((t)=>t.trim()), n = i.shift();
                        return n && i.length && (t[n.replace(/-([a-z])/g, (t)=>t[1].toUpperCase())] = i.join(":")), t;
                    }, {});
                }
                static setElementHTML(t, e) {
                    t.innerHTML = m.emptyHTML, e && new m(e).addToDOM(t);
                }
                constructor(t){
                    this.nodes = "string" == typeof t ? this.parseMarkup(t) : t;
                }
                addToDOM(e) {
                    return function e(n, o) {
                        let l;
                        return d(n).forEach(function(n) {
                            let h, d = n.tagName, u = n.textContent ? t.doc.createTextNode(n.textContent) : void 0, p = m.bypassHTMLFiltering;
                            if (d) {
                                if ("#text" === d) h = u;
                                else if (-1 !== m.allowedTags.indexOf(d) || p) {
                                    let a = "svg" === d ? i : o.namespaceURI || i, l = t.doc.createElementNS(a, d), f = n.attributes || {};
                                    c(n, function(t, _e1) {
                                        "tagName" !== _e1 && "attributes" !== _e1 && "children" !== _e1 && "style" !== _e1 && "textContent" !== _e1 && (f[_e1] = t);
                                    }), r(l, p ? f : m.filterUserAttributes(f)), n.style && s(l, n.style), u && l.appendChild(u), e(n.children || [], l), h = l;
                                } else a(33, !1, void 0, {
                                    "Invalid tagName in config": d
                                });
                            }
                            h && o.appendChild(h), l = h;
                        }), l;
                    }(this.nodes, e);
                }
                parseMarkup(t) {
                    let e, i = [];
                    if (t = t.trim().replace(/ style=(["'])/g, " data-style=$1"), g) e = (new DOMParser).parseFromString(p ? p.createHTML(t) : t, "text/html");
                    else {
                        let i = o("div");
                        i.innerHTML = t, e = {
                            body: i
                        };
                    }
                    let n = (t, e)=>{
                        let i = t.nodeName.toLowerCase(), r = {
                            tagName: i
                        };
                        "#text" === i && (r.textContent = t.textContent || "");
                        let o = t.attributes;
                        if (o) {
                            let t = {};
                            [].forEach.call(o, (e)=>{
                                "data-style" === e.name ? r.style = m.parseStyle(e.value) : t[e.name] = e.value;
                            }), r.attributes = t;
                        }
                        if (t.childNodes.length) {
                            let e = [];
                            [].forEach.call(t.childNodes, (t)=>{
                                n(t, e);
                            }), e.length && (r.children = e);
                        }
                        e.push(r);
                    };
                    return [].forEach.call(e.body.childNodes, (t)=>n(t, i)), i;
                }
            }
            return m.allowedAttributes = [
                "alt",
                "aria-controls",
                "aria-describedby",
                "aria-expanded",
                "aria-haspopup",
                "aria-hidden",
                "aria-label",
                "aria-labelledby",
                "aria-live",
                "aria-pressed",
                "aria-readonly",
                "aria-roledescription",
                "aria-selected",
                "class",
                "clip-path",
                "color",
                "colspan",
                "cx",
                "cy",
                "d",
                "dx",
                "dy",
                "disabled",
                "fill",
                "filterUnits",
                "flood-color",
                "flood-opacity",
                "height",
                "href",
                "id",
                "in",
                "in2",
                "markerHeight",
                "markerWidth",
                "offset",
                "opacity",
                "operator",
                "orient",
                "padding",
                "paddingLeft",
                "paddingRight",
                "patternUnits",
                "r",
                "radius",
                "refX",
                "refY",
                "role",
                "scope",
                "slope",
                "src",
                "startOffset",
                "stdDeviation",
                "stroke",
                "stroke-linecap",
                "stroke-width",
                "style",
                "tableValues",
                "result",
                "rowspan",
                "summary",
                "target",
                "tabindex",
                "text-align",
                "text-anchor",
                "textAnchor",
                "textLength",
                "title",
                "type",
                "valign",
                "width",
                "x",
                "x1",
                "x2",
                "xlink:href",
                "y",
                "y1",
                "y2",
                "zIndex"
            ], m.allowedReferences = [
                "https://",
                "http://",
                "mailto:",
                "/",
                "../",
                "./",
                "#"
            ], m.allowedTags = [
                "a",
                "abbr",
                "b",
                "br",
                "button",
                "caption",
                "circle",
                "clipPath",
                "code",
                "dd",
                "defs",
                "div",
                "dl",
                "dt",
                "em",
                "feComponentTransfer",
                "feComposite",
                "feDropShadow",
                "feFlood",
                "feFuncA",
                "feFuncB",
                "feFuncG",
                "feFuncR",
                "feGaussianBlur",
                "feMorphology",
                "feOffset",
                "feMerge",
                "feMergeNode",
                "filter",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "hr",
                "i",
                "img",
                "li",
                "linearGradient",
                "marker",
                "ol",
                "p",
                "path",
                "pattern",
                "pre",
                "rect",
                "small",
                "span",
                "stop",
                "strong",
                "style",
                "sub",
                "sup",
                "svg",
                "table",
                "text",
                "textPath",
                "thead",
                "title",
                "tbody",
                "tspan",
                "td",
                "th",
                "tr",
                "u",
                "ul",
                "#text"
            ], m.emptyHTML = f, m.bypassHTMLFiltering = !1, m;
        }), i(e, "Core/Templating.js", [
            e["Core/Defaults.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { defaultOptions: i, defaultTime: n } = t, { extend: r, getNestedProperty: o, isArray: s, isNumber: a, isObject: l, pick: h, pInt: c } = e, d = {
                add: (t, e)=>t + e,
                divide: (t, e)=>0 !== e ? t / e : "",
                eq: (t, e)=>t == e,
                each: function(t) {
                    let e = arguments[arguments.length - 1];
                    return !!s(t) && t.map((i, n)=>u(e.body, r(l(i) ? i : {
                            "@this": i
                        }, {
                            "@index": n,
                            "@first": 0 === n,
                            "@last": n === t.length - 1
                        }))).join("");
                },
                ge: (t, e)=>t >= e,
                gt: (t, e)=>t > e,
                if: (t)=>!!t,
                le: (t, e)=>t <= e,
                lt: (t, e)=>t < e,
                multiply: (t, e)=>t * e,
                ne: (t, e)=>t != e,
                subtract: (t, e)=>t - e,
                unless: (t)=>!t
            };
            function u(t = "", e, r) {
                let s, a, l, c = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, f = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, g = [], m = /f$/, b = /\.(\d)/, y = i.lang, x = r && r.time || n, v = r && r.numberFormatter || p, w = (t = "")=>{
                    let i;
                    return "true" === t || "false" !== t && ((i = Number(t)).toString() === t ? i : o(t, e));
                }, C = 0;
                for(; null !== (s = c.exec(t));){
                    let i = f.exec(s[1]);
                    i && (s = i, l = !0), a && a.isBlock || (a = {
                        ctx: e,
                        expression: s[1],
                        find: s[0],
                        isBlock: "#" === s[1].charAt(0),
                        start: s.index,
                        startInner: s.index + s[0].length,
                        length: s[0].length
                    });
                    let n = s[1].split(" ")[0].replace("#", "");
                    d[n] && (a.isBlock && n === a.fn && C++, a.fn || (a.fn = n));
                    let r = "else" === s[1];
                    if (a.isBlock && a.fn && (s[1] === `/${a.fn}` || r)) {
                        if (C) !r && C--;
                        else {
                            let e = a.startInner, i = t.substr(e, s.index - e);
                            void 0 === a.body ? (a.body = i, a.startInner = s.index + s[0].length) : a.elseBody = i, a.find += i + s[0], r || (g.push(a), a = void 0);
                        }
                    } else a.isBlock || g.push(a);
                    if (i && !a?.isBlock) break;
                }
                return g.forEach((i)=>{
                    let n, o, { body: s, elseBody: a, expression: l, fn: c } = i;
                    if (c) {
                        let t = [
                            i
                        ], h = l.split(" ");
                        for(o = d[c].length; o--;)t.unshift(w(h[o + 1]));
                        n = d[c].apply(e, t), i.isBlock && "boolean" == typeof n && (n = u(n ? s : a, e, r));
                    } else {
                        let t = l.split(":");
                        if (n = w(t.shift() || ""), t.length && "number" == typeof n) {
                            let e = t.join(":");
                            if (m.test(e)) {
                                let t = parseInt((e.match(b) || [
                                    "",
                                    "-1"
                                ])[1], 10);
                                null !== n && (n = v(n, t, y.decimalPoint, e.indexOf(",") > -1 ? y.thousandsSep : ""));
                            } else n = x.dateFormat(e, n);
                        }
                    }
                    t = t.replace(i.find, h(n, ""));
                }), l ? u(t, e, r) : t;
            }
            function p(t, e, n, r) {
                let o, s;
                t = +t || 0, e = +e;
                let l = i.lang, d = (t.toString().split(".")[1] || "").split("e")[0].length, u = t.toString().split("e"), p = e;
                -1 === e ? e = Math.min(d, 20) : a(e) ? e && u[1] && u[1] < 0 && ((s = e + +u[1]) >= 0 ? (u[0] = (+u[0]).toExponential(s).split("e")[0], e = s) : (u[0] = u[0].split(".")[0] || 0, t = e < 20 ? (u[0] * Math.pow(10, u[1])).toFixed(e) : 0, u[1] = 0)) : e = 2;
                let f = (Math.abs(u[1] ? u[0] : t) + Math.pow(10, -Math.max(e, d) - 1)).toFixed(e), g = String(c(f)), m = g.length > 3 ? g.length % 3 : 0;
                return n = h(n, l.decimalPoint), r = h(r, l.thousandsSep), o = (t < 0 ? "-" : "") + (m ? g.substr(0, m) + r : ""), 0 > +u[1] && !p ? o = "0" : o += g.substr(m).replace(/(\d{3})(?=\d)/g, "$1" + r), e ? o += n + f.slice(-e) : 0 == +o && (o = "0"), u[1] && 0 != +o && (o += "e" + u[1]), o;
            }
            return {
                dateFormat: function(t, e, i) {
                    return n.dateFormat(t, e, i);
                },
                format: u,
                helpers: d,
                numberFormat: p
            };
        }), i(e, "Core/Renderer/RendererRegistry.js", [
            e["Core/Globals.js"]
        ], function(t) {
            var e, i;
            let n;
            return (i = e || (e = {})).rendererTypes = {}, i.getRendererType = function(t = n) {
                return i.rendererTypes[t] || i.rendererTypes[n];
            }, i.registerRendererType = function(e, r, o) {
                i.rendererTypes[e] = r, (!n || o) && (n = e, t.Renderer = r);
            }, e;
        }), i(e, "Core/Renderer/RendererUtilities.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            var e;
            let { clamp: i, pick: n, pushUnique: r, stableSort: o } = t;
            return (e || (e = {})).distribute = function t(e, s, a) {
                let l, h, c, d, u, p, f = e, g = f.reducedLen || s, m = (t, e)=>t.target - e.target, b = [], y = e.length, x = [], v = b.push, w = !0, C = 0;
                for(l = y; l--;)C += e[l].size;
                if (C > g) {
                    for(o(e, (t, e)=>(e.rank || 0) - (t.rank || 0)), c = (p = e[0].rank === e[e.length - 1].rank) ? y / 2 : -1, h = p ? c : y - 1; c && C > g;)d = e[l = Math.floor(h)], r(x, l) && (C -= d.size), h += c, p && h >= e.length && (c /= 2, h = c);
                    x.sort((t, e)=>e - t).forEach((t)=>v.apply(b, e.splice(t, 1)));
                }
                for(o(e, m), e = e.map((t)=>({
                        size: t.size,
                        targets: [
                            t.target
                        ],
                        align: n(t.align, .5)
                    })); w;){
                    for(l = e.length; l--;)d = e[l], u = (Math.min.apply(0, d.targets) + Math.max.apply(0, d.targets)) / 2, d.pos = i(u - d.size * d.align, 0, s - d.size);
                    for(l = e.length, w = !1; l--;)l > 0 && e[l - 1].pos + e[l - 1].size > e[l].pos && (e[l - 1].size += e[l].size, e[l - 1].targets = e[l - 1].targets.concat(e[l].targets), e[l - 1].align = .5, e[l - 1].pos + e[l - 1].size > s && (e[l - 1].pos = s - e[l - 1].size), e.splice(l, 1), w = !0);
                }
                return v.apply(f, b), l = 0, e.some((e)=>{
                    let i = 0;
                    return (e.targets || []).some(()=>(f[l].pos = e.pos + i, void 0 !== a && Math.abs(f[l].pos - f[l].target) > a ? (f.slice(0, l + 1).forEach((t)=>delete t.pos), f.reducedLen = (f.reducedLen || s) - .1 * s, f.reducedLen > .1 * s && t(f, s, a), !0) : (i += f[l].size, l++, !1)));
                }), o(f, m), f;
            }, e;
        }), i(e, "Core/Renderer/SVG/SVGElement.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Color/Color.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { animate: r, animObject: o, stop: s } = t, { deg2rad: a, doc: l, svg: h, SVG_NS: c, win: d } = i, { addEvent: u, attr: p, createElement: f, crisp: g, css: m, defined: b, erase: y, extend: x, fireEvent: v, isArray: w, isFunction: C, isObject: S, isString: k, merge: A, objectEach: E, pick: M, pInt: T, pushUnique: P, replaceNested: R, syncTimeout: L, uniqueKey: O } = n;
            class D {
                _defaultGetter(t) {
                    let e = M(this[t + "Value"], this[t], this.element ? this.element.getAttribute(t) : null, 0);
                    return /^-?[\d\.]+$/.test(e) && (e = parseFloat(e)), e;
                }
                _defaultSetter(t, e, i) {
                    i.setAttribute(e, t);
                }
                add(t) {
                    let e, i = this.renderer, n = this.element;
                    return t && (this.parentGroup = t), void 0 !== this.textStr && "text" === this.element.nodeName && i.buildText(this), this.added = !0, (!t || t.handleZ || this.zIndex) && (e = this.zIndexSetter()), e || (t ? t.element : i.box).appendChild(n), this.onAdd && this.onAdd(), this;
                }
                addClass(t, e) {
                    let i = e ? "" : this.attr("class") || "";
                    return (t = (t || "").split(/ /g).reduce(function(t, e) {
                        return -1 === i.indexOf(e) && t.push(e), t;
                    }, i ? [
                        i
                    ] : []).join(" ")) !== i && this.attr("class", t), this;
                }
                afterSetters() {
                    this.doTransform && (this.updateTransform(), this.doTransform = !1);
                }
                align(t, e, i, n = !0) {
                    let r, o, s, a, l = {}, h = this.renderer, c = h.alignedObjects, d = !!t;
                    t ? (this.alignOptions = t, this.alignByTranslate = e, this.alignTo = i) : (t = this.alignOptions || {}, e = this.alignByTranslate, i = this.alignTo);
                    let u = !i || k(i) ? i || "renderer" : void 0;
                    u && (d && P(c, this), i = void 0);
                    let p = M(i, h[u], h), f = t.align, g = t.verticalAlign;
                    return r = (p.x || 0) + (t.x || 0), o = (p.y || 0) + (t.y || 0), "right" === f ? s = 1 : "center" === f && (s = 2), s && (r += ((p.width || 0) - (t.width || 0)) / s), l[e ? "translateX" : "x"] = Math.round(r), "bottom" === g ? a = 1 : "middle" === g && (a = 2), a && (o += ((p.height || 0) - (t.height || 0)) / a), l[e ? "translateY" : "y"] = Math.round(o), n && (this[this.placed ? "animate" : "attr"](l), this.placed = !0), this.alignAttr = l, this;
                }
                alignSetter(t) {
                    let e = {
                        left: "start",
                        center: "middle",
                        right: "end"
                    };
                    e[t] && (this.alignValue = t, this.element.setAttribute("text-anchor", e[t]));
                }
                animate(t, e, i) {
                    let n = o(M(e, this.renderer.globalAnimation, !0)), s = n.defer;
                    return l.hidden && (n.duration = 0), 0 !== n.duration ? (i && (n.complete = i), L(()=>{
                        this.element && r(this, t, n);
                    }, s)) : (this.attr(t, void 0, i || n.complete), E(t, function(t, e) {
                        n.step && n.step.call(this, t, {
                            prop: e,
                            pos: 1,
                            elem: this
                        });
                    }, this)), this;
                }
                applyTextOutline(t) {
                    let e = this.element;
                    -1 !== t.indexOf("contrast") && (t = t.replace(/contrast/g, this.renderer.getContrast(e.style.fill)));
                    let n = t.split(" "), r = n[n.length - 1], o = n[0];
                    if (o && "none" !== o && i.svg) {
                        this.fakeTS = !0, o = o.replace(/(^[\d\.]+)(.*?)$/g, function(t, e, i) {
                            return 2 * Number(e) + i;
                        }), this.removeTextOutline();
                        let t = l.createElementNS(c, "tspan");
                        p(t, {
                            class: "highcharts-text-outline",
                            fill: r,
                            stroke: r,
                            "stroke-width": o,
                            "stroke-linejoin": "round"
                        });
                        let i = e.querySelector("textPath") || e;
                        [].forEach.call(i.childNodes, (e)=>{
                            let i = e.cloneNode(!0);
                            i.removeAttribute && [
                                "fill",
                                "stroke",
                                "stroke-width",
                                "stroke"
                            ].forEach((t)=>i.removeAttribute(t)), t.appendChild(i);
                        });
                        let n = 0;
                        [].forEach.call(i.querySelectorAll("text tspan"), (t)=>{
                            n += Number(t.getAttribute("dy"));
                        });
                        let s = l.createElementNS(c, "tspan");
                        s.textContent = "\u200B", p(s, {
                            x: Number(e.getAttribute("x")),
                            dy: -n
                        }), t.appendChild(s), i.insertBefore(t, i.firstChild);
                    }
                }
                attr(t, e, i, n) {
                    let r, o, a, { element: l } = this, h = D.symbolCustomAttribs, c = this;
                    return "string" == typeof t && void 0 !== e && (r = t, (t = {})[r] = e), "string" == typeof t ? c = (this[t + "Getter"] || this._defaultGetter).call(this, t, l) : (E(t, function(e, i) {
                        a = !1, n || s(this, i), this.symbolName && -1 !== h.indexOf(i) && (o || (this.symbolAttr(t), o = !0), a = !0), this.rotation && ("x" === i || "y" === i) && (this.doTransform = !0), a || (this[i + "Setter"] || this._defaultSetter).call(this, e, i, l);
                    }, this), this.afterSetters()), i && i.call(this), c;
                }
                clip(t) {
                    if (t && !t.clipPath) {
                        let e = O() + "-", i = this.renderer.createElement("clipPath").attr({
                            id: e
                        }).add(this.renderer.defs);
                        x(t, {
                            clipPath: i,
                            id: e,
                            count: 0
                        }), t.add(i);
                    }
                    return this.attr("clip-path", t ? `url(${this.renderer.url}#${t.id})` : "none");
                }
                crisp(t, e) {
                    e = Math.round(e || t.strokeWidth || 0);
                    let i = t.x || this.x || 0, n = t.y || this.y || 0, r = (t.width || this.width || 0) + i, o = (t.height || this.height || 0) + n, s = g(i, e), a = g(n, e);
                    return x(t, {
                        x: s,
                        y: a,
                        width: g(r, e) - s,
                        height: g(o, e) - a
                    }), b(t.strokeWidth) && (t.strokeWidth = e), t;
                }
                complexColor(t, i, n) {
                    let r, o, s, a, l, h, c, d, u, p, f, g = this.renderer, m = [];
                    v(this.renderer, "complexColor", {
                        args: arguments
                    }, function() {
                        if (t.radialGradient ? o = "radialGradient" : t.linearGradient && (o = "linearGradient"), o) {
                            if (s = t[o], l = g.gradients, h = t.stops, u = n.radialReference, w(s) && (t[o] = s = {
                                x1: s[0],
                                y1: s[1],
                                x2: s[2],
                                y2: s[3],
                                gradientUnits: "userSpaceOnUse"
                            }), "radialGradient" === o && u && !b(s.gradientUnits) && (a = s, s = A(s, g.getRadialAttr(u, a), {
                                gradientUnits: "userSpaceOnUse"
                            })), E(s, function(t, e) {
                                "id" !== e && m.push(e, t);
                            }), E(h, function(t) {
                                m.push(t);
                            }), l[m = m.join(",")]) p = l[m].attr("id");
                            else {
                                s.id = p = O();
                                let t = l[m] = g.createElement(o).attr(s).add(g.defs);
                                t.radAttr = a, t.stops = [], h.forEach(function(i) {
                                    0 === i[1].indexOf("rgba") ? (c = (r = e.parse(i[1])).get("rgb"), d = r.get("a")) : (c = i[1], d = 1);
                                    let n = g.createElement("stop").attr({
                                        offset: i[0],
                                        "stop-color": c,
                                        "stop-opacity": d
                                    }).add(t);
                                    t.stops.push(n);
                                });
                            }
                            f = "url(" + g.url + "#" + p + ")", n.setAttribute(i, f), n.gradient = m, t.toString = function() {
                                return f;
                            };
                        }
                    });
                }
                css(t) {
                    let e, i = this.styles, n = {}, r = this.element, o = !i;
                    if (i && E(t, function(t, e) {
                        i && i[e] !== t && (n[e] = t, o = !0);
                    }), o) {
                        i && (t = x(i, n)), null === t.width || "auto" === t.width ? delete this.textWidth : "text" === r.nodeName.toLowerCase() && t.width && (e = this.textWidth = T(t.width)), x(this.styles, t), e && !h && this.renderer.forExport && delete t.width;
                        let o = A(t);
                        r.namespaceURI === this.SVG_NS && ([
                            "textOutline",
                            "textOverflow",
                            "width"
                        ].forEach((t)=>o && delete o[t]), o.color && (o.fill = o.color)), m(r, o);
                    }
                    return this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), t.textOutline && this.applyTextOutline(t.textOutline)), this;
                }
                dashstyleSetter(t) {
                    let e, i = this["stroke-width"];
                    if ("inherit" === i && (i = 1), t = t && t.toLowerCase()) {
                        let n = t.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
                        for(e = n.length; e--;)n[e] = "" + T(n[e]) * M(i, NaN);
                        t = n.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", t);
                    }
                }
                destroy() {
                    let t, e, i = this, n = i.element || {}, r = i.renderer, o = n.ownerSVGElement, a = "SPAN" === n.nodeName && i.parentGroup || void 0;
                    if (n.onclick = n.onmouseout = n.onmouseover = n.onmousemove = n.point = null, s(i), i.clipPath && o) {
                        let t = i.clipPath;
                        [].forEach.call(o.querySelectorAll("[clip-path],[CLIP-PATH]"), function(e) {
                            e.getAttribute("clip-path").indexOf(t.element.id) > -1 && e.removeAttribute("clip-path");
                        }), i.clipPath = t.destroy();
                    }
                    if (i.connector = i.connector?.destroy(), i.stops) {
                        for(e = 0; e < i.stops.length; e++)i.stops[e].destroy();
                        i.stops.length = 0, i.stops = void 0;
                    }
                    for(i.safeRemoveChild(n); a && a.div && 0 === a.div.childNodes.length;)t = a.parentGroup, i.safeRemoveChild(a.div), delete a.div, a = t;
                    i.alignOptions && y(r.alignedObjects, i), E(i, function(t, e) {
                        i[e] && i[e].parentGroup === i && i[e].destroy && i[e].destroy(), delete i[e];
                    });
                }
                dSetter(t, e, i) {
                    w(t) && ("string" == typeof t[0] && (t = this.renderer.pathToSegments(t)), this.pathArray = t, t = t.reduce((t, e, i)=>e && e.join ? (i ? t + " " : "") + e.join(" ") : (e || "").toString(), "")), /(NaN| {2}|^$)/.test(t) && (t = "M 0 0"), this[e] !== t && (i.setAttribute(e, t), this[e] = t);
                }
                fillSetter(t, e, i) {
                    "string" == typeof t ? i.setAttribute(e, t) : t && this.complexColor(t, e, i);
                }
                hrefSetter(t, e, i) {
                    i.setAttributeNS("http://www.w3.org/1999/xlink", e, t);
                }
                getBBox(t, e) {
                    let i, n, r, o, { alignValue: s, element: a, renderer: l, styles: h, textStr: c } = this, { cache: d, cacheKeys: u } = l, p = a.namespaceURI === this.SVG_NS, f = M(e, this.rotation, 0), g = l.styledMode ? a && D.prototype.getStyle.call(a, "font-size") : h.fontSize;
                    if (b(c) && (-1 === (o = c.toString()).indexOf("<") && (o = o.replace(/\d/g, "0")), o += [
                        "",
                        l.rootFontSize,
                        g,
                        f,
                        this.textWidth,
                        s,
                        h.textOverflow,
                        h.fontWeight
                    ].join(",")), o && !t && (i = d[o]), !i || i.polygon) {
                        if (p || l.forExport) {
                            try {
                                r = this.fakeTS && function(t) {
                                    let e = a.querySelector(".highcharts-text-outline");
                                    e && m(e, {
                                        display: t
                                    });
                                }, C(r) && r("none"), i = a.getBBox ? x({}, a.getBBox()) : {
                                    width: a.offsetWidth,
                                    height: a.offsetHeight,
                                    x: 0,
                                    y: 0
                                }, C(r) && r("");
                            } catch (t) {}
                            (!i || i.width < 0) && (i = {
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0
                            });
                        } else i = this.htmlGetBBox();
                        n = i.height, p && (i.height = n = ({
                            "11px,17": 14,
                            "13px,20": 16
                        })[`${g || ""},${Math.round(n)}`] || n), f && (i = this.getRotatedBox(i, f));
                        let e = {
                            bBox: i
                        };
                        v(this, "afterGetBBox", e), i = e.bBox;
                    }
                    if (o && ("" === c || i.height > 0)) {
                        for(; u.length > 250;)delete d[u.shift()];
                        d[o] || u.push(o), d[o] = i;
                    }
                    return i;
                }
                getRotatedBox(t, e) {
                    let { x: i, y: n, width: r, height: o } = t, { alignValue: s, translateY: l, rotationOriginX: h = 0, rotationOriginY: c = 0 } = this, d = {
                        right: 1,
                        center: .5
                    }[s || 0] || 0, u = Number(this.element.getAttribute("y") || 0) - (l ? 0 : n), p = e * a, f = (e - 90) * a, g = Math.cos(p), m = Math.sin(p), b = r * g, y = r * m, x = Math.cos(f), v = Math.sin(f), [[w, C], [S, k]] = [
                        h,
                        c
                    ].map((t)=>[
                            t - t * g,
                            t * m
                        ]), A = i + d * (r - b) + w + k + u * x, E = A + b, M = E - o * x, T = M - b, P = n + u - d * y - C + S + u * v, R = P + y, L = R - o * v, O = L - y, D = Math.min(A, E, M, T), j = Math.min(P, R, L, O);
                    return {
                        x: D,
                        y: j,
                        width: Math.max(A, E, M, T) - D,
                        height: Math.max(P, R, L, O) - j,
                        polygon: [
                            [
                                A,
                                P
                            ],
                            [
                                E,
                                R
                            ],
                            [
                                M,
                                L
                            ],
                            [
                                T,
                                O
                            ]
                        ]
                    };
                }
                getStyle(t) {
                    return d.getComputedStyle(this.element || this, "").getPropertyValue(t);
                }
                hasClass(t) {
                    return -1 !== ("" + this.attr("class")).split(" ").indexOf(t);
                }
                hide() {
                    return this.attr({
                        visibility: "hidden"
                    });
                }
                htmlGetBBox() {
                    return {
                        height: 0,
                        width: 0,
                        x: 0,
                        y: 0
                    };
                }
                constructor(t, e){
                    this.onEvents = {}, this.opacity = 1, this.SVG_NS = c, this.element = "span" === e || "body" === e ? f(e) : l.createElementNS(this.SVG_NS, e), this.renderer = t, this.styles = {}, v(this, "afterInit");
                }
                on(t, e) {
                    let { onEvents: i } = this;
                    return i[t] && i[t](), i[t] = u(this.element, t, e), this;
                }
                opacitySetter(t, e, i) {
                    let n = Number(Number(t).toFixed(3));
                    this.opacity = n, i.setAttribute(e, n);
                }
                reAlign() {
                    this.alignOptions?.width && "left" !== this.alignOptions.align && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
                }
                removeClass(t) {
                    return this.attr("class", ("" + this.attr("class")).replace(k(t) ? RegExp(`(^| )${t}( |$)`) : t, " ").replace(/ +/g, " ").trim());
                }
                removeTextOutline() {
                    let t = this.element.querySelector("tspan.highcharts-text-outline");
                    t && this.safeRemoveChild(t);
                }
                safeRemoveChild(t) {
                    let e = t.parentNode;
                    e && e.removeChild(t);
                }
                setRadialReference(t) {
                    let e = this.element.gradient && this.renderer.gradients[this.element.gradient];
                    return this.element.radialReference = t, e && e.radAttr && e.animate(this.renderer.getRadialAttr(t, e.radAttr)), this;
                }
                shadow(t) {
                    let { renderer: e } = this, i = A(90 === this.parentGroup?.rotation ? {
                        offsetX: -1,
                        offsetY: -1
                    } : {}, S(t) ? t : {}), n = e.shadowDefinition(i);
                    return this.attr({
                        filter: t ? `url(${e.url}#${n})` : "none"
                    });
                }
                show(t = !0) {
                    return this.attr({
                        visibility: t ? "inherit" : "visible"
                    });
                }
                "stroke-widthSetter"(t, e, i) {
                    this[e] = t, i.setAttribute(e, t);
                }
                strokeWidth() {
                    if (!this.renderer.styledMode) return this["stroke-width"] || 0;
                    let t, e = this.getStyle("stroke-width"), i = 0;
                    return /px$/.test(e) ? i = T(e) : "" !== e && (p(t = l.createElementNS(c, "rect"), {
                        width: e,
                        "stroke-width": 0
                    }), this.element.parentNode.appendChild(t), i = t.getBBox().width, t.parentNode.removeChild(t)), i;
                }
                symbolAttr(t) {
                    let e = this;
                    D.symbolCustomAttribs.forEach(function(i) {
                        e[i] = M(t[i], e[i]);
                    }), e.attr({
                        d: e.renderer.symbols[e.symbolName](e.x, e.y, e.width, e.height, e)
                    });
                }
                textSetter(t) {
                    t !== this.textStr && (delete this.textPxLength, this.textStr = t, this.added && this.renderer.buildText(this), this.reAlign());
                }
                titleSetter(t) {
                    let e = this.element, i = e.getElementsByTagName("title")[0] || l.createElementNS(this.SVG_NS, "title");
                    e.insertBefore ? e.insertBefore(i, e.firstChild) : e.appendChild(i), i.textContent = R(M(t, ""), [
                        /<[^>]*>/g,
                        ""
                    ]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
                }
                toFront() {
                    let t = this.element;
                    return t.parentNode.appendChild(t), this;
                }
                translate(t, e) {
                    return this.attr({
                        translateX: t,
                        translateY: e
                    });
                }
                updateTransform(t = "transform") {
                    let { element: e, matrix: i, rotation: n = 0, rotationOriginX: r, rotationOriginY: o, scaleX: s, scaleY: a, translateX: l = 0, translateY: h = 0 } = this, c = [
                        "translate(" + l + "," + h + ")"
                    ];
                    b(i) && c.push("matrix(" + i.join(",") + ")"), n && (c.push("rotate(" + n + " " + M(r, e.getAttribute("x"), 0) + " " + M(o, e.getAttribute("y") || 0) + ")"), "SPAN" === this.text?.element.tagName && this.text.attr({
                        rotation: n,
                        rotationOriginX: (r || 0) - this.padding,
                        rotationOriginY: (o || 0) - this.padding
                    })), (b(s) || b(a)) && c.push("scale(" + M(s, 1) + " " + M(a, 1) + ")"), c.length && !(this.text || this).textPath && e.setAttribute(t, c.join(" "));
                }
                visibilitySetter(t, e, i) {
                    "inherit" === t ? i.removeAttribute(e) : this[e] !== t && i.setAttribute(e, t), this[e] = t;
                }
                xGetter(t) {
                    return "circle" === this.element.nodeName && ("x" === t ? t = "cx" : "y" === t && (t = "cy")), this._defaultGetter(t);
                }
                zIndexSetter(t, e) {
                    let i, n, r, o, s, a = this.renderer, l = this.parentGroup, h = (l || a).element || a.box, c = this.element, d = h === a.box, u = !1, p = this.added;
                    if (b(t) ? (c.setAttribute("data-z-index", t), t = +t, this[e] === t && (p = !1)) : b(this[e]) && c.removeAttribute("data-z-index"), this[e] = t, p) {
                        for((t = this.zIndex) && l && (l.handleZ = !0), s = (i = h.childNodes).length - 1; s >= 0 && !u; s--)o = !b(r = (n = i[s]).getAttribute("data-z-index")), n !== c && (t < 0 && o && !d && !s ? (h.insertBefore(c, i[s]), u = !0) : (T(r) <= t || o && (!b(t) || t >= 0)) && (h.insertBefore(c, i[s + 1]), u = !0));
                        u || (h.insertBefore(c, i[d ? 3 : 0]), u = !0);
                    }
                    return u;
                }
            }
            return D.symbolCustomAttribs = [
                "anchorX",
                "anchorY",
                "clockwise",
                "end",
                "height",
                "innerR",
                "r",
                "start",
                "width",
                "x",
                "y"
            ], D.prototype.strokeSetter = D.prototype.fillSetter, D.prototype.yGetter = D.prototype.xGetter, D.prototype.matrixSetter = D.prototype.rotationOriginXSetter = D.prototype.rotationOriginYSetter = D.prototype.rotationSetter = D.prototype.scaleXSetter = D.prototype.scaleYSetter = D.prototype.translateXSetter = D.prototype.translateYSetter = D.prototype.verticalAlignSetter = function(t, e) {
                this[e] = t, this.doTransform = !0;
            }, D;
        }), i(e, "Core/Renderer/SVG/SVGLabel.js", [
            e["Core/Renderer/SVG/SVGElement.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { defined: i, extend: n, isNumber: r, merge: o, pick: s, removeEvent: a } = e;
            class l extends t {
                constructor(t, e, i, n, r, o, s, a, h, c){
                    let d;
                    super(t, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = e, this.x = i, this.y = n, this.anchorX = o, this.anchorY = s, this.baseline = h, this.className = c, this.addClass("button" === c ? "highcharts-no-tooltip" : "highcharts-label"), c && this.addClass("highcharts-" + c), this.text = t.text(void 0, 0, 0, a).attr({
                        zIndex: 1
                    }), "string" == typeof r && ((d = /^url\((.*?)\)$/.test(r)) || this.renderer.symbols[r]) && (this.symbolKey = r), this.bBox = l.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = t.styledMode || d, this.deferredAttr = {}, this.alignFactor = 0;
                }
                alignSetter(t) {
                    let e = {
                        left: 0,
                        center: .5,
                        right: 1
                    }[t];
                    e !== this.alignFactor && (this.alignFactor = e, this.bBox && r(this.xSetting) && this.attr({
                        x: this.xSetting
                    }));
                }
                anchorXSetter(t, e) {
                    this.anchorX = t, this.boxAttr(e, Math.round(t) - this.getCrispAdjust() - this.xSetting);
                }
                anchorYSetter(t, e) {
                    this.anchorY = t, this.boxAttr(e, t - this.ySetting);
                }
                boxAttr(t, e) {
                    this.box ? this.box.attr(t, e) : this.deferredAttr[t] = e;
                }
                css(e) {
                    if (e) {
                        let t = {};
                        e = o(e), l.textProps.forEach((i)=>{
                            void 0 !== e[i] && (t[i] = e[i], delete e[i]);
                        }), this.text.css(t), "fontSize" in t || "fontWeight" in t ? this.updateTextPadding() : ("width" in t || "textOverflow" in t) && this.updateBoxSize();
                    }
                    return t.prototype.css.call(this, e);
                }
                destroy() {
                    a(this.element, "mouseenter"), a(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), t.prototype.destroy.call(this);
                }
                fillSetter(t, e) {
                    t && (this.needsBox = !0), this.fill = t, this.boxAttr(e, t);
                }
                getBBox(t, e) {
                    this.textStr && 0 === this.bBox.width && 0 === this.bBox.height && this.updateBoxSize();
                    let { padding: i, height: n = 0, translateX: r = 0, translateY: o = 0, width: a = 0 } = this, l = s(this.paddingLeft, i), h = e ?? (this.rotation || 0), c = {
                        width: a,
                        height: n,
                        x: r + this.bBox.x - l,
                        y: o + this.bBox.y - i + this.baselineOffset
                    };
                    return h && (c = this.getRotatedBox(c, h)), c;
                }
                getCrispAdjust() {
                    return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
                }
                heightSetter(t) {
                    this.heightSetting = t, this.doUpdate = !0;
                }
                afterSetters() {
                    super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
                }
                onAdd() {
                    this.text.add(this), this.attr({
                        text: s(this.textStr, ""),
                        x: this.x || 0,
                        y: this.y || 0
                    }), this.box && i(this.anchorX) && this.attr({
                        anchorX: this.anchorX,
                        anchorY: this.anchorY
                    });
                }
                paddingSetter(t, e) {
                    r(t) ? t !== this[e] && (this[e] = t, this.updateTextPadding()) : this[e] = void 0;
                }
                rSetter(t, e) {
                    this.boxAttr(e, t);
                }
                strokeSetter(t, e) {
                    this.stroke = t, this.boxAttr(e, t);
                }
                "stroke-widthSetter"(t, e) {
                    t && (this.needsBox = !0), this["stroke-width"] = t, this.boxAttr(e, t);
                }
                "text-alignSetter"(t) {
                    this.textAlign = t;
                }
                textSetter(t) {
                    void 0 !== t && this.text.attr({
                        text: t
                    }), this.updateTextPadding(), this.reAlign();
                }
                updateBoxSize() {
                    let t, e = this.text, o = {}, s = this.padding, a = this.bBox = r(this.widthSetting) && r(this.heightSetting) && !this.textAlign || !i(e.textStr) ? l.emptyBBox : e.getBBox(void 0, 0);
                    this.width = this.getPaddedWidth(), this.height = (this.heightSetting || a.height || 0) + 2 * s;
                    let h = this.renderer.fontMetrics(e);
                    if (this.baselineOffset = s + Math.min((this.text.firstLineMetrics || h).b, a.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - h.h) / 2), this.needsBox && !e.textPath) {
                        if (!this.box) {
                            let t = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
                            t.addClass(("button" === this.className ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), t.add(this);
                        }
                        t = this.getCrispAdjust(), o.x = t, o.y = (this.baseline ? -this.baselineOffset : 0) + t, o.width = Math.round(this.width), o.height = Math.round(this.height), this.box.attr(n(o, this.deferredAttr)), this.deferredAttr = {};
                    }
                }
                updateTextPadding() {
                    let t = this.text;
                    if (!t.textPath) {
                        this.updateBoxSize();
                        let e = this.baseline ? 0 : this.baselineOffset, n = s(this.paddingLeft, this.padding);
                        i(this.widthSetting) && this.bBox && ("center" === this.textAlign || "right" === this.textAlign) && (n += ({
                            center: .5,
                            right: 1
                        })[this.textAlign] * (this.widthSetting - this.bBox.width)), (n !== t.x || e !== t.y) && (t.attr("x", n), t.hasBoxWidthChanged && (this.bBox = t.getBBox(!0)), void 0 !== e && t.attr("y", e)), t.x = n, t.y = e;
                    }
                }
                widthSetter(t) {
                    this.widthSetting = r(t) ? t : void 0, this.doUpdate = !0;
                }
                getPaddedWidth() {
                    let t = this.padding, e = s(this.paddingLeft, t), i = s(this.paddingRight, t);
                    return (this.widthSetting || this.bBox.width || 0) + e + i;
                }
                xSetter(t) {
                    this.x = t, this.alignFactor && (t -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(t), this.attr("translateX", this.xSetting);
                }
                ySetter(t) {
                    this.ySetting = this.y = Math.round(t), this.attr("translateY", this.ySetting);
                }
            }
            return l.emptyBBox = {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            }, l.textProps = [
                "color",
                "direction",
                "fontFamily",
                "fontSize",
                "fontStyle",
                "fontWeight",
                "lineHeight",
                "textAlign",
                "textDecoration",
                "textOutline",
                "textOverflow",
                "whiteSpace",
                "width"
            ], l;
        }), i(e, "Core/Renderer/SVG/Symbols.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            let { defined: e, isNumber: i, pick: n } = t;
            function r(t, i, r, o, s) {
                let a = [];
                if (s) {
                    let l = s.start || 0, h = n(s.r, r), c = n(s.r, o || r), d = 2e-4 / (s.borderRadius ? 1 : Math.max(h, 1)), u = Math.abs((s.end || 0) - l - 2 * Math.PI) < d, p = (s.end || 0) - (u ? d : 0), f = s.innerR, g = n(s.open, u), m = Math.cos(l), b = Math.sin(l), y = Math.cos(p), x = Math.sin(p), v = n(s.longArc, p - l - Math.PI < d ? 0 : 1), w = [
                        "A",
                        h,
                        c,
                        0,
                        v,
                        n(s.clockwise, 1),
                        t + h * y,
                        i + c * x
                    ];
                    w.params = {
                        start: l,
                        end: p,
                        cx: t,
                        cy: i
                    }, a.push([
                        "M",
                        t + h * m,
                        i + c * b
                    ], w), e(f) && ((w = [
                        "A",
                        f,
                        f,
                        0,
                        v,
                        e(s.clockwise) ? 1 - s.clockwise : 0,
                        t + f * m,
                        i + f * b
                    ]).params = {
                        start: p,
                        end: l,
                        cx: t,
                        cy: i
                    }, a.push(g ? [
                        "M",
                        t + f * y,
                        i + f * x
                    ] : [
                        "L",
                        t + f * y,
                        i + f * x
                    ], w)), g || a.push([
                        "Z"
                    ]);
                }
                return a;
            }
            function o(t, e, i, n, r) {
                return r && r.r ? s(t, e, i, n, r) : [
                    [
                        "M",
                        t,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e
                    ],
                    [
                        "L",
                        t + i,
                        e + n
                    ],
                    [
                        "L",
                        t,
                        e + n
                    ],
                    [
                        "Z"
                    ]
                ];
            }
            function s(t, e, i, n, r) {
                let o = r?.r || 0;
                return [
                    [
                        "M",
                        t + o,
                        e
                    ],
                    [
                        "L",
                        t + i - o,
                        e
                    ],
                    [
                        "A",
                        o,
                        o,
                        0,
                        0,
                        1,
                        t + i,
                        e + o
                    ],
                    [
                        "L",
                        t + i,
                        e + n - o
                    ],
                    [
                        "A",
                        o,
                        o,
                        0,
                        0,
                        1,
                        t + i - o,
                        e + n
                    ],
                    [
                        "L",
                        t + o,
                        e + n
                    ],
                    [
                        "A",
                        o,
                        o,
                        0,
                        0,
                        1,
                        t,
                        e + n - o
                    ],
                    [
                        "L",
                        t,
                        e + o
                    ],
                    [
                        "A",
                        o,
                        o,
                        0,
                        0,
                        1,
                        t + o,
                        e
                    ],
                    [
                        "Z"
                    ]
                ];
            }
            return {
                arc: r,
                callout: function(t, e, n, r, o) {
                    let a = Math.min(o && o.r || 0, n, r), l = a + 6, h = o && o.anchorX, c = o && o.anchorY || 0, d = s(t, e, n, r, {
                        r: a
                    });
                    if (!i(h) || h < n && h > 0 && c < r && c > 0) return d;
                    if (t + h > n - l) {
                        if (c > e + l && c < e + r - l) d.splice(3, 1, [
                            "L",
                            t + n,
                            c - 6
                        ], [
                            "L",
                            t + n + 6,
                            c
                        ], [
                            "L",
                            t + n,
                            c + 6
                        ], [
                            "L",
                            t + n,
                            e + r - a
                        ]);
                        else if (h < n) {
                            let i = c < e + l, o = i ? e : e + r;
                            d.splice(i ? 2 : 5, 0, [
                                "L",
                                h,
                                c
                            ], [
                                "L",
                                t + n - a,
                                o
                            ]);
                        } else d.splice(3, 1, [
                            "L",
                            t + n,
                            r / 2
                        ], [
                            "L",
                            h,
                            c
                        ], [
                            "L",
                            t + n,
                            r / 2
                        ], [
                            "L",
                            t + n,
                            e + r - a
                        ]);
                    } else if (t + h < l) {
                        if (c > e + l && c < e + r - l) d.splice(7, 1, [
                            "L",
                            t,
                            c + 6
                        ], [
                            "L",
                            t - 6,
                            c
                        ], [
                            "L",
                            t,
                            c - 6
                        ], [
                            "L",
                            t,
                            e + a
                        ]);
                        else if (h > 0) {
                            let i = c < e + l, n = i ? e : e + r;
                            d.splice(i ? 1 : 6, 0, [
                                "L",
                                h,
                                c
                            ], [
                                "L",
                                t + a,
                                n
                            ]);
                        } else d.splice(7, 1, [
                            "L",
                            t,
                            r / 2
                        ], [
                            "L",
                            h,
                            c
                        ], [
                            "L",
                            t,
                            r / 2
                        ], [
                            "L",
                            t,
                            e + a
                        ]);
                    } else c > r && h < n - l ? d.splice(5, 1, [
                        "L",
                        h + 6,
                        e + r
                    ], [
                        "L",
                        h,
                        e + r + 6
                    ], [
                        "L",
                        h - 6,
                        e + r
                    ], [
                        "L",
                        t + a,
                        e + r
                    ]) : c < 0 && h > l && d.splice(1, 1, [
                        "L",
                        h - 6,
                        e
                    ], [
                        "L",
                        h,
                        e - 6
                    ], [
                        "L",
                        h + 6,
                        e
                    ], [
                        "L",
                        n - a,
                        e
                    ]);
                    return d;
                },
                circle: function(t, e, i, n) {
                    return r(t + i / 2, e + n / 2, i / 2, n / 2, {
                        start: .5 * Math.PI,
                        end: 2.5 * Math.PI,
                        open: !1
                    });
                },
                diamond: function(t, e, i, n) {
                    return [
                        [
                            "M",
                            t + i / 2,
                            e
                        ],
                        [
                            "L",
                            t + i,
                            e + n / 2
                        ],
                        [
                            "L",
                            t + i / 2,
                            e + n
                        ],
                        [
                            "L",
                            t,
                            e + n / 2
                        ],
                        [
                            "Z"
                        ]
                    ];
                },
                rect: o,
                roundedRect: s,
                square: o,
                triangle: function(t, e, i, n) {
                    return [
                        [
                            "M",
                            t + i / 2,
                            e
                        ],
                        [
                            "L",
                            t + i,
                            e + n
                        ],
                        [
                            "L",
                            t,
                            e + n
                        ],
                        [
                            "Z"
                        ]
                    ];
                },
                "triangle-down": function(t, e, i, n) {
                    return [
                        [
                            "M",
                            t,
                            e
                        ],
                        [
                            "L",
                            t + i,
                            e
                        ],
                        [
                            "L",
                            t + i / 2,
                            e + n
                        ],
                        [
                            "Z"
                        ]
                    ];
                }
            };
        }), i(e, "Core/Renderer/SVG/TextBuilder.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { doc: n, SVG_NS: r, win: o } = e, { attr: s, extend: a, fireEvent: l, isString: h, objectEach: c, pick: d } = i;
            return class {
                constructor(t){
                    let e = t.styles;
                    this.renderer = t.renderer, this.svgElement = t, this.width = t.textWidth, this.textLineHeight = e && e.lineHeight, this.textOutline = e && e.textOutline, this.ellipsis = !(!e || "ellipsis" !== e.textOverflow), this.noWrap = !(!e || "nowrap" !== e.whiteSpace);
                }
                buildSVG() {
                    let e = this.svgElement, i = e.element, r = e.renderer, o = d(e.textStr, "").toString(), s = -1 !== o.indexOf("<"), a = i.childNodes, l = !e.added && r.box, c = [
                        o,
                        this.ellipsis,
                        this.noWrap,
                        this.textLineHeight,
                        this.textOutline,
                        e.getStyle("font-size"),
                        this.width
                    ].join(",");
                    if (c !== e.textCache) {
                        e.textCache = c, delete e.actualWidth;
                        for(let t = a.length; t--;)i.removeChild(a[t]);
                        if (s || this.ellipsis || this.width || e.textPath || -1 !== o.indexOf(" ") && (!this.noWrap || /<br.*?>/g.test(o))) {
                            if ("" !== o) {
                                l && l.appendChild(i);
                                let n = new t(o);
                                this.modifyTree(n.nodes), n.addToDOM(i), this.modifyDOM(), this.ellipsis && -1 !== (i.textContent || "").indexOf("\u2026") && e.attr("title", this.unescapeEntities(e.textStr || "", [
                                    "&lt;",
                                    "&gt;"
                                ])), l && l.removeChild(i);
                            }
                        } else i.appendChild(n.createTextNode(this.unescapeEntities(o)));
                        h(this.textOutline) && e.applyTextOutline && e.applyTextOutline(this.textOutline);
                    }
                }
                modifyDOM() {
                    let t, e = this.svgElement, i = s(e.element, "x");
                    for(e.firstLineMetrics = void 0; (t = e.element.firstChild) && /^[\s\u200B]*$/.test(t.textContent || " ");)e.element.removeChild(t);
                    [].forEach.call(e.element.querySelectorAll("tspan.highcharts-br"), (t, n)=>{
                        t.nextSibling && t.previousSibling && (0 === n && 1 === t.previousSibling.nodeType && (e.firstLineMetrics = e.renderer.fontMetrics(t.previousSibling)), s(t, {
                            dy: this.getLineHeight(t.nextSibling),
                            x: i
                        }));
                    });
                    let a = this.width || 0;
                    if (!a) return;
                    let l = (t, o)=>{
                        let l = t.textContent || "", h = l.replace(/([^\^])-/g, "$1- ").split(" "), c = !this.noWrap && (h.length > 1 || e.element.childNodes.length > 1), d = this.getLineHeight(o), u = 0, p = e.actualWidth;
                        if (this.ellipsis) l && this.truncate(t, l, void 0, 0, Math.max(0, a - .8 * d), (t, e)=>t.substring(0, e) + "\u2026");
                        else if (c) {
                            let l = [], c = [];
                            for(; o.firstChild && o.firstChild !== t;)c.push(o.firstChild), o.removeChild(o.firstChild);
                            for(; h.length;)h.length && !this.noWrap && u > 0 && (l.push(t.textContent || ""), t.textContent = h.join(" ").replace(/- /g, "-")), this.truncate(t, void 0, h, 0 === u && p || 0, a, (t, e)=>h.slice(0, e).join(" ").replace(/- /g, "-")), p = e.actualWidth, u++;
                            c.forEach((e)=>{
                                o.insertBefore(e, t);
                            }), l.forEach((e)=>{
                                o.insertBefore(n.createTextNode(e), t);
                                let a = n.createElementNS(r, "tspan");
                                a.textContent = "\u200B", s(a, {
                                    dy: d,
                                    x: i
                                }), o.insertBefore(a, t);
                            });
                        }
                    }, h = (t)=>{
                        [].slice.call(t.childNodes).forEach((i)=>{
                            i.nodeType === o.Node.TEXT_NODE ? l(i, t) : (-1 !== i.className.baseVal.indexOf("highcharts-br") && (e.actualWidth = 0), h(i));
                        });
                    };
                    h(e.element);
                }
                getLineHeight(t) {
                    let e = t.nodeType === o.Node.TEXT_NODE ? t.parentElement : t;
                    return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(e || this.svgElement.element).h;
                }
                modifyTree(t) {
                    let e = (i, n)=>{
                        let { attributes: r = {}, children: o, style: s = {}, tagName: l } = i, h = this.renderer.styledMode;
                        if ("b" === l || "strong" === l ? h ? r.class = "highcharts-strong" : s.fontWeight = "bold" : ("i" === l || "em" === l) && (h ? r.class = "highcharts-emphasized" : s.fontStyle = "italic"), s && s.color && (s.fill = s.color), "br" === l) {
                            r.class = "highcharts-br", i.textContent = "\u200B";
                            let e = t[n + 1];
                            e && e.textContent && (e.textContent = e.textContent.replace(/^ +/gm, ""));
                        } else "a" === l && o && o.some((t)=>"#text" === t.tagName) && (i.children = [
                            {
                                children: o,
                                tagName: "tspan"
                            }
                        ]);
                        "#text" !== l && "a" !== l && (i.tagName = "tspan"), a(i, {
                            attributes: r,
                            style: s
                        }), o && o.filter((t)=>"#text" !== t.tagName).forEach(e);
                    };
                    t.forEach(e), l(this.svgElement, "afterModifyTree", {
                        nodes: t
                    });
                }
                truncate(t, e, i, n, r, o) {
                    let s, a, l = this.svgElement, { rotation: h } = l, c = [], d = i ? 1 : 0, u = (e || i || "").length, p = u, f = function(e, r) {
                        let o = r || e, s = t.parentNode;
                        if (s && void 0 === c[o] && s.getSubStringLength) try {
                            c[o] = n + s.getSubStringLength(0, i ? o + 1 : o);
                        } catch (t) {}
                        return c[o];
                    };
                    if (l.rotation = 0, n + (a = f(t.textContent.length)) > r) {
                        for(; d <= u;)p = Math.ceil((d + u) / 2), i && (s = o(i, p)), a = f(p, s && s.length - 1), d === u ? d = u + 1 : a > r ? u = p - 1 : d = p;
                        0 === u ? t.textContent = "" : e && u === e.length - 1 || (t.textContent = s || o(e || i, p));
                    }
                    i && i.splice(0, p), l.actualWidth = a, l.rotation = h;
                }
                unescapeEntities(t, e) {
                    return c(this.renderer.escapes, function(i, n) {
                        e && -1 !== e.indexOf(i) || (t = t.toString().replace(RegExp(i, "g"), n));
                    }), t;
                }
            };
        }), i(e, "Core/Renderer/SVG/SVGRenderer.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Defaults.js"],
            e["Core/Color/Color.js"],
            e["Core/Globals.js"],
            e["Core/Renderer/RendererRegistry.js"],
            e["Core/Renderer/SVG/SVGElement.js"],
            e["Core/Renderer/SVG/SVGLabel.js"],
            e["Core/Renderer/SVG/Symbols.js"],
            e["Core/Renderer/SVG/TextBuilder.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a, l, h) {
            let c, { defaultOptions: d } = e, { charts: u, deg2rad: p, doc: f, isFirefox: g, isMS: m, isWebKit: b, noop: y, SVG_NS: x, symbolSizes: v, win: w } = n, { addEvent: C, attr: S, createElement: k, crisp: A, css: E, defined: M, destroyObjectProperties: T, extend: P, isArray: R, isNumber: L, isObject: O, isString: D, merge: j, pick: N, pInt: I, replaceNested: B, uniqueKey: F } = h;
            class z {
                constructor(t, e, i, n, r, o, s){
                    let a, l, h = this.createElement("svg").attr({
                        version: "1.1",
                        class: "highcharts-root"
                    }), c = h.element;
                    s || h.css(this.getStyle(n || {})), t.appendChild(c), S(t, "dir", "ltr"), -1 === t.innerHTML.indexOf("xmlns") && S(c, "xmlns", this.SVG_NS), this.box = c, this.boxWrapper = h, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(f.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = o, this.forExport = r, this.styledMode = s, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = h.getStyle("font-size"), this.setSize(e, i, !1), g && t.getBoundingClientRect && ((a = function() {
                        E(t, {
                            left: 0,
                            top: 0
                        }), l = t.getBoundingClientRect(), E(t, {
                            left: Math.ceil(l.left) - l.left + "px",
                            top: Math.ceil(l.top) - l.top + "px"
                        });
                    })(), this.unSubPixelFix = C(w, "resize", a));
                }
                definition(e) {
                    return new t([
                        e
                    ]).addToDOM(this.defs.element);
                }
                getReferenceURL() {
                    if ((g || b) && f.getElementsByTagName("base").length) {
                        if (!M(c)) {
                            let e = F(), i = new t([
                                {
                                    tagName: "svg",
                                    attributes: {
                                        width: 8,
                                        height: 8
                                    },
                                    children: [
                                        {
                                            tagName: "defs",
                                            children: [
                                                {
                                                    tagName: "clipPath",
                                                    attributes: {
                                                        id: e
                                                    },
                                                    children: [
                                                        {
                                                            tagName: "rect",
                                                            attributes: {
                                                                width: 4,
                                                                height: 4
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            tagName: "rect",
                                            attributes: {
                                                id: "hitme",
                                                width: 8,
                                                height: 8,
                                                "clip-path": `url(#${e})`,
                                                fill: "rgba(0,0,0,0.001)"
                                            }
                                        }
                                    ]
                                }
                            ]).addToDOM(f.body);
                            E(i, {
                                position: "fixed",
                                top: 0,
                                left: 0,
                                zIndex: 9e5
                            });
                            let n = f.elementFromPoint(6, 6);
                            c = "hitme" === (n && n.id), f.body.removeChild(i);
                        }
                        if (c) return B(w.location.href.split("#")[0], [
                            /<[^>]*>/g,
                            ""
                        ], [
                            /([\('\)])/g,
                            "\\$1"
                        ], [
                            / /g,
                            "%20"
                        ]);
                    }
                    return "";
                }
                getStyle(t) {
                    return this.style = P({
                        fontFamily: "Helvetica, Arial, sans-serif",
                        fontSize: "1rem"
                    }, t), this.style;
                }
                setStyle(t) {
                    this.boxWrapper.css(this.getStyle(t));
                }
                isHidden() {
                    return !this.boxWrapper.getBBox().width;
                }
                destroy() {
                    let t = this.defs;
                    return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), T(this.gradients || {}), this.gradients = null, this.defs = t.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
                }
                createElement(t) {
                    return new this.Element(this, t);
                }
                getRadialAttr(t, e) {
                    return {
                        cx: t[0] - t[2] / 2 + (e.cx || 0) * t[2],
                        cy: t[1] - t[2] / 2 + (e.cy || 0) * t[2],
                        r: (e.r || 0) * t[2]
                    };
                }
                shadowDefinition(t) {
                    let e = [
                        `highcharts-drop-shadow-${this.chartIndex}`,
                        ...Object.keys(t).map((e)=>`${e}-${t[e]}`)
                    ].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), i = j({
                        color: "#000000",
                        offsetX: 1,
                        offsetY: 1,
                        opacity: .15,
                        width: 5
                    }, t);
                    return this.defs.element.querySelector(`#${e}`) || this.definition({
                        tagName: "filter",
                        attributes: {
                            id: e,
                            filterUnits: i.filterUnits
                        },
                        children: this.getShadowFilterContent(i)
                    }), e;
                }
                getShadowFilterContent(t) {
                    return [
                        {
                            tagName: "feDropShadow",
                            attributes: {
                                dx: t.offsetX,
                                dy: t.offsetY,
                                "flood-color": t.color,
                                "flood-opacity": Math.min(5 * t.opacity, 1),
                                stdDeviation: t.width / 2
                            }
                        }
                    ];
                }
                buildText(t) {
                    new l(t).buildSVG();
                }
                getContrast(t) {
                    let e = i.parse(t).rgba.map((t)=>{
                        let e = t / 255;
                        return e <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
                    }), n = .2126 * e[0] + .7152 * e[1] + .0722 * e[2];
                    return 1.05 / (n + .05) > (n + .05) / .05 ? "#FFFFFF" : "#000000";
                }
                button(e, i, n, r, o = {}, s, a, l, h, c) {
                    let u = this.label(e, i, n, h, void 0, void 0, c, void 0, "button"), p = this.styledMode, f = arguments, g = 0;
                    o = j(d.global.buttonTheme, o), p && (delete o.fill, delete o.stroke, delete o["stroke-width"]);
                    let b = o.states || {}, y = o.style || {};
                    delete o.states, delete o.style;
                    let x = [
                        t.filterUserAttributes(o)
                    ], v = [
                        y
                    ];
                    return p || [
                        "hover",
                        "select",
                        "disabled"
                    ].forEach((e, i)=>{
                        x.push(j(x[0], t.filterUserAttributes(f[i + 5] || b[e] || {}))), v.push(x[i + 1].style), delete x[i + 1].style;
                    }), C(u.element, m ? "mouseover" : "mouseenter", function() {
                        3 !== g && u.setState(1);
                    }), C(u.element, m ? "mouseout" : "mouseleave", function() {
                        3 !== g && u.setState(g);
                    }), u.setState = (t = 0)=>{
                        if (1 !== t && (u.state = g = t), u.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + [
                            "normal",
                            "hover",
                            "pressed",
                            "disabled"
                        ][t]), !p) {
                            u.attr(x[t]);
                            let e = v[t];
                            O(e) && u.css(e);
                        }
                    }, u.attr(x[0]), !p && (u.css(P({
                        cursor: "default"
                    }, y)), c && u.text.css({
                        pointerEvents: "none"
                    })), u.on("touchstart", (t)=>t.stopPropagation()).on("click", function(t) {
                        3 !== g && r.call(u, t);
                    });
                }
                crispLine(t, e) {
                    let [i, n] = t;
                    return M(i[1]) && i[1] === n[1] && (i[1] = n[1] = A(i[1], e)), M(i[2]) && i[2] === n[2] && (i[2] = n[2] = A(i[2], e)), t;
                }
                path(t) {
                    let e = this.styledMode ? {} : {
                        fill: "none"
                    };
                    return R(t) ? e.d = t : O(t) && P(e, t), this.createElement("path").attr(e);
                }
                circle(t, e, i) {
                    let n = O(t) ? t : void 0 === t ? {} : {
                        x: t,
                        y: e,
                        r: i
                    }, r = this.createElement("circle");
                    return r.xSetter = r.ySetter = function(t, e, i) {
                        i.setAttribute("c" + e, t);
                    }, r.attr(n);
                }
                arc(t, e, i, n, r, o) {
                    let s;
                    O(t) ? (e = (s = t).y, i = s.r, n = s.innerR, r = s.start, o = s.end, t = s.x) : s = {
                        innerR: n,
                        start: r,
                        end: o
                    };
                    let a = this.symbol("arc", t, e, i, i, s);
                    return a.r = i, a;
                }
                rect(t, e, i, n, r, o) {
                    let s = O(t) ? t : void 0 === t ? {} : {
                        x: t,
                        y: e,
                        r: r,
                        width: Math.max(i || 0, 0),
                        height: Math.max(n || 0, 0)
                    }, a = this.createElement("rect");
                    return this.styledMode || (void 0 !== o && (s["stroke-width"] = o, P(s, a.crisp(s))), s.fill = "none"), a.rSetter = function(t, e, i) {
                        a.r = t, S(i, {
                            rx: t,
                            ry: t
                        });
                    }, a.rGetter = function() {
                        return a.r || 0;
                    }, a.attr(s);
                }
                roundedRect(t) {
                    return this.symbol("roundedRect").attr(t);
                }
                setSize(t, e, i) {
                    this.width = t, this.height = e, this.boxWrapper.animate({
                        width: t,
                        height: e
                    }, {
                        step: function() {
                            this.attr({
                                viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                            });
                        },
                        duration: N(i, !0) ? void 0 : 0
                    }), this.alignElements();
                }
                g(t) {
                    let e = this.createElement("g");
                    return t ? e.attr({
                        class: "highcharts-" + t
                    }) : e;
                }
                image(t, e, i, n, r, o) {
                    let s = {
                        preserveAspectRatio: "none"
                    };
                    L(e) && (s.x = e), L(i) && (s.y = i), L(n) && (s.width = n), L(r) && (s.height = r);
                    let a = this.createElement("image").attr(s), l = function(e) {
                        a.attr({
                            href: t
                        }), o.call(a, e);
                    };
                    if (o) {
                        a.attr({
                            href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                        });
                        let e = new w.Image;
                        C(e, "load", l), e.src = t, e.complete && l({});
                    } else a.attr({
                        href: t
                    });
                    return a;
                }
                symbol(t, e, i, n, r, o) {
                    let s, a, l, h, c = this, d = /^url\((.*?)\)$/, p = d.test(t), g = !p && (this.symbols[t] ? t : "circle"), m = g && this.symbols[g];
                    if (m) "number" == typeof e && (a = m.call(this.symbols, e || 0, i || 0, n || 0, r || 0, o)), s = this.path(a), c.styledMode || s.attr("fill", "none"), P(s, {
                        symbolName: g || void 0,
                        x: e,
                        y: i,
                        width: n,
                        height: r
                    }), o && P(s, o);
                    else if (p) {
                        l = t.match(d)[1];
                        let n = s = this.image(l);
                        n.imgwidth = N(o && o.width, v[l] && v[l].width), n.imgheight = N(o && o.height, v[l] && v[l].height), h = (t)=>t.attr({
                                width: t.width,
                                height: t.height
                            }), [
                            "width",
                            "height"
                        ].forEach((t)=>{
                            n[`${t}Setter`] = function(t, e) {
                                this[e] = t;
                                let { alignByTranslate: i, element: n, width: r, height: s, imgwidth: a, imgheight: l } = this, h = "width" === e ? a : l, c = 1;
                                o && "within" === o.backgroundSize && r && s && a && l ? (c = Math.min(r / a, s / l), S(n, {
                                    width: Math.round(a * c),
                                    height: Math.round(l * c)
                                })) : n && h && n.setAttribute(e, h), !i && a && l && this.translate(((r || 0) - a * c) / 2, ((s || 0) - l * c) / 2);
                            };
                        }), M(e) && n.attr({
                            x: e,
                            y: i
                        }), n.isImg = !0, n.symbolUrl = t, M(n.imgwidth) && M(n.imgheight) ? h(n) : (n.attr({
                            width: 0,
                            height: 0
                        }), k("img", {
                            onload: function() {
                                let t = u[c.chartIndex];
                                0 === this.width && (E(this, {
                                    position: "absolute",
                                    top: "-999em"
                                }), f.body.appendChild(this)), v[l] = {
                                    width: this.width,
                                    height: this.height
                                }, n.imgwidth = this.width, n.imgheight = this.height, n.element && h(n), this.parentNode && this.parentNode.removeChild(this), c.imgCount--, c.imgCount || !t || t.hasLoaded || t.onload();
                            },
                            src: l
                        }), this.imgCount++);
                    }
                    return s;
                }
                clipRect(t, e, i, n) {
                    return this.rect(t, e, i, n, 0);
                }
                text(t, e, i, n) {
                    let r = {};
                    if (n && (this.allowHTML || !this.forExport)) return this.html(t, e, i);
                    r.x = Math.round(e || 0), i && (r.y = Math.round(i)), M(t) && (r.text = t);
                    let o = this.createElement("text").attr(r);
                    return n && (!this.forExport || this.allowHTML) || (o.xSetter = function(t, e, i) {
                        let n = i.getElementsByTagName("tspan"), r = i.getAttribute(e);
                        for(let i, o = 0; o < n.length; o++)(i = n[o]).getAttribute(e) === r && i.setAttribute(e, t);
                        i.setAttribute(e, t);
                    }), o;
                }
                fontMetrics(t) {
                    let e = I(o.prototype.getStyle.call(t, "font-size") || 0), i = e < 24 ? e + 3 : Math.round(1.2 * e);
                    return {
                        h: i,
                        b: Math.round(.8 * i),
                        f: e
                    };
                }
                rotCorr(t, e, i) {
                    let n = t;
                    return e && i && (n = Math.max(n * Math.cos(e * p), 4)), {
                        x: -t / 3 * Math.sin(e * p),
                        y: n
                    };
                }
                pathToSegments(t) {
                    let e = [], i = [], n = {
                        A: 8,
                        C: 7,
                        H: 2,
                        L: 3,
                        M: 3,
                        Q: 5,
                        S: 5,
                        T: 3,
                        V: 2
                    };
                    for(let r = 0; r < t.length; r++)D(i[0]) && L(t[r]) && i.length === n[i[0].toUpperCase()] && t.splice(r, 0, i[0].replace("M", "L").replace("m", "l")), "string" == typeof t[r] && (i.length && e.push(i.slice(0)), i.length = 0), i.push(t[r]);
                    return e.push(i.slice(0)), e;
                }
                label(t, e, i, n, r, o, a, l, h) {
                    return new s(this, t, e, i, n, r, o, a, l, h);
                }
                alignElements() {
                    this.alignedObjects.forEach((t)=>t.align());
                }
            }
            return P(z.prototype, {
                Element: o,
                SVG_NS: x,
                escapes: {
                    "&": "&amp;",
                    "<": "&lt;",
                    ">": "&gt;",
                    "'": "&#39;",
                    '"': "&quot;"
                },
                symbols: a,
                draw: y
            }), r.registerRendererType("svg", z, !0), z;
        }), i(e, "Core/Renderer/HTML/HTMLElement.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Globals.js"],
            e["Core/Renderer/SVG/SVGElement.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { composed: r } = e, { attr: o, css: s, createElement: a, defined: l, extend: h, pInt: c, pushUnique: d } = n;
            function u(t, e, n) {
                let r = this.div?.style || n.style;
                i.prototype[`${e}Setter`].call(this, t, e, n), r && (r[e] = t);
            }
            let p = (t, e)=>{
                if (!t.div) {
                    let n = o(t.element, "class"), r = t.css, s = a("div", n ? {
                        className: n
                    } : void 0, {
                        position: "absolute",
                        left: `${t.translateX || 0}px`,
                        top: `${t.translateY || 0}px`,
                        ...t.styles,
                        display: t.display,
                        opacity: t.opacity,
                        visibility: t.visibility
                    }, t.parentGroup?.div || e);
                    t.classSetter = (t, e, i)=>{
                        i.setAttribute("class", t), s.className = t;
                    }, t.translateXSetter = t.translateYSetter = (e, i)=>{
                        t[i] = e, s.style["translateX" === i ? "left" : "top"] = `${e}px`, t.doTransform = !0;
                    }, t.opacitySetter = t.visibilitySetter = u, t.css = (e)=>(r.call(t, e), e.cursor && (s.style.cursor = e.cursor), e.pointerEvents && (s.style.pointerEvents = e.pointerEvents), t), t.on = function() {
                        return i.prototype.on.apply({
                            element: s,
                            onEvents: t.onEvents
                        }, arguments), t;
                    }, t.div = s;
                }
                return t.div;
            };
            class f extends i {
                static compose(t) {
                    d(r, this.compose) && (t.prototype.html = function(t, e, i) {
                        return new f(this, "span").attr({
                            text: t,
                            x: Math.round(e),
                            y: Math.round(i)
                        });
                    });
                }
                constructor(t, e){
                    super(t, e), this.css({
                        position: "absolute",
                        ...t.styledMode ? {} : {
                            fontFamily: t.style.fontFamily,
                            fontSize: t.style.fontSize
                        }
                    }), this.element.style.whiteSpace = "nowrap";
                }
                getSpanCorrection(t, e, i) {
                    this.xCorr = -t * i, this.yCorr = -e;
                }
                css(t) {
                    let e, { element: i } = this, n = "SPAN" === i.tagName && t && "width" in t, r = n && t.width;
                    return n && (delete t.width, this.textWidth = c(r) || void 0, e = !0), "ellipsis" === t?.textOverflow && (t.whiteSpace = "nowrap", t.overflow = "hidden"), h(this.styles, t), s(i, t), e && this.updateTransform(), this;
                }
                htmlGetBBox() {
                    let { element: t } = this;
                    return {
                        x: t.offsetLeft,
                        y: t.offsetTop,
                        width: t.offsetWidth,
                        height: t.offsetHeight
                    };
                }
                updateTransform() {
                    if (!this.added) return void (this.alignOnAdd = !0);
                    let { element: t, renderer: e, rotation: i, rotationOriginX: n, rotationOriginY: r, styles: o, textAlign: a = "left", textWidth: h, translateX: c = 0, translateY: d = 0, x: u = 0, y: p = 0 } = this, f = {
                        left: 0,
                        center: .5,
                        right: 1
                    }[a], g = o.whiteSpace;
                    if (s(t, {
                        marginLeft: `${c}px`,
                        marginTop: `${d}px`
                    }), "SPAN" === t.tagName) {
                        let o, c = [
                            i,
                            a,
                            t.innerHTML,
                            h,
                            this.textAlign
                        ].join(","), d = -1 * this.parentGroup?.padding || 0, m = !1;
                        if (h !== this.oldTextWidth) {
                            let e = this.textPxLength ? this.textPxLength : (s(t, {
                                width: "",
                                whiteSpace: g || "nowrap"
                            }), t.offsetWidth), n = h || 0;
                            (n > this.oldTextWidth || e > n) && (/[ \-]/.test(t.textContent || t.innerText) || "ellipsis" === t.style.textOverflow) && (s(t, {
                                width: e > n || i ? h + "px" : "auto",
                                display: "block",
                                whiteSpace: g || "normal"
                            }), this.oldTextWidth = h, m = !0);
                        }
                        this.hasBoxWidthChanged = m, c !== this.cTT && (o = e.fontMetrics(t).b, l(i) && (i !== (this.oldRotation || 0) || a !== this.oldAlign) && this.setSpanRotation(i, d, d), this.getSpanCorrection(!l(i) && this.textPxLength || t.offsetWidth, o, f));
                        let { xCorr: b = 0, yCorr: y = 0 } = this;
                        s(t, {
                            left: `${u + b}px`,
                            top: `${p + y}px`,
                            transformOrigin: `${(n ?? u) - b - u - d}px ${(r ?? p) - y - p - d}px`
                        }), this.cTT = c, this.oldRotation = i, this.oldAlign = a;
                    }
                }
                setSpanRotation(t, e, i) {
                    s(this.element, {
                        transform: `rotate(${t}deg)`,
                        transformOrigin: `${e}% ${i}px`
                    });
                }
                add(t) {
                    let e, i = this.renderer.box.parentNode, n = [];
                    if (this.parentGroup = t, t && !(e = t.div)) {
                        let r = t;
                        for(; r;)n.push(r), r = r.parentGroup;
                        for (let t of n.reverse())e = p(t, i);
                    }
                    return (e || i).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
                }
                textSetter(e) {
                    e !== this.textStr && (delete this.bBox, delete this.oldTextWidth, t.setElementHTML(this.element, e ?? ""), this.textStr = e, this.doTransform = !0);
                }
                alignSetter(t) {
                    this.alignValue = this.textAlign = t, this.doTransform = !0;
                }
                xSetter(t, e) {
                    this[e] = t, this.doTransform = !0;
                }
            }
            let g = f.prototype;
            return g.visibilitySetter = g.opacitySetter = u, g.ySetter = g.rotationSetter = g.rotationOriginXSetter = g.rotationOriginYSetter = g.xSetter, f;
        }), i(e, "Core/Axis/AxisDefaults.js", [], function() {
            var t, e;
            return (e = t || (t = {})).xAxis = {
                alignTicks: !0,
                allowDecimals: void 0,
                panningEnabled: !0,
                zIndex: 2,
                zoomEnabled: !0,
                dateTimeLabelFormats: {
                    millisecond: {
                        main: "%H:%M:%S.%L",
                        range: !1
                    },
                    second: {
                        main: "%H:%M:%S",
                        range: !1
                    },
                    minute: {
                        main: "%H:%M",
                        range: !1
                    },
                    hour: {
                        main: "%H:%M",
                        range: !1
                    },
                    day: {
                        main: "%e %b"
                    },
                    week: {
                        main: "%e %b"
                    },
                    month: {
                        main: "%b '%y"
                    },
                    year: {
                        main: "%Y"
                    }
                },
                endOnTick: !1,
                gridLineDashStyle: "Solid",
                gridZIndex: 1,
                labels: {
                    autoRotationLimit: 80,
                    distance: 15,
                    enabled: !0,
                    indentation: 10,
                    overflow: "justify",
                    reserveSpace: void 0,
                    rotation: void 0,
                    staggerLines: 0,
                    step: 0,
                    useHTML: !1,
                    zIndex: 7,
                    style: {
                        color: "#333333",
                        cursor: "default",
                        fontSize: "0.8em"
                    }
                },
                maxPadding: .01,
                minorGridLineDashStyle: "Solid",
                minorTickLength: 2,
                minorTickPosition: "outside",
                minorTicksPerMajor: 5,
                minPadding: .01,
                offset: void 0,
                reversed: void 0,
                reversedStacks: !1,
                showEmpty: !0,
                showFirstLabel: !0,
                showLastLabel: !0,
                startOfWeek: 1,
                startOnTick: !1,
                tickLength: 10,
                tickPixelInterval: 100,
                tickmarkPlacement: "between",
                tickPosition: "outside",
                title: {
                    align: "middle",
                    useHTML: !1,
                    x: 0,
                    y: 0,
                    style: {
                        color: "#666666",
                        fontSize: "0.8em"
                    }
                },
                visible: !0,
                minorGridLineColor: "#f2f2f2",
                minorGridLineWidth: 1,
                minorTickColor: "#999999",
                lineColor: "#333333",
                lineWidth: 1,
                gridLineColor: "#e6e6e6",
                gridLineWidth: void 0,
                tickColor: "#333333"
            }, e.yAxis = {
                reversedStacks: !0,
                endOnTick: !0,
                maxPadding: .05,
                minPadding: .05,
                tickPixelInterval: 72,
                showLastLabel: !0,
                labels: {
                    x: void 0
                },
                startOnTick: !0,
                title: {
                    text: "Values"
                },
                stackLabels: {
                    animation: {},
                    allowOverlap: !1,
                    enabled: !1,
                    crop: !0,
                    overflow: "justify",
                    formatter: function() {
                        let { numberFormatter: t } = this.axis.chart;
                        return t(this.total || 0, -1);
                    },
                    style: {
                        color: "#000000",
                        fontSize: "0.7em",
                        fontWeight: "bold",
                        textOutline: "1px contrast"
                    }
                },
                gridLineWidth: 1,
                lineWidth: 0
            }, t;
        }), i(e, "Core/Foundation.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            var e;
            let { addEvent: i, isFunction: n, objectEach: r, removeEvent: o } = t;
            return (e || (e = {})).registerEventOptions = function(t, e) {
                t.eventOptions = t.eventOptions || {}, r(e.events, function(e, r) {
                    t.eventOptions[r] !== e && (t.eventOptions[r] && (o(t, r, t.eventOptions[r]), delete t.eventOptions[r]), n(e) && (t.eventOptions[r] = e, i(t, r, e, {
                        order: 0
                    })));
                });
            }, e;
        }), i(e, "Core/Axis/Tick.js", [
            e["Core/Templating.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { deg2rad: n } = e, { clamp: r, correctFloat: o, defined: s, destroyObjectProperties: a, extend: l, fireEvent: h, isNumber: c, merge: d, objectEach: u, pick: p } = i;
            return class {
                constructor(t, e, i, n, r){
                    this.isNew = !0, this.isNewLabel = !0, this.axis = t, this.pos = e, this.type = i || "", this.parameters = r || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, h(this, "init"), i || n || this.addLabel();
                }
                addLabel() {
                    let e, i, n, r = this, a = r.axis, d = a.options, u = a.chart, f = a.categories, g = a.logarithmic, m = a.names, b = r.pos, y = p(r.options && r.options.labels, d.labels), x = a.tickPositions, v = b === x[0], w = b === x[x.length - 1], C = (!y.step || 1 === y.step) && 1 === a.tickInterval, S = x.info, k = r.label, A = this.parameters.category || (f ? p(f[b], m[b], b) : b);
                    g && c(A) && (A = o(g.lin2log(A))), a.dateTime && (S ? e = (i = u.time.resolveDTLFormat(d.dateTimeLabelFormats[!d.grid && S.higherRanks[b] || S.unitName])).main : c(A) && (e = a.dateTime.getXDateFormat(A, d.dateTimeLabelFormats || {}))), r.isFirst = v, r.isLast = w;
                    let E = {
                        axis: a,
                        chart: u,
                        dateTimeLabelFormat: e,
                        isFirst: v,
                        isLast: w,
                        pos: b,
                        tick: r,
                        tickPositionInfo: S,
                        value: A
                    };
                    h(this, "labelFormat", E);
                    let M = (e)=>y.formatter ? y.formatter.call(e, e) : y.format ? (e.text = a.defaultLabelFormatter.call(e), t.format(y.format, e, u)) : a.defaultLabelFormatter.call(e), T = M.call(E, E), P = i && i.list;
                    r.shortenLabel = P ? function() {
                        for(n = 0; n < P.length; n++)if (l(E, {
                            dateTimeLabelFormat: P[n]
                        }), k.attr({
                            text: M.call(E, E)
                        }), k.getBBox().width < a.getSlotWidth(r) - 2 * (y.padding || 0)) return;
                        k.attr({
                            text: ""
                        });
                    } : void 0, C && a._addedPlotLB && r.moveLabel(T, y), s(k) || r.movedLabel ? k && k.textStr !== T && !C && (!k.textWidth || y.style.width || k.styles.width || k.css({
                        width: null
                    }), k.attr({
                        text: T
                    }), k.textPxLength = k.getBBox().width) : (r.label = k = r.createLabel(T, y), r.rotation = 0);
                }
                createLabel(t, e, i) {
                    let n = this.axis, r = n.chart, o = s(t) && e.enabled ? r.renderer.text(t, i?.x, i?.y, e.useHTML).add(n.labelGroup) : void 0;
                    return o && (r.styledMode || o.css(d(e.style)), o.textPxLength = o.getBBox().width), o;
                }
                destroy() {
                    a(this, this.axis);
                }
                getPosition(t, e, i, n) {
                    let s = this.axis, a = s.chart, l = n && a.oldChartHeight || a.chartHeight, c = {
                        x: t ? o(s.translate(e + i, void 0, void 0, n) + s.transB) : s.left + s.offset + (s.opposite ? (n && a.oldChartWidth || a.chartWidth) - s.right - s.left : 0),
                        y: t ? l - s.bottom + s.offset - (s.opposite ? s.height : 0) : o(l - s.translate(e + i, void 0, void 0, n) - s.transB)
                    };
                    return c.y = r(c.y, -1000000000, 1e9), h(this, "afterGetPosition", {
                        pos: c
                    }), c;
                }
                getLabelPosition(t, e, i, r, o, a, l, c) {
                    let d, u, f = this.axis, g = f.transA, m = f.isLinked && f.linkedParent ? f.linkedParent.reversed : f.reversed, b = f.staggerLines, y = f.tickRotCorr || {
                        x: 0,
                        y: 0
                    }, x = r || f.reserveSpaceDefault ? 0 : -f.labelOffset * ("center" === f.labelAlign ? .5 : 1), v = o.distance, w = {};
                    return d = 0 === f.side ? i.rotation ? -v : -i.getBBox().height : 2 === f.side ? y.y + v : Math.cos(i.rotation * n) * (y.y - i.getBBox(!1, 0).height / 2), s(o.y) && (d = 0 === f.side && f.horiz ? o.y + d : o.y), t = t + p(o.x, [
                        0,
                        1,
                        0,
                        -1
                    ][f.side] * v) + x + y.x - (a && r ? a * g * (m ? -1 : 1) : 0), e = e + d - (a && !r ? a * g * (m ? 1 : -1) : 0), b && (u = l / (c || 1) % b, f.opposite && (u = b - u - 1), e += u * (f.labelOffset / b)), w.x = t, w.y = Math.round(e), h(this, "afterGetLabelPosition", {
                        pos: w,
                        tickmarkOffset: a,
                        index: l
                    }), w;
                }
                getLabelSize() {
                    return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
                }
                getMarkPath(t, e, i, n, r = !1, o) {
                    return o.crispLine([
                        [
                            "M",
                            t,
                            e
                        ],
                        [
                            "L",
                            t + (r ? 0 : -i),
                            e + (r ? i : 0)
                        ]
                    ], n);
                }
                handleOverflow(t) {
                    let e, i, r, o = this.axis, s = o.options.labels, a = t.x, l = o.chart.chartWidth, h = o.chart.spacing, c = p(o.labelLeft, Math.min(o.pos, h[3])), d = p(o.labelRight, Math.max(o.isRadial ? 0 : o.pos + o.len, l - h[1])), u = this.label, f = this.rotation, g = {
                        left: 0,
                        center: .5,
                        right: 1
                    }[o.labelAlign || u.attr("align")], m = u.getBBox().width, b = o.getSlotWidth(this), y = {}, x = b, v = 1;
                    f || "justify" !== s.overflow ? f < 0 && a - g * m < c ? r = Math.round(a / Math.cos(f * n) - c) : f > 0 && a + g * m > d && (r = Math.round((l - a) / Math.cos(f * n))) : (e = a - g * m, i = a + (1 - g) * m, e < c ? x = t.x + x * (1 - g) - c : i > d && (x = d - t.x + x * g, v = -1), (x = Math.min(b, x)) < b && "center" === o.labelAlign && (t.x += v * (b - x - g * (b - Math.min(m, x)))), (m > x || o.autoRotation && (u.styles || {}).width) && (r = x)), r && (this.shortenLabel ? this.shortenLabel() : (y.width = Math.floor(r) + "px", (s.style || {}).textOverflow || (y.textOverflow = "ellipsis"), u.css(y)));
                }
                moveLabel(t, e) {
                    let i, n = this, r = n.label, o = n.axis, s = !1;
                    r && r.textStr === t ? (n.movedLabel = r, s = !0, delete n.label) : u(o.ticks, function(e) {
                        s || e.isNew || e === n || !e.label || e.label.textStr !== t || (n.movedLabel = e.label, s = !0, e.labelPos = n.movedLabel.xy, delete e.label);
                    }), !s && (n.labelPos || r) && (i = n.labelPos || r.xy, n.movedLabel = n.createLabel(t, e, i), n.movedLabel && n.movedLabel.attr({
                        opacity: 0
                    }));
                }
                render(t, e, i) {
                    let n = this.axis, r = n.horiz, s = this.pos, a = p(this.tickmarkOffset, n.tickmarkOffset), l = this.getPosition(r, s, a, e), c = l.x, d = l.y, u = n.pos, f = u + n.len, g = r ? c : d;
                    !n.chart.polar && this.isNew && (o(g) < u || g > f) && (i = 0);
                    let m = p(i, this.label && this.label.newOpacity, 1);
                    i = p(i, 1), this.isActive = !0, this.renderGridLine(e, i), this.renderMark(l, i), this.renderLabel(l, e, m, t), this.isNew = !1, h(this, "afterRender");
                }
                renderGridLine(t, e) {
                    let i, n = this.axis, r = n.options, o = {}, s = this.pos, a = this.type, l = p(this.tickmarkOffset, n.tickmarkOffset), h = n.chart.renderer, c = this.gridLine, d = r.gridLineWidth, u = r.gridLineColor, f = r.gridLineDashStyle;
                    "minor" === this.type && (d = r.minorGridLineWidth, u = r.minorGridLineColor, f = r.minorGridLineDashStyle), c || (n.chart.styledMode || (o.stroke = u, o["stroke-width"] = d || 0, o.dashstyle = f), a || (o.zIndex = 1), t && (e = 0), this.gridLine = c = h.path().attr(o).addClass("highcharts-" + (a ? a + "-" : "") + "grid-line").add(n.gridGroup)), c && (i = n.getPlotLinePath({
                        value: s + l,
                        lineWidth: c.strokeWidth(),
                        force: "pass",
                        old: t,
                        acrossPanes: !1
                    })) && c[t || this.isNew ? "attr" : "animate"]({
                        d: i,
                        opacity: e
                    });
                }
                renderMark(t, e) {
                    let i = this.axis, n = i.options, r = i.chart.renderer, o = this.type, s = i.tickSize(o ? o + "Tick" : "tick"), a = t.x, l = t.y, h = p(n["minor" !== o ? "tickWidth" : "minorTickWidth"], !o && i.isXAxis ? 1 : 0), c = n["minor" !== o ? "tickColor" : "minorTickColor"], d = this.mark, u = !d;
                    s && (i.opposite && (s[0] = -s[0]), d || (this.mark = d = r.path().addClass("highcharts-" + (o ? o + "-" : "") + "tick").add(i.axisGroup), i.chart.styledMode || d.attr({
                        stroke: c,
                        "stroke-width": h
                    })), d[u ? "attr" : "animate"]({
                        d: this.getMarkPath(a, l, s[0], d.strokeWidth(), i.horiz, r),
                        opacity: e
                    }));
                }
                renderLabel(t, e, i, n) {
                    let r = this.axis, o = r.horiz, s = r.options, a = this.label, l = s.labels, h = l.step, d = p(this.tickmarkOffset, r.tickmarkOffset), u = t.x, f = t.y, g = !0;
                    a && c(u) && (a.xy = t = this.getLabelPosition(u, f, a, o, l, d, n, h), this.isFirst && !this.isLast && !s.showFirstLabel || this.isLast && !this.isFirst && !s.showLastLabel ? g = !1 : !o || l.step || l.rotation || e || 0 === i || this.handleOverflow(t), h && n % h && (g = !1), g && c(t.y) ? (t.opacity = i, a[this.isNewLabel ? "attr" : "animate"](t).show(!0), this.isNewLabel = !1) : (a.hide(), this.isNewLabel = !0));
                }
                replaceMovedLabel() {
                    let t = this.label, e = this.axis;
                    t && !this.isNew && (t.animate({
                        opacity: 0
                    }, void 0, t.destroy), delete this.label), e.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
                }
            };
        }), i(e, "Core/Axis/Axis.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Axis/AxisDefaults.js"],
            e["Core/Color/Color.js"],
            e["Core/Defaults.js"],
            e["Core/Foundation.js"],
            e["Core/Globals.js"],
            e["Core/Axis/Tick.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a) {
            let { animObject: l } = t, { xAxis: h, yAxis: c } = e, { defaultOptions: d } = n, { registerEventOptions: u } = r, { deg2rad: p } = o, { arrayMax: f, arrayMin: g, clamp: m, correctFloat: b, defined: y, destroyObjectProperties: x, erase: v, error: w, extend: C, fireEvent: S, getClosestDistance: k, insertItem: A, isArray: E, isNumber: M, isString: T, merge: P, normalizeTickInterval: R, objectEach: L, pick: O, relativeLength: D, removeEvent: j, splat: N, syncTimeout: I } = a, B = (t, e)=>R(e, void 0, void 0, O(t.options.allowDecimals, e < .5 || void 0 !== t.tickAmount), !!t.tickAmount);
            C(d, {
                xAxis: h,
                yAxis: P(h, c)
            });
            class F {
                constructor(t, e, i){
                    this.init(t, e, i);
                }
                init(t, e, i = this.coll) {
                    let n = "xAxis" === i, r = this.isZAxis || (t.inverted ? !n : n);
                    this.chart = t, this.horiz = r, this.isXAxis = n, this.coll = i, S(this, "init", {
                        userOptions: e
                    }), this.opposite = O(e.opposite, this.opposite), this.side = O(e.side, this.side, r ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(e);
                    let o = this.options, s = o.labels;
                    this.type ?? (this.type = o.type || "linear"), this.uniqueNames ?? (this.uniqueNames = o.uniqueNames ?? !0), S(this, "afterSetType"), this.userOptions = e, this.minPixelPadding = 0, this.reversed = O(o.reversed, this.reversed), this.visible = o.visible, this.zoomEnabled = o.zoomEnabled, this.hasNames = "category" === this.type || !0 === o.categories, this.categories = E(o.categories) && o.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = y(o.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len ?? (this.len = 0), this.minRange = this.userMinRange = o.minRange || o.maxZoom, this.range = o.range, this.offset = o.offset || 0, this.max = void 0, this.min = void 0;
                    let a = O(o.crosshair, N(t.options.tooltip.crosshairs)[n ? 0 : 1]);
                    this.crosshair = !0 === a ? {} : a, -1 === t.axes.indexOf(this) && (n ? t.axes.splice(t.xAxis.length, 0, this) : t.axes.push(this), A(this, t[this.coll])), t.orderItems(this.coll), this.series = this.series || [], t.inverted && !this.isZAxis && n && !y(this.reversed) && (this.reversed = !0), this.labelRotation = M(s.rotation) ? s.rotation : void 0, u(this, o), S(this, "afterInit");
                }
                setOptions(t) {
                    let e = this.horiz ? {
                        labels: {
                            autoRotation: [
                                -45
                            ],
                            padding: 4
                        },
                        margin: 15
                    } : {
                        labels: {
                            padding: 1
                        },
                        title: {
                            rotation: 90 * this.side
                        }
                    };
                    this.options = P(e, d[this.coll], t), S(this, "afterSetOptions", {
                        userOptions: t
                    });
                }
                defaultLabelFormatter() {
                    let t, e, i = this.axis, { numberFormatter: n } = this.chart, r = M(this.value) ? this.value : NaN, o = i.chart.time, s = i.categories, a = this.dateTimeLabelFormat, l = d.lang, h = l.numericSymbols, c = l.numericSymbolMagnitude || 1e3, u = i.logarithmic ? Math.abs(r) : i.tickInterval, p = h && h.length;
                    if (s) e = `${this.value}`;
                    else if (a) e = o.dateFormat(a, r);
                    else if (p && h && u >= 1e3) for(; p-- && void 0 === e;)u >= (t = Math.pow(c, p + 1)) && 10 * r % t == 0 && null !== h[p] && 0 !== r && (e = n(r / t, -1) + h[p]);
                    return void 0 === e && (e = Math.abs(r) >= 1e4 ? n(r, -1) : n(r, -1, void 0, "")), e;
                }
                getSeriesExtremes() {
                    let t, e = this;
                    S(this, "getSeriesExtremes", null, function() {
                        e.hasVisibleSeries = !1, e.dataMin = e.dataMax = e.threshold = void 0, e.softThreshold = !e.isXAxis, e.series.forEach((i)=>{
                            if (i.reserveSpace()) {
                                let n, r, o, s = i.options, a = s.threshold;
                                if (e.hasVisibleSeries = !0, e.positiveValuesOnly && 0 >= (a || 0) && (a = void 0), e.isXAxis) (n = i.xData) && n.length && (n = e.logarithmic ? n.filter((t)=>t > 0) : n, r = (t = i.getXExtremes(n)).min, o = t.max, M(r) || r instanceof Date || (n = n.filter(M), r = (t = i.getXExtremes(n)).min, o = t.max), n.length && (e.dataMin = Math.min(O(e.dataMin, r), r), e.dataMax = Math.max(O(e.dataMax, o), o)));
                                else {
                                    let t = i.applyExtremes();
                                    M(t.dataMin) && (r = t.dataMin, e.dataMin = Math.min(O(e.dataMin, r), r)), M(t.dataMax) && (o = t.dataMax, e.dataMax = Math.max(O(e.dataMax, o), o)), y(a) && (e.threshold = a), (!s.softThreshold || e.positiveValuesOnly) && (e.softThreshold = !1);
                                }
                            }
                        });
                    }), S(this, "afterGetSeriesExtremes");
                }
                translate(t, e, i, n, r, o) {
                    let s = this.linkedParent || this, a = n && s.old ? s.old.min : s.min;
                    if (!M(a)) return NaN;
                    let l = s.minPixelPadding, h = (s.isOrdinal || s.brokenAxis?.hasBreaks || s.logarithmic && r) && s.lin2val, c = 1, d = 0, u = n && s.old ? s.old.transA : s.transA, p = 0;
                    return u || (u = s.transA), i && (c *= -1, d = s.len), s.reversed && (c *= -1, d -= c * (s.sector || s.len)), e ? (p = (t = t * c + d - l) / u + a, h && (p = s.lin2val(p))) : (h && (t = s.val2lin(t)), p = c * (t - a) * u + d + c * l + (M(o) ? u * o : 0), s.isRadial || (p = b(p))), p;
                }
                toPixels(t, e) {
                    return this.translate(t, !1, !this.horiz, void 0, !0) + (e ? 0 : this.pos);
                }
                toValue(t, e) {
                    return this.translate(t - (e ? 0 : this.pos), !0, !this.horiz, void 0, !0);
                }
                getPlotLinePath(t) {
                    let e, i, n, r, o, s = this, a = s.chart, l = s.left, h = s.top, c = t.old, d = t.value, u = t.lineWidth, p = c && a.oldChartHeight || a.chartHeight, f = c && a.oldChartWidth || a.chartWidth, g = s.transB, b = t.translatedValue, y = t.force;
                    function x(t, e, i) {
                        return "pass" !== y && (t < e || t > i) && (y ? t = m(t, e, i) : o = !0), t;
                    }
                    let v = {
                        value: d,
                        lineWidth: u,
                        old: c,
                        force: y,
                        acrossPanes: t.acrossPanes,
                        translatedValue: b
                    };
                    return S(this, "getPlotLinePath", v, function(t) {
                        e = n = (b = m(b = O(b, s.translate(d, void 0, void 0, c)), -1000000000, 1e9)) + g, i = r = p - b - g, M(b) ? s.horiz ? (i = h, r = p - s.bottom + (s.options.isInternal ? 0 : a.scrollablePixelsY || 0), e = n = x(e, l, l + s.width)) : (e = l, n = f - s.right + (a.scrollablePixelsX || 0), i = r = x(i, h, h + s.height)) : (o = !0, y = !1), t.path = o && !y ? void 0 : a.renderer.crispLine([
                            [
                                "M",
                                e,
                                i
                            ],
                            [
                                "L",
                                n,
                                r
                            ]
                        ], u || 1);
                    }), v.path;
                }
                getLinearTickPositions(t, e, i) {
                    let n, r, o, s = b(Math.floor(e / t) * t), a = b(Math.ceil(i / t) * t), l = [];
                    if (b(s + t) === s && (o = 20), this.single) return [
                        e
                    ];
                    for(n = s; n <= a && (l.push(n), (n = b(n + t, o)) !== r);)r = n;
                    return l;
                }
                getMinorTickInterval() {
                    let { minorTicks: t, minorTickInterval: e } = this.options;
                    return !0 === t ? O(e, "auto") : !1 !== t ? e : void 0;
                }
                getMinorTickPositions() {
                    let t, e = this.options, i = this.tickPositions, n = this.minorTickInterval, r = this.pointRangePadding || 0, o = (this.min || 0) - r, s = (this.max || 0) + r, a = s - o, l = [];
                    if (a && a / n < this.len / 3) {
                        let r = this.logarithmic;
                        if (r) this.paddedTicks.forEach(function(t, e, i) {
                            e && l.push.apply(l, r.getLogTickPositions(n, i[e - 1], i[e], !0));
                        });
                        else if (this.dateTime && "auto" === this.getMinorTickInterval()) l = l.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(n), o, s, e.startOfWeek));
                        else for(t = o + (i[0] - o) % n; t <= s && t !== l[0]; t += n)l.push(t);
                    }
                    return 0 !== l.length && this.trimTicks(l), l;
                }
                adjustForMinRange() {
                    let t, e, i, n, r = this.options, o = this.logarithmic, { max: s, min: a, minRange: l } = this;
                    this.isXAxis && void 0 === l && !o && (l = y(r.min) || y(r.max) || y(r.floor) || y(r.ceiling) ? null : Math.min(5 * (k(this.series.map((t)=>(t.xIncrement ? t.xData?.slice(0, 2) : t.xData) || [])) || 0), this.dataMax - this.dataMin)), M(s) && M(a) && M(l) && s - a < l && (e = this.dataMax - this.dataMin >= l, t = (l - s + a) / 2, i = [
                        a - t,
                        O(r.min, a - t)
                    ], e && (i[2] = o ? o.log2lin(this.dataMin) : this.dataMin), n = [
                        (a = f(i)) + l,
                        O(r.max, a + l)
                    ], e && (n[2] = o ? o.log2lin(this.dataMax) : this.dataMax), (s = g(n)) - a < l && (i[0] = s - l, i[1] = O(r.min, s - l), a = f(i))), this.minRange = l, this.min = a, this.max = s;
                }
                getClosest() {
                    let t, e;
                    if (this.categories) e = 1;
                    else {
                        let i = [];
                        this.series.forEach(function(t) {
                            let n = t.closestPointRange;
                            1 === t.xData?.length ? i.push(t.xData[0]) : !t.noSharedTooltip && y(n) && t.reserveSpace() && (e = y(e) ? Math.min(e, n) : n);
                        }), i.length && (i.sort((t, e)=>t - e), t = k([
                            i
                        ]));
                    }
                    return t && e ? Math.min(t, e) : t || e;
                }
                nameToX(t) {
                    let e, i = E(this.options.categories), n = i ? this.categories : this.names, r = t.options.x;
                    return t.series.requireSorting = !1, y(r) || (r = this.uniqueNames && n ? i ? n.indexOf(t.name) : O(n.keys[t.name], -1) : t.series.autoIncrement()), -1 === r ? !i && n && (e = n.length) : e = r, void 0 !== e ? (this.names[e] = t.name, this.names.keys[t.name] = e) : t.x && (e = t.x), e;
                }
                updateNames() {
                    let t = this, e = this.names;
                    e.length > 0 && (Object.keys(e.keys).forEach(function(t) {
                        delete e.keys[t];
                    }), e.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((e)=>{
                        e.xIncrement = null, (!e.points || e.isDirtyData) && (t.max = Math.max(t.max, e.xData.length - 1), e.processData(), e.generatePoints()), e.data.forEach(function(i, n) {
                            let r;
                            i?.options && void 0 !== i.name && void 0 !== (r = t.nameToX(i)) && r !== i.x && (i.x = r, e.xData[n] = r);
                        });
                    }));
                }
                setAxisTranslation() {
                    let t, e, i = this, n = i.max - i.min, r = i.linkedParent, o = !!i.categories, s = i.isXAxis, a = i.axisPointRange || 0, l = 0, h = 0, c = i.transA;
                    (s || o || a) && (t = i.getClosest(), r ? (l = r.minPointOffset, h = r.pointRangePadding) : i.series.forEach(function(e) {
                        let n = o ? 1 : s ? O(e.options.pointRange, t, 0) : i.axisPointRange || 0, r = e.options.pointPlacement;
                        if (a = Math.max(a, n), !i.single || o) {
                            let t = e.is("xrange") ? !s : s;
                            l = Math.max(l, t && T(r) ? 0 : n / 2), h = Math.max(h, t && "on" === r ? 0 : n);
                        }
                    }), e = i.ordinal && i.ordinal.slope && t ? i.ordinal.slope / t : 1, i.minPointOffset = l *= e, i.pointRangePadding = h *= e, i.pointRange = Math.min(a, i.single && o ? 1 : n), s && t && (i.closestPointRange = t)), i.translationSlope = i.transA = c = i.staticScale || i.len / (n + h || 1), i.transB = i.horiz ? i.left : i.bottom, i.minPixelPadding = c * l, S(this, "afterSetAxisTranslation");
                }
                minFromRange() {
                    let { max: t, min: e } = this;
                    return M(t) && M(e) && t - e || void 0;
                }
                setTickInterval(t) {
                    let e, i, n, r, o, { categories: s, chart: a, dataMax: l, dataMin: h, dateTime: c, isXAxis: d, logarithmic: u, options: p, softThreshold: f } = this, g = M(this.threshold) ? this.threshold : void 0, m = this.minRange || 0, { ceiling: x, floor: v, linkedTo: C, softMax: k, softMin: A } = p, E = M(C) && a[this.coll]?.[C], T = p.tickPixelInterval, P = p.maxPadding, R = p.minPadding, L = 0, D = M(p.tickInterval) && p.tickInterval >= 0 ? p.tickInterval : void 0;
                    if (c || s || E || this.getTickAmount(), r = O(this.userMin, p.min), o = O(this.userMax, p.max), E ? (this.linkedParent = E, e = E.getExtremes(), this.min = O(e.min, e.dataMin), this.max = O(e.max, e.dataMax), this.type !== E.type && w(11, !0, a)) : (f && y(g) && M(l) && M(h) && (h >= g ? (i = g, R = 0) : l <= g && (n = g, P = 0)), this.min = O(r, i, h), this.max = O(o, n, l)), M(this.max) && M(this.min) && (u && (this.positiveValuesOnly && !t && 0 >= Math.min(this.min, O(h, this.min)) && w(10, !0, a), this.min = b(u.log2lin(this.min), 16), this.max = b(u.log2lin(this.max), 16)), this.range && M(h) && (this.userMin = this.min = r = Math.max(h, this.minFromRange() || 0), this.userMax = o = this.max, this.range = void 0)), S(this, "foundExtremes"), this.adjustForMinRange(), M(this.min) && M(this.max)) {
                        if (!M(this.userMin) && M(A) && A < this.min && (this.min = r = A), !M(this.userMax) && M(k) && k > this.max && (this.max = o = k), s || this.axisPointRange || this.stacking?.usePercentage || E || !(L = this.max - this.min) || (!y(r) && R && (this.min -= L * R), y(o) || !P || (this.max += L * P)), !M(this.userMin) && M(v) && (this.min = Math.max(this.min, v)), !M(this.userMax) && M(x) && (this.max = Math.min(this.max, x)), f && M(h) && M(l)) {
                            let t = g || 0;
                            !y(r) && this.min < t && h >= t ? this.min = p.minRange ? Math.min(t, this.max - m) : t : !y(o) && this.max > t && l <= t && (this.max = p.minRange ? Math.max(t, this.min + m) : t);
                        }
                        !a.polar && this.min > this.max && (y(p.min) ? this.max = this.min : y(p.max) && (this.min = this.max)), L = this.max - this.min;
                    }
                    if (this.min !== this.max && M(this.min) && M(this.max) ? E && !D && T === E.options.tickPixelInterval ? this.tickInterval = D = E.tickInterval : this.tickInterval = O(D, this.tickAmount ? L / Math.max(this.tickAmount - 1, 1) : void 0, s ? 1 : L * T / Math.max(this.len, T)) : this.tickInterval = 1, d && !t) {
                        let t = this.min !== this.old?.min || this.max !== this.old?.max;
                        this.series.forEach(function(e) {
                            e.forceCrop = e.forceCropping?.(), e.processData(t);
                        }), S(this, "postProcessData", {
                            hasExtremesChanged: t
                        });
                    }
                    this.setAxisTranslation(), S(this, "initialAxisTranslation"), this.pointRange && !D && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
                    let j = O(p.minTickInterval, c && !this.series.some((t)=>t.noSharedTooltip) ? this.closestPointRange : 0);
                    !D && this.tickInterval < j && (this.tickInterval = j), c || u || D || (this.tickInterval = B(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
                }
                setTickPositions() {
                    let t, e = this.options, i = e.tickPositions, n = e.tickPositioner, r = this.getMinorTickInterval(), o = !this.isPanning, s = o && e.startOnTick, a = o && e.endOnTick, l = [];
                    if (this.tickmarkOffset = this.categories && "between" === e.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0, this.single = this.min === this.max && y(this.min) && !this.tickAmount && (this.min % 1 == 0 || !1 !== e.allowDecimals), i) l = i.slice();
                    else if (M(this.min) && M(this.max)) {
                        if (!this.ordinal?.positions && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) l = [
                            this.min,
                            this.max
                        ], w(19, !1, this.chart);
                        else if (this.dateTime) l = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, e.units), this.min, this.max, e.startOfWeek, this.ordinal?.positions, this.closestPointRange, !0);
                        else if (this.logarithmic) l = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
                        else {
                            let t = this.tickInterval, e = t;
                            for(; e <= 2 * t && (l = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && l.length > this.tickAmount);)this.tickInterval = B(this, e *= 1.1);
                        }
                        l.length > this.len && (l = [
                            l[0],
                            l[l.length - 1]
                        ])[0] === l[1] && (l.length = 1), n && (this.tickPositions = l, (t = n.apply(this, [
                            this.min,
                            this.max
                        ])) && (l = t));
                    }
                    this.tickPositions = l, this.minorTickInterval = "auto" === r && this.tickInterval ? this.tickInterval / e.minorTicksPerMajor : r, this.paddedTicks = l.slice(0), this.trimTicks(l, s, a), !this.isLinked && M(this.min) && M(this.max) && (this.single && l.length < 2 && !this.categories && !this.series.some((t)=>t.is("heatmap") && "between" === t.options.pointPlacement) && (this.min -= .5, this.max += .5), i || t || this.adjustTickAmount()), S(this, "afterSetTickPositions");
                }
                trimTicks(t, e, i) {
                    let n = t[0], r = t[t.length - 1], o = !this.isOrdinal && this.minPointOffset || 0;
                    if (S(this, "trimTicks"), !this.isLinked) {
                        if (e && n !== -1 / 0) this.min = n;
                        else for(; this.min - o > t[0];)t.shift();
                        if (i) this.max = r;
                        else for(; this.max + o < t[t.length - 1];)t.pop();
                        0 === t.length && y(n) && !this.options.tickPositions && t.push((r + n) / 2);
                    }
                }
                alignToOthers() {
                    let t, e = this, i = e.chart, n = [
                        this
                    ], r = e.options, o = i.options.chart, s = "yAxis" === this.coll && o.alignThresholds, a = [];
                    if (e.thresholdAlignment = void 0, (!1 !== o.alignTicks && r.alignTicks || s) && !1 !== r.startOnTick && !1 !== r.endOnTick && !e.logarithmic) {
                        let r = (t)=>{
                            let { horiz: e, options: i } = t;
                            return [
                                e ? i.left : i.top,
                                i.width,
                                i.height,
                                i.pane
                            ].join(",");
                        }, o = r(this);
                        i[this.coll].forEach(function(i) {
                            let { series: s } = i;
                            s.length && s.some((t)=>t.visible) && i !== e && r(i) === o && (t = !0, n.push(i));
                        });
                    }
                    if (t && s) {
                        n.forEach((t)=>{
                            let i = t.getThresholdAlignment(e);
                            M(i) && a.push(i);
                        });
                        let t = a.length > 1 ? a.reduce((t, e)=>t + e, 0) / a.length : void 0;
                        n.forEach((e)=>{
                            e.thresholdAlignment = t;
                        });
                    }
                    return t;
                }
                getThresholdAlignment(t) {
                    if ((!M(this.dataMin) || this !== t && this.series.some((t)=>t.isDirty || t.isDirtyData)) && this.getSeriesExtremes(), M(this.threshold)) {
                        let t = m((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
                        return this.options.reversed && (t = 1 - t), t;
                    }
                }
                getTickAmount() {
                    let t = this.options, e = t.tickPixelInterval, i = t.tickAmount;
                    y(t.tickInterval) || i || !(this.len < e) || this.isRadial || this.logarithmic || !t.startOnTick || !t.endOnTick || (i = 2), !i && this.alignToOthers() && (i = Math.ceil(this.len / e) + 1), i < 4 && (this.finalTickAmt = i, i = 5), this.tickAmount = i;
                }
                adjustTickAmount() {
                    let t, e, i, n = this, { finalTickAmt: r, max: o, min: s, options: a, tickPositions: l, tickAmount: h, thresholdAlignment: c } = n, d = l?.length, u = O(n.threshold, n.softThreshold ? 0 : null), p = n.tickInterval, f = ()=>l.push(b(l[l.length - 1] + p)), g = ()=>l.unshift(b(l[0] - p));
                    if (M(c) && (i = c < .5 ? Math.ceil(c * (h - 1)) : Math.floor(c * (h - 1)), a.reversed && (i = h - 1 - i)), n.hasData() && M(s) && M(o)) {
                        let c = ()=>{
                            n.transA *= (d - 1) / (h - 1), n.min = a.startOnTick ? l[0] : Math.min(s, l[0]), n.max = a.endOnTick ? l[l.length - 1] : Math.max(o, l[l.length - 1]);
                        };
                        if (M(i) && M(n.threshold)) {
                            for(; l[i] !== u || l.length !== h || l[0] > s || l[l.length - 1] < o;){
                                for(l.length = 0, l.push(n.threshold); l.length < h;)void 0 === l[i] || l[i] > n.threshold ? g() : f();
                                if (p > 8 * n.tickInterval) break;
                                p *= 2;
                            }
                            c();
                        } else if (d < h) {
                            for(; l.length < h;)l.length % 2 || s === u ? f() : g();
                            c();
                        }
                        if (y(r)) {
                            for(e = t = l.length; e--;)(3 === r && e % 2 == 1 || r <= 2 && e > 0 && e < t - 1) && l.splice(e, 1);
                            n.finalTickAmt = void 0;
                        }
                    }
                }
                setScale() {
                    let { coll: t, stacking: e } = this, i = !1, n = !1;
                    this.series.forEach((t)=>{
                        i = i || t.isDirtyData || t.isDirty, n = n || t.xAxis && t.xAxis.isDirty || !1;
                    }), this.setAxisSize();
                    let r = this.len !== (this.old && this.old.len);
                    r || i || n || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (e && "yAxis" === t && e.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), e && "xAxis" === t && e.buildStacks(), this.isDirty || (this.isDirty = r || this.min !== this.old?.min || this.max !== this.old?.max)) : e && e.cleanStacks(), i && delete this.allExtremes, S(this, "afterSetScale");
                }
                setExtremes(t, e, i = !0, n, r) {
                    this.series.forEach((t)=>{
                        delete t.kdTree;
                    }), S(this, "setExtremes", r = C(r, {
                        min: t,
                        max: e
                    }), (t)=>{
                        this.userMin = t.min, this.userMax = t.max, this.eventArgs = t, i && this.chart.redraw(n);
                    });
                }
                setAxisSize() {
                    let t = this.chart, e = this.options, i = e.offsets || [
                        0,
                        0,
                        0,
                        0
                    ], n = this.horiz, r = this.width = Math.round(D(O(e.width, t.plotWidth - i[3] + i[1]), t.plotWidth)), o = this.height = Math.round(D(O(e.height, t.plotHeight - i[0] + i[2]), t.plotHeight)), s = this.top = Math.round(D(O(e.top, t.plotTop + i[0]), t.plotHeight, t.plotTop)), a = this.left = Math.round(D(O(e.left, t.plotLeft + i[3]), t.plotWidth, t.plotLeft));
                    this.bottom = t.chartHeight - o - s, this.right = t.chartWidth - r - a, this.len = Math.max(n ? r : o, 0), this.pos = n ? a : s;
                }
                getExtremes() {
                    let t = this.logarithmic;
                    return {
                        min: t ? b(t.lin2log(this.min)) : this.min,
                        max: t ? b(t.lin2log(this.max)) : this.max,
                        dataMin: this.dataMin,
                        dataMax: this.dataMax,
                        userMin: this.userMin,
                        userMax: this.userMax
                    };
                }
                getThreshold(t) {
                    let e = this.logarithmic, i = e ? e.lin2log(this.min) : this.min, n = e ? e.lin2log(this.max) : this.max;
                    return null === t || t === -1 / 0 ? t = i : t === 1 / 0 ? t = n : i > t ? t = i : n < t && (t = n), this.translate(t, 0, 1, 0, 1);
                }
                autoLabelAlign(t) {
                    let e = (O(t, 0) - 90 * this.side + 720) % 360, i = {
                        align: "center"
                    };
                    return S(this, "autoLabelAlign", i, function(t) {
                        e > 15 && e < 165 ? t.align = "right" : e > 195 && e < 345 && (t.align = "left");
                    }), i.align;
                }
                tickSize(t) {
                    let e, i = this.options, n = O(i["tick" === t ? "tickWidth" : "minorTickWidth"], "tick" === t && this.isXAxis && !this.categories ? 1 : 0), r = i["tick" === t ? "tickLength" : "minorTickLength"];
                    n && r && ("inside" === i[t + "Position"] && (r = -r), e = [
                        r,
                        n
                    ]);
                    let o = {
                        tickSize: e
                    };
                    return S(this, "afterTickSize", o), o.tickSize;
                }
                labelMetrics() {
                    let t = this.chart.renderer, e = this.ticks, i = e[Object.keys(e)[0]] || {};
                    return this.chart.renderer.fontMetrics(i.label || i.movedLabel || t.box);
                }
                unsquish() {
                    let t, e, i = this.options.labels, n = i.padding || 0, r = this.horiz, o = this.tickInterval, s = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / o), a = i.rotation, l = b(.8 * this.labelMetrics().h), h = Math.max(this.max - this.min, 0), c = function(t) {
                        let e = (t + 2 * n) / (s || 1);
                        return (e = e > 1 ? Math.ceil(e) : 1) * o > h && t !== 1 / 0 && s !== 1 / 0 && h && (e = Math.ceil(h / o)), b(e * o);
                    }, d = o, u = Number.MAX_VALUE;
                    if (r) {
                        if (!i.staggerLines && (M(a) ? e = [
                            a
                        ] : s < i.autoRotationLimit && (e = i.autoRotation)), e) {
                            let i, n;
                            for (let r of e)(r === a || r && r >= -90 && r <= 90) && (n = (i = c(Math.abs(l / Math.sin(p * r)))) + Math.abs(r / 360)) < u && (u = n, t = r, d = i);
                        }
                    } else d = c(.75 * l);
                    return this.autoRotation = e, this.labelRotation = O(t, M(a) ? a : 0), i.step ? o : d;
                }
                getSlotWidth(t) {
                    let e = this.chart, i = this.horiz, n = this.options.labels, r = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), o = e.margin[3];
                    if (t && M(t.slotWidth)) return t.slotWidth;
                    if (i && n.step < 2) return n.rotation ? 0 : (this.staggerLines || 1) * this.len / r;
                    if (!i) {
                        let t = n.style.width;
                        if (void 0 !== t) return parseInt(String(t), 10);
                        if (o) return o - e.spacing[3];
                    }
                    return .33 * e.chartWidth;
                }
                renderUnsquish() {
                    let t, e, i, n, r = this.chart, o = r.renderer, s = this.tickPositions, a = this.ticks, l = this.options.labels, h = l.style, c = this.horiz, d = this.getSlotWidth(), u = Math.max(1, Math.round(d - (c ? 2 * (l.padding || 0) : l.distance || 0))), p = {}, f = this.labelMetrics(), g = h.textOverflow, m = 0;
                    if (T(l.rotation) || (p.rotation = l.rotation || 0), s.forEach(function(t) {
                        let e = a[t];
                        e.movedLabel && e.replaceMovedLabel(), e && e.label && e.label.textPxLength > m && (m = e.label.textPxLength);
                    }), this.maxLabelLength = m, this.autoRotation) m > u && m > f.h ? p.rotation = this.labelRotation : this.labelRotation = 0;
                    else if (d && (t = u, !g)) for(e = "clip", n = s.length; !c && n--;)(i = a[s[n]].label) && ("ellipsis" === i.styles.textOverflow ? i.css({
                        textOverflow: "clip"
                    }) : i.textPxLength > d && i.css({
                        width: d + "px"
                    }), i.getBBox().height > this.len / s.length - (f.h - f.f) && (i.specificTextOverflow = "ellipsis"));
                    p.rotation && (t = m > .5 * r.chartHeight ? .33 * r.chartHeight : m, g || (e = "ellipsis")), this.labelAlign = l.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (p.align = this.labelAlign), s.forEach(function(i) {
                        let n = a[i], r = n && n.label, o = h.width, s = {};
                        r && (r.attr(p), n.shortenLabel ? n.shortenLabel() : t && !o && "nowrap" !== h.whiteSpace && (t < r.textPxLength || "SPAN" === r.element.tagName) ? (s.width = t + "px", g || (s.textOverflow = r.specificTextOverflow || e), r.css(s)) : !r.styles.width || s.width || o || r.css({
                            width: null
                        }), delete r.specificTextOverflow, n.rotation = p.rotation);
                    }, this), this.tickRotCorr = o.rotCorr(f.b, this.labelRotation || 0, 0 !== this.side);
                }
                hasData() {
                    return this.series.some(function(t) {
                        return t.hasData();
                    }) || this.options.showEmpty && y(this.min) && y(this.max);
                }
                addTitle(t) {
                    let e, i = this.chart.renderer, n = this.horiz, r = this.opposite, o = this.options.title, s = this.chart.styledMode;
                    this.axisTitle || ((e = o.textAlign) || (e = (n ? {
                        low: "left",
                        middle: "center",
                        high: "right"
                    } : {
                        low: r ? "right" : "left",
                        middle: "center",
                        high: r ? "left" : "right"
                    })[o.align]), this.axisTitle = i.text(o.text || "", 0, 0, o.useHTML).attr({
                        zIndex: 7,
                        rotation: o.rotation || 0,
                        align: e
                    }).addClass("highcharts-axis-title"), s || this.axisTitle.css(P(o.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), s || o.style.width || this.isRadial || this.axisTitle.css({
                        width: this.len + "px"
                    }), this.axisTitle[t ? "show" : "hide"](t);
                }
                generateTick(t) {
                    let e = this.ticks;
                    e[t] ? e[t].addLabel() : e[t] = new s(this, t);
                }
                createGroups() {
                    let { axisParent: t, chart: e, coll: i, options: n } = this, r = e.renderer, o = (e, o, s)=>r.g(e).attr({
                            zIndex: s
                        }).addClass(`highcharts-${i.toLowerCase()}${o} ` + (this.isRadial ? `highcharts-radial-axis${o} ` : "") + (n.className || "")).add(t);
                    this.axisGroup || (this.gridGroup = o("grid", "-grid", n.gridZIndex), this.axisGroup = o("axis", "", n.zIndex), this.labelGroup = o("axis-labels", "-labels", n.labels.zIndex));
                }
                getOffset() {
                    let t, e, i, n, r = this, { chart: o, horiz: s, options: a, side: l, ticks: h, tickPositions: c, coll: d } = r, u = o.inverted && !r.isZAxis ? [
                        1,
                        0,
                        3,
                        2
                    ][l] : l, p = r.hasData(), f = a.title, g = a.labels, m = M(a.crossing), b = o.axisOffset, x = o.clipOffset, v = [
                        -1,
                        1,
                        1,
                        -1
                    ][l], w = 0, C = 0, k = 0;
                    if (r.showAxis = t = p || a.showEmpty, r.staggerLines = r.horiz && g.staggerLines || void 0, r.createGroups(), p || r.isLinked ? (c.forEach(function(t) {
                        r.generateTick(t);
                    }), r.renderUnsquish(), r.reserveSpaceDefault = 0 === l || 2 === l || ({
                        1: "left",
                        3: "right"
                    })[l] === r.labelAlign, O(g.reserveSpace, !m && null, "center" === r.labelAlign || null, r.reserveSpaceDefault) && c.forEach(function(t) {
                        k = Math.max(h[t].getLabelSize(), k);
                    }), r.staggerLines && (k *= r.staggerLines), r.labelOffset = k * (r.opposite ? -1 : 1)) : L(h, function(t, e) {
                        t.destroy(), delete h[e];
                    }), f?.text && !1 !== f.enabled && (r.addTitle(t), t && !m && !1 !== f.reserveSpace && (r.titleOffset = w = r.axisTitle.getBBox()[s ? "height" : "width"], C = y(e = f.offset) ? 0 : O(f.margin, s ? 5 : 10))), r.renderLine(), r.offset = v * O(a.offset, b[l] ? b[l] + (a.margin || 0) : 0), r.tickRotCorr = r.tickRotCorr || {
                        x: 0,
                        y: 0
                    }, n = 0 === l ? -r.labelMetrics().h : 2 === l ? r.tickRotCorr.y : 0, i = Math.abs(k) + C, k && (i -= n, i += v * (s ? O(g.y, r.tickRotCorr.y + v * g.distance) : O(g.x, v * g.distance))), r.axisTitleMargin = O(e, i), r.getMaxLabelDimensions && (r.maxLabelDimensions = r.getMaxLabelDimensions(h, c)), "colorAxis" !== d && x) {
                        let t = this.tickSize("tick");
                        b[l] = Math.max(b[l], (r.axisTitleMargin || 0) + w + v * r.offset, i, c && c.length && t ? t[0] + v * r.offset : 0);
                        let e = !r.axisLine || a.offset ? 0 : r.axisLine.strokeWidth() / 2;
                        x[u] = Math.max(x[u], e);
                    }
                    S(this, "afterGetOffset");
                }
                getLinePath(t) {
                    let e = this.chart, i = this.opposite, n = this.offset, r = this.horiz, o = this.left + (i ? this.width : 0) + n, s = e.chartHeight - this.bottom - (i ? this.height : 0) + n;
                    return i && (t *= -1), e.renderer.crispLine([
                        [
                            "M",
                            r ? this.left : o,
                            r ? s : this.top
                        ],
                        [
                            "L",
                            r ? e.chartWidth - this.right : o,
                            r ? s : e.chartHeight - this.bottom
                        ]
                    ], t);
                }
                renderLine() {
                    this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
                        stroke: this.options.lineColor,
                        "stroke-width": this.options.lineWidth,
                        zIndex: 7
                    }));
                }
                getTitlePosition(t) {
                    let e = this.horiz, i = this.left, n = this.top, r = this.len, o = this.options.title, s = e ? i : n, a = this.opposite, l = this.offset, h = o.x, c = o.y, d = this.chart.renderer.fontMetrics(t), u = t ? Math.max(t.getBBox(!1, 0).height - d.h - 1, 0) : 0, p = {
                        low: s + (e ? 0 : r),
                        middle: s + r / 2,
                        high: s + (e ? r : 0)
                    }[o.align], f = (e ? n + this.height : i) + (e ? 1 : -1) * (a ? -1 : 1) * (this.axisTitleMargin || 0) + [
                        -u,
                        u,
                        d.f,
                        -u
                    ][this.side], g = {
                        x: e ? p + h : f + (a ? this.width : 0) + l + h,
                        y: e ? f + c - (a ? this.height : 0) + l : p + c
                    };
                    return S(this, "afterGetTitlePosition", {
                        titlePosition: g
                    }), g;
                }
                renderMinorTick(t, e) {
                    let i = this.minorTicks;
                    i[t] || (i[t] = new s(this, t, "minor")), e && i[t].isNew && i[t].render(null, !0), i[t].render(null, !1, 1);
                }
                renderTick(t, e, i) {
                    let n = this.isLinked, r = this.ticks;
                    (!n || t >= this.min && t <= this.max || this.grid && this.grid.isColumn) && (r[t] || (r[t] = new s(this, t)), i && r[t].isNew && r[t].render(e, !0, -1), r[t].render(e));
                }
                render() {
                    let t, e, i = this, n = i.chart, r = i.logarithmic, a = n.renderer, h = i.options, c = i.isLinked, d = i.tickPositions, u = i.axisTitle, p = i.ticks, f = i.minorTicks, g = i.alternateBands, m = h.stackLabels, b = h.alternateGridColor, y = h.crossing, x = i.tickmarkOffset, v = i.axisLine, w = i.showAxis, C = l(a.globalAnimation);
                    if (i.labelEdge.length = 0, i.overlap = !1, [
                        p,
                        f,
                        g
                    ].forEach(function(t) {
                        L(t, function(t) {
                            t.isActive = !1;
                        });
                    }), M(y)) {
                        let t = this.isXAxis ? n.yAxis[0] : n.xAxis[0], e = [
                            1,
                            -1,
                            -1,
                            1
                        ][this.side];
                        if (t) {
                            let n = t.toPixels(y, !0);
                            i.horiz && (n = t.len - n), i.offset = e * n;
                        }
                    }
                    if (i.hasData() || c) {
                        let a = i.chart.hasRendered && i.old && M(i.old.min);
                        i.minorTickInterval && !i.categories && i.getMinorTickPositions().forEach(function(t) {
                            i.renderMinorTick(t, a);
                        }), d.length && (d.forEach(function(t, e) {
                            i.renderTick(t, e, a);
                        }), x && (0 === i.min || i.single) && (p[-1] || (p[-1] = new s(i, -1, null, !0)), p[-1].render(-1))), b && d.forEach(function(s, a) {
                            e = void 0 !== d[a + 1] ? d[a + 1] + x : i.max - x, a % 2 == 0 && s < i.max && e <= i.max + (n.polar ? -x : x) && (g[s] || (g[s] = new o.PlotLineOrBand(i, {})), t = s + x, g[s].options = {
                                from: r ? r.lin2log(t) : t,
                                to: r ? r.lin2log(e) : e,
                                color: b,
                                className: "highcharts-alternate-grid"
                            }, g[s].render(), g[s].isActive = !0);
                        }), i._addedPlotLB || (i._addedPlotLB = !0, (h.plotLines || []).concat(h.plotBands || []).forEach(function(t) {
                            i.addPlotBandOrLine(t);
                        }));
                    }
                    [
                        p,
                        f,
                        g
                    ].forEach(function(t) {
                        let e = [], i = C.duration;
                        L(t, function(t, i) {
                            t.isActive || (t.render(i, !1, 0), t.isActive = !1, e.push(i));
                        }), I(function() {
                            let i = e.length;
                            for(; i--;)t[e[i]] && !t[e[i]].isActive && (t[e[i]].destroy(), delete t[e[i]]);
                        }, t !== g && n.hasRendered && i ? i : 0);
                    }), v && (v[v.isPlaced ? "animate" : "attr"]({
                        d: this.getLinePath(v.strokeWidth())
                    }), v.isPlaced = !0, v[w ? "show" : "hide"](w)), u && w && (u[u.isNew ? "attr" : "animate"](i.getTitlePosition(u)), u.isNew = !1), m && m.enabled && i.stacking && i.stacking.renderStackTotals(), i.old = {
                        len: i.len,
                        max: i.max,
                        min: i.min,
                        transA: i.transA,
                        userMax: i.userMax,
                        userMin: i.userMin
                    }, i.isDirty = !1, S(this, "afterRender");
                }
                redraw() {
                    this.visible && (this.render(), this.plotLinesAndBands.forEach(function(t) {
                        t.render();
                    })), this.series.forEach(function(t) {
                        t.isDirty = !0;
                    });
                }
                getKeepProps() {
                    return this.keepProps || F.keepProps;
                }
                destroy(t) {
                    let e = this, i = e.plotLinesAndBands, n = this.eventOptions;
                    if (S(this, "destroy", {
                        keepEvents: t
                    }), t || j(e), [
                        e.ticks,
                        e.minorTicks,
                        e.alternateBands
                    ].forEach(function(t) {
                        x(t);
                    }), i) {
                        let t = i.length;
                        for(; t--;)i[t].destroy();
                    }
                    for(let t in [
                        "axisLine",
                        "axisTitle",
                        "axisGroup",
                        "gridGroup",
                        "labelGroup",
                        "cross",
                        "scrollbar"
                    ].forEach(function(t) {
                        e[t] && (e[t] = e[t].destroy());
                    }), e.plotLinesAndBandsGroups)e.plotLinesAndBandsGroups[t] = e.plotLinesAndBandsGroups[t].destroy();
                    L(e, function(t, i) {
                        -1 === e.getKeepProps().indexOf(i) && delete e[i];
                    }), this.eventOptions = n;
                }
                drawCrosshair(t, e) {
                    let n, r, o, s, a = this.crosshair, l = O(a && a.snap, !0), h = this.chart, c = this.cross;
                    if (S(this, "drawCrosshair", {
                        e: t,
                        point: e
                    }), t || (t = this.cross && this.cross.e), a && !1 !== (y(e) || !l)) {
                        if (l ? y(e) && (r = O("colorAxis" !== this.coll ? e.crosshairPos : null, this.isXAxis ? e.plotX : this.len - e.plotY)) : r = t && (this.horiz ? t.chartX - this.pos : this.len - t.chartY + this.pos), y(r) && (s = {
                            value: e && (this.isXAxis ? e.x : O(e.stackY, e.y)),
                            translatedValue: r
                        }, h.polar && C(s, {
                            isCrosshair: !0,
                            chartX: t && t.chartX,
                            chartY: t && t.chartY,
                            point: e
                        }), n = this.getPlotLinePath(s) || null), !y(n)) return void this.hideCrosshair();
                        o = this.categories && !this.isRadial, c || (this.cross = c = h.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (o ? "category " : "thin ") + (a.className || "")).attr({
                            zIndex: O(a.zIndex, 2)
                        }).add(), !h.styledMode && (c.attr({
                            stroke: a.color || (o ? i.parse("#ccd3ff").setOpacity(.25).get() : "#cccccc"),
                            "stroke-width": O(a.width, 1)
                        }).css({
                            "pointer-events": "none"
                        }), a.dashStyle && c.attr({
                            dashstyle: a.dashStyle
                        }))), c.show().attr({
                            d: n
                        }), o && !a.width && c.attr({
                            "stroke-width": this.transA
                        }), this.cross.e = t;
                    } else this.hideCrosshair();
                    S(this, "afterDrawCrosshair", {
                        e: t,
                        point: e
                    });
                }
                hideCrosshair() {
                    this.cross && this.cross.hide(), S(this, "afterHideCrosshair");
                }
                update(t, e) {
                    let i = this.chart;
                    t = P(this.userOptions, t), this.destroy(!0), this.init(i, t), i.isDirtyBox = !0, O(e, !0) && i.redraw();
                }
                remove(t) {
                    let e = this.chart, i = this.coll, n = this.series, r = n.length;
                    for(; r--;)n[r] && n[r].remove(!1);
                    v(e.axes, this), v(e[i] || [], this), e.orderItems(i), this.destroy(), e.isDirtyBox = !0, O(t, !0) && e.redraw();
                }
                setTitle(t, e) {
                    this.update({
                        title: t
                    }, e);
                }
                setCategories(t, e) {
                    this.update({
                        categories: t
                    }, e);
                }
            }
            return F.keepProps = [
                "coll",
                "extKey",
                "hcEvents",
                "len",
                "names",
                "series",
                "userMax",
                "userMin"
            ], F;
        }), i(e, "Core/Axis/DateTimeAxis.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            var e;
            let { addEvent: i, getMagnitude: n, normalizeTickInterval: r, timeUnits: o } = t;
            return function(t) {
                function e() {
                    return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
                }
                function s() {
                    "datetime" === this.type ? this.dateTime || (this.dateTime = new a(this)) : this.dateTime = void 0;
                }
                t.compose = function(t) {
                    return t.keepProps.includes("dateTime") || (t.keepProps.push("dateTime"), t.prototype.getTimeTicks = e, i(t, "afterSetType", s)), t;
                };
                class a {
                    constructor(t){
                        this.axis = t;
                    }
                    normalizeTimeTickInterval(t, e) {
                        let i, s = e || [
                            [
                                "millisecond",
                                [
                                    1,
                                    2,
                                    5,
                                    10,
                                    20,
                                    25,
                                    50,
                                    100,
                                    200,
                                    500
                                ]
                            ],
                            [
                                "second",
                                [
                                    1,
                                    2,
                                    5,
                                    10,
                                    15,
                                    30
                                ]
                            ],
                            [
                                "minute",
                                [
                                    1,
                                    2,
                                    5,
                                    10,
                                    15,
                                    30
                                ]
                            ],
                            [
                                "hour",
                                [
                                    1,
                                    2,
                                    3,
                                    4,
                                    6,
                                    8,
                                    12
                                ]
                            ],
                            [
                                "day",
                                [
                                    1,
                                    2
                                ]
                            ],
                            [
                                "week",
                                [
                                    1,
                                    2
                                ]
                            ],
                            [
                                "month",
                                [
                                    1,
                                    2,
                                    3,
                                    4,
                                    6
                                ]
                            ],
                            [
                                "year",
                                null
                            ]
                        ], a = s[s.length - 1], l = o[a[0]], h = a[1];
                        for(i = 0; i < s.length && (l = o[(a = s[i])[0]], h = a[1], !(s[i + 1] && t <= (l * h[h.length - 1] + o[s[i + 1][0]]) / 2)); i++);
                        return l === o.year && t < 5 * l && (h = [
                            1,
                            2,
                            5
                        ]), {
                            unitRange: l,
                            count: r(t / l, h, "year" === a[0] ? Math.max(n(t / l), 1) : 1),
                            unitName: a[0]
                        };
                    }
                    getXDateFormat(t, e) {
                        let { axis: i } = this, n = i.chart.time;
                        return i.closestPointRange ? n.getDateFormat(i.closestPointRange, t, i.options.startOfWeek, e) || n.resolveDTLFormat(e.year).main : n.resolveDTLFormat(e.day).main;
                    }
                }
                t.Additions = a;
            }(e || (e = {})), e;
        }), i(e, "Core/Axis/LogarithmicAxis.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            var e;
            let { addEvent: i, normalizeTickInterval: n, pick: r } = t;
            return function(t) {
                function e() {
                    "logarithmic" !== this.type ? this.logarithmic = void 0 : this.logarithmic ?? (this.logarithmic = new s(this));
                }
                function o() {
                    let t = this.logarithmic;
                    t && (this.lin2val = function(e) {
                        return t.lin2log(e);
                    }, this.val2lin = function(e) {
                        return t.log2lin(e);
                    });
                }
                t.compose = function(t) {
                    return t.keepProps.includes("logarithmic") || (t.keepProps.push("logarithmic"), i(t, "afterSetType", e), i(t, "afterInit", o)), t;
                };
                class s {
                    constructor(t){
                        this.axis = t;
                    }
                    getLogTickPositions(t, e, i, o) {
                        let s = this.axis, a = s.len, l = s.options, h = [];
                        if (o || (this.minorAutoInterval = void 0), t >= .5) t = Math.round(t), h = s.getLinearTickPositions(t, e, i);
                        else if (t >= .08) {
                            let n, r, s, a, l, c, d;
                            for(n = t > .3 ? [
                                1,
                                2,
                                4
                            ] : t > .15 ? [
                                1,
                                2,
                                4,
                                6,
                                8
                            ] : [
                                1,
                                2,
                                3,
                                4,
                                5,
                                6,
                                7,
                                8,
                                9
                            ], r = Math.floor(e); r < i + 1 && !d; r++)for(s = 0, a = n.length; s < a && !d; s++)(l = this.log2lin(this.lin2log(r) * n[s])) > e && (!o || c <= i) && void 0 !== c && h.push(c), c > i && (d = !0), c = l;
                        } else {
                            let c = this.lin2log(e), d = this.lin2log(i), u = o ? s.getMinorTickInterval() : l.tickInterval, p = l.tickPixelInterval / (o ? 5 : 1), f = o ? a / s.tickPositions.length : a;
                            t = n(t = r("auto" === u ? null : u, this.minorAutoInterval, (d - c) * p / (f || 1))), h = s.getLinearTickPositions(t, c, d).map(this.log2lin), o || (this.minorAutoInterval = t / 5);
                        }
                        return o || (s.tickInterval = t), h;
                    }
                    lin2log(t) {
                        return Math.pow(10, t);
                    }
                    log2lin(t) {
                        return Math.log(t) / Math.LN10;
                    }
                }
                t.Additions = s;
            }(e || (e = {})), e;
        }), i(e, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            var e;
            let { erase: i, extend: n, isNumber: r } = t;
            return function(t) {
                let e;
                function o(t) {
                    return this.addPlotBandOrLine(t, "plotBands");
                }
                function s(t, i) {
                    let n = this.userOptions, r = new e(this, t);
                    if (this.visible && (r = r.render()), r) {
                        if (this._addedPlotLB || (this._addedPlotLB = !0, (n.plotLines || []).concat(n.plotBands || []).forEach((t)=>{
                            this.addPlotBandOrLine(t);
                        })), i) {
                            let e = n[i] || [];
                            e.push(t), n[i] = e;
                        }
                        this.plotLinesAndBands.push(r);
                    }
                    return r;
                }
                function a(t) {
                    return this.addPlotBandOrLine(t, "plotLines");
                }
                function l(t, e, i) {
                    i = i || this.options;
                    let n, o, s = this.getPlotLinePath({
                        value: e,
                        force: !0,
                        acrossPanes: i.acrossPanes
                    }), a = [], l = this.horiz, h = !r(this.min) || !r(this.max) || t < this.min && e < this.min || t > this.max && e > this.max, c = this.getPlotLinePath({
                        value: t,
                        force: !0,
                        acrossPanes: i.acrossPanes
                    }), d = 1;
                    if (c && s) for(h && (o = c.toString() === s.toString(), d = 0), n = 0; n < c.length; n += 2){
                        let t = c[n], e = c[n + 1], i = s[n], r = s[n + 1];
                        ("M" === t[0] || "L" === t[0]) && ("M" === e[0] || "L" === e[0]) && ("M" === i[0] || "L" === i[0]) && ("M" === r[0] || "L" === r[0]) && (l && i[1] === t[1] ? (i[1] += d, r[1] += d) : l || i[2] !== t[2] || (i[2] += d, r[2] += d), a.push([
                            "M",
                            t[1],
                            t[2]
                        ], [
                            "L",
                            e[1],
                            e[2]
                        ], [
                            "L",
                            r[1],
                            r[2]
                        ], [
                            "L",
                            i[1],
                            i[2]
                        ], [
                            "Z"
                        ])), a.isFlat = o;
                    }
                    return a;
                }
                function h(t) {
                    this.removePlotBandOrLine(t);
                }
                function c(t) {
                    let e = this.plotLinesAndBands, n = this.options, r = this.userOptions;
                    if (e) {
                        let o = e.length;
                        for(; o--;)e[o].id === t && e[o].destroy();
                        [
                            n.plotLines || [],
                            r.plotLines || [],
                            n.plotBands || [],
                            r.plotBands || []
                        ].forEach(function(e) {
                            for(o = e.length; o--;)(e[o] || {}).id === t && i(e, e[o]);
                        });
                    }
                }
                function d(t) {
                    this.removePlotBandOrLine(t);
                }
                t.compose = function(t, i) {
                    let r = i.prototype;
                    return r.addPlotBand || (e = t, n(r, {
                        addPlotBand: o,
                        addPlotLine: a,
                        addPlotBandOrLine: s,
                        getPlotBandPath: l,
                        removePlotBand: h,
                        removePlotLine: d,
                        removePlotBandOrLine: c
                    })), i;
                };
            }(e || (e = {})), e;
        }), i(e, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [
            e["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { addEvent: i, arrayMax: n, arrayMin: r, defined: o, destroyObjectProperties: s, erase: a, fireEvent: l, merge: h, objectEach: c, pick: d } = e;
            class u {
                static compose(e, n) {
                    return i(e, "afterInit", function() {
                        this.labelCollectors.push(()=>{
                            let t = [];
                            for (let e of this.axes)for (let { label: i, options: n } of e.plotLinesAndBands)i && !n?.label?.allowOverlap && t.push(i);
                            return t;
                        });
                    }), t.compose(u, n);
                }
                constructor(t, e){
                    this.axis = t, this.options = e, this.id = e.id;
                }
                render() {
                    l(this, "render");
                    let t, { axis: e, options: i } = this, { horiz: n, logarithmic: r } = e, { color: s, events: a, zIndex: u = 0 } = i, p = {}, f = e.chart.renderer, g = i.to, m = i.from, b = i.value, y = i.borderWidth, x = i.label, { label: v, svgElem: w } = this, C = [], S = o(m) && o(g), k = o(b), A = !w, E = {
                        class: "highcharts-plot-" + (S ? "band " : "line ") + (i.className || "")
                    }, M = S ? "bands" : "lines";
                    if (!e.chart.styledMode && (k ? (E.stroke = s || "#999999", E["stroke-width"] = d(i.width, 1), i.dashStyle && (E.dashstyle = i.dashStyle)) : S && (E.fill = s || "#e6e9ff", y && (E.stroke = i.borderColor, E["stroke-width"] = y))), p.zIndex = u, M += "-" + u, (t = e.plotLinesAndBandsGroups[M]) || (e.plotLinesAndBandsGroups[M] = t = f.g("plot-" + M).attr(p).add()), w || (this.svgElem = w = f.path().attr(E).add(t)), o(b)) C = e.getPlotLinePath({
                        value: r?.log2lin(b) ?? b,
                        lineWidth: w.strokeWidth(),
                        acrossPanes: i.acrossPanes
                    });
                    else {
                        if (!o(m) || !o(g)) return;
                        C = e.getPlotBandPath(r?.log2lin(m) ?? m, r?.log2lin(g) ?? g, i);
                    }
                    return !this.eventsAdded && a && (c(a, (t, e)=>{
                        w?.on(e, (t)=>{
                            a[e].apply(this, [
                                t
                            ]);
                        });
                    }), this.eventsAdded = !0), !A && w.d || !C?.length ? w && (C ? (w.show(), w.animate({
                        d: C
                    })) : w.d && (w.hide(), v && (this.label = v = v.destroy()))) : w.attr({
                        d: C
                    }), x && (o(x.text) || o(x.formatter)) && C?.length && e.width > 0 && e.height > 0 && !C.isFlat ? (x = h({
                        align: n && S ? "center" : void 0,
                        x: n ? !S && 4 : 10,
                        verticalAlign: !n && S ? "middle" : void 0,
                        y: n ? S ? 16 : 10 : S ? 6 : -4,
                        rotation: n && !S ? 90 : 0,
                        ...S ? {
                            inside: !0
                        } : {}
                    }, x), this.renderLabel(x, C, S, u)) : v && v.hide(), this;
                }
                renderLabel(t, e, i, s) {
                    let a = this.axis, l = a.chart.renderer, c = t.inside, d = this.label;
                    d || (this.label = d = l.text(this.getLabelText(t), 0, 0, t.useHTML).attr({
                        align: t.textAlign || t.align,
                        rotation: t.rotation,
                        class: "highcharts-plot-" + (i ? "band" : "line") + "-label " + (t.className || ""),
                        zIndex: s
                    }), a.chart.styledMode || d.css(h({
                        fontSize: "0.8em",
                        textOverflow: i && !c ? "" : "ellipsis"
                    }, t.style)), d.add());
                    let u = e.xBounds || [
                        e[0][1],
                        e[1][1],
                        i ? e[2][1] : e[0][1]
                    ], p = e.yBounds || [
                        e[0][2],
                        e[1][2],
                        i ? e[2][2] : e[0][2]
                    ], f = r(u), g = r(p), m = n(u) - f;
                    d.align(t, !1, {
                        x: f,
                        y: g,
                        width: m,
                        height: n(p) - g
                    }), (!d.alignValue || "left" === d.alignValue || o(c)) && d.css({
                        width: (t.style?.width || (i && c ? m : 90 === d.rotation ? a.height - (d.alignAttr.y - a.top) : (t.clip ? a.width : a.chart.chartWidth) - (d.alignAttr.x - a.left))) + "px"
                    }), d.show(!0);
                }
                getLabelText(t) {
                    return o(t.formatter) ? t.formatter.call(this) : t.text;
                }
                destroy() {
                    a(this.axis.plotLinesAndBands, this), delete this.axis, s(this);
                }
            }
            return u;
        }), i(e, "Core/Tooltip.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Templating.js"],
            e["Core/Globals.js"],
            e["Core/Renderer/RendererUtilities.js"],
            e["Core/Renderer/RendererRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o) {
            var s;
            let { animObject: a } = t, { format: l } = e, { composed: h, doc: c, isSafari: d } = i, { distribute: u } = n, { addEvent: p, clamp: f, css: g, discardElement: m, extend: b, fireEvent: y, isArray: x, isNumber: v, isString: w, merge: C, pick: S, pushUnique: k, splat: A, syncTimeout: E } = o;
            class M {
                constructor(t, e, i){
                    this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = t, this.init(t, e), this.pointer = i;
                }
                bodyFormatter(t) {
                    return t.map(function(t) {
                        let e = t.series.tooltipOptions;
                        return (e[(t.point.formatPrefix || "point") + "Formatter"] || t.point.tooltipFormatter).call(t.point, e[(t.point.formatPrefix || "point") + "Format"] || "");
                    });
                }
                cleanSplit(t) {
                    this.chart.series.forEach(function(e) {
                        let i = e && e.tt;
                        i && (!i.isActive || t ? e.tt = i.destroy() : i.isActive = !1);
                    });
                }
                defaultFormatter(t) {
                    let e, i = this.points || A(this);
                    return (e = (e = [
                        t.tooltipFooterHeaderFormatter(i[0])
                    ]).concat(t.bodyFormatter(i))).push(t.tooltipFooterHeaderFormatter(i[0], !0)), e;
                }
                destroy() {
                    this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), m(this.container)), o.clearTimeout(this.hideTimer);
                }
                getAnchor(t, e) {
                    let i, { chart: n, pointer: r } = this, o = n.inverted, s = n.plotTop, a = n.plotLeft;
                    if ((t = A(t))[0].series && t[0].series.yAxis && !t[0].series.yAxis.options.reversedStacks && (t = t.slice().reverse()), this.followPointer && e) void 0 === e.chartX && (e = r.normalize(e)), i = [
                        e.chartX - a,
                        e.chartY - s
                    ];
                    else if (t[0].tooltipPos) i = t[0].tooltipPos;
                    else {
                        let n = 0, r = 0;
                        t.forEach(function(t) {
                            let e = t.pos(!0);
                            e && (n += e[0], r += e[1]);
                        }), n /= t.length, r /= t.length, this.shared && t.length > 1 && e && (o ? n = e.chartX : r = e.chartY), i = [
                            n - a,
                            r - s
                        ];
                    }
                    return i.map(Math.round);
                }
                getClassName(t, e, i) {
                    let n = this.options, r = t.series, o = r.options;
                    return [
                        n.className,
                        "highcharts-label",
                        i && "highcharts-tooltip-header",
                        e ? "highcharts-tooltip-box" : "highcharts-tooltip",
                        !i && "highcharts-color-" + S(t.colorIndex, r.colorIndex),
                        o && o.className
                    ].filter(w).join(" ");
                }
                getLabel({ anchorX: t, anchorY: e } = {
                    anchorX: 0,
                    anchorY: 0
                }) {
                    let n = this, o = this.chart.styledMode, s = this.options, a = this.split && this.allowShared, l = this.container, h = this.chart.renderer;
                    if (this.label) {
                        let t = !this.label.hasClass("highcharts-label");
                        (!a && t || a && !t) && this.destroy();
                    }
                    if (!this.label) {
                        if (this.outside) {
                            let t = this.chart.options.chart.style, e = r.getRendererType();
                            this.container = l = i.doc.createElement("div"), l.className = "highcharts-tooltip-container", g(l, {
                                position: "absolute",
                                top: "1px",
                                pointerEvents: "none",
                                zIndex: Math.max(this.options.style.zIndex || 0, (t && t.zIndex || 0) + 3)
                            }), this.renderer = h = new e(l, 0, 0, t, void 0, void 0, h.styledMode);
                        }
                        if (a ? this.label = h.g("tooltip") : (this.label = h.label("", t, e, s.shape, void 0, void 0, s.useHTML, void 0, "tooltip").attr({
                            padding: s.padding,
                            r: s.borderRadius
                        }), o || this.label.attr({
                            fill: s.backgroundColor,
                            "stroke-width": s.borderWidth || 0
                        }).css(s.style).css({
                            pointerEvents: s.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none")
                        })), n.outside) {
                            let t = this.label;
                            [
                                t.xSetter,
                                t.ySetter
                            ].forEach((e, i)=>{
                                t[i ? "ySetter" : "xSetter"] = (r)=>{
                                    e.call(t, n.distance), t[i ? "y" : "x"] = r, l && (l.style[i ? "top" : "left"] = `${r}px`);
                                };
                            });
                        }
                        this.label.attr({
                            zIndex: 8
                        }).shadow(s.shadow).add();
                    }
                    return l && !l.parentElement && i.doc.body.appendChild(l), this.label;
                }
                getPlayingField() {
                    let { body: t, documentElement: e } = c, { chart: i, distance: n, outside: r } = this;
                    return {
                        width: r ? Math.max(t.scrollWidth, e.scrollWidth, t.offsetWidth, e.offsetWidth, e.clientWidth) - 2 * n : i.chartWidth,
                        height: r ? Math.max(t.scrollHeight, e.scrollHeight, t.offsetHeight, e.offsetHeight, e.clientHeight) : i.chartHeight
                    };
                }
                getPosition(t, e, i) {
                    let n, { distance: r, chart: o, outside: s, pointer: a } = this, { inverted: l, plotLeft: h, plotTop: c, polar: d } = o, { plotX: u = 0, plotY: p = 0 } = i, f = {}, g = l && i.h || 0, { height: m, width: b } = this.getPlayingField(), y = a.getChartPosition(), x = (t)=>t * y.scaleX, v = (t)=>t * y.scaleY, w = (i)=>{
                        let n = "x" === i;
                        return [
                            i,
                            n ? b : m,
                            n ? t : e
                        ].concat(s ? [
                            n ? x(t) : v(e),
                            n ? y.left - r + x(u + h) : y.top - r + v(p + c),
                            0,
                            n ? b : m
                        ] : [
                            n ? t : e,
                            n ? u + h : p + c,
                            n ? h : c,
                            n ? h + o.plotWidth : c + o.plotHeight
                        ]);
                    }, C = w("y"), k = w("x"), A = !!i.negative;
                    !d && o.hoverSeries?.yAxis?.reversed && (A = !A);
                    let E = !this.followPointer && S(i.ttBelow, !d && !l === A), M = function(t, e, i, n, o, a, l) {
                        let h = s ? "y" === t ? v(r) : x(r) : r, c = (i - n) / 2, d = n < o - r, u = o + r + n < e, p = o - h - i + c, m = o + h - c;
                        if (E && u) f[t] = m;
                        else if (!E && d) f[t] = p;
                        else if (d) f[t] = Math.min(l - n, p - g < 0 ? p : p - g);
                        else {
                            if (!u) return !1;
                            f[t] = Math.max(a, m + g + i > e ? m : m + g);
                        }
                    }, T = function(t, e, i, n, o) {
                        if (o < r || o > e - r) return !1;
                        f[t] = o < i / 2 ? 1 : o > e - n / 2 ? e - n - 2 : o - i / 2;
                    }, P = function(t) {
                        [C, k] = [
                            k,
                            C
                        ], n = t;
                    }, R = ()=>{
                        !1 !== M.apply(0, C) ? !1 !== T.apply(0, k) || n || (P(!0), R()) : n ? f.x = f.y = 0 : (P(!0), R());
                    };
                    return (l && !d || this.len > 1) && P(), R(), f;
                }
                hide(t) {
                    let e = this;
                    o.clearTimeout(this.hideTimer), t = S(t, this.options.hideDelay), this.isHidden || (this.hideTimer = E(function() {
                        let i = e.getLabel();
                        e.getLabel().animate({
                            opacity: 0
                        }, {
                            duration: t ? 150 : t,
                            complete: ()=>{
                                i.hide(), e.container && e.container.remove();
                            }
                        }), e.isHidden = !0;
                    }, t));
                }
                init(t, e) {
                    this.chart = t, this.options = e, this.crosshairs = [], this.isHidden = !0, this.split = e.split && !t.inverted && !t.polar, this.shared = e.shared || this.split, this.outside = S(e.outside, !(!t.scrollablePixelsX && !t.scrollablePixelsY));
                }
                shouldStickOnContact(t) {
                    return !(this.followPointer || !this.options.stickOnContact || t && !this.pointer.inClass(t.target, "highcharts-tooltip"));
                }
                move(t, e, i, n) {
                    let r = this, o = a(!r.isHidden && r.options.animation), s = {
                        x: t,
                        y: e
                    };
                    r.followPointer || (r.len || 0) > 1 || (s.anchorX = i, s.anchorY = n), o.step = ()=>r.drawTracker(), r.getLabel().animate(s, o);
                }
                refresh(t, e) {
                    let { chart: i, options: n, pointer: r, shared: s } = this, a = A(t), h = a[0], c = [], d = n.format, u = n.formatter || this.defaultFormatter, p = i.styledMode, g = {}, m = this.allowShared;
                    if (!n.enabled || !h.series) return;
                    o.clearTimeout(this.hideTimer), this.allowShared = !(!x(t) && t.series && t.series.noSharedTooltip), m = m && !this.allowShared, this.followPointer = !this.split && h.series.tooltipOptions.followPointer;
                    let b = this.getAnchor(t, e), v = b[0], C = b[1];
                    s && this.allowShared ? (r.applyInactiveState(a), a.forEach(function(t) {
                        t.setState("hover"), c.push(t.getLabelConfig());
                    }), (g = h.getLabelConfig()).points = c) : g = h.getLabelConfig(), this.len = c.length;
                    let k = w(d) ? l(d, g, i) : u.call(g, this), E = h.series;
                    if (this.distance = S(E.tooltipOptions.distance, 16), !1 === k) this.hide();
                    else {
                        if (this.split && this.allowShared) this.renderSplit(k, a);
                        else {
                            let t = v, o = C;
                            if (e && r.isDirectTouch && (t = e.chartX - i.plotLeft, o = e.chartY - i.plotTop), !i.polar && !1 !== E.options.clip && !a.some((e)=>r.isDirectTouch || e.series.shouldShowTooltip(t, o))) return void this.hide();
                            {
                                let t = this.getLabel(m && this.tt || {});
                                (!n.style.width || p) && t.css({
                                    width: (this.outside ? this.getPlayingField() : i.spacingBox).width + "px"
                                }), t.attr({
                                    class: this.getClassName(h),
                                    text: k && k.join ? k.join("") : k
                                }), this.outside && t.attr({
                                    x: f(t.x || 0, 0, this.getPlayingField().width - (t.width || 0))
                                }), p || t.attr({
                                    stroke: n.borderColor || h.color || E.color || "#666666"
                                }), this.updatePosition({
                                    plotX: v,
                                    plotY: C,
                                    negative: h.negative,
                                    ttBelow: h.ttBelow,
                                    h: b[2] || 0
                                });
                            }
                        }
                        this.isHidden && this.label && this.label.attr({
                            opacity: 1
                        }).show(), this.isHidden = !1;
                    }
                    y(this, "refresh");
                }
                renderSplit(t, e) {
                    let i = this, { chart: n, chart: { chartWidth: r, chartHeight: o, plotHeight: s, plotLeft: a, plotTop: l, scrollablePixelsY: h = 0, scrollablePixelsX: p, styledMode: g }, distance: m, options: y, options: { positioner: x }, pointer: v } = i, { scrollLeft: C = 0, scrollTop: k = 0 } = n.scrollablePlotArea?.scrollingContainer || {}, A = i.outside && "number" != typeof p ? c.documentElement.getBoundingClientRect() : {
                        left: C,
                        right: C + r,
                        top: k,
                        bottom: k + o
                    }, E = i.getLabel(), M = this.renderer || n.renderer, T = !(!n.xAxis[0] || !n.xAxis[0].opposite), { left: P, top: R } = v.getChartPosition(), L = l + k, O = 0, D = s - h;
                    function j(t, e, n, r, o = !0) {
                        let s, a;
                        return n ? (s = T ? 0 : D, a = f(t - r / 2, A.left, A.right - r - (i.outside ? P : 0))) : (s = e - L, a = f(a = o ? t - r - m : t + m, o ? a : A.left, A.right)), {
                            x: a,
                            y: s
                        };
                    }
                    w(t) && (t = [
                        !1,
                        t
                    ]);
                    let N = t.slice(0, e.length + 1).reduce(function(t, n, r) {
                        if (!1 !== n && "" !== n) {
                            let o = e[r - 1] || {
                                isHeader: !0,
                                plotX: e[0].plotX,
                                plotY: s,
                                series: {}
                            }, h = o.isHeader, c = h ? i : o.series, d = c.tt = function(t, e, n) {
                                let r = t, { isHeader: o, series: s } = e;
                                if (!r) {
                                    let t = {
                                        padding: y.padding,
                                        r: y.borderRadius
                                    };
                                    g || (t.fill = y.backgroundColor, t["stroke-width"] = y.borderWidth ?? 1), r = M.label("", 0, 0, y[o ? "headerShape" : "shape"], void 0, void 0, y.useHTML).addClass(i.getClassName(e, !0, o)).attr(t).add(E);
                                }
                                return r.isActive = !0, r.attr({
                                    text: n
                                }), g || r.css(y.style).attr({
                                    stroke: y.borderColor || e.color || s.color || "#333333"
                                }), r;
                            }(c.tt, o, n.toString()), u = d.getBBox(), p = u.width + d.strokeWidth();
                            h && (O = u.height, D += O, T && (L -= O));
                            let { anchorX: b, anchorY: v } = function(t) {
                                let e, i, { isHeader: n, plotX: r = 0, plotY: o = 0, series: h } = t;
                                if (n) e = Math.max(a + r, a), i = l + s / 2;
                                else {
                                    let { xAxis: t, yAxis: n } = h;
                                    e = t.pos + f(r, -m, t.len + m), h.shouldShowTooltip(0, n.pos - l + o, {
                                        ignoreX: !0
                                    }) && (i = n.pos + o);
                                }
                                return {
                                    anchorX: e = f(e, A.left - m, A.right + m),
                                    anchorY: i
                                };
                            }(o);
                            if ("number" == typeof v) {
                                let e = u.height + 1, n = x ? x.call(i, p, e, o) : j(b, v, h, p);
                                t.push({
                                    align: x ? 0 : void 0,
                                    anchorX: b,
                                    anchorY: v,
                                    boxWidth: p,
                                    point: o,
                                    rank: S(n.rank, h ? 1 : 0),
                                    size: e,
                                    target: n.y,
                                    tt: d,
                                    x: n.x
                                });
                            } else d.isActive = !1;
                        }
                        return t;
                    }, []);
                    !x && N.some((t)=>{
                        let { outside: e } = i, n = (e ? P : 0) + t.anchorX;
                        return n < A.left && n + t.boxWidth < A.right || n < P - A.left + t.boxWidth && A.right - n > n;
                    }) && (N = N.map((t)=>{
                        let { x: e, y: i } = j(t.anchorX, t.anchorY, t.point.isHeader, t.boxWidth, !1);
                        return b(t, {
                            target: i,
                            x: e
                        });
                    })), i.cleanSplit(), u(N, D);
                    let I = {
                        left: P,
                        right: P
                    };
                    N.forEach(function(t) {
                        let { x: e, boxWidth: n, isHeader: r } = t;
                        !r && (i.outside && P + e < I.left && (I.left = P + e), !r && i.outside && I.left + n > I.right && (I.right = P + e));
                    }), N.forEach(function(t) {
                        let { x: e, anchorX: n, anchorY: r, pos: o, point: { isHeader: s } } = t, a = {
                            visibility: void 0 === o ? "hidden" : "inherit",
                            x: e,
                            y: (o || 0) + L,
                            anchorX: n,
                            anchorY: r
                        };
                        if (i.outside && e < n) {
                            let t = P - I.left;
                            t > 0 && (s || (a.x = e + t, a.anchorX = n + t), s && (a.x = (I.right - I.left) / 2, a.anchorX = n + t));
                        }
                        t.tt.attr(a);
                    });
                    let { container: B, outside: F, renderer: z } = i;
                    if (F && B && z) {
                        let { width: t, height: e, x: i, y: n } = E.getBBox();
                        z.setSize(t + i, e + n, !1), B.style.left = I.left + "px", B.style.top = R + "px";
                    }
                    d && E.attr({
                        opacity: 1 === E.opacity ? .999 : 1
                    });
                }
                drawTracker() {
                    if (!this.shouldStickOnContact()) return void (this.tracker && (this.tracker = this.tracker.destroy()));
                    let t = this.chart, e = this.label, i = this.shared ? t.hoverPoints : t.hoverPoint;
                    if (!e || !i) return;
                    let n = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    }, r = this.getAnchor(i), o = e.getBBox();
                    r[0] += t.plotLeft - (e.translateX || 0), r[1] += t.plotTop - (e.translateY || 0), n.x = Math.min(0, r[0]), n.y = Math.min(0, r[1]), n.width = r[0] < 0 ? Math.max(Math.abs(r[0]), o.width - r[0]) : Math.max(Math.abs(r[0]), o.width), n.height = r[1] < 0 ? Math.max(Math.abs(r[1]), o.height - Math.abs(r[1])) : Math.max(Math.abs(r[1]), o.height), this.tracker ? this.tracker.attr(n) : (this.tracker = e.renderer.rect(n).addClass("highcharts-tracker").add(e), t.styledMode || this.tracker.attr({
                        fill: "rgba(0,0,0,0)"
                    }));
                }
                styledModeFormat(t) {
                    return t.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
                }
                tooltipFooterHeaderFormatter(t, e) {
                    let i = t.series, n = i.tooltipOptions, r = i.xAxis, o = r && r.dateTime, s = {
                        isFooter: e,
                        labelConfig: t
                    }, a = n.xDateFormat, h = n[e ? "footerFormat" : "headerFormat"];
                    return y(this, "headerFormatter", s, function(e) {
                        o && !a && v(t.key) && (a = o.getXDateFormat(t.key, n.dateTimeLabelFormats)), o && a && (t.point && t.point.tooltipDateKeys || [
                            "key"
                        ]).forEach(function(t) {
                            h = h.replace("{point." + t + "}", "{point." + t + ":" + a + "}");
                        }), i.chart.styledMode && (h = this.styledModeFormat(h)), e.text = l(h, {
                            point: t,
                            series: i
                        }, this.chart);
                    }), s.text;
                }
                update(t) {
                    this.destroy(), this.init(this.chart, C(!0, this.options, t));
                }
                updatePosition(t) {
                    let e, { chart: i, container: n, distance: r, options: o, pointer: s, renderer: a } = this, { height: l = 0, width: h = 0 } = this.getLabel(), { left: c, top: d, scaleX: u, scaleY: p } = s.getChartPosition(), f = (o.positioner || this.getPosition).call(this, h, l, t), m = (t.plotX || 0) + i.plotLeft, b = (t.plotY || 0) + i.plotTop;
                    a && n && (o.positioner && (f.x += c - r, f.y += d - r), e = (o.borderWidth || 0) + 2 * r + 2, a.setSize(h + e, l + e, !1), (1 !== u || 1 !== p) && (g(n, {
                        transform: `scale(${u}, ${p})`
                    }), m *= u, b *= p), m += c - f.x, b += d - f.y), this.move(Math.round(f.x), Math.round(f.y || 0), m, b);
                }
            }
            return (s = M || (M = {})).compose = function(t) {
                k(h, "Core.Tooltip") && p(t, "afterInit", function() {
                    let t = this.chart;
                    t.options.tooltip && (t.tooltip = new s(t, t.options.tooltip, this));
                });
            }, M;
        }), i(e, "Core/Series/Point.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Defaults.js"],
            e["Core/Templating.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { animObject: o } = e, { defaultOptions: s } = i, { format: a } = n, { addEvent: l, crisp: h, erase: c, extend: d, fireEvent: u, getNestedProperty: p, isArray: f, isFunction: g, isNumber: m, isObject: b, merge: y, pick: x, syncTimeout: v, removeEvent: w, uniqueKey: C } = r;
            class S {
                animateBeforeDestroy() {
                    let t = this, e = {
                        x: t.startXPos,
                        opacity: 0
                    }, i = t.getGraphicalProps();
                    i.singular.forEach(function(i) {
                        t[i] = t[i].animate("dataLabel" === i ? {
                            x: t[i].startXPos,
                            y: t[i].startYPos,
                            opacity: 0
                        } : e);
                    }), i.plural.forEach(function(e) {
                        t[e].forEach(function(e) {
                            e.element && e.animate(d({
                                x: t.startXPos
                            }, e.startYPos ? {
                                x: e.startXPos,
                                y: e.startYPos
                            } : {}));
                        });
                    });
                }
                applyOptions(t, e) {
                    let i = this.series, n = i.options.pointValKey || i.pointValKey;
                    return d(this, t = S.prototype.optionsToObject.call(this, t)), this.options = this.options ? d(this.options, t) : t, t.group && delete this.group, t.dataLabels && delete this.dataLabels, n && (this.y = S.prototype.getNestedProperty.call(this, n)), this.selected && (this.state = "select"), "name" in this && void 0 === e && i.xAxis && i.xAxis.hasNames && (this.x = i.xAxis.nameToX(this)), void 0 === this.x && i ? this.x = e ?? i.autoIncrement() : m(t.x) && i.options.relativeXValue && (this.x = i.autoIncrement(t.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
                }
                destroy() {
                    if (!this.destroyed) {
                        let t = this, e = t.series, i = e.chart, n = e.options.dataSorting, r = i.hoverPoints, s = o(t.series.chart.renderer.globalAnimation), a = ()=>{
                            for(let e in (t.graphic || t.graphics || t.dataLabel || t.dataLabels) && (w(t), t.destroyElements()), t)delete t[e];
                        };
                        t.legendItem && i.legend.destroyItem(t), r && (t.setState(), c(r, t), r.length || (i.hoverPoints = null)), t === i.hoverPoint && t.onMouseOut(), n && n.enabled ? (this.animateBeforeDestroy(), v(a, s.duration)) : a(), i.pointCount--;
                    }
                    this.destroyed = !0;
                }
                destroyElements(t) {
                    let e = this, i = e.getGraphicalProps(t);
                    i.singular.forEach(function(t) {
                        e[t] = e[t].destroy();
                    }), i.plural.forEach(function(t) {
                        e[t].forEach(function(t) {
                            t && t.element && t.destroy();
                        }), delete e[t];
                    });
                }
                firePointEvent(t, e, i) {
                    let n = this, r = this.series.options;
                    n.manageEvent(t), "click" === t && r.allowPointSelect && (i = function(t) {
                        !n.destroyed && n.select && n.select(null, t.ctrlKey || t.metaKey || t.shiftKey);
                    }), u(n, t, e, i);
                }
                getClassName() {
                    return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (void 0 !== this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
                }
                getGraphicalProps(t) {
                    let e, i, n = this, r = [], o = {
                        singular: [],
                        plural: []
                    };
                    for((t = t || {
                        graphic: 1,
                        dataLabel: 1
                    }).graphic && r.push("graphic", "connector"), t.dataLabel && r.push("dataLabel", "dataLabelPath", "dataLabelUpper"), i = r.length; i--;)n[e = r[i]] && o.singular.push(e);
                    return [
                        "graphic",
                        "dataLabel"
                    ].forEach(function(e) {
                        let i = e + "s";
                        t[e] && n[i] && o.plural.push(i);
                    }), o;
                }
                getLabelConfig() {
                    return {
                        x: this.category,
                        y: this.y,
                        color: this.color,
                        colorIndex: this.colorIndex,
                        key: this.name || this.category,
                        series: this.series,
                        point: this,
                        percentage: this.percentage,
                        total: this.total || this.stackTotal
                    };
                }
                getNestedProperty(t) {
                    return t ? 0 === t.indexOf("custom.") ? p(t, this.options) : this[t] : void 0;
                }
                getZone() {
                    let t, e = this.series, i = e.zones, n = e.zoneAxis || "y", r = 0;
                    for(t = i[0]; this[n] >= t.value;)t = i[++r];
                    return this.nonZonedColor || (this.nonZonedColor = this.color), t && t.color && !this.options.color ? this.color = t.color : this.color = this.nonZonedColor, t;
                }
                hasNewShapeType() {
                    return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
                }
                constructor(t, e, i){
                    this.formatPrefix = "point", this.visible = !0, this.series = t, this.applyOptions(e, i), this.id ?? (this.id = C()), this.resolveColor(), t.chart.pointCount++, u(this, "afterInit");
                }
                isValid() {
                    return (m(this.x) || this.x instanceof Date) && m(this.y);
                }
                optionsToObject(t) {
                    let e, i = this.series, n = i.options.keys, r = n || i.pointArrayMap || [
                        "y"
                    ], o = r.length, s = {}, a = 0, l = 0;
                    if (m(t) || null === t) s[r[0]] = t;
                    else if (f(t)) for(!n && t.length > o && ("string" == (e = typeof t[0]) ? s.name = t[0] : "number" === e && (s.x = t[0]), a++); l < o;)n && void 0 === t[a] || (r[l].indexOf(".") > 0 ? S.prototype.setNestedProperty(s, t[a], r[l]) : s[r[l]] = t[a]), a++, l++;
                    else "object" == typeof t && (s = t, t.dataLabels && (i.hasDataLabels = ()=>!0), t.marker && (i._hasPointMarkers = !0));
                    return s;
                }
                pos(t, e = this.plotY) {
                    if (!this.destroyed) {
                        let { plotX: i, series: n } = this, { chart: r, xAxis: o, yAxis: s } = n, a = 0, l = 0;
                        if (m(i) && m(e)) return t && (a = o ? o.pos : r.plotLeft, l = s ? s.pos : r.plotTop), r.inverted && o && s ? [
                            s.len - e + l,
                            o.len - i + a
                        ] : [
                            i + a,
                            e + l
                        ];
                    }
                }
                resolveColor() {
                    let t, e, i, n = this.series, r = n.chart.options.chart, o = n.chart.styledMode, s = r.colorCount;
                    delete this.nonZonedColor, n.options.colorByPoint ? (o || (t = (e = n.options.colors || n.chart.options.colors)[n.colorCounter], s = e.length), i = n.colorCounter, n.colorCounter++, n.colorCounter === s && (n.colorCounter = 0)) : (o || (t = n.color), i = n.colorIndex), this.colorIndex = x(this.options.colorIndex, i), this.color = x(this.options.color, t);
                }
                setNestedProperty(t, e, i) {
                    return i.split(".").reduce(function(t, i, n, r) {
                        let o = r.length - 1 === n;
                        return t[i] = o ? e : b(t[i], !0) ? t[i] : {}, t[i];
                    }, t), t;
                }
                shouldDraw() {
                    return !this.isNull;
                }
                tooltipFormatter(t) {
                    let e = this.series, i = e.tooltipOptions, n = x(i.valueDecimals, ""), r = i.valuePrefix || "", o = i.valueSuffix || "";
                    return e.chart.styledMode && (t = e.chart.tooltip.styledModeFormat(t)), (e.pointArrayMap || [
                        "y"
                    ]).forEach(function(e) {
                        e = "{point." + e, (r || o) && (t = t.replace(RegExp(e + "}", "g"), r + e + "}" + o)), t = t.replace(RegExp(e + "}", "g"), e + ":,." + n + "f}");
                    }), a(t, {
                        point: this,
                        series: this.series
                    }, e.chart);
                }
                update(t, e, i, n) {
                    let r, o = this, s = o.series, a = o.graphic, l = s.chart, h = s.options;
                    function c() {
                        o.applyOptions(t);
                        let n = a && o.hasMockGraphic, c = null === o.y ? !n : n;
                        a && c && (o.graphic = a.destroy(), delete o.hasMockGraphic), b(t, !0) && (a && a.element && t && t.marker && void 0 !== t.marker.symbol && (o.graphic = a.destroy()), t?.dataLabels && o.dataLabel && (o.dataLabel = o.dataLabel.destroy())), r = o.index, s.updateParallelArrays(o, r), h.data[r] = b(h.data[r], !0) || b(t, !0) ? o.options : x(t, h.data[r]), s.isDirty = s.isDirtyData = !0, !s.fixedBox && s.hasCartesianSeries && (l.isDirtyBox = !0), "point" === h.legendType && (l.isDirtyLegend = !0), e && l.redraw(i);
                    }
                    e = x(e, !0), !1 === n ? c() : o.firePointEvent("update", {
                        options: t
                    }, c);
                }
                remove(t, e) {
                    this.series.removePoint(this.series.data.indexOf(this), t, e);
                }
                select(t, e) {
                    let i = this, n = i.series, r = n.chart;
                    t = x(t, !i.selected), this.selectedStaging = t, i.firePointEvent(t ? "select" : "unselect", {
                        accumulate: e
                    }, function() {
                        i.selected = i.options.selected = t, n.options.data[n.data.indexOf(i)] = i.options, i.setState(t && "select"), e || r.getSelectedPoints().forEach(function(t) {
                            let e = t.series;
                            t.selected && t !== i && (t.selected = t.options.selected = !1, e.options.data[e.data.indexOf(t)] = t.options, t.setState(r.hoverPoints && e.options.inactiveOtherPoints ? "inactive" : ""), t.firePointEvent("unselect"));
                        });
                    }), delete this.selectedStaging;
                }
                onMouseOver(t) {
                    let { inverted: e, pointer: i } = this.series.chart;
                    i && (t = t ? i.normalize(t) : i.getChartCoordinatesFromPoint(this, e), i.runPointActions(t, this));
                }
                onMouseOut() {
                    let t = this.series.chart;
                    this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (t.hoverPoints || []).forEach(function(t) {
                        t.setState();
                    }), t.hoverPoints = t.hoverPoint = null;
                }
                manageEvent(t) {
                    let e = y(this.series.options.point, this.options), i = e.events?.[t];
                    !g(i) || this.hcEvents?.[t] && -1 !== this.hcEvents?.[t]?.map((t)=>t.fn).indexOf(i) ? this.importedUserEvent && !i && this.hcEvents?.[t] && (w(this, t), delete this.hcEvents[t], Object.keys(this.hcEvents) || delete this.importedUserEvent) : (this.importedUserEvent?.(), this.importedUserEvent = l(this, t, i));
                }
                setState(e, i) {
                    let n, r, o, a, l = this.series, h = this.state, c = l.options.states[e || "normal"] || {}, p = s.plotOptions[l.type].marker && l.options.marker, f = p && !1 === p.enabled, g = p && p.states && p.states[e || "normal"] || {}, b = !1 === g.enabled, y = this.marker || {}, v = l.chart, w = p && l.markerAttribs, C = l.halo, S = l.stateMarkerGraphic;
                    if ((e = e || "") === this.state && !i || this.selected && "select" !== e || !1 === c.enabled || e && (b || f && !1 === g.enabled) || e && y.states && y.states[e] && !1 === y.states[e].enabled) return;
                    if (this.state = e, w && (n = l.markerAttribs(this, e)), this.graphic && !this.hasMockGraphic) {
                        if (h && this.graphic.removeClass("highcharts-point-" + h), e && this.graphic.addClass("highcharts-point-" + e), !v.styledMode) {
                            r = l.pointAttribs(this, e), o = x(v.options.chart.animation, c.animation);
                            let t = r.opacity;
                            l.options.inactiveOtherPoints && m(t) && (this.dataLabels || []).forEach(function(e) {
                                e && !e.hasClass("highcharts-data-label-hidden") && (e.animate({
                                    opacity: t
                                }, o), e.connector && e.connector.animate({
                                    opacity: t
                                }, o));
                            }), this.graphic.animate(r, o);
                        }
                        n && this.graphic.animate(n, x(v.options.chart.animation, g.animation, p.animation)), S && S.hide();
                    } else e && g && (a = y.symbol || l.symbol, S && S.currentSymbol !== a && (S = S.destroy()), n && (S ? S[i ? "animate" : "attr"]({
                        x: n.x,
                        y: n.y
                    }) : a && (l.stateMarkerGraphic = S = v.renderer.symbol(a, n.x, n.y, n.width, n.height).add(l.markerGroup), S.currentSymbol = a)), !v.styledMode && S && "inactive" !== this.state && S.attr(l.pointAttribs(this, e))), S && (S[e && this.isInside ? "show" : "hide"](), S.element.point = this, S.addClass(this.getClassName(), !0));
                    let k = c.halo, A = this.graphic || S, E = A && A.visibility || "inherit";
                    k && k.size && A && "hidden" !== E && !this.isCluster ? (C || (l.halo = C = v.renderer.path().add(A.parentGroup)), C.show()[i ? "animate" : "attr"]({
                        d: this.haloPath(k.size)
                    }), C.attr({
                        class: "highcharts-halo highcharts-color-" + x(this.colorIndex, l.colorIndex) + (this.className ? " " + this.className : ""),
                        visibility: E,
                        zIndex: -1
                    }), C.point = this, v.styledMode || C.attr(d({
                        fill: this.color || l.color,
                        "fill-opacity": k.opacity
                    }, t.filterUserAttributes(k.attributes || {})))) : C?.point?.haloPath && !C.point.destroyed && C.animate({
                        d: C.point.haloPath(0)
                    }, null, C.hide), u(this, "afterSetState", {
                        state: e
                    });
                }
                haloPath(t) {
                    let e = this.pos();
                    return e ? this.series.chart.renderer.symbols.circle(h(e[0], 1) - t, e[1] - t, 2 * t, 2 * t) : [];
                }
            }
            return S;
        }), i(e, "Core/Pointer.js", [
            e["Core/Color/Color.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            var n;
            let { parse: r } = t, { charts: o, composed: s, isTouchDevice: a } = e, { addEvent: l, attr: h, css: c, extend: d, find: u, fireEvent: p, isNumber: f, isObject: g, objectEach: m, offset: b, pick: y, pushUnique: x, splat: v } = i;
            class w {
                applyInactiveState(t) {
                    let e, i = [];
                    (t || []).forEach(function(t) {
                        e = t.series, i.push(e), e.linkedParent && i.push(e.linkedParent), e.linkedSeries && (i = i.concat(e.linkedSeries)), e.navigatorSeries && i.push(e.navigatorSeries);
                    }), this.chart.series.forEach(function(t) {
                        -1 === i.indexOf(t) ? t.setState("inactive", !0) : t.options.inactiveOtherPoints && t.setAllPointsToState("inactive");
                    });
                }
                destroy() {
                    let t = this;
                    this.eventsToUnbind.forEach((t)=>t()), this.eventsToUnbind = [], !e.chartCount && (w.unbindDocumentMouseUp && w.unbindDocumentMouseUp.forEach((t)=>t()), w.unbindDocumentTouchEnd && (w.unbindDocumentTouchEnd = w.unbindDocumentTouchEnd())), clearInterval(t.tooltipTimeout), m(t, function(e, i) {
                        t[i] = void 0;
                    });
                }
                getSelectionMarkerAttrs(t, e) {
                    let i = {
                        args: {
                            chartX: t,
                            chartY: e
                        },
                        attrs: {},
                        shapeType: "rect"
                    };
                    return p(this, "getSelectionMarkerAttrs", i, (i)=>{
                        let n, { chart: r, zoomHor: o, zoomVert: s } = this, { mouseDownX: a = 0, mouseDownY: l = 0 } = r, h = i.attrs;
                        h.x = r.plotLeft, h.y = r.plotTop, h.width = o ? 1 : r.plotWidth, h.height = s ? 1 : r.plotHeight, o && (n = t - a, h.width = Math.max(1, Math.abs(n)), h.x = (n > 0 ? 0 : n) + a), s && (n = e - l, h.height = Math.max(1, Math.abs(n)), h.y = (n > 0 ? 0 : n) + l);
                    }), i;
                }
                drag(t) {
                    let e, { chart: i } = this, { mouseDownX: n = 0, mouseDownY: o = 0 } = i, { panning: s, panKey: a, selectionMarkerFill: l } = i.options.chart, h = i.plotLeft, c = i.plotTop, d = i.plotWidth, u = i.plotHeight, p = g(s) ? s.enabled : s, f = a && t[`${a}Key`], m = t.chartX, b = t.chartY, y = this.selectionMarker;
                    if ((!y || !y.touch) && (m < h ? m = h : m > h + d && (m = h + d), b < c ? b = c : b > c + u && (b = c + u), this.hasDragged = Math.sqrt(Math.pow(n - m, 2) + Math.pow(o - b, 2)), this.hasDragged > 10)) {
                        e = i.isInsidePlot(n - h, o - c, {
                            visiblePlotOnly: !0
                        });
                        let { shapeType: a, attrs: d } = this.getSelectionMarkerAttrs(m, b);
                        (i.hasCartesianSeries || i.mapView) && this.hasZoom && e && !f && !y && (this.selectionMarker = y = i.renderer[a](), y.attr({
                            class: "highcharts-selection-marker",
                            zIndex: 7
                        }).add(), i.styledMode || y.attr({
                            fill: l || r("#334eff").setOpacity(.25).get()
                        })), y && y.attr(d), e && !y && p && i.pan(t, s);
                    }
                }
                dragStart(t) {
                    let e = this.chart;
                    e.mouseIsDown = t.type, e.cancelClick = !1, e.mouseDownX = t.chartX, e.mouseDownY = t.chartY;
                }
                getSelectionBox(t) {
                    let e = {
                        args: {
                            marker: t
                        },
                        result: t.getBBox()
                    };
                    return p(this, "getSelectionBox", e), e.result;
                }
                drop(t) {
                    let e, { chart: i, selectionMarker: n } = this;
                    for (let t of i.axes)t.isPanning && (t.isPanning = !1, (t.options.startOnTick || t.options.endOnTick || t.series.some((t)=>t.boosted)) && (t.forceRedraw = !0, t.setExtremes(t.userMin, t.userMax, !1), e = !0));
                    if (e && i.redraw(), n && t) {
                        if (this.hasDragged) {
                            let e = this.getSelectionBox(n);
                            i.transform({
                                axes: i.axes.filter((t)=>t.zoomEnabled && ("xAxis" === t.coll && this.zoomX || "yAxis" === t.coll && this.zoomY)),
                                selection: {
                                    originalEvent: t,
                                    xAxis: [],
                                    yAxis: [],
                                    ...e
                                },
                                from: e
                            });
                        }
                        f(i.index) && (this.selectionMarker = n.destroy());
                    }
                    i && f(i.index) && (c(i.container, {
                        cursor: i._cursor
                    }), i.cancelClick = this.hasDragged > 10, i.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
                }
                findNearestKDPoint(t, e, i) {
                    let n;
                    return t.forEach(function(t) {
                        let r = !(t.noSharedTooltip && e) && 0 > t.options.findNearestPointBy.indexOf("y"), o = t.searchPoint(i, r);
                        g(o, !0) && o.series && (!g(n, !0) || function(t, i) {
                            let n = t.distX - i.distX, r = t.dist - i.dist, o = i.series.group?.zIndex - t.series.group?.zIndex;
                            return 0 !== n && e ? n : 0 !== r ? r : 0 !== o ? o : t.series.index > i.series.index ? -1 : 1;
                        }(n, o) > 0) && (n = o);
                    }), n;
                }
                getChartCoordinatesFromPoint(t, e) {
                    let { xAxis: i, yAxis: n } = t.series, r = t.shapeArgs;
                    if (i && n) {
                        let o = t.clientX ?? t.plotX ?? 0, s = t.plotY || 0;
                        return t.isNode && r && f(r.x) && f(r.y) && (o = r.x, s = r.y), e ? {
                            chartX: n.len + n.pos - s,
                            chartY: i.len + i.pos - o
                        } : {
                            chartX: o + i.pos,
                            chartY: s + n.pos
                        };
                    }
                    if (r && r.x && r.y) return {
                        chartX: r.x,
                        chartY: r.y
                    };
                }
                getChartPosition() {
                    if (this.chartPosition) return this.chartPosition;
                    let { container: t } = this.chart, e = b(t);
                    this.chartPosition = {
                        left: e.left,
                        top: e.top,
                        scaleX: 1,
                        scaleY: 1
                    };
                    let { offsetHeight: i, offsetWidth: n } = t;
                    return n > 2 && i > 2 && (this.chartPosition.scaleX = e.width / n, this.chartPosition.scaleY = e.height / i), this.chartPosition;
                }
                getCoordinates(t) {
                    let e = {
                        xAxis: [],
                        yAxis: []
                    };
                    for (let i of this.chart.axes)e[i.isXAxis ? "xAxis" : "yAxis"].push({
                        axis: i,
                        value: i.toValue(t[i.horiz ? "chartX" : "chartY"])
                    });
                    return e;
                }
                getHoverData(t, e, i, n, r, o) {
                    let s, a = [], l = function(t) {
                        return t.visible && !(!r && t.directTouch) && y(t.options.enableMouseTracking, !0);
                    }, h = e, c = {
                        chartX: o ? o.chartX : void 0,
                        chartY: o ? o.chartY : void 0,
                        shared: r
                    };
                    p(this, "beforeGetHoverData", c), s = h && !h.stickyTracking ? [
                        h
                    ] : i.filter((t)=>t.stickyTracking && (c.filter || l)(t));
                    let d = n && t || !o ? t : this.findNearestKDPoint(s, r, o);
                    return h = d && d.series, d && (r && !h.noSharedTooltip ? (s = i.filter(function(t) {
                        return c.filter ? c.filter(t) : l(t) && !t.noSharedTooltip;
                    })).forEach(function(t) {
                        let e = u(t.points, function(t) {
                            return t.x === d.x && !t.isNull;
                        });
                        g(e) && (t.boosted && t.boost && (e = t.boost.getPoint(e)), a.push(e));
                    }) : a.push(d)), p(this, "afterGetHoverData", c = {
                        hoverPoint: d
                    }), {
                        hoverPoint: c.hoverPoint,
                        hoverSeries: h,
                        hoverPoints: a
                    };
                }
                getPointFromEvent(t) {
                    let e, i = t.target;
                    for(; i && !e;)e = i.point, i = i.parentNode;
                    return e;
                }
                onTrackerMouseOut(t) {
                    let e = this.chart, i = t.relatedTarget, n = e.hoverSeries;
                    this.isDirectTouch = !1, !n || !i || n.stickyTracking || this.inClass(i, "highcharts-tooltip") || this.inClass(i, "highcharts-series-" + n.index) && this.inClass(i, "highcharts-tracker") || n.onMouseOut();
                }
                inClass(t, e) {
                    let i, n = t;
                    for(; n;){
                        if (i = h(n, "class")) {
                            if (-1 !== i.indexOf(e)) return !0;
                            if (-1 !== i.indexOf("highcharts-container")) return !1;
                        }
                        n = n.parentElement;
                    }
                }
                constructor(t, e){
                    this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = e, this.chart = t, this.runChartClick = !!e.chart.events?.click, this.pinchDown = [], this.setDOMEvents(), p(this, "afterInit");
                }
                normalize(t, e) {
                    let i = t.touches, n = i ? i.length ? i.item(0) : y(i.changedTouches, t.changedTouches)[0] : t;
                    e || (e = this.getChartPosition());
                    let r = n.pageX - e.left, o = n.pageY - e.top;
                    return d(t, {
                        chartX: Math.round(r /= e.scaleX),
                        chartY: Math.round(o /= e.scaleY)
                    });
                }
                onContainerClick(t) {
                    let e = this.chart, i = e.hoverPoint, n = this.normalize(t), r = e.plotLeft, o = e.plotTop;
                    !e.cancelClick && (i && this.inClass(n.target, "highcharts-tracker") ? (p(i.series, "click", d(n, {
                        point: i
                    })), e.hoverPoint && i.firePointEvent("click", n)) : (d(n, this.getCoordinates(n)), e.isInsidePlot(n.chartX - r, n.chartY - o, {
                        visiblePlotOnly: !0
                    }) && p(e, "click", n)));
                }
                onContainerMouseDown(t) {
                    let i = !(1 & ~(t.buttons || t.button));
                    t = this.normalize(t), e.isFirefox && 0 !== t.button && this.onContainerMouseMove(t), (void 0 === t.button || i) && (this.zoomOption(t), i && t.preventDefault?.(), this.dragStart(t));
                }
                onContainerMouseLeave(t) {
                    let { pointer: e } = o[y(w.hoverChartIndex, -1)] || {};
                    t = this.normalize(t), this.onContainerMouseMove(t), e && !this.inClass(t.relatedTarget, "highcharts-tooltip") && (e.reset(), e.chartPosition = void 0);
                }
                onContainerMouseEnter() {
                    delete this.chartPosition;
                }
                onContainerMouseMove(t) {
                    let e = this.chart, i = e.tooltip, n = this.normalize(t);
                    this.setHoverChartIndex(t), ("mousedown" === e.mouseIsDown || this.touchSelect(n)) && this.drag(n), !e.openMenu && (this.inClass(n.target, "highcharts-tracker") || e.isInsidePlot(n.chartX - e.plotLeft, n.chartY - e.plotTop, {
                        visiblePlotOnly: !0
                    })) && (!i || !i.shouldStickOnContact(n)) && (this.inClass(n.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(n));
                }
                onDocumentTouchEnd(t) {
                    this.onDocumentMouseUp(t);
                }
                onContainerTouchMove(t) {
                    this.touchSelect(t) ? this.onContainerMouseMove(t) : this.touch(t);
                }
                onContainerTouchStart(t) {
                    this.touchSelect(t) ? this.onContainerMouseDown(t) : (this.zoomOption(t), this.touch(t, !0));
                }
                onDocumentMouseMove(t) {
                    let e = this.chart, i = e.tooltip, n = this.chartPosition, r = this.normalize(t, n);
                    !n || e.isInsidePlot(r.chartX - e.plotLeft, r.chartY - e.plotTop, {
                        visiblePlotOnly: !0
                    }) || i && i.shouldStickOnContact(r) || r.target !== e.container.ownerDocument && this.inClass(r.target, "highcharts-tracker") || this.reset();
                }
                onDocumentMouseUp(t) {
                    o[y(w.hoverChartIndex, -1)]?.pointer?.drop(t);
                }
                pinch(t) {
                    let e = this, { chart: i, hasZoom: n, lastTouches: r } = e, o = [].map.call(t.touches || [], (t)=>e.normalize(t)), s = o.length, a = 1 === s && (e.inClass(t.target, "highcharts-tracker") && i.runTrackerClick || e.runChartClick), l = i.tooltip, h = 1 === s && y(l?.options.followTouchMove, !0);
                    s > 1 ? e.initiated = !0 : h && (e.initiated = !1), n && e.initiated && !a && !1 !== t.cancelable && t.preventDefault(), "touchstart" === t.type ? (e.pinchDown = o, e.res = !0, i.mouseDownX = t.chartX) : h ? this.runPointActions(e.normalize(t)) : r && (p(i, "touchpan", {
                        originalEvent: t,
                        touches: o
                    }, ()=>{
                        let e = (t)=>{
                            let e = t[0], i = t[1] || e;
                            return {
                                x: e.chartX,
                                y: e.chartY,
                                width: i.chartX - e.chartX,
                                height: i.chartY - e.chartY
                            };
                        };
                        i.transform({
                            axes: i.axes.filter((t)=>t.zoomEnabled && (this.zoomHor && t.horiz || this.zoomVert && !t.horiz)),
                            to: e(o),
                            from: e(r),
                            trigger: t.type
                        });
                    }), e.res && (e.res = !1, this.reset(!1, 0))), e.lastTouches = o;
                }
                reset(t, e) {
                    let i = this.chart, n = i.hoverSeries, r = i.hoverPoint, o = i.hoverPoints, s = i.tooltip, a = s && s.shared ? o : r;
                    t && a && v(a).forEach(function(e) {
                        e.series.isCartesian && void 0 === e.plotX && (t = !1);
                    }), t ? s && a && v(a).length && (s.refresh(a), s.shared && o ? o.forEach(function(t) {
                        t.setState(t.state, !0), t.series.isCartesian && (t.series.xAxis.crosshair && t.series.xAxis.drawCrosshair(null, t), t.series.yAxis.crosshair && t.series.yAxis.drawCrosshair(null, t));
                    }) : r && (r.setState(r.state, !0), i.axes.forEach(function(t) {
                        t.crosshair && r.series[t.coll] === t && t.drawCrosshair(null, r);
                    }))) : (r && r.onMouseOut(), o && o.forEach(function(t) {
                        t.setState();
                    }), n && n.onMouseOut(), s && s.hide(e), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), i.axes.forEach(function(t) {
                        t.hideCrosshair();
                    }), i.hoverPoints = i.hoverPoint = void 0);
                }
                runPointActions(t, e, i) {
                    let n = this.chart, r = n.series, s = n.tooltip && n.tooltip.options.enabled ? n.tooltip : void 0, a = !!s && s.shared, h = e || n.hoverPoint, c = h && h.series || n.hoverSeries, d = (!t || "touchmove" !== t.type) && (!!e || c && c.directTouch && this.isDirectTouch), p = this.getHoverData(h, c, r, d, a, t);
                    h = p.hoverPoint, c = p.hoverSeries;
                    let f = p.hoverPoints, g = c && c.tooltipOptions.followPointer && !c.tooltipOptions.split, m = a && c && !c.noSharedTooltip;
                    if (h && (i || h !== n.hoverPoint || s && s.isHidden)) {
                        if ((n.hoverPoints || []).forEach(function(t) {
                            -1 === f.indexOf(t) && t.setState();
                        }), n.hoverSeries !== c && c.onMouseOver(), this.applyInactiveState(f), (f || []).forEach(function(t) {
                            t.setState("hover");
                        }), n.hoverPoint && n.hoverPoint.firePointEvent("mouseOut"), !h.series) return;
                        n.hoverPoints = f, n.hoverPoint = h, h.firePointEvent("mouseOver", void 0, ()=>{
                            s && h && s.refresh(m ? f : h, t);
                        });
                    } else if (g && s && !s.isHidden) {
                        let e = s.getAnchor([
                            {}
                        ], t);
                        n.isInsidePlot(e[0], e[1], {
                            visiblePlotOnly: !0
                        }) && s.updatePosition({
                            plotX: e[0],
                            plotY: e[1]
                        });
                    }
                    this.unDocMouseMove || (this.unDocMouseMove = l(n.container.ownerDocument, "mousemove", (t)=>o[w.hoverChartIndex ?? -1]?.pointer?.onDocumentMouseMove(t)), this.eventsToUnbind.push(this.unDocMouseMove)), n.axes.forEach(function(e) {
                        let i, r = y((e.crosshair || {}).snap, !0);
                        !r || (i = n.hoverPoint) && i.series[e.coll] === e || (i = u(f, (t)=>t.series && t.series[e.coll] === e)), i || !r ? e.drawCrosshair(t, i) : e.hideCrosshair();
                    });
                }
                setDOMEvents() {
                    let t = this.chart.container, e = t.ownerDocument;
                    t.onmousedown = this.onContainerMouseDown.bind(this), t.onmousemove = this.onContainerMouseMove.bind(this), t.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(l(t, "mouseenter", this.onContainerMouseEnter.bind(this)), l(t, "mouseleave", this.onContainerMouseLeave.bind(this))), w.unbindDocumentMouseUp || (w.unbindDocumentMouseUp = []), w.unbindDocumentMouseUp.push(l(e, "mouseup", this.onDocumentMouseUp.bind(this)));
                    let i = this.chart.renderTo.parentElement;
                    for(; i && "BODY" !== i.tagName;)this.eventsToUnbind.push(l(i, "scroll", ()=>{
                        delete this.chartPosition;
                    })), i = i.parentElement;
                    this.eventsToUnbind.push(l(t, "touchstart", this.onContainerTouchStart.bind(this), {
                        passive: !1
                    }), l(t, "touchmove", this.onContainerTouchMove.bind(this), {
                        passive: !1
                    })), w.unbindDocumentTouchEnd || (w.unbindDocumentTouchEnd = l(e, "touchend", this.onDocumentTouchEnd.bind(this), {
                        passive: !1
                    })), this.setPointerCapture(), l(this.chart, "redraw", this.setPointerCapture.bind(this));
                }
                setPointerCapture() {
                    if (!a) return;
                    let t = this.pointerCaptureEventsToUnbind, e = this.chart, i = e.container, n = y(e.options.tooltip?.followTouchMove, !0) && e.series.some((t)=>t.options.findNearestPointBy.indexOf("y") > -1);
                    !this.hasPointerCapture && n ? (t.push(l(i, "pointerdown", (t)=>{
                        t.target?.hasPointerCapture(t.pointerId) && t.target?.releasePointerCapture(t.pointerId);
                    }), l(i, "pointermove", (t)=>{
                        e.pointer?.getPointFromEvent(t)?.onMouseOver(t);
                    })), e.styledMode || c(i, {
                        "touch-action": "none"
                    }), i.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !n && (t.forEach((t)=>t()), t.length = 0, e.styledMode || c(i, {
                        "touch-action": y(e.options.chart.style?.["touch-action"], "manipulation")
                    }), i.className = i.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
                }
                setHoverChartIndex(t) {
                    let i = this.chart, n = e.charts[y(w.hoverChartIndex, -1)];
                    if (n && n !== i) {
                        let e = {
                            relatedTarget: i.container
                        };
                        t && !t?.relatedTarget && (t = {
                            ...e,
                            ...t
                        }), n.pointer?.onContainerMouseLeave(t || e);
                    }
                    n && n.mouseIsDown || (w.hoverChartIndex = i.index);
                }
                touch(t, e) {
                    let i, { chart: n, pinchDown: r = [] } = this;
                    this.setHoverChartIndex(), 1 === (t = this.normalize(t)).touches.length ? n.isInsidePlot(t.chartX - n.plotLeft, t.chartY - n.plotTop, {
                        visiblePlotOnly: !0
                    }) && !n.openMenu ? (e && this.runPointActions(t), "touchmove" === t.type && (i = !!r[0] && Math.pow(r[0].chartX - t.chartX, 2) + Math.pow(r[0].chartY - t.chartY, 2) >= 16), y(i, !0) && this.pinch(t)) : e && this.reset() : 2 === t.touches.length && this.pinch(t);
                }
                touchSelect(t) {
                    return !(!this.chart.zooming.singleTouch || !t.touches || 1 !== t.touches.length);
                }
                zoomOption(t) {
                    let e, i, n = this.chart, r = n.inverted, o = n.zooming.type || "";
                    /touch/.test(t.type) && (o = y(n.zooming.pinchType, o)), this.zoomX = e = /x/.test(o), this.zoomY = i = /y/.test(o), this.zoomHor = e && !r || i && r, this.zoomVert = i && !r || e && r, this.hasZoom = e || i;
                }
            }
            return (n = w || (w = {})).compose = function(t) {
                x(s, "Core.Pointer") && l(t, "beforeRender", function() {
                    this.pointer = new n(this, this.options);
                });
            }, w;
        }), i(e, "Core/Legend/LegendSymbol.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            var e;
            let { extend: i, merge: n, pick: r } = t;
            return function(t) {
                function e(t, e, o) {
                    let s, a = this.legendItem = this.legendItem || {}, { chart: l, options: h } = this, { baseline: c = 0, symbolWidth: d, symbolHeight: u } = t, p = this.symbol || "circle", f = u / 2, g = l.renderer, m = a.group, b = c - Math.round((t.fontMetrics?.b || u) * (o ? .4 : .3)), y = {}, x = h.marker, v = 0;
                    if (l.styledMode || (y["stroke-width"] = Math.min(h.lineWidth || 0, 24), h.dashStyle ? y.dashstyle = h.dashStyle : "square" === h.linecap || (y["stroke-linecap"] = "round")), a.line = g.path().addClass("highcharts-graph").attr(y).add(m), o && (a.area = g.path().addClass("highcharts-area").add(m)), y["stroke-linecap"] && (v = Math.min(a.line.strokeWidth(), d) / 2), d) {
                        let t = [
                            [
                                "M",
                                v,
                                b
                            ],
                            [
                                "L",
                                d - v,
                                b
                            ]
                        ];
                        a.line.attr({
                            d: t
                        }), a.area?.attr({
                            d: [
                                ...t,
                                [
                                    "L",
                                    d - v,
                                    c
                                ],
                                [
                                    "L",
                                    v,
                                    c
                                ]
                            ]
                        });
                    }
                    if (x && !1 !== x.enabled && d) {
                        let t = Math.min(r(x.radius, f), f);
                        0 === p.indexOf("url") && (x = n(x, {
                            width: u,
                            height: u
                        }), t = 0), a.symbol = s = g.symbol(p, d / 2 - t, b - t, 2 * t, 2 * t, i({
                            context: "legend"
                        }, x)).addClass("highcharts-point").add(m), s.isMarker = !0;
                    }
                }
                t.areaMarker = function(t, i) {
                    e.call(this, t, i, !0);
                }, t.lineMarker = e, t.rectangle = function(t, e) {
                    let i = e.legendItem || {}, n = t.options, o = t.symbolHeight, s = n.squareSymbol, a = s ? o : t.symbolWidth;
                    i.symbol = this.chart.renderer.rect(s ? (t.symbolWidth - o) / 2 : 0, t.baseline - o + 1, a, o, r(t.options.symbolRadius, o / 2)).addClass("highcharts-point").attr({
                        zIndex: 3
                    }).add(i.group);
                };
            }(e || (e = {})), e;
        }), i(e, "Core/Series/SeriesDefaults.js", [], function() {
            return {
                lineWidth: 2,
                allowPointSelect: !1,
                crisp: !0,
                showCheckbox: !1,
                animation: {
                    duration: 1e3
                },
                enableMouseTracking: !0,
                events: {},
                marker: {
                    enabledThreshold: 2,
                    lineColor: "#ffffff",
                    lineWidth: 0,
                    radius: 4,
                    states: {
                        normal: {
                            animation: !0
                        },
                        hover: {
                            animation: {
                                duration: 150
                            },
                            enabled: !0,
                            radiusPlus: 2,
                            lineWidthPlus: 1
                        },
                        select: {
                            fillColor: "#cccccc",
                            lineColor: "#000000",
                            lineWidth: 2
                        }
                    }
                },
                point: {
                    events: {}
                },
                dataLabels: {
                    animation: {},
                    align: "center",
                    borderWidth: 0,
                    defer: !0,
                    formatter: function() {
                        let { numberFormatter: t } = this.series.chart;
                        return "number" != typeof this.y ? "" : t(this.y, -1);
                    },
                    padding: 5,
                    style: {
                        fontSize: "0.7em",
                        fontWeight: "bold",
                        color: "contrast",
                        textOutline: "1px contrast"
                    },
                    verticalAlign: "bottom",
                    x: 0,
                    y: 0
                },
                cropThreshold: 300,
                opacity: 1,
                pointRange: 0,
                softThreshold: !0,
                states: {
                    normal: {
                        animation: !0
                    },
                    hover: {
                        animation: {
                            duration: 150
                        },
                        lineWidthPlus: 1,
                        marker: {},
                        halo: {
                            size: 10,
                            opacity: .25
                        }
                    },
                    select: {
                        animation: {
                            duration: 0
                        }
                    },
                    inactive: {
                        animation: {
                            duration: 150
                        },
                        opacity: .2
                    }
                },
                stickyTracking: !0,
                turboThreshold: 1e3,
                findNearestPointBy: "x"
            };
        }), i(e, "Core/Series/SeriesRegistry.js", [
            e["Core/Globals.js"],
            e["Core/Defaults.js"],
            e["Core/Series/Point.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            var r;
            let { defaultOptions: o } = e, { extend: s, extendClass: a, merge: l } = n;
            return function(e) {
                function n(t, n) {
                    let r = o.plotOptions || {}, s = n.defaultOptions, a = n.prototype;
                    return a.type = t, a.pointClass || (a.pointClass = i), !e.seriesTypes[t] && (s && (r[t] = s), e.seriesTypes[t] = n, !0);
                }
                e.seriesTypes = t.seriesTypes, e.registerSeriesType = n, e.seriesType = function(t, r, h, c, d) {
                    let u = o.plotOptions || {};
                    if (r = r || "", u[t] = l(u[r], h), delete e.seriesTypes[t], n(t, a(e.seriesTypes[r] || function() {}, c)), e.seriesTypes[t].prototype.type = t, d) {
                        class n extends i {
                        }
                        s(n.prototype, d), e.seriesTypes[t].prototype.pointClass = n;
                    }
                    return e.seriesTypes[t];
                };
            }(r || (r = {})), r;
        }), i(e, "Core/Series/Series.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Defaults.js"],
            e["Core/Foundation.js"],
            e["Core/Globals.js"],
            e["Core/Legend/LegendSymbol.js"],
            e["Core/Series/Point.js"],
            e["Core/Series/SeriesDefaults.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Renderer/SVG/SVGElement.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a, l, h) {
            let { animObject: c, setAnimation: d } = t, { defaultOptions: u } = e, { registerEventOptions: p } = i, { svg: f, win: g } = n, { seriesTypes: m } = a, { arrayMax: b, arrayMin: y, clamp: x, correctFloat: v, crisp: w, defined: C, destroyObjectProperties: S, diffObjects: k, erase: A, error: E, extend: M, find: T, fireEvent: P, getClosestDistance: R, getNestedProperty: L, insertItem: O, isArray: D, isNumber: j, isString: N, merge: I, objectEach: B, pick: F, removeEvent: z, splat: H, syncTimeout: U } = h;
            class W {
                constructor(){
                    this.zoneAxis = "y";
                }
                init(t, e) {
                    let i;
                    P(this, "init", {
                        options: e
                    });
                    let n = this, r = t.series;
                    this.eventsToUnbind = [], n.chart = t, n.options = n.setOptions(e);
                    let o = n.options, s = !1 !== o.visible;
                    n.linkedSeries = [], n.bindAxes(), M(n, {
                        name: o.name,
                        state: "",
                        visible: s,
                        selected: !0 === o.selected
                    }), p(this, o);
                    let a = o.events;
                    (a && a.click || o.point && o.point.events && o.point.events.click || o.allowPointSelect) && (t.runTrackerClick = !0), n.getColor(), n.getSymbol(), n.parallelArrays.forEach(function(t) {
                        n[t + "Data"] || (n[t + "Data"] = []);
                    }), n.isCartesian && (t.hasCartesianSeries = !0), r.length && (i = r[r.length - 1]), n._i = F(i && i._i, -1) + 1, n.opacity = n.options.opacity, t.orderItems("series", O(this, r)), o.dataSorting && o.dataSorting.enabled ? n.setDataSortingOptions() : n.points || n.data || n.setData(o.data, !1), P(this, "afterInit");
                }
                is(t) {
                    return m[t] && this instanceof m[t];
                }
                bindAxes() {
                    let t, e = this, i = e.options, n = e.chart;
                    P(this, "bindAxes", null, function() {
                        (e.axisTypes || []).forEach(function(r) {
                            (n[r] || []).forEach(function(n) {
                                t = n.options, (F(i[r], 0) === n.index || void 0 !== i[r] && i[r] === t.id) && (O(e, n.series), e[r] = n, n.isDirty = !0);
                            }), e[r] || e.optionalAxis === r || E(18, !0, n);
                        });
                    }), P(this, "afterBindAxes");
                }
                updateParallelArrays(t, e, i) {
                    let n = t.series, r = j(e) ? function(i) {
                        let r = "y" === i && n.toYData ? n.toYData(t) : t[i];
                        n[i + "Data"][e] = r;
                    } : function(t) {
                        Array.prototype[e].apply(n[t + "Data"], i);
                    };
                    n.parallelArrays.forEach(r);
                }
                hasData() {
                    return this.visible && void 0 !== this.dataMax && void 0 !== this.dataMin || this.visible && this.yData && this.yData.length > 0;
                }
                hasMarkerChanged(t, e) {
                    let i = t.marker, n = e.marker || {};
                    return i && (n.enabled && !i.enabled || n.symbol !== i.symbol || n.height !== i.height || n.width !== i.width);
                }
                autoIncrement(t) {
                    let e, i, n = this.options, r = n.pointIntervalUnit, o = n.relativeXValue, s = this.chart.time, a = this.xIncrement;
                    return a = F(a, n.pointStart, 0), this.pointInterval = i = F(this.pointInterval, n.pointInterval, 1), o && j(t) && (i *= t), r && (e = new s.Date(a), "day" === r ? s.set("Date", e, s.get("Date", e) + i) : "month" === r ? s.set("Month", e, s.get("Month", e) + i) : "year" === r && s.set("FullYear", e, s.get("FullYear", e) + i), i = e.getTime() - a), o && j(t) ? a + i : (this.xIncrement = a + i, a);
                }
                setDataSortingOptions() {
                    let t = this.options;
                    M(this, {
                        requireSorting: !1,
                        sorted: !1,
                        enabledDataSorting: !0,
                        allowDG: !1
                    }), C(t.pointRange) || (t.pointRange = 1);
                }
                setOptions(t) {
                    let e, i = this.chart, n = i.options.plotOptions, r = i.userOptions || {}, o = I(t), s = i.styledMode, a = {
                        plotOptions: n,
                        userOptions: o
                    };
                    P(this, "setOptions", a);
                    let l = a.plotOptions[this.type], h = r.plotOptions || {}, c = h.series || {}, d = u.plotOptions[this.type] || {}, p = h[this.type] || {};
                    this.userOptions = a.userOptions;
                    let f = I(l, n.series, p, o);
                    this.tooltipOptions = I(u.tooltip, u.plotOptions.series?.tooltip, d?.tooltip, i.userOptions.tooltip, h.series?.tooltip, p.tooltip, o.tooltip), this.stickyTracking = F(o.stickyTracking, p.stickyTracking, c.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || f.stickyTracking), null === l.marker && delete f.marker, this.zoneAxis = f.zoneAxis || "y";
                    let g = this.zones = (f.zones || []).map((t)=>({
                            ...t
                        }));
                    return (f.negativeColor || f.negativeFillColor) && !f.zones && (e = {
                        value: f[this.zoneAxis + "Threshold"] || f.threshold || 0,
                        className: "highcharts-negative"
                    }, s || (e.color = f.negativeColor, e.fillColor = f.negativeFillColor), g.push(e)), g.length && C(g[g.length - 1].value) && g.push(s ? {} : {
                        color: this.color,
                        fillColor: this.fillColor
                    }), P(this, "afterSetOptions", {
                        options: f
                    }), f;
                }
                getName() {
                    return F(this.options.name, "Series " + (this.index + 1));
                }
                getCyclic(t, e, i) {
                    let n, r, o = this.chart, s = `${t}Index`, a = `${t}Counter`, l = i?.length || o.options.chart.colorCount;
                    !e && (C(r = F("color" === t ? this.options.colorIndex : void 0, this[s])) ? n = r : (o.series.length || (o[a] = 0), n = o[a] % l, o[a] += 1), i && (e = i[n])), void 0 !== n && (this[s] = n), this[t] = e;
                }
                getColor() {
                    this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || u.plotOptions[this.type].color, this.chart.options.colors);
                }
                getPointsCollection() {
                    return (this.hasGroupedData ? this.points : this.data) || [];
                }
                getSymbol() {
                    let t = this.options.marker;
                    this.getCyclic("symbol", t.symbol, this.chart.options.symbols);
                }
                findPointIndex(t, e) {
                    let i, n, r, s = t.id, a = t.x, l = this.points, h = this.options.dataSorting;
                    if (s) {
                        let t = this.chart.get(s);
                        t instanceof o && (i = t);
                    } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
                        let e = (e)=>!e.touched && e.index === t.index;
                        if (h && h.matchByName ? e = (e)=>!e.touched && e.name === t.name : this.options.relativeXValue && (e = (e)=>!e.touched && e.options.x === t.x), !(i = T(l, e))) return;
                    }
                    return i && void 0 !== (r = i && i.index) && (n = !0), void 0 === r && j(a) && (r = this.xData.indexOf(a, e)), -1 !== r && void 0 !== r && this.cropped && (r = r >= this.cropStart ? r - this.cropStart : r), !n && j(r) && l[r] && l[r].touched && (r = void 0), r;
                }
                updateData(t, e) {
                    let i, n, r, o, s = this.options, a = s.dataSorting, l = this.points, h = [], c = this.requireSorting, d = t.length === l.length, u = !0;
                    if (this.xIncrement = null, t.forEach(function(t, e) {
                        let n, r = C(t) && this.pointClass.prototype.optionsToObject.call({
                            series: this
                        }, t) || {}, u = r.x;
                        r.id || j(u) ? (-1 === (n = this.findPointIndex(r, o)) || void 0 === n ? h.push(t) : l[n] && t !== s.data[n] ? (l[n].update(t, !1, null, !1), l[n].touched = !0, c && (o = n + 1)) : l[n] && (l[n].touched = !0), (!d || e !== n || a && a.enabled || this.hasDerivedData) && (i = !0)) : h.push(t);
                    }, this), i) for(n = l.length; n--;)(r = l[n]) && !r.touched && r.remove && r.remove(!1, e);
                    else !d || a && a.enabled ? u = !1 : (t.forEach(function(t, e) {
                        t === l[e].y || l[e].destroyed || l[e].update(t, !1, null, !1);
                    }), h.length = 0);
                    return l.forEach(function(t) {
                        t && (t.touched = !1);
                    }), !!u && (h.forEach(function(t) {
                        this.addPoint(t, !1, null, null, !1);
                    }, this), null === this.xIncrement && this.xData && this.xData.length && (this.xIncrement = b(this.xData), this.autoIncrement()), !0);
                }
                setData(t, e = !0, i, n) {
                    let r, o, s, a, l = this, h = l.points, c = h && h.length || 0, d = l.options, u = l.chart, p = d.dataSorting, f = l.xAxis, g = d.turboThreshold, m = this.xData, b = this.yData, y = l.pointArrayMap, x = y && y.length, v = d.keys, w = 0, C = 1;
                    u.options.chart.allowMutatingData || (d.data && delete l.options.data, l.userOptions.data && delete l.userOptions.data, a = I(!0, t));
                    let S = (t = a || t || []).length;
                    if (p && p.enabled && (t = this.sortData(t)), u.options.chart.allowMutatingData && !1 !== n && S && c && !l.cropped && !l.hasGroupedData && l.visible && !l.boosted && (s = this.updateData(t, i)), !s) {
                        l.xIncrement = null, l.colorCounter = 0, this.parallelArrays.forEach(function(t) {
                            l[t + "Data"].length = 0;
                        });
                        let e = g && S > g;
                        if (e) {
                            let i = l.getFirstValidPoint(t), n = l.getFirstValidPoint(t, S - 1, -1), s = (t)=>!(!D(t) || !v && !j(t[0]));
                            if (j(i) && j(n)) for(r = 0; r < S; r++)m[r] = this.autoIncrement(), b[r] = t[r];
                            else if (s(i) && s(n)) {
                                if (x) {
                                    if (i.length === x) for(r = 0; r < S; r++)m[r] = this.autoIncrement(), b[r] = t[r];
                                    else for(r = 0; r < S; r++)o = t[r], m[r] = o[0], b[r] = o.slice(1, x + 1);
                                } else if (v && (w = v.indexOf("x"), C = v.indexOf("y"), w = w >= 0 ? w : 0, C = C >= 0 ? C : 1), 1 === i.length && (C = 0), w === C) for(r = 0; r < S; r++)m[r] = this.autoIncrement(), b[r] = t[r][C];
                                else for(r = 0; r < S; r++)o = t[r], m[r] = o[w], b[r] = o[C];
                            } else e = !1;
                        }
                        if (!e) for(r = 0; r < S; r++)o = {
                            series: l
                        }, l.pointClass.prototype.applyOptions.apply(o, [
                            t[r]
                        ]), l.updateParallelArrays(o, r);
                        for(b && N(b[0]) && E(14, !0, u), l.data = [], l.options.data = l.userOptions.data = t, r = c; r--;)h[r]?.destroy();
                        f && (f.minRange = f.userMinRange), l.isDirty = u.isDirtyBox = !0, l.isDirtyData = !!h, i = !1;
                    }
                    "point" === d.legendType && (this.processData(), this.generatePoints()), e && u.redraw(i);
                }
                sortData(t) {
                    let e = this, i = e.options.dataSorting.sortKey || "y", n = function(t, e) {
                        return C(e) && t.pointClass.prototype.optionsToObject.call({
                            series: t
                        }, e) || {};
                    };
                    return t.forEach(function(i, r) {
                        t[r] = n(e, i), t[r].index = r;
                    }, this), t.concat().sort((t, e)=>{
                        let n = L(i, t), r = L(i, e);
                        return r < n ? -1 : r > n ? 1 : 0;
                    }).forEach(function(t, e) {
                        t.x = e;
                    }, this), e.linkedSeries && e.linkedSeries.forEach(function(e) {
                        let i = e.options, r = i.data;
                        i.dataSorting && i.dataSorting.enabled || !r || (r.forEach(function(i, o) {
                            r[o] = n(e, i), t[o] && (r[o].x = t[o].x, r[o].index = o);
                        }), e.setData(r, !1));
                    }), t;
                }
                getProcessedData(t) {
                    let e, i, n, r, o, s = this, a = s.xAxis, l = s.options.cropThreshold, h = a?.logarithmic, c = s.isCartesian, d = 0, u = s.xData, p = s.yData, f = !1, g = u.length;
                    a && (r = (n = a.getExtremes()).min, o = n.max, f = !(!a.categories || a.names.length)), c && s.sorted && !t && (!l || g > l || s.forceCrop) && (u[g - 1] < r || u[0] > o ? (u = [], p = []) : s.yData && (u[0] < r || u[g - 1] > o) && (u = (e = this.cropData(s.xData, s.yData, r, o)).xData, p = e.yData, d = e.start, i = !0));
                    let m = R([
                        h ? u.map(h.log2lin) : u
                    ], ()=>s.requireSorting && !f && E(15, !1, s.chart));
                    return {
                        xData: u,
                        yData: p,
                        cropped: i,
                        cropStart: d,
                        closestPointRange: m
                    };
                }
                processData(t) {
                    let e = this.xAxis;
                    if (this.isCartesian && !this.isDirty && !e.isDirty && !this.yAxis.isDirty && !t) return !1;
                    let i = this.getProcessedData();
                    this.cropped = i.cropped, this.cropStart = i.cropStart, this.processedXData = i.xData, this.processedYData = i.yData, this.closestPointRange = this.basePointRange = i.closestPointRange, P(this, "afterProcessData");
                }
                cropData(t, e, i, n) {
                    let r, o, s = t.length, a = 0, l = s;
                    for(r = 0; r < s; r++)if (t[r] >= i) {
                        a = Math.max(0, r - 1);
                        break;
                    }
                    for(o = r; o < s; o++)if (t[o] > n) {
                        l = o + 1;
                        break;
                    }
                    return {
                        xData: t.slice(a, l),
                        yData: e.slice(a, l),
                        start: a,
                        end: l
                    };
                }
                generatePoints() {
                    let t, e, i, n, r = this.options, o = this.processedData || r.data, s = this.processedXData, a = this.processedYData, l = this.pointClass, h = s.length, c = this.cropStart || 0, d = this.hasGroupedData, u = r.keys, p = [], f = r.dataGrouping && r.dataGrouping.groupAll ? c : 0, g = this.data;
                    if (!g && !d) {
                        let t = [];
                        t.length = o.length, g = this.data = t;
                    }
                    for(u && d && (this.options.keys = !1), n = 0; n < h; n++)e = c + n, d ? ((i = new l(this, [
                        s[n]
                    ].concat(H(a[n])))).dataGroup = this.groupMap[f + n], i.dataGroup.options && (i.options = i.dataGroup.options, M(i, i.dataGroup.options), delete i.dataLabels)) : (i = g[e]) || void 0 === o[e] || (g[e] = i = new l(this, o[e], s[n])), i && (i.index = d ? f + n : e, p[n] = i);
                    if (this.options.keys = u, g && (h !== (t = g.length) || d)) for(n = 0; n < t; n++)n !== c || d || (n += h), g[n] && (g[n].destroyElements(), g[n].plotX = void 0);
                    this.data = g, this.points = p, P(this, "afterGeneratePoints");
                }
                getXExtremes(t) {
                    return {
                        min: y(t),
                        max: b(t)
                    };
                }
                getExtremes(t, e) {
                    let i, n, r, o, s, a, l, h = this.xAxis, c = this.yAxis, d = [], u = this.requireSorting && !this.is("column") ? 1 : 0, p = !!c && c.positiveValuesOnly, f = e || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: g, processedYData: m } = this, x = 0, v = 0, w = 0;
                    if (this.cropped && f) {
                        let t = this.getProcessedData(!0);
                        g = t.xData, m = t.yData;
                    }
                    let C = (t = t || this.stackedYData || m || []).length, S = g || this.xData;
                    for(h && (x = (i = h.getExtremes()).min, v = i.max), a = 0; a < C; a++)if (o = S[a], n = (j(s = t[a]) || D(s)) && ((j(s) ? s > 0 : s.length) || !p), r = e || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !h || (S[a + u] || o) >= x && (S[a - u] || o) <= v, n && r) {
                        if (l = s.length) for(; l--;)j(s[l]) && (d[w++] = s[l]);
                        else d[w++] = s;
                    }
                    let k = {
                        activeYData: d,
                        dataMin: y(d),
                        dataMax: b(d)
                    };
                    return P(this, "afterGetExtremes", {
                        dataExtremes: k
                    }), k;
                }
                applyExtremes() {
                    let t = this.getExtremes();
                    return this.dataMin = t.dataMin, this.dataMax = t.dataMax, t;
                }
                getFirstValidPoint(t, e = 0, i = 1) {
                    let n = t.length, r = e;
                    for(; r >= 0 && r < n;){
                        if (C(t[r])) return t[r];
                        r += i;
                    }
                }
                translate() {
                    this.processedXData || this.processData(), this.generatePoints();
                    let t, e, i, n, r = this.options, o = r.stacking, s = this.xAxis, a = s.categories, l = this.enabledDataSorting, h = this.yAxis, c = this.points, d = c.length, u = this.pointPlacementToXValue(), p = !!u, f = r.threshold, g = r.startFromThreshold ? f : 0, m = Number.MAX_VALUE;
                    function b(t) {
                        return x(t, -1000000000, 1e9);
                    }
                    for(t = 0; t < d; t++){
                        let r, d, y, x = c[t], w = x.x, S = x.y, k = x.low, A = o && h.stacking?.stacks[(this.negStacks && S < (g ? 0 : f) ? "-" : "") + this.stackKey];
                        e = s.translate(w, !1, !1, !1, !0, u), x.plotX = j(e) ? v(b(e)) : void 0, o && this.visible && A && A[w] && (n = this.getStackIndicator(n, w, this.index), !x.isNull && n.key && (y = (d = A[w]).points[n.key]), d && D(y) && (k = y[0], S = y[1], k === g && n.key === A[w].base && (k = F(j(f) ? f : h.min)), h.positiveValuesOnly && C(k) && k <= 0 && (k = void 0), x.total = x.stackTotal = F(d.total), x.percentage = C(x.y) && d.total ? x.y / d.total * 100 : void 0, x.stackY = S, this.irregularWidths || d.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), x.yBottom = C(k) ? b(h.translate(k, !1, !0, !1, !0)) : void 0, this.dataModify && (S = this.dataModify.modifyValue(S, t)), j(S) && void 0 !== x.plotX && (r = j(r = h.translate(S, !1, !0, !1, !0)) ? b(r) : void 0), x.plotY = r, x.isInside = this.isPointInside(x), x.clientX = p ? v(s.translate(w, !1, !1, !1, !0, u)) : e, x.negative = (x.y || 0) < (f || 0), x.category = F(a && a[x.x], x.x), x.isNull || !1 === x.visible || (void 0 !== i && (m = Math.min(m, Math.abs(e - i))), i = e), x.zone = this.zones.length ? x.getZone() : void 0, !x.graphic && this.group && l && (x.isNew = !0);
                    }
                    this.closestPointRangePx = m, P(this, "afterTranslate");
                }
                getValidPoints(t, e, i) {
                    let n = this.chart;
                    return (t || this.points || []).filter(function(t) {
                        let { plotX: r, plotY: o } = t;
                        return !(!(i || !t.isNull && j(o)) || e && !n.isInsidePlot(r, o, {
                            inverted: n.inverted
                        })) && !1 !== t.visible;
                    });
                }
                getClipBox() {
                    let { chart: t, xAxis: e, yAxis: i } = this, { x: n, y: r, width: o, height: s } = I(t.clipBox);
                    return e && e.len !== t.plotSizeX && (o = e.len), i && i.len !== t.plotSizeY && (s = i.len), t.inverted && !this.invertible && ([o, s] = [
                        s,
                        o
                    ]), {
                        x: n,
                        y: r,
                        width: o,
                        height: s
                    };
                }
                getSharedClipKey() {
                    return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
                }
                setClip() {
                    let { chart: t, group: e, markerGroup: i } = this, n = t.sharedClips, r = t.renderer, o = this.getClipBox(), s = this.getSharedClipKey(), a = n[s];
                    a ? a.animate(o) : n[s] = a = r.clipRect(o), e && e.clip(!1 === this.options.clip ? void 0 : a), i && i.clip();
                }
                animate(t) {
                    let { chart: e, group: i, markerGroup: n } = this, r = e.inverted, o = c(this.options.animation), s = [
                        this.getSharedClipKey(),
                        o.duration,
                        o.easing,
                        o.defer
                    ].join(","), a = e.sharedClips[s], l = e.sharedClips[s + "m"];
                    if (t && i) {
                        let t = this.getClipBox();
                        if (a) a.attr("height", t.height);
                        else {
                            t.width = 0, r && (t.x = e.plotHeight), a = e.renderer.clipRect(t), e.sharedClips[s] = a;
                            let i = {
                                x: -99,
                                y: -99,
                                width: r ? e.plotWidth + 199 : 99,
                                height: r ? 99 : e.plotHeight + 199
                            };
                            l = e.renderer.clipRect(i), e.sharedClips[s + "m"] = l;
                        }
                        i.clip(a), n?.clip(l);
                    } else if (a && !a.hasClass("highcharts-animating")) {
                        let t = this.getClipBox(), i = o.step;
                        (n?.element.childNodes.length || e.series.length > 1) && (o.step = function(t, e) {
                            i && i.apply(e, arguments), "width" === e.prop && l?.element && l.attr(r ? "height" : "width", t + 99);
                        }), a.addClass("highcharts-animating").animate(t, o);
                    }
                }
                afterAnimate() {
                    this.setClip(), B(this.chart.sharedClips, (t, e, i)=>{
                        t && !this.chart.container.querySelector(`[clip-path="url(#${t.id})"]`) && (t.destroy(), delete i[e]);
                    }), this.finishedAnimating = !0, P(this, "afterAnimate");
                }
                drawPoints(t = this.points) {
                    let e, i, n, r, o, s, a, l = this.chart, h = l.styledMode, { colorAxis: c, options: d } = this, u = d.marker, p = this[this.specialGroup || "markerGroup"], f = this.xAxis, g = F(u.enabled, !f || !!f.isRadial || null, this.closestPointRangePx >= u.enabledThreshold * u.radius);
                    if (!1 !== u.enabled || this._hasPointMarkers) for(e = 0; e < t.length; e++)if (r = (n = (i = t[e]).graphic) ? "animate" : "attr", o = i.marker || {}, s = !!i.marker, (g && void 0 === o.enabled || o.enabled) && !i.isNull && !1 !== i.visible) {
                        let t = F(o.symbol, this.symbol, "rect");
                        a = this.markerAttribs(i, i.selected && "select"), this.enabledDataSorting && (i.startXPos = f.reversed ? -(a.width || 0) : f.width);
                        let e = !1 !== i.isInside;
                        if (!n && e && ((a.width || 0) > 0 || i.hasImage) && (i.graphic = n = l.renderer.symbol(t, a.x, a.y, a.width, a.height, s ? o : u).add(p), this.enabledDataSorting && l.hasRendered && (n.attr({
                            x: i.startXPos
                        }), r = "animate")), n && "animate" === r && n[e ? "show" : "hide"](e).animate(a), n) {
                            let t = this.pointAttribs(i, h || !i.selected ? void 0 : "select");
                            h ? c && n.css({
                                fill: t.fill
                            }) : n[r](t);
                        }
                        n && n.addClass(i.getClassName(), !0);
                    } else n && (i.graphic = n.destroy());
                }
                markerAttribs(t, e) {
                    let i, n, r = this.options, o = r.marker, s = t.marker || {}, a = s.symbol || o.symbol, l = {}, h = F(s.radius, o && o.radius);
                    e && (i = o.states[e], h = F((n = s.states && s.states[e]) && n.radius, i && i.radius, h && h + (i && i.radiusPlus || 0))), t.hasImage = a && 0 === a.indexOf("url"), t.hasImage && (h = 0);
                    let c = t.pos();
                    return j(h) && c && (r.crisp && (c[0] = w(c[0], t.hasImage ? 0 : "rect" === a ? o?.lineWidth || 0 : 1)), l.x = c[0] - h, l.y = c[1] - h), h && (l.width = l.height = 2 * h), l;
                }
                pointAttribs(t, e) {
                    let i, n, r, o, s = this.options.marker, a = t && t.options, l = a && a.marker || {}, h = a && a.color, c = t && t.color, d = t && t.zone && t.zone.color, u = this.color, p = F(l.lineWidth, s.lineWidth), f = 1;
                    return u = h || d || c || u, r = l.fillColor || s.fillColor || u, o = l.lineColor || s.lineColor || u, e = e || "normal", i = s.states[e] || {}, p = F((n = l.states && l.states[e] || {}).lineWidth, i.lineWidth, p + F(n.lineWidthPlus, i.lineWidthPlus, 0)), r = n.fillColor || i.fillColor || r, {
                        stroke: o = n.lineColor || i.lineColor || o,
                        "stroke-width": p,
                        fill: r,
                        opacity: f = F(n.opacity, i.opacity, f)
                    };
                }
                destroy(t) {
                    let e, i, n, r = this, o = r.chart, s = /AppleWebKit\/533/.test(g.navigator.userAgent), a = r.data || [];
                    for(P(r, "destroy", {
                        keepEventsForUpdate: t
                    }), this.removeEvents(t), (r.axisTypes || []).forEach(function(t) {
                        (n = r[t]) && n.series && (A(n.series, r), n.isDirty = n.forceRedraw = !0);
                    }), r.legendItem && r.chart.legend.destroyItem(r), e = a.length; e--;)(i = a[e]) && i.destroy && i.destroy();
                    for (let t of r.zones)S(t, void 0, !0);
                    h.clearTimeout(r.animationTimeout), B(r, function(t, e) {
                        t instanceof l && !t.survive && t[s && "group" === e ? "hide" : "destroy"]();
                    }), o.hoverSeries === r && (o.hoverSeries = void 0), A(o.series, r), o.orderItems("series"), B(r, function(e, i) {
                        t && "hcEvents" === i || delete r[i];
                    });
                }
                applyZones() {
                    let { area: t, chart: e, graph: i, zones: n, points: r, xAxis: o, yAxis: s, zoneAxis: a } = this, { inverted: l, renderer: h } = e, c = this[`${a}Axis`], { isXAxis: d, len: u = 0 } = c || {}, p = (i?.strokeWidth() || 0) / 2 + 1, f = (t, e = 0, i = 0)=>{
                        l && (i = u - i);
                        let { translated: n = 0, lineClip: r } = t, o = i - n;
                        r?.push([
                            "L",
                            e,
                            Math.abs(o) < p ? i - p * (o <= 0 ? -1 : 1) : n
                        ]);
                    };
                    if (n.length && (i || t) && c && j(c.min)) {
                        let e = c.getExtremes().max, p = (t)=>{
                            t.forEach((e, i)=>{
                                ("M" === e[0] || "L" === e[0]) && (t[i] = [
                                    e[0],
                                    d ? u - e[1] : e[1],
                                    d ? e[2] : u - e[2]
                                ]);
                            });
                        };
                        if (n.forEach((t)=>{
                            t.lineClip = [], t.translated = x(c.toPixels(F(t.value, e), !0) || 0, 0, u);
                        }), i && !this.showLine && i.hide(), t && t.hide(), "y" === a && r.length < o.len) for (let t of r){
                            let { plotX: e, plotY: i, zone: r } = t, o = r && n[n.indexOf(r) - 1];
                            r && f(r, e, i), o && f(o, e, i);
                        }
                        let g = [], m = c.toPixels(c.getExtremes().min, !0);
                        n.forEach((e)=>{
                            let n = e.lineClip || [], r = Math.round(e.translated || 0);
                            o.reversed && n.reverse();
                            let { clip: a, simpleClip: c } = e, u = 0, f = 0, b = o.len, y = s.len;
                            d ? (u = r, b = m) : (f = r, y = m);
                            let x = [
                                [
                                    "M",
                                    u,
                                    f
                                ],
                                [
                                    "L",
                                    b,
                                    f
                                ],
                                [
                                    "L",
                                    b,
                                    y
                                ],
                                [
                                    "L",
                                    u,
                                    y
                                ],
                                [
                                    "Z"
                                ]
                            ], v = [
                                x[0],
                                ...n,
                                x[1],
                                x[2],
                                ...g,
                                x[3],
                                x[4]
                            ];
                            g = n.reverse(), m = r, l && (p(v), t && p(x)), a ? (a.animate({
                                d: v
                            }), c?.animate({
                                d: x
                            })) : (a = e.clip = h.path(v), t && (c = e.simpleClip = h.path(x))), i && e.graph?.clip(a), t && e.area?.clip(c);
                        });
                    } else this.visible && (i && i.show(), t && t.show());
                }
                plotGroup(t, e, i, n, r) {
                    let o = this[t], s = !o, a = {
                        visibility: i,
                        zIndex: n || .1
                    };
                    return C(this.opacity) && !this.chart.styledMode && "inactive" !== this.state && (a.opacity = this.opacity), o || (this[t] = o = this.chart.renderer.g().add(r)), o.addClass("highcharts-" + e + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (C(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (o.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), o.attr(a)[s ? "attr" : "animate"](this.getPlotBox(e)), o;
                }
                getPlotBox(t) {
                    let e = this.xAxis, i = this.yAxis, n = this.chart, r = n.inverted && !n.polar && e && this.invertible && "series" === t;
                    return n.inverted && (e = i, i = this.xAxis), {
                        translateX: e ? e.left : n.plotLeft,
                        translateY: i ? i.top : n.plotTop,
                        rotation: r ? 90 : 0,
                        rotationOriginX: r ? (e.len - i.len) / 2 : 0,
                        rotationOriginY: r ? (e.len + i.len) / 2 : 0,
                        scaleX: r ? -1 : 1,
                        scaleY: 1
                    };
                }
                removeEvents(t) {
                    let { eventsToUnbind: e } = this;
                    t || z(this), e.length && (e.forEach((t)=>{
                        t();
                    }), e.length = 0);
                }
                render() {
                    let t = this, { chart: e, options: i, hasRendered: n } = t, r = c(i.animation), o = t.visible ? "inherit" : "hidden", s = i.zIndex, a = e.seriesGroup, l = t.finishedAnimating ? 0 : r.duration;
                    P(this, "render"), t.plotGroup("group", "series", o, s, a), t.markerGroup = t.plotGroup("markerGroup", "markers", o, s, a), !1 !== i.clip && t.setClip(), l && t.animate?.(!0), t.drawGraph && (t.drawGraph(), t.applyZones()), t.visible && t.drawPoints(), t.drawDataLabels?.(), t.redrawPoints?.(), i.enableMouseTracking && t.drawTracker?.(), l && t.animate?.(), n || (l && r.defer && (l += r.defer), t.animationTimeout = U(()=>{
                        t.afterAnimate();
                    }, l || 0)), t.isDirty = !1, t.hasRendered = !0, P(t, "afterRender");
                }
                redraw() {
                    let t = this.isDirty || this.isDirtyData;
                    this.translate(), this.render(), t && delete this.kdTree;
                }
                reserveSpace() {
                    return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
                }
                searchPoint(t, e) {
                    let { xAxis: i, yAxis: n } = this, r = this.chart.inverted;
                    return this.searchKDTree({
                        clientX: r ? i.len - t.chartY + i.pos : t.chartX - i.pos,
                        plotY: r ? n.len - t.chartX + n.pos : t.chartY - n.pos
                    }, e, t);
                }
                buildKDTree(t) {
                    this.buildingKdTree = !0;
                    let e = this, i = e.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
                    delete e.kdTree, U(function() {
                        e.kdTree = function t(i, n, r) {
                            let o, s, a = i?.length;
                            if (a) return o = e.kdAxisArray[n % r], i.sort((t, e)=>(t[o] || 0) - (e[o] || 0)), {
                                point: i[s = Math.floor(a / 2)],
                                left: t(i.slice(0, s), n + 1, r),
                                right: t(i.slice(s + 1), n + 1, r)
                            };
                        }(e.getValidPoints(void 0, !e.directTouch), i, i), e.buildingKdTree = !1;
                    }, e.options.kdNow || "touchstart" === t?.type ? 0 : 1);
                }
                searchKDTree(t, e, i) {
                    let n = this, [r, o] = this.kdAxisArray, s = e ? "distX" : "dist", a = (n.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, l = !!n.isBubble;
                    if (this.kdTree || this.buildingKdTree || this.buildKDTree(i), this.kdTree) return function t(e, i, a, h) {
                        let c, d, u = i.point, p = n.kdAxisArray[a % h], f = u;
                        !function(_t1, e) {
                            let i = _t1[r], n = e[r], s = C(i) && C(n) ? i - n : null, a = _t1[o], h = e[o], c = C(a) && C(h) ? a - h : 0, d = l && e.marker?.radius || 0;
                            e.dist = Math.sqrt((s && s * s || 0) + c * c) - d, e.distX = C(s) ? Math.abs(s) - d : Number.MAX_VALUE;
                        }(e, u);
                        let g = (e[p] || 0) - (u[p] || 0) + (l && u.marker?.radius || 0), m = g < 0 ? "left" : "right", b = g < 0 ? "right" : "left";
                        return i[m] && (f = (c = t(e, i[m], a + 1, h))[s] < f[s] ? c : u), i[b] && Math.sqrt(g * g) < f[s] && (f = (d = t(e, i[b], a + 1, h))[s] < f[s] ? d : f), f;
                    }(t, this.kdTree, a, a);
                }
                pointPlacementToXValue() {
                    let { options: t, xAxis: e } = this, i = t.pointPlacement;
                    return "between" === i && (i = e.reversed ? -0.5 : .5), j(i) ? i * (t.pointRange || e.pointRange) : 0;
                }
                isPointInside(t) {
                    let { chart: e, xAxis: i, yAxis: n } = this, { plotX: r = -1, plotY: o = -1 } = t;
                    return o >= 0 && o <= (n ? n.len : e.plotHeight) && r >= 0 && r <= (i ? i.len : e.plotWidth);
                }
                drawTracker() {
                    let t = this, e = t.options, i = e.trackByArea, n = [].concat((i ? t.areaPath : t.graphPath) || []), r = t.chart, o = r.pointer, s = r.renderer, a = r.options.tooltip?.snap || 0, l = ()=>{
                        e.enableMouseTracking && r.hoverSeries !== t && t.onMouseOver();
                    }, h = "rgba(192,192,192," + (f ? 1e-4 : .002) + ")", c = t.tracker;
                    c ? c.attr({
                        d: n
                    }) : t.graph && (t.tracker = c = s.path(n).attr({
                        visibility: t.visible ? "inherit" : "hidden",
                        zIndex: 2
                    }).addClass(i ? "highcharts-tracker-area" : "highcharts-tracker-line").add(t.group), r.styledMode || c.attr({
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        stroke: h,
                        fill: i ? h : "none",
                        "stroke-width": t.graph.strokeWidth() + (i ? 0 : 2 * a)
                    }), [
                        t.tracker,
                        t.markerGroup,
                        t.dataLabelsGroup
                    ].forEach((t)=>{
                        t && (t.addClass("highcharts-tracker").on("mouseover", l).on("mouseout", (t)=>{
                            o?.onTrackerMouseOut(t);
                        }), e.cursor && !r.styledMode && t.css({
                            cursor: e.cursor
                        }), t.on("touchstart", l));
                    })), P(this, "afterDrawTracker");
                }
                addPoint(t, e, i, n, r) {
                    let o, s, a = this.options, l = this.data, h = this.chart, c = this.xAxis, d = c && c.hasNames && c.names, u = a.data, p = this.xData;
                    e = F(e, !0);
                    let f = {
                        series: this
                    };
                    this.pointClass.prototype.applyOptions.apply(f, [
                        t
                    ]);
                    let g = f.x;
                    if (s = p.length, this.requireSorting && g < p[s - 1]) for(o = !0; s && p[s - 1] > g;)s--;
                    this.updateParallelArrays(f, "splice", [
                        s,
                        0,
                        0
                    ]), this.updateParallelArrays(f, s), d && f.name && (d[g] = f.name), u.splice(s, 0, t), (o || this.processedData) && (this.data.splice(s, 0, null), this.processData()), "point" === a.legendType && this.generatePoints(), i && (l[0] && l[0].remove ? l[0].remove(!1) : (l.shift(), this.updateParallelArrays(f, "shift"), u.shift())), !1 !== r && P(this, "addPoint", {
                        point: f
                    }), this.isDirty = !0, this.isDirtyData = !0, e && h.redraw(n);
                }
                removePoint(t, e, i) {
                    let n = this, r = n.data, o = r[t], s = n.points, a = n.chart, l = function() {
                        s && s.length === r.length && s.splice(t, 1), r.splice(t, 1), n.options.data.splice(t, 1), n.updateParallelArrays(o || {
                            series: n
                        }, "splice", [
                            t,
                            1
                        ]), o && o.destroy(), n.isDirty = !0, n.isDirtyData = !0, e && a.redraw();
                    };
                    d(i, a), e = F(e, !0), o ? o.firePointEvent("remove", null, l) : l();
                }
                remove(t, e, i, n) {
                    let r = this, o = r.chart;
                    function s() {
                        r.destroy(n), o.isDirtyLegend = o.isDirtyBox = !0, o.linkSeries(n), F(t, !0) && o.redraw(e);
                    }
                    !1 !== i ? P(r, "remove", null, s) : s();
                }
                update(t, e) {
                    P(this, "update", {
                        options: t = k(t, this.userOptions)
                    });
                    let i, n, r = this, o = r.chart, s = r.userOptions, a = r.initialType || r.type, l = o.options.plotOptions, h = m[a].prototype, c = r.finishedAnimating && {
                        animation: !1
                    }, d = {}, u = [
                        "colorIndex",
                        "eventOptions",
                        "navigatorSeries",
                        "symbolIndex",
                        "baseSeries"
                    ], p = t.type || s.type || o.options.chart.type, f = !(this.hasDerivedData || p && p !== this.type || void 0 !== t.pointStart || void 0 !== t.pointInterval || void 0 !== t.relativeXValue || t.joinBy || t.mapData || [
                        "dataGrouping",
                        "pointStart",
                        "pointInterval",
                        "pointIntervalUnit",
                        "keys"
                    ].some((t)=>r.hasOptionChanged(t)));
                    p = p || a, f && (u.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), !1 !== t.visible && u.push("area", "graph"), r.parallelArrays.forEach(function(t) {
                        u.push(t + "Data");
                    }), t.data && (t.dataSorting && M(r.options.dataSorting, t.dataSorting), this.setData(t.data, !1))), t = I(s, {
                        index: void 0 === s.index ? r.index : s.index,
                        pointStart: l?.series?.pointStart ?? s.pointStart ?? r.xData?.[0]
                    }, !f && {
                        data: r.options.data
                    }, t, c), f && t.data && (t.data = r.options.data), (u = [
                        "group",
                        "markerGroup",
                        "dataLabelsGroup",
                        "transformGroup"
                    ].concat(u)).forEach(function(t) {
                        u[t] = r[t], delete r[t];
                    });
                    let g = !1;
                    if (m[p]) {
                        if (g = p !== r.type, r.remove(!1, !1, !1, !0), g) {
                            if (o.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(r, m[p].prototype);
                            else {
                                let t = Object.hasOwnProperty.call(r, "hcEvents") && r.hcEvents;
                                for(n in h)r[n] = void 0;
                                M(r, m[p].prototype), t ? r.hcEvents = t : delete r.hcEvents;
                            }
                        }
                    } else E(17, !0, o, {
                        missingModuleFor: p
                    });
                    if (u.forEach(function(t) {
                        r[t] = u[t];
                    }), r.init(o, t), f && this.points) for (let t of (!1 === (i = r.options).visible ? (d.graphic = 1, d.dataLabel = 1) : (this.hasMarkerChanged(i, s) && (d.graphic = 1), r.hasDataLabels?.() || (d.dataLabel = 1)), this.points))t && t.series && (t.resolveColor(), Object.keys(d).length && t.destroyElements(d), !1 === i.showInLegend && t.legendItem && o.legend.destroyItem(t));
                    r.initialType = a, o.linkSeries(), o.setSortedData(), g && r.linkedSeries.length && (r.isDirtyData = !0), P(this, "afterUpdate"), F(e, !0) && o.redraw(!!f && void 0);
                }
                setName(t) {
                    this.name = this.options.name = this.userOptions.name = t, this.chart.isDirtyLegend = !0;
                }
                hasOptionChanged(t) {
                    let e = this.chart, i = this.options[t], n = e.options.plotOptions, r = this.userOptions[t], o = F(n?.[this.type]?.[t], n?.series?.[t]);
                    return r && !C(o) ? i !== r : i !== F(o, i);
                }
                onMouseOver() {
                    let t = this.chart, e = t.hoverSeries, i = t.pointer;
                    i?.setHoverChartIndex(), e && e !== this && e.onMouseOut(), this.options.events.mouseOver && P(this, "mouseOver"), this.setState("hover"), t.hoverSeries = this;
                }
                onMouseOut() {
                    let t = this.options, e = this.chart, i = e.tooltip, n = e.hoverPoint;
                    e.hoverSeries = null, n && n.onMouseOut(), this && t.events.mouseOut && P(this, "mouseOut"), i && !this.stickyTracking && (!i.shared || this.noSharedTooltip) && i.hide(), e.series.forEach(function(t) {
                        t.setState("", !0);
                    });
                }
                setState(t, e) {
                    let i = this, n = i.options, r = i.graph, o = n.inactiveOtherPoints, s = n.states, a = F(s[t || "normal"] && s[t || "normal"].animation, i.chart.options.chart.animation), l = n.lineWidth, h = n.opacity;
                    if (t = t || "", i.state !== t && ([
                        i.group,
                        i.markerGroup,
                        i.dataLabelsGroup
                    ].forEach(function(e) {
                        e && (i.state && e.removeClass("highcharts-series-" + i.state), t && e.addClass("highcharts-series-" + t));
                    }), i.state = t, !i.chart.styledMode)) {
                        if (s[t] && !1 === s[t].enabled) return;
                        if (t && (l = s[t].lineWidth || l + (s[t].lineWidthPlus || 0), h = F(s[t].opacity, h)), r && !r.dashstyle && j(l)) for (let t of [
                            r,
                            ...this.zones.map((t)=>t.graph)
                        ])t?.animate({
                            "stroke-width": l
                        }, a);
                        o || [
                            i.group,
                            i.markerGroup,
                            i.dataLabelsGroup,
                            i.labelBySeries
                        ].forEach(function(t) {
                            t && t.animate({
                                opacity: h
                            }, a);
                        });
                    }
                    e && o && i.points && i.setAllPointsToState(t || void 0);
                }
                setAllPointsToState(t) {
                    this.points.forEach(function(e) {
                        e.setState && e.setState(t);
                    });
                }
                setVisible(t, e) {
                    let i = this, n = i.chart, r = n.options.chart.ignoreHiddenSeries, o = i.visible;
                    i.visible = t = i.options.visible = i.userOptions.visible = void 0 === t ? !o : t;
                    let s = t ? "show" : "hide";
                    [
                        "group",
                        "dataLabelsGroup",
                        "markerGroup",
                        "tracker",
                        "tt"
                    ].forEach((t)=>{
                        i[t]?.[s]();
                    }), (n.hoverSeries === i || n.hoverPoint?.series === i) && i.onMouseOut(), i.legendItem && n.legend.colorizeItem(i, t), i.isDirty = !0, i.options.stacking && n.series.forEach((t)=>{
                        t.options.stacking && t.visible && (t.isDirty = !0);
                    }), i.linkedSeries.forEach((e)=>{
                        e.setVisible(t, !1);
                    }), r && (n.isDirtyBox = !0), P(i, s), !1 !== e && n.redraw();
                }
                show() {
                    this.setVisible(!0);
                }
                hide() {
                    this.setVisible(!1);
                }
                select(t) {
                    this.selected = t = this.options.selected = void 0 === t ? !this.selected : t, this.checkbox && (this.checkbox.checked = t), P(this, t ? "select" : "unselect");
                }
                shouldShowTooltip(t, e, i = {}) {
                    return i.series = this, i.visiblePlotOnly = !0, this.chart.isInsidePlot(t, e, i);
                }
                drawLegendSymbol(t, e) {
                    r[this.options.legendSymbol || "rectangle"]?.call(this, t, e);
                }
            }
            return W.defaultOptions = s, W.types = a.seriesTypes, W.registerType = a.registerSeriesType, M(W.prototype, {
                axisTypes: [
                    "xAxis",
                    "yAxis"
                ],
                coll: "series",
                colorCounter: 0,
                directTouch: !1,
                invertible: !0,
                isCartesian: !0,
                kdAxisArray: [
                    "clientX",
                    "plotY"
                ],
                parallelArrays: [
                    "x",
                    "y"
                ],
                pointClass: o,
                requireSorting: !0,
                sorted: !0
            }), a.series = W, W;
        }), i(e, "Core/Legend/Legend.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Foundation.js"],
            e["Core/Globals.js"],
            e["Core/Series/Series.js"],
            e["Core/Series/Point.js"],
            e["Core/Renderer/RendererUtilities.js"],
            e["Core/Templating.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a) {
            var l;
            let { animObject: h, setAnimation: c } = t, { registerEventOptions: d } = e, { composed: u, marginNames: p } = i, { distribute: f } = o, { format: g } = s, { addEvent: m, createElement: b, css: y, defined: x, discardElement: v, find: w, fireEvent: C, isNumber: S, merge: k, pick: A, pushUnique: E, relativeLength: M, stableSort: T, syncTimeout: P } = a;
            class R {
                constructor(t, e){
                    this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = t, this.setOptions(e), e.enabled && (this.render(), d(this, e), m(this.chart, "endResize", function() {
                        this.legend.positionCheckboxes();
                    })), m(this.chart, "render", ()=>{
                        this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
                    });
                }
                setOptions(t) {
                    let e = A(t.padding, 8);
                    this.options = t, this.chart.styledMode || (this.itemStyle = t.itemStyle, this.itemHiddenStyle = k(this.itemStyle, t.itemHiddenStyle)), this.itemMarginTop = t.itemMarginTop, this.itemMarginBottom = t.itemMarginBottom, this.padding = e, this.initialItemY = e - 5, this.symbolWidth = A(t.symbolWidth, 16), this.pages = [], this.proximate = "proximate" === t.layout && !this.chart.inverted, this.baseline = void 0;
                }
                update(t, e) {
                    let i = this.chart;
                    this.setOptions(k(!0, this.options, t)), "events" in this.options && d(this, this.options), this.destroy(), i.isDirtyLegend = i.isDirtyBox = !0, A(e, !0) && i.redraw(), C(this, "afterUpdate", {
                        redraw: e
                    });
                }
                colorizeItem(t, e) {
                    let { area: i, group: n, label: r, line: o, symbol: s } = t.legendItem || {};
                    if (n?.[e ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
                        let { itemHiddenStyle: n = {} } = this, a = n.color, { fillColor: l, fillOpacity: h, lineColor: c, marker: d } = t.options, u = (t)=>(!e && (t.fill && (t.fill = a), t.stroke && (t.stroke = a)), t);
                        r?.css(k(e ? this.itemStyle : n)), o?.attr(u({
                            stroke: c || t.color
                        })), s && s.attr(u(d && s.isMarker ? t.pointAttribs() : {
                            fill: t.color
                        })), i?.attr(u({
                            fill: l || t.color,
                            "fill-opacity": l ? 1 : h ?? .75
                        }));
                    }
                    C(this, "afterColorizeItem", {
                        item: t,
                        visible: e
                    });
                }
                positionItems() {
                    this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
                }
                positionItem(t) {
                    let { group: e, x: i = 0, y: n = 0 } = t.legendItem || {}, r = this.options, o = r.symbolPadding, s = !r.rtl, a = t.checkbox;
                    if (e && e.element) {
                        let r = {
                            translateX: s ? i : this.legendWidth - i - 2 * o - 4,
                            translateY: n
                        };
                        e[x(e.translateY) ? "animate" : "attr"](r, void 0, ()=>{
                            C(this, "afterPositionItem", {
                                item: t
                            });
                        });
                    }
                    a && (a.x = i, a.y = n);
                }
                destroyItem(t) {
                    let e = t.checkbox, i = t.legendItem || {};
                    for (let t of [
                        "group",
                        "label",
                        "line",
                        "symbol"
                    ])i[t] && (i[t] = i[t].destroy());
                    e && v(e), t.legendItem = void 0;
                }
                destroy() {
                    for (let t of this.getAllItems())this.destroyItem(t);
                    for (let t of [
                        "clipRect",
                        "up",
                        "down",
                        "pager",
                        "nav",
                        "box",
                        "title",
                        "group"
                    ])this[t] && (this[t] = this[t].destroy());
                    this.display = null;
                }
                positionCheckboxes() {
                    let t, e = this.group && this.group.alignAttr, i = this.clipHeight || this.legendHeight, n = this.titleHeight;
                    e && (t = e.translateY, this.allItems.forEach(function(r) {
                        let o, s = r.checkbox;
                        s && (o = t + n + s.y + (this.scrollOffset || 0) + 3, y(s, {
                            left: e.translateX + r.checkboxOffset + s.x - 20 + "px",
                            top: o + "px",
                            display: this.proximate || o > t - 6 && o < t + i - 6 ? "" : "none"
                        }));
                    }, this));
                }
                renderTitle() {
                    let t, e = this.options, i = this.padding, n = e.title, r = 0;
                    n.text && (this.title || (this.title = this.chart.renderer.label(n.text, i - 3, i - 4, void 0, void 0, void 0, e.useHTML, void 0, "legend-title").attr({
                        zIndex: 1
                    }), this.chart.styledMode || this.title.css(n.style), this.title.add(this.group)), n.width || this.title.css({
                        width: this.maxLegendWidth + "px"
                    }), r = (t = this.title.getBBox()).height, this.offsetWidth = t.width, this.contentGroup.attr({
                        translateY: r
                    })), this.titleHeight = r;
                }
                setText(t) {
                    let e = this.options;
                    t.legendItem.label.attr({
                        text: e.labelFormat ? g(e.labelFormat, t, this.chart) : e.labelFormatter.call(t)
                    });
                }
                renderItem(t) {
                    let e = t.legendItem = t.legendItem || {}, i = this.chart, n = i.renderer, r = this.options, o = "horizontal" === r.layout, s = this.symbolWidth, a = r.symbolPadding || 0, l = this.itemStyle, h = this.itemHiddenStyle, c = o ? A(r.itemDistance, 20) : 0, d = !r.rtl, u = !t.series, p = !u && t.series.drawLegendSymbol ? t.series : t, f = p.options, g = !!this.createCheckboxForItem && f && f.showCheckbox, m = r.useHTML, b = t.options.className, y = e.label, x = s + a + c + (g ? 20 : 0);
                    !y && (e.group = n.g("legend-item").addClass("highcharts-" + p.type + "-series highcharts-color-" + t.colorIndex + (b ? " " + b : "") + (u ? " highcharts-series-" + t.index : "")).attr({
                        zIndex: 1
                    }).add(this.scrollGroup), e.label = y = n.text("", d ? s + a : -a, this.baseline || 0, m), i.styledMode || y.css(k(t.visible ? l : h)), y.attr({
                        align: d ? "left" : "right",
                        zIndex: 2
                    }).add(e.group), !this.baseline && (this.fontMetrics = n.fontMetrics(y), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, y.attr("y", this.baseline), this.symbolHeight = A(r.symbolHeight, this.fontMetrics.f), r.squareSymbol && (this.symbolWidth = A(r.symbolWidth, Math.max(this.symbolHeight, 16)), x = this.symbolWidth + a + c + (g ? 20 : 0), d && y.attr("x", this.symbolWidth + a))), p.drawLegendSymbol(this, t), this.setItemEvents && this.setItemEvents(t, y, m)), g && !t.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(t), this.colorizeItem(t, t.visible), (i.styledMode || !l.width) && y.css({
                        width: (r.itemWidth || this.widthOption || i.spacingBox.width) - x + "px"
                    }), this.setText(t);
                    let v = y.getBBox(), w = this.fontMetrics && this.fontMetrics.h || 0;
                    t.itemWidth = t.checkboxOffset = r.itemWidth || e.labelWidth || v.width + x, this.maxItemWidth = Math.max(this.maxItemWidth, t.itemWidth), this.totalItemWidth += t.itemWidth, this.itemHeight = t.itemHeight = Math.round(e.labelHeight || (v.height > 1.5 * w ? v.height : w));
                }
                layoutItem(t) {
                    let e = this.options, i = this.padding, n = "horizontal" === e.layout, r = t.itemHeight, o = this.itemMarginBottom, s = this.itemMarginTop, a = n ? A(e.itemDistance, 20) : 0, l = this.maxLegendWidth, h = e.alignColumns && this.totalItemWidth > l ? this.maxItemWidth : t.itemWidth, c = t.legendItem || {};
                    n && this.itemX - i + h > l && (this.itemX = i, this.lastLineHeight && (this.itemY += s + this.lastLineHeight + o), this.lastLineHeight = 0), this.lastItemY = s + this.itemY + o, this.lastLineHeight = Math.max(r, this.lastLineHeight), c.x = this.itemX, c.y = this.itemY, n ? this.itemX += h : (this.itemY += s + r + o, this.lastLineHeight = r), this.offsetWidth = this.widthOption || Math.max((n ? this.itemX - i - (t.checkbox ? 0 : a) : h) + i, this.offsetWidth);
                }
                getAllItems() {
                    let t = [];
                    return this.chart.series.forEach(function(e) {
                        let i = e && e.options;
                        e && A(i.showInLegend, !x(i.linkedTo) && void 0, !0) && (t = t.concat((e.legendItem || {}).labels || ("point" === i.legendType ? e.data : e)));
                    }), C(this, "afterGetAllItems", {
                        allItems: t
                    }), t;
                }
                getAlignment() {
                    let t = this.options;
                    return this.proximate ? t.align.charAt(0) + "tv" : t.floating ? "" : t.align.charAt(0) + t.verticalAlign.charAt(0) + t.layout.charAt(0);
                }
                adjustMargins(t, e) {
                    let i = this.chart, n = this.options, r = this.getAlignment();
                    r && [
                        /(lth|ct|rth)/,
                        /(rtv|rm|rbv)/,
                        /(rbh|cb|lbh)/,
                        /(lbv|lm|ltv)/
                    ].forEach(function(o, s) {
                        o.test(r) && !x(t[s]) && (i[p[s]] = Math.max(i[p[s]], i.legend[(s + 1) % 2 ? "legendHeight" : "legendWidth"] + [
                            1,
                            -1,
                            -1,
                            1
                        ][s] * n[s % 2 ? "x" : "y"] + A(n.margin, 12) + e[s] + (i.titleOffset[s] || 0)));
                    });
                }
                proximatePositions() {
                    let t, e = this.chart, i = [], n = "left" === this.options.align;
                    for (let r of (this.allItems.forEach(function(t) {
                        let r, o, s, a, l = n;
                        t.yAxis && (t.xAxis.options.reversed && (l = !l), t.points && (r = w(l ? t.points : t.points.slice(0).reverse(), function(t) {
                            return S(t.plotY);
                        })), o = this.itemMarginTop + t.legendItem.label.getBBox().height + this.itemMarginBottom, a = t.yAxis.top - e.plotTop, s = t.visible ? (r ? r.plotY : t.yAxis.height) + (a - .3 * o) : a + t.yAxis.height, i.push({
                            target: s,
                            size: o,
                            item: t
                        }));
                    }, this), f(i, e.plotHeight)))t = r.item.legendItem || {}, S(r.pos) && (t.y = e.plotTop - e.spacing[0] + r.pos);
                }
                render() {
                    let t, e, i, n, r = this.chart, o = r.renderer, s = this.options, a = this.padding, l = this.getAllItems(), h = this.group, c = this.box;
                    this.itemX = a, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = M(s.width, r.spacingBox.width - a), n = r.spacingBox.width - 2 * a - s.x, [
                        "rm",
                        "lm"
                    ].indexOf(this.getAlignment().substring(0, 2)) > -1 && (n /= 2), this.maxLegendWidth = this.widthOption || n, h || (this.group = h = o.g("legend").addClass(s.className || "").attr({
                        zIndex: 7
                    }).add(), this.contentGroup = o.g().attr({
                        zIndex: 1
                    }).add(h), this.scrollGroup = o.g().add(this.contentGroup)), this.renderTitle(), T(l, (t, e)=>(t.options && t.options.legendIndex || 0) - (e.options && e.options.legendIndex || 0)), s.reversed && l.reverse(), this.allItems = l, this.display = t = !!l.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, l.forEach(this.renderItem, this), l.forEach(this.layoutItem, this), e = (this.widthOption || this.offsetWidth) + a, i = this.lastItemY + this.lastLineHeight + this.titleHeight, i = this.handleOverflow(i) + a, c || (this.box = c = o.rect().addClass("highcharts-legend-box").attr({
                        r: s.borderRadius
                    }).add(h)), r.styledMode || c.attr({
                        stroke: s.borderColor,
                        "stroke-width": s.borderWidth || 0,
                        fill: s.backgroundColor || "none"
                    }).shadow(s.shadow), e > 0 && i > 0 && c[c.placed ? "animate" : "attr"](c.crisp.call({}, {
                        x: 0,
                        y: 0,
                        width: e,
                        height: i
                    }, c.strokeWidth())), h[t ? "show" : "hide"](), r.styledMode && "none" === h.getStyle("display") && (e = i = 0), this.legendWidth = e, this.legendHeight = i, t && this.align(), this.proximate || this.positionItems(), C(this, "afterRender");
                }
                align(t = this.chart.spacingBox) {
                    let e = this.chart, i = this.options, n = t.y;
                    /(lth|ct|rth)/.test(this.getAlignment()) && e.titleOffset[0] > 0 ? n += e.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && e.titleOffset[2] > 0 && (n -= e.titleOffset[2]), n !== t.y && (t = k(t, {
                        y: n
                    })), e.hasRendered || (this.group.placed = !1), this.group.align(k(i, {
                        width: this.legendWidth,
                        height: this.legendHeight,
                        verticalAlign: this.proximate ? "top" : i.verticalAlign
                    }), !0, t);
                }
                handleOverflow(t) {
                    let e, i, n, r = this, o = this.chart, s = o.renderer, a = this.options, l = a.y, h = "top" === a.verticalAlign, c = this.padding, d = a.maxHeight, u = a.navigation, p = A(u.animation, !0), f = u.arrowSize || 12, g = this.pages, m = this.allItems, b = function(t) {
                        "number" == typeof t ? w.attr({
                            height: t
                        }) : w && (r.clipRect = w.destroy(), r.contentGroup.clip()), r.contentGroup.div && (r.contentGroup.div.style.clip = t ? "rect(" + c + "px,9999px," + (c + t) + "px,0)" : "auto");
                    }, y = function(t) {
                        return r[t] = s.circle(0, 0, 1.3 * f).translate(f / 2, f / 2).add(v), o.styledMode || r[t].attr("fill", "rgba(0,0,0,0.0001)"), r[t];
                    }, x = o.spacingBox.height + (h ? -l : l) - c, v = this.nav, w = this.clipRect;
                    return "horizontal" !== a.layout || "middle" === a.verticalAlign || a.floating || (x /= 2), d && (x = Math.min(x, d)), g.length = 0, t && x > 0 && t > x && !1 !== u.enabled ? (this.clipHeight = e = Math.max(x - 20 - this.titleHeight - c, 0), this.currentPage = A(this.currentPage, 1), this.fullHeight = t, m.forEach((t, r)=>{
                        let o = (n = t.legendItem || {}).y || 0, s = Math.round(n.label.getBBox().height), a = g.length;
                        (!a || o - g[a - 1] > e && (i || o) !== g[a - 1]) && (g.push(i || o), a++), n.pageIx = a - 1, i && ((m[r - 1].legendItem || {}).pageIx = a - 1), r === m.length - 1 && o + s - g[a - 1] > e && o > g[a - 1] && (g.push(o), n.pageIx = a), o !== i && (i = o);
                    }), w || (w = r.clipRect = s.clipRect(0, c - 2, 9999, 0), r.contentGroup.clip(w)), b(e), v || (this.nav = v = s.g().attr({
                        zIndex: 1
                    }).add(this.group), this.up = s.symbol("triangle", 0, 0, f, f).add(v), y("upTracker").on("click", function() {
                        r.scroll(-1, p);
                    }), this.pager = s.text("", 15, 10).addClass("highcharts-legend-navigation"), !o.styledMode && u.style && this.pager.css(u.style), this.pager.add(v), this.down = s.symbol("triangle-down", 0, 0, f, f).add(v), y("downTracker").on("click", function() {
                        r.scroll(1, p);
                    })), r.scroll(0), t = x) : v && (b(), this.nav = v.destroy(), this.scrollGroup.attr({
                        translateY: 1
                    }), this.clipHeight = 0), t;
                }
                scroll(t, e) {
                    let i = this.chart, n = this.pages, r = n.length, o = this.clipHeight, s = this.options.navigation, a = this.pager, l = this.padding, d = this.currentPage + t;
                    d > r && (d = r), d > 0 && (void 0 !== e && c(e, i), this.nav.attr({
                        translateX: l,
                        translateY: o + this.padding + 7 + this.titleHeight,
                        visibility: "inherit"
                    }), [
                        this.up,
                        this.upTracker
                    ].forEach(function(t) {
                        t.attr({
                            class: 1 === d ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                        });
                    }), a.attr({
                        text: d + "/" + r
                    }), [
                        this.down,
                        this.downTracker
                    ].forEach(function(t) {
                        t.attr({
                            x: 18 + this.pager.getBBox().width,
                            class: d === r ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                        });
                    }, this), i.styledMode || (this.up.attr({
                        fill: 1 === d ? s.inactiveColor : s.activeColor
                    }), this.upTracker.css({
                        cursor: 1 === d ? "default" : "pointer"
                    }), this.down.attr({
                        fill: d === r ? s.inactiveColor : s.activeColor
                    }), this.downTracker.css({
                        cursor: d === r ? "default" : "pointer"
                    })), this.scrollOffset = -n[d - 1] + this.initialItemY, this.scrollGroup.animate({
                        translateY: this.scrollOffset
                    }), this.currentPage = d, this.positionCheckboxes(), P(()=>{
                        C(this, "afterScroll", {
                            currentPage: d
                        });
                    }, h(A(e, i.renderer.globalAnimation, !0)).duration));
                }
                setItemEvents(t, e, i) {
                    let o = this, s = t.legendItem || {}, a = o.chart.renderer.boxWrapper, l = t instanceof r, h = t instanceof n, c = "highcharts-legend-" + (l ? "point" : "series") + "-active", d = o.chart.styledMode, u = i ? [
                        e,
                        s.symbol
                    ] : [
                        s.group
                    ], p = (e)=>{
                        o.allItems.forEach((i)=>{
                            t !== i && [
                                i
                            ].concat(i.linkedSeries || []).forEach((t)=>{
                                t.setState(e, !l);
                            });
                        });
                    };
                    for (let i of u)i && i.on("mouseover", function() {
                        t.visible && p("inactive"), t.setState("hover"), t.visible && a.addClass(c), d || e.css(o.options.itemHoverStyle);
                    }).on("mouseout", function() {
                        o.chart.styledMode || e.css(k(t.visible ? o.itemStyle : o.itemHiddenStyle)), p(""), a.removeClass(c), t.setState();
                    }).on("click", function(e) {
                        a.removeClass(c), C(o, "itemClick", {
                            browserEvent: e,
                            legendItem: t
                        }, function() {
                            t.setVisible && t.setVisible(), p(t.visible ? "inactive" : "");
                        }), l ? t.firePointEvent("legendItemClick", {
                            browserEvent: e
                        }) : h && C(t, "legendItemClick", {
                            browserEvent: e
                        });
                    });
                }
                createCheckboxForItem(t) {
                    t.checkbox = b("input", {
                        type: "checkbox",
                        className: "highcharts-legend-checkbox",
                        checked: t.selected,
                        defaultChecked: t.selected
                    }, this.options.itemCheckboxStyle, this.chart.container), m(t.checkbox, "click", function(e) {
                        let i = e.target;
                        C(t.series || t, "checkboxClick", {
                            checked: i.checked,
                            item: t
                        }, function() {
                            t.select();
                        });
                    });
                }
            }
            return (l = R || (R = {})).compose = function(t) {
                E(u, "Core.Legend") && m(t, "beforeMargins", function() {
                    this.legend = new l(this, this.options.legend);
                });
            }, R;
        }), i(e, "Core/Chart/Chart.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Axis/Axis.js"],
            e["Core/Defaults.js"],
            e["Core/Templating.js"],
            e["Core/Foundation.js"],
            e["Core/Globals.js"],
            e["Core/Renderer/RendererRegistry.js"],
            e["Core/Series/Series.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Renderer/SVG/SVGRenderer.js"],
            e["Core/Time.js"],
            e["Core/Utilities.js"],
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Axis/Tick.js"]
        ], function(t, e, i, n, r, o, s, a, l, h, c, d, u, p) {
            let { animate: f, animObject: g, setAnimation: m } = t, { defaultOptions: b, defaultTime: y } = i, { numberFormat: x } = n, { registerEventOptions: v } = r, { charts: w, doc: C, marginNames: S, svg: k, win: A } = o, { seriesTypes: E } = l, { addEvent: M, attr: T, createElement: P, css: R, defined: L, diffObjects: O, discardElement: D, erase: j, error: N, extend: I, find: B, fireEvent: F, getStyle: z, isArray: H, isNumber: U, isObject: W, isString: Y, merge: _, objectEach: X, pick: G, pInt: q, relativeLength: V, removeEvent: $, splat: K, syncTimeout: Z, uniqueKey: Q } = d;
            class J {
                static chart(t, e, i) {
                    return new J(t, e, i);
                }
                constructor(t, e, i){
                    this.sharedClips = {};
                    let n = [
                        ...arguments
                    ];
                    (Y(t) || t.nodeName) && (this.renderTo = n.shift()), this.init(n[0], n[1]);
                }
                setZoomOptions() {
                    let t = this.options.chart, e = t.zooming;
                    this.zooming = {
                        ...e,
                        type: G(t.zoomType, e.type),
                        key: G(t.zoomKey, e.key),
                        pinchType: G(t.pinchType, e.pinchType),
                        singleTouch: G(t.zoomBySingleTouch, e.singleTouch, !1),
                        resetButton: _(e.resetButton, t.resetZoomButton)
                    };
                }
                init(t, e) {
                    F(this, "init", {
                        args: arguments
                    }, function() {
                        let i = _(b, t), n = i.chart;
                        this.userOptions = I({}, t), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = e, this.isResizing = 0, this.options = i, this.axes = [], this.series = [], this.time = t.time && Object.keys(t.time).length ? new c(t.time) : o.time, this.numberFormatter = n.numberFormatter || x, this.styledMode = n.styledMode, this.hasCartesianSeries = n.showAxes, this.index = w.length, w.push(this), o.chartCount++, v(this, n), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), F(this, "afterInit"), this.firstRender();
                    });
                }
                initSeries(t) {
                    let e = this.options.chart, i = t.type || e.type, n = E[i];
                    n || N(17, !0, this, {
                        missingModuleFor: i
                    });
                    let r = new n;
                    return "function" == typeof r.init && r.init(this, t), r;
                }
                setSortedData() {
                    this.getSeriesOrderByLinks().forEach(function(t) {
                        t.points || t.data || !t.enabledDataSorting || t.setData(t.options.data, !1);
                    });
                }
                getSeriesOrderByLinks() {
                    return this.series.concat().sort(function(t, e) {
                        return t.linkedSeries.length || e.linkedSeries.length ? e.linkedSeries.length - t.linkedSeries.length : 0;
                    });
                }
                orderItems(t, e = 0) {
                    let i = this[t], n = this.options[t] = K(this.options[t]).slice(), r = this.userOptions[t] = this.userOptions[t] ? K(this.userOptions[t]).slice() : [];
                    if (this.hasRendered && (n.splice(e), r.splice(e)), i) for(let t = e, o = i.length; t < o; ++t){
                        let e = i[t];
                        e && (e.index = t, e instanceof a && (e.name = e.getName()), e.options.isInternal || (n[t] = e.options, r[t] = e.userOptions));
                    }
                }
                isInsidePlot(t, e, i = {}) {
                    let { inverted: n, plotBox: r, plotLeft: o, plotTop: s, scrollablePlotBox: a } = this, { scrollLeft: l = 0, scrollTop: h = 0 } = i.visiblePlotOnly && this.scrollablePlotArea?.scrollingContainer || {}, c = i.series, d = i.visiblePlotOnly && a || r, u = i.inverted ? e : t, p = i.inverted ? t : e, f = {
                        x: u,
                        y: p,
                        isInsidePlot: !0,
                        options: i
                    };
                    if (!i.ignoreX) {
                        let t = c && (n && !this.polar ? c.yAxis : c.xAxis) || {
                            pos: o,
                            len: 1 / 0
                        }, e = i.paneCoordinates ? t.pos + u : o + u;
                        e >= Math.max(l + o, t.pos) && e <= Math.min(l + o + d.width, t.pos + t.len) || (f.isInsidePlot = !1);
                    }
                    if (!i.ignoreY && f.isInsidePlot) {
                        let t = !n && i.axis && !i.axis.isXAxis && i.axis || c && (n ? c.xAxis : c.yAxis) || {
                            pos: s,
                            len: 1 / 0
                        }, e = i.paneCoordinates ? t.pos + p : s + p;
                        e >= Math.max(h + s, t.pos) && e <= Math.min(h + s + d.height, t.pos + t.len) || (f.isInsidePlot = !1);
                    }
                    return F(this, "afterIsInsidePlot", f), f.isInsidePlot;
                }
                redraw(t) {
                    F(this, "beforeRedraw");
                    let e, i, n, r, o = this.hasCartesianSeries ? this.axes : this.colorAxis || [], s = this.series, a = this.pointer, l = this.legend, h = this.userOptions.legend, c = this.renderer, d = c.isHidden(), u = [], p = this.isDirtyBox, f = this.isDirtyLegend;
                    for(c.rootFontSize = c.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), m(!!this.hasRendered && t, this), d && this.temporaryDisplay(), this.layOutTitles(!1), n = s.length; n--;)if (((r = s[n]).options.stacking || r.options.centerInCategory) && (i = !0, r.isDirty)) {
                        e = !0;
                        break;
                    }
                    if (e) for(n = s.length; n--;)(r = s[n]).options.stacking && (r.isDirty = !0);
                    s.forEach(function(t) {
                        t.isDirty && ("point" === t.options.legendType ? ("function" == typeof t.updateTotals && t.updateTotals(), f = !0) : h && (h.labelFormatter || h.labelFormat) && (f = !0)), t.isDirtyData && F(t, "updatedData");
                    }), f && l && l.options.enabled && (l.render(), this.isDirtyLegend = !1), i && this.getStacks(), o.forEach(function(t) {
                        t.updateNames(), t.setScale();
                    }), this.getMargins(), o.forEach(function(t) {
                        t.isDirty && (p = !0);
                    }), o.forEach(function(t) {
                        let e = t.min + "," + t.max;
                        t.extKey !== e && (t.extKey = e, u.push(function() {
                            F(t, "afterSetExtremes", I(t.eventArgs, t.getExtremes())), delete t.eventArgs;
                        })), (p || i) && t.redraw();
                    }), p && this.drawChartBox(), F(this, "predraw"), s.forEach(function(t) {
                        (p || t.isDirty) && t.visible && t.redraw(), t.isDirtyData = !1;
                    }), a && a.reset(!0), c.draw(), F(this, "redraw"), F(this, "render"), d && this.temporaryDisplay(!0), u.forEach(function(t) {
                        t.call();
                    });
                }
                get(t) {
                    let e = this.series;
                    function i(e) {
                        return e.id === t || e.options && e.options.id === t;
                    }
                    let n = B(this.axes, i) || B(this.series, i);
                    for(let t = 0; !n && t < e.length; t++)n = B(e[t].points || [], i);
                    return n;
                }
                getAxes() {
                    let t = this.userOptions;
                    for (let i of (F(this, "getAxes"), [
                        "xAxis",
                        "yAxis"
                    ]))for (let n of t[i] = K(t[i] || {}))new e(this, n, i);
                    F(this, "afterGetAxes");
                }
                getSelectedPoints() {
                    return this.series.reduce((t, e)=>(e.getPointsCollection().forEach((e)=>{
                            G(e.selectedStaging, e.selected) && t.push(e);
                        }), t), []);
                }
                getSelectedSeries() {
                    return this.series.filter(function(t) {
                        return t.selected;
                    });
                }
                setTitle(t, e, i) {
                    this.applyDescription("title", t), this.applyDescription("subtitle", e), this.applyDescription("caption", void 0), this.layOutTitles(i);
                }
                applyDescription(t, e) {
                    let i = this, n = this.options[t] = _(this.options[t], e), r = this[t];
                    r && e && (this[t] = r = r.destroy()), n && !r && ((r = this.renderer.text(n.text, 0, 0, n.useHTML).attr({
                        align: n.align,
                        class: "highcharts-" + t,
                        zIndex: n.zIndex || 4
                    }).add()).update = function(e, n) {
                        i.applyDescription(t, e), i.layOutTitles(n);
                    }, this.styledMode || r.css(I("title" === t ? {
                        fontSize: this.options.isStock ? "1em" : "1.2em"
                    } : {}, n.style)), this[t] = r);
                }
                layOutTitles(t = !0) {
                    let e = [
                        0,
                        0,
                        0
                    ], i = this.renderer, n = this.spacingBox;
                    [
                        "title",
                        "subtitle",
                        "caption"
                    ].forEach(function(t) {
                        let r = this[t], o = this.options[t], s = o.verticalAlign || "top", a = "title" === t ? "top" === s ? -3 : 0 : "top" === s ? e[0] + 2 : 0;
                        if (r) {
                            r.css({
                                width: (o.width || n.width + (o.widthAdjust || 0)) + "px"
                            });
                            let t = i.fontMetrics(r).b, l = Math.round(r.getBBox(o.useHTML).height);
                            r.align(I({
                                y: "bottom" === s ? t : a + t,
                                height: l
                            }, o), !1, "spacingBox"), o.floating || ("top" === s ? e[0] = Math.ceil(e[0] + l) : "bottom" === s && (e[2] = Math.ceil(e[2] + l)));
                        }
                    }, this), e[0] && "top" === (this.options.title.verticalAlign || "top") && (e[0] += this.options.title.margin), e[2] && "bottom" === this.options.caption.verticalAlign && (e[2] += this.options.caption.margin);
                    let r = !this.titleOffset || this.titleOffset.join(",") !== e.join(",");
                    this.titleOffset = e, F(this, "afterLayOutTitles"), !this.isDirtyBox && r && (this.isDirtyBox = this.isDirtyLegend = r, this.hasRendered && t && this.isDirtyBox && this.redraw());
                }
                getContainerBox() {
                    let t = [].map.call(this.renderTo.children, (t)=>{
                        if (t !== this.container) {
                            let e = t.style.display;
                            return t.style.display = "none", [
                                t,
                                e
                            ];
                        }
                    }), e = {
                        width: z(this.renderTo, "width", !0) || 0,
                        height: z(this.renderTo, "height", !0) || 0
                    };
                    return t.filter(Boolean).forEach(([t, e])=>{
                        t.style.display = e;
                    }), e;
                }
                getChartSize() {
                    let t = this.options.chart, e = t.width, i = t.height, n = this.getContainerBox(), r = n.height > 1 && !(!this.renderTo.parentElement?.style.height && "100%" === this.renderTo.style.height);
                    this.chartWidth = Math.max(0, e || n.width || 600), this.chartHeight = Math.max(0, V(i, this.chartWidth) || (r ? n.height : 400)), this.containerBox = n;
                }
                temporaryDisplay(t) {
                    let e, i = this.renderTo;
                    if (t) for(; i && i.style;)i.hcOrigStyle && (R(i, i.hcOrigStyle), delete i.hcOrigStyle), i.hcOrigDetached && (C.body.removeChild(i), i.hcOrigDetached = !1), i = i.parentNode;
                    else for(; i && i.style && (C.body.contains(i) || i.parentNode || (i.hcOrigDetached = !0, C.body.appendChild(i)), ("none" === z(i, "display", !1) || i.hcOricDetached) && (i.hcOrigStyle = {
                        display: i.style.display,
                        height: i.style.height,
                        overflow: i.style.overflow
                    }, e = {
                        display: "block",
                        overflow: "hidden"
                    }, i !== this.renderTo && (e.height = 0), R(i, e), i.offsetWidth || i.style.setProperty("display", "block", "important")), (i = i.parentNode) !== C.body););
                }
                setClassName(t) {
                    this.container.className = "highcharts-container " + (t || "");
                }
                getContainer() {
                    let t, e = this.options, i = e.chart, n = "data-highcharts-chart", r = Q(), o = this.renderTo;
                    o || (this.renderTo = o = i.renderTo), Y(o) && (this.renderTo = o = C.getElementById(o)), o || N(13, !0, this);
                    let a = q(T(o, n));
                    U(a) && w[a] && w[a].hasRendered && w[a].destroy(), T(o, n, this.index), o.innerHTML = u.emptyHTML, i.skipClone || o.offsetWidth || this.temporaryDisplay(), this.getChartSize();
                    let l = this.chartHeight, c = this.chartWidth;
                    R(o, {
                        overflow: "hidden"
                    }), this.styledMode || (t = I({
                        position: "relative",
                        overflow: "hidden",
                        width: c + "px",
                        height: l + "px",
                        textAlign: "left",
                        lineHeight: "normal",
                        zIndex: 0,
                        "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                        userSelect: "none",
                        "touch-action": "manipulation",
                        outline: "none",
                        padding: "0px"
                    }, i.style || {}));
                    let d = P("div", {
                        id: r
                    }, t, o);
                    this.container = d, this.getChartSize(), c === this.chartWidth || (c = this.chartWidth, this.styledMode || R(d, {
                        width: G(i.style?.width, c + "px")
                    })), this.containerBox = this.getContainerBox(), this._cursor = d.style.cursor;
                    let p = i.renderer || !k ? s.getRendererType(i.renderer) : h;
                    if (this.renderer = new p(d, c, l, void 0, i.forExport, e.exporting && e.exporting.allowHTML, this.styledMode), m(void 0, this), this.setClassName(i.className), this.styledMode) for(let t in e.defs)this.renderer.definition(e.defs[t]);
                    else this.renderer.setStyle(i.style);
                    this.renderer.chartIndex = this.index, F(this, "afterGetContainer");
                }
                getMargins(t) {
                    let { spacing: e, margin: i, titleOffset: n } = this;
                    this.resetMargins(), n[0] && !L(i[0]) && (this.plotTop = Math.max(this.plotTop, n[0] + e[0])), n[2] && !L(i[2]) && (this.marginBottom = Math.max(this.marginBottom, n[2] + e[2])), this.legend && this.legend.display && this.legend.adjustMargins(i, e), F(this, "getMargins"), t || this.getAxisMargins();
                }
                getAxisMargins() {
                    let t = this, e = t.axisOffset = [
                        0,
                        0,
                        0,
                        0
                    ], i = t.colorAxis, n = t.margin, r = function(t) {
                        t.forEach(function(t) {
                            t.visible && t.getOffset();
                        });
                    };
                    t.hasCartesianSeries ? r(t.axes) : i && i.length && r(i), S.forEach(function(i, r) {
                        L(n[r]) || (t[i] += e[r]);
                    }), t.setChartSize();
                }
                getOptions() {
                    return O(this.userOptions, b);
                }
                reflow(t) {
                    let e = this, i = e.containerBox, n = e.getContainerBox();
                    delete e.pointer?.chartPosition, !e.isPrinting && !e.isResizing && i && n.width && ((n.width !== i.width || n.height !== i.height) && (d.clearTimeout(e.reflowTimeout), e.reflowTimeout = Z(function() {
                        e.container && e.setSize(void 0, void 0, !1);
                    }, t ? 100 : 0)), e.containerBox = n);
                }
                setReflow() {
                    let t = this, e = (e)=>{
                        t.options?.chart.reflow && t.hasLoaded && t.reflow(e);
                    };
                    if ("function" == typeof ResizeObserver) new ResizeObserver(e).observe(t.renderTo);
                    else {
                        let t = M(A, "resize", e);
                        M(this, "destroy", t);
                    }
                }
                setSize(t, e, i) {
                    let n = this, r = n.renderer;
                    n.isResizing += 1, m(i, n);
                    let o = r.globalAnimation;
                    n.oldChartHeight = n.chartHeight, n.oldChartWidth = n.chartWidth, void 0 !== t && (n.options.chart.width = t), void 0 !== e && (n.options.chart.height = e), n.getChartSize();
                    let { chartWidth: s, chartHeight: a, scrollablePixelsX: l = 0, scrollablePixelsY: h = 0 } = n;
                    (n.isDirtyBox || s !== n.oldChartWidth || a !== n.oldChartHeight) && (n.styledMode || (o ? f : R)(n.container, {
                        width: `${s + l}px`,
                        height: `${a + h}px`
                    }, o), n.setChartSize(!0), r.setSize(s, a, o), n.axes.forEach(function(t) {
                        t.isDirty = !0, t.setScale();
                    }), n.isDirtyLegend = !0, n.isDirtyBox = !0, n.layOutTitles(), n.getMargins(), n.redraw(o), n.oldChartHeight = void 0, F(n, "resize"), setTimeout(()=>{
                        n && F(n, "endResize");
                    }, g(o).duration)), n.isResizing -= 1;
                }
                setChartSize(t) {
                    let e, i, n, r, { chartHeight: o, chartWidth: s, inverted: a, spacing: l, renderer: h } = this, c = this.clipOffset, d = Math[a ? "floor" : "round"];
                    this.plotLeft = e = Math.round(this.plotLeft), this.plotTop = i = Math.round(this.plotTop), this.plotWidth = n = Math.max(0, Math.round(s - e - this.marginRight)), this.plotHeight = r = Math.max(0, Math.round(o - i - this.marginBottom)), this.plotSizeX = a ? r : n, this.plotSizeY = a ? n : r, this.spacingBox = h.spacingBox = {
                        x: l[3],
                        y: l[0],
                        width: s - l[3] - l[1],
                        height: o - l[0] - l[2]
                    }, this.plotBox = h.plotBox = {
                        x: e,
                        y: i,
                        width: n,
                        height: r
                    }, c && (this.clipBox = {
                        x: d(c[3]),
                        y: d(c[0]),
                        width: d(this.plotSizeX - c[1] - c[3]),
                        height: d(this.plotSizeY - c[0] - c[2])
                    }), t || (this.axes.forEach(function(t) {
                        t.setAxisSize(), t.setAxisTranslation();
                    }), h.alignElements()), F(this, "afterSetChartSize", {
                        skipAxes: t
                    });
                }
                resetMargins() {
                    F(this, "resetMargins");
                    let t = this, e = t.options.chart, i = e.plotBorderWidth || 0, n = i / 2;
                    [
                        "margin",
                        "spacing"
                    ].forEach(function(i) {
                        let n = e[i], r = W(n) ? n : [
                            n,
                            n,
                            n,
                            n
                        ];
                        [
                            "Top",
                            "Right",
                            "Bottom",
                            "Left"
                        ].forEach(function(n, o) {
                            t[i][o] = G(e[i + n], r[o]);
                        });
                    }), S.forEach(function(e, i) {
                        t[e] = G(t.margin[i], t.spacing[i]);
                    }), t.axisOffset = [
                        0,
                        0,
                        0,
                        0
                    ], t.clipOffset = [
                        n,
                        n,
                        n,
                        n
                    ], t.plotBorderWidth = i;
                }
                drawChartBox() {
                    let t, e, i, n = this.options.chart, r = this.renderer, o = this.chartWidth, s = this.chartHeight, a = this.styledMode, l = this.plotBGImage, h = n.backgroundColor, c = n.plotBackgroundColor, d = n.plotBackgroundImage, u = this.plotLeft, p = this.plotTop, f = this.plotWidth, g = this.plotHeight, m = this.plotBox, b = this.clipRect, y = this.clipBox, x = this.chartBackground, v = this.plotBackground, w = this.plotBorder, C = "animate";
                    x || (this.chartBackground = x = r.rect().addClass("highcharts-background").add(), C = "attr"), a ? t = e = x.strokeWidth() : (e = (t = n.borderWidth || 0) + (n.shadow ? 8 : 0), i = {
                        fill: h || "none"
                    }, (t || x["stroke-width"]) && (i.stroke = n.borderColor, i["stroke-width"] = t), x.attr(i).shadow(n.shadow)), x[C]({
                        x: e / 2,
                        y: e / 2,
                        width: o - e - t % 2,
                        height: s - e - t % 2,
                        r: n.borderRadius
                    }), C = "animate", v || (C = "attr", this.plotBackground = v = r.rect().addClass("highcharts-plot-background").add()), v[C](m), !a && (v.attr({
                        fill: c || "none"
                    }).shadow(n.plotShadow), d && (l ? (d !== l.attr("href") && l.attr("href", d), l.animate(m)) : this.plotBGImage = r.image(d, u, p, f, g).add())), b ? b.animate({
                        width: y.width,
                        height: y.height
                    }) : this.clipRect = r.clipRect(y), C = "animate", w || (C = "attr", this.plotBorder = w = r.rect().addClass("highcharts-plot-border").attr({
                        zIndex: 1
                    }).add()), a || w.attr({
                        stroke: n.plotBorderColor,
                        "stroke-width": n.plotBorderWidth || 0,
                        fill: "none"
                    }), w[C](w.crisp({
                        x: u,
                        y: p,
                        width: f,
                        height: g
                    }, -w.strokeWidth())), this.isDirtyBox = !1, F(this, "afterDrawChartBox");
                }
                propFromSeries() {
                    let t, e, i, n = this, r = n.options.chart, o = n.options.series;
                    [
                        "inverted",
                        "angular",
                        "polar"
                    ].forEach(function(s) {
                        for(e = E[r.type], i = r[s] || e && e.prototype[s], t = o && o.length; !i && t--;)(e = E[o[t].type]) && e.prototype[s] && (i = !0);
                        n[s] = i;
                    });
                }
                linkSeries(t) {
                    let e = this, i = e.series;
                    i.forEach(function(t) {
                        t.linkedSeries.length = 0;
                    }), i.forEach(function(t) {
                        let { linkedTo: i } = t.options;
                        if (Y(i)) {
                            let n;
                            (n = ":previous" === i ? e.series[t.index - 1] : e.get(i)) && n.linkedParent !== t && (n.linkedSeries.push(t), t.linkedParent = n, n.enabledDataSorting && t.setDataSortingOptions(), t.visible = G(t.options.visible, n.options.visible, t.visible));
                        }
                    }), F(this, "afterLinkSeries", {
                        isUpdating: t
                    });
                }
                renderSeries() {
                    this.series.forEach(function(t) {
                        t.translate(), t.render();
                    });
                }
                render() {
                    let t, e = this.axes, i = this.colorAxis, n = this.renderer, r = this.options.chart.axisLayoutRuns || 2, o = (t)=>{
                        t.forEach((t)=>{
                            t.visible && t.render();
                        });
                    }, s = 0, a = !0, l = 0;
                    for (let t of (this.setTitle(), F(this, "beforeMargins"), this.getStacks?.(), this.getMargins(!0), this.setChartSize(), e)){
                        let { options: e } = t, { labels: i } = e;
                        if (this.hasCartesianSeries && t.horiz && t.visible && i.enabled && t.series.length && "colorAxis" !== t.coll && !this.polar) {
                            s = e.tickLength, t.createGroups();
                            let n = new p(t, 0, "", !0), r = n.createLabel("x", i);
                            if (n.destroy(), r && G(i.reserveSpace, !U(e.crossing)) && (s = r.getBBox().height + i.distance + Math.max(e.offset || 0, 0)), s) {
                                r?.destroy();
                                break;
                            }
                        }
                    }
                    for(this.plotHeight = Math.max(this.plotHeight - s, 0); (a || t || r > 1) && l < r;){
                        let i = this.plotWidth, n = this.plotHeight;
                        for (let i of e)0 === l ? i.setScale() : (i.horiz && a || !i.horiz && t) && i.setTickInterval(!0);
                        0 === l ? this.getAxisMargins() : this.getMargins(), a = i / this.plotWidth > (l ? 1 : 1.1), t = n / this.plotHeight > (l ? 1 : 1.05), l++;
                    }
                    this.drawChartBox(), this.hasCartesianSeries ? o(e) : i && i.length && o(i), this.seriesGroup || (this.seriesGroup = n.g("series-group").attr({
                        zIndex: 3
                    }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
                }
                addCredits(t) {
                    let e = this, i = _(!0, this.options.credits, t);
                    i.enabled && !this.credits && (this.credits = this.renderer.text(i.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
                        i.href && (A.location.href = i.href);
                    }).attr({
                        align: i.position.align,
                        zIndex: 8
                    }), e.styledMode || this.credits.css(i.style), this.credits.add().align(i.position), this.credits.update = function(t) {
                        e.credits = e.credits.destroy(), e.addCredits(t);
                    });
                }
                destroy() {
                    let t, e = this, i = e.axes, n = e.series, r = e.container, s = r && r.parentNode;
                    for(F(e, "destroy"), e.renderer.forExport ? j(w, e) : w[e.index] = void 0, o.chartCount--, e.renderTo.removeAttribute("data-highcharts-chart"), $(e), t = i.length; t--;)i[t] = i[t].destroy();
                    for(this.scroller && this.scroller.destroy && this.scroller.destroy(), t = n.length; t--;)n[t] = n[t].destroy();
                    [
                        "title",
                        "subtitle",
                        "chartBackground",
                        "plotBackground",
                        "plotBGImage",
                        "plotBorder",
                        "seriesGroup",
                        "clipRect",
                        "credits",
                        "pointer",
                        "rangeSelector",
                        "legend",
                        "resetZoomButton",
                        "tooltip",
                        "renderer"
                    ].forEach(function(t) {
                        let i = e[t];
                        i && i.destroy && (e[t] = i.destroy());
                    }), r && (r.innerHTML = u.emptyHTML, $(r), s && D(r)), X(e, function(t, i) {
                        delete e[i];
                    });
                }
                firstRender() {
                    let t = this, e = t.options;
                    t.getContainer(), t.resetMargins(), t.setChartSize(), t.propFromSeries(), t.getAxes();
                    let i = H(e.series) ? e.series : [];
                    e.series = [], i.forEach(function(e) {
                        t.initSeries(e);
                    }), t.linkSeries(), t.setSortedData(), F(t, "beforeRender"), t.render(), t.pointer?.getChartPosition(), t.renderer.imgCount || t.hasLoaded || t.onload(), t.temporaryDisplay(!0);
                }
                onload() {
                    this.callbacks.concat([
                        this.callback
                    ]).forEach(function(t) {
                        t && void 0 !== this.index && t.apply(this, [
                            this
                        ]);
                    }, this), F(this, "load"), F(this, "render"), L(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
                }
                warnIfA11yModuleNotLoaded() {
                    let { options: t, title: e } = this;
                    !t || this.accessibility || (this.renderer.boxWrapper.attr({
                        role: "img",
                        "aria-label": (e && e.element.textContent || "").replace(/</g, "&lt;")
                    }), t.accessibility && !1 === t.accessibility.enabled || N('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
                }
                addSeries(t, e, i) {
                    let n, r = this;
                    return t && (e = G(e, !0), F(r, "addSeries", {
                        options: t
                    }, function() {
                        n = r.initSeries(t), r.isDirtyLegend = !0, r.linkSeries(), n.enabledDataSorting && n.setData(t.data, !1), F(r, "afterAddSeries", {
                            series: n
                        }), e && r.redraw(i);
                    })), n;
                }
                addAxis(t, e, i, n) {
                    return this.createAxis(e ? "xAxis" : "yAxis", {
                        axis: t,
                        redraw: i,
                        animation: n
                    });
                }
                addColorAxis(t, e, i) {
                    return this.createAxis("colorAxis", {
                        axis: t,
                        redraw: e,
                        animation: i
                    });
                }
                createAxis(t, i) {
                    let n = new e(this, i.axis, t);
                    return G(i.redraw, !0) && this.redraw(i.animation), n;
                }
                showLoading(t) {
                    let e = this, i = e.options, n = i.loading, r = function() {
                        o && R(o, {
                            left: e.plotLeft + "px",
                            top: e.plotTop + "px",
                            width: e.plotWidth + "px",
                            height: e.plotHeight + "px"
                        });
                    }, o = e.loadingDiv, s = e.loadingSpan;
                    o || (e.loadingDiv = o = P("div", {
                        className: "highcharts-loading highcharts-loading-hidden"
                    }, null, e.container)), s || (e.loadingSpan = s = P("span", {
                        className: "highcharts-loading-inner"
                    }, null, o), M(e, "redraw", r)), o.className = "highcharts-loading", u.setElementHTML(s, G(t, i.lang.loading, "")), e.styledMode || (R(o, I(n.style, {
                        zIndex: 10
                    })), R(s, n.labelStyle), e.loadingShown || (R(o, {
                        opacity: 0,
                        display: ""
                    }), f(o, {
                        opacity: n.style.opacity || .5
                    }, {
                        duration: n.showDuration || 0
                    }))), e.loadingShown = !0, r();
                }
                hideLoading() {
                    let t = this.options, e = this.loadingDiv;
                    e && (e.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || f(e, {
                        opacity: 0
                    }, {
                        duration: t.loading.hideDuration || 100,
                        complete: function() {
                            R(e, {
                                display: "none"
                            });
                        }
                    })), this.loadingShown = !1;
                }
                update(t, e, i, n) {
                    let r, o, s, a = this, l = {
                        credits: "addCredits",
                        title: "setTitle",
                        subtitle: "setSubtitle",
                        caption: "setCaption"
                    }, h = t.isResponsiveOptions, d = [];
                    F(a, "update", {
                        options: t
                    }), h || a.setResponsive(!1, !0), t = O(t, a.options), a.userOptions = _(a.userOptions, t);
                    let u = t.chart;
                    u && (_(!0, a.options.chart, u), this.setZoomOptions(), "className" in u && a.setClassName(u.className), ("inverted" in u || "polar" in u || "type" in u) && (a.propFromSeries(), r = !0), "alignTicks" in u && (r = !0), "events" in u && v(this, u), X(u, function(t, e) {
                        -1 !== a.propsRequireUpdateSeries.indexOf("chart." + e) && (o = !0), -1 !== a.propsRequireDirtyBox.indexOf(e) && (a.isDirtyBox = !0), -1 === a.propsRequireReflow.indexOf(e) || (a.isDirtyBox = !0, h || (s = !0));
                    }), !a.styledMode && u.style && a.renderer.setStyle(a.options.chart.style || {})), !a.styledMode && t.colors && (this.options.colors = t.colors), t.time && (this.time === y && (this.time = new c(t.time)), _(!0, a.options.time, t.time)), X(t, function(e, i) {
                        a[i] && "function" == typeof a[i].update ? a[i].update(e, !1) : "function" == typeof a[l[i]] ? a[l[i]](e) : "colors" !== i && -1 === a.collectionsWithUpdate.indexOf(i) && _(!0, a.options[i], t[i]), "chart" !== i && -1 !== a.propsRequireUpdateSeries.indexOf(i) && (o = !0);
                    }), this.collectionsWithUpdate.forEach(function(e) {
                        t[e] && (K(t[e]).forEach(function(t, n) {
                            let r, o = L(t.id);
                            o && (r = a.get(t.id)), !r && a[e] && (r = a[e][G(t.index, n)]) && (o && L(r.options.id) || r.options.isInternal) && (r = void 0), r && r.coll === e && (r.update(t, !1), i && (r.touched = !0)), !r && i && a.collectionsWithInit[e] && (a.collectionsWithInit[e][0].apply(a, [
                                t
                            ].concat(a.collectionsWithInit[e][1] || []).concat([
                                !1
                            ])).touched = !0);
                        }), i && a[e].forEach(function(t) {
                            t.touched || t.options.isInternal ? delete t.touched : d.push(t);
                        }));
                    }), d.forEach(function(t) {
                        t.chart && t.remove && t.remove(!1);
                    }), r && a.axes.forEach(function(t) {
                        t.update({}, !1);
                    }), o && a.getSeriesOrderByLinks().forEach(function(t) {
                        t.chart && t.update({}, !1);
                    }, this);
                    let p = u && u.width, f = u && (Y(u.height) ? V(u.height, p || a.chartWidth) : u.height);
                    s || U(p) && p !== a.chartWidth || U(f) && f !== a.chartHeight ? a.setSize(p, f, n) : G(e, !0) && a.redraw(n), F(a, "afterUpdate", {
                        options: t,
                        redraw: e,
                        animation: n
                    });
                }
                setSubtitle(t, e) {
                    this.applyDescription("subtitle", t), this.layOutTitles(e);
                }
                setCaption(t, e) {
                    this.applyDescription("caption", t), this.layOutTitles(e);
                }
                showResetZoom() {
                    let t = this, e = b.lang, i = t.zooming.resetButton, n = i.theme, r = "chart" === i.relativeTo || "spacingBox" === i.relativeTo ? null : "plotBox";
                    function o() {
                        t.zoomOut();
                    }
                    F(this, "beforeShowResetZoom", null, function() {
                        t.resetZoomButton = t.renderer.button(e.resetZoom, null, null, o, n).attr({
                            align: i.position.align,
                            title: e.resetZoomTitle
                        }).addClass("highcharts-reset-zoom").add().align(i.position, !1, r);
                    }), F(this, "afterShowResetZoom");
                }
                zoomOut() {
                    F(this, "selection", {
                        resetSelection: !0
                    }, ()=>this.transform({
                            reset: !0,
                            trigger: "zoom"
                        }));
                }
                pan(t, e) {
                    let i = this, n = "object" == typeof e ? e : {
                        enabled: e,
                        type: "x"
                    }, r = n.type, o = r && i[({
                        x: "xAxis",
                        xy: "axes",
                        y: "yAxis"
                    })[r]].filter((t)=>t.options.panningEnabled && !t.options.isInternal), s = i.options.chart;
                    s?.panning && (s.panning = n), F(this, "pan", {
                        originalEvent: t
                    }, ()=>{
                        i.transform({
                            axes: o,
                            event: t,
                            to: {
                                x: t.chartX - (i.mouseDownX || 0),
                                y: t.chartY - (i.mouseDownY || 0)
                            },
                            trigger: "pan"
                        }), R(i.container, {
                            cursor: "move"
                        });
                    });
                }
                transform(t) {
                    let e, i, { axes: n = this.axes, event: r, from: o = {}, reset: s, selection: a, to: l = {}, trigger: h } = t, { inverted: c } = this, d = !1;
                    for (let t of (this.hoverPoints?.forEach((t)=>t.setState()), n)){
                        let { horiz: n, len: u, minPointOffset: p = 0, options: f, reversed: g } = t, m = n ? "width" : "height", b = n ? "x" : "y", y = G(l[m], t.len), x = G(o[m], t.len), v = 10 > Math.abs(y) ? 1 : y / x, w = (o[b] || 0) + x / 2 - t.pos, C = w - ((l[b] ?? t.pos) + y / 2 - t.pos) / v, S = g && !c || !g && c ? -1 : 1;
                        if (!s && (w < 0 || w > t.len)) continue;
                        let k = t.toValue(C, !0) + (a || t.isOrdinal ? 0 : p * S), A = t.toValue(C + u / v, !0) - (a || t.isOrdinal ? 0 : p * S || 0), E = t.allExtremes;
                        if (k > A && ([k, A] = [
                            A,
                            k
                        ]), 1 === v && !s && "yAxis" === t.coll && !E) {
                            for (let e of t.series){
                                let t = e.getExtremes(e.getProcessedData(!0).yData, !0);
                                E ?? (E = {
                                    dataMin: Number.MAX_VALUE,
                                    dataMax: -Number.MAX_VALUE
                                }), U(t.dataMin) && U(t.dataMax) && (E.dataMin = Math.min(t.dataMin, E.dataMin), E.dataMax = Math.max(t.dataMax, E.dataMax));
                            }
                            t.allExtremes = E;
                        }
                        let { dataMin: M, dataMax: T, min: P, max: R } = I(t.getExtremes(), E || {}), O = M ?? f.min, D = T ?? f.max, j = A - k, N = t.categories ? 0 : Math.min(j, D - O), B = O - N * (L(f.min) ? 0 : f.minPadding), F = D + N * (L(f.max) ? 0 : f.maxPadding), z = t.allowZoomOutside || 1 === v || "zoom" !== h && v > 1, H = Math.min(f.min ?? B, B, z ? P : B), W = Math.max(f.max ?? F, F, z ? R : F);
                        (!t.isOrdinal || t.options.overscroll || 1 !== v || s) && (k < H && (k = H, v >= 1 && (A = k + j)), A > W && (A = W, v >= 1 && (k = A - j)), (s || t.series.length && (k !== P || A !== R) && k >= H && A <= W) && (a ? a[t.coll].push({
                            axis: t,
                            min: k,
                            max: A
                        }) : (t.isPanning = "zoom" !== h, t.isPanning && (i = !0), t.setExtremes(s ? void 0 : k, s ? void 0 : A, !1, !1, {
                            move: C,
                            trigger: h,
                            scale: v
                        }), !s && (k > H || A < W) && "mousewheel" !== h && (e = !0)), d = !0), r && (this[n ? "mouseDownX" : "mouseDownY"] = r[n ? "chartX" : "chartY"]));
                    }
                    return d && (a ? F(this, "selection", a, ()=>{
                        delete t.selection, t.trigger = "zoom", this.transform(t);
                    }) : (!e || i || this.resetZoomButton ? !e && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw("zoom" === h && (this.options.chart.animation ?? this.pointCount < 100)))), d;
                }
            }
            return I(J.prototype, {
                callbacks: [],
                collectionsWithInit: {
                    xAxis: [
                        J.prototype.addAxis,
                        [
                            !0
                        ]
                    ],
                    yAxis: [
                        J.prototype.addAxis,
                        [
                            !1
                        ]
                    ],
                    series: [
                        J.prototype.addSeries
                    ]
                },
                collectionsWithUpdate: [
                    "xAxis",
                    "yAxis",
                    "series"
                ],
                propsRequireDirtyBox: [
                    "backgroundColor",
                    "borderColor",
                    "borderWidth",
                    "borderRadius",
                    "plotBackgroundColor",
                    "plotBackgroundImage",
                    "plotBorderColor",
                    "plotBorderWidth",
                    "plotShadow",
                    "shadow"
                ],
                propsRequireReflow: [
                    "margin",
                    "marginTop",
                    "marginRight",
                    "marginBottom",
                    "marginLeft",
                    "spacing",
                    "spacingTop",
                    "spacingRight",
                    "spacingBottom",
                    "spacingLeft"
                ],
                propsRequireUpdateSeries: [
                    "chart.inverted",
                    "chart.polar",
                    "chart.ignoreHiddenSeries",
                    "chart.type",
                    "colors",
                    "plotOptions",
                    "time",
                    "tooltip"
                ]
            }), J;
        }), i(e, "Extensions/ScrollablePlotArea.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Globals.js"],
            e["Core/Renderer/RendererRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { stop: r } = t, { composed: o } = e, { addEvent: s, createElement: a, css: l, defined: h, merge: c, pushUnique: d } = n;
            function u() {
                let t = this.scrollablePlotArea;
                (this.scrollablePixelsX || this.scrollablePixelsY) && !t && (this.scrollablePlotArea = t = new f(this)), t?.applyFixed();
            }
            function p() {
                this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
            }
            class f {
                static compose(t, e, i) {
                    d(o, this.compose) && (s(t, "afterInit", p), s(e, "afterSetChartSize", (t)=>this.afterSetSize(t.target, t)), s(e, "render", u), s(i, "show", p));
                }
                static afterSetSize(t, e) {
                    let i, n, r, { minWidth: o, minHeight: s } = t.options.chart.scrollablePlotArea || {}, { clipBox: a, plotBox: l, inverted: d, renderer: u } = t;
                    if (!u.forExport && (o ? (t.scrollablePixelsX = i = Math.max(0, o - t.chartWidth), i && (t.scrollablePlotBox = c(t.plotBox), l.width = t.plotWidth += i, a[d ? "height" : "width"] += i, r = !0)) : s && (t.scrollablePixelsY = n = Math.max(0, s - t.chartHeight), h(n) && (t.scrollablePlotBox = c(t.plotBox), l.height = t.plotHeight += n, a[d ? "width" : "height"] += n, r = !1)), h(r) && !e.skipAxes)) for (let e of t.axes)e.horiz === r && (e.setAxisSize(), e.setAxisTranslation());
                }
                constructor(t){
                    let e, n = t.options.chart, r = i.getRendererType(), o = n.scrollablePlotArea || {}, h = this.moveFixedElements.bind(this), c = {
                        WebkitOverflowScrolling: "touch",
                        overflowX: "hidden",
                        overflowY: "hidden"
                    };
                    t.scrollablePixelsX && (c.overflowX = "auto"), t.scrollablePixelsY && (c.overflowY = "auto"), this.chart = t;
                    let d = this.parentDiv = a("div", {
                        className: "highcharts-scrolling-parent"
                    }, {
                        position: "relative"
                    }, t.renderTo), u = this.scrollingContainer = a("div", {
                        className: "highcharts-scrolling"
                    }, c, d), p = this.innerContainer = a("div", {
                        className: "highcharts-inner-container"
                    }, void 0, u), f = this.fixedDiv = a("div", {
                        className: "highcharts-fixed"
                    }, {
                        position: "absolute",
                        overflow: "hidden",
                        pointerEvents: "none",
                        zIndex: (n.style?.zIndex || 0) + 2,
                        top: 0
                    }, void 0, !0), g = this.fixedRenderer = new r(f, t.chartWidth, t.chartHeight, n.style);
                    this.mask = g.path().attr({
                        fill: n.backgroundColor || "#fff",
                        "fill-opacity": o.opacity ?? .85,
                        zIndex: -1
                    }).addClass("highcharts-scrollable-mask").add(), u.parentNode.insertBefore(f, u), l(t.renderTo, {
                        overflow: "visible"
                    }), s(t, "afterShowResetZoom", h), s(t, "afterApplyDrilldown", h), s(t, "afterLayOutTitles", h), s(u, "scroll", ()=>{
                        let { pointer: i, hoverPoint: n } = t;
                        i && (delete i.chartPosition, n && (e = n), i.runPointActions(void 0, e, !0));
                    }), p.appendChild(t.container);
                }
                applyFixed() {
                    let { chart: t, fixedRenderer: e, isDirty: i, scrollingContainer: n } = this, { axisOffset: o, chartWidth: s, chartHeight: a, container: c, plotHeight: d, plotLeft: u, plotTop: p, plotWidth: f, scrollablePixelsX: g = 0, scrollablePixelsY: m = 0 } = t, { scrollPositionX: b = 0, scrollPositionY: y = 0 } = t.options.chart.scrollablePlotArea || {}, x = s + g, v = a + m;
                    e.setSize(s, a), (i ?? !0) && (this.isDirty = !1, this.moveFixedElements()), r(t.container), l(c, {
                        width: `${x}px`,
                        height: `${v}px`
                    }), t.renderer.boxWrapper.attr({
                        width: x,
                        height: v,
                        viewBox: [
                            0,
                            0,
                            x,
                            v
                        ].join(" ")
                    }), t.chartBackground?.attr({
                        width: x,
                        height: v
                    }), l(n, {
                        width: `${s}px`,
                        height: `${a}px`
                    }), h(i) || (n.scrollLeft = g * b, n.scrollTop = m * y);
                    let w = p - o[0] - 1, C = u - o[3] - 1, S = p + d + o[2] + 1, k = u + f + o[1] + 1, A = u + f - g, E = p + d - m, M = [
                        [
                            "M",
                            0,
                            0
                        ]
                    ];
                    g ? M = [
                        [
                            "M",
                            0,
                            w
                        ],
                        [
                            "L",
                            u - 1,
                            w
                        ],
                        [
                            "L",
                            u - 1,
                            S
                        ],
                        [
                            "L",
                            0,
                            S
                        ],
                        [
                            "Z"
                        ],
                        [
                            "M",
                            A,
                            w
                        ],
                        [
                            "L",
                            s,
                            w
                        ],
                        [
                            "L",
                            s,
                            S
                        ],
                        [
                            "L",
                            A,
                            S
                        ],
                        [
                            "Z"
                        ]
                    ] : m && (M = [
                        [
                            "M",
                            C,
                            0
                        ],
                        [
                            "L",
                            C,
                            p - 1
                        ],
                        [
                            "L",
                            k,
                            p - 1
                        ],
                        [
                            "L",
                            k,
                            0
                        ],
                        [
                            "Z"
                        ],
                        [
                            "M",
                            C,
                            E
                        ],
                        [
                            "L",
                            C,
                            a
                        ],
                        [
                            "L",
                            k,
                            a
                        ],
                        [
                            "L",
                            k,
                            E
                        ],
                        [
                            "Z"
                        ]
                    ]), "adjustHeight" !== t.redrawTrigger && this.mask.attr({
                        d: M
                    });
                }
                moveFixedElements() {
                    let t, { container: e, inverted: i, scrollablePixelsX: n, scrollablePixelsY: r } = this.chart, o = this.fixedRenderer, s = f.fixedSelectors;
                    for (let a of (n && !i ? t = ".highcharts-yaxis" : n && i || r && !i ? t = ".highcharts-xaxis" : r && i && (t = ".highcharts-yaxis"), t && s.push(`${t}:not(.highcharts-radial-axis)`, `${t}-labels:not(.highcharts-radial-axis-labels)`), s))[].forEach.call(e.querySelectorAll(a), (t)=>{
                        (t.namespaceURI === o.SVG_NS ? o.box : o.box.parentNode).appendChild(t), t.style.pointerEvents = "auto";
                    });
                }
            }
            return f.fixedSelectors = [
                ".highcharts-breadcrumbs-group",
                ".highcharts-contextbutton",
                ".highcharts-caption",
                ".highcharts-credits",
                ".highcharts-drillup-button",
                ".highcharts-legend",
                ".highcharts-legend-checkbox",
                ".highcharts-navigator-series",
                ".highcharts-navigator-xaxis",
                ".highcharts-navigator-yaxis",
                ".highcharts-navigator",
                ".highcharts-range-selector-group",
                ".highcharts-reset-zoom",
                ".highcharts-scrollbar",
                ".highcharts-subtitle",
                ".highcharts-title"
            ], f;
        }), i(e, "Core/Axis/Stacking/StackItem.js", [
            e["Core/Templating.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { format: n } = t, { series: r } = e, { destroyObjectProperties: o, fireEvent: s, isNumber: a, pick: l } = i;
            return class {
                constructor(t, e, i, n, r){
                    let o = t.chart.inverted, s = t.reversed;
                    this.axis = t;
                    let a = this.isNegative = !!i != !!s;
                    this.options = e = e || {}, this.x = n, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = r, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = {
                        align: e.align || (o ? a ? "left" : "right" : "center"),
                        verticalAlign: e.verticalAlign || (o ? "middle" : a ? "bottom" : "top"),
                        y: e.y,
                        x: e.x
                    }, this.textAlign = e.textAlign || (o ? a ? "right" : "left" : "center");
                }
                destroy() {
                    o(this, this.axis);
                }
                render(t) {
                    let e = this.axis.chart, i = this.options, r = i.format, o = r ? n(r, this, e) : i.formatter.call(this);
                    if (this.label) this.label.attr({
                        text: o,
                        visibility: "hidden"
                    });
                    else {
                        this.label = e.renderer.label(o, null, void 0, i.shape, void 0, void 0, i.useHTML, !1, "stack-labels");
                        let n = {
                            r: i.borderRadius || 0,
                            text: o,
                            padding: l(i.padding, 5),
                            visibility: "hidden"
                        };
                        e.styledMode || (n.fill = i.backgroundColor, n.stroke = i.borderColor, n["stroke-width"] = i.borderWidth, this.label.css(i.style || {})), this.label.attr(n), this.label.added || this.label.add(t);
                    }
                    this.label.labelrank = e.plotSizeY, s(this, "afterRender");
                }
                setOffset(t, e, i, n, o, h) {
                    let { alignOptions: c, axis: d, label: u, options: p, textAlign: f } = this, g = d.chart, m = this.getStackBox({
                        xOffset: t,
                        width: e,
                        boxBottom: i,
                        boxTop: n,
                        defaultX: o,
                        xAxis: h
                    }), { verticalAlign: b } = c;
                    if (u && m) {
                        let t, e = u.getBBox(void 0, 0), i = u.padding, n = "justify" === l(p.overflow, "justify");
                        c.x = p.x || 0, c.y = p.y || 0;
                        let { x: o, y: s } = this.adjustStackPosition({
                            labelBox: e,
                            verticalAlign: b,
                            textAlign: f
                        });
                        m.x -= o, m.y -= s, u.align(c, !1, m), (t = g.isInsidePlot(u.alignAttr.x + c.x + o, u.alignAttr.y + c.y + s)) || (n = !1), n && r.prototype.justifyDataLabel.call(d, u, c, u.alignAttr, e, m), u.attr({
                            x: u.alignAttr.x,
                            y: u.alignAttr.y,
                            rotation: p.rotation,
                            rotationOriginX: e.width * ({
                                left: 0,
                                center: .5,
                                right: 1
                            })[p.textAlign || "center"],
                            rotationOriginY: e.height / 2
                        }), l(!n && p.crop, !0) && (t = a(u.x) && a(u.y) && g.isInsidePlot(u.x - i + (u.width || 0), u.y) && g.isInsidePlot(u.x + i, u.y)), u[t ? "show" : "hide"]();
                    }
                    s(this, "afterSetOffset", {
                        xOffset: t,
                        width: e
                    });
                }
                adjustStackPosition({ labelBox: t, verticalAlign: e, textAlign: i }) {
                    let n = {
                        bottom: 0,
                        middle: 1,
                        top: 2,
                        right: 1,
                        center: 0,
                        left: -1
                    }, r = n[e], o = n[i];
                    return {
                        x: t.width / 2 + t.width / 2 * o,
                        y: t.height / 2 * r
                    };
                }
                getStackBox(t) {
                    let e = this.axis, i = e.chart, { boxTop: n, defaultX: r, xOffset: o, width: s, boxBottom: h } = t, c = e.stacking.usePercentage ? 100 : l(n, this.total, 0), d = e.toPixels(c), u = t.xAxis || i.xAxis[0], p = l(r, u.translate(this.x)) + o, f = Math.abs(d - e.toPixels(h || a(e.min) && e.logarithmic && e.logarithmic.lin2log(e.min) || 0)), g = i.inverted, m = this.isNegative;
                    return g ? {
                        x: (m ? d : d - f) - i.plotLeft,
                        y: u.height - p - s + u.top - i.plotTop,
                        width: f,
                        height: s
                    } : {
                        x: p + u.transB - i.plotLeft,
                        y: (m ? d - f : d) - i.plotTop,
                        width: s,
                        height: f
                    };
                }
            };
        }), i(e, "Core/Axis/Stacking/StackingAxis.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Axis/Axis.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Axis/Stacking/StackItem.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            var o;
            let { getDeferredAnimation: s } = t, { series: { prototype: a } } = i, { addEvent: l, correctFloat: h, defined: c, destroyObjectProperties: d, fireEvent: u, isArray: p, isNumber: f, objectEach: g, pick: m } = r;
            function b() {
                let t = this.inverted;
                this.axes.forEach((t)=>{
                    t.stacking && t.stacking.stacks && t.hasVisibleSeries && (t.stacking.oldStacks = t.stacking.stacks);
                }), this.series.forEach((e)=>{
                    let i = e.xAxis && e.xAxis.options || {};
                    e.options.stacking && e.reserveSpace() && (e.stackKey = [
                        e.type,
                        m(e.options.stack, ""),
                        t ? i.top : i.left,
                        t ? i.height : i.width
                    ].join(","));
                });
            }
            function y() {
                let t = this.stacking;
                if (t) {
                    let e = t.stacks;
                    g(e, (t, i)=>{
                        d(t), delete e[i];
                    }), t.stackTotalGroup?.destroy();
                }
            }
            function x() {
                this.stacking || (this.stacking = new A(this));
            }
            function v(t, e, i, n) {
                return !c(t) || t.x !== e || n && t.stackKey !== n ? t = {
                    x: e,
                    index: 0,
                    key: n,
                    stackKey: n
                } : t.index++, t.key = [
                    i,
                    e,
                    t.index
                ].join(","), t;
            }
            function w() {
                let t, e = this, i = e.yAxis, n = e.stackKey || "", r = i.stacking.stacks, o = e.processedXData, s = e.options.stacking, a = e[s + "Stacker"];
                a && [
                    n,
                    "-" + n
                ].forEach((i)=>{
                    let n, s, l, h = o.length;
                    for(; h--;)n = o[h], t = e.getStackIndicator(t, n, e.index, i), s = r[i]?.[n], (l = s?.points[t.key || ""]) && a.call(e, l, s, h);
                });
            }
            function C(t, e, i) {
                let n = e.total ? 100 / e.total : 0;
                t[0] = h(t[0] * n), t[1] = h(t[1] * n), this.stackedYData[i] = t[1];
            }
            function S(t) {
                (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? a.setStackedPoints.call(this, t, "group") : t.stacking.resetStacks());
            }
            function k(t, e) {
                let i, r, o, s, a, l, d, u, f, g = e || this.options.stacking;
                if (!g || !this.reserveSpace() || (({
                    group: "xAxis"
                })[g] || "yAxis") !== t.coll) return;
                let b = this.processedXData, y = this.processedYData, x = [], v = y.length, w = this.options, C = w.threshold || 0, S = w.startFromThreshold ? C : 0, k = w.stack, A = e ? `${this.type},${g}` : this.stackKey || "", E = "-" + A, M = this.negStacks, T = t.stacking, P = T.stacks, R = T.oldStacks;
                for(T.stacksTouched += 1, d = 0; d < v; d++){
                    u = b[d], f = y[d], l = (i = this.getStackIndicator(i, u, this.index)).key || "", P[a = (r = M && f < (S ? 0 : C)) ? E : A] || (P[a] = {}), P[a][u] || (R[a]?.[u] ? (P[a][u] = R[a][u], P[a][u].total = null) : P[a][u] = new n(t, t.options.stackLabels, !!r, u, k)), o = P[a][u], null !== f ? (o.points[l] = o.points[this.index] = [
                        m(o.cumulative, S)
                    ], c(o.cumulative) || (o.base = l), o.touched = T.stacksTouched, i.index > 0 && !1 === this.singleStacks && (o.points[l][0] = o.points[this.index + "," + u + ",0"][0])) : (delete o.points[l], delete o.points[this.index]);
                    let e = o.total || 0;
                    "percent" === g ? (s = r ? A : E, e = M && P[s]?.[u] ? (s = P[s][u]).total = Math.max(s.total || 0, e) + Math.abs(f) || 0 : h(e + (Math.abs(f) || 0))) : "group" === g ? (p(f) && (f = f[0]), null !== f && e++) : e = h(e + (f || 0)), o.cumulative = "group" === g ? (e || 1) - 1 : h(m(o.cumulative, S) + (f || 0)), o.total = e, null !== f && (o.points[l].push(o.cumulative), x[d] = o.cumulative, o.hasValidPoints = !0);
                }
                "percent" === g && (T.usePercentage = !0), "group" !== g && (this.stackedYData = x), T.oldStacks = {};
            }
            class A {
                constructor(t){
                    this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = t;
                }
                buildStacks() {
                    let t, e, i = this.axis, n = i.series, r = "xAxis" === i.coll, o = i.options.reversedStacks, s = n.length;
                    for(this.resetStacks(), this.usePercentage = !1, e = s; e--;)t = n[o ? e : s - e - 1], r && t.setGroupedPoints(i), t.setStackedPoints(i);
                    if (!r) for(e = 0; e < s; e++)n[e].modifyStacks();
                    u(i, "afterBuildStacks");
                }
                cleanStacks() {
                    this.oldStacks && (this.stacks = this.oldStacks, g(this.stacks, (t)=>{
                        g(t, (t)=>{
                            t.cumulative = t.total;
                        });
                    }));
                }
                resetStacks() {
                    g(this.stacks, (t)=>{
                        g(t, (e, i)=>{
                            f(e.touched) && e.touched < this.stacksTouched ? (e.destroy(), delete t[i]) : (e.total = null, e.cumulative = null);
                        });
                    });
                }
                renderStackTotals() {
                    let t = this.axis, e = t.chart, i = e.renderer, n = this.stacks, r = s(e, t.options.stackLabels?.animation || !1), o = this.stackTotalGroup = this.stackTotalGroup || i.g("stack-labels").attr({
                        zIndex: 6,
                        opacity: 0
                    }).add();
                    o.translate(e.plotLeft, e.plotTop), g(n, (t)=>{
                        g(t, (t)=>{
                            t.render(o);
                        });
                    }), o.animate({
                        opacity: 1
                    }, r);
                }
            }
            return (o || (o = {})).compose = function(t, e, i) {
                let n = e.prototype, r = i.prototype;
                n.getStacks || (l(t, "init", x), l(t, "destroy", y), n.getStacks = b, r.getStackIndicator = v, r.modifyStacks = w, r.percentStacker = C, r.setGroupedPoints = S, r.setStackedPoints = k);
            }, o;
        }), i(e, "Series/Line/LineSeries.js", [
            e["Core/Series/Series.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { defined: n, merge: r, isObject: o } = i;
            class s extends t {
                drawGraph() {
                    let t = this.options, e = (this.gappedPath || this.getGraphPath).call(this), i = this.chart.styledMode;
                    [
                        this,
                        ...this.zones
                    ].forEach((n, s)=>{
                        let a, l = n.graph, h = l ? "animate" : "attr", c = n.dashStyle || t.dashStyle;
                        l ? (l.endX = this.preventGraphAnimation ? null : e.xMap, l.animate({
                            d: e
                        })) : e.length && (n.graph = l = this.chart.renderer.path(e).addClass("highcharts-graph" + (s ? ` highcharts-zone-graph-${s - 1} ` : " ") + (s && n.className || "")).attr({
                            zIndex: 1
                        }).add(this.group)), l && !i && (a = {
                            stroke: !s && t.lineColor || n.color || this.color || "#cccccc",
                            "stroke-width": t.lineWidth || 0,
                            fill: this.fillGraph && this.color || "none"
                        }, c ? a.dashstyle = c : "square" !== t.linecap && (a["stroke-linecap"] = a["stroke-linejoin"] = "round"), l[h](a).shadow(s < 2 && t.shadow && r({
                            filterUnits: "userSpaceOnUse"
                        }, o(t.shadow) ? t.shadow : {}))), l && (l.startX = e.xMap, l.isArea = e.isArea);
                    });
                }
                getGraphPath(t, e, i) {
                    let r, o = this, s = o.options, a = [], l = [], h = s.step, c = (t = t || o.points).reversed;
                    return c && t.reverse(), (h = ({
                        right: 1,
                        center: 2
                    })[h] || h && 3) && c && (h = 4 - h), (t = this.getValidPoints(t, !1, !(s.connectNulls && !e && !i))).forEach(function(c, d) {
                        let u, p = c.plotX, f = c.plotY, g = t[d - 1], m = c.isNull || "number" != typeof f;
                        (c.leftCliff || g && g.rightCliff) && !i && (r = !0), m && !n(e) && d > 0 ? r = !s.connectNulls : m && !e ? r = !0 : (0 === d || r ? u = [
                            [
                                "M",
                                c.plotX,
                                c.plotY
                            ]
                        ] : o.getPointSpline ? u = [
                            o.getPointSpline(t, c, d)
                        ] : h ? (u = 1 === h ? [
                            [
                                "L",
                                g.plotX,
                                f
                            ]
                        ] : 2 === h ? [
                            [
                                "L",
                                (g.plotX + p) / 2,
                                g.plotY
                            ],
                            [
                                "L",
                                (g.plotX + p) / 2,
                                f
                            ]
                        ] : [
                            [
                                "L",
                                p,
                                g.plotY
                            ]
                        ]).push([
                            "L",
                            p,
                            f
                        ]) : u = [
                            [
                                "L",
                                p,
                                f
                            ]
                        ], l.push(c.x), h && (l.push(c.x), 2 === h && l.push(c.x)), a.push.apply(a, u), r = !1);
                    }), a.xMap = l, o.graphPath = a, a;
                }
            }
            return s.defaultOptions = r(t.defaultOptions, {
                legendSymbol: "lineMarker"
            }), e.registerSeriesType("line", s), s;
        }), i(e, "Series/Area/AreaSeriesDefaults.js", [], function() {
            return {
                threshold: 0,
                legendSymbol: "areaMarker"
            };
        }), i(e, "Series/Area/AreaSeries.js", [
            e["Series/Area/AreaSeriesDefaults.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { seriesTypes: { line: n } } = e, { extend: r, merge: o, objectEach: s, pick: a } = i;
            class l extends n {
                drawGraph() {
                    this.areaPath = [], super.drawGraph.apply(this);
                    let { areaPath: t, options: e } = this;
                    [
                        this,
                        ...this.zones
                    ].forEach((i, n)=>{
                        let r = {}, o = i.fillColor || e.fillColor, s = i.area, a = s ? "animate" : "attr";
                        s ? (s.endX = this.preventGraphAnimation ? null : t.xMap, s.animate({
                            d: t
                        })) : (r.zIndex = 0, (s = i.area = this.chart.renderer.path(t).addClass("highcharts-area" + (n ? ` highcharts-zone-area-${n - 1} ` : " ") + (n && i.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (r.fill = o || i.color || this.color, r["fill-opacity"] = o ? 1 : e.fillOpacity ?? .75, s.css({
                            pointerEvents: this.stickyTracking ? "none" : "auto"
                        })), s[a](r), s.startX = t.xMap, s.shiftUnit = e.step ? 2 : 1;
                    });
                }
                getGraphPath(t) {
                    let e, i, r, o = n.prototype.getGraphPath, s = this.options, l = s.stacking, h = this.yAxis, c = [], d = [], u = this.index, p = h.stacking.stacks[this.stackKey], f = s.threshold, g = Math.round(h.getThreshold(s.threshold)), m = a(s.connectNulls, "percent" === l), b = function(i, n, r) {
                        let o, s, a = t[i], m = l && p[a.x].points[u], b = a[r + "Null"] || 0, y = a[r + "Cliff"] || 0, x = !0;
                        y || b ? (o = (b ? m[0] : m[1]) + y, s = m[0] + y, x = !!b) : !l && t[n] && t[n].isNull && (o = s = f), void 0 !== o && (d.push({
                            plotX: e,
                            plotY: null === o ? g : h.getThreshold(o),
                            isNull: x,
                            isCliff: !0
                        }), c.push({
                            plotX: e,
                            plotY: null === s ? g : h.getThreshold(s),
                            doCurve: !1
                        }));
                    };
                    t = t || this.points, l && (t = this.getStackPoints(t));
                    for(let n = 0, o = t.length; n < o; ++n)l || (t[n].leftCliff = t[n].rightCliff = t[n].leftNull = t[n].rightNull = void 0), i = t[n].isNull, e = a(t[n].rectPlotX, t[n].plotX), r = l ? a(t[n].yBottom, g) : g, i && !m || (m || b(n, n - 1, "left"), i && !l && m || (d.push(t[n]), c.push({
                        x: n,
                        plotX: e,
                        plotY: r
                    })), m || b(n, n + 1, "right"));
                    let y = o.call(this, d, !0, !0);
                    c.reversed = !0;
                    let x = o.call(this, c, !0, !0), v = x[0];
                    v && "M" === v[0] && (x[0] = [
                        "L",
                        v[1],
                        v[2]
                    ]);
                    let w = y.concat(x);
                    w.length && w.push([
                        "Z"
                    ]);
                    let C = o.call(this, d, !1, m);
                    return this.chart.series.length > 1 && l && d.some((t)=>t.isCliff) && (w.hasStackedCliffs = C.hasStackedCliffs = !0), w.xMap = y.xMap, this.areaPath = w, C;
                }
                getStackPoints(t) {
                    let e = this, i = [], n = [], r = this.xAxis, o = this.yAxis, l = o.stacking.stacks[this.stackKey], h = {}, c = o.series, d = c.length, u = o.options.reversedStacks ? 1 : -1, p = c.indexOf(e);
                    if (t = t || this.points, this.options.stacking) {
                        for(let e = 0; e < t.length; e++)t[e].leftNull = t[e].rightNull = void 0, h[t[e].x] = t[e];
                        s(l, function(t, e) {
                            null !== t.total && n.push(e);
                        }), n.sort(function(t, e) {
                            return t - e;
                        });
                        let f = c.map((t)=>t.visible);
                        n.forEach(function(t, s) {
                            let g, m, b = 0;
                            if (h[t] && !h[t].isNull) i.push(h[t]), [
                                -1,
                                1
                            ].forEach(function(i) {
                                let r = 1 === i ? "rightNull" : "leftNull", o = l[n[s + i]], a = 0;
                                if (o) {
                                    let i = p;
                                    for(; i >= 0 && i < d;){
                                        let n = c[i].index;
                                        !(g = o.points[n]) && (n === e.index ? h[t][r] = !0 : f[i] && (m = l[t].points[n]) && (a -= m[1] - m[0])), i += u;
                                    }
                                }
                                h[t][1 === i ? "rightCliff" : "leftCliff"] = a;
                            });
                            else {
                                let e = p;
                                for(; e >= 0 && e < d;){
                                    let i = c[e].index;
                                    if (g = l[t].points[i]) {
                                        b = g[1];
                                        break;
                                    }
                                    e += u;
                                }
                                b = a(b, 0), b = o.translate(b, 0, 1, 0, 1), i.push({
                                    isNull: !0,
                                    plotX: r.translate(t, 0, 0, 0, 1),
                                    x: t,
                                    plotY: b,
                                    yBottom: b
                                });
                            }
                        });
                    }
                    return i;
                }
            }
            return l.defaultOptions = o(n.defaultOptions, t), r(l.prototype, {
                singleStacks: !1
            }), e.registerSeriesType("area", l), l;
        }), i(e, "Series/Spline/SplineSeries.js", [
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { line: i } = t.seriesTypes, { merge: n, pick: r } = e;
            class o extends i {
                getPointSpline(t, e, i) {
                    let n, o, s, a, l = e.plotX || 0, h = e.plotY || 0, c = t[i - 1], d = t[i + 1];
                    function u(t) {
                        return t && !t.isNull && !1 !== t.doCurve && !e.isCliff;
                    }
                    if (u(c) && u(d)) {
                        let t = c.plotX || 0, i = c.plotY || 0, r = d.plotX || 0, u = d.plotY || 0, p = 0;
                        n = (1.5 * l + t) / 2.5, o = (1.5 * h + i) / 2.5, s = (1.5 * l + r) / 2.5, a = (1.5 * h + u) / 2.5, s !== n && (p = (a - o) * (s - l) / (s - n) + h - a), o += p, a += p, o > i && o > h ? (o = Math.max(i, h), a = 2 * h - o) : o < i && o < h && (o = Math.min(i, h), a = 2 * h - o), a > u && a > h ? (a = Math.max(u, h), o = 2 * h - a) : a < u && a < h && (a = Math.min(u, h), o = 2 * h - a), e.rightContX = s, e.rightContY = a, e.controlPoints = {
                            low: [
                                n,
                                o
                            ],
                            high: [
                                s,
                                a
                            ]
                        };
                    }
                    let p = [
                        "C",
                        r(c.rightContX, c.plotX, 0),
                        r(c.rightContY, c.plotY, 0),
                        r(n, l, 0),
                        r(o, h, 0),
                        l,
                        h
                    ];
                    return c.rightContX = c.rightContY = void 0, p;
                }
            }
            return o.defaultOptions = n(i.defaultOptions), t.registerSeriesType("spline", o), o;
        }), i(e, "Series/AreaSpline/AreaSplineSeries.js", [
            e["Series/Spline/SplineSeries.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { area: n, area: { prototype: r } } = e.seriesTypes, { extend: o, merge: s } = i;
            class a extends t {
            }
            return a.defaultOptions = s(t.defaultOptions, n.defaultOptions), o(a.prototype, {
                getGraphPath: r.getGraphPath,
                getStackPoints: r.getStackPoints,
                drawGraph: r.drawGraph
            }), e.registerSeriesType("areaspline", a), a;
        }), i(e, "Series/Column/ColumnSeriesDefaults.js", [], function() {
            return {
                borderRadius: 3,
                centerInCategory: !1,
                groupPadding: .2,
                marker: null,
                pointPadding: .1,
                minPointLength: 0,
                cropThreshold: 50,
                pointRange: null,
                states: {
                    hover: {
                        halo: !1,
                        brightness: .1
                    },
                    select: {
                        color: "#cccccc",
                        borderColor: "#000000"
                    }
                },
                dataLabels: {
                    align: void 0,
                    verticalAlign: void 0,
                    y: void 0
                },
                startFromThreshold: !0,
                stickyTracking: !1,
                tooltip: {
                    distance: 6
                },
                threshold: 0,
                borderColor: "#ffffff"
            };
        }), i(e, "Series/Column/ColumnSeries.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Color/Color.js"],
            e["Series/Column/ColumnSeriesDefaults.js"],
            e["Core/Globals.js"],
            e["Core/Series/Series.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s) {
            let { animObject: a } = t, { parse: l } = e, { noop: h } = n, { clamp: c, crisp: d, defined: u, extend: p, fireEvent: f, isArray: g, isNumber: m, merge: b, pick: y, objectEach: x } = s;
            class v extends r {
                animate(t) {
                    let e, i, n = this, r = this.yAxis, o = r.pos, s = r.reversed, l = n.options, { clipOffset: h, inverted: d } = this.chart, u = {}, f = d ? "translateX" : "translateY";
                    t && h ? (u.scaleY = .001, i = c(r.toPixels(l.threshold), o, o + r.len), d ? (i += s ? -Math.floor(h[0]) : Math.ceil(h[2]), u.translateX = i - r.len) : (i += s ? Math.ceil(h[0]) : -Math.floor(h[2]), u.translateY = i), n.clipBox && n.setClip(), n.group.attr(u)) : (e = Number(n.group.attr(f)), n.group.animate({
                        scaleY: 1
                    }, p(a(n.options.animation), {
                        step: function(t, i) {
                            n.group && (u[f] = e + i.pos * (o - e), n.group.attr(u));
                        }
                    })));
                }
                init(t, e) {
                    super.init.apply(this, arguments);
                    let i = this;
                    (t = i.chart).hasRendered && t.series.forEach(function(t) {
                        t.type === i.type && (t.isDirty = !0);
                    });
                }
                getColumnMetrics() {
                    let t, e = this, i = e.options, n = e.xAxis, r = e.yAxis, o = n.options.reversedStacks, s = n.reversed && !o || !n.reversed && o, a = {}, l = 0;
                    !1 === i.grouping ? l = 1 : e.chart.series.forEach(function(i) {
                        let n, o = i.yAxis, s = i.options;
                        i.type === e.type && i.reserveSpace() && r.len === o.len && r.pos === o.pos && (s.stacking && "group" !== s.stacking ? (void 0 === a[t = i.stackKey] && (a[t] = l++), n = a[t]) : !1 !== s.grouping && (n = l++), i.columnIndex = n);
                    });
                    let h = Math.min(Math.abs(n.transA) * (!n.brokenAxis?.hasBreaks && n.ordinal?.slope || i.pointRange || n.closestPointRange || n.tickInterval || 1), n.len), c = h * i.groupPadding, d = (h - 2 * c) / (l || 1), u = Math.min(i.maxPointWidth || n.len, y(i.pointWidth, d * (1 - 2 * i.pointPadding))), p = (e.columnIndex || 0) + (s ? 1 : 0);
                    return e.columnMetrics = {
                        width: u,
                        offset: (d - u) / 2 + (c + p * d - h / 2) * (s ? -1 : 1),
                        paddedWidth: d,
                        columnCount: l
                    }, e.columnMetrics;
                }
                crispCol(t, e, i, n) {
                    let r = this.borderWidth, o = this.chart.inverted;
                    return n = d(e + n, r, o) - (e = d(e, r, o)), this.options.crisp && (i = d(t + i, r) - (t = d(t, r))), {
                        x: t,
                        y: e,
                        width: i,
                        height: n
                    };
                }
                adjustForMissingColumns(t, e, i, n) {
                    if (!i.isNull && n.columnCount > 1) {
                        let r = this.xAxis.series.filter((t)=>t.visible).map((t)=>t.index), o = 0, s = 0;
                        x(this.xAxis.stacking?.stacks, (t)=>{
                            if ("number" == typeof i.x) {
                                let e = t[i.x.toString()];
                                if (e && g(e.points[this.index])) {
                                    let t = Object.keys(e.points).filter((t)=>!t.match(",") && e.points[t] && e.points[t].length > 1).map(parseFloat).filter((t)=>-1 !== r.indexOf(t)).sort((t, e)=>e - t);
                                    o = t.indexOf(this.index), s = t.length;
                                }
                            }
                        }), o = this.xAxis.reversed ? s - 1 - o : o;
                        let a = (s - 1) * n.paddedWidth + e;
                        t = (i.plotX || 0) + a / 2 - e - o * n.paddedWidth;
                    }
                    return t;
                }
                translate() {
                    let t = this, e = t.chart, i = t.options, n = t.dense = t.closestPointRange * t.xAxis.transA < 2, o = t.borderWidth = y(i.borderWidth, n ? 0 : 1), s = t.xAxis, a = t.yAxis, l = i.threshold, h = y(i.minPointLength, 5), d = t.getColumnMetrics(), p = d.width, g = t.pointXOffset = d.offset, b = t.dataMin, x = t.dataMax, v = t.translatedThreshold = a.getThreshold(l), w = t.barW = Math.max(p, 1 + 2 * o);
                    i.pointPadding && (w = Math.ceil(w)), r.prototype.translate.apply(t), t.points.forEach(function(n) {
                        let r, o = y(n.yBottom, v), f = 999 + Math.abs(o), C = n.plotX || 0, S = c(n.plotY, -f, a.len + f), k = Math.min(S, o), A = Math.max(S, o) - k, E = p, M = C + g, T = w;
                        h && Math.abs(A) < h && (A = h, r = !a.reversed && !n.negative || a.reversed && n.negative, m(l) && m(x) && n.y === l && x <= l && (a.min || 0) < l && (b !== x || (a.max || 0) <= l) && (r = !r, n.negative = !n.negative), k = Math.abs(k - v) > h ? o - h : v - (r ? h : 0)), u(n.options.pointWidth) && (M -= Math.round(((E = T = Math.ceil(n.options.pointWidth)) - p) / 2)), i.centerInCategory && !i.stacking && (M = t.adjustForMissingColumns(M, E, n, d)), n.barX = M, n.pointWidth = E, n.tooltipPos = e.inverted ? [
                            c(a.len + a.pos - e.plotLeft - S, a.pos - e.plotLeft, a.len + a.pos - e.plotLeft),
                            s.len + s.pos - e.plotTop - M - T / 2,
                            A
                        ] : [
                            s.left - e.plotLeft + M + T / 2,
                            c(S + a.pos - e.plotTop, a.pos - e.plotTop, a.len + a.pos - e.plotTop),
                            A
                        ], n.shapeType = t.pointClass.prototype.shapeType || "roundedRect", n.shapeArgs = t.crispCol(M, n.isNull ? v : k, T, n.isNull ? 0 : A);
                    }), f(this, "afterColumnTranslate");
                }
                drawGraph() {
                    this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
                }
                pointAttribs(t, e) {
                    let i, n, r, o = this.options, s = this.pointAttrToOptions || {}, a = s.stroke || "borderColor", h = s["stroke-width"] || "borderWidth", c = t && t.color || this.color, d = t && t[a] || o[a] || c, u = t && t.options.dashStyle || o.dashStyle, p = t && t[h] || o[h] || this[h] || 0, f = y(t && t.opacity, o.opacity, 1);
                    t && this.zones.length && (n = t.getZone(), c = t.options.color || n && (n.color || t.nonZonedColor) || this.color, n && (d = n.borderColor || d, u = n.dashStyle || u, p = n.borderWidth || p)), e && t && (r = (i = b(o.states[e], t.options.states && t.options.states[e] || {})).brightness, c = i.color || void 0 !== r && l(c).brighten(i.brightness).get() || c, d = i[a] || d, p = i[h] || p, u = i.dashStyle || u, f = y(i.opacity, f));
                    let g = {
                        fill: c,
                        stroke: d,
                        "stroke-width": p,
                        opacity: f
                    };
                    return u && (g.dashstyle = u), g;
                }
                drawPoints(t = this.points) {
                    let e, i = this, n = this.chart, r = i.options, o = n.renderer, s = r.animationLimit || 250;
                    t.forEach(function(t) {
                        let a = t.plotY, l = t.graphic, h = !!l, c = l && n.pointCount < s ? "animate" : "attr";
                        m(a) && null !== t.y ? (e = t.shapeArgs, l && t.hasNewShapeType() && (l = l.destroy()), i.enabledDataSorting && (t.startXPos = i.xAxis.reversed ? -(e && e.width || 0) : i.xAxis.width), !l && (t.graphic = l = o[t.shapeType](e).add(t.group || i.group), l && i.enabledDataSorting && n.hasRendered && n.pointCount < s && (l.attr({
                            x: t.startXPos
                        }), h = !0, c = "animate")), l && h && l[c](b(e)), n.styledMode || l[c](i.pointAttribs(t, t.selected && "select")).shadow(!1 !== t.allowShadow && r.shadow), l && (l.addClass(t.getClassName(), !0), l.attr({
                            visibility: t.visible ? "inherit" : "hidden"
                        }))) : l && (t.graphic = l.destroy());
                    });
                }
                drawTracker(t = this.points) {
                    let e, i = this, n = i.chart, r = n.pointer, o = function(t) {
                        let e = r?.getPointFromEvent(t);
                        r && e && i.options.enableMouseTracking && (r.isDirectTouch = !0, e.onMouseOver(t));
                    };
                    t.forEach(function(t) {
                        e = g(t.dataLabels) ? t.dataLabels : t.dataLabel ? [
                            t.dataLabel
                        ] : [], t.graphic && (t.graphic.element.point = t), e.forEach(function(e) {
                            (e.div || e.element).point = t;
                        });
                    }), i._hasTracking || (i.trackerGroups.forEach(function(t) {
                        i[t] && (i[t].addClass("highcharts-tracker").on("mouseover", o).on("mouseout", function(t) {
                            r?.onTrackerMouseOut(t);
                        }).on("touchstart", o), !n.styledMode && i.options.cursor && i[t].css({
                            cursor: i.options.cursor
                        }));
                    }), i._hasTracking = !0), f(this, "afterDrawTracker");
                }
                remove() {
                    let t = this, e = t.chart;
                    e.hasRendered && e.series.forEach(function(e) {
                        e.type === t.type && (e.isDirty = !0);
                    }), r.prototype.remove.apply(t, arguments);
                }
            }
            return v.defaultOptions = b(r.defaultOptions, i), p(v.prototype, {
                directTouch: !0,
                getSymbol: h,
                negStacks: !0,
                trackerGroups: [
                    "group",
                    "dataLabelsGroup"
                ]
            }), o.registerSeriesType("column", v), v;
        }), i(e, "Core/Series/DataLabel.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Templating.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            var n;
            let { getDeferredAnimation: r } = t, { format: o } = e, { defined: s, extend: a, fireEvent: l, isArray: h, isString: c, merge: d, objectEach: u, pick: p, pInt: f, splat: g } = i;
            return function(t) {
                function e() {
                    return v(this).some((t)=>t?.enabled);
                }
                function i(t, e, i, n, r) {
                    let { chart: o, enabledDataSorting: l } = this, h = this.isCartesian && o.inverted, c = t.plotX, u = t.plotY, f = i.rotation || 0, g = s(c) && s(u) && o.isInsidePlot(c, Math.round(u), {
                        inverted: h,
                        paneCoordinates: !0,
                        series: this
                    }), m = 0 === f && "justify" === p(i.overflow, l ? "none" : "justify"), b = this.visible && !1 !== t.visible && s(c) && (t.series.forceDL || l && !m || g || p(i.inside, !!this.options.stacking) && n && o.isInsidePlot(c, h ? n.x + 1 : n.y + n.height - 1, {
                        inverted: h,
                        paneCoordinates: !0,
                        series: this
                    })), y = t.pos();
                    if (b && y) {
                        var x;
                        let s = e.getBBox(), c = e.getBBox(void 0, 0), u = {
                            right: 1,
                            center: .5
                        }[i.align || 0] || 0, v = {
                            bottom: 1,
                            middle: .5
                        }[i.verticalAlign || 0] || 0;
                        if (n = a({
                            x: y[0],
                            y: Math.round(y[1]),
                            width: 0,
                            height: 0
                        }, n || {}), "plotEdges" === i.alignTo && this.isCartesian && (n[h ? "x" : "y"] = 0, n[h ? "width" : "height"] = this.yAxis?.len || 0), a(i, {
                            width: s.width,
                            height: s.height
                        }), x = n, l && this.xAxis && !m && this.setDataLabelStartPos(t, e, r, g, x), e.align(d(i, {
                            width: c.width,
                            height: c.height
                        }), !1, n, !1), e.alignAttr.x += u * (c.width - s.width), e.alignAttr.y += v * (c.height - s.height), e[e.placed ? "animate" : "attr"]({
                            x: e.alignAttr.x + (s.width - c.width) / 2,
                            y: e.alignAttr.y + (s.height - c.height) / 2,
                            rotationOriginX: (e.width || 0) / 2,
                            rotationOriginY: (e.height || 0) / 2
                        }), m && n.height >= 0) this.justifyDataLabel(e, i, e.alignAttr, s, n, r);
                        else if (p(i.crop, !0)) {
                            let { x: t, y: i } = e.alignAttr;
                            b = o.isInsidePlot(t, i, {
                                paneCoordinates: !0,
                                series: this
                            }) && o.isInsidePlot(t + s.width - 1, i + s.height - 1, {
                                paneCoordinates: !0,
                                series: this
                            });
                        }
                        i.shape && !f && e[r ? "attr" : "animate"]({
                            anchorX: y[0],
                            anchorY: y[1]
                        });
                    }
                    r && l && (e.placed = !1), b || l && !m ? (e.show(), e.placed = !0) : (e.hide(), e.placed = !1);
                }
                function n() {
                    return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
                }
                function m(t) {
                    let e = this.hasRendered || 0, i = this.initDataLabelsGroup().attr({
                        opacity: +e
                    });
                    return !e && i && (this.visible && i.show(), this.options.animation ? i.animate({
                        opacity: 1
                    }, t) : i.attr({
                        opacity: 1
                    })), i;
                }
                function b(t) {
                    let e;
                    t = t || this.points;
                    let i = this, n = i.chart, a = i.options, h = n.renderer, { backgroundColor: d, plotBackgroundColor: m } = n.options.chart, b = h.getContrast(c(m) && m || c(d) && d || "#000000"), y = v(i), { animation: w, defer: C } = y[0], S = C ? r(n, w, i) : {
                        defer: 0,
                        duration: 0
                    };
                    l(this, "drawDataLabels"), i.hasDataLabels?.() && (e = this.initDataLabels(S), t.forEach((t)=>{
                        let r = t.dataLabels || [];
                        g(x(y, t.dlOptions || t.options?.dataLabels)).forEach((d, g)=>{
                            let m, y, x, v, w, C = d.enabled && (t.visible || t.dataLabelOnHidden) && (!t.isNull || t.dataLabelOnNull) && function(t, e) {
                                let i = e.filter;
                                if (i) {
                                    let e = i.operator, n = t[i.property], r = i.value;
                                    return ">" === e && n > r || "<" === e && n < r || ">=" === e && n >= r || "<=" === e && n <= r || "==" === e && n == r || "===" === e && n === r || "!=" === e && n != r || "!==" === e && n !== r;
                                }
                                return !0;
                            }(t, d), { backgroundColor: S, borderColor: k, distance: A, style: E = {} } = d, M = {}, T = r[g], P = !T;
                            C && (y = p(d[t.formatPrefix + "Format"], d.format), m = t.getLabelConfig(), x = s(y) ? o(y, m, n) : (d[t.formatPrefix + "Formatter"] || d.formatter).call(m, d), v = d.rotation, !n.styledMode && (E.color = p(d.color, E.color, c(i.color) ? i.color : void 0, "#000000"), "contrast" === E.color ? ("none" !== S && (w = S), t.contrastColor = h.getContrast("auto" !== w && w || t.color || i.color), E.color = w || !s(A) && d.inside || 0 > f(A || 0) || a.stacking ? t.contrastColor : b) : delete t.contrastColor, a.cursor && (E.cursor = a.cursor)), M = {
                                r: d.borderRadius || 0,
                                rotation: v,
                                padding: d.padding,
                                zIndex: 1
                            }, n.styledMode || (M.fill = "auto" === S ? t.color : S, M.stroke = "auto" === k ? t.color : k, M["stroke-width"] = d.borderWidth), u(M, (t, e)=>{
                                void 0 === t && delete M[e];
                            })), !T || C && s(x) && !!T.div == !!d.useHTML && (T.rotation && d.rotation || T.rotation === d.rotation) || (T = void 0, P = !0), C && s(x) && (T ? M.text = x : (T = h.label(x, 0, 0, d.shape, void 0, void 0, d.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + t.colorIndex + " " + (d.className || "") + (d.useHTML ? " highcharts-tracker" : "")), T && (T.options = d, T.attr(M), n.styledMode ? E.width && T.css({
                                width: E.width,
                                textOverflow: E.textOverflow
                            }) : T.css(E).shadow(d.shadow), l(T, "beforeAddingDataLabel", {
                                labelOptions: d,
                                point: t
                            }), T.added || T.add(e), i.alignDataLabel(t, T, d, void 0, P), T.isActive = !0, r[g] && r[g] !== T && r[g].destroy(), r[g] = T));
                        });
                        let d = r.length;
                        for(; d--;)r[d] && r[d].isActive ? r[d].isActive = !1 : (r[d]?.destroy(), r.splice(d, 1));
                        t.dataLabel = r[0], t.dataLabels = r;
                    })), l(this, "afterDrawDataLabels");
                }
                function y(t, e, i, n, r, o) {
                    let s, a, l = this.chart, h = e.align, c = e.verticalAlign, d = t.box ? 0 : t.padding || 0, u = l.inverted ? this.yAxis : this.xAxis, p = u ? u.left - l.plotLeft : 0, f = l.inverted ? this.xAxis : this.yAxis, g = f ? f.top - l.plotTop : 0, { x: m = 0, y: b = 0 } = e;
                    return (s = (i.x || 0) + d + p) < 0 && ("right" === h && m >= 0 ? (e.align = "left", e.inside = !0) : m -= s, a = !0), (s = (i.x || 0) + n.width - d + p) > l.plotWidth && ("left" === h && m <= 0 ? (e.align = "right", e.inside = !0) : m += l.plotWidth - s, a = !0), (s = i.y + d + g) < 0 && ("bottom" === c && b >= 0 ? (e.verticalAlign = "top", e.inside = !0) : b -= s, a = !0), (s = (i.y || 0) + n.height - d + g) > l.plotHeight && ("top" === c && b <= 0 ? (e.verticalAlign = "bottom", e.inside = !0) : b += l.plotHeight - s, a = !0), a && (e.x = m, e.y = b, t.placed = !o, t.align(e, void 0, r)), a;
                }
                function x(t, e) {
                    let i, n = [];
                    if (h(t) && !h(e)) n = t.map(function(t) {
                        return d(t, e);
                    });
                    else if (h(e) && !h(t)) n = e.map(function(e) {
                        return d(t, e);
                    });
                    else if (h(t) || h(e)) {
                        if (h(t) && h(e)) for(i = Math.max(t.length, e.length); i--;)n[i] = d(t[i], e[i]);
                    } else n = d(t, e);
                    return n;
                }
                function v(t) {
                    let e = t.chart.options.plotOptions;
                    return g(x(x(e?.series?.dataLabels, e?.[t.type]?.dataLabels), t.options.dataLabels));
                }
                function w(t, e, i, n, r) {
                    let o = this.chart, s = o.inverted, a = this.xAxis, l = a.reversed, h = ((s ? e.height : e.width) || 0) / 2, c = t.pointWidth, d = c ? c / 2 : 0;
                    e.startXPos = s ? r.x : l ? -h - d : a.width - h + d, e.startYPos = s ? l ? this.yAxis.height - h + d : -h - d : r.y, n ? "hidden" === e.visibility && (e.show(), e.attr({
                        opacity: 0
                    }).animate({
                        opacity: 1
                    })) : e.attr({
                        opacity: 1
                    }).animate({
                        opacity: 0
                    }, void 0, e.hide), o.hasRendered && (i && e.attr({
                        x: e.startXPos,
                        y: e.startYPos
                    }), e.placed = !0);
                }
                t.compose = function(t) {
                    let r = t.prototype;
                    r.initDataLabels || (r.initDataLabels = m, r.initDataLabelsGroup = n, r.alignDataLabel = i, r.drawDataLabels = b, r.justifyDataLabel = y, r.setDataLabelStartPos = w, r.hasDataLabels = e);
                };
            }(n || (n = {})), n;
        }), i(e, "Series/Column/ColumnDataLabel.js", [
            e["Core/Series/DataLabel.js"],
            e["Core/Globals.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            var r;
            let { composed: o } = e, { series: s } = i, { merge: a, pick: l, pushUnique: h } = n;
            return function(e) {
                function i(t, e, i, n, r) {
                    let o = this.chart.inverted, h = t.series, c = (h.xAxis ? h.xAxis.len : this.chart.plotSizeX) || 0, d = (h.yAxis ? h.yAxis.len : this.chart.plotSizeY) || 0, u = t.dlBox || t.shapeArgs, p = l(t.below, t.plotY > l(this.translatedThreshold, d)), f = l(i.inside, !!this.options.stacking);
                    if (u) {
                        if (n = a(u), "allow" !== i.overflow || !1 !== i.crop) {
                            n.y < 0 && (n.height += n.y, n.y = 0);
                            let t = n.y + n.height - d;
                            t > 0 && t < n.height - 1 && (n.height -= t);
                        }
                        o && (n = {
                            x: d - n.y - n.height,
                            y: c - n.x - n.width,
                            width: n.height,
                            height: n.width
                        }), f || (o ? (n.x += p ? 0 : n.width, n.width = 0) : (n.y += p ? n.height : 0, n.height = 0));
                    }
                    i.align = l(i.align, !o || f ? "center" : p ? "right" : "left"), i.verticalAlign = l(i.verticalAlign, o || f ? "middle" : p ? "top" : "bottom"), s.prototype.alignDataLabel.call(this, t, e, i, n, r), i.inside && t.contrastColor && e.css({
                        color: t.contrastColor
                    });
                }
                e.compose = function(e) {
                    t.compose(s), h(o, "ColumnDataLabel") && (e.prototype.alignDataLabel = i);
                };
            }(r || (r = {})), r;
        }), i(e, "Series/Bar/BarSeries.js", [
            e["Series/Column/ColumnSeries.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { extend: n, merge: r } = i;
            class o extends t {
            }
            return o.defaultOptions = r(t.defaultOptions, {}), n(o.prototype, {
                inverted: !0
            }), e.registerSeriesType("bar", o), o;
        }), i(e, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
            return {
                lineWidth: 0,
                findNearestPointBy: "xy",
                jitter: {
                    x: 0,
                    y: 0
                },
                marker: {
                    enabled: !0
                },
                tooltip: {
                    headerFormat: '<span style="color:{point.color}">\u25CF</span> <span style="font-size: 0.8em"> {series.name}</span><br/>',
                    pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
                }
            };
        }), i(e, "Series/Scatter/ScatterSeries.js", [
            e["Series/Scatter/ScatterSeriesDefaults.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { column: n, line: r } = e.seriesTypes, { addEvent: o, extend: s, merge: a } = i;
            class l extends r {
                applyJitter() {
                    let t = this, e = this.options.jitter, i = this.points.length;
                    e && this.points.forEach(function(n, r) {
                        [
                            "x",
                            "y"
                        ].forEach(function(o, s) {
                            if (e[o] && !n.isNull) {
                                let a = `plot${o.toUpperCase()}`, l = t[`${o}Axis`], h = e[o] * l.transA;
                                if (l && !l.logarithmic) {
                                    let t = Math.max(0, (n[a] || 0) - h), e = Math.min(l.len, (n[a] || 0) + h);
                                    n[a] = t + (e - t) * function(t) {
                                        let e = 1e4 * Math.sin(t);
                                        return e - Math.floor(e);
                                    }(r + s * i), "x" === o && (n.clientX = n.plotX);
                                }
                            }
                        });
                    });
                }
                drawGraph() {
                    this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
                }
            }
            return l.defaultOptions = a(r.defaultOptions, t), s(l.prototype, {
                drawTracker: n.prototype.drawTracker,
                sorted: !1,
                requireSorting: !1,
                noSharedTooltip: !0,
                trackerGroups: [
                    "group",
                    "markerGroup",
                    "dataLabelsGroup"
                ]
            }), o(l, "afterTranslate", function() {
                this.applyJitter();
            }), e.registerSeriesType("scatter", l), l;
        }), i(e, "Series/CenteredUtilities.js", [
            e["Core/Globals.js"],
            e["Core/Series/Series.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            var n, r;
            let { deg2rad: o } = t, { fireEvent: s, isNumber: a, pick: l, relativeLength: h } = i;
            return (r = n || (n = {})).getCenter = function() {
                let t, i, n, r = this.options, o = this.chart, c = 2 * (r.slicedOffset || 0), d = o.plotWidth - 2 * c, u = o.plotHeight - 2 * c, p = r.center, f = Math.min(d, u), g = r.thickness, m = r.size, b = r.innerSize || 0;
                "string" == typeof m && (m = parseFloat(m)), "string" == typeof b && (b = parseFloat(b));
                let y = [
                    l(p[0], "50%"),
                    l(p[1], "50%"),
                    l(m && m < 0 ? void 0 : r.size, "100%"),
                    l(b && b < 0 ? void 0 : r.innerSize || 0, "0%")
                ];
                for(!o.angular || this instanceof e || (y[3] = 0), i = 0; i < 4; ++i)n = y[i], t = i < 2 || 2 === i && /%$/.test(n), y[i] = h(n, [
                    d,
                    u,
                    f,
                    y[2]
                ][i]) + (t ? c : 0);
                return y[3] > y[2] && (y[3] = y[2]), a(g) && 2 * g < y[2] && g > 0 && (y[3] = y[2] - 2 * g), s(this, "afterGetCenter", {
                    positions: y
                }), y;
            }, r.getStartAndEndRadians = function(t, e) {
                let i = a(t) ? t : 0, n = a(e) && e > i && e - i < 360 ? e : i + 360;
                return {
                    start: o * (i + -90),
                    end: o * (n + -90)
                };
            }, n;
        }), i(e, "Series/Pie/PiePoint.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Series/Point.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { setAnimation: n } = t, { addEvent: r, defined: o, extend: s, isNumber: a, pick: l, relativeLength: h } = i;
            class c extends e {
                getConnectorPath(t) {
                    let e = t.dataLabelPosition, i = t.options || {}, n = i.connectorShape, r = this.connectorShapes[n] || n;
                    return e && r.call(this, {
                        ...e.computed,
                        alignment: e.alignment
                    }, e.connectorPosition, i) || [];
                }
                getTranslate() {
                    return this.sliced && this.slicedTranslation || {
                        translateX: 0,
                        translateY: 0
                    };
                }
                haloPath(t) {
                    let e = this.shapeArgs;
                    return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(e.x, e.y, e.r + t, e.r + t, {
                        innerR: e.r - 1,
                        start: e.start,
                        end: e.end,
                        borderRadius: e.borderRadius
                    });
                }
                constructor(t, e, i){
                    super(t, e, i), this.half = 0, this.name ?? (this.name = "Slice");
                    let n = (t)=>{
                        this.slice("select" === t.type);
                    };
                    r(this, "select", n), r(this, "unselect", n);
                }
                isValid() {
                    return a(this.y) && this.y >= 0;
                }
                setVisible(t, e = !0) {
                    t !== this.visible && this.update({
                        visible: t ?? !this.visible
                    }, e, void 0, !1);
                }
                slice(t, e, i) {
                    let r = this.series;
                    n(i, r.chart), e = l(e, !0), this.sliced = this.options.sliced = t = o(t) ? t : !this.sliced, r.options.data[r.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
                }
            }
            return s(c.prototype, {
                connectorShapes: {
                    fixedOffset: function(t, e, i) {
                        let n = e.breakAt, r = e.touchingSliceAt, o = i.softConnector ? [
                            "C",
                            t.x + ("left" === t.alignment ? -5 : 5),
                            t.y,
                            2 * n.x - r.x,
                            2 * n.y - r.y,
                            n.x,
                            n.y
                        ] : [
                            "L",
                            n.x,
                            n.y
                        ];
                        return [
                            [
                                "M",
                                t.x,
                                t.y
                            ],
                            o,
                            [
                                "L",
                                r.x,
                                r.y
                            ]
                        ];
                    },
                    straight: function(t, e) {
                        let i = e.touchingSliceAt;
                        return [
                            [
                                "M",
                                t.x,
                                t.y
                            ],
                            [
                                "L",
                                i.x,
                                i.y
                            ]
                        ];
                    },
                    crookedLine: function(t, e, i) {
                        let { breakAt: n, touchingSliceAt: r } = e, { series: o } = this, [s, a, l] = o.center, c = l / 2, { plotLeft: d, plotWidth: u } = o.chart, p = "left" === t.alignment, { x: f, y: g } = t, m = n.x;
                        if (i.crookDistance) {
                            let t = h(i.crookDistance, 1);
                            m = p ? s + c + (u + d - s - c) * (1 - t) : d + (s - c) * t;
                        } else m = s + (a - g) * Math.tan((this.angle || 0) - Math.PI / 2);
                        let b = [
                            [
                                "M",
                                f,
                                g
                            ]
                        ];
                        return (p ? m <= f && m >= n.x : m >= f && m <= n.x) && b.push([
                            "L",
                            m,
                            g
                        ]), b.push([
                            "L",
                            n.x,
                            n.y
                        ], [
                            "L",
                            r.x,
                            r.y
                        ]), b;
                    }
                }
            }), c;
        }), i(e, "Series/Pie/PieSeriesDefaults.js", [], function() {
            return {
                borderRadius: 3,
                center: [
                    null,
                    null
                ],
                clip: !1,
                colorByPoint: !0,
                dataLabels: {
                    connectorPadding: 5,
                    connectorShape: "crookedLine",
                    crookDistance: void 0,
                    distance: 30,
                    enabled: !0,
                    formatter: function() {
                        return this.point.isNull ? void 0 : this.point.name;
                    },
                    softConnector: !0,
                    x: 0
                },
                fillColor: void 0,
                ignoreHiddenPoint: !0,
                inactiveOtherPoints: !0,
                legendType: "point",
                marker: null,
                size: null,
                showInLegend: !1,
                slicedOffset: 10,
                stickyTracking: !1,
                tooltip: {
                    followPointer: !0
                },
                borderColor: "#ffffff",
                borderWidth: 1,
                lineWidth: void 0,
                states: {
                    hover: {
                        brightness: .1
                    }
                }
            };
        }), i(e, "Series/Pie/PieSeries.js", [
            e["Series/CenteredUtilities.js"],
            e["Series/Column/ColumnSeries.js"],
            e["Core/Globals.js"],
            e["Series/Pie/PiePoint.js"],
            e["Series/Pie/PieSeriesDefaults.js"],
            e["Core/Series/Series.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Renderer/SVG/Symbols.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a, l) {
            let { getStartAndEndRadians: h } = t, { noop: c } = i, { clamp: d, extend: u, fireEvent: p, merge: f, pick: g } = l;
            class m extends o {
                animate(t) {
                    let e = this, i = e.points, n = e.startAngleRad;
                    t || i.forEach(function(t) {
                        let i = t.graphic, r = t.shapeArgs;
                        i && r && (i.attr({
                            r: g(t.startR, e.center && e.center[3] / 2),
                            start: n,
                            end: n
                        }), i.animate({
                            r: r.r,
                            start: r.start,
                            end: r.end
                        }, e.options.animation));
                    });
                }
                drawEmpty() {
                    let t, e, i = this.startAngleRad, n = this.endAngleRad, r = this.options;
                    0 === this.total && this.center ? (t = this.center[0], e = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(t, e, this.center[1] / 2, 0, i, n).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({
                        d: a.arc(t, e, this.center[2] / 2, 0, {
                            start: i,
                            end: n,
                            innerR: this.center[3] / 2
                        })
                    }), this.chart.styledMode || this.graph.attr({
                        "stroke-width": r.borderWidth,
                        fill: r.fillColor || "none",
                        stroke: r.color || "#cccccc"
                    })) : this.graph && (this.graph = this.graph.destroy());
                }
                drawPoints() {
                    let t = this.chart.renderer;
                    this.points.forEach(function(e) {
                        e.graphic && e.hasNewShapeType() && (e.graphic = e.graphic.destroy()), e.graphic || (e.graphic = t[e.shapeType](e.shapeArgs).add(e.series.group), e.delayedRendering = !0);
                    });
                }
                generatePoints() {
                    super.generatePoints(), this.updateTotals();
                }
                getX(t, e, i, n) {
                    let r = this.center, o = this.radii ? this.radii[i.index] || 0 : r[2] / 2, s = n.dataLabelPosition, a = s?.distance || 0, l = Math.asin(d((t - r[1]) / (o + a), -1, 1));
                    return r[0] + Math.cos(l) * (o + a) * (e ? -1 : 1) + (a > 0 ? (e ? -1 : 1) * (n.padding || 0) : 0);
                }
                hasData() {
                    return !!this.processedXData.length;
                }
                redrawPoints() {
                    let t, e, i, n, r = this, o = r.chart;
                    this.drawEmpty(), r.group && !o.styledMode && r.group.shadow(r.options.shadow), r.points.forEach(function(s) {
                        let a = {};
                        e = s.graphic, !s.isNull && e ? (n = s.shapeArgs, t = s.getTranslate(), o.styledMode || (i = r.pointAttribs(s, s.selected && "select")), s.delayedRendering ? (e.setRadialReference(r.center).attr(n).attr(t), o.styledMode || e.attr(i).attr({
                            "stroke-linejoin": "round"
                        }), s.delayedRendering = !1) : (e.setRadialReference(r.center), o.styledMode || f(!0, a, i), f(!0, a, n, t), e.animate(a)), e.attr({
                            visibility: s.visible ? "inherit" : "hidden"
                        }), e.addClass(s.getClassName(), !0)) : e && (s.graphic = e.destroy());
                    });
                }
                sortByAngle(t, e) {
                    t.sort(function(t, i) {
                        return void 0 !== t.angle && (i.angle - t.angle) * e;
                    });
                }
                translate(t) {
                    p(this, "translate"), this.generatePoints();
                    let e, i, n, r, o, s, a, l = this.options, c = l.slicedOffset, d = h(l.startAngle, l.endAngle), u = this.startAngleRad = d.start, f = (this.endAngleRad = d.end) - u, g = this.points, m = l.ignoreHiddenPoint, b = g.length, y = 0;
                    for(t || (this.center = t = this.getCenter()), s = 0; s < b; s++){
                        a = g[s], e = u + y * f, a.isValid() && (!m || a.visible) && (y += a.percentage / 100), i = u + y * f;
                        let l = {
                            x: t[0],
                            y: t[1],
                            r: t[2] / 2,
                            innerR: t[3] / 2,
                            start: Math.round(1e3 * e) / 1e3,
                            end: Math.round(1e3 * i) / 1e3
                        };
                        a.shapeType = "arc", a.shapeArgs = l, (n = (i + e) / 2) > 1.5 * Math.PI ? n -= 2 * Math.PI : n < -Math.PI / 2 && (n += 2 * Math.PI), a.slicedTranslation = {
                            translateX: Math.round(Math.cos(n) * c),
                            translateY: Math.round(Math.sin(n) * c)
                        }, r = Math.cos(n) * t[2] / 2, o = Math.sin(n) * t[2] / 2, a.tooltipPos = [
                            t[0] + .7 * r,
                            t[1] + .7 * o
                        ], a.half = n < -Math.PI / 2 || n > Math.PI / 2 ? 1 : 0, a.angle = n;
                    }
                    p(this, "afterTranslate");
                }
                updateTotals() {
                    let t, e, i = this.points, n = i.length, r = this.options.ignoreHiddenPoint, o = 0;
                    for(t = 0; t < n; t++)(e = i[t]).isValid() && (!r || e.visible) && (o += e.y);
                    for(t = 0, this.total = o; t < n; t++)(e = i[t]).percentage = o > 0 && (e.visible || !r) ? e.y / o * 100 : 0, e.total = o;
                }
            }
            return m.defaultOptions = f(o.defaultOptions, r), u(m.prototype, {
                axisTypes: [],
                directTouch: !0,
                drawGraph: void 0,
                drawTracker: e.prototype.drawTracker,
                getCenter: t.getCenter,
                getSymbol: c,
                invertible: !1,
                isCartesian: !1,
                noSharedTooltip: !0,
                pointAttribs: e.prototype.pointAttribs,
                pointClass: n,
                requireSorting: !1,
                searchPoint: c,
                trackerGroups: [
                    "group",
                    "dataLabelsGroup"
                ]
            }), s.registerSeriesType("pie", m), m;
        }), i(e, "Series/Pie/PieDataLabel.js", [
            e["Core/Series/DataLabel.js"],
            e["Core/Globals.js"],
            e["Core/Renderer/RendererUtilities.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            var o;
            let { composed: s, noop: a } = e, { distribute: l } = i, { series: h } = n, { arrayMax: c, clamp: d, defined: u, pick: p, pushUnique: f, relativeLength: g } = r;
            return function(e) {
                let i = {
                    radialDistributionY: function(t, e) {
                        return (e.dataLabelPosition?.top || 0) + t.distributeBox.pos;
                    },
                    radialDistributionX: function(t, e, i, n, r) {
                        let o = r.dataLabelPosition;
                        return t.getX(i < (o?.top || 0) + 2 || i > (o?.bottom || 0) - 2 ? n : i, e.half, e, r);
                    },
                    justify: function(t, e, i, n) {
                        return n[0] + (t.half ? -1 : 1) * (i + (e.dataLabelPosition?.distance || 0));
                    },
                    alignToPlotEdges: function(t, e, i, n) {
                        let r = t.getBBox().width;
                        return e ? r + n : i - r - n;
                    },
                    alignToConnectors: function(t, e, i, n) {
                        let r, o = 0;
                        return t.forEach(function(t) {
                            (r = t.dataLabel.getBBox().width) > o && (o = r);
                        }), e ? o + n : i - o - n;
                    }
                };
                function n(t, e) {
                    let { center: i, options: n } = this, r = i[2] / 2, o = t.angle || 0, s = Math.cos(o), a = Math.sin(o), l = i[0] + s * r, h = i[1] + a * r, c = Math.min((n.slicedOffset || 0) + (n.borderWidth || 0), e / 5);
                    return {
                        natural: {
                            x: l + s * e,
                            y: h + a * e
                        },
                        computed: {},
                        alignment: e < 0 ? "center" : t.half ? "right" : "left",
                        connectorPosition: {
                            breakAt: {
                                x: l + s * c,
                                y: h + a * c
                            },
                            touchingSliceAt: {
                                x: l,
                                y: h
                            }
                        },
                        distance: e
                    };
                }
                function r() {
                    let t, e, i, n = this, r = n.points, o = n.chart, s = o.plotWidth, a = o.plotHeight, d = o.plotLeft, f = Math.round(o.chartWidth / 3), m = n.center, b = m[2] / 2, y = m[1], x = [
                        [],
                        []
                    ], v = [
                        0,
                        0,
                        0,
                        0
                    ], w = n.dataLabelPositioners, C = 0;
                    n.visible && n.hasDataLabels?.() && (r.forEach((t)=>{
                        (t.dataLabels || []).forEach((t)=>{
                            t.shortened && (t.attr({
                                width: "auto"
                            }).css({
                                width: "auto",
                                textOverflow: "clip"
                            }), t.shortened = !1);
                        });
                    }), h.prototype.drawDataLabels.apply(n), r.forEach((t)=>{
                        (t.dataLabels || []).forEach((e, i)=>{
                            let n = m[2] / 2, r = e.options, o = g(r?.distance || 0, n);
                            0 === i && x[t.half].push(t), !u(r?.style?.width) && e.getBBox().width > f && (e.css({
                                width: Math.round(.7 * f) + "px"
                            }), e.shortened = !0), e.dataLabelPosition = this.getDataLabelPosition(t, o), C = Math.max(C, o);
                        });
                    }), x.forEach((t, r)=>{
                        let h, c, f, g = t.length, x = [], S = 0;
                        g && (n.sortByAngle(t, r - .5), C > 0 && (h = Math.max(0, y - b - C), c = Math.min(y + b + C, o.plotHeight), t.forEach((t)=>{
                            (t.dataLabels || []).forEach((e)=>{
                                let i = e.dataLabelPosition;
                                i && i.distance > 0 && (i.top = Math.max(0, y - b - i.distance), i.bottom = Math.min(y + b + i.distance, o.plotHeight), S = e.getBBox().height || 21, e.lineHeight = o.renderer.fontMetrics(e.text || e).h + 2 * e.padding, t.distributeBox = {
                                    target: (e.dataLabelPosition?.natural.y || 0) - i.top + e.lineHeight / 2,
                                    size: S,
                                    rank: t.y
                                }, x.push(t.distributeBox));
                            });
                        }), l(x, f = c + S - h, f / 5)), t.forEach((o)=>{
                            (o.dataLabels || []).forEach((l)=>{
                                let h = l.options || {}, c = o.distributeBox, f = l.dataLabelPosition, g = f?.natural.y || 0, y = h.connectorPadding || 0, C = l.lineHeight || 21, S = (C - l.getBBox().height) / 2, k = 0, A = g, E = "inherit";
                                if (f) {
                                    if (x && u(c) && f.distance > 0 && (void 0 === c.pos ? E = "hidden" : (i = c.size, A = w.radialDistributionY(o, l))), h.justify) k = w.justify(o, l, b, m);
                                    else switch(h.alignTo){
                                        case "connectors":
                                            k = w.alignToConnectors(t, r, s, d);
                                            break;
                                        case "plotEdges":
                                            k = w.alignToPlotEdges(l, r, s, d);
                                            break;
                                        default:
                                            k = w.radialDistributionX(n, o, A - S, g, l);
                                    }
                                    if (f.attribs = {
                                        visibility: E,
                                        align: f.alignment
                                    }, f.posAttribs = {
                                        x: k + (h.x || 0) + (({
                                            left: y,
                                            right: -y
                                        })[f.alignment] || 0),
                                        y: A + (h.y || 0) - C / 2
                                    }, f.computed.x = k, f.computed.y = A - S, p(h.crop, !0)) {
                                        let t;
                                        k - (e = l.getBBox().width) < y && 1 === r ? (t = Math.round(e - k + y), v[3] = Math.max(t, v[3])) : k + e > s - y && 0 === r && (t = Math.round(k + e - s + y), v[1] = Math.max(t, v[1])), A - i / 2 < 0 ? v[0] = Math.max(Math.round(i / 2 - A), v[0]) : A + i / 2 > a && (v[2] = Math.max(Math.round(A + i / 2 - a), v[2])), f.sideOverflow = t;
                                    }
                                }
                            });
                        }));
                    }), (0 === c(v) || this.verifyDataLabelOverflow(v)) && (this.placeDataLabels(), this.points.forEach((e)=>{
                        (e.dataLabels || []).forEach((i)=>{
                            let { connectorColor: r, connectorWidth: s = 1 } = i.options || {}, a = i.dataLabelPosition;
                            if (s) {
                                let l;
                                t = i.connector, a && a.distance > 0 ? (l = !t, t || (i.connector = t = o.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + e.colorIndex + (e.className ? " " + e.className : "")).add(n.dataLabelsGroup)), o.styledMode || t.attr({
                                    "stroke-width": s,
                                    stroke: r || e.color || "#666666"
                                }), t[l ? "attr" : "animate"]({
                                    d: e.getConnectorPath(i)
                                }), t.attr({
                                    visibility: a.attribs?.visibility
                                })) : t && (i.connector = t.destroy());
                            }
                        });
                    })));
                }
                function o() {
                    this.points.forEach((t)=>{
                        (t.dataLabels || []).forEach((t)=>{
                            let e = t.dataLabelPosition;
                            e ? (e.sideOverflow && (t.css({
                                width: Math.max(t.getBBox().width - e.sideOverflow, 0) + "px",
                                textOverflow: (t.options?.style || {}).textOverflow || "ellipsis"
                            }), t.shortened = !0), t.attr(e.attribs), t[t.moved ? "animate" : "attr"](e.posAttribs), t.moved = !0) : t && t.attr({
                                y: -9999
                            });
                        }), delete t.distributeBox;
                    }, this);
                }
                function m(t) {
                    let e = this.center, i = this.options, n = i.center, r = i.minSize || 80, o = r, s = null !== i.size;
                    return !s && (null !== n[0] ? o = Math.max(e[2] - Math.max(t[1], t[3]), r) : (o = Math.max(e[2] - t[1] - t[3], r), e[0] += (t[3] - t[1]) / 2), null !== n[1] ? o = d(o, r, e[2] - Math.max(t[0], t[2])) : (o = d(o, r, e[2] - t[0] - t[2]), e[1] += (t[0] - t[2]) / 2), o < e[2] ? (e[2] = o, e[3] = Math.min(i.thickness ? Math.max(0, o - 2 * i.thickness) : Math.max(0, g(i.innerSize || 0, o)), o), this.translate(e), this.drawDataLabels && this.drawDataLabels()) : s = !0), s;
                }
                e.compose = function(e) {
                    if (t.compose(h), f(s, "PieDataLabel")) {
                        let t = e.prototype;
                        t.dataLabelPositioners = i, t.alignDataLabel = a, t.drawDataLabels = r, t.getDataLabelPosition = n, t.placeDataLabels = o, t.verifyDataLabelOverflow = m;
                    }
                };
            }(o || (o = {})), o;
        }), i(e, "Core/Geometry/GeometryUtilities.js", [], function() {
            var t, e;
            return (e = t || (t = {})).getCenterOfPoints = function(t) {
                let e = t.reduce((t, e)=>(t.x += e.x, t.y += e.y, t), {
                    x: 0,
                    y: 0
                });
                return {
                    x: e.x / t.length,
                    y: e.y / t.length
                };
            }, e.getDistanceBetweenPoints = function(t, e) {
                return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
            }, e.getAngleBetweenPoints = function(t, e) {
                return Math.atan2(e.x - t.x, e.y - t.y);
            }, e.pointInPolygon = function({ x: t, y: e }, i) {
                let n, r, o = i.length, s = !1;
                for(n = 0, r = o - 1; n < o; r = n++){
                    let [o, a] = i[n], [l, h] = i[r];
                    a > e != h > e && t < (l - o) * (e - a) / (h - a) + o && (s = !s);
                }
                return s;
            }, t;
        }), i(e, "Extensions/OverlappingDataLabels.js", [
            e["Core/Geometry/GeometryUtilities.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { pointInPolygon: i } = t, { addEvent: n, fireEvent: r, objectEach: o, pick: s } = e;
            function a(t) {
                let e, n, o, s, a, h = t.length, c = (t, e)=>!(e.x >= t.x + t.width || e.x + e.width <= t.x || e.y >= t.y + t.height || e.y + e.height <= t.y), d = (t, e)=>{
                    for (let n of t)if (i({
                        x: n[0],
                        y: n[1]
                    }, e)) return !0;
                    return !1;
                }, u = !1;
                for(let i = 0; i < h; i++)(e = t[i]) && (e.oldOpacity = e.opacity, e.newOpacity = 1, e.absoluteBox = function(t) {
                    if (t && (!t.alignAttr || t.placed)) {
                        let e = t.box ? 0 : t.padding || 0, i = t.alignAttr || {
                            x: t.attr("x"),
                            y: t.attr("y")
                        }, n = t.getBBox();
                        return t.width = n.width, t.height = n.height, {
                            x: i.x + (t.parentGroup?.translateX || 0) + e,
                            y: i.y + (t.parentGroup?.translateY || 0) + e,
                            width: (t.width || 0) - 2 * e,
                            height: (t.height || 0) - 2 * e,
                            polygon: n?.polygon
                        };
                    }
                }(e));
                t.sort((t, e)=>(e.labelrank || 0) - (t.labelrank || 0));
                for(let e = 0; e < h; ++e){
                    s = (n = t[e]) && n.absoluteBox;
                    let i = s?.polygon;
                    for(let r = e + 1; r < h; ++r){
                        a = (o = t[r]) && o.absoluteBox;
                        let e = !1;
                        if (s && a && n !== o && 0 !== n.newOpacity && 0 !== o.newOpacity && "hidden" !== n.visibility && "hidden" !== o.visibility) {
                            let t = a.polygon;
                            if (i && t && i !== t ? d(i, t) && (e = !0) : c(s, a) && (e = !0), e) {
                                let t = n.labelrank < o.labelrank ? n : o, e = t.text;
                                t.newOpacity = 0, e?.element.querySelector("textPath") && e.hide();
                            }
                        }
                    }
                }
                for (let e of t)l(e, this) && (u = !0);
                u && r(this, "afterHideAllOverlappingLabels");
            }
            function l(t, e) {
                let i, n, o = !1;
                return t && (n = t.newOpacity, t.oldOpacity !== n && (t.hasClass("highcharts-data-label") ? (t[n ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), i = function() {
                    e.styledMode || t.css({
                        pointerEvents: n ? "auto" : "none"
                    });
                }, o = !0, t[t.isOld ? "animate" : "attr"]({
                    opacity: n
                }, void 0, i), r(e, "afterHideOverlappingLabel")) : t.attr({
                    opacity: n
                })), t.isOld = !0), o;
            }
            function h() {
                let t = this, e = [];
                for (let i of t.labelCollectors || [])e = e.concat(i());
                for (let i of t.yAxis || [])i.stacking && i.options.stackLabels && !i.options.stackLabels.allowOverlap && o(i.stacking.stacks, (t)=>{
                    o(t, (t)=>{
                        t.label && e.push(t.label);
                    });
                });
                for (let i of t.series || [])if (i.visible && i.hasDataLabels?.()) {
                    let n = (i)=>{
                        for (let n of i)n.visible && (n.dataLabels || []).forEach((i)=>{
                            let r = i.options || {};
                            i.labelrank = s(r.labelrank, n.labelrank, n.shapeArgs?.height), r.allowOverlap ?? Number(r.distance) > 0 ? (i.oldOpacity = i.opacity, i.newOpacity = 1, l(i, t)) : e.push(i);
                        });
                    };
                    n(i.nodes || []), n(i.points);
                }
                this.hideOverlappingLabels(e);
            }
            return {
                compose: function(t) {
                    let e = t.prototype;
                    e.hideOverlappingLabels || (e.hideOverlappingLabels = a, n(t, "render", h));
                }
            };
        }), i(e, "Extensions/BorderRadius.js", [
            e["Core/Defaults.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { defaultOptions: n } = t, { noop: r } = e, { addEvent: o, extend: s, isObject: a, merge: l, relativeLength: h } = i, c = {
                radius: 0,
                scope: "stack",
                where: void 0
            }, d = r, u = r;
            function p(t, e, i, n, r = {}) {
                let o = d(t, e, i, n, r), { innerR: s = 0, r: a = i, start: l = 0, end: c = 0 } = r;
                if (r.open || !r.borderRadius) return o;
                let u = c - l, p1 = Math.sin(u / 2), f = Math.max(Math.min(h(r.borderRadius || 0, a - s), (a - s) / 2, a * p1 / (1 + p1)), 0), g = Math.min(f, u / Math.PI * 2 * s), m = o.length - 1;
                for(; m--;)!function(t, e, i) {
                    let n, r, o, s = t[e], a = t[e + 1];
                    if ("Z" === a[0] && (a = t[0]), "M" !== s[0] && "L" !== s[0] || "A" !== a[0] ? "A" === s[0] && ("M" === a[0] || "L" === a[0]) && (n = a, r = s) : (n = s, r = a, o = !0), n && r && r.params) {
                        let s = r[1], a = r[5], l = r.params, { start: h, end: c, cx: d, cy: u } = l, p = a ? s - i : s + i, f = p ? Math.asin(i / p) : 0, g = a ? f : -f, m = Math.cos(f) * p;
                        o ? (l.start = h + g, n[1] = d + m * Math.cos(h), n[2] = u + m * Math.sin(h), t.splice(e + 1, 0, [
                            "A",
                            i,
                            i,
                            0,
                            0,
                            1,
                            d + s * Math.cos(l.start),
                            u + s * Math.sin(l.start)
                        ])) : (l.end = c - g, r[6] = d + s * Math.cos(l.end), r[7] = u + s * Math.sin(l.end), t.splice(e + 1, 0, [
                            "A",
                            i,
                            i,
                            0,
                            0,
                            1,
                            d + m * Math.cos(c),
                            u + m * Math.sin(c)
                        ])), r[4] = Math.abs(l.end - l.start) < Math.PI ? 0 : 1;
                    }
                }(o, m, m > 1 ? g : f);
                return o;
            }
            function f() {
                if (this.options.borderRadius && (!this.chart.is3d || !this.chart.is3d())) {
                    let { options: t, yAxis: e } = this, i = "percent" === t.stacking, r = n.plotOptions?.[this.type]?.borderRadius, o = g(t.borderRadius, a(r) ? r : {}), l = e.options.reversed;
                    for (let n of this.points){
                        let { shapeArgs: r } = n;
                        if ("roundedRect" === n.shapeType && r) {
                            let { width: a = 0, height: c = 0, y: d = 0 } = r, u = d, p = c;
                            if ("stack" === o.scope && n.stackTotal) {
                                let r = e.translate(i ? 100 : n.stackTotal, !1, !0, !1, !0), o = e.translate(t.threshold || 0, !1, !0, !1, !0), s = this.crispCol(0, Math.min(r, o), 0, Math.abs(r - o));
                                u = s.y, p = s.height;
                            }
                            let f = (n.negative ? -1 : 1) * (l ? -1 : 1) == -1, g = o.where;
                            !g && this.is("waterfall") && Math.abs((n.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (g = "all"), g || (g = "end");
                            let m = Math.min(h(o.radius, a), a / 2, "all" === g ? c / 2 : 1 / 0) || 0;
                            "end" === g && (f && (u -= m), p += m), s(r, {
                                brBoxHeight: p,
                                brBoxY: u,
                                r: m
                            });
                        }
                    }
                }
            }
            function g(t, e) {
                return a(t) || (t = {
                    radius: t || 0
                }), l(c, e, t);
            }
            function m() {
                let t = g(this.options.borderRadius);
                for (let e of this.points){
                    let i = e.shapeArgs;
                    i && (i.borderRadius = h(t.radius, (i.r || 0) - (i.innerR || 0)));
                }
            }
            function b(t, e, i, n, r = {}) {
                let o = u(t, e, i, n, r), { r: s = 0, brBoxHeight: a = n, brBoxY: l = e } = r, h = e - l, c = l + a - (e + n), d = h - s > -0.1 ? 0 : s, p = c - s > -0.1 ? 0 : s, f = Math.max(d && h, 0), g = Math.max(p && c, 0), m = [
                    t + d,
                    e
                ], b1 = [
                    t + i - d,
                    e
                ], y = [
                    t + i,
                    e + d
                ], x = [
                    t + i,
                    e + n - p
                ], v = [
                    t + i - p,
                    e + n
                ], w = [
                    t + p,
                    e + n
                ], C = [
                    t,
                    e + n - p
                ], S = [
                    t,
                    e + d
                ], k = (t, e)=>Math.sqrt(Math.pow(t, 2) - Math.pow(e, 2));
                if (f) {
                    let t = k(d, d - f);
                    m[0] -= t, b1[0] += t, y[1] = S[1] = e + d - f;
                }
                if (n < d - f) {
                    let r = k(d, d - f - n);
                    y[0] = x[0] = t + i - d + r, v[0] = Math.min(y[0], v[0]), w[0] = Math.max(x[0], w[0]), C[0] = S[0] = t + d - r, y[1] = S[1] = e + n;
                }
                if (g) {
                    let t = k(p, p - g);
                    v[0] += t, w[0] -= t, x[1] = C[1] = e + n - p + g;
                }
                if (n < p - g) {
                    let r = k(p, p - g - n);
                    y[0] = x[0] = t + i - p + r, b1[0] = Math.min(y[0], b1[0]), m[0] = Math.max(x[0], m[0]), C[0] = S[0] = t + p - r, x[1] = C[1] = e;
                }
                return o.length = 0, o.push([
                    "M",
                    ...m
                ], [
                    "L",
                    ...b1
                ], [
                    "A",
                    d,
                    d,
                    0,
                    0,
                    1,
                    ...y
                ], [
                    "L",
                    ...x
                ], [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    ...v
                ], [
                    "L",
                    ...w
                ], [
                    "A",
                    p,
                    p,
                    0,
                    0,
                    1,
                    ...C
                ], [
                    "L",
                    ...S
                ], [
                    "A",
                    d,
                    d,
                    0,
                    0,
                    1,
                    ...m
                ], [
                    "Z"
                ]), o;
            }
            return {
                compose: function(t, e, i) {
                    let n = t.types.pie;
                    if (!e.symbolCustomAttribs.includes("borderRadius")) {
                        let r = i.prototype.symbols;
                        o(t, "afterColumnTranslate", f, {
                            order: 9
                        }), o(n, "afterTranslate", m), e.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), d = r.arc, u = r.roundedRect, r.arc = p, r.roundedRect = b;
                    }
                },
                optionsToObject: g
            };
        }), i(e, "Core/Responsive.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            var e;
            let { diffObjects: i, extend: n, find: r, merge: o, pick: s, uniqueKey: a } = t;
            return function(t) {
                function e(t, e) {
                    let i = t.condition;
                    (i.callback || function() {
                        return this.chartWidth <= s(i.maxWidth, Number.MAX_VALUE) && this.chartHeight <= s(i.maxHeight, Number.MAX_VALUE) && this.chartWidth >= s(i.minWidth, 0) && this.chartHeight >= s(i.minHeight, 0);
                    }).call(this) && e.push(t._id);
                }
                function l(t, e) {
                    let n, s = this.options.responsive, l = this.currentResponsive, h = [];
                    !e && s && s.rules && s.rules.forEach((t)=>{
                        void 0 === t._id && (t._id = a()), this.matchResponsiveRule(t, h);
                    }, this);
                    let c = o(...h.map((t)=>r((s || {}).rules || [], (e)=>e._id === t)).map((t)=>t && t.chartOptions));
                    c.isResponsiveOptions = !0, h = h.toString() || void 0;
                    let d = l && l.ruleIds;
                    h === d || (l && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(l.undoOptions, t, !0), this.updatingResponsive = !1), h ? ((n = i(c, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = {
                        ruleIds: h,
                        mergedOptions: c,
                        undoOptions: n
                    }, this.updatingResponsive || this.update(c, t, !0)) : this.currentResponsive = void 0);
                }
                t.compose = function(t) {
                    let i = t.prototype;
                    return i.matchResponsiveRule || n(i, {
                        matchResponsiveRule: e,
                        setResponsive: l
                    }), t;
                };
            }(e || (e = {})), e;
        }), i(e, "masters/highcharts.src.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"],
            e["Core/Defaults.js"],
            e["Core/Animation/Fx.js"],
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Templating.js"],
            e["Core/Renderer/RendererRegistry.js"],
            e["Core/Renderer/RendererUtilities.js"],
            e["Core/Renderer/SVG/SVGElement.js"],
            e["Core/Renderer/SVG/SVGRenderer.js"],
            e["Core/Renderer/HTML/HTMLElement.js"],
            e["Core/Axis/Axis.js"],
            e["Core/Axis/DateTimeAxis.js"],
            e["Core/Axis/LogarithmicAxis.js"],
            e["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"],
            e["Core/Axis/Tick.js"],
            e["Core/Tooltip.js"],
            e["Core/Series/Point.js"],
            e["Core/Pointer.js"],
            e["Core/Legend/Legend.js"],
            e["Core/Legend/LegendSymbol.js"],
            e["Core/Chart/Chart.js"],
            e["Extensions/ScrollablePlotArea.js"],
            e["Core/Axis/Stacking/StackingAxis.js"],
            e["Core/Axis/Stacking/StackItem.js"],
            e["Core/Series/Series.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Series/Column/ColumnDataLabel.js"],
            e["Series/Pie/PieDataLabel.js"],
            e["Core/Series/DataLabel.js"],
            e["Extensions/OverlappingDataLabels.js"],
            e["Extensions/BorderRadius.js"],
            e["Core/Responsive.js"],
            e["Core/Color/Color.js"],
            e["Core/Time.js"]
        ], function(t, e, i, n, r, o, s, a, l, h, c, d, u, p, f, g, m, b, y, x, v, w, C, S, k, A, E, M, T, P, R, L, O, D, j, N) {
            return t.AST = o, t.Axis = u, t.Chart = C, t.Color = j, t.DataLabel = R, t.Fx = n, t.HTMLElement = d, t.Legend = v, t.LegendSymbol = w, t.OverlappingDataLabels = t.OverlappingDataLabels || L, t.PlotLineOrBand = g, t.Point = y, t.Pointer = x, t.RendererRegistry = a, t.Series = E, t.SeriesRegistry = M, t.StackItem = A, t.SVGElement = h, t.SVGRenderer = c, t.Templating = s, t.Tick = m, t.Time = N, t.Tooltip = b, t.animate = r.animate, t.animObject = r.animObject, t.chart = C.chart, t.color = j.parse, t.dateFormat = s.dateFormat, t.defaultOptions = i.defaultOptions, t.distribute = l.distribute, t.format = s.format, t.getDeferredAnimation = r.getDeferredAnimation, t.getOptions = i.getOptions, t.numberFormat = s.numberFormat, t.seriesType = M.seriesType, t.setAnimation = r.setAnimation, t.setOptions = i.setOptions, t.stop = r.stop, t.time = i.defaultTime, t.timers = n.timers, O.compose(t.Series, t.SVGElement, t.SVGRenderer), T.compose(t.Series.types.column), R.compose(t.Series), p.compose(t.Axis), d.compose(t.SVGRenderer), v.compose(t.Chart), f.compose(t.Axis), L.compose(t.Chart), P.compose(t.Series.types.pie), g.compose(t.Chart, t.Axis), x.compose(t.Chart), D.compose(t.Chart), S.compose(t.Axis, t.Chart, t.Series), k.compose(t.Axis, t.Chart, t.Series), b.compose(t.Pointer), e.extend(t, e), t;
        }), e["masters/highcharts.src.js"]._modules = e, e["masters/highcharts.src.js"];
    }, t.exports ? (i.default = i, t.exports = e && e.document ? i(e) : i) : (e.Highcharts && e.Highcharts.error(16, !0), e.Highcharts = i(e));
}(vr)), vr.exports), kr = b(Sr), Ar = {
    exports: {}
};
var Er, Mr = (Cr || (Cr = 1, function(t) {
    var e;
    e = function(t) {
        var e = t ? t._modules : {};
        function i(e, i, n, r) {
            e.hasOwnProperty(i) || (e[i] = r.apply(null, n), "function" == typeof CustomEvent && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
                detail: {
                    path: i,
                    module: e[i]
                }
            })));
        }
        i(e, "Extensions/Pane/PaneComposition.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            let { addEvent: e, correctFloat: i, defined: n, pick: r } = t;
            function o(t) {
                let e, i = this;
                return t && i.pane.forEach((n)=>{
                    s(t.chartX - i.plotLeft, t.chartY - i.plotTop, n.center) && (e = n);
                }), e;
            }
            function s(t, e, r, o, s) {
                let a = !0, l = r[0], h = r[1], c = Math.sqrt(Math.pow(t - l, 2) + Math.pow(e - h, 2));
                if (n(o) && n(s)) {
                    let n = Math.atan2(i(e - h, 8), i(t - l, 8));
                    s !== o && (a = o > s ? n >= o && n <= Math.PI || n <= s && n >= -Math.PI : n >= o && n <= i(s, 8));
                }
                return c <= Math.ceil(r[2] / 2) && a;
            }
            function a(t) {
                this.polar && (t.options.inverted && ([t.x, t.y] = [
                    t.y,
                    t.x
                ]), t.isInsidePlot = this.pane.some((e)=>s(t.x, t.y, e.center, e.axis && e.axis.normalizedStartAngleRad, e.axis && e.axis.normalizedEndAngleRad)));
            }
            function l(t) {
                let e = this.chart;
                t.hoverPoint && t.hoverPoint.plotX && t.hoverPoint.plotY && e.hoverPane && !s(t.hoverPoint.plotX, t.hoverPoint.plotY, e.hoverPane.center) && (t.hoverPoint = void 0);
            }
            function h(t) {
                let e = this.chart;
                e.polar ? (e.hoverPane = e.getHoverPane(t), t.filter = function(i) {
                    return i.visible && !(!t.shared && i.directTouch) && r(i.options.enableMouseTracking, !0) && (!e.hoverPane || i.xAxis.pane === e.hoverPane);
                }) : e.hoverPane = void 0;
            }
            return {
                compose: function(t, i) {
                    let n = t.prototype;
                    n.getHoverPane || (n.collectionsWithUpdate.push("pane"), n.getHoverPane = o, e(t, "afterIsInsidePlot", a), e(i, "afterGetHoverData", l), e(i, "beforeGetHoverData", h));
                }
            };
        }), i(e, "Extensions/Pane/PaneDefaults.js", [], function() {
            return {
                pane: {
                    center: [
                        "50%",
                        "50%"
                    ],
                    size: "85%",
                    innerSize: "0%",
                    startAngle: 0
                },
                background: {
                    shape: "circle",
                    borderRadius: 0,
                    borderWidth: 1,
                    borderColor: "#cccccc",
                    backgroundColor: {
                        linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1
                        },
                        stops: [
                            [
                                0,
                                "#ffffff"
                            ],
                            [
                                1,
                                "#e6e6e6"
                            ]
                        ]
                    },
                    from: -Number.MAX_VALUE,
                    innerRadius: 0,
                    to: Number.MAX_VALUE,
                    outerRadius: "105%"
                }
            };
        }), i(e, "Extensions/Pane/Pane.js", [
            e["Series/CenteredUtilities.js"],
            e["Extensions/Pane/PaneComposition.js"],
            e["Extensions/Pane/PaneDefaults.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { extend: r, merge: o, splat: s } = n;
            class a {
                constructor(t, e){
                    this.coll = "pane", this.init(t, e);
                }
                init(t, e) {
                    this.chart = e, this.background = [], e.pane.push(this), this.setOptions(t);
                }
                setOptions(t) {
                    this.options = t = o(i.pane, this.chart.angular ? {
                        background: {}
                    } : void 0, t);
                }
                render() {
                    let t = this.options, e = this.chart.renderer;
                    this.group || (this.group = e.g("pane-group").attr({
                        zIndex: t.zIndex || 0
                    }).add()), this.updateCenter();
                    let n = this.options.background;
                    if (n) {
                        let t = Math.max((n = s(n)).length, this.background.length || 0);
                        for(let e = 0; e < t; e++)n[e] && this.axis ? this.renderBackground(o(i.background, n[e]), e) : this.background[e] && (this.background[e] = this.background[e].destroy(), this.background.splice(e, 1));
                    }
                }
                renderBackground(t, e) {
                    let i = {
                        class: "highcharts-pane " + (t.className || "")
                    }, n = "animate";
                    this.chart.styledMode || r(i, {
                        fill: t.backgroundColor,
                        stroke: t.borderColor,
                        "stroke-width": t.borderWidth
                    }), this.background[e] || (this.background[e] = this.chart.renderer.path().add(this.group), n = "attr"), this.background[e][n]({
                        d: this.axis.getPlotBandPath(t.from, t.to, t)
                    }).attr(i);
                }
                updateCenter(e) {
                    this.center = (e || this.axis || {}).center = t.getCenter.call(this);
                }
                update(t, e) {
                    o(!0, this.options, t), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function(t) {
                        t.pane === this && (t.pane = null, t.update({}, e));
                    }, this);
                }
            }
            return a.compose = e.compose, a;
        }), i(e, "Series/AreaRange/AreaRangePoint.js", [
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { area: { prototype: { pointClass: i, pointClass: { prototype: n } } } } = t.seriesTypes, { defined: r, isNumber: o } = e;
            return class extends i {
                setState() {
                    let t = this.state, e = this.series, i = e.chart.polar;
                    r(this.plotHigh) || (this.plotHigh = e.yAxis.toPixels(this.high, !0)), r(this.plotLow) || (this.plotLow = this.plotY = e.yAxis.toPixels(this.low, !0)), e.lowerStateMarkerGraphic = e.stateMarkerGraphic, e.stateMarkerGraphic = e.upperStateMarkerGraphic, this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, i && o(this.plotHighX) && (this.plotX = this.plotHighX), n.setState.apply(this, arguments), this.state = t, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], i && o(this.plotLowX) && (this.plotX = this.plotLowX), e.upperStateMarkerGraphic = e.stateMarkerGraphic, e.stateMarkerGraphic = e.lowerStateMarkerGraphic, e.lowerStateMarkerGraphic = void 0;
                    let s = e.modifyMarkerSettings();
                    n.setState.apply(this, arguments), e.restoreMarkerSettings(s);
                }
                haloPath() {
                    let t = this.series.chart.polar, e = [];
                    return this.plotY = this.plotLow, t && o(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (e = n.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, t && o(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (e = e.concat(n.haloPath.apply(this, arguments))), e;
                }
                isValid() {
                    return o(this.low) && o(this.high);
                }
            };
        }), i(e, "Series/AreaRange/AreaRangeSeries.js", [
            e["Series/AreaRange/AreaRangePoint.js"],
            e["Core/Globals.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { noop: r } = e, { area: o, area: { prototype: s }, column: { prototype: a } } = i.seriesTypes, { addEvent: l, defined: h, extend: c, isArray: d, isNumber: u, pick: p, merge: f } = n;
            class g extends o {
                toYData(t) {
                    return [
                        t.low,
                        t.high
                    ];
                }
                highToXY(t) {
                    let e = this.chart, i = this.xAxis.postTranslate(t.rectPlotX || 0, this.yAxis.len - (t.plotHigh || 0));
                    t.plotHighX = i.x - e.plotLeft, t.plotHigh = i.y - e.plotTop, t.plotLowX = t.plotX;
                }
                getGraphPath(t) {
                    let e, i, n, r = [], o = [], a = s.getGraphPath, l = this.options, h = this.chart.polar, c = h && !1 !== l.connectEnds, d = l.connectNulls, u = l.step;
                    for(e = (t = t || this.points).length; e--;){
                        i = t[e];
                        let s = h ? {
                            plotX: i.rectPlotX,
                            plotY: i.yBottom,
                            doCurve: !1
                        } : {
                            plotX: i.plotX,
                            plotY: i.plotY,
                            doCurve: !1
                        };
                        i.isNull || c || d || t[e + 1] && !t[e + 1].isNull || o.push(s), n = {
                            polarPlotY: i.polarPlotY,
                            rectPlotX: i.rectPlotX,
                            yBottom: i.yBottom,
                            plotX: p(i.plotHighX, i.plotX),
                            plotY: i.plotHigh,
                            isNull: i.isNull
                        }, o.push(n), r.push(n), i.isNull || c || d || t[e - 1] && !t[e - 1].isNull || o.push(s);
                    }
                    let f = a.call(this, t);
                    u && (!0 === u && (u = "left"), l.step = ({
                        left: "right",
                        center: "center",
                        right: "left"
                    })[u]);
                    let g = a.call(this, r), m = a.call(this, o);
                    l.step = u;
                    let b = [].concat(f, g);
                    return !this.chart.polar && m[0] && "M" === m[0][0] && (m[0] = [
                        "L",
                        m[0][1],
                        m[0][2]
                    ]), this.graphPath = b, this.areaPath = f.concat(m), b.isArea = !0, b.xMap = f.xMap, this.areaPath.xMap = f.xMap, b;
                }
                drawDataLabels() {
                    let t, e, i, n, r, o = this.points, a = o.length, l = [], h = this.options.dataLabels, u = this.chart.inverted;
                    if (h) {
                        if (d(h) ? (n = h[0] || {
                            enabled: !1
                        }, r = h[1] || {
                            enabled: !1
                        }) : ((n = c({}, h)).x = h.xHigh, n.y = h.yHigh, (r = c({}, h)).x = h.xLow, r.y = h.yLow), n.enabled || this.hasDataLabels?.()) {
                            for(t = a; t--;)if (e = o[t]) {
                                let { plotHigh: r = 0, plotLow: o = 0 } = e;
                                i = n.inside ? r < o : r > o, e.y = e.high, e._plotY = e.plotY, e.plotY = r, l[t] = e.dataLabel, e.dataLabel = e.dataLabelUpper, e.below = i, u ? n.align || (n.align = i ? "right" : "left") : n.verticalAlign || (n.verticalAlign = i ? "top" : "bottom");
                            }
                            for(this.options.dataLabels = n, s.drawDataLabels && s.drawDataLabels.apply(this, arguments), t = a; t--;)(e = o[t]) && (e.dataLabelUpper = e.dataLabel, e.dataLabel = l[t], delete e.dataLabels, e.y = e.low, e.plotY = e._plotY);
                        }
                        if (r.enabled || this.hasDataLabels?.()) {
                            for(t = a; t--;)if (e = o[t]) {
                                let { plotHigh: t = 0, plotLow: n = 0 } = e;
                                i = r.inside ? t < n : t > n, e.below = !i, u ? r.align || (r.align = i ? "left" : "right") : r.verticalAlign || (r.verticalAlign = i ? "bottom" : "top");
                            }
                            this.options.dataLabels = r, s.drawDataLabels && s.drawDataLabels.apply(this, arguments);
                        }
                        if (n.enabled) for(t = a; t--;)(e = o[t]) && (e.dataLabels = [
                            e.dataLabelUpper,
                            e.dataLabel
                        ].filter(function(t) {
                            return !!t;
                        }));
                        this.options.dataLabels = h;
                    }
                }
                alignDataLabel() {
                    a.alignDataLabel.apply(this, arguments);
                }
                modifyMarkerSettings() {
                    let t = {
                        marker: this.options.marker,
                        symbol: this.symbol
                    };
                    if (this.options.lowMarker) {
                        let { options: { marker: t, lowMarker: e } } = this;
                        this.options.marker = f(t, e), e.symbol && (this.symbol = e.symbol);
                    }
                    return t;
                }
                restoreMarkerSettings(t) {
                    this.options.marker = t.marker, this.symbol = t.symbol;
                }
                drawPoints() {
                    let t, e, i = this.points.length, n = this.modifyMarkerSettings();
                    for(s.drawPoints.apply(this, arguments), this.restoreMarkerSettings(n), t = 0; t < i;)(e = this.points[t]).graphics = e.graphics || [], e.origProps = {
                        plotY: e.plotY,
                        plotX: e.plotX,
                        isInside: e.isInside,
                        negative: e.negative,
                        zone: e.zone,
                        y: e.y
                    }, (e.graphic || e.graphics[0]) && (e.graphics[0] = e.graphic), e.graphic = e.graphics[1], e.plotY = e.plotHigh, h(e.plotHighX) && (e.plotX = e.plotHighX), e.y = p(e.high, e.origProps.y), e.negative = e.y < (this.options.threshold || 0), this.zones.length && (e.zone = e.getZone()), this.chart.polar || (e.isInside = e.isTopInside = void 0 !== e.plotY && e.plotY >= 0 && e.plotY <= this.yAxis.len && e.plotX >= 0 && e.plotX <= this.xAxis.len), t++;
                    for(s.drawPoints.apply(this, arguments), t = 0; t < i;)(e = this.points[t]).graphics = e.graphics || [], (e.graphic || e.graphics[1]) && (e.graphics[1] = e.graphic), e.graphic = e.graphics[0], e.origProps && (c(e, e.origProps), delete e.origProps), t++;
                }
                hasMarkerChanged(t, e) {
                    let i = t.lowMarker, n = e.lowMarker || {};
                    return i && (!1 === i.enabled || n.symbol !== i.symbol || n.height !== i.height || n.width !== i.width) || super.hasMarkerChanged(t, e);
                }
            }
            return g.defaultOptions = f(o.defaultOptions, {
                lineWidth: 1,
                threshold: null,
                tooltip: {
                    pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'
                },
                trackByArea: !0,
                dataLabels: {
                    align: void 0,
                    verticalAlign: void 0,
                    xLow: 0,
                    xHigh: 0,
                    yLow: 0,
                    yHigh: 0
                }
            }), l(g, "afterTranslate", function() {
                "low,high" === this.pointArrayMap.join(",") && this.points.forEach((t)=>{
                    let e = t.high, i = t.plotY;
                    t.isNull ? t.plotY = void 0 : (t.plotLow = i, t.plotHigh = u(e) ? this.yAxis.translate(this.dataModify ? this.dataModify.modifyValue(e) : e, !1, !0, void 0, !0) : void 0, this.dataModify && (t.yBottom = t.plotHigh));
                });
            }, {
                order: 0
            }), l(g, "afterTranslate", function() {
                this.points.forEach((t)=>{
                    if (this.chart.polar) this.highToXY(t), t.plotLow = t.plotY, t.tooltipPos = [
                        ((t.plotHighX || 0) + (t.plotLowX || 0)) / 2,
                        ((t.plotHigh || 0) + (t.plotLow || 0)) / 2
                    ];
                    else {
                        let e = t.pos(!1, t.plotLow), i = t.pos(!1, t.plotHigh);
                        e && i && (e[0] = (e[0] + i[0]) / 2, e[1] = (e[1] + i[1]) / 2), t.tooltipPos = e;
                    }
                });
            }, {
                order: 3
            }), c(g.prototype, {
                deferTranslatePolar: !0,
                pointArrayMap: [
                    "low",
                    "high"
                ],
                pointClass: t,
                pointValKey: "low",
                setStackedPoints: r
            }), i.registerSeriesType("arearange", g), g;
        }), i(e, "Series/AreaSplineRange/AreaSplineRangeSeries.js", [
            e["Series/AreaRange/AreaRangeSeries.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { spline: { prototype: n } } = e.seriesTypes, { merge: r, extend: o } = i;
            class s extends t {
            }
            return s.defaultOptions = r(t.defaultOptions), o(s.prototype, {
                getPointSpline: n.getPointSpline
            }), e.registerSeriesType("areasplinerange", s), s;
        }), i(e, "Series/BoxPlot/BoxPlotSeriesDefaults.js", [], function() {
            return {
                threshold: null,
                tooltip: {
                    pointFormat: '<span style="color:{point.color}">\u25CF</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>'
                },
                whiskerLength: "50%",
                fillColor: "#ffffff",
                lineWidth: 1,
                medianWidth: 2,
                whiskerWidth: 2
            };
        }), i(e, "Series/BoxPlot/BoxPlotSeries.js", [
            e["Series/BoxPlot/BoxPlotSeriesDefaults.js"],
            e["Series/Column/ColumnSeries.js"],
            e["Core/Globals.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { noop: o } = i, { crisp: s, extend: a, merge: l, pick: h } = r;
            class c extends e {
                pointAttribs() {
                    return {};
                }
                translate() {
                    let t = this.yAxis, e = this.pointArrayMap;
                    super.translate.apply(this), this.points.forEach(function(i) {
                        e.forEach(function(e) {
                            null !== i[e] && (i[e + "Plot"] = t.translate(i[e], 0, 1, 0, 1));
                        }), i.plotHigh = i.highPlot;
                    });
                }
                drawPoints() {
                    let t, e, i, n, r, o, a, l, c, d, u, p = this.points, f = this.options, g = this.chart, m = g.renderer, b = !1 !== this.doQuartiles, y = this.options.whiskerLength;
                    for (let x of p){
                        let p = (o = x.graphic) ? "animate" : "attr", v = x.shapeArgs, w = {}, C = {}, S = {}, k = {}, A = x.color || this.color;
                        if (void 0 !== x.plotY) {
                            let E;
                            a = v.width, c = (l = v.x) + a, d = a / 2, t = b ? x.q1Plot : x.lowPlot, e = b ? x.q3Plot : x.lowPlot, i = x.highPlot, n = x.lowPlot, o || (x.graphic = o = m.g("point").add(this.group), x.stem = m.path().addClass("highcharts-boxplot-stem").add(o), y && (x.whiskers = m.path().addClass("highcharts-boxplot-whisker").add(o)), b && (x.box = m.path(void 0).addClass("highcharts-boxplot-box").add(o)), x.medianShape = m.path(void 0).addClass("highcharts-boxplot-median").add(o)), g.styledMode || (C.stroke = x.stemColor || f.stemColor || A, C["stroke-width"] = h(x.stemWidth, f.stemWidth, f.lineWidth), C.dashstyle = x.stemDashStyle || f.stemDashStyle || f.dashStyle, x.stem.attr(C), y && (S.stroke = x.whiskerColor || f.whiskerColor || A, S["stroke-width"] = h(x.whiskerWidth, f.whiskerWidth, f.lineWidth), S.dashstyle = x.whiskerDashStyle || f.whiskerDashStyle || f.dashStyle, x.whiskers.attr(S)), b && (w.fill = x.fillColor || f.fillColor || A, w.stroke = f.lineColor || A, w["stroke-width"] = f.lineWidth || 0, w.dashstyle = x.boxDashStyle || f.boxDashStyle || f.dashStyle, x.box.attr(w)), k.stroke = x.medianColor || f.medianColor || A, k["stroke-width"] = h(x.medianWidth, f.medianWidth, f.lineWidth), k.dashstyle = x.medianDashStyle || f.medianDashStyle || f.dashStyle, x.medianShape.attr(k));
                            let M = s((x.plotX || 0) + (this.pointXOffset || 0) + (this.barW || 0) / 2, x.stem.strokeWidth());
                            if (E = [
                                [
                                    "M",
                                    M,
                                    e
                                ],
                                [
                                    "L",
                                    M,
                                    i
                                ],
                                [
                                    "M",
                                    M,
                                    t
                                ],
                                [
                                    "L",
                                    M,
                                    n
                                ]
                            ], x.stem[p]({
                                d: E
                            }), b) {
                                let i = x.box.strokeWidth();
                                t = s(t, i), e = s(e, i), E = [
                                    [
                                        "M",
                                        l = s(l, i),
                                        e
                                    ],
                                    [
                                        "L",
                                        l,
                                        t
                                    ],
                                    [
                                        "L",
                                        c = s(c, i),
                                        t
                                    ],
                                    [
                                        "L",
                                        c,
                                        e
                                    ],
                                    [
                                        "L",
                                        l,
                                        e
                                    ],
                                    [
                                        "Z"
                                    ]
                                ], x.box[p]({
                                    d: E
                                });
                            }
                            if (y) {
                                let t = x.whiskers.strokeWidth();
                                i = s(x.highPlot, t), n = s(x.lowPlot, t), E = [
                                    [
                                        "M",
                                        s(M - (u = "string" == typeof y && /%$/.test(y) ? d * parseFloat(y) / 100 : Number(y) / 2)),
                                        i
                                    ],
                                    [
                                        "L",
                                        s(M + u),
                                        i
                                    ],
                                    [
                                        "M",
                                        s(M - u),
                                        n
                                    ],
                                    [
                                        "L",
                                        s(M + u),
                                        n
                                    ]
                                ], x.whiskers[p]({
                                    d: E
                                });
                            }
                            E = [
                                [
                                    "M",
                                    l,
                                    r = s(x.medianPlot, x.medianShape.strokeWidth())
                                ],
                                [
                                    "L",
                                    c,
                                    r
                                ]
                            ], x.medianShape[p]({
                                d: E
                            });
                        }
                    }
                }
                toYData(t) {
                    return [
                        t.low,
                        t.q1,
                        t.median,
                        t.q3,
                        t.high
                    ];
                }
            }
            return c.defaultOptions = l(e.defaultOptions, t), a(c.prototype, {
                pointArrayMap: [
                    "low",
                    "q1",
                    "median",
                    "q3",
                    "high"
                ],
                pointValKey: "high",
                drawDataLabels: o,
                setStackedPoints: o
            }), n.registerSeriesType("boxplot", c), c;
        }), i(e, "Series/Bubble/BubbleLegendDefaults.js", [], function() {
            return {
                borderColor: void 0,
                borderWidth: 2,
                className: void 0,
                color: void 0,
                connectorClassName: void 0,
                connectorColor: void 0,
                connectorDistance: 60,
                connectorWidth: 1,
                enabled: !1,
                labels: {
                    className: void 0,
                    allowOverlap: !1,
                    format: "",
                    formatter: void 0,
                    align: "right",
                    style: {
                        fontSize: "0.9em",
                        color: "#000000"
                    },
                    x: 0,
                    y: 0
                },
                maxSize: 60,
                minSize: 10,
                legendIndex: 0,
                ranges: {
                    value: void 0,
                    borderColor: void 0,
                    color: void 0,
                    connectorColor: void 0
                },
                sizeBy: "area",
                sizeByAbsoluteValue: !1,
                zIndex: 1,
                zThreshold: 0
            };
        }), i(e, "Series/Bubble/BubbleLegendItem.js", [
            e["Core/Color/Color.js"],
            e["Core/Templating.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { parse: r } = t, { noop: o } = i, { arrayMax: s, arrayMin: a, isNumber: l, merge: h, pick: c, stableSort: d } = n;
            return class {
                constructor(t, e){
                    this.setState = o, this.init(t, e);
                }
                init(t, e) {
                    this.options = t, this.visible = !0, this.chart = e.chart, this.legend = e;
                }
                addToLegend(t) {
                    t.splice(this.options.legendIndex, 0, this);
                }
                drawLegendSymbol(t) {
                    let e, i = c(t.options.itemDistance, 20), n = this.legendItem || {}, r = this.options, o = r.ranges, s = r.connectorDistance;
                    if (!o || !o.length || !l(o[0].value)) return void (t.options.bubbleLegend.autoRanges = !0);
                    d(o, function(t, e) {
                        return e.value - t.value;
                    }), this.ranges = o, this.setOptions(), this.render();
                    let a = this.getMaxLabelSize(), h = this.ranges[0].radius, u = 2 * h;
                    e = (e = s - h + a.width) > 0 ? e : 0, this.maxLabel = a, this.movementX = "left" === r.labels.align ? e : 0, n.labelWidth = u + e + i, n.labelHeight = u + a.height / 2;
                }
                setOptions() {
                    let t = this.ranges, e = this.options, i = this.chart.series[e.seriesIndex], n = this.legend.baseline, o = {
                        zIndex: e.zIndex,
                        "stroke-width": e.borderWidth
                    }, s = {
                        zIndex: e.zIndex,
                        "stroke-width": e.connectorWidth
                    }, a = {
                        align: this.legend.options.rtl || "left" === e.labels.align ? "right" : "left",
                        zIndex: e.zIndex
                    }, l = i.options.marker.fillOpacity, d = this.chart.styledMode;
                    t.forEach(function(u, p) {
                        d || (o.stroke = c(u.borderColor, e.borderColor, i.color), o.fill = c(u.color, e.color, 1 !== l ? r(i.color).setOpacity(l).get("rgba") : i.color), s.stroke = c(u.connectorColor, e.connectorColor, i.color)), t[p].radius = this.getRangeRadius(u.value), t[p] = h(t[p], {
                            center: t[0].radius - t[p].radius + n
                        }), d || h(!0, t[p], {
                            bubbleAttribs: h(o),
                            connectorAttribs: h(s),
                            labelAttribs: a
                        });
                    }, this);
                }
                getRangeRadius(t) {
                    let e = this.options, i = this.options.seriesIndex, n = this.chart.series[i], r = e.ranges[0].value, o = e.ranges[e.ranges.length - 1].value, s = e.minSize, a = e.maxSize;
                    return n.getRadius.call(this, o, r, s, a, t);
                }
                render() {
                    let t = this.legendItem || {}, e = this.chart.renderer, i = this.options.zThreshold;
                    for (let n of (this.symbols || (this.symbols = {
                        connectors: [],
                        bubbleItems: [],
                        labels: []
                    }), t.symbol = e.g("bubble-legend"), t.label = e.g("bubble-legend-item").css(this.legend.itemStyle || {}), t.symbol.translateX = 0, t.symbol.translateY = 0, t.symbol.add(t.label), t.label.add(t.group), this.ranges))n.value >= i && this.renderRange(n);
                    this.hideOverlappingLabels();
                }
                renderRange(t) {
                    let e = this.ranges[0], i = this.legend, n = this.options, r = n.labels, o = this.chart, s = o.series[n.seriesIndex], a = o.renderer, l = this.symbols, h = l.labels, c = t.center, d = Math.abs(t.radius), u = n.connectorDistance || 0, p = r.align, f = i.options.rtl, g = n.borderWidth, m = n.connectorWidth, b = e.radius || 0, y = c - d - g / 2 + m / 2, x = (y % 1 ? 1 : .5) - (m % 2 ? 0 : .5), v = a.styledMode, w = f || "left" === p ? -u : u;
                    "center" === p && (w = 0, n.connectorDistance = 0, t.labelAttribs.align = "center"), l.bubbleItems.push(a.circle(b, c + x, d).attr(v ? {} : t.bubbleAttribs).addClass((v ? "highcharts-color-" + s.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (n.className || "")).add(this.legendItem.symbol)), l.connectors.push(a.path(a.crispLine([
                        [
                            "M",
                            b,
                            y
                        ],
                        [
                            "L",
                            b + w,
                            y
                        ]
                    ], n.connectorWidth)).attr(v ? {} : t.connectorAttribs).addClass((v ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (n.connectorClassName || "")).add(this.legendItem.symbol));
                    let C = a.text(this.formatLabel(t)).attr(v ? {} : t.labelAttribs).css(v ? {} : r.style).addClass("highcharts-bubble-legend-labels " + (n.labels.className || "")).add(this.legendItem.symbol), S = {
                        x: b + w + n.labels.x,
                        y: y + n.labels.y + .4 * C.getBBox().height
                    };
                    C.attr(S), h.push(C), C.placed = !0, C.alignAttr = S;
                }
                getMaxLabelSize() {
                    let t, e;
                    return this.symbols.labels.forEach(function(i) {
                        e = i.getBBox(!0), t = t ? e.width > t.width ? e : t : e;
                    }), t || {};
                }
                formatLabel(t) {
                    let i = this.options, n = i.labels.formatter, r = i.labels.format, { numberFormatter: o } = this.chart;
                    return r ? e.format(r, t) : n ? n.call(t) : o(t.value, 1);
                }
                hideOverlappingLabels() {
                    let t = this.chart, e = this.options.labels.allowOverlap, i = this.symbols;
                    !e && i && (t.hideOverlappingLabels(i.labels), i.labels.forEach(function(t, e) {
                        t.newOpacity ? t.newOpacity !== t.oldOpacity && i.connectors[e].show() : i.connectors[e].hide();
                    }));
                }
                getRanges() {
                    let t, e, i = this.legend.bubbleLegend, n = i.chart.series, r = i.options.ranges, o = Number.MAX_VALUE, d = -Number.MAX_VALUE;
                    return n.forEach(function(t) {
                        t.isBubble && !t.ignoreSeries && (e = t.zData.filter(l)).length && (o = c(t.options.zMin, Math.min(o, Math.max(a(e), !1 === t.options.displayNegative ? t.options.zThreshold : -Number.MAX_VALUE))), d = c(t.options.zMax, Math.max(d, s(e))));
                    }), t = o === d ? [
                        {
                            value: d
                        }
                    ] : [
                        {
                            value: o
                        },
                        {
                            value: (o + d) / 2
                        },
                        {
                            value: d,
                            autoRanges: !0
                        }
                    ], r.length && r[0].radius && t.reverse(), t.forEach(function(e, i) {
                        r && r[i] && (t[i] = h(r[i], e));
                    }), t;
                }
                predictBubbleSizes() {
                    let t, e = this.chart, i = e.legend.options, n = i.floating, r = "horizontal" === i.layout, o = r ? e.legend.lastLineHeight : 0, s = e.plotSizeX, a = e.plotSizeY, l = e.series[this.options.seriesIndex], h = l.getPxExtremes(), c = Math.ceil(h.minPxSize), d = Math.ceil(h.maxPxSize), u = Math.min(a, s), p = l.options.maxSize;
                    return n || !/%$/.test(p) ? t = d : (t = (u + o) * (p = parseFloat(p)) / 100 / (p / 100 + 1), (r && a - t >= s || !r && s - t >= a) && (t = d)), [
                        c,
                        Math.ceil(t)
                    ];
                }
                updateRanges(t, e) {
                    let i = this.legend.options.bubbleLegend;
                    i.minSize = t, i.maxSize = e, i.ranges = this.getRanges();
                }
                correctSizes() {
                    let t = this.legend, e = this.chart.series[this.options.seriesIndex].getPxExtremes();
                    Math.abs(Math.ceil(e.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, e.maxPxSize), t.render());
                }
            };
        }), i(e, "Series/Bubble/BubbleLegendComposition.js", [
            e["Series/Bubble/BubbleLegendDefaults.js"],
            e["Series/Bubble/BubbleLegendItem.js"],
            e["Core/Defaults.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { setOptions: o } = i, { composed: s } = n, { addEvent: a, objectEach: l, pushUnique: h, wrap: c } = r;
            function d(t, e, i) {
                let n, r, o, s = this.legend, a = u(this) >= 0;
                s && s.options.enabled && s.bubbleLegend && s.options.bubbleLegend.autoRanges && a ? (n = s.bubbleLegend.options, r = s.bubbleLegend.predictBubbleSizes(), s.bubbleLegend.updateRanges(r[0], r[1]), n.placed || (s.group.placed = !1, s.allItems.forEach((t)=>{
                    (o = t.legendItem || {}).group && (o.group.translateY = void 0);
                })), s.render(), n.placed || (this.getMargins(), this.axes.forEach(function(t) {
                    t.visible && t.render(), n.placed || (t.setScale(), t.updateNames(), l(t.ticks, function(t) {
                        t.isNew = !0, t.isNewLabel = !0;
                    }));
                }), this.getMargins()), n.placed = !0, t.call(this, e, i), s.bubbleLegend.correctSizes(), m(s, p(s))) : (t.call(this, e, i), s && s.options.enabled && s.bubbleLegend && (s.render(), m(s, p(s))));
            }
            function u(t) {
                let e = t.series, i = 0;
                for(; i < e.length;){
                    if (e[i] && e[i].isBubble && e[i].visible && e[i].zData.length) return i;
                    i++;
                }
                return -1;
            }
            function p(t) {
                let e, i, n, r = t.allItems, o = [], s = r.length, a = 0, l = 0;
                for(a = 0; a < s; a++)if (i = r[a].legendItem || {}, n = (r[a + 1] || {}).legendItem || {}, i.labelHeight && (r[a].itemHeight = i.labelHeight), r[a] === r[s - 1] || i.y !== n.y) {
                    for(o.push({
                        height: 0
                    }), e = o[o.length - 1]; l <= a; l++)r[l].itemHeight > e.height && (e.height = r[l].itemHeight);
                    e.step = a;
                }
                return o;
            }
            function f(t) {
                let i = this.bubbleLegend, n = this.options, r = n.bubbleLegend, o = u(this.chart);
                i && i.ranges && i.ranges.length && (r.ranges.length && (r.autoRanges = !!r.ranges[0].autoRanges), this.destroyItem(i)), o >= 0 && n.enabled && r.enabled && (r.seriesIndex = o, this.bubbleLegend = new e(r, this), this.bubbleLegend.addToLegend(t.allItems));
            }
            function g(t) {
                let e;
                if (t.defaultPrevented) return !1;
                let i = t.legendItem, n = this.chart, r = i.visible;
                this && this.bubbleLegend && (i.visible = !r, i.ignoreSeries = r, e = u(n) >= 0, this.bubbleLegend.visible !== e && (this.update({
                    bubbleLegend: {
                        enabled: e
                    }
                }), this.bubbleLegend.visible = e), i.visible = r);
            }
            function m(t, e) {
                let i, n, r, o, s = t.allItems, a = t.options.rtl, l = 0;
                s.forEach((t, s)=>{
                    (o = t.legendItem || {}).group && (i = o.group.translateX || 0, n = o.y || 0, ((r = t.movementX) || a && t.ranges) && (r = a ? i - t.options.maxSize / 2 : i + r, o.group.attr({
                        translateX: r
                    })), s > e[l].step && l++, o.group.attr({
                        translateY: Math.round(n + e[l].height / 2)
                    }), o.y = n + e[l].height / 2);
                });
            }
            return {
                compose: function(e, i) {
                    h(s, "Series.BubbleLegend") && (o({
                        legend: {
                            bubbleLegend: t
                        }
                    }), c(e.prototype, "drawChartBox", d), a(i, "afterGetAllItems", f), a(i, "itemClick", g));
                }
            };
        }), i(e, "Series/Bubble/BubblePoint.js", [
            e["Core/Series/Point.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { seriesTypes: { scatter: { prototype: { pointClass: n } } } } = e, { extend: r } = i;
            class o extends n {
                haloPath(e) {
                    let i = (e && this.marker && this.marker.radius || 0) + e;
                    if (this.series.chart.inverted) {
                        let t = this.pos() || [
                            0,
                            0
                        ], { xAxis: e, yAxis: n, chart: r } = this.series;
                        return r.renderer.symbols.circle(e.len - t[1] - i, n.len - t[0] - i, 2 * i, 2 * i);
                    }
                    return t.prototype.haloPath.call(this, i);
                }
            }
            return r(o.prototype, {
                ttBelow: !1
            }), o;
        }), i(e, "Series/Bubble/BubbleSeries.js", [
            e["Series/Bubble/BubbleLegendComposition.js"],
            e["Series/Bubble/BubblePoint.js"],
            e["Core/Color/Color.js"],
            e["Core/Globals.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o) {
            let { parse: s } = i, { composed: a, noop: l } = n, { series: h, seriesTypes: { column: { prototype: c }, scatter: d } } = r, { addEvent: u, arrayMax: p, arrayMin: f, clamp: g, extend: m, isNumber: b, merge: y, pick: x, pushUnique: v } = o;
            function w() {
                let t, e = this.len, { coll: i, isXAxis: n, min: r } = this, o = n ? "xData" : "yData", s = (this.max || 0) - (r || 0), a = 0, l = e, h = e / s;
                ("xAxis" === i || "yAxis" === i) && (this.series.forEach((e)=>{
                    if (e.bubblePadding && e.reserveSpace()) {
                        this.allowZoomOutside = !0, t = !0;
                        let i = e[o];
                        if (n && ((e.onPoint || e).getRadii(0, 0, e), e.onPoint && (e.radii = e.onPoint.radii)), s > 0) {
                            let t = i.length;
                            for(; t--;)if (b(i[t]) && this.dataMin <= i[t] && i[t] <= this.max) {
                                let n = e.radii && e.radii[t] || 0;
                                a = Math.min((i[t] - r) * h - n, a), l = Math.max((i[t] - r) * h + n, l);
                            }
                        }
                    }
                }), t && s > 0 && !this.logarithmic && (l -= e, h *= (e + Math.max(0, a) - Math.min(l, e)) / e, [
                    [
                        "min",
                        "userMin",
                        a
                    ],
                    [
                        "max",
                        "userMax",
                        l
                    ]
                ].forEach((t)=>{
                    void 0 === x(this.options[t[0]], this[t[1]]) && (this[t[0]] += t[2] / h);
                })));
            }
            class C extends d {
                static compose(e, i, n) {
                    t.compose(i, n), v(a, "Series.Bubble") && u(e, "foundExtremes", w);
                }
                animate(t) {
                    !t && this.points.length < this.options.animationLimit && this.points.forEach(function(t) {
                        let { graphic: e, plotX: i = 0, plotY: n = 0 } = t;
                        e && e.width && (this.hasRendered || e.attr({
                            x: i,
                            y: n,
                            width: 1,
                            height: 1
                        }), e.animate(this.markerAttribs(t), this.options.animation));
                    }, this);
                }
                getRadii() {
                    let t, e, i, n = this.zData, r = this.yData, o = [], s = this.chart.bubbleZExtremes, { minPxSize: a, maxPxSize: l } = this.getPxExtremes();
                    if (!s) {
                        let t, e = Number.MAX_VALUE, i = -Number.MAX_VALUE;
                        this.chart.series.forEach((n)=>{
                            if (n.bubblePadding && n.reserveSpace()) {
                                let r = (n.onPoint || n).getZExtremes();
                                r && (e = Math.min(x(e, r.zMin), r.zMin), i = Math.max(x(i, r.zMax), r.zMax), t = !0);
                            }
                        }), t ? (s = {
                            zMin: e,
                            zMax: i
                        }, this.chart.bubbleZExtremes = s) : s = {
                            zMin: 0,
                            zMax: 0
                        };
                    }
                    for(e = 0, t = n.length; e < t; e++)i = n[e], o.push(this.getRadius(s.zMin, s.zMax, a, l, i, r && r[e]));
                    this.radii = o;
                }
                getRadius(t, e, i, n, r, o) {
                    let s = this.options, a = "width" !== s.sizeBy, l = s.zThreshold, h = e - t, c = .5;
                    if (null === o || null === r) return null;
                    if (b(r)) {
                        if (s.sizeByAbsoluteValue && (r = Math.abs(r - l), e = h = Math.max(e - l, Math.abs(t - l)), t = 0), r < t) return i / 2 - 1;
                        h > 0 && (c = (r - t) / h);
                    }
                    return a && c >= 0 && (c = Math.sqrt(c)), Math.ceil(i + c * (n - i)) / 2;
                }
                hasData() {
                    return !!this.processedXData.length;
                }
                markerAttribs(t, e) {
                    let i = super.markerAttribs(t, e), { height: n = 0, width: r = 0 } = i;
                    return this.chart.inverted ? m(i, {
                        x: (t.plotX || 0) - r / 2,
                        y: (t.plotY || 0) - n / 2
                    }) : i;
                }
                pointAttribs(t, e) {
                    let i = this.options.marker.fillOpacity, n = h.prototype.pointAttribs.call(this, t, e);
                    return 1 !== i && (n.fill = s(n.fill).setOpacity(i).get("rgba")), n;
                }
                translate() {
                    super.translate.call(this), this.getRadii(), this.translateBubble();
                }
                translateBubble() {
                    let { data: t, options: e, radii: i } = this, { minPxSize: n } = this.getPxExtremes(), r = t.length;
                    for(; r--;){
                        let o = t[r], s = i ? i[r] : 0;
                        "z" === this.zoneAxis && (o.negative = (o.z || 0) < (e.zThreshold || 0)), b(s) && s >= n / 2 ? (o.marker = m(o.marker, {
                            radius: s,
                            width: 2 * s,
                            height: 2 * s
                        }), o.dlBox = {
                            x: o.plotX - s,
                            y: o.plotY - s,
                            width: 2 * s,
                            height: 2 * s
                        }) : (o.shapeArgs = o.plotY = o.dlBox = void 0, o.isInside = !1);
                    }
                }
                getPxExtremes() {
                    let t = Math.min(this.chart.plotWidth, this.chart.plotHeight), e = (e)=>{
                        let i;
                        return "string" == typeof e && (i = /%$/.test(e), e = parseInt(e, 10)), i ? t * e / 100 : e;
                    }, i = e(x(this.options.minSize, 8));
                    return {
                        minPxSize: i,
                        maxPxSize: Math.max(e(x(this.options.maxSize, "20%")), i)
                    };
                }
                getZExtremes() {
                    let t = this.options, e = (this.zData || []).filter(b);
                    if (e.length) {
                        let i = x(t.zMin, g(f(e), !1 === t.displayNegative ? t.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)), n = x(t.zMax, p(e));
                        if (b(i) && b(n)) return {
                            zMin: i,
                            zMax: n
                        };
                    }
                }
            }
            return C.defaultOptions = y(d.defaultOptions, {
                dataLabels: {
                    formatter: function() {
                        let { numberFormatter: t } = this.series.chart, { z: e } = this.point;
                        return b(e) ? t(e, -1) : "";
                    },
                    inside: !0,
                    verticalAlign: "middle"
                },
                animationLimit: 250,
                marker: {
                    lineColor: null,
                    lineWidth: 1,
                    fillOpacity: .5,
                    radius: null,
                    states: {
                        hover: {
                            radiusPlus: 0
                        }
                    },
                    symbol: "circle"
                },
                minSize: 8,
                maxSize: "20%",
                softThreshold: !1,
                states: {
                    hover: {
                        halo: {
                            size: 5
                        }
                    }
                },
                tooltip: {
                    pointFormat: "({point.x}, {point.y}), Size: {point.z}"
                },
                turboThreshold: 0,
                zThreshold: 0,
                zoneAxis: "z"
            }), m(C.prototype, {
                alignDataLabel: c.alignDataLabel,
                applyZones: l,
                bubblePadding: !0,
                isBubble: !0,
                pointArrayMap: [
                    "y",
                    "z"
                ],
                pointClass: e,
                parallelArrays: [
                    "x",
                    "y",
                    "z"
                ],
                trackerGroups: [
                    "group",
                    "dataLabelsGroup"
                ],
                specialGroup: "group",
                zoneAxis: "z"
            }), u(C, "updatedData", (t)=>{
                delete t.target.chart.bubbleZExtremes;
            }), u(C, "remove", (t)=>{
                delete t.target.chart.bubbleZExtremes;
            }), r.registerSeriesType("bubble", C), C;
        }), i(e, "Series/ColumnRange/ColumnRangePoint.js", [
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { seriesTypes: { column: { prototype: { pointClass: { prototype: i } } }, arearange: { prototype: { pointClass: n } } } } = t, { extend: r, isNumber: o } = e;
            class s extends n {
                isValid() {
                    return o(this.low);
                }
            }
            return r(s.prototype, {
                setState: i.setState
            }), s;
        }), i(e, "Series/ColumnRange/ColumnRangeSeries.js", [
            e["Series/ColumnRange/ColumnRangePoint.js"],
            e["Core/Globals.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { noop: r } = e, { seriesTypes: { arearange: o, column: s, column: { prototype: a } } } = i, { addEvent: l, clamp: h, extend: c, isNumber: d, merge: u, pick: p } = n;
            class f extends o {
                setOptions() {
                    return u(!0, arguments[0], {
                        stacking: void 0
                    }), o.prototype.setOptions.apply(this, arguments);
                }
                translate() {
                    return a.translate.apply(this);
                }
                pointAttribs() {
                    return a.pointAttribs.apply(this, arguments);
                }
                translate3dPoints() {
                    return a.translate3dPoints.apply(this, arguments);
                }
                translate3dShapes() {
                    return a.translate3dShapes.apply(this, arguments);
                }
                afterColumnTranslate() {
                    let t, e, i, n, r = this.yAxis, o = this.xAxis, s = o.startAngleRad, a = this.chart, l = this.xAxis.isRadial, c = Math.max(a.chartWidth, a.chartHeight) + 999;
                    this.points.forEach((f)=>{
                        let g = f.shapeArgs || {}, m = this.options.minPointLength, b = f.plotY, y = r.translate(f.high, 0, 1, 0, 1);
                        if (d(y) && d(b)) {
                            if (f.plotHigh = h(y, -c, c), f.plotLow = h(b, -c, c), n = f.plotHigh, Math.abs(t = p(f.rectPlotY, f.plotY) - f.plotHigh) < m ? (e = m - t, t += e, n -= e / 2) : t < 0 && (t *= -1, n -= t), l && this.polar) i = f.barX + s, f.shapeType = "arc", f.shapeArgs = this.polar.arc(n + t, n, i, i + f.pointWidth);
                            else {
                                g.height = t, g.y = n;
                                let { x: e = 0, width: i = 0 } = g;
                                f.shapeArgs = u(f.shapeArgs, this.crispCol(e, n, i, t)), f.tooltipPos = a.inverted ? [
                                    r.len + r.pos - a.plotLeft - n - t / 2,
                                    o.len + o.pos - a.plotTop - e - i / 2,
                                    t
                                ] : [
                                    o.left - a.plotLeft + e + i / 2,
                                    r.pos - a.plotTop + n + t / 2,
                                    t
                                ];
                            }
                        }
                    });
                }
            }
            return f.defaultOptions = u(s.defaultOptions, o.defaultOptions, {
                borderRadius: {
                    where: "all"
                },
                pointRange: null,
                legendSymbol: "rectangle",
                marker: null,
                states: {
                    hover: {
                        halo: !1
                    }
                }
            }), l(f, "afterColumnTranslate", function() {
                f.prototype.afterColumnTranslate.apply(this);
            }, {
                order: 5
            }), c(f.prototype, {
                directTouch: !0,
                pointClass: t,
                trackerGroups: [
                    "group",
                    "dataLabelsGroup"
                ],
                adjustForMissingColumns: a.adjustForMissingColumns,
                animate: a.animate,
                crispCol: a.crispCol,
                drawGraph: r,
                drawPoints: a.drawPoints,
                getSymbol: r,
                drawTracker: a.drawTracker,
                getColumnMetrics: a.getColumnMetrics
            }), i.registerSeriesType("columnrange", f), f;
        }), i(e, "Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js", [], function() {
            return {};
        }), i(e, "Series/ColumnPyramid/ColumnPyramidSeries.js", [
            e["Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { column: n } = e.seriesTypes, { clamp: r, merge: o, pick: s } = i;
            class a extends n {
                translate() {
                    let t = this.chart, e = this.options, i = this.dense = this.closestPointRange * this.xAxis.transA < 2, n = this.borderWidth = s(e.borderWidth, i ? 0 : 1), o = this.yAxis, a = e.threshold, l = s(e.minPointLength, 5), h = this.getColumnMetrics(), c = h.width, d = this.pointXOffset = h.offset, u = this.translatedThreshold = o.getThreshold(a), p = this.barW = Math.max(c, 1 + 2 * n);
                    for (let i of (t.inverted && (u -= .5), e.pointPadding && (p = Math.ceil(p)), super.translate(), this.points)){
                        let n, f, g, m, b, y, x, v, w, C, S, k = s(i.yBottom, u), A = 999 + Math.abs(k), E = r(i.plotY, -A, o.len + A), M = p / 2, T = Math.min(E, k), P = Math.max(E, k) - T, R = i.plotX + d;
                        e.centerInCategory && (R = this.adjustForMissingColumns(R, c, i, h)), i.barX = R, i.pointWidth = c, i.tooltipPos = t.inverted ? [
                            o.len + o.pos - t.plotLeft - E,
                            this.xAxis.len - R - M,
                            P
                        ] : [
                            R + M,
                            E + o.pos - t.plotTop,
                            P
                        ], n = a + (i.total || i.y), "percent" === e.stacking && (n = a + (i.y < 0) ? -100 : 100);
                        let L = o.toPixels(n, !0);
                        g = (f = t.plotHeight - L - (t.plotHeight - u)) ? M * (T - L) / f : 0, m = f ? M * (T + P - L) / f : 0, y = R - g + M, x = R + g + M, v = R + m + M, w = R - m + M, C = T - l, S = T + P, i.y < 0 && (C = T, S = T + P + l), t.inverted && (b = o.width - T, f = L - (o.width - u), g = M * (L - b) / f, m = M * (L - (b - P)) / f, x = (y = R + M + g) - 2 * g, v = R - m + M, w = R + m + M, C = T, S = T + P - l, i.y < 0 && (S = T + P + l)), i.shapeType = "path", i.shapeArgs = {
                            x: y,
                            y: C,
                            width: x - y,
                            height: P,
                            d: [
                                [
                                    "M",
                                    y,
                                    C
                                ],
                                [
                                    "L",
                                    x,
                                    C
                                ],
                                [
                                    "L",
                                    v,
                                    S
                                ],
                                [
                                    "L",
                                    w,
                                    S
                                ],
                                [
                                    "Z"
                                ]
                            ]
                        };
                    }
                }
            }
            return a.defaultOptions = o(n.defaultOptions, t), e.registerSeriesType("columnpyramid", a), a;
        }), i(e, "Series/ErrorBar/ErrorBarSeriesDefaults.js", [], function() {
            return {
                color: "#000000",
                grouping: !1,
                linkedTo: ":previous",
                tooltip: {
                    pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'
                },
                whiskerWidth: null
            };
        }), i(e, "Series/ErrorBar/ErrorBarSeries.js", [
            e["Series/BoxPlot/BoxPlotSeries.js"],
            e["Series/Column/ColumnSeries.js"],
            e["Series/ErrorBar/ErrorBarSeriesDefaults.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { arearange: o } = n.seriesTypes, { addEvent: s, merge: a, extend: l } = r;
            class h extends t {
                getColumnMetrics() {
                    return this.linkedParent && this.linkedParent.columnMetrics || e.prototype.getColumnMetrics.call(this);
                }
                drawDataLabels() {
                    let t = this.pointValKey;
                    if (o) for (let e of (o.prototype.drawDataLabels.call(this), this.points))e.y = e[t];
                }
                toYData(t) {
                    return [
                        t.low,
                        t.high
                    ];
                }
            }
            return h.defaultOptions = a(t.defaultOptions, i), s(h, "afterTranslate", function() {
                for (let t of this.points)t.plotLow = t.plotY;
            }, {
                order: 0
            }), l(h.prototype, {
                pointArrayMap: [
                    "low",
                    "high"
                ],
                pointValKey: "high",
                doQuartiles: !1
            }), n.registerSeriesType("errorbar", h), h;
        }), i(e, "Series/Gauge/GaugePoint.js", [
            e["Core/Series/SeriesRegistry.js"]
        ], function(t) {
            let { series: { prototype: { pointClass: e } } } = t;
            return class extends e {
                setState(t) {
                    this.state = t;
                }
            };
        }), i(e, "Series/Gauge/GaugeSeries.js", [
            e["Series/Gauge/GaugePoint.js"],
            e["Core/Globals.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { noop: r } = e, { series: o, seriesTypes: { column: s } } = i, { clamp: a, isNumber: l, extend: h, merge: c, pick: d, pInt: u, defined: p } = n;
            class f extends o {
                translate() {
                    let t = this.yAxis, e = this.options, i = t.center;
                    this.generatePoints(), this.points.forEach((n)=>{
                        let r = c(e.dial, n.dial), o = u(r.radius) * i[2] / 200, s = u(r.baseLength) * o / 100, h = u(r.rearLength) * o / 100, d = r.baseWidth, f = r.topWidth, g = e.overshoot, m = t.startAngleRad + t.translate(n.y, void 0, void 0, void 0, !0);
                        (l(g) || !1 === e.wrap) && (g = l(g) ? g / 180 * Math.PI : 0, m = a(m, t.startAngleRad - g, t.endAngleRad + g)), m = 180 * m / Math.PI, n.shapeType = "path";
                        let b = r.path || [
                            [
                                "M",
                                -h,
                                -d / 2
                            ],
                            [
                                "L",
                                s,
                                -d / 2
                            ],
                            [
                                "L",
                                o,
                                -f / 2
                            ],
                            [
                                "L",
                                o,
                                f / 2
                            ],
                            [
                                "L",
                                s,
                                d / 2
                            ],
                            [
                                "L",
                                -h,
                                d / 2
                            ],
                            [
                                "Z"
                            ]
                        ];
                        n.shapeArgs = {
                            d: b,
                            translateX: i[0],
                            translateY: i[1],
                            rotation: m
                        }, n.plotX = i[0], n.plotY = i[1], p(n.y) && t.max - t.min && (n.percentage = (n.y - t.min) / (t.max - t.min) * 100);
                    });
                }
                drawPoints() {
                    let t = this, e = t.chart, i = t.yAxis.center, n = t.pivot, r = t.options, o = r.pivot, s = e.renderer;
                    t.points.forEach((i)=>{
                        let n = i.graphic, o = i.shapeArgs, a = o.d, l = c(r.dial, i.dial);
                        n ? (n.animate(o), o.d = a) : i.graphic = s[i.shapeType](o).addClass("highcharts-dial").add(t.group), e.styledMode || i.graphic[n ? "animate" : "attr"]({
                            stroke: l.borderColor,
                            "stroke-width": l.borderWidth,
                            fill: l.backgroundColor
                        });
                    }), n ? n.animate({
                        translateX: i[0],
                        translateY: i[1]
                    }) : o && (t.pivot = s.circle(0, 0, o.radius).attr({
                        zIndex: 2
                    }).addClass("highcharts-pivot").translate(i[0], i[1]).add(t.group), e.styledMode || t.pivot.attr({
                        fill: o.backgroundColor,
                        stroke: o.borderColor,
                        "stroke-width": o.borderWidth
                    }));
                }
                animate(t) {
                    let e = this;
                    t || e.points.forEach((t)=>{
                        let i = t.graphic;
                        i && (i.attr({
                            rotation: 180 * e.yAxis.startAngleRad / Math.PI
                        }), i.animate({
                            rotation: t.shapeArgs.rotation
                        }, e.options.animation));
                    });
                }
                render() {
                    this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), o.prototype.render.call(this), this.group.clip(this.chart.clipRect);
                }
                setData(t, e) {
                    o.prototype.setData.call(this, t, !1), this.processData(), this.generatePoints(), d(e, !0) && this.chart.redraw();
                }
                hasData() {
                    return !!this.points.length;
                }
            }
            return f.defaultOptions = c(o.defaultOptions, {
                dataLabels: {
                    borderColor: "#cccccc",
                    borderRadius: 3,
                    borderWidth: 1,
                    crop: !1,
                    defer: !1,
                    enabled: !0,
                    verticalAlign: "top",
                    y: 15,
                    zIndex: 2
                },
                dial: {
                    backgroundColor: "#000000",
                    baseLength: "70%",
                    baseWidth: 3,
                    borderColor: "#cccccc",
                    borderWidth: 0,
                    radius: "80%",
                    rearLength: "10%",
                    topWidth: 1
                },
                pivot: {
                    radius: 5,
                    borderWidth: 0,
                    borderColor: "#cccccc",
                    backgroundColor: "#000000"
                },
                tooltip: {
                    headerFormat: ""
                },
                showInLegend: !1
            }), h(f.prototype, {
                angular: !0,
                directTouch: !0,
                drawGraph: r,
                drawTracker: s.prototype.drawTracker,
                fixedBox: !0,
                forceDL: !0,
                noSharedTooltip: !0,
                pointClass: t,
                trackerGroups: [
                    "group",
                    "dataLabelsGroup"
                ]
            }), i.registerSeriesType("gauge", f), f;
        }), i(e, "Series/DragNodesComposition.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { composed: i } = t, { addEvent: n, pushUnique: r } = e;
            function o() {
                let t, e, i, r = this;
                r.container && (t = n(r.container, "mousedown", (t)=>{
                    let o = r.hoverPoint;
                    o && o.series && o.series.hasDraggableNodes && o.series.options.draggable && (o.series.onMouseDown(o, t), e = n(r.container, "mousemove", (t)=>o && o.series && o.series.onMouseMove(o, t)), i = n(r.container.ownerDocument, "mouseup", (t)=>(e(), i(), o && o.series && o.series.onMouseUp(o, t))));
                })), n(r, "destroy", function() {
                    t();
                });
            }
            return {
                compose: function(t) {
                    r(i, "DragNodes") && n(t, "load", o);
                },
                onMouseDown: function(t, e) {
                    let i = this.chart.pointer?.normalize(e) || e;
                    t.fixedPosition = {
                        chartX: i.chartX,
                        chartY: i.chartY,
                        plotX: t.plotX,
                        plotY: t.plotY
                    }, t.inDragMode = !0;
                },
                onMouseMove: function(t, e) {
                    if (t.fixedPosition && t.inDragMode) {
                        let i, n, r = this.chart, o = r.pointer?.normalize(e) || e, s = t.fixedPosition.chartX - o.chartX, a = t.fixedPosition.chartY - o.chartY, l = r.graphLayoutsLookup;
                        (Math.abs(s) > 5 || Math.abs(a) > 5) && (i = t.fixedPosition.plotX - s, n = t.fixedPosition.plotY - a, r.isInsidePlot(i, n) && (t.plotX = i, t.plotY = n, t.hasDragged = !0, this.redrawHalo(t), l.forEach((t)=>{
                            t.restartSimulation();
                        })));
                    }
                },
                onMouseUp: function(t) {
                    t.fixedPosition && (t.hasDragged && (this.layout.enableSimulation ? this.layout.start() : this.chart.redraw()), t.inDragMode = t.hasDragged = !1, this.options.fixedDraggable || delete t.fixedPosition);
                },
                redrawHalo: function(t) {
                    t && this.halo && this.halo.attr({
                        d: t.haloPath(this.options.states.hover.halo.size)
                    });
                }
            };
        }), i(e, "Series/GraphLayoutComposition.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { setAnimation: n } = t, { composed: r } = e, { addEvent: o, pushUnique: s } = i;
            function a() {
                this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((t)=>{
                    t.updateSimulation();
                }), this.redraw());
            }
            function l() {
                this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach((t)=>{
                    t.updateSimulation(!1);
                }), this.redraw());
            }
            function h() {
                this.graphLayoutsLookup && this.graphLayoutsLookup.forEach((t)=>{
                    t.stop();
                });
            }
            function c() {
                let t, e = !1, i = (i)=>{
                    i.maxIterations-- && isFinite(i.temperature) && !i.isStable() && !i.enableSimulation && (i.beforeStep && i.beforeStep(), i.step(), t = !1, e = !0);
                };
                if (this.graphLayoutsLookup) {
                    for(n(!1, this), this.graphLayoutsLookup.forEach((t)=>t.start()); !t;)t = !0, this.graphLayoutsLookup.forEach(i);
                    e && this.series.forEach((t)=>{
                        t && t.layout && t.render();
                    });
                }
            }
            return {
                compose: function(t) {
                    s(r, "GraphLayout") && (o(t, "afterPrint", a), o(t, "beforePrint", l), o(t, "predraw", h), o(t, "render", c));
                },
                integrations: {},
                layouts: {}
            };
        }), i(e, "Series/PackedBubble/PackedBubblePoint.js", [
            e["Core/Chart/Chart.js"],
            e["Core/Series/Point.js"],
            e["Core/Series/SeriesRegistry.js"]
        ], function(t, e, i) {
            let { seriesTypes: { bubble: { prototype: { pointClass: n } } } } = i;
            return class extends n {
                destroy() {
                    return this.series?.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), e.prototype.destroy.apply(this, arguments);
                }
                firePointEvent() {
                    let t = this.series.options;
                    if (this.isParentNode && t.parentNode) {
                        let i = t.allowPointSelect;
                        t.allowPointSelect = t.parentNode.allowPointSelect, e.prototype.firePointEvent.apply(this, arguments), t.allowPointSelect = i;
                    } else e.prototype.firePointEvent.apply(this, arguments);
                }
                select() {
                    let i = this.series.chart;
                    this.isParentNode ? (i.getSelectedPoints = i.getSelectedParentNodes, e.prototype.select.apply(this, arguments), i.getSelectedPoints = t.prototype.getSelectedPoints) : e.prototype.select.apply(this, arguments);
                }
            };
        }), i(e, "Series/PackedBubble/PackedBubbleSeriesDefaults.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            let { isNumber: e } = t;
            return {
                minSize: "10%",
                maxSize: "50%",
                sizeBy: "area",
                zoneAxis: "y",
                crisp: !1,
                tooltip: {
                    pointFormat: "Value: {point.value}"
                },
                draggable: !0,
                useSimulation: !0,
                parentNode: {
                    allowPointSelect: !1
                },
                dataLabels: {
                    formatter: function() {
                        let { numberFormatter: t } = this.series.chart, { value: i } = this.point;
                        return e(i) ? t(i, -1) : "";
                    },
                    parentNodeFormatter: function() {
                        return this.name;
                    },
                    parentNodeTextPath: {
                        enabled: !0
                    },
                    padding: 0,
                    style: {
                        transition: "opacity 2000ms"
                    }
                },
                layoutAlgorithm: {
                    initialPositions: "circle",
                    initialPositionRadius: 20,
                    bubblePadding: 5,
                    parentNodeLimit: !1,
                    seriesInteraction: !0,
                    dragBetweenSeries: !1,
                    parentNodeOptions: {
                        maxIterations: 400,
                        gravitationalConstant: .03,
                        maxSpeed: 50,
                        initialPositionRadius: 100,
                        seriesInteraction: !0,
                        marker: {
                            fillColor: null,
                            fillOpacity: 1,
                            lineWidth: null,
                            lineColor: null,
                            symbol: "circle"
                        }
                    },
                    enableSimulation: !0,
                    type: "packedbubble",
                    integration: "packedbubble",
                    maxIterations: 1e3,
                    splitSeries: !1,
                    maxSpeed: 5,
                    gravitationalConstant: .01,
                    friction: -0.981
                }
            };
        }), i(e, "Series/Networkgraph/VerletIntegration.js", [], function() {
            return {
                attractive: function(t, e, i) {
                    let n = t.getMass(), r = -i.x * e * this.diffTemperature, o = -i.y * e * this.diffTemperature;
                    t.fromNode.fixedPosition || (t.fromNode.plotX -= r * n.fromNode / t.fromNode.degree, t.fromNode.plotY -= o * n.fromNode / t.fromNode.degree), t.toNode.fixedPosition || (t.toNode.plotX += r * n.toNode / t.toNode.degree, t.toNode.plotY += o * n.toNode / t.toNode.degree);
                },
                attractiveForceFunction: function(t, e) {
                    return (e - t) / t;
                },
                barycenter: function() {
                    let t = this.options.gravitationalConstant || 0, e = (this.barycenter.xFactor - (this.box.left + this.box.width) / 2) * t, i = (this.barycenter.yFactor - (this.box.top + this.box.height) / 2) * t;
                    this.nodes.forEach(function(t) {
                        t.fixedPosition || (t.plotX -= e / t.mass / t.degree, t.plotY -= i / t.mass / t.degree);
                    });
                },
                getK: function(t) {
                    return Math.pow(t.box.width * t.box.height / t.nodes.length, .5);
                },
                integrate: function(t, e) {
                    let i = -t.options.friction, n = t.options.maxSpeed, r = e.prevX, o = e.prevY, s = (e.plotX + e.dispX - r) * i, a = (e.plotY + e.dispY - o) * i, l = Math.abs, h = l(s) / (s || 1), c = l(a) / (a || 1), d = h * Math.min(n, Math.abs(s)), u = c * Math.min(n, Math.abs(a));
                    e.prevX = e.plotX + e.dispX, e.prevY = e.plotY + e.dispY, e.plotX += d, e.plotY += u, e.temperature = t.vectorLength({
                        x: d,
                        y: u
                    });
                },
                repulsive: function(t, e, i) {
                    let n = e * this.diffTemperature / t.mass / t.degree;
                    t.fixedPosition || (t.plotX += i.x * n, t.plotY += i.y * n);
                },
                repulsiveForceFunction: function(t, e) {
                    return (e - t) / t * (e > t ? 1 : 0);
                }
            };
        }), i(e, "Series/PackedBubble/PackedBubbleIntegration.js", [
            e["Core/Globals.js"],
            e["Series/Networkgraph/VerletIntegration.js"]
        ], function(t, e) {
            let { noop: i } = t;
            return {
                barycenter: function() {
                    let t, e, i = this.options.gravitationalConstant, n = this.box, r = this.nodes;
                    for (let o of r)this.options.splitSeries && !o.isParentNode ? (t = o.series.parentNode.plotX, e = o.series.parentNode.plotY) : (t = n.width / 2, e = n.height / 2), o.fixedPosition || (o.plotX -= (o.plotX - t) * i / (o.mass * Math.sqrt(r.length)), o.plotY -= (o.plotY - e) * i / (o.mass * Math.sqrt(r.length)));
                },
                getK: i,
                integrate: e.integrate,
                repulsive: function(t, e, i, n) {
                    let r = e * this.diffTemperature / t.mass / t.degree, o = i.x * r, s = i.y * r;
                    t.fixedPosition || (t.plotX += o, t.plotY += s), n.fixedPosition || (n.plotX -= o, n.plotY -= s);
                },
                repulsiveForceFunction: function(t, e, i, n) {
                    return Math.min(t, (i.marker.radius + n.marker.radius) / 2);
                }
            };
        }), i(e, "Series/Networkgraph/EulerIntegration.js", [], function() {
            return {
                attractive: function(t, e, i, n) {
                    let r = t.getMass(), o = i.x / n * e, s = i.y / n * e;
                    t.fromNode.fixedPosition || (t.fromNode.dispX -= o * r.fromNode / t.fromNode.degree, t.fromNode.dispY -= s * r.fromNode / t.fromNode.degree), t.toNode.fixedPosition || (t.toNode.dispX += o * r.toNode / t.toNode.degree, t.toNode.dispY += s * r.toNode / t.toNode.degree);
                },
                attractiveForceFunction: function(t, e) {
                    return t * t / e;
                },
                barycenter: function() {
                    let t = this.options.gravitationalConstant, e = this.barycenter.xFactor, i = this.barycenter.yFactor;
                    this.nodes.forEach(function(n) {
                        if (!n.fixedPosition) {
                            let r = n.getDegree(), o = r * (1 + r / 2);
                            n.dispX += (e - n.plotX) * t * o / n.degree, n.dispY += (i - n.plotY) * t * o / n.degree;
                        }
                    });
                },
                getK: function(t) {
                    return Math.pow(t.box.width * t.box.height / t.nodes.length, .3);
                },
                integrate: function(t, e) {
                    e.dispX += e.dispX * t.options.friction, e.dispY += e.dispY * t.options.friction;
                    let i = e.temperature = t.vectorLength({
                        x: e.dispX,
                        y: e.dispY
                    });
                    0 !== i && (e.plotX += e.dispX / i * Math.min(Math.abs(e.dispX), t.temperature), e.plotY += e.dispY / i * Math.min(Math.abs(e.dispY), t.temperature));
                },
                repulsive: function(t, e, i, n) {
                    t.dispX += i.x / n * e / t.degree, t.dispY += i.y / n * e / t.degree;
                },
                repulsiveForceFunction: function(t, e) {
                    return e * e / t;
                }
            };
        }), i(e, "Series/Networkgraph/QuadTreeNode.js", [], function() {
            class t {
                constructor(t){
                    this.body = !1, this.isEmpty = !1, this.isInternal = !1, this.nodes = [], this.box = t, this.boxSize = Math.min(t.width, t.height);
                }
                divideBox() {
                    let e = this.box.width / 2, i = this.box.height / 2;
                    this.nodes[0] = new t({
                        left: this.box.left,
                        top: this.box.top,
                        width: e,
                        height: i
                    }), this.nodes[1] = new t({
                        left: this.box.left + e,
                        top: this.box.top,
                        width: e,
                        height: i
                    }), this.nodes[2] = new t({
                        left: this.box.left + e,
                        top: this.box.top + i,
                        width: e,
                        height: i
                    }), this.nodes[3] = new t({
                        left: this.box.left,
                        top: this.box.top + i,
                        width: e,
                        height: i
                    });
                }
                getBoxPosition(t) {
                    let e = t.plotX < this.box.left + this.box.width / 2, i = t.plotY < this.box.top + this.box.height / 2;
                    return e ? i ? 0 : 3 : i ? 1 : 2;
                }
                insert(e, i) {
                    let n;
                    this.isInternal ? this.nodes[this.getBoxPosition(e)].insert(e, i - 1) : (this.isEmpty = !1, this.body ? i ? (this.isInternal = !0, this.divideBox(), !0 !== this.body && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, i - 1), this.body = !0), this.nodes[this.getBoxPosition(e)].insert(e, i - 1)) : ((n = new t({
                        top: e.plotX || NaN,
                        left: e.plotY || NaN,
                        width: .1,
                        height: .1
                    })).body = e, n.isInternal = !1, this.nodes.push(n)) : (this.isInternal = !1, this.body = e));
                }
                updateMassAndCenter() {
                    let t = 0, e = 0, i = 0;
                    if (this.isInternal) {
                        for (let n of this.nodes)n.isEmpty || (t += n.mass, e += n.plotX * n.mass, i += n.plotY * n.mass);
                        e /= t, i /= t;
                    } else this.body && (t = this.body.mass, e = this.body.plotX, i = this.body.plotY);
                    this.mass = t, this.plotX = e, this.plotY = i;
                }
            }
            return t;
        }), i(e, "Series/Networkgraph/QuadTree.js", [
            e["Series/Networkgraph/QuadTreeNode.js"]
        ], function(t) {
            return class {
                constructor(e, i, n, r){
                    this.box = {
                        left: e,
                        top: i,
                        width: n,
                        height: r
                    }, this.maxDepth = 25, this.root = new t(this.box), this.root.isInternal = !0, this.root.isRoot = !0, this.root.divideBox();
                }
                calculateMassAndCenter() {
                    this.visitNodeRecursive(null, null, function(t) {
                        t.updateMassAndCenter();
                    });
                }
                insertNodes(t) {
                    for (let e of t)this.root.insert(e, this.maxDepth);
                }
                visitNodeRecursive(t, e, i) {
                    let n;
                    if (t || (t = this.root), t === this.root && e && (n = e(t)), !1 !== n) {
                        for (let r of t.nodes){
                            if (r.isInternal) {
                                if (e && (n = e(r)), !1 === n) continue;
                                this.visitNodeRecursive(r, e, i);
                            } else r.body && e && e(r.body);
                            i && i(r);
                        }
                        t === this.root && i && i(t);
                    }
                }
            };
        }), i(e, "Series/Networkgraph/ReingoldFruchtermanLayout.js", [
            e["Series/Networkgraph/EulerIntegration.js"],
            e["Core/Globals.js"],
            e["Series/GraphLayoutComposition.js"],
            e["Series/Networkgraph/QuadTree.js"],
            e["Core/Utilities.js"],
            e["Series/Networkgraph/VerletIntegration.js"]
        ], function(t, e, i, n, r, o) {
            let { win: s } = e, { clamp: a, defined: l, isFunction: h, fireEvent: c, pick: d } = r;
            class u {
                constructor(){
                    this.box = {}, this.currentStep = 0, this.initialRendering = !0, this.links = [], this.nodes = [], this.series = [], this.simulation = !1;
                }
                static compose(e) {
                    i.compose(e), i.integrations.euler = t, i.integrations.verlet = o, i.layouts["reingold-fruchterman"] = u;
                }
                init(t) {
                    this.options = t, this.nodes = [], this.links = [], this.series = [], this.box = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    }, this.setInitialRendering(!0), this.integration = i.integrations[t.integration], this.enableSimulation = t.enableSimulation, this.attractiveForce = d(t.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = d(t.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = t.approximation;
                }
                updateSimulation(t) {
                    this.enableSimulation = d(t, this.options.enableSimulation);
                }
                start() {
                    let t = this.series, e = this.options;
                    this.currentStep = 0, this.forces = t[0] && t[0].forces || [], this.chart = t[0] && t[0].chart, this.initialRendering && (this.initPositions(), t.forEach(function(t) {
                        t.finishedAnimating = !0, t.render();
                    })), this.setK(), this.resetSimulation(e), this.enableSimulation && this.step();
                }
                step() {
                    let t = this.series;
                    for (let t of (this.currentStep++, "barnes-hut" === this.approximation && (this.createQuadTree(), this.quadTree.calculateMassAndCenter()), this.forces || []))this[t + "Forces"](this.temperature);
                    if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
                        for (let e of t)e.chart && e.render();
                        this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && s.cancelAnimationFrame(this.simulation), this.simulation = s.requestAnimationFrame(()=>this.step())) : (this.simulation = !1, this.series.forEach((t)=>{
                            c(t, "afterSimulation");
                        }));
                    }
                }
                stop() {
                    this.simulation && s.cancelAnimationFrame(this.simulation);
                }
                setArea(t, e, i, n) {
                    this.box = {
                        left: t,
                        top: e,
                        width: i,
                        height: n
                    };
                }
                setK() {
                    this.k = this.options.linkLength || this.integration.getK(this);
                }
                addElementsToCollection(t, e) {
                    for (let i of t)-1 === e.indexOf(i) && e.push(i);
                }
                removeElementFromCollection(t, e) {
                    let i = e.indexOf(t);
                    -1 !== i && e.splice(i, 1);
                }
                clear() {
                    this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
                }
                resetSimulation() {
                    this.forcedStop = !1, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
                }
                restartSimulation() {
                    this.simulation ? this.resetSimulation() : (this.setInitialRendering(!1), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(!0));
                }
                setMaxIterations(t) {
                    this.maxIterations = d(t, this.options.maxIterations);
                }
                setTemperature() {
                    this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
                }
                setDiffTemperature() {
                    this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
                }
                setInitialRendering(t) {
                    this.initialRendering = t;
                }
                createQuadTree() {
                    this.quadTree = new n(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
                }
                initPositions() {
                    let t = this.options.initialPositions;
                    if (h(t)) for (let e of (t.call(this), this.nodes))l(e.prevX) || (e.prevX = e.plotX), l(e.prevY) || (e.prevY = e.plotY), e.dispX = 0, e.dispY = 0;
                    else "circle" === t ? this.setCircularPositions() : this.setRandomPositions();
                }
                setCircularPositions() {
                    let t, e = this.box, i = this.nodes, n = 2 * Math.PI / (i.length + 1), r = i.filter(function(t) {
                        return 0 === t.linksTo.length;
                    }), o = {}, s = this.options.initialPositionRadius, a = (t)=>{
                        for (let e of t.linksFrom || [])o[e.toNode.id] || (o[e.toNode.id] = !0, l.push(e.toNode), a(e.toNode));
                    }, l = [];
                    for (let t of r)l.push(t), a(t);
                    if (l.length) for (let t of i)-1 === l.indexOf(t) && l.push(t);
                    else l = i;
                    for(let i = 0, r = l.length; i < r; ++i)(t = l[i]).plotX = t.prevX = d(t.plotX, e.width / 2 + s * Math.cos(i * n)), t.plotY = t.prevY = d(t.plotY, e.height / 2 + s * Math.sin(i * n)), t.dispX = 0, t.dispY = 0;
                }
                setRandomPositions() {
                    let t, e = this.box, i = this.nodes, n = i.length + 1, r = (t)=>{
                        let e = t * t / Math.PI;
                        return e - Math.floor(e);
                    };
                    for(let o = 0, s = i.length; o < s; ++o)(t = i[o]).plotX = t.prevX = d(t.plotX, e.width * r(o)), t.plotY = t.prevY = d(t.plotY, e.height * r(n + o)), t.dispX = 0, t.dispY = 0;
                }
                force(t, ...e) {
                    this.integration[t].apply(this, e);
                }
                barycenterForces() {
                    this.getBarycenter(), this.force("barycenter");
                }
                getBarycenter() {
                    let t = 0, e = 0, i = 0;
                    for (let n of this.nodes)e += n.plotX * n.mass, i += n.plotY * n.mass, t += n.mass;
                    return this.barycenter = {
                        x: e,
                        y: i,
                        xFactor: e / t,
                        yFactor: i / t
                    }, this.barycenter;
                }
                barnesHutApproximation(t, e) {
                    let i, n, r = this.getDistXY(t, e), o = this.vectorLength(r);
                    return t !== e && 0 !== o && (e.isInternal ? e.boxSize / o < this.options.theta && 0 !== o ? (n = this.repulsiveForce(o, this.k), this.force("repulsive", t, n * e.mass, r, o), i = !1) : i = !0 : (n = this.repulsiveForce(o, this.k), this.force("repulsive", t, n * e.mass, r, o))), i;
                }
                repulsiveForces() {
                    if ("barnes-hut" === this.approximation) for (let t of this.nodes)this.quadTree.visitNodeRecursive(null, (e)=>this.barnesHutApproximation(t, e));
                    else {
                        let t, e, i;
                        for (let n of this.nodes)for (let r of this.nodes)n === r || n.fixedPosition || (i = this.getDistXY(n, r), 0 !== (e = this.vectorLength(i)) && (t = this.repulsiveForce(e, this.k), this.force("repulsive", n, t * r.mass, i, e)));
                    }
                }
                attractiveForces() {
                    let t, e, i;
                    for (let n of this.links)n.fromNode && n.toNode && (t = this.getDistXY(n.fromNode, n.toNode), 0 !== (e = this.vectorLength(t)) && (i = this.attractiveForce(e, this.k), this.force("attractive", n, i, t, e)));
                }
                applyLimits() {
                    for (let t of this.nodes)t.fixedPosition || (this.integration.integrate(this, t), this.applyLimitBox(t, this.box), t.dispX = 0, t.dispY = 0);
                }
                applyLimitBox(t, e) {
                    let i = t.radius;
                    t.plotX = a(t.plotX, e.left + i, e.width - i), t.plotY = a(t.plotY, e.top + i, e.height - i);
                }
                coolDown(t, e, i) {
                    return t - e * i;
                }
                isStable() {
                    return 1e-5 > Math.abs(this.systemTemperature - this.prevSystemTemperature) || this.temperature <= 0;
                }
                getSystemTemperature() {
                    let t = 0;
                    for (let e of this.nodes)t += e.temperature;
                    return t;
                }
                vectorLength(t) {
                    return Math.sqrt(t.x * t.x + t.y * t.y);
                }
                getDistR(t, e) {
                    let i = this.getDistXY(t, e);
                    return this.vectorLength(i);
                }
                getDistXY(t, e) {
                    let i = t.plotX - e.plotX, n = t.plotY - e.plotY;
                    return {
                        x: i,
                        y: n,
                        absX: Math.abs(i),
                        absY: Math.abs(n)
                    };
                }
            }
            return u;
        }), i(e, "Series/PackedBubble/PackedBubbleLayout.js", [
            e["Series/GraphLayoutComposition.js"],
            e["Series/PackedBubble/PackedBubbleIntegration.js"],
            e["Series/Networkgraph/ReingoldFruchtermanLayout.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { addEvent: r, pick: o } = n;
            function s() {
                let t = this.series, e = [];
                return t.forEach((t)=>{
                    t.parentNode && t.parentNode.selected && e.push(t.parentNode);
                }), e;
            }
            function a() {
                this.allDataPoints && delete this.allDataPoints;
            }
            class l extends i {
                constructor(){
                    super(...arguments), this.index = NaN, this.nodes = [], this.series = [];
                }
                static compose(n) {
                    i.compose(n), t.integrations.packedbubble = e, t.layouts.packedbubble = l;
                    let o = n.prototype;
                    o.getSelectedParentNodes || (r(n, "beforeRedraw", a), o.getSelectedParentNodes = s);
                }
                beforeStep() {
                    this.options.marker && this.series.forEach((t)=>{
                        t && t.calculateParentRadius();
                    });
                }
                isStable() {
                    let t = Math.abs(this.prevSystemTemperature - this.systemTemperature);
                    return 1 > Math.abs(10 * this.systemTemperature / Math.sqrt(this.nodes.length)) && t < 1e-5 || this.temperature <= 0;
                }
                setCircularPositions() {
                    let t, e, i = this.box, n = this.nodes, r = 2 * Math.PI / (n.length + 1), s = this.options.initialPositionRadius, a = 0;
                    for (let l of n)this.options.splitSeries && !l.isParentNode ? (t = l.series.parentNode.plotX, e = l.series.parentNode.plotY) : (t = i.width / 2, e = i.height / 2), l.plotX = l.prevX = o(l.plotX, t + s * Math.cos(l.index || a * r)), l.plotY = l.prevY = o(l.plotY, e + s * Math.sin(l.index || a * r)), l.dispX = 0, l.dispY = 0, a++;
                }
                repulsiveForces() {
                    let t, e, i, n = this, r = n.options.bubblePadding, o = n.nodes;
                    o.forEach((s)=>{
                        s.degree = s.mass, s.neighbours = 0, o.forEach((o)=>{
                            t = 0, s !== o && !s.fixedPosition && (n.options.seriesInteraction || s.series === o.series) && (i = n.getDistXY(s, o), (e = n.vectorLength(i) - (s.marker.radius + o.marker.radius + r)) < 0 && (s.degree += .01, s.neighbours++, t = n.repulsiveForce(-e / Math.sqrt(s.neighbours), n.k, s, o)), n.force("repulsive", s, t * o.mass, i, o, e));
                        });
                    });
                }
                applyLimitBox(t, e) {
                    let i, n;
                    this.options.splitSeries && !t.isParentNode && this.options.parentNodeLimit && (i = this.getDistXY(t, t.series.parentNode), (n = t.series.parentNodeRadius - t.marker.radius - this.vectorLength(i)) < 0 && n > -2 * t.marker.radius && (t.plotX -= .01 * i.x, t.plotY -= .01 * i.y)), super.applyLimitBox(t, e);
                }
            }
            return t.layouts.packedbubble = l, l;
        }), i(e, "Series/SimulationSeriesUtilities.js", [
            e["Core/Utilities.js"],
            e["Core/Animation/AnimationUtilities.js"]
        ], function(t, e) {
            let { merge: i, syncTimeout: n } = t, { animObject: r } = e;
            return {
                initDataLabels: function() {
                    let t = this.options.dataLabels;
                    if (!this.dataLabelsGroup) {
                        let e = this.initDataLabelsGroup();
                        return !this.chart.styledMode && t?.style && e.css(t.style), e.attr({
                            opacity: 0
                        }), this.visible && e.show(), e;
                    }
                    return this.dataLabelsGroup.attr(i({
                        opacity: 1
                    }, this.getPlotBox("data-labels"))), this.dataLabelsGroup;
                },
                initDataLabelsDefer: function() {
                    let t = this.options.dataLabels;
                    t?.defer && this.options.layoutAlgorithm?.enableSimulation ? n(()=>{
                        this.deferDataLabels = !1;
                    }, t ? r(t.animation).defer : 0) : this.deferDataLabels = !1;
                }
            };
        }), i(e, "Extensions/TextPath.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { deg2rad: i } = t, { addEvent: n, merge: r, uniqueKey: o, defined: s, extend: a } = e;
            function l(t, e) {
                e = r(!0, {
                    enabled: !0,
                    attributes: {
                        dy: -5,
                        startOffset: "50%",
                        textAnchor: "middle"
                    }
                }, e);
                let i = this.renderer.url, l = this.text || this, h = l.textPath, { attributes: c, enabled: d } = e;
                if (t = t || h && h.path, h && h.undo(), t && d) {
                    let e = n(l, "afterModifyTree", (e)=>{
                        if (t && d) {
                            let n = t.attr("id");
                            n || t.attr("id", n = o());
                            let r = {
                                x: 0,
                                y: 0
                            };
                            s(c.dx) && (r.dx = c.dx, delete c.dx), s(c.dy) && (r.dy = c.dy, delete c.dy), l.attr(r), this.attr({
                                transform: ""
                            }), this.box && (this.box = this.box.destroy());
                            let h = e.nodes.slice(0);
                            e.nodes.length = 0, e.nodes[0] = {
                                tagName: "textPath",
                                attributes: a(c, {
                                    "text-anchor": c.textAnchor,
                                    href: `${i}#${n}`
                                }),
                                children: h
                            };
                        }
                    });
                    l.textPath = {
                        path: t,
                        undo: e
                    };
                } else l.attr({
                    dx: 0,
                    dy: 0
                }), delete l.textPath;
                return this.added && (l.textCache = "", this.renderer.buildText(l)), this;
            }
            function h(t) {
                let e = t.bBox, n = this.element?.querySelector("textPath");
                if (n) {
                    let r = [], { b: o, h: s } = this.renderer.fontMetrics(this.element), a = s - o, l = RegExp('(<tspan>|<tspan(?!\\sclass="highcharts-br")[^>]*>|<\\/tspan>)', "g"), h = n.innerHTML.replace(l, "").split(/<tspan class="highcharts-br"[^>]*>/), c = h.length, d = (t, e)=>{
                        let { x: r, y: s } = e, l = (n.getRotationOfChar(t) - 90) * i, h = Math.cos(l), c = Math.sin(l);
                        return [
                            [
                                r - a * h,
                                s - a * c
                            ],
                            [
                                r + o * h,
                                s + o * c
                            ]
                        ];
                    };
                    for(let e = 0, i = 0; i < c; i++){
                        let o = h[i].length;
                        for(let s = 0; s < o; s += 5)try {
                            let t = e + s + i, [o, a] = d(t, n.getStartPositionOfChar(t));
                            0 === s ? (r.push(a), r.push(o)) : (0 === i && r.unshift(a), i === c - 1 && r.push(o));
                        } catch (t) {
                            break;
                        }
                        e += o - 1;
                        try {
                            let t = e + i, o = n.getEndPositionOfChar(t), [s, a] = d(t, o);
                            r.unshift(a), r.unshift(s);
                        } catch (t) {
                            break;
                        }
                    }
                    r.length && r.push(r[0].slice()), e.polygon = r;
                }
                return e;
            }
            function c(t) {
                let e = t.labelOptions, i = t.point, n = e[i.formatPrefix + "TextPath"] || e.textPath;
                n && !e.useHTML && (this.setTextPath(i.getDataLabelPath?.(this) || i.graphic, n), i.dataLabelPath && !n.enabled && (i.dataLabelPath = i.dataLabelPath.destroy()));
            }
            return {
                compose: function(t) {
                    n(t, "afterGetBBox", h), n(t, "beforeAddingDataLabel", c);
                    let e = t.prototype;
                    e.setTextPath || (e.setTextPath = l);
                }
            };
        }), i(e, "Series/PackedBubble/PackedBubbleSeries.js", [
            e["Core/Color/Color.js"],
            e["Series/DragNodesComposition.js"],
            e["Series/GraphLayoutComposition.js"],
            e["Core/Globals.js"],
            e["Series/PackedBubble/PackedBubblePoint.js"],
            e["Series/PackedBubble/PackedBubbleSeriesDefaults.js"],
            e["Series/PackedBubble/PackedBubbleLayout.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Series/SimulationSeriesUtilities.js"],
            e["Core/Utilities.js"],
            e["Core/Renderer/SVG/SVGElement.js"],
            e["Extensions/TextPath.js"]
        ], function(t, e, i, n, r, o, s, a, l, h, c, d) {
            let { parse: u } = t, { noop: p } = n, { series: { prototype: f }, seriesTypes: { bubble: g } } = a, { initDataLabels: m, initDataLabelsDefer: b } = l, { addEvent: y, clamp: x, defined: v, extend: w, fireEvent: C, isArray: S, isNumber: k, merge: A, pick: E } = h;
            d.compose(c);
            class M extends g {
                constructor(){
                    super(...arguments), this.parentNodeMass = 0, this.deferDataLabels = !0;
                }
                static compose(t, i, n) {
                    g.compose(t, i, n), e.compose(i), s.compose(i);
                }
                accumulateAllPoints() {
                    let t, e = this.chart, i = [];
                    for (let n of e.series)if (n.is("packedbubble") && n.reserveSpace()) {
                        t = n.yData || [];
                        for(let e = 0; e < t.length; e++)i.push([
                            null,
                            null,
                            t[e],
                            n.index,
                            e,
                            {
                                id: e,
                                marker: {
                                    radius: 0
                                }
                            }
                        ]);
                    }
                    return i;
                }
                addLayout() {
                    let t, e = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, n = e.type || "packedbubble", r = this.chart.options.chart, o = this.chart.graphLayoutsStorage, s = this.chart.graphLayoutsLookup;
                    o || (this.chart.graphLayoutsStorage = o = {}, this.chart.graphLayoutsLookup = s = []), (t = o[n]) || (e.enableSimulation = v(r.forExport) ? !r.forExport : e.enableSimulation, o[n] = t = new i.layouts[n], t.init(e), s.splice(t.index, 0, t)), this.layout = t, this.points.forEach((t)=>{
                        t.mass = 2, t.degree = 1, t.collisionNmb = 1;
                    }), t.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), t.addElementsToCollection([
                        this
                    ], t.series), t.addElementsToCollection(this.points, t.nodes);
                }
                addSeriesLayout() {
                    let t = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {}, e = t.type || "packedbubble", n = this.chart.graphLayoutsStorage, r = this.chart.graphLayoutsLookup, o = A(t, t.parentNodeOptions, {
                        enableSimulation: this.layout.options.enableSimulation
                    }), s = n[e + "-series"];
                    s || (n[e + "-series"] = s = new i.layouts[e], s.init(o), r.splice(s.index, 0, s)), this.parentNodeLayout = s, this.createParentNodes();
                }
                calculateParentRadius() {
                    let t = this.seriesBox();
                    this.parentNodeRadius = x(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, t ? Math.max(Math.sqrt(Math.pow(t.width, 2) + Math.pow(t.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
                }
                calculateZExtremes() {
                    let t = this.chart.series, e = this.options.zMin, i = this.options.zMax, n = 1 / 0, r = -1 / 0;
                    return e && i ? [
                        e,
                        i
                    ] : (t.forEach((t)=>{
                        t.yData.forEach((t)=>{
                            v(t) && (t > r && (r = t), t < n && (n = t));
                        });
                    }), [
                        e = E(e, n),
                        i = E(i, r)
                    ]);
                }
                checkOverlap(t, e) {
                    let i = t[0] - e[0], n = t[1] - e[1];
                    return Math.sqrt(i * i + n * n) - Math.abs(t[2] + e[2]) < -0.001;
                }
                createParentNodes() {
                    let t, e = this.pointClass, i = this.chart, n = this.parentNodeLayout, r = this.layout.options, o = this.parentNode, s = {
                        radius: this.parentNodeRadius,
                        lineColor: this.color,
                        fillColor: u(this.color).brighten(.4).get()
                    };
                    r.parentNodeOptions && (s = A(r.parentNodeOptions.marker || {}, s)), this.parentNodeMass = 0, this.points.forEach((t)=>{
                        this.parentNodeMass += Math.PI * Math.pow(t.marker.radius, 2);
                    }), this.calculateParentRadius(), n.nodes.forEach((e)=>{
                        e.seriesIndex === this.index && (t = !0);
                    }), n.setArea(0, 0, i.plotWidth, i.plotHeight), t || (o || (o = new e(this, {
                        mass: this.parentNodeRadius / 2,
                        marker: s,
                        dataLabels: {
                            inside: !1
                        },
                        states: {
                            normal: {
                                marker: s
                            },
                            hover: {
                                marker: s
                            }
                        },
                        dataLabelOnNull: !0,
                        degree: this.parentNodeRadius,
                        isParentNode: !0,
                        seriesIndex: this.index
                    })), this.parentNode && (o.plotX = this.parentNode.plotX, o.plotY = this.parentNode.plotY), this.parentNode = o, n.addElementsToCollection([
                        this
                    ], n.series), n.addElementsToCollection([
                        o
                    ], n.nodes));
                }
                deferLayout() {
                    let t = this.options.layoutAlgorithm;
                    this.visible && (this.addLayout(), t.splitSeries && this.addSeriesLayout());
                }
                destroy() {
                    this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach((t)=>{
                        t.removeElementFromCollection(this, t.series);
                    }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), f.destroy.apply(this, arguments);
                }
                drawDataLabels() {
                    !this.deferDataLabels && (f.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", f.drawDataLabels.call(this, [
                        this.parentNode
                    ])));
                }
                drawGraph() {
                    if (!this.layout || !this.layout.options.splitSeries) return;
                    let t = this.chart, e = this.layout.options.parentNodeOptions.marker, i = {
                        fill: e.fillColor || u(this.color).brighten(.4).get(),
                        opacity: e.fillOpacity,
                        stroke: e.lineColor || this.color,
                        "stroke-width": E(e.lineWidth, this.options.lineWidth)
                    }, n = {};
                    this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", .1, t.seriesGroup), this.group?.attr({
                        zIndex: 2
                    }), this.calculateParentRadius(), this.parentNode && v(this.parentNode.plotX) && v(this.parentNode.plotY) && v(this.parentNodeRadius) && (n = A({
                        x: this.parentNode.plotX - this.parentNodeRadius,
                        y: this.parentNode.plotY - this.parentNodeRadius,
                        width: 2 * this.parentNodeRadius,
                        height: 2 * this.parentNodeRadius
                    }, i), this.parentNode.graphic || (this.graph = this.parentNode.graphic = t.renderer.symbol(i.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(n));
                }
                drawTracker() {
                    let t, e = this.parentNode;
                    super.drawTracker(), e && (t = S(e.dataLabels) ? e.dataLabels : e.dataLabel ? [
                        e.dataLabel
                    ] : [], e.graphic && (e.graphic.element.point = e), t.forEach((t)=>{
                        (t.div || t.element).point = e;
                    }));
                }
                getPointRadius() {
                    let t, e, i, n, r = this.chart, o = r.plotWidth, s = r.plotHeight, a = this.options, l = a.useSimulation, h = Math.min(o, s), c = {}, d = [], u = r.allDataPoints || [], p = u.length;
                    [
                        "minSize",
                        "maxSize"
                    ].forEach((t)=>{
                        let e = parseInt(a[t], 10), i = /%$/.test(a[t]);
                        c[t] = i ? h * e / 100 : e * Math.sqrt(p);
                    }), r.minRadius = t = c.minSize / Math.sqrt(p), r.maxRadius = e = c.maxSize / Math.sqrt(p);
                    let f = l ? this.calculateZExtremes() : [
                        t,
                        e
                    ];
                    u.forEach((r, o)=>{
                        i = l ? x(r[2], f[0], f[1]) : r[2], 0 === (n = this.getRadius(f[0], f[1], t, e, i)) && (n = null), u[o][2] = n, d.push(n);
                    }), this.radii = d;
                }
                init() {
                    return f.init.apply(this, arguments), b.call(this), this.eventsToUnbind.push(y(this, "updatedData", function() {
                        this.chart.series.forEach((t)=>{
                            t.type === this.type && (t.isDirty = !0);
                        }, this);
                    })), this;
                }
                onMouseUp(t) {
                    if (t.fixedPosition && !t.removed) {
                        let i, n = this.layout, r = this.parentNodeLayout;
                        r && n.options.dragBetweenSeries && r.nodes.forEach((e)=>{
                            t && t.marker && e !== t.series.parentNode && (i = n.getDistXY(t, e), n.vectorLength(i) - e.marker.radius - t.marker.radius < 0 && (e.series.addPoint(A(t.options, {
                                plotX: t.plotX,
                                plotY: t.plotY
                            }), !1), n.removeElementFromCollection(t, n.nodes), t.remove()));
                        }), e.onMouseUp.apply(this, arguments);
                    }
                }
                placeBubbles(t) {
                    let e, i, n = this.checkOverlap, r = this.positionBubble, o = [], s = 1, a = 0, l = 0, h = [], c = t.sort((t, e)=>e[2] - t[2]);
                    if (c.length) {
                        if (o.push([
                            [
                                0,
                                0,
                                c[0][2],
                                c[0][3],
                                c[0][4]
                            ]
                        ]), c.length > 1) for(o.push([
                            [
                                0,
                                0 - c[1][2] - c[0][2],
                                c[1][2],
                                c[1][3],
                                c[1][4]
                            ]
                        ]), i = 2; i < c.length; i++)c[i][2] = c[i][2] || 1, n(e = r(o[s][a], o[s - 1][l], c[i]), o[s][0]) ? (o.push([]), l = 0, o[s + 1].push(r(o[s][a], o[s][0], c[i])), s++, a = 0) : s > 1 && o[s - 1][l + 1] && n(e, o[s - 1][l + 1]) ? (l++, o[s].push(r(o[s][a], o[s - 1][l], c[i])), a++) : (a++, o[s].push(e));
                        this.chart.stages = o, this.chart.rawPositions = [].concat.apply([], o), this.resizeRadius(), h = this.chart.rawPositions;
                    }
                    return h;
                }
                pointAttribs(t, e) {
                    let i = this.options, n = t && t.isParentNode, r = i.marker;
                    n && i.layoutAlgorithm && i.layoutAlgorithm.parentNodeOptions && (r = i.layoutAlgorithm.parentNodeOptions.marker);
                    let o = r.fillOpacity, s = f.pointAttribs.call(this, t, e);
                    return 1 !== o && (s["fill-opacity"] = o), s;
                }
                positionBubble(t, e, i) {
                    let n = Math.asin, r = Math.acos, o = Math.pow, s = Math.abs, a = (0, Math.sqrt)(o(t[0] - e[0], 2) + o(t[1] - e[1], 2)), l = r((o(a, 2) + o(i[2] + e[2], 2) - o(i[2] + t[2], 2)) / (2 * (i[2] + e[2]) * a)), h = n(s(t[0] - e[0]) / a), c = (t[1] - e[1] < 0 ? 0 : Math.PI) + l + h * ((t[0] - e[0]) * (t[1] - e[1]) < 0 ? 1 : -1), d = Math.cos(c), u = Math.sin(c);
                    return [
                        e[0] + (e[2] + i[2]) * u,
                        e[1] - (e[2] + i[2]) * d,
                        i[2],
                        i[3],
                        i[4]
                    ];
                }
                render() {
                    let t = [];
                    f.render.apply(this, arguments), !this.options.dataLabels.allowOverlap && (this.data.forEach((e)=>{
                        S(e.dataLabels) && e.dataLabels.forEach((e)=>{
                            t.push(e);
                        });
                    }), this.options.useSimulation && this.chart.hideOverlappingLabels(t));
                }
                resizeRadius() {
                    let t, e, i, n, r, o = this.chart, s = o.rawPositions, a = Math.min, l = Math.max, h = o.plotLeft, c = o.plotTop, d = o.plotHeight, u = o.plotWidth;
                    for (let o of (t = i = Number.POSITIVE_INFINITY, e = n = Number.NEGATIVE_INFINITY, s))r = o[2], t = a(t, o[0] - r), e = l(e, o[0] + r), i = a(i, o[1] - r), n = l(n, o[1] + r);
                    let p = [
                        e - t,
                        n - i
                    ], f = [
                        (u - h) / p[0],
                        (d - c) / p[1]
                    ], g = a.apply([], f);
                    if (Math.abs(g - 1) > 1e-10) {
                        for (let t of s)t[2] *= g;
                        this.placeBubbles(s);
                    } else o.diffY = d / 2 + c - i - (n - i) / 2, o.diffX = u / 2 + h - t - (e - t) / 2;
                }
                seriesBox() {
                    let t, e = this.chart, i = this.data, n = Math.max, r = Math.min, o = [
                        e.plotLeft,
                        e.plotLeft + e.plotWidth,
                        e.plotTop,
                        e.plotTop + e.plotHeight
                    ];
                    return i.forEach((e)=>{
                        v(e.plotX) && v(e.plotY) && e.marker.radius && (t = e.marker.radius, o[0] = r(o[0], e.plotX - t), o[1] = n(o[1], e.plotX + t), o[2] = r(o[2], e.plotY - t), o[3] = n(o[3], e.plotY + t));
                    }), k(o.width / o.height) ? o : null;
                }
                setVisible() {
                    let t = this;
                    f.setVisible.apply(t, arguments), t.parentNodeLayout && t.graph ? t.visible ? (t.graph.show(), t.parentNode.dataLabel && t.parentNode.dataLabel.show()) : (t.graph.hide(), t.parentNodeLayout.removeElementFromCollection(t.parentNode, t.parentNodeLayout.nodes), t.parentNode.dataLabel && t.parentNode.dataLabel.hide()) : t.layout && (t.visible ? t.layout.addElementsToCollection(t.points, t.layout.nodes) : t.points.forEach((e)=>{
                        t.layout.removeElementFromCollection(e, t.layout.nodes);
                    }));
                }
                translate() {
                    let t, e, i, n = this.chart, r = this.data, o = this.index, s = this.options.useSimulation;
                    for (let a of (this.processedXData = this.xData, this.generatePoints(), v(n.allDataPoints) || (n.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), s ? i = n.allDataPoints : (i = this.placeBubbles(n.allDataPoints), this.options.draggable = !1), i))a[3] === o && (t = r[a[4]], e = E(a[2], void 0), s || (t.plotX = a[0] - n.plotLeft + n.diffX, t.plotY = a[1] - n.plotTop + n.diffY), k(e) && (t.marker = w(t.marker, {
                        radius: e,
                        width: 2 * e,
                        height: 2 * e
                    }), t.radius = e));
                    s && this.deferLayout(), C(this, "afterTranslate");
                }
            }
            return M.defaultOptions = A(g.defaultOptions, o), w(M.prototype, {
                pointClass: r,
                axisTypes: [],
                directTouch: !0,
                forces: [
                    "barycenter",
                    "repulsive"
                ],
                hasDraggableNodes: !0,
                invertible: !1,
                isCartesian: !1,
                noSharedTooltip: !0,
                pointArrayMap: [
                    "value"
                ],
                pointValKey: "value",
                requireSorting: !1,
                trackerGroups: [
                    "group",
                    "dataLabelsGroup",
                    "parentNodesGroup"
                ],
                initDataLabels: m,
                alignDataLabel: f.alignDataLabel,
                indexateNodes: p,
                onMouseDown: e.onMouseDown,
                onMouseMove: e.onMouseMove,
                redrawHalo: e.redrawHalo,
                searchPoint: p
            }), a.registerSeriesType("packedbubble", M), M;
        }), i(e, "Series/Polygon/PolygonSeriesDefaults.js", [], function() {
            return {
                marker: {
                    enabled: !1,
                    states: {
                        hover: {
                            enabled: !1
                        }
                    }
                },
                stickyTracking: !1,
                tooltip: {
                    followPointer: !0,
                    pointFormat: ""
                },
                trackByArea: !0,
                legendSymbol: "rectangle"
            };
        }), i(e, "Series/Polygon/PolygonSeries.js", [
            e["Core/Globals.js"],
            e["Series/Polygon/PolygonSeriesDefaults.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { noop: r } = t, { area: o, line: s, scatter: a } = i.seriesTypes, { extend: l, merge: h } = n;
            class c extends a {
                getGraphPath() {
                    let t = s.prototype.getGraphPath.call(this), e = t.length + 1;
                    for(; e--;)(e === t.length || "M" === t[e][0]) && e > 0 && t.splice(e, 0, [
                        "Z"
                    ]);
                    return this.areaPath = t, t;
                }
                drawGraph() {
                    this.options.fillColor = this.color, o.prototype.drawGraph.call(this);
                }
            }
            return c.defaultOptions = h(a.defaultOptions, e), l(c.prototype, {
                type: "polygon",
                drawTracker: s.prototype.drawTracker,
                setStackedPoints: r
            }), i.registerSeriesType("polygon", c), c;
        }), i(e, "Core/Axis/RadialAxisDefaults.js", [], function() {
            return {
                circular: {
                    gridLineWidth: 1,
                    labels: {
                        align: void 0,
                        x: 0,
                        y: void 0,
                        style: {
                            textOverflow: "none"
                        }
                    },
                    maxPadding: 0,
                    minPadding: 0,
                    showLastLabel: !1,
                    tickLength: 0
                },
                radial: {
                    gridLineInterpolation: "circle",
                    gridLineWidth: 1,
                    labels: {
                        align: "right",
                        padding: 5,
                        x: -3,
                        y: -2
                    },
                    showLastLabel: !1,
                    title: {
                        x: 4,
                        text: null,
                        rotation: 90
                    }
                },
                radialGauge: {
                    endOnTick: !1,
                    gridLineWidth: 0,
                    labels: {
                        align: "center",
                        distance: -25,
                        x: 0,
                        y: void 0
                    },
                    lineWidth: 1,
                    minorGridLineWidth: 0,
                    minorTickInterval: "auto",
                    minorTickLength: 10,
                    minorTickPosition: "inside",
                    minorTickWidth: 1,
                    startOnTick: !1,
                    tickLength: 10,
                    tickPixelInterval: 100,
                    tickPosition: "inside",
                    tickWidth: 2,
                    title: {
                        rotation: 0,
                        text: ""
                    },
                    zIndex: 2
                }
            };
        }), i(e, "Core/Axis/RadialAxis.js", [
            e["Core/Axis/RadialAxisDefaults.js"],
            e["Core/Defaults.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            var r;
            let { defaultOptions: o } = e, { composed: s, noop: a } = i, { addEvent: l, correctFloat: h, defined: c, extend: d, fireEvent: u, isObject: p, merge: f, pick: g, pushUnique: m, relativeLength: b, wrap: y } = n;
            return function(e) {
                function n() {
                    this.autoConnect = this.isCircular && void 0 === g(this.userMax, this.options.max) && h(this.endAngleRad - this.startAngleRad) === h(2 * Math.PI), !this.isCircular && this.chart.inverted && this.max++, this.autoConnect && (this.max += (this.categories ? 1 : this.pointRange) || this.closestPointRange || 0);
                }
                function r() {
                    return ()=>{
                        if (this.isRadial && this.tickPositions && this.options.labels && !0 !== this.options.labels.allowOverlap) return this.tickPositions.map((t)=>this.ticks[t] && this.ticks[t].label).filter((t)=>!!t);
                    };
                }
                function x() {
                    return a;
                }
                function v(t, e, i) {
                    let n, r, o, s = this.pane.center, a = t.value;
                    return this.isCircular ? (c(a) ? t.point && (t.point.shapeArgs || {}).start && (a = this.chart.inverted ? this.translate(t.point.rectPlotY, !0) : t.point.x) : (r = t.chartX || 0, o = t.chartY || 0, a = this.translate(Math.atan2(o - i, r - e) - this.startAngleRad, !0)), r = (n = this.getPosition(a)).x, o = n.y) : (c(a) || (r = t.chartX, o = t.chartY), c(r) && c(o) && (i = s[1] + this.chart.plotTop, a = this.translate(Math.min(Math.sqrt(Math.pow(r - e, 2) + Math.pow(o - i, 2)), s[2] / 2) - s[3] / 2, !0))), [
                        a,
                        r || 0,
                        o || 0
                    ];
                }
                function w(t, e, i) {
                    let n, r, o = this.pane.center, s = this.chart, a = this.left || 0, l = this.top || 0, h = g(e, o[2] / 2 - this.offset);
                    return void 0 === i && (i = this.horiz ? 0 : this.center && -this.center[3] / 2), i && (h += i), this.isCircular || void 0 !== e ? ((r = this.chart.renderer.symbols.arc(a + o[0], l + o[1], h, h, {
                        start: this.startAngleRad,
                        end: this.endAngleRad,
                        open: !0,
                        innerR: 0
                    })).xBounds = [
                        a + o[0]
                    ], r.yBounds = [
                        l + o[1] - h
                    ]) : (n = this.postTranslate(this.angleRad, h), r = [
                        [
                            "M",
                            this.center[0] + s.plotLeft,
                            this.center[1] + s.plotTop
                        ],
                        [
                            "L",
                            n.x,
                            n.y
                        ]
                    ]), r;
                }
                function C() {
                    this.constructor.prototype.getOffset.call(this), this.chart.axisOffset[this.side] = 0;
                }
                function S(t, e, i) {
                    let n, r, o, s, a, l, h = this.chart, c = (t)=>{
                        if ("string" == typeof t) {
                            let e = parseInt(t, 10);
                            return y.test(t) && (e = e * p / 100), e;
                        }
                        return t;
                    }, d = this.center, u = this.startAngleRad, p = d[2] / 2, f = Math.min(this.offset, 0), m = this.left || 0, b = this.top || 0, y = /%$/, x = this.isCircular, v = g(c(i.outerRadius), p), w = c(i.innerRadius), C = g(c(i.thickness), 10);
                    if ("polygon" === this.options.gridLineInterpolation) l = this.getPlotLinePath({
                        value: t
                    }).concat(this.getPlotLinePath({
                        value: e,
                        reverse: !0
                    }));
                    else {
                        t = Math.max(t, this.min), e = Math.min(e, this.max);
                        let c = this.translate(t), p = this.translate(e);
                        x || (v = c || 0, w = p || 0), "circle" !== i.shape && x ? (n = u + (c || 0), r = u + (p || 0)) : (n = -Math.PI / 2, r = 1.5 * Math.PI, a = !0), v -= f, C -= f, l = h.renderer.symbols.arc(m + d[0], b + d[1], v, v, {
                            start: Math.min(n, r),
                            end: Math.max(n, r),
                            innerR: g(w, v - C),
                            open: a,
                            borderRadius: i.borderRadius
                        }), x && (o = (r + n) / 2, s = m + d[0] + d[2] / 2 * Math.cos(o), l.xBounds = o > -Math.PI / 2 && o < Math.PI / 2 ? [
                            s,
                            h.plotWidth
                        ] : [
                            0,
                            s
                        ], l.yBounds = [
                            b + d[1] + d[2] / 2 * Math.sin(o)
                        ], l.yBounds[0] += o > -Math.PI && o < 0 || o > Math.PI ? -10 : 10);
                    }
                    return l;
                }
                function k(t) {
                    let e, i, n, r, o, s, a, l, h, c = this.pane.center, d = this.chart, u = d.inverted, p = t.reverse, f = this.pane.options.background ? this.pane.options.background[0] || this.pane.options.background : {}, g = f.innerRadius || "0%", m = f.outerRadius || "100%", y = c[0] + d.plotLeft, x = c[1] + d.plotTop, v = this.height, w = t.isCrosshair, C = c[3] / 2, S = t.value, k = this.getPosition(S), A = k.x, E = k.y;
                    if (w && (S = (l = this.getCrosshairPosition(t, y, x))[0], A = l[1], E = l[2]), this.isCircular) i = Math.sqrt(Math.pow(A - y, 2) + Math.pow(E - x, 2)), n = "string" == typeof g ? b(g, 1) : g / i, r = "string" == typeof m ? b(m, 1) : m / i, c && C && (n < (e = C / i) && (n = e), r < e && (r = e)), h = [
                        [
                            "M",
                            y + n * (A - y),
                            x - n * (x - E)
                        ],
                        [
                            "L",
                            A - (1 - r) * (A - y),
                            E + (1 - r) * (x - E)
                        ]
                    ];
                    else if ((S = this.translate(S)) && (S < 0 || S > v) && (S = 0), "circle" === this.options.gridLineInterpolation) h = this.getLinePath(0, S, C);
                    else if (h = [], d[u ? "yAxis" : "xAxis"].forEach((t)=>{
                        t.pane === this.pane && (o = t);
                    }), o) {
                        a = o.tickPositions, o.autoConnect && (a = a.concat([
                            a[0]
                        ])), p && (a = a.slice().reverse()), S && (S += C);
                        for(let t = 0; t < a.length; t++)s = o.getPosition(a[t], S), h.push(t ? [
                            "L",
                            s.x,
                            s.y
                        ] : [
                            "M",
                            s.x,
                            s.y
                        ]);
                    }
                    return h;
                }
                function A(t, e) {
                    let i = this.translate(t);
                    return this.postTranslate(this.isCircular ? i : this.angleRad, g(this.isCircular ? e : i < 0 ? 0 : i, this.center[2] / 2) - this.offset);
                }
                function E() {
                    let t = this.center, e = this.chart, i = this.options.title;
                    return {
                        x: e.plotLeft + t[0] + (i.x || 0),
                        y: e.plotTop + t[1] - ({
                            high: .5,
                            middle: .25,
                            low: 0
                        })[i.align] * t[2] + (i.y || 0)
                    };
                }
                function M(t) {
                    t.beforeSetTickPositions = n, t.createLabelCollector = r, t.getCrosshairPosition = v, t.getLinePath = w, t.getOffset = C, t.getPlotBandPath = S, t.getPlotLinePath = k, t.getPosition = A, t.getTitlePosition = E, t.postTranslate = I, t.setAxisSize = F, t.setAxisTranslation = z, t.setOptions = H;
                }
                function T() {
                    let t = this.chart, e = this.options, i = t.angular && this.isXAxis, n = this.pane, r = n && n.options;
                    if (!i && n && (t.angular || t.polar)) {
                        let t = 2 * Math.PI, i = (g(r.startAngle, 0) - 90) * Math.PI / 180, n = (g(r.endAngle, g(r.startAngle, 0) + 360) - 90) * Math.PI / 180;
                        this.angleRad = (e.angle || 0) * Math.PI / 180, this.startAngleRad = i, this.endAngleRad = n, this.offset = e.offset || 0;
                        let o = (i % t + t) % t, s = (n % t + t) % t;
                        o > Math.PI && (o -= t), s > Math.PI && (s -= t), this.normalizedStartAngleRad = o, this.normalizedEndAngleRad = s;
                    }
                }
                function P(t) {
                    this.isRadial && (t.align = void 0, t.preventDefault());
                }
                function R() {
                    if (this.chart && this.chart.labelCollectors) {
                        let t = this.labelCollector ? this.chart.labelCollectors.indexOf(this.labelCollector) : -1;
                        t >= 0 && this.chart.labelCollectors.splice(t, 1);
                    }
                }
                function L(t) {
                    let e, i = this.chart, n = i.angular, r = i.polar, o = this.isXAxis, s = this.coll, l = t.userOptions.pane || 0, h = this.pane = i.pane && i.pane[l];
                    "colorAxis" !== s ? (n ? (n && o ? (this.isHidden = !0, this.createLabelCollector = x, this.getOffset = a, this.redraw = B, this.render = B, this.setScale = a, this.setCategories = a, this.setTitle = a) : M(this), e = !o) : r && (M(this), e = this.horiz), n || r ? (this.isRadial = !0, this.labelCollector || (this.labelCollector = this.createLabelCollector()), this.labelCollector && i.labelCollectors.push(this.labelCollector)) : this.isRadial = !1, h && e && (h.axis = this), this.isCircular = e) : this.isRadial = !1;
                }
                function O() {
                    this.isRadial && this.beforeSetTickPositions();
                }
                function D(t) {
                    let e = this.label;
                    if (!e) return;
                    let i, n = this.axis, r = e.getBBox(), o = n.options.labels, s = (n.translate(this.pos) + n.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360, a = Math.round(s), l = c(o.y) ? 0 : -0.3 * r.height, h = o.y, d = 20, u = o.align, p = "end", f = a < 0 ? a + 360 : a, m = f, y = 0, x = 0;
                    n.isRadial && (i = n.getPosition(this.pos, n.center[2] / 2 + b(g(o.distance, -25), n.center[2] / 2, -n.center[2] / 2)), "auto" === o.rotation ? e.attr({
                        rotation: s
                    }) : c(h) || (h = n.chart.renderer.fontMetrics(e).b - r.height / 2), c(u) || (n.isCircular ? (r.width > n.len * n.tickInterval / (n.max - n.min) && (d = 0), u = s > d && s < 180 - d ? "left" : s > 180 + d && s < 360 - d ? "right" : "center") : u = "center", e.attr({
                        align: u
                    })), "auto" === u && 2 === n.tickPositions.length && n.isCircular && (f > 90 && f < 180 ? f = 180 - f : f > 270 && f <= 360 && (f = 540 - f), m > 180 && m <= 360 && (m = 360 - m), (n.pane.options.startAngle === a || n.pane.options.startAngle === a + 360 || n.pane.options.startAngle === a - 360) && (p = "start"), u = a >= -90 && a <= 90 || a >= -360 && a <= -270 || a >= 270 && a <= 360 ? "start" === p ? "right" : "left" : "start" === p ? "left" : "right", m > 70 && m < 110 && (u = "center"), f < 15 || f >= 180 && f < 195 ? y = .3 * r.height : f >= 15 && f <= 35 ? y = "start" === p ? 0 : .75 * r.height : f >= 195 && f <= 215 ? y = "start" === p ? .75 * r.height : 0 : f > 35 && f <= 90 ? y = "start" === p ? -0.25 * r.height : r.height : f > 215 && f <= 270 && (y = "start" === p ? r.height : -0.25 * r.height), m < 15 ? x = "start" === p ? -0.15 * r.height : .15 * r.height : m > 165 && m <= 180 && (x = "start" === p ? .15 * r.height : -0.15 * r.height), e.attr({
                        align: u
                    }), e.translate(x, y + l)), t.pos.x = i.x + (o.x || 0), t.pos.y = i.y + (h || 0));
                }
                function j(t) {
                    this.axis.getPosition && d(t.pos, this.axis.getPosition(this.pos));
                }
                function N({ options: t }) {
                    t.xAxis && f(!0, e.radialDefaultOptions.circular, t.xAxis), t.yAxis && f(!0, e.radialDefaultOptions.radialGauge, t.yAxis);
                }
                function I(t, e) {
                    let i = this.chart, n = this.center;
                    return t = this.startAngleRad + t, {
                        x: i.plotLeft + n[0] + Math.cos(t) * e,
                        y: i.plotTop + n[1] + Math.sin(t) * e
                    };
                }
                function B() {
                    this.isDirty = !1;
                }
                function F() {
                    let t, e;
                    this.constructor.prototype.setAxisSize.call(this), this.isRadial && (this.pane.updateCenter(this), t = this.center = this.pane.center.slice(), this.isCircular ? this.sector = this.endAngleRad - this.startAngleRad : (e = this.postTranslate(this.angleRad, t[3] / 2), t[0] = e.x - this.chart.plotLeft, t[1] = e.y - this.chart.plotTop), this.len = this.width = this.height = (t[2] - t[3]) * g(this.sector, 1) / 2);
                }
                function z() {
                    this.constructor.prototype.setAxisTranslation.call(this), this.center && (this.isCircular ? this.transA = (this.endAngleRad - this.startAngleRad) / (this.max - this.min || 1) : this.transA = (this.center[2] - this.center[3]) / 2 / (this.max - this.min || 1), this.isXAxis ? this.minPixelPadding = this.transA * this.minPointOffset : this.minPixelPadding = 0);
                }
                function H(t) {
                    let { coll: i } = this, { angular: n, inverted: r, polar: s } = this.chart, a = {};
                    n ? this.isXAxis || (a = f(o.yAxis, e.radialDefaultOptions.radialGauge)) : s && (a = this.horiz ? f(o.xAxis, e.radialDefaultOptions.circular) : f("xAxis" === i ? o.xAxis : o.yAxis, e.radialDefaultOptions.radial)), r && "yAxis" === i && (a.stackLabels = p(o.yAxis, !0) ? o.yAxis.stackLabels : {}, a.reversedStacks = !0);
                    let l = this.options = f(a, t);
                    l.plotBands || (l.plotBands = []), u(this, "afterSetOptions");
                }
                function U(t, e, i, n, r, o, s) {
                    let a, l = this.axis;
                    return l.isRadial ? [
                        "M",
                        e,
                        i,
                        "L",
                        (a = l.getPosition(this.pos, l.center[2] / 2 + n)).x,
                        a.y
                    ] : t.call(this, e, i, n, r, o, s);
                }
                e.radialDefaultOptions = f(t), e.compose = function(t, e) {
                    return m(s, "Axis.Radial") && (l(t, "afterInit", T), l(t, "autoLabelAlign", P), l(t, "destroy", R), l(t, "init", L), l(t, "initialAxisTranslation", O), l(e, "afterGetLabelPosition", D), l(e, "afterGetPosition", j), l(i, "setOptions", N), y(e.prototype, "getMarkPath", U)), t;
                };
            }(r || (r = {})), r;
        }), i(e, "Series/PolarComposition.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Globals.js"],
            e["Core/Series/Series.js"],
            e["Extensions/Pane/Pane.js"],
            e["Core/Axis/RadialAxis.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o) {
            let { animObject: s } = t, { composed: a } = e, { addEvent: l, defined: h, find: c, isNumber: d, merge: u, pick: p, pushUnique: f, relativeLength: g, splat: m, uniqueKey: b, wrap: y } = o;
            function x() {
                (this.pane || []).forEach((t)=>{
                    t.render();
                });
            }
            function v(t) {
                let e = t.args[0].xAxis, i = t.args[0].yAxis, n = t.args[0].chart;
                e && i && ("polygon" === i.gridLineInterpolation ? (e.startOnTick = !0, e.endOnTick = !0) : "polygon" === e.gridLineInterpolation && n.inverted && (i.startOnTick = !0, i.endOnTick = !0));
            }
            function w() {
                this.pane || (this.pane = []), this.options.pane = m(this.options.pane), this.options.pane.forEach((t)=>{
                    new n(t, this);
                }, this);
            }
            function C(t) {
                let e = t.args.marker, i = this.chart.xAxis[0], n = this.chart.yAxis[0], r = this.chart.inverted, o = r ? n : i, s = r ? i : n;
                if (this.chart.polar) {
                    t.preventDefault();
                    let i = (e.attr ? e.attr("start") : e.start) - o.startAngleRad, n = e.attr ? e.attr("r") : e.r, r = (e.attr ? e.attr("end") : e.end) - o.startAngleRad, a = e.attr ? e.attr("innerR") : e.innerR;
                    t.result.x = i + o.pos, t.result.width = r - i, t.result.y = s.len + s.pos - n, t.result.height = n - a;
                }
            }
            function S(t) {
                let e = this.chart;
                if (e.polar && e.hoverPane && e.hoverPane.axis) {
                    t.preventDefault();
                    let i = e.hoverPane.center, n = e.mouseDownX || 0, r = e.mouseDownY || 0, o = t.args.chartY, s = t.args.chartX, a = 2 * Math.PI, l = e.hoverPane.axis.startAngleRad, h = e.hoverPane.axis.endAngleRad, c = e.inverted ? e.xAxis[0] : e.yAxis[0], d = {}, u = "arc";
                    if (d.x = i[0] + e.plotLeft, d.y = i[1] + e.plotTop, this.zoomHor) {
                        let t = l > 0 ? h - l : Math.abs(l) + Math.abs(h), p = Math.atan2(r - e.plotTop - i[1], n - e.plotLeft - i[0]) - l, f = Math.atan2(o - e.plotTop - i[1], s - e.plotLeft - i[0]) - l;
                        d.r = i[2] / 2, d.innerR = i[3] / 2, p <= 0 && (p += a), f <= 0 && (f += a), f < p && (f = [
                            p,
                            p = f
                        ][0]), t < a && l + f > h + (a - t) / 2 && (f = p, p = l <= 0 ? l : 0);
                        let g = d.start = Math.max(p + l, l), m = d.end = Math.min(f + l, h);
                        if ("polygon" === c.options.gridLineInterpolation) {
                            let t = e.hoverPane.axis, n = g - t.startAngleRad + t.pos, r = c.getPlotLinePath({
                                value: c.max
                            }), o = t.toValue(n), s = t.toValue(n + (m - g));
                            if (o < t.getExtremes().min) {
                                let { min: e, max: i } = t.getExtremes();
                                o = i - (e - o);
                            }
                            if (s < t.getExtremes().min) {
                                let { min: e, max: i } = t.getExtremes();
                                s = i - (e - s);
                            }
                            s < o && (s = [
                                o,
                                o = s
                            ][0]), (r = M(r, o, s, t)).push([
                                "L",
                                i[0] + e.plotLeft,
                                e.plotTop + i[1]
                            ]), d.d = r, u = "path";
                        }
                    }
                    if (this.zoomVert) {
                        let t = e.inverted ? e.xAxis[0] : e.yAxis[0], a = Math.sqrt(Math.pow(n - e.plotLeft - i[0], 2) + Math.pow(r - e.plotTop - i[1], 2)), c = Math.sqrt(Math.pow(s - e.plotLeft - i[0], 2) + Math.pow(o - e.plotTop - i[1], 2));
                        if (c < a && (a = [
                            c,
                            c = a
                        ][0]), c > i[2] / 2 && (c = i[2] / 2), a < i[3] / 2 && (a = i[3] / 2), this.zoomHor || (d.start = l, d.end = h), d.r = c, d.innerR = a, "polygon" === t.options.gridLineInterpolation) {
                            let e = t.toValue(t.len + t.pos - a), i = t.toValue(t.len + t.pos - c), n = t.getPlotLinePath({
                                value: i
                            }).concat(t.getPlotLinePath({
                                value: e,
                                reverse: !0
                            }));
                            d.d = n, u = "path";
                        }
                    }
                    if (this.zoomHor && this.zoomVert && "polygon" === c.options.gridLineInterpolation) {
                        let t = e.hoverPane.axis, i = d.start || 0, n = d.end || 0, r = i - t.startAngleRad + t.pos, o = t.toValue(r), s = t.toValue(r + (n - i));
                        if (d.d instanceof Array) {
                            let t = d.d.slice(0, d.d.length / 2), i = d.d.slice(d.d.length / 2, d.d.length);
                            i = [
                                ...i
                            ].reverse();
                            let n = e.hoverPane.axis;
                            t = M(t, o, s, n), (i = M(i, o, s, n)) && (i[0][0] = "L"), i = [
                                ...i
                            ].reverse(), d.d = t.concat(i), u = "path";
                        }
                    }
                    t.attrs = d, t.shapeType = u;
                }
            }
            function k() {
                let t = this.chart;
                t.polar && (this.polar = new B(this), t.inverted && (this.isRadialSeries = !0, this.is("column") && (this.isRadialBar = !0)));
            }
            function A() {
                if (this.chart.polar && this.xAxis) {
                    let { xAxis: t, yAxis: i } = this, n = this.chart;
                    this.kdByAngle = n.tooltip && n.tooltip.shared, this.kdByAngle || n.inverted ? this.searchPoint = E : this.options.findNearestPointBy = "xy";
                    let r = this.points, o = r.length;
                    for(; o--;)this.is("column") || this.is("columnrange") || this.polar.toXY(r[o]), n.hasParallelCoordinates || this.yAxis.reversed || (p(r[o].y, Number.MIN_VALUE) < i.min || r[o].x < t.min || r[o].x > t.max ? (r[o].isNull = !0, r[o].plotY = NaN) : r[o].isNull = r[o].isValid && !r[o].isValid());
                    this.hasClipCircleSetter || (this.hasClipCircleSetter = !!this.eventsToUnbind.push(l(this, "afterRender", function() {
                        let t;
                        n.polar && !1 !== this.options.clip && (t = this.yAxis.pane.center, this.clipCircle ? this.clipCircle.animate({
                            x: t[0],
                            y: t[1],
                            r: t[2] / 2,
                            innerR: t[3] / 2
                        }) : this.clipCircle = function(t, e, i, n, r) {
                            let o = b(), s = t.createElement("clipPath").attr({
                                id: o
                            }).add(t.defs), a = r ? t.arc(e, i, n, r, 0, 2 * Math.PI).add(s) : t.circle(e, i, n).add(s);
                            return a.id = o, a.clipPath = s, a;
                        }(n.renderer, t[0], t[1], t[2] / 2, t[3] / 2), this.group.clip(this.clipCircle), this.setClip = e.noop);
                    })));
                }
            }
            function E(t) {
                let e = this.chart, i = this.xAxis, n = this.yAxis, r = i.pane && i.pane.center, o = t.chartX - (r && r[0] || 0) - e.plotLeft, s = t.chartY - (r && r[1] || 0) - e.plotTop, a = e.inverted ? {
                    clientX: t.chartX - n.pos,
                    plotY: t.chartY - i.pos
                } : {
                    clientX: 180 + -180 / Math.PI * Math.atan2(o, s)
                };
                return this.searchKDTree(a);
            }
            function M(t, e, i, n) {
                let r = n.tickInterval, o = n.tickPositions, s = c(o, (t)=>t >= i), a = c([
                    ...o
                ].reverse(), (t)=>t <= e);
                return h(s) || (s = o[o.length - 1]), h(a) || (a = o[0], s += r, t[0][0] = "L", t.unshift(t[t.length - 3])), (t = t.slice(o.indexOf(a), o.indexOf(s) + 1))[0][0] = "M", t;
            }
            function T(t, e) {
                return c(this.pane || [], (t)=>t.options.id === e) || t.call(this, e);
            }
            function P(t, e, n, r, o, s) {
                let a, l, h, c = this.chart, d = p(r.inside, !!this.options.stacking);
                if (c.polar) {
                    if (a = e.rectPlotX / Math.PI * 180, c.inverted) this.forceDL = c.isInsidePlot(e.plotX, e.plotY), d && e.shapeArgs ? (l = e.shapeArgs, o = u(o, {
                        x: (h = this.yAxis.postTranslate(((l.start || 0) + (l.end || 0)) / 2 - this.xAxis.startAngleRad, e.barX + e.pointWidth / 2)).x - c.plotLeft,
                        y: h.y - c.plotTop
                    })) : e.tooltipPos && (o = u(o, {
                        x: e.tooltipPos[0],
                        y: e.tooltipPos[1]
                    })), r.align = p(r.align, "center"), r.verticalAlign = p(r.verticalAlign, "middle");
                    else {
                        var f;
                        let t, e;
                        null === (f = r).align && (t = a > 20 && a < 160 ? "left" : a > 200 && a < 340 ? "right" : "center", f.align = t), null === f.verticalAlign && (e = a < 45 || a > 315 ? "bottom" : a > 135 && a < 225 ? "top" : "middle", f.verticalAlign = e), r = f;
                    }
                    i.prototype.alignDataLabel.call(this, e, n, r, o, s), this.isRadialBar && e.shapeArgs && e.shapeArgs.start === e.shapeArgs.end ? n.hide() : n.show();
                } else t.call(this, e, n, r, o, s);
            }
            function R() {
                let t, e, i, n, r, s, a, l, c, u, p, f, m, b = this.options, y = b.stacking, x = this.chart, v = this.xAxis, w = this.yAxis, C = w.reversed, S = w.center, k = v.startAngleRad, A = v.endAngleRad - k, E = b.threshold, M = 0, T = 0, P = 0;
                if (v.isRadial) for(i = (t = this.points).length, n = w.translate(w.min), r = w.translate(w.max), E = b.threshold || 0, x.inverted && d(E) && h(M = w.translate(E)) && (M < 0 ? M = 0 : M > A && (M = A), this.translatedThreshold = M + k); i--;){
                    if (p = (e = t[i]).barX, a = e.x, l = e.y, e.shapeType = "arc", x.inverted) {
                        e.plotY = w.translate(l), y && w.stacking ? (u = w.stacking.stacks[(l < 0 ? "-" : "") + this.stackKey], this.visible && u && u[a] && !e.isNull && (c = u[a].points[this.getStackIndicator(void 0, a, this.index).key], T = w.translate(c[0]), P = w.translate(c[1]), h(T) && (T = o.clamp(T, 0, A)))) : (T = M, P = e.plotY), T > P && (P = [
                            T,
                            T = P
                        ][0]), C ? P > n ? P = n : T < r ? T = r : (T > n || P < r) && (T = P = A) : T < n ? T = n : P > r ? P = r : (P < n || T > r) && (T = P = 0), w.min > w.max && (T = P = C ? A : 0), T += k, P += k, S && (e.barX = p += S[3] / 2), f = Math.max(p, 0), m = Math.max(p + e.pointWidth, 0);
                        let t = b.borderRadius, i = g(("object" == typeof t ? t.radius : t) || 0, m - f);
                        e.shapeArgs = {
                            x: S[0],
                            y: S[1],
                            r: m,
                            innerR: f,
                            start: T,
                            end: P,
                            borderRadius: i
                        }, e.opacity = T === P ? 0 : void 0, e.plotY = (h(this.translatedThreshold) && (T < this.translatedThreshold ? T : P)) - k;
                    } else T = p + k, e.shapeArgs = this.polar.arc(e.yBottom, e.plotY, T, T + e.pointWidth), e.shapeArgs.borderRadius = 0;
                    this.polar.toXY(e), x.inverted ? (s = w.postTranslate(e.rectPlotY, p + e.pointWidth / 2), e.tooltipPos = [
                        s.x - x.plotLeft,
                        s.y - x.plotTop
                    ]) : e.tooltipPos = [
                        e.plotX,
                        e.plotY
                    ], S && (e.ttBelow = e.plotY > S[1]);
                }
            }
            function L(t, e) {
                let i, n, r = this;
                if (this.chart.polar) {
                    e = e || this.points;
                    for(let t = 0; t < e.length; t++)if (!e[t].isNull) {
                        i = t;
                        break;
                    }
                    !1 !== this.options.connectEnds && void 0 !== i && (this.connectEnds = !0, e.splice(e.length, 0, e[i]), n = !0), e.forEach((t)=>{
                        void 0 === t.polarPlotY && r.polar.toXY(t);
                    });
                }
                let o = t.apply(this, [].slice.call(arguments, 1));
                return n && e.pop(), o;
            }
            function O(t, e) {
                let i = this.chart, n = {
                    xAxis: [],
                    yAxis: []
                };
                return i.polar ? i.axes.forEach((t)=>{
                    if ("colorAxis" === t.coll) return;
                    let r = t.isXAxis, o = t.center, s = e.chartX - o[0] - i.plotLeft, a = e.chartY - o[1] - i.plotTop;
                    n[r ? "xAxis" : "yAxis"].push({
                        axis: t,
                        value: t.translate(r ? Math.PI - Math.atan2(s, a) : Math.sqrt(Math.pow(s, 2) + Math.pow(a, 2)), !0)
                    });
                }) : n = t.call(this, e), n;
            }
            function D(t, e) {
                this.chart.polar || t.call(this, e);
            }
            function j(t, i) {
                let n, r, o, a, l, h, c = this, d = this.chart, u = this.group, f = this.markerGroup, g = this.xAxis && this.xAxis.center, m = d.plotLeft, b = d.plotTop, y = this.options.animation;
                d.polar ? c.isRadialBar ? i || (c.startAngleRad = p(c.translatedThreshold, c.xAxis.startAngleRad), e.seriesTypes.pie.prototype.animate.call(c, i)) : (y = s(y), c.is("column") ? i || (r = g[3] / 2, c.points.forEach((t)=>{
                    o = t.graphic, l = (a = t.shapeArgs) && a.r, h = a && a.innerR, o && a && (o.attr({
                        r: r,
                        innerR: r
                    }), o.animate({
                        r: l,
                        innerR: h
                    }, c.options.animation));
                })) : i ? (n = {
                    translateX: g[0] + m,
                    translateY: g[1] + b,
                    scaleX: .001,
                    scaleY: .001
                }, u.attr(n), f && f.attr(n)) : (n = {
                    translateX: m,
                    translateY: b,
                    scaleX: 1,
                    scaleY: 1
                }, u.animate(n, y), f && f.animate(n, y))) : t.call(this, i);
            }
            function N(t, e, i, n) {
                let r, o;
                if (this.chart.polar) {
                    if (n) {
                        let t = (o = function t(e, i, n, r) {
                            let o, s, a, l, h, c, d = r ? 1 : 0, u = (o = i >= 0 && i <= e.length - 1 ? i : i < 0 ? e.length - 1 + i : 0) - 1 < 0 ? e.length - (1 + d) : o - 1, p = o + 1 > e.length - 1 ? d : o + 1, f = e[u], g = e[p], m = f.plotX, b = f.plotY, y = g.plotX, x = g.plotY, v = e[o].plotX, w = e[o].plotY;
                            s = (1.5 * v + m) / 2.5, a = (1.5 * w + b) / 2.5, l = (1.5 * v + y) / 2.5, h = (1.5 * w + x) / 2.5;
                            let C = Math.sqrt(Math.pow(s - v, 2) + Math.pow(a - w, 2)), S = Math.sqrt(Math.pow(l - v, 2) + Math.pow(h - w, 2)), k = Math.atan2(a - w, s - v);
                            c = Math.PI / 2 + (k + Math.atan2(h - w, l - v)) / 2, Math.abs(k - c) > Math.PI / 2 && (c -= Math.PI), s = v + Math.cos(c) * C, a = w + Math.sin(c) * C;
                            let A = {
                                rightContX: l = v + Math.cos(Math.PI + c) * S,
                                rightContY: h = w + Math.sin(Math.PI + c) * S,
                                leftContX: s,
                                leftContY: a,
                                plotX: v,
                                plotY: w
                            };
                            return n && (A.prevPointCont = t(e, u, !1, r)), A;
                        }(e, n, !0, this.connectEnds)).prevPointCont && o.prevPointCont.rightContX, i = o.prevPointCont && o.prevPointCont.rightContY;
                        r = [
                            "C",
                            d(t) ? t : o.plotX,
                            d(i) ? i : o.plotY,
                            d(o.leftContX) ? o.leftContX : o.plotX,
                            d(o.leftContY) ? o.leftContY : o.plotY,
                            o.plotX,
                            o.plotY
                        ];
                    } else r = [
                        "M",
                        i.plotX,
                        i.plotY
                    ];
                } else r = t.call(this, e, i, n);
                return r;
            }
            function I(t, e, i = this.plotY) {
                if (!this.destroyed) {
                    let { plotX: n, series: r } = this, { chart: o } = r;
                    return o.polar && d(n) && d(i) ? [
                        n + (e ? o.plotLeft : 0),
                        i + (e ? o.plotTop : 0)
                    ] : t.call(this, e, i);
                }
            }
            class B {
                static compose(t, e, i, o, s, h, c, d, u, p) {
                    if (n.compose(e, i), r.compose(t, s), f(a, "Polar")) {
                        let t = e.prototype, n = h.prototype, r = i.prototype, s = o.prototype;
                        if (l(e, "afterDrawChartBox", x), l(e, "getAxes", w), l(e, "init", v), y(t, "get", T), y(r, "getCoordinates", O), y(r, "pinch", D), l(i, "getSelectionMarkerAttrs", S), l(i, "getSelectionBox", C), l(o, "afterInit", k), l(o, "afterTranslate", A, {
                            order: 2
                        }), l(o, "afterColumnTranslate", R, {
                            order: 4
                        }), y(s, "animate", j), y(n, "pos", I), d) {
                            let t = d.prototype;
                            y(t, "alignDataLabel", P), y(t, "animate", j);
                        }
                        if (u && y(u.prototype, "getGraphPath", L), p) {
                            let t = p.prototype;
                            y(t, "getPointSpline", N), c && (c.prototype.getPointSpline = t.getPointSpline);
                        }
                    }
                }
                constructor(t){
                    this.series = t;
                }
                arc(t, e, i, n) {
                    let r = this.series, o = r.xAxis.center, s = r.yAxis.len, a = o[3] / 2, l = s - e + a, h = s - p(t, s) + a;
                    return r.yAxis.reversed && (l < 0 && (l = a), h < 0 && (h = a)), {
                        x: o[0],
                        y: o[1],
                        r: l,
                        innerR: h,
                        start: i,
                        end: n
                    };
                }
                toXY(t) {
                    let e, i = this.series, n = i.chart, r = i.xAxis, o = i.yAxis, s = t.plotX, a = n.inverted, l = t.y, h = t.plotY, c = a ? s : o.len - h;
                    if (a && i && !i.isRadialBar && (t.plotY = h = d(l) ? o.translate(l) : 0), t.rectPlotX = s, t.rectPlotY = h, o.center && (c += o.center[3] / 2), d(h)) {
                        let e = a ? o.postTranslate(h, c) : r.postTranslate(s, c);
                        t.plotX = t.polarPlotX = e.x - n.plotLeft, t.plotY = t.polarPlotY = e.y - n.plotTop;
                    }
                    i.kdByAngle ? ((e = (s / Math.PI * 180 + r.pane.options.startAngle) % 360) < 0 && (e += 360), t.clientX = e) : t.clientX = t.plotX;
                }
            }
            return B;
        }), i(e, "Core/Axis/WaterfallAxis.js", [
            e["Core/Globals.js"],
            e["Core/Axis/Stacking/StackItem.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            var n;
            let { composed: r } = t, { addEvent: o, objectEach: s, pushUnique: a } = i;
            return function(t) {
                function i() {
                    let t = this.waterfall.stacks;
                    t && (t.changed = !1, delete t.alreadyChanged);
                }
                function n() {
                    let t = this.options.stackLabels;
                    t && t.enabled && this.waterfall.stacks && this.waterfall.renderStackTotals();
                }
                function l() {
                    this.waterfall || (this.waterfall = new c(this));
                }
                function h() {
                    let t = this.axes;
                    for (let e of this.series)if (e.options.stacking) {
                        for (let e of t)e.isXAxis || (e.waterfall.stacks.changed = !0);
                        break;
                    }
                }
                t.compose = function(t, e) {
                    a(r, "Axis.Waterfall") && (o(t, "init", l), o(t, "afterBuildStacks", i), o(t, "afterRender", n), o(e, "beforeRedraw", h));
                };
                class c {
                    constructor(t){
                        this.axis = t, this.stacks = {
                            changed: !1
                        };
                    }
                    renderStackTotals() {
                        let t = this.axis, i = t.waterfall.stacks, n = t.stacking && t.stacking.stackTotalGroup, r = new e(t, t.options.stackLabels || {}, !1, 0, void 0);
                        this.dummyStackItem = r, n && s(i, (t)=>{
                            s(t, (t, i)=>{
                                r.total = t.stackTotal, r.x = +i, t.label && (r.label = t.label), e.prototype.render.call(r, n), t.label = r.label, delete r.label;
                            });
                        }), r.total = null;
                    }
                }
                t.Composition = c;
            }(n || (n = {})), n;
        }), i(e, "Series/Waterfall/WaterfallPoint.js", [
            e["Series/Column/ColumnSeries.js"],
            e["Core/Series/Point.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { isNumber: n } = i;
            class r extends t.prototype.pointClass {
                getClassName() {
                    let t = e.prototype.getClassName.call(this);
                    return this.isSum ? t += " highcharts-sum" : this.isIntermediateSum && (t += " highcharts-intermediate-sum"), t;
                }
                isValid() {
                    return n(this.y) || this.isSum || !!this.isIntermediateSum;
                }
            }
            return r;
        }), i(e, "Series/Waterfall/WaterfallSeriesDefaults.js", [], function() {
            return {
                dataLabels: {
                    inside: !0
                },
                lineWidth: 1,
                lineColor: "#333333",
                dashStyle: "Dot",
                borderColor: "#333333",
                states: {
                    hover: {
                        lineWidthPlus: 0
                    }
                }
            };
        }), i(e, "Series/Waterfall/WaterfallSeries.js", [
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"],
            e["Core/Axis/WaterfallAxis.js"],
            e["Series/Waterfall/WaterfallPoint.js"],
            e["Series/Waterfall/WaterfallSeriesDefaults.js"]
        ], function(t, e, i, n, r) {
            let { column: o, line: s } = t.seriesTypes, { addEvent: a, arrayMax: l, arrayMin: h, correctFloat: c, crisp: d, extend: u, isNumber: p, merge: f, objectEach: g, pick: m } = e;
            function b(t, e) {
                return Object.hasOwnProperty.call(t, e);
            }
            class y extends o {
                generatePoints() {
                    o.prototype.generatePoints.apply(this);
                    for(let t = 0, e = this.points.length; t < e; t++){
                        let e = this.points[t], i = this.processedYData[t];
                        p(i) && (e.isIntermediateSum || e.isSum) && (e.y = c(i));
                    }
                }
                processData(t) {
                    let e, i, n, r, o, s, a = this.options, l = this.yData, h = a.data, d = l.length, u = a.threshold || 0;
                    n = i = r = o = 0;
                    for(let t = 0; t < d; t++)s = l[t], e = h && h[t] ? h[t] : {}, "sum" === s || e.isSum ? l[t] = c(n) : "intermediateSum" === s || e.isIntermediateSum ? (l[t] = c(i), i = 0) : (n += s, i += s), r = Math.min(n, r), o = Math.max(n, o);
                    super.processData.call(this, t), a.stacking || (this.dataMin = r + u, this.dataMax = o);
                }
                toYData(t) {
                    return t.isSum ? "sum" : t.isIntermediateSum ? "intermediateSum" : t.y;
                }
                updateParallelArrays(t, e) {
                    super.updateParallelArrays.call(this, t, e), ("sum" === this.yData[0] || "intermediateSum" === this.yData[0]) && (this.yData[0] = null);
                }
                pointAttribs(t, e) {
                    let i = this.options.upColor;
                    i && !t.options.color && p(t.y) && (t.color = t.y > 0 ? i : void 0);
                    let n = o.prototype.pointAttribs.call(this, t, e);
                    return delete n.dashstyle, n;
                }
                getGraphPath() {
                    return [
                        [
                            "M",
                            0,
                            0
                        ]
                    ];
                }
                getCrispPath() {
                    let t = this.data.filter((t)=>p(t.y)), e = this.yAxis, i = t.length, n = this.graph?.strokeWidth() || 0, r = this.xAxis.reversed, o = this.yAxis.reversed, s = this.options.stacking, a = [];
                    for(let l = 1; l < i; l++){
                        if (!this.options.connectNulls && !p(this.data[t[l].index - 1].y)) continue;
                        let i = t[l].box, h = t[l - 1], c = h.y || 0, u = t[l - 1].box;
                        if (!i || !u) continue;
                        let f = e.waterfall.stacks[this.stackKey], g = c > 0 ? -u.height : 0;
                        if (f && u && i) {
                            let t, c = f[l - 1];
                            if (s) {
                                let i = c.connectorThreshold;
                                t = d(e.translate(i, !1, !0, !1, !0) + (o ? g : 0), n);
                            } else t = d(u.y + (h.minPointLengthOffset || 0), n);
                            a.push([
                                "M",
                                (u.x || 0) + (r ? 0 : u.width || 0),
                                t
                            ], [
                                "L",
                                (i.x || 0) + (r && i.width || 0),
                                t
                            ]);
                        }
                        if (u && a.length && (!s && c < 0 && !o || c > 0 && o)) {
                            let t = a[a.length - 2];
                            t && "number" == typeof t[2] && (t[2] += u.height || 0);
                            let e = a[a.length - 1];
                            e && "number" == typeof e[2] && (e[2] += u.height || 0);
                        }
                    }
                    return a;
                }
                drawGraph() {
                    s.prototype.drawGraph.call(this), this.graph && this.graph.attr({
                        d: this.getCrispPath()
                    });
                }
                setStackedPoints(t) {
                    let e, i, n, r, o, s, a, l, h, c = this.options, d = t.waterfall?.stacks, u = c.threshold || 0, p = this.stackKey, f = this.xData, g = f.length, m = u, b = m, y = 0, x = 0, v = 0, w = (t, n, r, o)=>{
                        if (e) {
                            if (i) for(; r < i; r++)e.stackState[r] += o;
                            else e.stackState[0] = t, i = e.stackState.length;
                            e.stackState.push(e.stackState[i - 1] + n);
                        }
                    };
                    if (t.stacking && d && this.reserveSpace()) {
                        h = d.changed, (l = d.alreadyChanged) && 0 > l.indexOf(p) && (h = !0), d[p] || (d[p] = {});
                        let t = d[p];
                        if (t) for(let l = 0; l < g; l++)(!t[a = f[l]] || h) && (t[a] = {
                            negTotal: 0,
                            posTotal: 0,
                            stackTotal: 0,
                            threshold: 0,
                            stateIndex: 0,
                            stackState: [],
                            label: h && t[a] ? t[a].label : void 0
                        }), e = t[a], (s = this.yData[l]) >= 0 ? e.posTotal += s : e.negTotal += s, o = c.data[l], n = e.absolutePos = e.posTotal, r = e.absoluteNeg = e.negTotal, e.stackTotal = n + r, i = e.stackState.length, o && o.isIntermediateSum ? (w(v, x, 0, v), v = x, x = u, m ^= b, b ^= m, m ^= b) : o && o.isSum ? (w(u, y, i, 0), m = u) : (w(m, s, 0, y), o && (y += s, x += s)), e.stateIndex++, e.threshold = m, m += e.stackTotal;
                        d.changed = !1, d.alreadyChanged || (d.alreadyChanged = []), d.alreadyChanged.push(p);
                    }
                }
                getExtremes() {
                    let t, e, i, n = this.options.stacking;
                    return n ? (t = this.yAxis.waterfall.stacks, e = this.stackedYNeg = [], i = this.stackedYPos = [], g(t[this.stackKey], "overlap" === n ? function(t) {
                        e.push(h(t.stackState)), i.push(l(t.stackState));
                    } : function(t) {
                        e.push(t.negTotal + t.threshold), i.push(t.posTotal + t.threshold);
                    }), {
                        dataMin: h(e),
                        dataMax: l(i)
                    }) : {
                        dataMin: this.dataMin,
                        dataMax: this.dataMax
                    };
                }
            }
            return y.defaultOptions = f(o.defaultOptions, r), y.compose = i.compose, u(y.prototype, {
                pointValKey: "y",
                showLine: !0,
                pointClass: n
            }), a(y, "afterColumnTranslate", function() {
                let t, e, i, n, { options: r, points: o, yAxis: s } = this, a = m(r.minPointLength, 5), l = a / 2, h = r.threshold || 0, c = r.stacking, g = s.waterfall.stacks[this.stackKey], y = h, x = h;
                for(let r = 0; r < o.length; r++){
                    let m = o[r], v = this.processedYData[r], w = u({
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    }, m.shapeArgs || {});
                    m.box = w;
                    let C = [
                        0,
                        v
                    ], S = m.y || 0;
                    if (c) {
                        if (g) {
                            let o = g[r];
                            "overlap" === c ? (e = o.stackState[o.stateIndex--], t = S >= 0 ? e : e - S, b(o, "absolutePos") && delete o.absolutePos, b(o, "absoluteNeg") && delete o.absoluteNeg) : (S >= 0 ? (e = o.threshold + o.posTotal, o.posTotal -= S, t = e) : (e = o.threshold + o.negTotal, o.negTotal -= S, t = e - S), !o.posTotal && p(o.absolutePos) && b(o, "absolutePos") && (o.posTotal = o.absolutePos, delete o.absolutePos), !o.negTotal && p(o.absoluteNeg) && b(o, "absoluteNeg") && (o.negTotal = o.absoluteNeg, delete o.absoluteNeg)), m.isSum || (o.connectorThreshold = o.threshold + o.stackTotal), s.reversed ? (i = S >= 0 ? t - S : t + S, n = t) : (i = t, n = t - S), m.below = i <= h, w.y = s.translate(i, !1, !0, !1, !0), w.height = Math.abs(w.y - s.translate(n, !1, !0, !1, !0));
                            let a = s.waterfall.dummyStackItem;
                            a && (a.x = r, a.label = g[r].label, a.setOffset(this.pointXOffset || 0, this.barW || 0, this.stackedYNeg[r], this.stackedYPos[r], void 0, this.xAxis));
                        }
                    } else t = Math.max(x, x + S) + C[0], w.y = s.translate(t, !1, !0, !1, !0), m.isSum ? (w.y = s.translate(C[1], !1, !0, !1, !0), w.height = Math.min(s.translate(C[0], !1, !0, !1, !0), s.len) - w.y, m.below = C[1] <= h) : m.isIntermediateSum ? (S >= 0 ? (i = C[1] + y, n = y) : (i = y, n = C[1] + y), s.reversed && (i ^= n, n ^= i, i ^= n), w.y = s.translate(i, !1, !0, !1, !0), w.height = Math.abs(w.y - Math.min(s.translate(n, !1, !0, !1, !0), s.len)), y += C[1], m.below = i <= h) : (w.height = v > 0 ? s.translate(x, !1, !0, !1, !0) - w.y : s.translate(x, !1, !0, !1, !0) - s.translate(x - v, !1, !0, !1, !0), x += v, m.below = x < h), w.height < 0 && (w.y += w.height, w.height *= -1);
                    m.plotY = w.y, m.yBottom = w.y + w.height, w.height <= a && !m.isNull ? (w.height = a, w.y -= l, m.yBottom = w.y + w.height, m.plotY = w.y, m.minPointLengthOffset = S < 0 ? -l : l) : (m.isNull && (w.width = 0), m.minPointLengthOffset = 0);
                    let k = m.plotY + (m.negative ? w.height : 0);
                    m.below && (m.plotY += w.height), m.tooltipPos && (this.chart.inverted ? m.tooltipPos[0] = s.len - k : m.tooltipPos[1] = k), m.isInside = this.isPointInside(m);
                    let A = d(m.yBottom, this.borderWidth);
                    w.y = d(w.y, this.borderWidth), w.height = A - w.y, f(!0, m.shapeArgs, w);
                }
            }, {
                order: 2
            }), t.registerSeriesType("waterfall", y), y;
        }), i(e, "masters/highcharts-more.src.js", [
            e["Core/Globals.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Extensions/Pane/Pane.js"],
            e["Series/Bubble/BubbleSeries.js"],
            e["Series/PackedBubble/PackedBubbleSeries.js"],
            e["Series/PolarComposition.js"],
            e["Core/Axis/RadialAxis.js"],
            e["Series/Waterfall/WaterfallSeries.js"]
        ], function(t, e, i, n, r, o, s, a) {
            return t.RadialAxis = s, n.compose(t.Axis, t.Chart, t.Legend), r.compose(t.Axis, t.Chart, t.Legend), i.compose(t.Chart, t.Pointer), o.compose(t.Axis, t.Chart, t.Pointer, t.Series, t.Tick, t.Point, e.seriesTypes.areasplinerange, e.seriesTypes.column, e.seriesTypes.line, e.seriesTypes.spline), a.compose(t.Axis, t.Chart), t;
        });
    }, t.exports ? (e.default = e, t.exports = e) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}(Ar)), Ar.exports), Tr = b(Mr), Pr = {
    exports: {}
};
var Rr, Lr = (Er || (Er = 1, function(t) {
    var e;
    e = function(t) {
        var e = t ? t._modules : {};
        function i(e, i, n, r) {
            e.hasOwnProperty(i) || (e[i] = r.apply(null, n), "function" == typeof CustomEvent && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
                detail: {
                    path: i,
                    module: e[i]
                }
            })));
        }
        i(e, "Accessibility/Utils/HTMLUtilities.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { doc: i, win: n } = t, { css: r } = e, o = n.EventTarget && new n.EventTarget || "none";
            function s(t) {
                if ("function" == typeof n.MouseEvent) return new n.MouseEvent(t.type, t);
                if (i.createEvent) {
                    let e = i.createEvent("MouseEvent");
                    if (e.initMouseEvent) return e.initMouseEvent(t.type, t.bubbles, t.cancelable, t.view || n, t.detail, t.screenX, t.screenY, t.clientX, t.clientY, t.ctrlKey, t.altKey, t.shiftKey, t.metaKey, t.button, t.relatedTarget), e;
                }
                return a(t.type);
            }
            function a(t, e, r) {
                let s = e || {
                    x: 0,
                    y: 0
                };
                if ("function" == typeof n.MouseEvent) return new n.MouseEvent(t, {
                    bubbles: !0,
                    cancelable: !0,
                    composed: !0,
                    button: 0,
                    buttons: 1,
                    relatedTarget: r || o,
                    view: n,
                    detail: "click" === t ? 1 : 0,
                    screenX: s.x,
                    screenY: s.y,
                    clientX: s.x,
                    clientY: s.y
                });
                if (i.createEvent) {
                    let e = i.createEvent("MouseEvent");
                    if (e.initMouseEvent) return e.initMouseEvent(t, !0, !0, n, "click" === t ? 1 : 0, s.x, s.y, s.x, s.y, !1, !1, !1, !1, 0, null), e;
                }
                return {
                    type: t
                };
            }
            return {
                addClass: function(t, e) {
                    t.classList ? t.classList.add(e) : 0 > t.className.indexOf(e) && (t.className += " " + e);
                },
                cloneMouseEvent: s,
                cloneTouchEvent: function(t) {
                    let e = (t)=>{
                        let e = [];
                        for(let i = 0; i < t.length; ++i){
                            let n = t.item(i);
                            n && e.push(n);
                        }
                        return e;
                    };
                    if ("function" == typeof n.TouchEvent) {
                        let i = new n.TouchEvent(t.type, {
                            touches: e(t.touches),
                            targetTouches: e(t.targetTouches),
                            changedTouches: e(t.changedTouches),
                            ctrlKey: t.ctrlKey,
                            shiftKey: t.shiftKey,
                            altKey: t.altKey,
                            metaKey: t.metaKey,
                            bubbles: t.bubbles,
                            cancelable: t.cancelable,
                            composed: t.composed,
                            detail: t.detail,
                            view: t.view
                        });
                        return t.defaultPrevented && i.preventDefault(), i;
                    }
                    let i = s(t);
                    return i.touches = t.touches, i.changedTouches = t.changedTouches, i.targetTouches = t.targetTouches, i;
                },
                escapeStringForHTML: function(t) {
                    return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
                },
                getElement: function(t) {
                    return i.getElementById(t);
                },
                getFakeMouseEvent: a,
                getHeadingTagNameForElement: function(t) {
                    let e = (t)=>"h" + Math.min(6, parseInt(t.slice(1), 10) + 1), i = (t)=>/^H[1-6]$/i.test(t), n = (t)=>{
                        let r = ((t)=>{
                            let e = t;
                            for(; e = e.previousSibling;){
                                let t = e.tagName || "";
                                if (i(t)) return t;
                            }
                            return "";
                        })(t);
                        if (r) return e(r);
                        let o = t.parentElement;
                        if (!o) return "p";
                        let s = o.tagName;
                        return i(s) ? e(s) : n(o);
                    };
                    return n(t);
                },
                removeChildNodes: function(t) {
                    for(; t.lastChild;)t.removeChild(t.lastChild);
                },
                removeClass: function(t, e) {
                    t.classList ? t.classList.remove(e) : t.className = t.className.replace(RegExp(e, "g"), "");
                },
                removeElement: function(t) {
                    t && t.parentNode && t.parentNode.removeChild(t);
                },
                reverseChildNodes: function(t) {
                    let e = t.childNodes.length;
                    for(; e--;)t.appendChild(t.childNodes[e]);
                },
                simulatedEventTarget: o,
                stripHTMLTagsFromString: function(t, e = !1) {
                    return "string" == typeof t ? e ? t.replace(/<\/?[^>]+(>|$)/g, "") : t.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : t;
                },
                visuallyHideElement: function(t) {
                    r(t, {
                        position: "absolute",
                        width: "1px",
                        height: "1px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        clip: "rect(1px, 1px, 1px, 1px)",
                        marginTop: "-3px",
                        "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)",
                        filter: "alpha(opacity=1)",
                        opacity: .01
                    });
                }
            };
        }), i(e, "Accessibility/A11yI18n.js", [
            e["Core/Templating.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            var i;
            let { format: n } = t, { getNestedProperty: r, pick: o } = e;
            return function(t) {
                function e(t, e, i) {
                    let s, a, l = (t, e)=>{
                        let i = t.slice(e || 0), n = i.indexOf("{"), r = i.indexOf("}");
                        if (n > -1 && r > n) return {
                            statement: i.substring(n + 1, r),
                            begin: e + n + 1,
                            end: e + r
                        };
                    }, h = [], c = 0;
                    do s = l(t, c), (a = t.substring(c, s && s.begin - 1)).length && h.push({
                        value: a,
                        type: "constant"
                    }), s && h.push({
                        value: s.statement,
                        type: "statement"
                    }), c = s ? s.end + 1 : c + 1;
                    while (s);
                    return h.forEach((t)=>{
                        "statement" === t.type && (t.value = function(t, e) {
                            let i, n, s = t.indexOf("#each("), a = t.indexOf("#plural("), l = t.indexOf("["), h = t.indexOf("]");
                            if (s > -1) {
                                let o, a = t.slice(s).indexOf(")") + s, l = t.substring(0, s), h = t.substring(a + 1), c = t.substring(s + 6, a).split(","), d = Number(c[1]);
                                if (n = "", i = r(c[0], e)) {
                                    o = (d = isNaN(d) ? i.length : d) < 0 ? i.length + d : Math.min(d, i.length);
                                    for(let t = 0; t < o; ++t)n += l + i[t] + h;
                                }
                                return n.length ? n : "";
                            }
                            if (a > -1) {
                                var c;
                                let i = t.slice(a).indexOf(")") + a, s = t.substring(a + 8, i).split(",");
                                switch(Number(r(s[0], e))){
                                    case 0:
                                        n = o(s[4], s[1]);
                                        break;
                                    case 1:
                                        n = o(s[2], s[1]);
                                        break;
                                    case 2:
                                        n = o(s[3], s[1]);
                                        break;
                                    default:
                                        n = s[1];
                                }
                                return n ? (c = n).trim && c.trim() || c.replace(/^\s+|\s+$/g, "") : "";
                            }
                            if (l > -1) {
                                let n, o = t.substring(0, l), s = Number(t.substring(l + 1, h));
                                return i = r(o, e), !isNaN(s) && i && (s < 0 ? void 0 === (n = i[i.length + s]) && (n = i[0]) : void 0 === (n = i[s]) && (n = i[i.length - 1])), void 0 !== n ? n : "";
                            }
                            return "{" + t + "}";
                        }(t.value, e));
                    }), n(h.reduce((t, e)=>t + e.value, ""), e, i);
                }
                function i(t, i) {
                    let n = t.split("."), r = this.options.lang, o = 0;
                    for(; o < n.length; ++o)r = r && r[n[o]];
                    return "string" == typeof r ? e(r, i, this) : "";
                }
                t.compose = function(t) {
                    let e = t.prototype;
                    e.langFormat || (e.langFormat = i);
                }, t.i18nFormat = e;
            }(i || (i = {})), i;
        }), i(e, "Accessibility/Utils/ChartUtilities.js", [
            e["Core/Globals.js"],
            e["Accessibility/Utils/HTMLUtilities.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { doc: n } = t, { stripHTMLTagsFromString: r } = e, { defined: o, find: s, fireEvent: a } = i;
            function l(t) {
                if (t.points && t.points.length) {
                    let e = s(t.points, (t)=>!!t.graphic);
                    return e && e.graphic && e.graphic.element;
                }
            }
            function h(t) {
                let e = l(t);
                return e && e.parentNode || t.graph && t.graph.element || t.group && t.group.element;
            }
            return {
                fireEventOnWrappedOrUnwrappedElement: function t(e, i) {
                    let r = i.type, o = e.hcEvents;
                    n.createEvent && (e.dispatchEvent || e.fireEvent) ? e.dispatchEvent ? e.dispatchEvent(i) : e.fireEvent(r, i) : o && o[r] ? a(e, r, i) : e.element && t(e.element, i);
                },
                getChartTitle: function(t) {
                    return r(t.options.title.text || t.langFormat("accessibility.defaultChartTitle", {
                        chart: t
                    }), t.renderer.forExport);
                },
                getAxisDescription: function(t) {
                    return t && (t.options.accessibility?.description || t.axisTitle?.textStr || t.options.id || t.categories && "categories" || t.dateTime && "Time" || "values");
                },
                getAxisRangeDescription: function(t) {
                    let e = t.options || {};
                    return e.accessibility && void 0 !== e.accessibility.rangeDescription ? e.accessibility.rangeDescription : t.categories ? function(t) {
                        let e = t.chart;
                        return t.dataMax && t.dataMin ? e.langFormat("accessibility.axis.rangeCategories", {
                            chart: e,
                            axis: t,
                            numCategories: t.dataMax - t.dataMin + 1
                        }) : "";
                    }(t) : !t.dateTime || 0 !== t.min && 0 !== t.dataMin ? function(t) {
                        let e = t.chart, i = e.options, n = i && i.accessibility && i.accessibility.screenReaderSection.axisRangeDateFormat || "", r = {
                            min: t.dataMin || t.min || 0,
                            max: t.dataMax || t.max || 0
                        }, o = function(i) {
                            return t.dateTime ? e.time.dateFormat(n, r[i]) : r[i].toString();
                        };
                        return e.langFormat("accessibility.axis.rangeFromTo", {
                            chart: e,
                            axis: t,
                            rangeFrom: o("min"),
                            rangeTo: o("max")
                        });
                    }(t) : function(t) {
                        let e = t.chart, i = {}, n = t.dataMin || t.min || 0, r = t.dataMax || t.max || 0, o = "Seconds";
                        i.Seconds = (r - n) / 1e3, i.Minutes = i.Seconds / 60, i.Hours = i.Minutes / 60, i.Days = i.Hours / 24, [
                            "Minutes",
                            "Hours",
                            "Days"
                        ].forEach(function(t) {
                            i[t] > 2 && (o = t);
                        });
                        let s = i[o].toFixed("Seconds" !== o && "Minutes" !== o ? 1 : 0);
                        return e.langFormat("accessibility.axis.timeRange" + o, {
                            chart: e,
                            axis: t,
                            range: s.replace(".0", "")
                        });
                    }(t);
                },
                getPointFromXY: function(t, e, i) {
                    let n, r = t.length;
                    for(; r--;)if (n = s(t[r].points || [], function(t) {
                        return t.x === e && t.y === i;
                    })) return n;
                },
                getSeriesFirstPointElement: l,
                getSeriesFromName: function(t, e) {
                    return e ? (t.series || []).filter(function(t) {
                        return t.name === e;
                    }) : t.series;
                },
                getSeriesA11yElement: h,
                unhideChartElementFromAT: function t(e, i) {
                    i.setAttribute("aria-hidden", !1), i !== e.renderTo && i.parentNode && i.parentNode !== n.body && (Array.prototype.forEach.call(i.parentNode.childNodes, function(_t1) {
                        _t1.hasAttribute("aria-hidden") || _t1.setAttribute("aria-hidden", !0);
                    }), t(e, i.parentNode));
                },
                hideSeriesFromAT: function(t) {
                    let e = h(t);
                    e && e.setAttribute("aria-hidden", !0);
                },
                scrollAxisToPoint: function(t) {
                    let e = t.series.xAxis, i = t.series.yAxis, n = e && e.scrollbar ? e : i, r = n && n.scrollbar;
                    if (r && o(r.to) && o(r.from)) {
                        let e = r.to - r.from, i = function(t, e) {
                            if (!o(t.dataMin) || !o(t.dataMax)) return 0;
                            let i = t.toPixels(t.dataMin), n = t.toPixels(t.dataMax), r = "xAxis" === t.coll ? "x" : "y";
                            return (t.toPixels(e[r] || 0) - i) / (n - i);
                        }(n, t);
                        r.updatePosition(i - e / 2, i + e / 2), a(r, "changed", {
                            from: r.from,
                            to: r.to,
                            trigger: "scrollbar",
                            DOMEvent: null
                        });
                    }
                }
            };
        }), i(e, "Accessibility/Utils/DOMElementProvider.js", [
            e["Core/Globals.js"],
            e["Accessibility/Utils/HTMLUtilities.js"]
        ], function(t, e) {
            let { doc: i } = t, { removeElement: n } = e;
            return class {
                constructor(){
                    this.elements = [];
                }
                createElement() {
                    let t = i.createElement.apply(i, arguments);
                    return this.elements.push(t), t;
                }
                removeElement(t) {
                    n(t), this.elements.splice(this.elements.indexOf(t), 1);
                }
                destroyCreatedElements() {
                    this.elements.forEach(function(t) {
                        n(t);
                    }), this.elements = [];
                }
            };
        }), i(e, "Accessibility/Utils/EventProvider.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { addEvent: i } = e;
            return class {
                constructor(){
                    this.eventRemovers = [];
                }
                addEvent() {
                    let e = i.apply(t, arguments);
                    return this.eventRemovers.push({
                        element: arguments[0],
                        remover: e
                    }), e;
                }
                removeEvent(t) {
                    let e = this.eventRemovers.map((t)=>t.remover).indexOf(t);
                    this.eventRemovers[e].remover(), this.eventRemovers.splice(e, 1);
                }
                removeAddedEvents() {
                    this.eventRemovers.map((t)=>t.remover).forEach((t)=>t()), this.eventRemovers = [];
                }
            };
        }), i(e, "Accessibility/AccessibilityComponent.js", [
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/Utils/DOMElementProvider.js"],
            e["Accessibility/Utils/EventProvider.js"],
            e["Accessibility/Utils/HTMLUtilities.js"]
        ], function(t, e, i, n) {
            let { fireEventOnWrappedOrUnwrappedElement: r } = t, { getFakeMouseEvent: o } = n;
            return class {
                destroy() {}
                getKeyboardNavigation() {
                    return [];
                }
                init() {}
                onChartRender() {}
                onChartUpdate() {}
                initBase(t, n) {
                    this.chart = t, this.eventProvider = new i, this.domElementProvider = new e, this.proxyProvider = n, this.keyCodes = {
                        left: 37,
                        right: 39,
                        up: 38,
                        down: 40,
                        enter: 13,
                        space: 32,
                        esc: 27,
                        tab: 9,
                        pageUp: 33,
                        pageDown: 34,
                        end: 35,
                        home: 36
                    };
                }
                addEvent(t, e, i, n) {
                    return this.eventProvider.addEvent(t, e, i, n);
                }
                createElement(t, e) {
                    return this.domElementProvider.createElement(t, e);
                }
                fakeClickEvent(t) {
                    r(t, o("click"));
                }
                destroyBase() {
                    this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
                }
            };
        }), i(e, "Accessibility/KeyboardNavigationHandler.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            let { find: e } = t;
            return class {
                constructor(t, e){
                    this.chart = t, this.keyCodeMap = e.keyCodeMap || [], this.validate = e.validate, this.init = e.init, this.terminate = e.terminate, this.response = {
                        success: 1,
                        prev: 2,
                        next: 3,
                        noHandler: 4,
                        fail: 5
                    };
                }
                run(t) {
                    let i = t.which || t.keyCode, n = this.response.noHandler, r = e(this.keyCodeMap, function(t) {
                        return t[0].indexOf(i) > -1;
                    });
                    return r ? n = r[1].call(this, i, t) : 9 === i && (n = this.response[t.shiftKey ? "prev" : "next"]), n;
                }
            };
        }), i(e, "Accessibility/Components/ContainerComponent.js", [
            e["Accessibility/AccessibilityComponent.js"],
            e["Accessibility/KeyboardNavigationHandler.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Core/Globals.js"],
            e["Accessibility/Utils/HTMLUtilities.js"]
        ], function(t, e, i, n, r) {
            let { unhideChartElementFromAT: o, getChartTitle: s } = i, { doc: a } = n, { stripHTMLTagsFromString: l } = r;
            return class extends t {
                onChartUpdate() {
                    this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
                }
                handleSVGTitleElement() {
                    let t = this.chart, e = "highcharts-title-" + t.index, i = l(t.langFormat("accessibility.svgContainerTitle", {
                        chartTitle: s(t)
                    }));
                    if (i.length) {
                        let n = this.svgTitleElement = this.svgTitleElement || a.createElementNS("http://www.w3.org/2000/svg", "title");
                        n.textContent = i, n.id = e, t.renderTo.insertBefore(n, t.renderTo.firstChild);
                    }
                }
                setSVGContainerLabel() {
                    let t = this.chart, e = t.langFormat("accessibility.svgContainerLabel", {
                        chartTitle: s(t)
                    });
                    t.renderer.box && e.length && t.renderer.box.setAttribute("aria-label", e);
                }
                setGraphicContainerAttrs() {
                    let t = this.chart, e = t.langFormat("accessibility.graphicContainerLabel", {
                        chartTitle: s(t)
                    });
                    e.length && t.container.setAttribute("aria-label", e);
                }
                setRenderToAttrs() {
                    let t = this.chart, e = "disabled" !== t.options.accessibility.landmarkVerbosity, i = t.langFormat("accessibility.chartContainerLabel", {
                        title: s(t),
                        chart: t
                    });
                    i && (t.renderTo.setAttribute("role", e ? "region" : "group"), t.renderTo.setAttribute("aria-label", i));
                }
                makeCreditsAccessible() {
                    let t = this.chart, e = t.credits;
                    e && (e.textStr && e.element.setAttribute("aria-label", t.langFormat("accessibility.credits", {
                        creditsStr: l(e.textStr, t.renderer.forExport)
                    })), o(t, e.element));
                }
                getKeyboardNavigation() {
                    let t = this.chart;
                    return new e(t, {
                        keyCodeMap: [],
                        validate: function() {
                            return !0;
                        },
                        init: function() {
                            let e = t.accessibility;
                            e && e.keyboardNavigation.tabindexContainer.focus();
                        }
                    });
                }
                destroy() {
                    this.chart.renderTo.setAttribute("aria-hidden", !0);
                }
            };
        }), i(e, "Accessibility/FocusBorder.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            var e;
            let { addEvent: i, pick: n } = t;
            return function(t) {
                let e = [
                    "x",
                    "y",
                    "transform",
                    "width",
                    "height",
                    "r",
                    "d",
                    "stroke-width"
                ];
                function r() {
                    let t = this.focusElement, e = this.options.accessibility.keyboardNavigation.focusBorder;
                    t && (t.removeFocusBorder(), e.enabled && t.addFocusBorder(e.margin, {
                        stroke: e.style.color,
                        strokeWidth: e.style.lineWidth,
                        r: e.style.borderRadius
                    }));
                }
                function o(t, e) {
                    let n = this.options.accessibility.keyboardNavigation.focusBorder, r = e || t.element;
                    r && r.focus && (r.hcEvents && r.hcEvents.focusin || i(r, "focusin", function() {}), r.focus(), n.hideBrowserFocusOutline && (r.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = t, this.renderFocusBorder();
                }
                function s(t, i) {
                    this.focusBorder && this.removeFocusBorder();
                    let r = this.getBBox(), o = n(t, 3), s = this.parentGroup, a = this.scaleX || s && s.scaleX, l = this.scaleY || s && s.scaleY, h = (a ? !l : l) ? Math.abs(a || l || 1) : (Math.abs(a || 1) + Math.abs(l || 1)) / 2;
                    r.x += this.translateX ? this.translateX : 0, r.y += this.translateY ? this.translateY : 0;
                    let c = r.x - o, d = r.y - o, u = r.width + 2 * o, p = r.height + 2 * o, f = !!this.text;
                    if ("text" === this.element.nodeName || f) {
                        let t, e, i = !!this.rotation, n = f ? {
                            x: i ? 1 : 0,
                            y: 0
                        } : (t = 0, e = 0, "middle" === this.attr("text-anchor") ? t = e = .5 : this.rotation ? t = .25 : e = .75, {
                            x: t,
                            y: e
                        }), s = +this.attr("x"), a = +this.attr("y");
                        if (isNaN(s) || (c = s - r.width * n.x - o), isNaN(a) || (d = a - r.height * n.y - o), f && i) {
                            let t = u;
                            u = p, p = t, isNaN(s) || (c = s - r.height * n.x - o), isNaN(a) || (d = a - r.width * n.y - o);
                        }
                    }
                    this.focusBorder = this.renderer.rect(c, d, u, p, parseInt((i && i.r || 0).toString(), 10) / h).addClass("highcharts-focus-border").attr({
                        zIndex: 99
                    }).add(s), this.renderer.styledMode || this.focusBorder.attr({
                        stroke: i && i.stroke,
                        "stroke-width": (i && i.strokeWidth || 0) / h
                    }), function(t, ...i) {
                        t.focusBorderUpdateHooks || (t.focusBorderUpdateHooks = {}, e.forEach((e)=>{
                            let n = e + "Setter", r = t[n] || t._defaultSetter;
                            t.focusBorderUpdateHooks[n] = r, t[n] = function() {
                                let e = r.apply(t, arguments);
                                return t.addFocusBorder.apply(t, i), e;
                            };
                        }));
                    }(this, t, i), function(t) {
                        if (t.focusBorderDestroyHook) return;
                        let e = t.destroy;
                        t.destroy = function() {
                            return t.focusBorder && t.focusBorder.destroy && t.focusBorder.destroy(), e.apply(t, arguments);
                        }, t.focusBorderDestroyHook = e;
                    }(this);
                }
                function a() {
                    var t;
                    (t = this).focusBorderUpdateHooks && (Object.keys(t.focusBorderUpdateHooks).forEach((e)=>{
                        let i = t.focusBorderUpdateHooks[e];
                        i === t._defaultSetter ? delete t[e] : t[e] = i;
                    }), delete t.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
                }
                t.compose = function(t, e) {
                    let i = t.prototype, n = e.prototype;
                    i.renderFocusBorder || (i.renderFocusBorder = r, i.setFocusToElement = o), n.addFocusBorder || (n.addFocusBorder = s, n.removeFocusBorder = a);
                };
            }(e || (e = {})), e;
        }), i(e, "Accessibility/Utils/Announcer.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Accessibility/Utils/DOMElementProvider.js"],
            e["Core/Globals.js"],
            e["Accessibility/Utils/HTMLUtilities.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { doc: o } = i, { addClass: s, visuallyHideElement: a } = n, { attr: l } = r;
            return class {
                constructor(t, i){
                    this.chart = t, this.domElementProvider = new e, this.announceRegion = this.addAnnounceRegion(i);
                }
                destroy() {
                    this.domElementProvider.destroyCreatedElements();
                }
                announce(e) {
                    t.setElementHTML(this.announceRegion, e), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(()=>{
                        this.announceRegion.innerHTML = t.emptyHTML, delete this.clearAnnouncementRegionTimer;
                    }, 3e3);
                }
                addAnnounceRegion(t) {
                    let e = this.chart.announcerContainer || this.createAnnouncerContainer(), i = this.domElementProvider.createElement("div");
                    return l(i, {
                        "aria-hidden": !1,
                        "aria-live": t,
                        "aria-atomic": !0
                    }), this.chart.styledMode ? s(i, "highcharts-visually-hidden") : a(i), e.appendChild(i), i;
                }
                createAnnouncerContainer() {
                    let t = this.chart, e = o.createElement("div");
                    return l(e, {
                        "aria-hidden": !1,
                        class: "highcharts-announcer-container"
                    }), e.style.position = "relative", t.renderTo.insertBefore(e, t.renderTo.firstChild), t.announcerContainer = e, e;
                }
            };
        }), i(e, "Accessibility/Components/AnnotationsA11y.js", [
            e["Accessibility/Utils/HTMLUtilities.js"]
        ], function(t) {
            let { escapeStringForHTML: e, stripHTMLTagsFromString: i } = t;
            function n(t) {
                return (t.annotations || []).reduce((t, e)=>(e.options && !1 !== e.options.visible && (t = t.concat(e.labels)), t), []);
            }
            function r(t) {
                return t.options && t.options.accessibility && t.options.accessibility.description || t.graphic && t.graphic.text && t.graphic.text.textStr || "";
            }
            function o(t) {
                let e = t.options && t.options.accessibility && t.options.accessibility.description;
                if (e) return e;
                let i = t.chart, n = r(t), o = t.points, s = o.filter((t)=>!!t.graphic).map((t)=>{
                    let e = t.accessibility && t.accessibility.valueDescription || ((t)=>t.graphic && t.graphic.element && t.graphic.element.getAttribute("aria-label") || "")(t), i = t && t.series.name || "";
                    return (i ? i + ", " : "") + "data point " + e;
                }).filter((t)=>!!t), a = s.length, l = a > 1 ? "MultiplePoints" : a ? "SinglePoint" : "NoPoints", h = {
                    annotationText: n,
                    annotation: t,
                    numPoints: a,
                    annotationPoint: s[0],
                    additionalAnnotationPoints: s.slice(1)
                };
                return i.langFormat("accessibility.screenReaderSection.annotations.description" + l, h);
            }
            function s(t) {
                return n(t).map((n)=>{
                    let r = e(i(o(n), t.renderer.forExport));
                    return r ? `<li>${r}</li>` : "";
                });
            }
            return {
                getAnnotationsInfoHTML: function(t) {
                    let e = t.annotations;
                    return e && e.length ? `<ul style="list-style-type: none">${s(t).join(" ")}</ul>` : "";
                },
                getAnnotationLabelDescription: o,
                getAnnotationListItems: s,
                getPointAnnotationTexts: function(t) {
                    let e = n(t.series.chart).filter((e)=>e.points.indexOf(t) > -1);
                    return e.length ? e.map((t)=>`${r(t)}`) : [];
                }
            };
        }), i(e, "Accessibility/Components/InfoRegionsComponent.js", [
            e["Accessibility/A11yI18n.js"],
            e["Accessibility/AccessibilityComponent.js"],
            e["Accessibility/Utils/Announcer.js"],
            e["Accessibility/Components/AnnotationsA11y.js"],
            e["Core/Renderer/HTML/AST.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Core/Templating.js"],
            e["Core/Globals.js"],
            e["Accessibility/Utils/HTMLUtilities.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a, l, h) {
            let { getAnnotationsInfoHTML: c } = n, { getAxisDescription: d, getAxisRangeDescription: u, getChartTitle: p, unhideChartElementFromAT: f } = o, { format: g } = s, { doc: m } = a, { addClass: b, getElement: y, getHeadingTagNameForElement: x, stripHTMLTagsFromString: v, visuallyHideElement: w } = l, { attr: C, pick: S, replaceNested: k } = h;
            function A(t) {
                return k(t, [
                    /<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g,
                    ""
                ]);
            }
            return class extends e {
                constructor(){
                    super(...arguments), this.screenReaderSections = {};
                }
                init() {
                    let t = this.chart, e = this;
                    this.initRegionsDefinitions(), this.addEvent(t, "aftergetTableAST", function(t) {
                        e.onDataTableCreated(t);
                    }), this.addEvent(t, "afterViewData", function(t) {
                        t.wasHidden && (e.dataTableDiv = t.element, setTimeout(function() {
                            e.focusDataTable();
                        }, 300));
                    }), this.addEvent(t, "afterHideData", function() {
                        e.viewDataTableButton && e.viewDataTableButton.setAttribute("aria-expanded", "false");
                    }), t.exporting && this.addEvent(t, "afterPrint", function() {
                        e.updateAllScreenReaderSections();
                    }), this.announcer = new i(t, "assertive");
                }
                initRegionsDefinitions() {
                    let t = this, e = this.chart.options.accessibility;
                    this.screenReaderSections = {
                        before: {
                            element: null,
                            buildContent: function(i) {
                                let n = e.screenReaderSection.beforeChartFormatter;
                                return n ? n(i) : t.defaultBeforeChartFormatter(i);
                            },
                            insertIntoDOM: function(t, e) {
                                e.renderTo.insertBefore(t, e.renderTo.firstChild);
                            },
                            afterInserted: function() {
                                void 0 !== t.sonifyButtonId && t.initSonifyButton(t.sonifyButtonId), void 0 !== t.dataTableButtonId && t.initDataTableButton(t.dataTableButtonId);
                            }
                        },
                        after: {
                            element: null,
                            buildContent: function(i) {
                                let n = e.screenReaderSection.afterChartFormatter;
                                return n ? n(i) : t.defaultAfterChartFormatter();
                            },
                            insertIntoDOM: function(t, e) {
                                e.renderTo.insertBefore(t, e.container.nextSibling);
                            },
                            afterInserted: function() {
                                t.chart.accessibility && e.keyboardNavigation.enabled && t.chart.accessibility.keyboardNavigation.updateExitAnchor();
                            }
                        }
                    };
                }
                onChartRender() {
                    this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), this.updateAllScreenReaderSections();
                }
                updateAllScreenReaderSections() {
                    let t = this;
                    Object.keys(this.screenReaderSections).forEach(function(e) {
                        t.updateScreenReaderSection(e);
                    });
                }
                getLinkedDescriptionElement() {
                    let t = this.chart.options.accessibility.linkedDescription;
                    if (!t) return;
                    if ("string" != typeof t) return t;
                    let e = g(t, this.chart), i = m.querySelectorAll(e);
                    return 1 === i.length ? i[0] : void 0;
                }
                setLinkedDescriptionAttrs() {
                    let t = this.linkedDescriptionElement;
                    t && (t.setAttribute("aria-hidden", "true"), b(t, "highcharts-linked-description"));
                }
                updateScreenReaderSection(t) {
                    let e = this.chart, i = this.screenReaderSections[t], n = i.buildContent(e), o = i.element = i.element || this.createElement("div"), s = o.firstChild || this.createElement("div");
                    n ? (this.setScreenReaderSectionAttribs(o, t), r.setElementHTML(s, n), o.appendChild(s), i.insertIntoDOM(o, e), e.styledMode ? b(s, "highcharts-visually-hidden") : w(s), f(e, s), i.afterInserted && i.afterInserted()) : (o.parentNode && o.parentNode.removeChild(o), i.element = null);
                }
                setScreenReaderSectionAttribs(t, e) {
                    let i = this.chart, n = i.langFormat("accessibility.screenReaderSection." + e + "RegionLabel", {
                        chart: i,
                        chartTitle: p(i)
                    });
                    C(t, {
                        id: `highcharts-screen-reader-region-${e}-${i.index}`,
                        "aria-label": n || void 0
                    }), t.style.position = "relative", n && t.setAttribute("role", "all" === i.options.accessibility.landmarkVerbosity ? "region" : "group");
                }
                defaultBeforeChartFormatter() {
                    let e = this.chart, i = e.options.accessibility.screenReaderSection.beforeChartFormat;
                    if (!i) return "";
                    let n = this.getAxesDescription(), r = e.sonify && e.options.sonification && e.options.sonification.enabled, o = "highcharts-a11y-sonify-data-btn-" + e.index, s = "hc-linkto-highcharts-data-table-" + e.index, a = c(e), l = e.langFormat("accessibility.screenReaderSection.annotations.heading", {
                        chart: e
                    }), h = {
                        headingTagName: x(e.renderTo),
                        chartTitle: p(e),
                        typeDescription: this.getTypeDescriptionText(),
                        chartSubtitle: this.getSubtitleText(),
                        chartLongdesc: this.getLongdescText(),
                        xAxisDescription: n.xAxis,
                        yAxisDescription: n.yAxis,
                        playAsSoundButton: r ? this.getSonifyButtonText(o) : "",
                        viewTableButton: e.getCSV ? this.getDataTableButtonText(s) : "",
                        annotationsTitle: a ? l : "",
                        annotationsList: a
                    }, d = t.i18nFormat(i, h, e);
                    return this.dataTableButtonId = s, this.sonifyButtonId = o, A(d);
                }
                defaultAfterChartFormatter() {
                    let e = this.chart, i = e.options.accessibility.screenReaderSection.afterChartFormat;
                    if (!i) return "";
                    let n = {
                        endOfChartMarker: this.getEndOfChartMarkerText()
                    };
                    return A(t.i18nFormat(i, n, e));
                }
                getLinkedDescription() {
                    let t = this.linkedDescriptionElement;
                    return v(t && t.innerHTML || "", this.chart.renderer.forExport);
                }
                getLongdescText() {
                    let t = this.chart.options, e = t.caption, i = e && e.text, n = this.getLinkedDescription();
                    return t.accessibility.description || n || i || "";
                }
                getTypeDescriptionText() {
                    let t = this.chart;
                    return t.types ? t.options.accessibility.typeDescription || function(t, e) {
                        let i = e[0], n = t.series && t.series[0] || {}, r = t.mapView && t.mapView.geoMap && t.mapView.geoMap.title, o = {
                            numSeries: t.series.length,
                            numPoints: n.points && n.points.length,
                            chart: t,
                            mapTitle: r
                        };
                        return i ? "map" === i || "tiledwebmap" === i ? o.mapTitle ? t.langFormat("accessibility.chartTypes.mapTypeDescription", o) : t.langFormat("accessibility.chartTypes.unknownMap", o) : t.types.length > 1 ? t.langFormat("accessibility.chartTypes.combinationChart", o) : function(t, e, i) {
                            let n = e[0], r = t.langFormat("accessibility.seriesTypeDescriptions." + n, i), o = t.series && t.series.length < 2 ? "Single" : "Multiple";
                            return (t.langFormat("accessibility.chartTypes." + n + o, i) || t.langFormat("accessibility.chartTypes.default" + o, i)) + (r ? " " + r : "");
                        }(t, e, o) : t.langFormat("accessibility.chartTypes.emptyChart", o);
                    }(t, t.types) : "";
                }
                getDataTableButtonText(t) {
                    let e = this.chart;
                    return '<button id="' + t + '">' + e.langFormat("accessibility.table.viewAsDataTableButtonText", {
                        chart: e,
                        chartTitle: p(e)
                    }) + "</button>";
                }
                getSonifyButtonText(t) {
                    let e = this.chart;
                    return e.options.sonification && !1 === e.options.sonification.enabled ? "" : '<button id="' + t + '">' + e.langFormat("accessibility.sonification.playAsSoundButtonText", {
                        chart: e,
                        chartTitle: p(e)
                    }) + "</button>";
                }
                getSubtitleText() {
                    let t = this.chart.options.subtitle;
                    return v(t && t.text || "", this.chart.renderer.forExport);
                }
                getEndOfChartMarkerText() {
                    let t = y(`highcharts-end-of-chart-marker-${this.chart.index}`);
                    if (t) return t.outerHTML;
                    let e = this.chart, i = e.langFormat("accessibility.screenReaderSection.endOfChartMarker", {
                        chart: e
                    });
                    return '<div id="highcharts-end-of-chart-marker-' + e.index + '">' + i + "</div>";
                }
                onDataTableCreated(t) {
                    let e = this.chart;
                    if (e.options.accessibility.enabled) {
                        this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
                        let i = t.tree.attributes || {};
                        i.tabindex = -1, i.summary = e.langFormat("accessibility.table.tableSummary", {
                            chart: e
                        }), t.tree.attributes = i;
                    }
                }
                focusDataTable() {
                    let t = this.dataTableDiv, e = t && t.getElementsByTagName("table")[0];
                    e && e.focus && e.focus();
                }
                initSonifyButton(t) {
                    let e = this.sonifyButton = y(t), i = this.chart, n = (t)=>{
                        e && (e.setAttribute("aria-hidden", "true"), e.setAttribute("aria-label", "")), t.preventDefault(), t.stopPropagation();
                        let n = i.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", {
                            chart: i
                        });
                        this.announcer.announce(n), setTimeout(()=>{
                            e && (e.removeAttribute("aria-hidden"), e.removeAttribute("aria-label")), i.sonify && i.sonify();
                        }, 1e3);
                    };
                    e && i && (e.setAttribute("tabindex", -1), e.onclick = function(t) {
                        (i.options.accessibility && i.options.accessibility.screenReaderSection.onPlayAsSoundClick || n).call(this, t, i);
                    });
                }
                initDataTableButton(t) {
                    let e = this.viewDataTableButton = y(t), i = this.chart, n = t.replace("hc-linkto-", "");
                    e && (C(e, {
                        tabindex: -1,
                        "aria-expanded": !!y(n)
                    }), e.onclick = i.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
                        i.viewData();
                    });
                }
                getAxesDescription() {
                    let t = this.chart, e = function(e, i) {
                        let n = t[e];
                        return n.length > 1 || n[0] && S(n[0].options.accessibility && n[0].options.accessibility.enabled, i);
                    }, i = !!t.types && 0 > t.types.indexOf("map") && 0 > t.types.indexOf("treemap") && 0 > t.types.indexOf("tilemap"), n = !!t.hasCartesianSeries, r = e("xAxis", !t.angular && n && i), o = e("yAxis", n && i), s = {};
                    return r && (s.xAxis = this.getAxisDescriptionText("xAxis")), o && (s.yAxis = this.getAxisDescriptionText("yAxis")), s;
                }
                getAxisDescriptionText(t) {
                    let e = this.chart, i = e[t];
                    return e.langFormat("accessibility.axis." + t + "Description" + (i.length > 1 ? "Plural" : "Singular"), {
                        chart: e,
                        names: i.map(function(t) {
                            return d(t);
                        }),
                        ranges: i.map(function(t) {
                            return u(t);
                        }),
                        numAxes: i.length
                    });
                }
                destroy() {
                    this.announcer && this.announcer.destroy();
                }
            };
        }), i(e, "Accessibility/Components/MenuComponent.js", [
            e["Core/Utilities.js"],
            e["Accessibility/AccessibilityComponent.js"],
            e["Accessibility/KeyboardNavigationHandler.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/Utils/HTMLUtilities.js"]
        ], function(t, e, i, n, r) {
            let { attr: o } = t, { getChartTitle: s, unhideChartElementFromAT: a } = n, { getFakeMouseEvent: l } = r;
            function h(t) {
                return t.exportSVGElements && t.exportSVGElements[0];
            }
            class c extends e {
                init() {
                    let t = this.chart, e = this;
                    this.addEvent(t, "exportMenuShown", function() {
                        e.onMenuShown();
                    }), this.addEvent(t, "exportMenuHidden", function() {
                        e.onMenuHidden();
                    }), this.createProxyGroup();
                }
                onMenuHidden() {
                    let t = this.chart.exportContextMenu;
                    t && t.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
                }
                onMenuShown() {
                    let t = this.chart, e = t.exportContextMenu;
                    e && (this.addAccessibleContextMenuAttribs(), a(t, e)), this.setExportButtonExpandedState("true");
                }
                setExportButtonExpandedState(t) {
                    this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", t);
                }
                onChartRender() {
                    let t = this.chart, e = t.focusElement, i = t.accessibility;
                    this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && e && e === t.exportingGroup && (e.focusBorder ? t.setFocusToElement(e, this.exportButtonProxy.innerElement) : i && i.keyboardNavigation.tabindexContainer.focus());
                }
                proxyMenuButton() {
                    let t = this.chart, e = this.proxyProvider, i = h(t);
                    (function(t) {
                        let e = t.options.exporting, i = h(t);
                        return !!(e && !1 !== e.enabled && e.accessibility && e.accessibility.enabled && i && i.element);
                    })(t) && i && (this.exportButtonProxy = e.addProxyElement("chartMenu", {
                        click: i
                    }, "button", {
                        "aria-label": t.langFormat("accessibility.exporting.menuButtonLabel", {
                            chart: t,
                            chartTitle: s(t)
                        }),
                        "aria-expanded": !1,
                        title: t.options.lang.contextButtonTitle || null
                    }));
                }
                createProxyGroup() {
                    this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
                }
                addAccessibleContextMenuAttribs() {
                    let t = this.chart, e = t.exportDivElements;
                    if (e && e.length) {
                        e.forEach((t)=>{
                            t && ("LI" !== t.tagName || t.children && t.children.length ? t.setAttribute("aria-hidden", "true") : t.setAttribute("tabindex", -1));
                        });
                        let i = e[0] && e[0].parentNode;
                        i && o(i, {
                            "aria-hidden": void 0,
                            "aria-label": t.langFormat("accessibility.exporting.chartMenuLabel", {
                                chart: t
                            }),
                            role: "list"
                        });
                    }
                }
                getKeyboardNavigation() {
                    let t = this.keyCodes, e = this.chart, n = this;
                    return new i(e, {
                        keyCodeMap: [
                            [
                                [
                                    t.left,
                                    t.up
                                ],
                                function() {
                                    return n.onKbdPrevious(this);
                                }
                            ],
                            [
                                [
                                    t.right,
                                    t.down
                                ],
                                function() {
                                    return n.onKbdNext(this);
                                }
                            ],
                            [
                                [
                                    t.enter,
                                    t.space
                                ],
                                function() {
                                    return n.onKbdClick(this);
                                }
                            ]
                        ],
                        validate: function() {
                            return !!e.exporting && !1 !== e.options.exporting.enabled && !1 !== e.options.exporting.accessibility.enabled;
                        },
                        init: function() {
                            let t = n.exportButtonProxy, i = n.chart.exportingGroup;
                            t && i && e.setFocusToElement(i, t.innerElement);
                        },
                        terminate: function() {
                            e.hideExportMenu();
                        }
                    });
                }
                onKbdPrevious(t) {
                    let e = this.chart, i = e.options.accessibility, n = t.response, r = e.highlightedExportItemIx || 0;
                    for(; r--;)if (e.highlightExportItem(r)) return n.success;
                    return i.keyboardNavigation.wrapAround ? (e.highlightLastExportItem(), n.success) : n.prev;
                }
                onKbdNext(t) {
                    let e = this.chart, i = e.options.accessibility, n = t.response;
                    for(let t = (e.highlightedExportItemIx || 0) + 1; t < e.exportDivElements.length; ++t)if (e.highlightExportItem(t)) return n.success;
                    return i.keyboardNavigation.wrapAround ? (e.highlightExportItem(0), n.success) : n.next;
                }
                onKbdClick(t) {
                    let e = this.chart, i = e.exportDivElements[e.highlightedExportItemIx], n = h(e).element;
                    return e.openMenu ? this.fakeClickEvent(i) : (this.fakeClickEvent(n), e.highlightExportItem(0)), t.response.success;
                }
            }
            return function(t) {
                function e() {
                    let t = h(this);
                    if (t) {
                        let e = t.element;
                        e.onclick && e.onclick(l("click"));
                    }
                }
                function i() {
                    let t = this.exportDivElements;
                    t && this.exportContextMenu && this.openMenu && (t.forEach((t)=>{
                        t && "highcharts-menu-item" === t.className && t.onmouseout && t.onmouseout(l("mouseout"));
                    }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
                }
                function n(t) {
                    let e = this.exportDivElements && this.exportDivElements[t], i = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
                    if (e && "LI" === e.tagName && (!e.children || !e.children.length)) {
                        let n = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
                        return e.focus && n && e.focus(), i && i.onmouseout && i.onmouseout(l("mouseout")), e.onmouseover && e.onmouseover(l("mouseover")), this.highlightedExportItemIx = t, !0;
                    }
                    return !1;
                }
                function r() {
                    if (this.exportDivElements) {
                        let t = this.exportDivElements.length;
                        for(; t--;)if (this.highlightExportItem(t)) return !0;
                    }
                    return !1;
                }
                t.compose = function(t) {
                    let o = t.prototype;
                    o.hideExportMenu || (o.hideExportMenu = i, o.highlightExportItem = n, o.highlightLastExportItem = r, o.showExportMenu = e);
                };
            }(c || (c = {})), c;
        }), i(e, "Accessibility/KeyboardNavigation.js", [
            e["Core/Globals.js"],
            e["Accessibility/Components/MenuComponent.js"],
            e["Core/Utilities.js"],
            e["Accessibility/Utils/EventProvider.js"],
            e["Accessibility/Utils/HTMLUtilities.js"]
        ], function(t, e, i, n, r) {
            let { doc: o, win: s } = t, { addEvent: a, defined: l, fireEvent: h } = i, { getElement: c, simulatedEventTarget: d } = r;
            class u {
                constructor(t, e){
                    this.currentModuleIx = NaN, this.modules = [], this.init(t, e);
                }
                init(t, e) {
                    let i = this.eventProvider = new n;
                    this.chart = t, this.components = e, this.modules = [], this.currentModuleIx = 0, this.update(), i.addEvent(this.tabindexContainer, "keydown", (t)=>this.onKeydown(t)), i.addEvent(this.tabindexContainer, "focus", (t)=>this.onFocus(t)), [
                        "mouseup",
                        "touchend"
                    ].forEach((t)=>i.addEvent(o, t, (t)=>this.onMouseUp(t))), [
                        "mousedown",
                        "touchstart"
                    ].forEach((e)=>i.addEvent(t.renderTo, e, ()=>{
                            this.isClickingChart = !0;
                        }));
                }
                update(t) {
                    let e = this.chart.options.accessibility, i = e && e.keyboardNavigation, n = this.components;
                    this.updateContainerTabindex(), i && i.enabled && t && t.length ? (this.modules = t.reduce(function(t, e) {
                        let i = n[e].getKeyboardNavigation();
                        return t.concat(i);
                    }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
                }
                updateExitAnchor() {
                    let t = c(`highcharts-end-of-chart-marker-${this.chart.index}`);
                    this.removeExitAnchor(), t ? (this.makeElementAnExitAnchor(t), this.exitAnchor = t) : this.createExitAnchor();
                }
                move(t) {
                    let e = this.modules && this.modules[this.currentModuleIx];
                    e && e.terminate && e.terminate(t), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += t;
                    let i = this.modules && this.modules[this.currentModuleIx];
                    if (i) {
                        if (i.validate && !i.validate()) return this.move(t);
                        if (i.init) return i.init(t), !0;
                    }
                    return this.currentModuleIx = 0, this.exiting = !0, t > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
                }
                onFocus(t) {
                    let e = this.chart, i = t.relatedTarget && e.container.contains(t.relatedTarget), n = e.options.accessibility, r = n && n.keyboardNavigation;
                    if (r && r.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !i) {
                        let t = this.getFirstValidModuleIx();
                        null !== t && (this.currentModuleIx = t, this.modules[t].init(1));
                    }
                    this.keyboardReset = !1, this.exiting = !1;
                }
                onMouseUp(t) {
                    if (delete this.isClickingChart, !this.keyboardReset && t.relatedTarget !== d) {
                        let e = this.chart;
                        if (!t.target || !e.container.contains(t.target)) {
                            let t = this.modules && this.modules[this.currentModuleIx || 0];
                            t && t.terminate && t.terminate(), this.currentModuleIx = 0;
                        }
                        e.focusElement && (e.focusElement.removeFocusBorder(), delete e.focusElement), this.keyboardReset = !0;
                    }
                }
                onKeydown(t) {
                    let e, i = t || s.event, n = this.modules && this.modules.length && this.modules[this.currentModuleIx], r = i.target;
                    if ((!r || "INPUT" !== r.nodeName || r.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = !1, this.exiting = !1, n)) {
                        let t = n.run(i);
                        t === n.response.success ? e = !0 : t === n.response.prev ? e = this.move(-1) : t === n.response.next && (e = this.move(1)), e && (i.preventDefault(), i.stopPropagation());
                    }
                }
                updateContainerTabindex() {
                    let t, e = this.chart.options.accessibility, i = e && e.keyboardNavigation, n = !(i && !1 === i.enabled), r = this.chart, o = r.container;
                    r.renderTo.hasAttribute("tabindex") ? (o.removeAttribute("tabindex"), t = r.renderTo) : t = o, this.tabindexContainer = t;
                    let s = t.getAttribute("tabindex");
                    n && !s ? t.setAttribute("tabindex", "0") : n || r.container.removeAttribute("tabindex");
                }
                createExitAnchor() {
                    let t = this.chart, e = this.exitAnchor = o.createElement("div");
                    t.renderTo.appendChild(e), this.makeElementAnExitAnchor(e);
                }
                makeElementAnExitAnchor(t) {
                    let e = this.tabindexContainer.getAttribute("tabindex") || 0;
                    t.setAttribute("class", "highcharts-exit-anchor"), t.setAttribute("tabindex", e), t.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(t);
                }
                removeExitAnchor() {
                    if (this.exitAnchor) {
                        let t = this.eventProvider.eventRemovers.find((t)=>t.element === this.exitAnchor);
                        t && l(t.remover) && this.eventProvider.removeEvent(t.remover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor;
                    }
                }
                addExitAnchorEventsToEl(t) {
                    let e = this.chart, i = this;
                    this.eventProvider.addEvent(t, "focus", function(t) {
                        let n = t || s.event, r = !(n.relatedTarget && e.container.contains(n.relatedTarget) || i.exiting);
                        if (e.focusElement && delete e.focusElement, r) {
                            if (i.tabbingInBackwards = !0, i.tabindexContainer.focus(), delete i.tabbingInBackwards, n.preventDefault(), i.modules && i.modules.length) {
                                i.currentModuleIx = i.modules.length - 1;
                                let t = i.modules[i.currentModuleIx];
                                t && t.validate && !t.validate() ? i.move(-1) : t && t.init(-1);
                            }
                        } else i.exiting = !1;
                    });
                }
                getFirstValidModuleIx() {
                    let t = this.modules.length;
                    for(let e = 0; e < t; ++e){
                        let t = this.modules[e];
                        if (!t.validate || t.validate()) return e;
                    }
                    return null;
                }
                destroy() {
                    this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
                }
            }
            return function(i) {
                function n() {
                    let t = this;
                    h(this, "dismissPopupContent", {}, function() {
                        t.tooltip && t.tooltip.hide(0), t.hideExportMenu();
                    });
                }
                function r(e) {
                    27 === (e.which || e.keyCode) && t.charts && t.charts.forEach((t)=>{
                        t && t.dismissPopupContent && t.dismissPopupContent();
                    });
                }
                i.compose = function(t) {
                    e.compose(t);
                    let i = t.prototype;
                    return i.dismissPopupContent || (i.dismissPopupContent = n, a(o, "keydown", r)), t;
                };
            }(u || (u = {})), u;
        }), i(e, "Accessibility/Components/LegendComponent.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Globals.js"],
            e["Core/Legend/Legend.js"],
            e["Core/Utilities.js"],
            e["Accessibility/AccessibilityComponent.js"],
            e["Accessibility/KeyboardNavigationHandler.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/Utils/HTMLUtilities.js"]
        ], function(t, e, i, n, r, o, s, a) {
            let { animObject: l } = t, { doc: h } = e, { addEvent: c, fireEvent: d, isNumber: u, pick: p, syncTimeout: f } = n, { getChartTitle: g } = s, { stripHTMLTagsFromString: m, addClass: b, removeClass: y } = a;
            function x(t) {
                let e = t.legend && t.legend.allItems, i = t.options.legend.accessibility || {}, n = t.colorAxis && t.colorAxis.some((t)=>!t.dataClasses || !t.dataClasses.length);
                return !(!e || !e.length || n || !1 === i.enabled);
            }
            function v(t, e) {
                let i = e.legendItem || {};
                for (let n of (e.setState(t ? "hover" : "", !0), [
                    "group",
                    "label",
                    "symbol"
                ])){
                    let e = i[n], r = e && e.element || e;
                    r && d(r, t ? "mouseover" : "mouseout");
                }
            }
            class w extends r {
                constructor(){
                    super(...arguments), this.highlightedLegendItemIx = NaN, this.proxyGroup = null;
                }
                init() {
                    let t = this;
                    this.recreateProxies(), this.addEvent(i, "afterScroll", function() {
                        this.chart === t.chart && (t.proxyProvider.updateGroupProxyElementPositions("legend"), t.updateLegendItemProxyVisibility(), t.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(t.highlightedLegendItemIx));
                    }), this.addEvent(i, "afterPositionItem", function(e) {
                        this.chart === t.chart && this.chart.renderer && t.updateProxyPositionForItem(e.item);
                    }), this.addEvent(i, "afterRender", function() {
                        this.chart === t.chart && this.chart.renderer && t.recreateProxies() && f(()=>t.proxyProvider.updateGroupProxyElementPositions("legend"), l(p(this.chart.renderer.globalAnimation, !0)).duration);
                    });
                }
                updateLegendItemProxyVisibility() {
                    let t, e = this.chart, i = e.legend, n = i.allItems || [], r = i.currentPage || 1, o = i.clipHeight || 0;
                    n.forEach((n)=>{
                        if (n.a11yProxyElement) {
                            let s = i.pages && i.pages.length, a = n.a11yProxyElement.element, l = !1;
                            if (t = n.legendItem || {}, s) {
                                let e = t.pageIx || 0;
                                l = (t.y || 0) + (t.label ? Math.round(t.label.getBBox().height) : 0) - i.pages[e] > o || e !== r - 1;
                            }
                            l ? e.styledMode ? b(a, "highcharts-a11y-invisible") : a.style.visibility = "hidden" : (y(a, "highcharts-a11y-invisible"), a.style.visibility = "");
                        }
                    });
                }
                onChartRender() {
                    x(this.chart) || this.removeProxies();
                }
                highlightAdjacentLegendPage(t) {
                    let e = this.chart, i = e.legend, n = (i.currentPage || 1) + t, r = i.pages || [];
                    if (n > 0 && n <= r.length) {
                        let t = 0;
                        for (let r of i.allItems)((r.legendItem || {}).pageIx || 0) + 1 === n && e.highlightLegendItem(t) && (this.highlightedLegendItemIx = t), ++t;
                    }
                }
                updateProxyPositionForItem(t) {
                    t.a11yProxyElement && t.a11yProxyElement.refreshPosition();
                }
                recreateProxies() {
                    let t = h.activeElement, e = this.proxyGroup, i = t && e && e.contains(t);
                    return this.removeProxies(), !!x(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), i && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
                }
                removeProxies() {
                    this.proxyProvider.removeGroup("legend");
                }
                updateLegendTitle() {
                    let t = this.chart, e = m((t.legend && t.legend.options.title && t.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), t.renderer.forExport), i = t.langFormat("accessibility.legend.legendLabel" + (e ? "" : "NoTitle"), {
                        chart: t,
                        legendTitle: e,
                        chartTitle: g(t)
                    });
                    this.proxyProvider.updateGroupAttrs("legend", {
                        "aria-label": i
                    });
                }
                addLegendProxyGroup() {
                    let t = "all" === this.chart.options.accessibility.landmarkVerbosity ? "region" : null;
                    this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", {
                        "aria-label": "_placeholder_",
                        role: t
                    });
                }
                proxyLegendItems() {
                    let t, e = this;
                    ((this.chart.legend || {}).allItems || []).forEach((i)=>{
                        (t = i.legendItem || {}).label && t.label.element && e.proxyLegendItem(i);
                    });
                }
                proxyLegendItem(t) {
                    let e = t.legendItem || {};
                    if (!e.label || !e.group) return;
                    let i = this.chart.langFormat("accessibility.legend.legendItem", {
                        chart: this.chart,
                        itemName: m(t.name, this.chart.renderer.forExport),
                        item: t
                    }), n = {
                        tabindex: -1,
                        "aria-pressed": t.visible,
                        "aria-label": i
                    }, r = e.group.div ? e.label : e.group;
                    t.a11yProxyElement = this.proxyProvider.addProxyElement("legend", {
                        click: e.label,
                        visual: r.element
                    }, "button", n);
                }
                getKeyboardNavigation() {
                    let t = this.keyCodes, e = this, i = this.chart;
                    return new o(i, {
                        keyCodeMap: [
                            [
                                [
                                    t.left,
                                    t.right,
                                    t.up,
                                    t.down
                                ],
                                function(t) {
                                    return e.onKbdArrowKey(this, t);
                                }
                            ],
                            [
                                [
                                    t.enter,
                                    t.space
                                ],
                                function() {
                                    return e.onKbdClick(this);
                                }
                            ],
                            [
                                [
                                    t.pageDown,
                                    t.pageUp
                                ],
                                function(i) {
                                    let n = i === t.pageDown ? 1 : -1;
                                    return e.highlightAdjacentLegendPage(n), this.response.success;
                                }
                            ]
                        ],
                        validate: function() {
                            return e.shouldHaveLegendNavigation();
                        },
                        init: function() {
                            i.highlightLegendItem(0), e.highlightedLegendItemIx = 0;
                        },
                        terminate: function() {
                            e.highlightedLegendItemIx = -1, i.legend.allItems.forEach((t)=>v(!1, t));
                        }
                    });
                }
                onKbdArrowKey(t, e) {
                    let { keyCodes: { left: i, up: n }, highlightedLegendItemIx: r, chart: o } = this, s = o.legend.allItems.length, a = o.options.accessibility.keyboardNavigation.wrapAround, l = e === i || e === n ? -1 : 1;
                    return o.highlightLegendItem(r + l) ? this.highlightedLegendItemIx += l : a && s > 1 && (this.highlightedLegendItemIx = l > 0 ? 0 : s - 1, o.highlightLegendItem(this.highlightedLegendItemIx)), t.response.success;
                }
                onKbdClick(t) {
                    let e = this.chart.legend.allItems[this.highlightedLegendItemIx];
                    return e && e.a11yProxyElement && e.a11yProxyElement.click(), t.response.success;
                }
                shouldHaveLegendNavigation() {
                    if (!x(this.chart)) return !1;
                    let t = this.chart, e = (t.options.legend || {}).accessibility || {};
                    return !!(t.legend.display && e.keyboardNavigation && e.keyboardNavigation.enabled);
                }
                destroy() {
                    this.removeProxies();
                }
            }
            return function(t) {
                function e(t) {
                    let e = this.legend.allItems, i = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, n = e[t], r = n?.legendItem || {};
                    if (n) {
                        u(i) && e[i] && v(!1, e[i]), function(t, e) {
                            let i = (t.allItems[e].legendItem || {}).pageIx, n = t.currentPage;
                            void 0 !== i && i + 1 !== n && t.scroll(1 + i - n);
                        }(this.legend, t);
                        let o = r.label, s = n.a11yProxyElement && n.a11yProxyElement.innerElement;
                        return o && o.element && s && this.setFocusToElement(o, s), v(!0, n), !0;
                    }
                    return !1;
                }
                function i(t) {
                    let e = this.chart.options.accessibility, i = t.item;
                    e.enabled && i && i.a11yProxyElement && i.a11yProxyElement.innerElement.setAttribute("aria-pressed", t.visible ? "true" : "false");
                }
                t.compose = function(t, n) {
                    let r = t.prototype;
                    r.highlightLegendItem || (r.highlightLegendItem = e, c(n, "afterColorizeItem", i));
                };
            }(w || (w = {})), w;
        }), i(e, "Stock/Navigator/ChartNavigatorComposition.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let i, { isTouchDevice: n } = t, { addEvent: r, merge: o, pick: s } = e, a = [];
            function l() {
                this.navigator && this.navigator.setBaseSeries(null, !1);
            }
            function h() {
                let t, e, i, n = this.legend, r = this.navigator;
                if (r) {
                    t = n && n.options, e = r.xAxis, i = r.yAxis;
                    let { scrollbarHeight: o, scrollButtonSize: a } = r;
                    this.inverted ? (r.left = r.opposite ? this.chartWidth - o - r.height : this.spacing[3] + o, r.top = this.plotTop + a) : (r.left = s(e.left, this.plotLeft + a), r.top = r.navigatorOptions.top || this.chartHeight - r.height - o - (this.scrollbar?.options.margin || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (t && "bottom" === t.verticalAlign && "proximate" !== t.layout && t.enabled && !t.floating ? n.legendHeight + s(t.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), e && i && (this.inverted ? e.options.left = i.options.left = r.left : e.options.top = i.options.top = r.top, e.setAxisSize(), i.setAxisSize());
                }
            }
            function c(t) {
                !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new i(this), s(t.redraw, !0) && this.redraw(t.animation));
            }
            function d() {
                let t = this.options;
                (t.navigator.enabled || t.scrollbar.enabled) && (this.scroller = this.navigator = new i(this));
            }
            function u() {
                let t = this.options, e = t.navigator, i = t.rangeSelector;
                if ((e && e.enabled || i && i.enabled) && (!n && "x" === this.zooming.type || n && "x" === this.zooming.pinchType)) return !1;
            }
            function p(t) {
                let e = t.navigator;
                if (e && t.xAxis[0]) {
                    let i = t.xAxis[0].getExtremes();
                    e.render(i.min, i.max);
                }
            }
            function f(t) {
                let e = t.options.navigator || {}, i = t.options.scrollbar || {};
                !this.navigator && !this.scroller && (e.enabled || i.enabled) && (o(!0, this.options.navigator, e), o(!0, this.options.scrollbar, i), delete t.options.navigator, delete t.options.scrollbar);
            }
            return {
                compose: function(t, n) {
                    if (e.pushUnique(a, t)) {
                        let e = t.prototype;
                        i = n, e.callbacks.push(p), r(t, "afterAddSeries", l), r(t, "afterSetChartSize", h), r(t, "afterUpdate", c), r(t, "beforeRender", d), r(t, "beforeShowResetZoom", u), r(t, "update", f);
                    }
                }
            };
        }), i(e, "Core/Axis/NavigatorAxisComposition.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { isTouchDevice: i } = t, { addEvent: n, correctFloat: r, defined: o, isNumber: s, pick: a } = e;
            function l() {
                this.navigatorAxis || (this.navigatorAxis = new c(this));
            }
            function h(t) {
                let e, n = this.chart, r = n.options, s = r.navigator, a = this.navigatorAxis, l = n.zooming.pinchType, h = r.rangeSelector, c = n.zooming.type;
                if (this.isXAxis && (s?.enabled || h?.enabled)) {
                    if ("y" === c && "zoom" === t.trigger) e = !1;
                    else if (("zoom" === t.trigger && "xy" === c || i && "xy" === l) && this.options.range) {
                        let e = a.previousZoom;
                        o(t.min) ? a.previousZoom = [
                            this.min,
                            this.max
                        ] : e && (t.min = e[0], t.max = e[1], a.previousZoom = void 0);
                    }
                }
                void 0 !== e && t.preventDefault();
            }
            class c {
                static compose(t) {
                    t.keepProps.includes("navigatorAxis") || (t.keepProps.push("navigatorAxis"), n(t, "init", l), n(t, "setExtremes", h));
                }
                constructor(t){
                    this.axis = t;
                }
                destroy() {
                    this.axis = void 0;
                }
                toFixedRange(t, e, i, n) {
                    let l = this.axis, h = (l.pointRange || 0) / 2, c = a(i, l.translate(t, !0, !l.horiz)), d = a(n, l.translate(e, !0, !l.horiz));
                    return o(i) || (c = r(c + h)), o(n) || (d = r(d - h)), s(c) && s(d) || (c = d = void 0), {
                        min: c,
                        max: d
                    };
                }
            }
            return c;
        }), i(e, "Stock/Navigator/NavigatorDefaults.js", [
            e["Core/Color/Color.js"],
            e["Core/Series/SeriesRegistry.js"]
        ], function(t, e) {
            let { parse: i } = t, { seriesTypes: n } = e;
            return {
                height: 40,
                margin: 25,
                maskInside: !0,
                handles: {
                    width: 7,
                    borderRadius: 0,
                    height: 15,
                    symbols: [
                        "navigator-handle",
                        "navigator-handle"
                    ],
                    enabled: !0,
                    lineWidth: 1,
                    backgroundColor: "#f2f2f2",
                    borderColor: "#999999"
                },
                maskFill: i("#667aff").setOpacity(.3).get(),
                outlineColor: "#999999",
                outlineWidth: 1,
                series: {
                    type: void 0 === n.areaspline ? "line" : "areaspline",
                    fillOpacity: .05,
                    lineWidth: 1,
                    compare: null,
                    sonification: {
                        enabled: !1
                    },
                    dataGrouping: {
                        approximation: "average",
                        enabled: !0,
                        groupPixelWidth: 2,
                        firstAnchor: "firstPoint",
                        anchor: "middle",
                        lastAnchor: "lastPoint",
                        units: [
                            [
                                "millisecond",
                                [
                                    1,
                                    2,
                                    5,
                                    10,
                                    20,
                                    25,
                                    50,
                                    100,
                                    200,
                                    500
                                ]
                            ],
                            [
                                "second",
                                [
                                    1,
                                    2,
                                    5,
                                    10,
                                    15,
                                    30
                                ]
                            ],
                            [
                                "minute",
                                [
                                    1,
                                    2,
                                    5,
                                    10,
                                    15,
                                    30
                                ]
                            ],
                            [
                                "hour",
                                [
                                    1,
                                    2,
                                    3,
                                    4,
                                    6,
                                    8,
                                    12
                                ]
                            ],
                            [
                                "day",
                                [
                                    1,
                                    2,
                                    3,
                                    4
                                ]
                            ],
                            [
                                "week",
                                [
                                    1,
                                    2,
                                    3
                                ]
                            ],
                            [
                                "month",
                                [
                                    1,
                                    3,
                                    6
                                ]
                            ],
                            [
                                "year",
                                null
                            ]
                        ]
                    },
                    dataLabels: {
                        enabled: !1,
                        zIndex: 2
                    },
                    id: "highcharts-navigator-series",
                    className: "highcharts-navigator-series",
                    lineColor: null,
                    marker: {
                        enabled: !1
                    },
                    threshold: null
                },
                xAxis: {
                    className: "highcharts-navigator-xaxis",
                    tickLength: 0,
                    lineWidth: 0,
                    gridLineColor: "#e6e6e6",
                    id: "navigator-x-axis",
                    gridLineWidth: 1,
                    tickPixelInterval: 200,
                    labels: {
                        align: "left",
                        style: {
                            color: "#000000",
                            fontSize: "0.7em",
                            opacity: .6,
                            textOutline: "2px contrast"
                        },
                        x: 3,
                        y: -4
                    },
                    crosshair: !1
                },
                yAxis: {
                    className: "highcharts-navigator-yaxis",
                    gridLineWidth: 0,
                    startOnTick: !1,
                    endOnTick: !1,
                    minPadding: .1,
                    id: "navigator-y-axis",
                    maxPadding: .1,
                    labels: {
                        enabled: !1
                    },
                    crosshair: !1,
                    title: {
                        text: null
                    },
                    tickLength: 0,
                    tickWidth: 0
                }
            };
        }), i(e, "Stock/Navigator/NavigatorSymbols.js", [
            e["Core/Renderer/SVG/Symbols.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { relativeLength: i } = e;
            return {
                "navigator-handle": function(e, n, r, o, s = {}) {
                    let a = s.width ? s.width / 2 : r, l = i(s.borderRadius || 0, Math.min(2 * a, o));
                    return [
                        [
                            "M",
                            -1.5,
                            (o = s.height || o) / 2 - 3.5
                        ],
                        [
                            "L",
                            -1.5,
                            o / 2 + 4.5
                        ],
                        [
                            "M",
                            .5,
                            o / 2 - 3.5
                        ],
                        [
                            "L",
                            .5,
                            o / 2 + 4.5
                        ],
                        ...t.rect(-a - 1, .5, 2 * a + 1, o, {
                            r: l
                        })
                    ];
                }
            };
        }), i(e, "Stock/Utilities/StockUtilities.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            let { defined: e } = t;
            return {
                setFixedRange: function(t) {
                    let i = this.xAxis[0];
                    e(i.dataMax) && e(i.dataMin) && t ? this.fixedRange = Math.min(t, i.dataMax - i.dataMin) : this.fixedRange = t;
                }
            };
        }), i(e, "Stock/Navigator/NavigatorComposition.js", [
            e["Core/Defaults.js"],
            e["Core/Globals.js"],
            e["Core/Axis/NavigatorAxisComposition.js"],
            e["Stock/Navigator/NavigatorDefaults.js"],
            e["Stock/Navigator/NavigatorSymbols.js"],
            e["Core/Renderer/RendererRegistry.js"],
            e["Stock/Utilities/StockUtilities.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a) {
            let { setOptions: l } = t, { composed: h } = e, { getRendererType: c } = o, { setFixedRange: d } = s, { addEvent: u, extend: p, pushUnique: f } = a;
            function g() {
                this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
            }
            return {
                compose: function(t, e, o) {
                    i.compose(e), f(h, "Navigator") && (t.prototype.setFixedRange = d, p(c().prototype.symbols, r), u(o, "afterUpdate", g), l({
                        navigator: n
                    }));
                }
            };
        }), i(e, "Core/Axis/ScrollbarAxis.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            var i;
            let { composed: n } = t, { addEvent: r, defined: o, pick: s, pushUnique: a } = e;
            return function(t) {
                let e;
                function i(t) {
                    let e = s(t.options && t.options.min, t.min), i = s(t.options && t.options.max, t.max);
                    return {
                        axisMin: e,
                        axisMax: i,
                        scrollMin: o(t.dataMin) ? Math.min(e, t.min, t.dataMin, s(t.threshold, 1 / 0)) : e,
                        scrollMax: o(t.dataMax) ? Math.max(i, t.max, t.dataMax, s(t.threshold, -1 / 0)) : i
                    };
                }
                function l() {
                    let t = this.scrollbar, e = t && !t.options.opposite, i = this.horiz ? 2 : e ? 3 : 1;
                    t && (this.chart.scrollbarsOffsets = [
                        0,
                        0
                    ], this.chart.axisOffset[i] += t.size + (t.options.margin || 0));
                }
                function h() {
                    let t = this;
                    t.options && t.options.scrollbar && t.options.scrollbar.enabled && (t.options.scrollbar.vertical = !t.horiz, t.options.startOnTick = t.options.endOnTick = !1, t.scrollbar = new e(t.chart.renderer, t.options.scrollbar, t.chart), r(t.scrollbar, "changed", function(e) {
                        let n, r, { axisMin: s, axisMax: a, scrollMin: l, scrollMax: h } = i(t), c = h - l;
                        if (o(s) && o(a)) {
                            if (t.horiz && !t.reversed || !t.horiz && t.reversed ? (n = l + c * this.to, r = l + c * this.from) : (n = l + c * (1 - this.from), r = l + c * (1 - this.to)), this.shouldUpdateExtremes(e.DOMType)) {
                                let i = "mousemove" !== e.DOMType && "touchmove" !== e.DOMType && void 0;
                                t.setExtremes(r, n, !0, i, e);
                            } else this.setRange(this.from, this.to);
                        }
                    }));
                }
                function c() {
                    let t, e, n, { scrollMin: r, scrollMax: s } = i(this), a = this.scrollbar, l = this.axisTitleMargin + (this.titleOffset || 0), h = this.chart.scrollbarsOffsets, c = this.options.margin || 0;
                    if (a && h) {
                        if (this.horiz) this.opposite || (h[1] += l), a.position(this.left, this.top + this.height + 2 + h[1] - (this.opposite ? c : 0), this.width, this.height), this.opposite || (h[1] += c), t = 1;
                        else {
                            let e;
                            this.opposite && (h[0] += l), e = a.options.opposite ? this.left + this.width + 2 + h[0] - (this.opposite ? 0 : c) : this.opposite ? 0 : c, a.position(e, this.top, this.width, this.height), this.opposite && (h[0] += c), t = 0;
                        }
                        if (h[t] += a.size + (a.options.margin || 0), isNaN(r) || isNaN(s) || !o(this.min) || !o(this.max) || this.dataMin === this.dataMax) a.setRange(0, 1);
                        else if (this.min === this.max) {
                            let t = this.pointRange / (this.dataMax + 1);
                            e = t * this.min, n = t * (this.max + 1), a.setRange(e, n);
                        } else e = (this.min - r) / (s - r), n = (this.max - r) / (s - r), this.horiz && !this.reversed || !this.horiz && this.reversed ? a.setRange(e, n) : a.setRange(1 - n, 1 - e);
                    }
                }
                t.compose = function(t, i) {
                    a(n, "Axis.Scrollbar") && (e = i, r(t, "afterGetOffset", l), r(t, "afterInit", h), r(t, "afterRender", c));
                };
            }(i || (i = {})), i;
        }), i(e, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
            return {
                height: 10,
                barBorderRadius: 5,
                buttonBorderRadius: 0,
                buttonsEnabled: !1,
                liveRedraw: void 0,
                margin: void 0,
                minWidth: 6,
                opposite: !0,
                step: .2,
                zIndex: 3,
                barBackgroundColor: "#cccccc",
                barBorderWidth: 0,
                barBorderColor: "#cccccc",
                buttonArrowColor: "#333333",
                buttonBackgroundColor: "#e6e6e6",
                buttonBorderColor: "#cccccc",
                buttonBorderWidth: 1,
                rifleColor: "none",
                trackBackgroundColor: "rgba(255, 255, 255, 0.001)",
                trackBorderColor: "#cccccc",
                trackBorderRadius: 5,
                trackBorderWidth: 1
            };
        }), i(e, "Stock/Scrollbar/Scrollbar.js", [
            e["Core/Defaults.js"],
            e["Core/Globals.js"],
            e["Core/Axis/ScrollbarAxis.js"],
            e["Stock/Scrollbar/ScrollbarDefaults.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { defaultOptions: o } = t, { addEvent: s, correctFloat: a, crisp: l, defined: h, destroyObjectProperties: c, fireEvent: d, merge: u, pick: p, removeEvent: f } = r;
            class g {
                static compose(t) {
                    i.compose(t, g);
                }
                static swapXY(t, e) {
                    return e && t.forEach((t)=>{
                        let e, i = t.length;
                        for(let n = 0; n < i; n += 2)"number" == typeof (e = t[n + 1]) && (t[n + 1] = t[n + 2], t[n + 2] = e);
                    }), t;
                }
                constructor(t, e, i){
                    this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(t, e, i);
                }
                addEvents() {
                    let t = this.options.inverted ? [
                        1,
                        0
                    ] : [
                        0,
                        1
                    ], e = this.scrollbarButtons, i = this.scrollbarGroup.element, n = this.track.element, r = this.mouseDownHandler.bind(this), o = this.mouseMoveHandler.bind(this), a = this.mouseUpHandler.bind(this), l = [
                        [
                            e[t[0]].element,
                            "click",
                            this.buttonToMinClick.bind(this)
                        ],
                        [
                            e[t[1]].element,
                            "click",
                            this.buttonToMaxClick.bind(this)
                        ],
                        [
                            n,
                            "click",
                            this.trackClick.bind(this)
                        ],
                        [
                            i,
                            "mousedown",
                            r
                        ],
                        [
                            i.ownerDocument,
                            "mousemove",
                            o
                        ],
                        [
                            i.ownerDocument,
                            "mouseup",
                            a
                        ],
                        [
                            i,
                            "touchstart",
                            r
                        ],
                        [
                            i.ownerDocument,
                            "touchmove",
                            o
                        ],
                        [
                            i.ownerDocument,
                            "touchend",
                            a
                        ]
                    ];
                    l.forEach(function(t) {
                        s.apply(null, t);
                    }), this._events = l;
                }
                buttonToMaxClick(t) {
                    let e = (this.to - this.from) * p(this.options.step, .2);
                    this.updatePosition(this.from + e, this.to + e), d(this, "changed", {
                        from: this.from,
                        to: this.to,
                        trigger: "scrollbar",
                        DOMEvent: t
                    });
                }
                buttonToMinClick(t) {
                    let e = a(this.to - this.from) * p(this.options.step, .2);
                    this.updatePosition(a(this.from - e), a(this.to - e)), d(this, "changed", {
                        from: this.from,
                        to: this.to,
                        trigger: "scrollbar",
                        DOMEvent: t
                    });
                }
                cursorToScrollbarPosition(t) {
                    let e = this.options, i = e.minWidth > this.calculatedWidth ? e.minWidth : 0;
                    return {
                        chartX: (t.chartX - this.x - this.xOffset) / (this.barWidth - i),
                        chartY: (t.chartY - this.y - this.yOffset) / (this.barWidth - i)
                    };
                }
                destroy() {
                    let t = this, e = t.chart.scroller;
                    t.removeEvents(), [
                        "track",
                        "scrollbarRifles",
                        "scrollbar",
                        "scrollbarGroup",
                        "group"
                    ].forEach(function(e) {
                        t[e] && t[e].destroy && (t[e] = t[e].destroy());
                    }), e && t === e.scrollbar && (e.scrollbar = null, c(e.scrollbarButtons));
                }
                drawScrollbarButton(t) {
                    let e = this.renderer, i = this.scrollbarButtons, n = this.options, r = this.size, o = e.g().add(this.group);
                    if (i.push(o), n.buttonsEnabled) {
                        let s = e.rect().addClass("highcharts-scrollbar-button").add(o);
                        this.chart.styledMode || s.attr({
                            stroke: n.buttonBorderColor,
                            "stroke-width": n.buttonBorderWidth,
                            fill: n.buttonBackgroundColor
                        }), s.attr(s.crisp({
                            x: -0.5,
                            y: -0.5,
                            width: r,
                            height: r,
                            r: n.buttonBorderRadius
                        }, s.strokeWidth()));
                        let a = e.path(g.swapXY([
                            [
                                "M",
                                r / 2 + (t ? -1 : 1),
                                r / 2 - 3
                            ],
                            [
                                "L",
                                r / 2 + (t ? -1 : 1),
                                r / 2 + 3
                            ],
                            [
                                "L",
                                r / 2 + (t ? 2 : -2),
                                r / 2
                            ]
                        ], n.vertical)).addClass("highcharts-scrollbar-arrow").add(i[t]);
                        this.chart.styledMode || a.attr({
                            fill: n.buttonArrowColor
                        });
                    }
                }
                init(t, e, i) {
                    this.scrollbarButtons = [], this.renderer = t, this.userOptions = e, this.options = u(n, o.scrollbar, e), this.options.margin = p(this.options.margin, 10), this.chart = i, this.size = p(this.options.size, this.options.height), e.enabled && (this.render(), this.addEvents());
                }
                mouseDownHandler(t) {
                    let e = this.chart.pointer?.normalize(t) || t, i = this.cursorToScrollbarPosition(e);
                    this.chartX = i.chartX, this.chartY = i.chartY, this.initPositions = [
                        this.from,
                        this.to
                    ], this.grabbedCenter = !0;
                }
                mouseMoveHandler(t) {
                    let e, i = this.chart.pointer?.normalize(t) || t, n = this.options.vertical ? "chartY" : "chartX", r = this.initPositions || [];
                    this.grabbedCenter && (!t.touches || 0 !== t.touches[0][n]) && (e = this.cursorToScrollbarPosition(i)[n] - this[n], this.hasDragged = !0, this.updatePosition(r[0] + e, r[1] + e), this.hasDragged && d(this, "changed", {
                        from: this.from,
                        to: this.to,
                        trigger: "scrollbar",
                        DOMType: t.type,
                        DOMEvent: t
                    }));
                }
                mouseUpHandler(t) {
                    this.hasDragged && d(this, "changed", {
                        from: this.from,
                        to: this.to,
                        trigger: "scrollbar",
                        DOMType: t.type,
                        DOMEvent: t
                    }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
                }
                position(t, e, i, n) {
                    let { buttonsEnabled: r, margin: o = 0, vertical: s } = this.options, a = this.rendered ? "animate" : "attr", l = n, h = 0;
                    this.group.show(), this.x = t, this.y = e + this.trackBorderWidth, this.width = i, this.height = n, this.xOffset = l, this.yOffset = h, s ? (this.width = this.yOffset = i = h = this.size, this.xOffset = l = 0, this.yOffset = h = r ? this.size : 0, this.barWidth = n - (r ? 2 * i : 0), this.x = t += o) : (this.height = n = this.size, this.xOffset = l = r ? this.size : 0, this.barWidth = i - (r ? 2 * n : 0), this.y = this.y + o), this.group[a]({
                        translateX: t,
                        translateY: this.y
                    }), this.track[a]({
                        width: i,
                        height: n
                    }), this.scrollbarButtons[1][a]({
                        translateX: s ? 0 : i - l,
                        translateY: s ? n - h : 0
                    });
                }
                removeEvents() {
                    this._events.forEach(function(t) {
                        f.apply(null, t);
                    }), this._events.length = 0;
                }
                render() {
                    let t = this.renderer, e = this.options, i = this.size, n = this.chart.styledMode, r = t.g("scrollbar").attr({
                        zIndex: e.zIndex
                    }).hide().add();
                    this.group = r, this.track = t.rect().addClass("highcharts-scrollbar-track").attr({
                        r: e.trackBorderRadius || 0,
                        height: i,
                        width: i
                    }).add(r), n || this.track.attr({
                        fill: e.trackBackgroundColor,
                        stroke: e.trackBorderColor,
                        "stroke-width": e.trackBorderWidth
                    });
                    let o = this.trackBorderWidth = this.track.strokeWidth();
                    this.track.attr({
                        x: -l(0, o),
                        y: -l(0, o)
                    }), this.scrollbarGroup = t.g().add(r), this.scrollbar = t.rect().addClass("highcharts-scrollbar-thumb").attr({
                        height: i - o,
                        width: i - o,
                        r: e.barBorderRadius || 0
                    }).add(this.scrollbarGroup), this.scrollbarRifles = t.path(g.swapXY([
                        [
                            "M",
                            -3,
                            i / 4
                        ],
                        [
                            "L",
                            -3,
                            2 * i / 3
                        ],
                        [
                            "M",
                            0,
                            i / 4
                        ],
                        [
                            "L",
                            0,
                            2 * i / 3
                        ],
                        [
                            "M",
                            3,
                            i / 4
                        ],
                        [
                            "L",
                            3,
                            2 * i / 3
                        ]
                    ], e.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), n || (this.scrollbar.attr({
                        fill: e.barBackgroundColor,
                        stroke: e.barBorderColor,
                        "stroke-width": e.barBorderWidth
                    }), this.scrollbarRifles.attr({
                        stroke: e.rifleColor,
                        "stroke-width": 1
                    })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-l(0, this.scrollbarStrokeWidth), -l(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
                }
                setRange(t, e) {
                    let i, n, r = this.options, o = r.vertical, s = r.minWidth, l = this.barWidth, c = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
                    if (!h(l)) return;
                    let d = l * Math.min(e, 1);
                    i = Math.ceil(l * (t = Math.max(t, 0))), this.calculatedWidth = n = a(d - i), n < s && (i = (l - s + n) * t, n = s);
                    let u = Math.floor(i + this.xOffset + this.yOffset), p = n / 2 - .5;
                    this.from = t, this.to = e, o ? (this.scrollbarGroup[c]({
                        translateY: u
                    }), this.scrollbar[c]({
                        height: n
                    }), this.scrollbarRifles[c]({
                        translateY: p
                    }), this.scrollbarTop = u, this.scrollbarLeft = 0) : (this.scrollbarGroup[c]({
                        translateX: u
                    }), this.scrollbar[c]({
                        width: n
                    }), this.scrollbarRifles[c]({
                        translateX: p
                    }), this.scrollbarLeft = u, this.scrollbarTop = 0), n <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), !1 === r.showFull && (t <= 0 && e >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
                }
                shouldUpdateExtremes(t) {
                    return p(this.options.liveRedraw, e.svg && !e.isTouchDevice && !this.chart.boosted) || "mouseup" === t || "touchend" === t || !h(t);
                }
                trackClick(t) {
                    let e = this.chart.pointer?.normalize(t) || t, i = this.to - this.from, n = this.y + this.scrollbarTop, r = this.x + this.scrollbarLeft;
                    this.options.vertical && e.chartY > n || !this.options.vertical && e.chartX > r ? this.updatePosition(this.from + i, this.to + i) : this.updatePosition(this.from - i, this.to - i), d(this, "changed", {
                        from: this.from,
                        to: this.to,
                        trigger: "scrollbar",
                        DOMEvent: t
                    });
                }
                update(t) {
                    this.destroy(), this.init(this.chart.renderer, u(!0, this.options, t), this.chart);
                }
                updatePosition(t, e) {
                    e > 1 && (t = a(1 - a(e - t)), e = 1), t < 0 && (e = a(e - t), t = 0), this.from = t, this.to = e;
                }
            }
            return g.defaultOptions = n, o.scrollbar = u(!0, g.defaultOptions, o.scrollbar), g;
        }), i(e, "Stock/Navigator/Navigator.js", [
            e["Core/Axis/Axis.js"],
            e["Stock/Navigator/ChartNavigatorComposition.js"],
            e["Core/Defaults.js"],
            e["Core/Globals.js"],
            e["Core/Axis/NavigatorAxisComposition.js"],
            e["Stock/Navigator/NavigatorComposition.js"],
            e["Stock/Scrollbar/Scrollbar.js"],
            e["Core/Renderer/SVG/SVGRenderer.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a, l) {
            let { defaultOptions: h } = i, { isTouchDevice: c } = n, { prototype: { symbols: d } } = a, { addEvent: u, clamp: p, correctFloat: f, defined: g, destroyObjectProperties: m, erase: b, extend: y, find: x, fireEvent: v, isArray: w, isNumber: C, merge: S, pick: k, removeEvent: A, splat: E } = l;
            function M(t, ...e) {
                let i = [].filter.call(e, C);
                if (i.length) return Math[t].apply(0, i);
            }
            class T {
                static compose(t, i, n) {
                    e.compose(t, T), o.compose(t, i, n);
                }
                constructor(t){
                    this.isDirty = !1, this.scrollbarHeight = 0, this.init(t);
                }
                drawHandle(t, e, i, n) {
                    let r = this.navigatorOptions.handles.height;
                    this.handles[e][n](i ? {
                        translateX: Math.round(this.left + this.height / 2),
                        translateY: Math.round(this.top + parseInt(t, 10) + .5 - r)
                    } : {
                        translateX: Math.round(this.left + parseInt(t, 10)),
                        translateY: Math.round(this.top + this.height / 2 - r / 2 - 1)
                    });
                }
                drawOutline(t, e, i, n) {
                    let r, o, s = this.navigatorOptions.maskInside, a = this.outline.strokeWidth(), l = a / 2, h = a % 2 / 2, c = this.scrollButtonSize, d = this.size, u = this.top, p = this.height, f = u - l, g = u + p, m = this.left;
                    i ? (r = u + e + h, o = [
                        [
                            "M",
                            m + p,
                            u - c - h
                        ],
                        [
                            "L",
                            m + p,
                            r
                        ],
                        [
                            "L",
                            m,
                            r
                        ],
                        [
                            "M",
                            m,
                            e = u + t + h
                        ],
                        [
                            "L",
                            m + p,
                            e
                        ],
                        [
                            "L",
                            m + p,
                            u + d + c
                        ]
                    ], s && o.push([
                        "M",
                        m + p,
                        r - l
                    ], [
                        "L",
                        m + p,
                        e + l
                    ])) : (m -= c, o = [
                        [
                            "M",
                            m,
                            f
                        ],
                        [
                            "L",
                            t += m + c - h,
                            f
                        ],
                        [
                            "L",
                            t,
                            g
                        ],
                        [
                            "M",
                            e += m + c - h,
                            g
                        ],
                        [
                            "L",
                            e,
                            f
                        ],
                        [
                            "L",
                            m + d + 2 * c,
                            f
                        ]
                    ], s && o.push([
                        "M",
                        t - l,
                        f
                    ], [
                        "L",
                        e + l,
                        f
                    ])), this.outline[n]({
                        d: o
                    });
                }
                drawMasks(t, e, i, n) {
                    let r, o, s, a, l = this.left, h = this.top, c = this.height;
                    i ? (s = [
                        l,
                        l,
                        l
                    ], a = [
                        h,
                        h + t,
                        h + e
                    ], o = [
                        c,
                        c,
                        c
                    ], r = [
                        t,
                        e - t,
                        this.size - e
                    ]) : (s = [
                        l,
                        l + t,
                        l + e
                    ], a = [
                        h,
                        h,
                        h
                    ], o = [
                        t,
                        e - t,
                        this.size - e
                    ], r = [
                        c,
                        c,
                        c
                    ]), this.shades.forEach((t, e)=>{
                        t[n]({
                            x: s[e],
                            y: a[e],
                            width: o[e],
                            height: r[e]
                        });
                    });
                }
                renderElements() {
                    let t = this, e = t.navigatorOptions, i = e.maskInside, n = t.chart, r = n.inverted, o = n.renderer, s = {
                        cursor: r ? "ns-resize" : "ew-resize"
                    }, a = t.navigatorGroup ?? (t.navigatorGroup = o.g("navigator").attr({
                        zIndex: 8,
                        visibility: "hidden"
                    }).add());
                    if ([
                        !i,
                        i,
                        !i
                    ].forEach((i, r)=>{
                        let l = t.shades[r] ?? (t.shades[r] = o.rect().addClass("highcharts-navigator-mask" + (1 === r ? "-inside" : "-outside")).add(a));
                        n.styledMode || (l.attr({
                            fill: i ? e.maskFill : "rgba(0,0,0,0)"
                        }), 1 === r && l.css(s));
                    }), t.outline || (t.outline = o.path().addClass("highcharts-navigator-outline").add(a)), n.styledMode || t.outline.attr({
                        "stroke-width": e.outlineWidth,
                        stroke: e.outlineColor
                    }), e.handles?.enabled) {
                        let i = e.handles, { height: r, width: l } = i;
                        [
                            0,
                            1
                        ].forEach((e)=>{
                            let h = i.symbols[e];
                            if (t.handles[e] && t.handles[e].symbolUrl === h) {
                                if (!t.handles[e].isImg && t.handles[e].symbolName !== h) {
                                    let i = d[h].call(d, -l / 2 - 1, 0, l, r);
                                    t.handles[e].attr({
                                        d: i
                                    }), t.handles[e].symbolName = h;
                                }
                            } else t.handles[e]?.destroy(), t.handles[e] = o.symbol(h, -l / 2 - 1, 0, l, r, i), t.handles[e].attr({
                                zIndex: 7 - e
                            }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + [
                                "left",
                                "right"
                            ][e]).add(a), t.addMouseEvents();
                            n.inverted && t.handles[e].attr({
                                rotation: 90,
                                rotationOriginX: Math.floor(-l / 2),
                                rotationOriginY: (r + l) / 2
                            }), n.styledMode || t.handles[e].attr({
                                fill: i.backgroundColor,
                                stroke: i.borderColor,
                                "stroke-width": i.lineWidth,
                                width: i.width,
                                height: i.height,
                                x: -l / 2 - 1,
                                y: 0
                            }).css(s);
                        });
                    }
                }
                update(t, e = !1) {
                    let i = this.chart, n = i.options.chart.inverted !== i.scrollbar?.options.vertical;
                    if (S(!0, i.options.navigator, t), this.navigatorOptions = i.options.navigator || {}, this.setOpposite(), g(t.enabled) || n) return this.destroy(), this.navigatorEnabled = t.enabled || this.navigatorEnabled, this.init(i);
                    if (this.navigatorEnabled && (this.isDirty = !0, !1 === t.adaptToUpdatedData && this.baseSeries.forEach((t)=>{
                        A(t, "updatedData", this.updatedDataHandler);
                    }, this), t.adaptToUpdatedData && this.baseSeries.forEach((t)=>{
                        t.eventsToUnbind.push(u(t, "updatedData", this.updatedDataHandler));
                    }, this), (t.series || t.baseSeries) && this.setBaseSeries(void 0, !1), t.height || t.xAxis || t.yAxis)) {
                        this.height = t.height ?? this.height;
                        let e = this.getXAxisOffsets();
                        this.xAxis.update({
                            ...t.xAxis,
                            offsets: e,
                            [i.inverted ? "width" : "height"]: this.height,
                            [i.inverted ? "height" : "width"]: void 0
                        }, !1), this.yAxis.update({
                            ...t.yAxis,
                            [i.inverted ? "width" : "height"]: this.height
                        }, !1);
                    }
                    e && i.redraw();
                }
                render(t, e, i, n) {
                    let r, o, s, a, l, h = this.chart, c = this.xAxis, d = c.pointRange || 0, u = c.navigatorAxis.fake ? h.xAxis[0] : c, m = this.navigatorEnabled, b = this.rendered, y = h.inverted, x = h.xAxis[0].minRange, w = h.xAxis[0].options.maxRange, S = this.scrollButtonSize, A = this.scrollbarHeight;
                    if (this.hasDragged && !g(i)) return;
                    if (this.isDirty && this.renderElements(), t = f(t - d / 2), e = f(e + d / 2), !C(t) || !C(e)) {
                        if (!b) return;
                        i = 0, n = k(c.width, u.width);
                    }
                    this.left = k(c.left, h.plotLeft + S + (y ? h.plotWidth : 0));
                    let E = this.size = a = k(c.len, (y ? h.plotHeight : h.plotWidth) - 2 * S);
                    r = y ? A : a + 2 * S, i = k(i, c.toPixels(t, !0)), n = k(n, c.toPixels(e, !0)), C(i) && Math.abs(i) !== 1 / 0 || (i = 0, n = r);
                    let M = c.toValue(i, !0), T = c.toValue(n, !0), P = Math.abs(f(T - M));
                    P < x ? this.grabbedLeft ? i = c.toPixels(T - x - d, !0) : this.grabbedRight && (n = c.toPixels(M + x + d, !0)) : g(w) && f(P - d) > w && (this.grabbedLeft ? i = c.toPixels(T - w - d, !0) : this.grabbedRight && (n = c.toPixels(M + w + d, !0))), this.zoomedMax = p(Math.max(i, n), 0, E), this.zoomedMin = p(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(i, n), 0, E), this.range = this.zoomedMax - this.zoomedMin, E = Math.round(this.zoomedMax);
                    let R = Math.round(this.zoomedMin);
                    m && (this.navigatorGroup.attr({
                        visibility: "inherit"
                    }), l = b && !this.hasDragged ? "animate" : "attr", this.drawMasks(R, E, y, l), this.drawOutline(R, E, y, l), this.navigatorOptions.handles.enabled && (this.drawHandle(R, 0, y, l), this.drawHandle(E, 1, y, l))), this.scrollbar && (y ? (s = this.top - S, o = this.left - A + (m || !u.opposite ? 0 : (u.titleOffset || 0) + u.axisTitleMargin), A = a + 2 * S) : (s = this.top + (m ? this.height : -A), o = this.left - S), this.scrollbar.position(o, s, r, A), this.scrollbar.setRange(this.zoomedMin / (a || 1), this.zoomedMax / (a || 1))), this.rendered = !0, this.isDirty = !1, v(this, "afterRender");
                }
                addMouseEvents() {
                    let t, e, i = this, n = i.chart, r = n.container, o = [];
                    i.mouseMoveHandler = t = function(t) {
                        i.onMouseMove(t);
                    }, i.mouseUpHandler = e = function(t) {
                        i.onMouseUp(t);
                    }, (o = i.getPartsEvents("mousedown")).push(u(n.renderTo, "mousemove", t), u(r.ownerDocument, "mouseup", e), u(n.renderTo, "touchmove", t), u(r.ownerDocument, "touchend", e)), o.concat(i.getPartsEvents("touchstart")), i.eventsToUnbind = o, i.series && i.series[0] && o.push(u(i.series[0].xAxis, "foundExtremes", function() {
                        n.navigator.modifyNavigatorAxisExtremes();
                    }));
                }
                getPartsEvents(t) {
                    let e = this, i = [];
                    return [
                        "shades",
                        "handles"
                    ].forEach(function(n) {
                        e[n].forEach(function(r, o) {
                            i.push(u(r.element, t, function(t) {
                                e[n + "Mousedown"](t, o);
                            }));
                        });
                    }), i;
                }
                shadesMousedown(t, e) {
                    t = this.chart.pointer?.normalize(t) || t;
                    let i, n, r, o, s = this.chart, a = this.xAxis, l = this.zoomedMin, h = this.size, c = this.range, d = this.left, u = t.chartX;
                    s.inverted && (u = t.chartY, d = this.top), 1 === e ? (this.grabbedCenter = u, this.fixedWidth = c, this.dragOffset = u - l) : (o = u - d - c / 2, 0 === e ? o = Math.max(0, o) : 2 === e && o + c >= h && (o = h - c, this.reversedExtremes ? (o -= c, n = this.getUnionExtremes().dataMin) : i = this.getUnionExtremes().dataMax), o !== l && (this.fixedWidth = c, g((r = a.navigatorAxis.toFixedRange(o, o + c, n, i)).min) && v(this, "setRange", {
                        min: Math.min(r.min, r.max),
                        max: Math.max(r.min, r.max),
                        redraw: !0,
                        eventArguments: {
                            trigger: "navigator"
                        }
                    })));
                }
                handlesMousedown(t, e) {
                    t = this.chart.pointer?.normalize(t) || t;
                    let i = this.chart, n = i.xAxis[0], r = this.reversedExtremes;
                    0 === e ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = r ? n.min : n.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = r ? n.max : n.min), i.setFixedRange(void 0);
                }
                onMouseMove(t) {
                    let e, i = this, n = i.chart, r = i.navigatorSize, o = i.range, s = i.dragOffset, a = n.inverted, l = i.left;
                    (!t.touches || 0 !== t.touches[0].pageX) && (e = (t = n.pointer?.normalize(t) || t).chartX, a && (l = i.top, e = t.chartY), i.grabbedLeft ? (i.hasDragged = !0, i.render(0, 0, e - l, i.otherHandlePos)) : i.grabbedRight ? (i.hasDragged = !0, i.render(0, 0, i.otherHandlePos, e - l)) : i.grabbedCenter && (i.hasDragged = !0, e < s ? e = s : e > r + s - o && (e = r + s - o), i.render(0, 0, e - s, e - s + o)), i.hasDragged && i.scrollbar && k(i.scrollbar.options.liveRedraw, !c && !this.chart.boosted) && (t.DOMType = t.type, setTimeout(function() {
                        i.onMouseUp(t);
                    }, 0)));
                }
                onMouseUp(t) {
                    let e, i, n, r, o, s, a = this.chart, l = this.xAxis, h = this.scrollbar, c = t.DOMEvent || t, d = a.inverted, u = this.rendered && !this.hasDragged ? "animate" : "attr";
                    (this.hasDragged && (!h || !h.hasDragged) || "scrollbar" === t.trigger) && (n = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? r = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (o = this.fixedExtreme), this.zoomedMax === this.size && (o = this.reversedExtremes ? n.dataMin : n.dataMax), 0 === this.zoomedMin && (r = this.reversedExtremes ? n.dataMax : n.dataMin), g((s = l.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, r, o)).min) && v(this, "setRange", {
                        min: Math.min(s.min, s.max),
                        max: Math.max(s.min, s.max),
                        redraw: !0,
                        animation: !this.hasDragged && null,
                        eventArguments: {
                            trigger: "navigator",
                            triggerOp: "navigator-drag",
                            DOMEvent: c
                        }
                    })), "mousemove" !== t.DOMType && "touchmove" !== t.DOMType && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && C(this.zoomedMin) && C(this.zoomedMax) && (i = Math.round(this.zoomedMin), e = Math.round(this.zoomedMax), this.shades && this.drawMasks(i, e, d, u), this.outline && this.drawOutline(i, e, d, u), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(i, 0, d, u), this.drawHandle(e, 1, d, u)));
                }
                removeEvents() {
                    this.eventsToUnbind && (this.eventsToUnbind.forEach(function(t) {
                        t();
                    }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
                }
                removeBaseSeriesEvents() {
                    let t = this.baseSeries || [];
                    this.navigatorEnabled && t[0] && (!1 !== this.navigatorOptions.adaptToUpdatedData && t.forEach(function(t) {
                        A(t, "updatedData", this.updatedDataHandler);
                    }, this), t[0].xAxis && A(t[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
                }
                getXAxisOffsets() {
                    return this.chart.inverted ? [
                        this.scrollButtonSize,
                        0,
                        -this.scrollButtonSize,
                        0
                    ] : [
                        0,
                        -this.scrollButtonSize,
                        0,
                        this.scrollButtonSize
                    ];
                }
                init(e) {
                    let i = e.options, n = i.navigator || {}, o = n.enabled, a = i.scrollbar || {}, l = a.enabled, h = o && n.height || 0, c = l && a.height || 0, d = a.buttonsEnabled && c || 0;
                    this.handles = [], this.shades = [], this.chart = e, this.setBaseSeries(), this.height = h, this.scrollbarHeight = c, this.scrollButtonSize = d, this.scrollbarEnabled = l, this.navigatorEnabled = o, this.navigatorOptions = n, this.scrollbarOptions = a, this.setOpposite();
                    let p = this, f = p.baseSeries, g = e.xAxis.length, m = e.yAxis.length, b = f && f[0] && f[0].xAxis || e.xAxis[0] || {
                        options: {}
                    };
                    if (e.isDirtyBox = !0, p.navigatorEnabled) {
                        let i = this.getXAxisOffsets();
                        p.xAxis = new t(e, S({
                            breaks: b.options.breaks,
                            ordinal: b.options.ordinal,
                            overscroll: b.options.overscroll
                        }, n.xAxis, {
                            type: "datetime",
                            yAxis: n.yAxis?.id,
                            index: g,
                            isInternal: !0,
                            offset: 0,
                            keepOrdinalPadding: !0,
                            startOnTick: !1,
                            endOnTick: !1,
                            minPadding: b.options.ordinal ? 0 : b.options.minPadding,
                            maxPadding: b.options.ordinal ? 0 : b.options.maxPadding,
                            zoomEnabled: !1
                        }, e.inverted ? {
                            offsets: i,
                            width: h
                        } : {
                            offsets: i,
                            height: h
                        }), "xAxis"), p.yAxis = new t(e, S(n.yAxis, {
                            alignTicks: !1,
                            offset: 0,
                            index: m,
                            isInternal: !0,
                            reversed: k(n.yAxis && n.yAxis.reversed, e.yAxis[0] && e.yAxis[0].reversed, !1),
                            zoomEnabled: !1
                        }, e.inverted ? {
                            width: h
                        } : {
                            height: h
                        }), "yAxis"), f || n.series.data ? p.updateNavigatorSeries(!1) : 0 === e.series.length && (p.unbindRedraw = u(e, "beforeRedraw", function() {
                            e.series.length > 0 && !p.series && (p.setBaseSeries(), p.unbindRedraw());
                        })), p.reversedExtremes = e.inverted && !p.xAxis.reversed || !e.inverted && p.xAxis.reversed, p.renderElements(), p.addMouseEvents();
                    } else p.xAxis = {
                        chart: e,
                        navigatorAxis: {
                            fake: !0
                        },
                        translate: function(t, i) {
                            let n = e.xAxis[0], r = n.getExtremes(), o = n.len - 2 * d, s = M("min", n.options.min, r.dataMin), a = M("max", n.options.max, r.dataMax) - s;
                            return i ? t * a / o + s : o * (t - s) / a;
                        },
                        toPixels: function(t) {
                            return this.translate(t);
                        },
                        toValue: function(t) {
                            return this.translate(t, !0);
                        }
                    }, p.xAxis.navigatorAxis.axis = p.xAxis, p.xAxis.navigatorAxis.toFixedRange = r.prototype.toFixedRange.bind(p.xAxis.navigatorAxis);
                    if (e.options.scrollbar.enabled) {
                        let t = S(e.options.scrollbar, {
                            vertical: e.inverted
                        });
                        !C(t.margin) && p.navigatorEnabled && (t.margin = e.inverted ? -3 : 3), e.scrollbar = p.scrollbar = new s(e.renderer, t, e), u(p.scrollbar, "changed", function(t) {
                            let e = p.size, i = e * this.to, n = e * this.from;
                            p.hasDragged = p.scrollbar.hasDragged, p.render(0, 0, n, i), this.shouldUpdateExtremes(t.DOMType) && setTimeout(function() {
                                p.onMouseUp(t);
                            });
                        });
                    }
                    p.addBaseSeriesEvents(), p.addChartEvents();
                }
                setOpposite() {
                    let t = this.navigatorOptions, e = this.navigatorEnabled, i = this.chart;
                    this.opposite = k(t.opposite, !(e || !i.inverted));
                }
                getUnionExtremes(t) {
                    let e, i = this.chart.xAxis[0], n = this.xAxis, r = n.options, o = i.options;
                    return t && null === i.dataMin || (e = {
                        dataMin: k(r && r.min, M("min", o.min, i.dataMin, n.dataMin, n.min)),
                        dataMax: k(r && r.max, M("max", o.max, i.dataMax, n.dataMax, n.max))
                    }), e;
                }
                setBaseSeries(t, e) {
                    let i = this.chart, n = this.baseSeries = [];
                    t = t || i.options && i.options.navigator.baseSeries || (i.series.length ? x(i.series, (t)=>!t.options.isInternal).index : 0), (i.series || []).forEach((e, i)=>{
                        !e.options.isInternal && (e.options.showInNavigator || (i === t || e.options.id === t) && !1 !== e.options.showInNavigator) && n.push(e);
                    }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, e);
                }
                updateNavigatorSeries(t, e) {
                    let i, n, r, o = this, s = o.chart, a = o.baseSeries, l = {
                        enableMouseTracking: !1,
                        index: null,
                        linkedTo: null,
                        group: "nav",
                        padXAxis: !1,
                        xAxis: this.navigatorOptions.xAxis?.id,
                        yAxis: this.navigatorOptions.yAxis?.id,
                        showInLegend: !1,
                        stacking: void 0,
                        isInternal: !0,
                        states: {
                            inactive: {
                                opacity: 1
                            }
                        }
                    }, c = o.series = (o.series || []).filter((t)=>{
                        let e = t.baseSeries;
                        return !(0 > a.indexOf(e) && (e && (A(e, "updatedData", o.updatedDataHandler), delete e.navigatorSeries), t.chart && t.destroy(), 1));
                    }), d = o.navigatorOptions.series;
                    a && a.length && a.forEach((t)=>{
                        let u = t.navigatorSeries, p = y({
                            color: t.color,
                            visible: t.visible
                        }, w(d) ? h.navigator.series : d);
                        if (u && !1 === o.navigatorOptions.adaptToUpdatedData) return;
                        l.name = "Navigator " + a.length, r = (i = t.options || {}).navigatorOptions || {}, p.dataLabels = E(p.dataLabels), (n = S(i, l, p, r)).pointRange = k(p.pointRange, r.pointRange, h.plotOptions[n.type || "line"].pointRange);
                        let f = r.data || p.data;
                        o.hasNavigatorData = o.hasNavigatorData || !!f, n.data = f || i.data && i.data.slice(0), u && u.options ? u.update(n, e) : (t.navigatorSeries = s.initSeries(n), s.setSortedData(), t.navigatorSeries.baseSeries = t, c.push(t.navigatorSeries));
                    }), (d.data && !(a && a.length) || w(d)) && (o.hasNavigatorData = !1, (d = E(d)).forEach((t, e)=>{
                        l.name = "Navigator " + (c.length + 1), (n = S(h.navigator.series, {
                            color: s.series[e] && !s.series[e].options.isInternal && s.series[e].color || s.options.colors[e] || s.options.colors[0]
                        }, l, t)).data = t.data, n.data && (o.hasNavigatorData = !0, c.push(s.initSeries(n)));
                    })), t && this.addBaseSeriesEvents();
                }
                addBaseSeriesEvents() {
                    let t = this, e = t.baseSeries || [];
                    e[0] && e[0].xAxis && e[0].eventsToUnbind.push(u(e[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), e.forEach((i)=>{
                        i.eventsToUnbind.push(u(i, "show", function() {
                            this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
                        })), i.eventsToUnbind.push(u(i, "hide", function() {
                            this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
                        })), !1 !== this.navigatorOptions.adaptToUpdatedData && i.xAxis && i.eventsToUnbind.push(u(i, "updatedData", this.updatedDataHandler)), i.eventsToUnbind.push(u(i, "remove", function() {
                            e && b(e, i), this.navigatorSeries && (b(t.series, this.navigatorSeries), g(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
                        }));
                    });
                }
                getBaseSeriesMin(t) {
                    return this.baseSeries.reduce(function(t, e) {
                        return Math.min(t, e.xData && e.xData.length ? e.xData[0] : t);
                    }, t);
                }
                modifyNavigatorAxisExtremes() {
                    let t = this.xAxis;
                    if (void 0 !== t.getExtremes) {
                        let e = this.getUnionExtremes(!0);
                        e && (e.dataMin !== t.min || e.dataMax !== t.max) && (t.min = e.dataMin, t.max = e.dataMax);
                    }
                }
                modifyBaseAxisExtremes() {
                    let t, e, i = this.chart.navigator, n = this.getExtremes(), r = n.min, o = n.max, s = n.dataMin, a = n.dataMax, l = o - r, h = i.stickToMin, c = i.stickToMax, d = k(this.ordinal?.convertOverscroll(this.options.overscroll), 0), u = i.series && i.series[0], p = !!this.setExtremes;
                    !(this.eventArgs && "rangeSelectorButton" === this.eventArgs.trigger) && (h && (t = (e = s) + l), c && (t = a + d, h || (e = Math.max(s, t - l, i.getBaseSeriesMin(u && u.xData ? u.xData[0] : -Number.MAX_VALUE)))), p && (h || c) && C(e) && (this.min = this.userMin = e, this.max = this.userMax = t)), i.stickToMin = i.stickToMax = null;
                }
                updatedDataHandler() {
                    let t = this.chart.navigator, e = this.navigatorSeries, i = t.reversedExtremes ? 0 === Math.round(t.zoomedMin) : Math.round(t.zoomedMax) >= Math.round(t.size);
                    t.stickToMax = k(this.chart.options.navigator && this.chart.options.navigator.stickToMax, i), t.stickToMin = t.shouldStickToMin(this, t), e && !t.hasNavigatorData && (e.options.pointStart = this.xData[0], e.setData(this.options.data, !1, null, !1));
                }
                shouldStickToMin(t, e) {
                    let i = e.getBaseSeriesMin(t.xData[0]), n = t.xAxis, r = n.max, o = n.min, s = n.options.range;
                    return !(!C(r) || !C(o)) && (s && r - i > 0 ? r - i < s : o <= i);
                }
                addChartEvents() {
                    this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(u(this.chart, "redraw", function() {
                        let t = this.navigator, e = t && (t.baseSeries && t.baseSeries[0] && t.baseSeries[0].xAxis || this.xAxis[0]);
                        e && t.render(e.min, e.max);
                    }), u(this.chart, "getMargins", function() {
                        let t = this.navigator, e = t.opposite ? "plotTop" : "marginBottom";
                        this.inverted && (e = t.opposite ? "marginRight" : "plotLeft"), this[e] = (this[e] || 0) + (t.navigatorEnabled || !this.inverted ? t.height + t.scrollbarHeight : 0) + t.navigatorOptions.margin;
                    }), u(T, "setRange", function(t) {
                        this.chart.xAxis[0].setExtremes(t.min, t.max, t.redraw, t.animation, t.eventArguments);
                    }));
                }
                destroy() {
                    this.removeEvents(), this.xAxis && (b(this.chart.xAxis, this.xAxis), b(this.chart.axes, this.xAxis)), this.yAxis && (b(this.chart.yAxis, this.yAxis), b(this.chart.axes, this.yAxis)), (this.series || []).forEach((t)=>{
                        t.destroy && t.destroy();
                    }), [
                        "series",
                        "xAxis",
                        "yAxis",
                        "shades",
                        "outline",
                        "scrollbarTrack",
                        "scrollbarRifles",
                        "scrollbarGroup",
                        "scrollbar",
                        "navigatorGroup",
                        "rendered"
                    ].forEach((t)=>{
                        this[t] && this[t].destroy && this[t].destroy(), this[t] = null;
                    }), [
                        this.handles
                    ].forEach((t)=>{
                        m(t);
                    }), this.navigatorEnabled = !1;
                }
            }
            return T;
        }), i(e, "Accessibility/Components/NavigatorComponent.js", [
            e["Accessibility/AccessibilityComponent.js"],
            e["Accessibility/Utils/Announcer.js"],
            e["Accessibility/KeyboardNavigationHandler.js"],
            e["Stock/Navigator/Navigator.js"],
            e["Core/Animation/AnimationUtilities.js"],
            e["Core/Templating.js"],
            e["Core/Utilities.js"],
            e["Accessibility/Utils/HTMLUtilities.js"],
            e["Accessibility/Utils/ChartUtilities.js"]
        ], function(t, e, i, n, r, o, s, a, l) {
            let { animObject: h } = r, { format: c } = o, { clamp: d, pick: u, syncTimeout: p } = s, { getFakeMouseEvent: f } = a, { getAxisRangeDescription: g, fireEventOnWrappedOrUnwrappedElement: m } = l;
            return class extends t {
                init() {
                    let t = this.chart, i = this;
                    this.announcer = new e(t, "polite"), this.addEvent(n, "afterRender", function() {
                        this.chart === i.chart && this.chart.renderer && p(()=>{
                            i.proxyProvider.updateGroupProxyElementPositions("navigator"), i.updateHandleValues();
                        }, h(u(this.chart.renderer.globalAnimation, !0)).duration);
                    });
                }
                onChartUpdate() {
                    let t = this.chart, e = t.options, i = e.navigator;
                    if (i.enabled && i.accessibility?.enabled) {
                        let i = e.accessibility.landmarkVerbosity, n = e.lang.accessibility?.navigator.groupLabel;
                        this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", {
                            role: "all" === i ? "region" : "group",
                            "aria-label": c(n, {
                                chart: t
                            }, t)
                        });
                        let r = e.lang.accessibility?.navigator.handleLabel;
                        [
                            0,
                            1
                        ].forEach((e)=>{
                            let i = this.getHandleByIx(e);
                            if (i) {
                                let n = this.proxyProvider.addProxyElement("navigator", {
                                    click: i
                                }, "input", {
                                    type: "range",
                                    "aria-label": c(r, {
                                        handleIx: e,
                                        chart: t
                                    }, t)
                                });
                                this[e ? "maxHandleProxy" : "minHandleProxy"] = n.innerElement, n.innerElement.style.pointerEvents = "none", n.innerElement.oninput = ()=>this.updateNavigator();
                            }
                        }), this.updateHandleValues();
                    } else this.proxyProvider.removeGroup("navigator");
                }
                getNavigatorHandleNavigation(t) {
                    let e = this, n = this.chart, r = t ? this.maxHandleProxy : this.minHandleProxy, o = this.keyCodes;
                    return new i(n, {
                        keyCodeMap: [
                            [
                                [
                                    o.left,
                                    o.right,
                                    o.up,
                                    o.down
                                ],
                                function(i) {
                                    if (r) {
                                        let s = i === o.left || i === o.up ? -1 : 1;
                                        r.value = "" + d(parseFloat(r.value) + s, 0, 100), e.updateNavigator(()=>{
                                            let i = e.getHandleByIx(t);
                                            i && n.setFocusToElement(i, r);
                                        });
                                    }
                                    return this.response.success;
                                }
                            ]
                        ],
                        init: ()=>{
                            n.setFocusToElement(this.getHandleByIx(t), r);
                        },
                        validate: ()=>!!(this.getHandleByIx(t) && r && n.options.navigator.accessibility?.enabled)
                    });
                }
                getKeyboardNavigation() {
                    return [
                        this.getNavigatorHandleNavigation(0),
                        this.getNavigatorHandleNavigation(1)
                    ];
                }
                destroy() {
                    this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
                }
                updateHandleValues() {
                    let t = this.chart.navigator;
                    if (t && this.minHandleProxy && this.maxHandleProxy) {
                        let e = t.size;
                        this.minHandleProxy.value = "" + Math.round(t.zoomedMin / e * 100), this.maxHandleProxy.value = "" + Math.round(t.zoomedMax / e * 100);
                    }
                }
                getHandleByIx(t) {
                    let e = this.chart.navigator;
                    return e && e.handles && e.handles[t];
                }
                updateNavigator(t) {
                    this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(((t)=>{
                        let e = this.chart, { navigator: i, pointer: n } = e;
                        if (i && n && this.minHandleProxy && this.maxHandleProxy) {
                            let r = n.getChartPosition(), o = parseFloat(this.minHandleProxy.value) / 100 * i.size, s = parseFloat(this.maxHandleProxy.value) / 100 * i.size;
                            [
                                [
                                    0,
                                    "mousedown",
                                    i.zoomedMin
                                ],
                                [
                                    0,
                                    "mousemove",
                                    o
                                ],
                                [
                                    0,
                                    "mouseup",
                                    o
                                ],
                                [
                                    1,
                                    "mousedown",
                                    i.zoomedMax
                                ],
                                [
                                    1,
                                    "mousemove",
                                    s
                                ],
                                [
                                    1,
                                    "mouseup",
                                    s
                                ]
                            ].forEach(([t, e, n])=>{
                                let o = this.getHandleByIx(t)?.element;
                                o && m(o, f(e, {
                                    x: r.left + i.left + n,
                                    y: r.top + i.top
                                }, o));
                            }), t && t();
                            let a = e.options.lang.accessibility?.navigator.changeAnnouncement, l = g(e.xAxis[0]);
                            this.announcer.announce(c(a, {
                                axisRangeDescription: l,
                                chart: e
                            }, e));
                        }
                    }).bind(this, t), 20);
                }
            };
        }), i(e, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [
            e["Accessibility/Components/AnnotationsA11y.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Core/Templating.js"],
            e["Accessibility/Utils/HTMLUtilities.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { getPointAnnotationTexts: o } = t, { getAxisDescription: s, getSeriesFirstPointElement: a, getSeriesA11yElement: l, unhideChartElementFromAT: h } = e, { format: c, numberFormat: d } = i, { reverseChildNodes: u, stripHTMLTagsFromString: p } = n, { find: f, isNumber: g, isString: m, pick: b, defined: y } = r;
            function x(t) {
                let e = t.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
                return !!(!1 !== e && t.points && t.points.length >= +e);
            }
            function v(t, e) {
                let i = t.series, n = i.chart, r = n.options.accessibility.point || {}, o = i.options.accessibility && i.options.accessibility.point || {}, s = i.tooltipOptions || {}, a = n.options.lang;
                return g(e) ? d(e, o.valueDecimals || r.valueDecimals || s.valueDecimals || -1, a.decimalPoint, a.accessibility.thousandsSep || a.thousandsSep) : e;
            }
            function w(t, e) {
                let i = t[e];
                return t.chart.langFormat("accessibility.series." + e + "Description", {
                    name: s(i),
                    series: t
                });
            }
            function C(t) {
                let e = t.series, i = e.chart.series.length > 1 || e.options.name, n = function(t) {
                    let e = t.series, i = e.chart, n = e.options.accessibility, r = n && n.point && n.point.valueDescriptionFormat || i.options.accessibility.point.valueDescriptionFormat, o = b(e.xAxis && e.xAxis.options.accessibility && e.xAxis.options.accessibility.enabled, !i.angular && "flowmap" !== e.type), s = o ? function(t) {
                        let e = function(t) {
                            let e = t.series, i = e.chart, n = e.options.accessibility && e.options.accessibility.point || {}, r = i.options.accessibility.point || {}, o = e.xAxis && e.xAxis.dateTime;
                            if (o) {
                                let e = o.getXDateFormat(t.x || 0, i.options.tooltip.dateTimeLabelFormats), s = n.dateFormatter && n.dateFormatter(t) || r.dateFormatter && r.dateFormatter(t) || n.dateFormat || r.dateFormat || e;
                                return i.time.dateFormat(s, t.x || 0, void 0);
                            }
                        }(t), i = (t.series.xAxis || {}).categories && y(t.category) && ("" + t.category).replace("<br/>", " "), n = y(t.id) && 0 > ("" + t.id).indexOf("highcharts-"), r = "x, " + t.x;
                        return t.name || e || i || (n ? t.id : r);
                    }(t) : "";
                    return c(r, {
                        point: t,
                        index: y(t.index) ? t.index + 1 : "",
                        xDescription: s,
                        value: function(t) {
                            let e = t.series, i = e.chart.options.accessibility.point || {}, n = e.chart.options.accessibility && e.chart.options.accessibility.point || {}, r = e.tooltipOptions || {}, o = n.valuePrefix || i.valuePrefix || r.valuePrefix || "", s = n.valueSuffix || i.valueSuffix || r.valueSuffix || "", a = v(t, t[void 0 !== t.value ? "value" : "y"]);
                            return t.isNull ? e.chart.langFormat("accessibility.series.nullPointValue", {
                                point: t
                            }) : e.pointArrayMap ? function(t, e, i) {
                                let n = e || "", r = i || "", o = function(e) {
                                    let i = v(t, b(t[e], t.options[e]));
                                    return void 0 !== i ? e + ": " + n + i + r : i;
                                };
                                return t.series.pointArrayMap.reduce(function(t, e) {
                                    let i = o(e);
                                    return i ? t + (t.length ? ", " : "") + i : t;
                                }, "");
                            }(t, o, s) : o + a + s;
                        }(t),
                        separator: o ? ", " : ""
                    }, i);
                }(t), r = t.options && t.options.accessibility && t.options.accessibility.description, s = i ? " " + e.name + "." : "", a = function(t) {
                    let e = t.series.chart, i = o(t);
                    return i.length ? e.langFormat("accessibility.series.pointAnnotationsDescription", {
                        point: t,
                        annotations: i
                    }) : "";
                }(t);
                return t.accessibility = t.accessibility || {}, t.accessibility.valueDescription = n, n + (r ? " " + r : "") + s + (a ? " " + a : "");
            }
            function S(t) {
                let e = t.chart, i = e.types || [], n = function(t) {
                    let e = (t.options.accessibility || {}).description;
                    return e && t.chart.langFormat("accessibility.series.description", {
                        description: e,
                        series: t
                    }) || "";
                }(t), r = function(i) {
                    return e[i] && e[i].length > 1 && t[i];
                }, o = t.index + 1, s = w(t, "xAxis"), a = w(t, "yAxis"), l = {
                    seriesNumber: o,
                    series: t,
                    chart: e
                }, h = i.length > 1 ? "Combination" : "", d = e.langFormat("accessibility.series.summary." + t.type + h, l) || e.langFormat("accessibility.series.summary.default" + h, l), u = (r("yAxis") ? " " + a + "." : "") + (r("xAxis") ? " " + s + "." : "");
                return c(b(t.options.accessibility && t.options.accessibility.descriptionFormat, e.options.accessibility.series.descriptionFormat, ""), {
                    seriesDescription: d,
                    authorDescription: n ? " " + n : "",
                    axisDescription: u,
                    series: t,
                    chart: e,
                    seriesNumber: o
                }, void 0);
            }
            return {
                defaultPointDescriptionFormatter: C,
                defaultSeriesDescriptionFormatter: S,
                describeSeries: function(t) {
                    let e = t.chart, i = a(t), n = l(t), r = e.is3d && e.is3d();
                    n && (n.lastChild !== i || r || u(n), function(t) {
                        let e = function(t) {
                            let e = t.options.accessibility || {};
                            return !x(t) && !e.exposeAsGroupOnly;
                        }(t), i = function(t) {
                            let e = t.chart.options.accessibility.keyboardNavigation.seriesNavigation;
                            return !(!t.points || !(t.points.length < +e.pointNavigationEnabledThreshold || !1 === e.pointNavigationEnabledThreshold));
                        }(t), n = t.chart.options.accessibility.point.describeNull;
                        (e || i) && t.points.forEach((i)=>{
                            let r = i.graphic && i.graphic.element || function(t) {
                                let e = t.series, i = e && e.chart, n = e && e.is("sunburst"), r = t.isNull, o = i && i.options.accessibility.point.describeNull;
                                return r && !n && o;
                            }(i) && function(t) {
                                let e = t.series, i = function(t) {
                                    let e = t.index;
                                    return t.series && t.series.data && y(e) && f(t.series.data, function(t) {
                                        return !!(t && void 0 !== t.index && t.index > e && t.graphic && t.graphic.element);
                                    }) || null;
                                }(t), n = i && i.graphic, r = n ? n.parentGroup : e.graph || e.group, o = function(t, e) {
                                    let i = t.series.chart.renderer.rect(e.x, e.y, 1, 1);
                                    return i.attr({
                                        class: "highcharts-a11y-mock-point",
                                        fill: "none",
                                        opacity: 0,
                                        "fill-opacity": 0,
                                        "stroke-opacity": 0
                                    }), i;
                                }(t, i ? {
                                    x: b(t.plotX, i.plotX, 0),
                                    y: b(t.plotY, i.plotY, 0)
                                } : {
                                    x: b(t.plotX, 0),
                                    y: b(t.plotY, 0)
                                });
                                if (r && r.element) return t.graphic = o, t.hasMockGraphic = !0, o.add(r), r.element.insertBefore(o.element, n ? n.element : null), o.element;
                            }(i), o = i.options && i.options.accessibility && !1 === i.options.accessibility.enabled;
                            if (r) {
                                if (i.isNull && !n) return void r.setAttribute("aria-hidden", !0);
                                r.setAttribute("tabindex", "-1"), t.chart.styledMode || (r.style.outline = "none"), e && !o ? function(t, e) {
                                    let i = t.series, n = i.options.accessibility?.point || {}, r = i.chart.options.accessibility.point || {}, o = p(m(n.descriptionFormat) && c(n.descriptionFormat, t, i.chart) || n.descriptionFormatter?.(t) || m(r.descriptionFormat) && c(r.descriptionFormat, t, i.chart) || r.descriptionFormatter?.(t) || C(t), i.chart.renderer.forExport);
                                    e.setAttribute("role", "img"), e.setAttribute("aria-label", o);
                                }(i, r) : r.setAttribute("aria-hidden", !0);
                            }
                        });
                    }(t), h(e, n), function(t) {
                        let e = t.chart, i = e.options.chart, n = i.options3d && i.options3d.enabled, r = e.series.length > 1, o = e.options.accessibility.series.describeSingleSeries, s = (t.options.accessibility || {}).exposeAsGroupOnly;
                        return !(n && r) && (r || o || s || x(t));
                    }(t) ? function(t, e) {
                        let i = t.options.accessibility || {}, n = t.chart.options.accessibility, r = n.landmarkVerbosity;
                        i.exposeAsGroupOnly ? e.setAttribute("role", "img") : "all" === r ? e.setAttribute("role", "region") : e.setAttribute("role", "group"), e.setAttribute("tabindex", "-1"), t.chart.styledMode || (e.style.outline = "none"), e.setAttribute("aria-label", p(n.series.descriptionFormatter && n.series.descriptionFormatter(t) || S(t), t.chart.renderer.forExport));
                    }(t, n) : n.removeAttribute("aria-label"));
                }
            };
        }), i(e, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"],
            e["Accessibility/Utils/Announcer.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/Utils/EventProvider.js"],
            e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]
        ], function(t, e, i, n, r, o) {
            let { composed: s } = t, { addEvent: a, defined: l, pushUnique: h } = e, { getChartTitle: c } = n, { defaultPointDescriptionFormatter: d, defaultSeriesDescriptionFormatter: u } = o;
            function p(t) {
                return !!t.options.accessibility.announceNewData.enabled;
            }
            class f {
                constructor(t){
                    this.dirty = {
                        allSeries: {}
                    }, this.lastAnnouncementTime = 0, this.chart = t;
                }
                init() {
                    let t = this.chart, e = t.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
                    this.lastAnnouncementTime = 0, this.dirty = {
                        allSeries: {}
                    }, this.eventProvider = new r, this.announcer = new i(t, e), this.addEventListeners();
                }
                destroy() {
                    this.eventProvider.removeAddedEvents(), this.announcer.destroy();
                }
                addEventListeners() {
                    let t = this, e = this.chart, i = this.eventProvider;
                    i.addEvent(e, "afterApplyDrilldown", function() {
                        t.lastAnnouncementTime = 0;
                    }), i.addEvent(e, "afterAddSeries", function(e) {
                        t.onSeriesAdded(e.series);
                    }), i.addEvent(e, "redraw", function() {
                        t.announceDirtyData();
                    });
                }
                onSeriesAdded(t) {
                    p(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[t.name + t.index] = t, this.dirty.newSeries = l(this.dirty.newSeries) ? void 0 : t);
                }
                announceDirtyData() {
                    let t = this.chart, e = this;
                    if (t.options.accessibility.announceNewData && this.dirty.hasDirty) {
                        let t = this.dirty.newPoint;
                        t && (t = function(t) {
                            let e = t.series.data.filter((e)=>t.x === e.x && t.y === e.y);
                            return 1 === e.length ? e[0] : t;
                        }(t)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((t)=>e.dirty.allSeries[t]), this.dirty.newSeries, t), this.dirty = {
                            allSeries: {}
                        };
                    }
                }
                queueAnnouncement(t, e, i) {
                    let n = this.chart.options.accessibility.announceNewData;
                    if (n.enabled) {
                        let r = +new Date, o = r - this.lastAnnouncementTime, s = Math.max(0, n.minAnnounceInterval - o), a = function(t, e) {
                            let i = (t || []).concat(e || []).reduce((t, e)=>(t[e.name + e.index] = e, t), {});
                            return Object.keys(i).map((t)=>i[t]);
                        }(this.queuedAnnouncement && this.queuedAnnouncement.series, t), l = this.buildAnnouncementMessage(a, e, i);
                        l && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = {
                            time: r,
                            message: l,
                            series: a
                        }, this.queuedAnnouncementTimer = setTimeout(()=>{
                            this && this.announcer && (this.lastAnnouncementTime = +new Date, this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
                        }, s));
                    }
                }
                buildAnnouncementMessage(e, i, n) {
                    let r = this.chart, o = r.options.accessibility.announceNewData;
                    if (o.announcementFormatter) {
                        let t = o.announcementFormatter(e, i, n);
                        if (!1 !== t) return t.length ? t : null;
                    }
                    let s = t.charts && t.charts.length > 1 ? "Multiple" : "Single", a = i ? "newSeriesAnnounce" + s : n ? "newPointAnnounce" + s : "newDataAnnounce", l = c(r);
                    return r.langFormat("accessibility.announceNewData." + a, {
                        chartTitle: l,
                        seriesDesc: i ? u(i) : null,
                        pointDesc: n ? d(n) : null,
                        point: n,
                        series: i
                    });
                }
            }
            return function(t) {
                function e(t) {
                    let e = this.chart, i = e.accessibility?.components.series.newDataAnnouncer;
                    i && i.chart === e && p(e) && (i.dirty.newPoint = l(i.dirty.newPoint) ? void 0 : t.point);
                }
                function i() {
                    let t = this.chart, e = t.accessibility?.components.series.newDataAnnouncer;
                    e && e.chart === t && p(t) && (e.dirty.hasDirty = !0, e.dirty.allSeries[this.name + this.index] = this);
                }
                t.compose = function(t) {
                    h(s, "A11y.NDA") && (a(t, "addPoint", e), a(t, "updatedData", i));
                };
            }(f || (f = {})), f;
        }), i(e, "Accessibility/ProxyElement.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"],
            e["Accessibility/Utils/EventProvider.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/Utils/HTMLUtilities.js"]
        ], function(t, e, i, n, r) {
            let { doc: o } = t, { attr: s, css: a, merge: l } = e, { fireEventOnWrappedOrUnwrappedElement: h } = n, { cloneMouseEvent: c, cloneTouchEvent: d, getFakeMouseEvent: u, removeElement: p } = r;
            return class {
                constructor(t, e, n = "button", r, s){
                    this.chart = t, this.target = e, this.eventProvider = new i;
                    let a = this.innerElement = o.createElement(n), l = this.element = r ? o.createElement(r) : a;
                    t.styledMode || this.hideElementVisually(a), r && ("li" !== r || t.styledMode || (l.style.listStyle = "none"), l.appendChild(a), this.element = l), this.updateTarget(e, s);
                }
                click() {
                    let t = this.getTargetPosition();
                    t.x += t.width / 2, t.y += t.height / 2;
                    let e = u("click", t);
                    h(this.target.click, e);
                }
                updateTarget(t, e) {
                    this.target = t, this.updateCSSClassName();
                    let i = e || {};
                    Object.keys(i).forEach((t)=>{
                        null === i[t] && delete i[t];
                    });
                    let n = this.getTargetAttr(t.click, "aria-label");
                    s(this.innerElement, l(n ? {
                        "aria-label": n
                    } : {}, i)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, t.click), this.refreshPosition();
                }
                refreshPosition() {
                    let t = this.getTargetPosition();
                    a(this.innerElement, {
                        width: (t.width || 1) + "px",
                        height: (t.height || 1) + "px",
                        left: (Math.round(t.x) || 0) + "px",
                        top: (Math.round(t.y) || 0) + "px"
                    });
                }
                remove() {
                    this.eventProvider.removeAddedEvents(), p(this.element);
                }
                updateCSSClassName() {
                    let t = (t)=>t.indexOf("highcharts-no-tooltip") > -1, e = this.chart.legend, i = e.group && e.group.div, n = t(i && i.className || ""), r = t(this.getTargetAttr(this.target.click, "class") || "");
                    this.innerElement.className = n || r ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
                }
                addProxyEventsToElement(t, e) {
                    [
                        "click",
                        "touchstart",
                        "touchend",
                        "touchcancel",
                        "touchmove",
                        "mouseover",
                        "mouseenter",
                        "mouseleave",
                        "mouseout"
                    ].forEach((i)=>{
                        let n = 0 === i.indexOf("touch");
                        this.eventProvider.addEvent(t, i, (t)=>{
                            let i = n ? d(t) : c(t);
                            e && h(e, i), t.stopPropagation(), n || t.preventDefault();
                        }, {
                            passive: !1
                        });
                    });
                }
                hideElementVisually(t) {
                    a(t, {
                        borderWidth: 0,
                        backgroundColor: "transparent",
                        cursor: "pointer",
                        outline: "none",
                        opacity: .001,
                        filter: "alpha(opacity=1)",
                        zIndex: 999,
                        overflow: "hidden",
                        padding: 0,
                        margin: 0,
                        display: "block",
                        position: "absolute",
                        "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)"
                    });
                }
                getTargetPosition() {
                    let t = this.target.click, e = t.element ? t.element : t, i = this.target.visual || e, n = this.chart.renderTo, r = this.chart.pointer;
                    if (n && i?.getBoundingClientRect && r) {
                        let t = i.getBoundingClientRect(), e = r.getChartPosition();
                        return {
                            x: (t.left - e.left) / e.scaleX,
                            y: (t.top - e.top) / e.scaleY,
                            width: t.right / e.scaleX - t.left / e.scaleX,
                            height: t.bottom / e.scaleY - t.top / e.scaleY
                        };
                    }
                    return {
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1
                    };
                }
                getTargetAttr(t, e) {
                    return t.element ? t.element.getAttribute(e) : t.getAttribute(e);
                }
            };
        }), i(e, "Accessibility/ProxyProvider.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/Utils/DOMElementProvider.js"],
            e["Accessibility/Utils/HTMLUtilities.js"],
            e["Accessibility/ProxyElement.js"]
        ], function(t, e, i, n, r, o) {
            let { doc: s } = t, { attr: a, css: l } = e, { unhideChartElementFromAT: h } = i, { removeChildNodes: c } = r;
            return class {
                constructor(t){
                    this.chart = t, this.domElementProvider = new n, this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
                }
                addProxyElement(t, e, i = "button", n) {
                    let r = this.groups[t];
                    if (!r) throw Error("ProxyProvider.addProxyElement: Invalid group key " + t);
                    let s = "ul" === r.type || "ol" === r.type ? "li" : void 0, a = new o(this.chart, e, i, s, n);
                    return r.proxyContainerElement.appendChild(a.element), r.proxyElements.push(a), a;
                }
                addGroup(t, e = "div", i) {
                    let n, r = this.groups[t];
                    if (r) return r.groupElement;
                    let o = this.domElementProvider.createElement(e);
                    return i && i.role && "div" !== e ? (n = this.domElementProvider.createElement("div")).appendChild(o) : n = o, n.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + t.replace(/\W/g, "-"), this.groups[t] = {
                        proxyContainerElement: o,
                        groupElement: n,
                        type: e,
                        proxyElements: []
                    }, a(n, i || {}), "ul" === e && o.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(n), this.updateGroupOrder(this.groupOrder), n;
                }
                updateGroupAttrs(t, e) {
                    let i = this.groups[t];
                    if (!i) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + t);
                    a(i.groupElement, e);
                }
                updateGroupOrder(t) {
                    if (this.groupOrder = t.slice(), this.isDOMOrderGroupOrder()) return;
                    let e = t.indexOf("series"), i = e > -1 ? t.slice(0, e) : t, n = e > -1 ? t.slice(e + 1) : [], r = s.activeElement;
                    [
                        "before",
                        "after"
                    ].forEach((t)=>{
                        let e = this["before" === t ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
                        c(e), ("before" === t ? i : n).forEach((t)=>{
                            let i = this.groups[t];
                            i && e.appendChild(i.groupElement);
                        });
                    }), (this.beforeChartProxyPosContainer.contains(r) || this.afterChartProxyPosContainer.contains(r)) && r && r.focus && r.focus();
                }
                clearGroup(t) {
                    let e = this.groups[t];
                    if (!e) throw Error("ProxyProvider.clearGroup: Invalid group key " + t);
                    c(e.proxyContainerElement);
                }
                removeGroup(t) {
                    let e = this.groups[t];
                    e && (this.domElementProvider.removeElement(e.groupElement), e.groupElement !== e.proxyContainerElement && this.domElementProvider.removeElement(e.proxyContainerElement), delete this.groups[t]);
                }
                update() {
                    this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
                }
                updateProxyElementPositions() {
                    Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
                }
                updateGroupProxyElementPositions(t) {
                    let e = this.groups[t];
                    e && e.proxyElements.forEach((t)=>t.refreshPosition());
                }
                destroy() {
                    this.domElementProvider.destroyCreatedElements();
                }
                createProxyPosContainer(t) {
                    let e = this.domElementProvider.createElement("div");
                    return e.setAttribute("aria-hidden", "false"), e.className = "highcharts-a11y-proxy-container" + (t ? "-" + t : ""), l(e, {
                        top: "0",
                        left: "0"
                    }), this.chart.styledMode || (e.style.whiteSpace = "nowrap", e.style.position = "absolute"), e;
                }
                getCurrentGroupOrderInDOM() {
                    let t = (t)=>{
                        let e = Object.keys(this.groups), i = e.length;
                        for(; i--;){
                            let n = e[i], r = this.groups[n];
                            if (r && t === r.groupElement) return n;
                        }
                    }, e = (e)=>{
                        let i = [], n = e.children;
                        for(let e = 0; e < n.length; ++e){
                            let r = t(n[e]);
                            r && i.push(r);
                        }
                        return i;
                    }, i = e(this.beforeChartProxyPosContainer), n = e(this.afterChartProxyPosContainer);
                    return i.push("series"), i.concat(n);
                }
                isDOMOrderGroupOrder() {
                    let t = this.getCurrentGroupOrderInDOM(), e = this.groupOrder.filter((t)=>"series" === t || !!this.groups[t]), i = t.length;
                    if (i !== e.length) return !1;
                    for(; i--;)if (t[i] !== e[i]) return !1;
                    return !0;
                }
                updatePosContainerPositions() {
                    let t = this.chart;
                    if (t.renderer.forExport) return;
                    let e = t.renderer.box;
                    t.container.insertBefore(this.afterChartProxyPosContainer, e.nextSibling), t.container.insertBefore(this.beforeChartProxyPosContainer, e), h(this.chart, this.afterChartProxyPosContainer), h(this.chart, this.beforeChartProxyPosContainer);
                }
            };
        }), i(e, "Accessibility/Components/RangeSelectorComponent.js", [
            e["Accessibility/AccessibilityComponent.js"],
            e["Accessibility/Utils/Announcer.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/KeyboardNavigationHandler.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { unhideChartElementFromAT: o, getAxisRangeDescription: s } = i, { addEvent: a, attr: l } = r;
            class h extends t {
                init() {
                    let t = this.chart;
                    this.announcer = new e(t, "polite");
                }
                onChartUpdate() {
                    let t = this.chart, e = this, i = t.rangeSelector;
                    i && (this.updateSelectorVisibility(), this.setDropdownAttrs(), i.buttons && i.buttons.length && i.buttons.forEach((t)=>{
                        e.setRangeButtonAttrs(t);
                    }), i.maxInput && i.minInput && [
                        "minInput",
                        "maxInput"
                    ].forEach(function(n, r) {
                        let s = i[n];
                        s && (o(t, s), e.setRangeInputAttrs(s, "accessibility.rangeSelector." + (r ? "max" : "min") + "InputLabel"));
                    }));
                }
                updateSelectorVisibility() {
                    let t = this.chart, e = t.rangeSelector, i = e && e.dropdown, n = e && e.buttons || [], r = (t)=>t.setAttribute("aria-hidden", !0);
                    e && e.hasVisibleDropdown && i ? (o(t, i), n.forEach((t)=>r(t.element))) : (i && r(i), n.forEach((e)=>o(t, e.element)));
                }
                setDropdownAttrs() {
                    let t = this.chart, e = t.rangeSelector && t.rangeSelector.dropdown;
                    if (e) {
                        let i = t.langFormat("accessibility.rangeSelector.dropdownLabel", {
                            rangeTitle: t.options.lang.rangeSelectorZoom
                        });
                        e.setAttribute("aria-label", i), e.setAttribute("tabindex", -1);
                    }
                }
                setRangeButtonAttrs(t) {
                    l(t.element, {
                        tabindex: -1,
                        role: "button"
                    });
                }
                setRangeInputAttrs(t, e) {
                    let i = this.chart;
                    l(t, {
                        tabindex: -1,
                        "aria-label": i.langFormat(e, {
                            chart: i
                        })
                    });
                }
                onButtonNavKbdArrowKey(t, e) {
                    let i = t.response, n = this.keyCodes, r = this.chart, o = r.options.accessibility.keyboardNavigation.wrapAround, s = e === n.left || e === n.up ? -1 : 1;
                    return r.highlightRangeSelectorButton(r.highlightedRangeSelectorItemIx + s) ? i.success : o ? (t.init(s), i.success) : i[s > 0 ? "next" : "prev"];
                }
                onButtonNavKbdClick(t) {
                    let e = t.response, i = this.chart;
                    return 3 !== i.oldRangeSelectorItemState && this.fakeClickEvent(i.rangeSelector.buttons[i.highlightedRangeSelectorItemIx].element), e.success;
                }
                onAfterBtnClick() {
                    let t = this.chart, e = s(t.xAxis[0]), i = t.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", {
                        chart: t,
                        axisRangeDescription: e
                    });
                    i && this.announcer.announce(i);
                }
                onInputKbdMove(t) {
                    let e = this.chart, i = e.rangeSelector, n = e.highlightedInputRangeIx = (e.highlightedInputRangeIx || 0) + t;
                    if (n > 1 || n < 0) {
                        if (e.accessibility) return e.accessibility.keyboardNavigation.exiting = !0, e.accessibility.keyboardNavigation.tabindexContainer.focus(), e.accessibility.keyboardNavigation.move(t);
                    } else if (i) {
                        let t = i[n ? "maxDateBox" : "minDateBox"], r = i[n ? "maxInput" : "minInput"];
                        t && r && e.setFocusToElement(t, r);
                    }
                    return !0;
                }
                onInputNavInit(t) {
                    let e = this, i = this.chart, n = t > 0 ? 0 : 1, r = i.rangeSelector, o = r && r[n ? "maxDateBox" : "minDateBox"], s = r && r.minInput, l = r && r.maxInput;
                    if (i.highlightedInputRangeIx = n, o && s && l) {
                        i.setFocusToElement(o, n ? l : s), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
                        let t = (t)=>{
                            (t.which || t.keyCode) === this.keyCodes.tab && e.onInputKbdMove(t.shiftKey ? -1 : 1) && (t.preventDefault(), t.stopPropagation());
                        }, r = a(s, "keydown", t), h = a(l, "keydown", t);
                        this.removeInputKeydownHandler = ()=>{
                            r(), h();
                        };
                    }
                }
                onInputNavTerminate() {
                    let t = this.chart.rangeSelector || {};
                    t.maxInput && t.hideInput("max"), t.minInput && t.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
                }
                initDropdownNav() {
                    let t = this.chart, e = t.rangeSelector, i = e && e.dropdown;
                    e && i && (t.setFocusToElement(e.buttonGroup, i), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = a(i, "keydown", (e)=>{
                        let i = (e.which || e.keyCode) === this.keyCodes.tab, n = t.accessibility;
                        i && (e.preventDefault(), e.stopPropagation(), n && (n.keyboardNavigation.tabindexContainer.focus(), n.keyboardNavigation.move(e.shiftKey ? -1 : 1)));
                    }));
                }
                getRangeSelectorButtonNavigation() {
                    let t = this.chart, e = this.keyCodes, i = this;
                    return new n(t, {
                        keyCodeMap: [
                            [
                                [
                                    e.left,
                                    e.right,
                                    e.up,
                                    e.down
                                ],
                                function(t) {
                                    return i.onButtonNavKbdArrowKey(this, t);
                                }
                            ],
                            [
                                [
                                    e.enter,
                                    e.space
                                ],
                                function() {
                                    return i.onButtonNavKbdClick(this);
                                }
                            ]
                        ],
                        validate: function() {
                            return !!(t.rangeSelector && t.rangeSelector.buttons && t.rangeSelector.buttons.length);
                        },
                        init: function(e) {
                            let n = t.rangeSelector;
                            if (n && n.hasVisibleDropdown) i.initDropdownNav();
                            else if (n) {
                                let i = n.buttons.length - 1;
                                t.highlightRangeSelectorButton(e > 0 ? 0 : i);
                            }
                        },
                        terminate: function() {
                            i.removeDropdownKeydownHandler && (i.removeDropdownKeydownHandler(), delete i.removeDropdownKeydownHandler);
                        }
                    });
                }
                getRangeSelectorInputNavigation() {
                    let t = this.chart, e = this;
                    return new n(t, {
                        keyCodeMap: [],
                        validate: function() {
                            return !!(t.rangeSelector && t.rangeSelector.inputGroup && "hidden" !== t.rangeSelector.inputGroup.element.style.visibility && !1 !== t.options.rangeSelector.inputEnabled && t.rangeSelector.minInput && t.rangeSelector.maxInput);
                        },
                        init: function(t) {
                            e.onInputNavInit(t);
                        },
                        terminate: function() {
                            e.onInputNavTerminate();
                        }
                    });
                }
                getKeyboardNavigation() {
                    return [
                        this.getRangeSelectorButtonNavigation(),
                        this.getRangeSelectorInputNavigation()
                    ];
                }
                destroy() {
                    this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
                }
            }
            return function(t) {
                function e(t) {
                    let e = this.rangeSelector && this.rangeSelector.buttons || [], i = this.highlightedRangeSelectorItemIx, n = this.rangeSelector && this.rangeSelector.selected;
                    return void 0 !== i && e[i] && i !== n && e[i].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = t, !!e[t] && (this.setFocusToElement(e[t].box, e[t].element), t !== n && (this.oldRangeSelectorItemState = e[t].state, e[t].setState(1)), !0);
                }
                function i() {
                    let t = this.chart.accessibility;
                    if (t && t.components.rangeSelector) return t.components.rangeSelector.onAfterBtnClick();
                }
                t.compose = function(t, n) {
                    let r = t.prototype;
                    r.highlightRangeSelectorButton || (r.highlightRangeSelectorButton = e, a(n, "afterBtnClick", i));
                };
            }(h || (h = {})), h;
        }), i(e, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            var i;
            let { composed: n } = t, { addEvent: r, merge: o, pushUnique: s } = e;
            return function(t) {
                function e(t) {
                    o(!0, t, {
                        marker: {
                            enabled: !0,
                            states: {
                                normal: {
                                    opacity: 0
                                }
                            }
                        }
                    });
                }
                function i(t) {
                    return t.marker.states && t.marker.states.normal && t.marker.states.normal.opacity;
                }
                function a(t) {
                    return !!(t._hasPointMarkers && t.points && t.points.length);
                }
                function l() {
                    this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), a(this) && this.points.forEach((t)=>{
                        t.graphic && (t.graphic[t.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), t.graphic[!1 === t.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
                    }));
                }
                function h(t) {
                    this.resetA11yMarkerOptions = o(t.options.marker || {}, this.userOptions.marker || {});
                }
                function c() {
                    let t = this.options;
                    !function(t) {
                        let e = t.chart.options.accessibility.enabled, i = !1 !== (t.options.accessibility && t.options.accessibility.enabled);
                        return e && i && function(t) {
                            let e = t.chart.options.accessibility;
                            return t.points.length < e.series.pointDescriptionEnabledThreshold || !1 === e.series.pointDescriptionEnabledThreshold;
                        }(t);
                    }(this) ? this.a11yMarkersForced && (delete this.a11yMarkersForced, function(t) {
                        let e = t.resetA11yMarkerOptions;
                        if (e) {
                            let i = e.states && e.states.normal && e.states.normal.opacity;
                            t.userOptions && t.userOptions.marker && (t.userOptions.marker.enabled = !0), t.update({
                                marker: {
                                    enabled: e.enabled,
                                    states: {
                                        normal: {
                                            opacity: i
                                        }
                                    }
                                }
                            });
                        }
                    }(this), delete this.resetA11yMarkerOptions) : (t.marker && !1 === t.marker.enabled && (this.a11yMarkersForced = !0, e(this.options)), a(this) && function(t) {
                        let n = t.points.length;
                        for(; n--;){
                            let r = t.points[n], s = r.options, a = r.hasForcedA11yMarker;
                            if (delete r.hasForcedA11yMarker, s.marker) {
                                let t = a && 0 === i(s);
                                s.marker.enabled && !t ? (o(!0, s.marker, {
                                    states: {
                                        normal: {
                                            opacity: i(s) || 1
                                        }
                                    }
                                }), r.hasForcedA11yMarker = !1) : !1 === s.marker.enabled && (e(s), r.hasForcedA11yMarker = !0);
                            }
                        }
                    }(this));
                }
                function d() {
                    this.boosted && this.a11yMarkersForced && (o(!0, this.options, {
                        marker: {
                            enabled: !1
                        }
                    }), delete this.a11yMarkersForced);
                }
                t.compose = function(t) {
                    s(n, "A11y.FM") && (r(t, "afterSetOptions", h), r(t, "render", c), r(t, "afterRender", l), r(t, "renderCanvas", d));
                };
            }(i || (i = {})), i;
        }), i(e, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [
            e["Core/Series/Point.js"],
            e["Core/Series/Series.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"],
            e["Accessibility/KeyboardNavigationHandler.js"],
            e["Accessibility/Utils/EventProvider.js"],
            e["Accessibility/Utils/ChartUtilities.js"]
        ], function(t, e, i, n, r, o, s, a) {
            let { seriesTypes: l } = i, { doc: h } = n, { defined: c, fireEvent: d } = r, { getPointFromXY: u, getSeriesFromName: p, scrollAxisToPoint: f } = a;
            function g(t) {
                let e = t.index, i = t.series.points, n = i.length;
                if (i[e] === t) return e;
                for(; n--;)if (i[n] === t) return n;
            }
            function m(t) {
                let e = t.chart.options.accessibility.keyboardNavigation.seriesNavigation, i = t.options.accessibility || {}, n = i.keyboardNavigation;
                return n && !1 === n.enabled || !1 === i.enabled || !1 === t.options.enableMouseTracking || !t.visible || e.pointNavigationEnabledThreshold && +e.pointNavigationEnabledThreshold <= t.points.length;
            }
            function b(t) {
                let e = t.series.chart.options.accessibility, i = t.options.accessibility && !1 === t.options.accessibility.enabled;
                return t.isNull && e.keyboardNavigation.seriesNavigation.skipNullPoints || !1 === t.visible || !1 === t.isInside || i || m(t.series);
            }
            function y(t) {
                let e = t.series || [], i = e.length;
                for(let t = 0; t < i; ++t)if (!m(e[t])) {
                    let i = function(t) {
                        let e = t.points || [], i = e.length;
                        for(let t = 0; t < i; ++t)if (!b(e[t])) return e[t];
                        return null;
                    }(e[t]);
                    if (i) return i;
                }
                return null;
            }
            function x(t) {
                let e = t.series.length, i = !1;
                for(; e-- && (t.highlightedPoint = t.series[e].points[t.series[e].points.length - 1], !(i = t.series[e].highlightNextValidPoint())););
                return i;
            }
            function v(t) {
                delete t.highlightedPoint;
                let e = y(t);
                return !!e && e.highlight();
            }
            class w {
                constructor(t, e){
                    this.keyCodes = e, this.chart = t;
                }
                init() {
                    let i = this, n = this.chart, r = this.eventProvider = new s;
                    r.addEvent(e, "destroy", function() {
                        return i.onSeriesDestroy(this);
                    }), r.addEvent(n, "afterApplyDrilldown", function() {
                        !function(t) {
                            let e = y(t);
                            e && e.highlight(!1);
                        }(this);
                    }), r.addEvent(n, "drilldown", function(t) {
                        let e = t.point, n = e.series;
                        i.lastDrilledDownPoint = {
                            x: e.x,
                            y: e.y,
                            seriesName: n ? n.name : ""
                        };
                    }), r.addEvent(n, "drillupall", function() {
                        setTimeout(function() {
                            i.onDrillupAll();
                        }, 10);
                    }), r.addEvent(t, "afterSetState", function() {
                        let t = this.graphic && this.graphic.element, e = h.activeElement, i = e && e.getAttribute("class"), r = i && i.indexOf("highcharts-a11y-proxy-element") > -1;
                        n.highlightedPoint === this && e !== t && !r && t && t.focus && t.focus();
                    });
                }
                onDrillupAll() {
                    let t, e = this.lastDrilledDownPoint, i = this.chart, n = e && p(i, e.seriesName);
                    e && n && c(e.x) && c(e.y) && (t = u(n, e.x, e.y)), t = t || y(i), i.container && i.container.focus(), t && t.highlight && t.highlight(!1);
                }
                getKeyboardNavigationHandler() {
                    let t = this, e = this.keyCodes, i = this.chart, n = i.inverted;
                    return new o(i, {
                        keyCodeMap: [
                            [
                                n ? [
                                    e.up,
                                    e.down
                                ] : [
                                    e.left,
                                    e.right
                                ],
                                function(e) {
                                    return t.onKbdSideways(this, e);
                                }
                            ],
                            [
                                n ? [
                                    e.left,
                                    e.right
                                ] : [
                                    e.up,
                                    e.down
                                ],
                                function(e) {
                                    return t.onKbdVertical(this, e);
                                }
                            ],
                            [
                                [
                                    e.enter,
                                    e.space
                                ],
                                function(t, e) {
                                    let n = i.highlightedPoint;
                                    if (n) {
                                        let { plotLeft: t, plotTop: i } = this.chart, { plotX: r = 0, plotY: o = 0 } = n;
                                        e = {
                                            ...e,
                                            chartX: t + r,
                                            chartY: i + o,
                                            point: n,
                                            target: n.graphic?.element || e.target
                                        }, d(n.series, "click", e), n.firePointEvent("click", e);
                                    }
                                    return this.response.success;
                                }
                            ],
                            [
                                [
                                    e.home
                                ],
                                function() {
                                    return v(i), this.response.success;
                                }
                            ],
                            [
                                [
                                    e.end
                                ],
                                function() {
                                    return x(i), this.response.success;
                                }
                            ],
                            [
                                [
                                    e.pageDown,
                                    e.pageUp
                                ],
                                function(t) {
                                    return i.highlightAdjacentSeries(t === e.pageDown), this.response.success;
                                }
                            ]
                        ],
                        init: function() {
                            return t.onHandlerInit(this);
                        },
                        validate: function() {
                            return !!y(i);
                        },
                        terminate: function() {
                            return t.onHandlerTerminate();
                        }
                    });
                }
                onKbdSideways(t, e) {
                    let i = this.keyCodes, n = e === i.right || e === i.down;
                    return this.attemptHighlightAdjacentPoint(t, n);
                }
                onHandlerInit(t) {
                    let e = this.chart;
                    return e.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && e.highlightedPoint ? e.highlightedPoint.highlight() : v(e), t.response.success;
                }
                onKbdVertical(t, e) {
                    let i = this.chart, n = this.keyCodes, r = e === n.down || e === n.right, o = i.options.accessibility.keyboardNavigation.seriesNavigation;
                    return o.mode && "serialize" === o.mode ? this.attemptHighlightAdjacentPoint(t, r) : (i[i.highlightedPoint && i.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries"](r), t.response.success);
                }
                onHandlerTerminate() {
                    let t = this.chart, e = t.options.accessibility.keyboardNavigation;
                    t.tooltip && t.tooltip.hide(0);
                    let i = t.highlightedPoint && t.highlightedPoint.series;
                    i && i.onMouseOut && i.onMouseOut(), t.highlightedPoint && t.highlightedPoint.onMouseOut && t.highlightedPoint.onMouseOut(), e.seriesNavigation.rememberPointFocus || delete t.highlightedPoint;
                }
                attemptHighlightAdjacentPoint(t, e) {
                    let i = this.chart, n = i.options.accessibility.keyboardNavigation.wrapAround;
                    return i.highlightAdjacentPoint(e) || n && (e ? v(i) : x(i)) ? t.response.success : t.response[e ? "next" : "prev"];
                }
                onSeriesDestroy(t) {
                    let e = this.chart;
                    e.highlightedPoint && e.highlightedPoint.series === t && (delete e.highlightedPoint, e.focusElement && e.focusElement.removeFocusBorder());
                }
                destroy() {
                    this.eventProvider.removeAddedEvents();
                }
            }
            return function(t) {
                function e(t) {
                    let e, i, n = this.series, r = this.highlightedPoint, o = r && g(r) || 0, s = r && r.series.points || [], a = this.series && this.series[this.series.length - 1], l = a && a.points && a.points[a.points.length - 1];
                    if (!n[0] || !n[0].points) return !1;
                    if (r) {
                        if (e = n[r.series.index + (t ? 1 : -1)], (i = s[o + (t ? 1 : -1)]) || !e || (i = e.points[t ? 0 : e.points.length - 1]), !i) return !1;
                    } else i = t ? n[0].points[0] : l;
                    return b(i) ? (m(e = i.series) ? this.highlightedPoint = t ? e.points[e.points.length - 1] : e.points[0] : this.highlightedPoint = i, this.highlightAdjacentPoint(t)) : i.highlight();
                }
                function i(t) {
                    let e, i = this.highlightedPoint, n = 1 / 0;
                    return !(!c(i.plotX) || !c(i.plotY)) && (this.series.forEach((r)=>{
                        m(r) || r.points.forEach((o)=>{
                            if (!c(o.plotY) || !c(o.plotX) || o === i) return;
                            let s = o.plotY - i.plotY, a = Math.abs(o.plotX - i.plotX), l = Math.abs(s) * Math.abs(s) + a * a * 4;
                            r.yAxis && r.yAxis.reversed && (s *= -1), !(s <= 0 && t || s >= 0 && !t || l < 5 || b(o)) && l < n && (n = l, e = o);
                        });
                    }), !!e && e.highlight());
                }
                function n(t) {
                    let e, i, n, r = this.highlightedPoint, o = this.series && this.series[this.series.length - 1], s = o && o.points && o.points[o.points.length - 1];
                    return this.highlightedPoint ? !(!(e = this.series[r.series.index + (t ? -1 : 1)]) || !(i = function(t, e, i, n) {
                        let r, o, s, a = 1 / 0, l = e.points.length, h = (t)=>!(c(t.plotX) && c(t.plotY));
                        if (!h(t)) {
                            for(; l--;)!h(r = e.points[l]) && (s = (t.plotX - r.plotX) * (t.plotX - r.plotX) * 4 + (t.plotY - r.plotY) * (t.plotY - r.plotY) * 1) < a && (a = s, o = l);
                            return c(o) ? e.points[o] : void 0;
                        }
                    }(r, e))) && (m(e) ? (i.highlight(), (n = this.highlightAdjacentSeries(t)) ? n : (r.highlight(), !1)) : (i.highlight(), i.series.highlightNextValidPoint())) : (e = t ? this.series && this.series[0] : o, !!(i = t ? e && e.points && e.points[0] : s) && i.highlight());
                }
                function r(t = !0) {
                    let e = this.series.chart, i = e.tooltip?.label?.element;
                    !this.isNull && t ? this.onMouseOver() : e.tooltip && e.tooltip.hide(0), f(this), this.graphic && (e.setFocusToElement(this.graphic), !t && e.focusElement && e.focusElement.removeFocusBorder()), e.highlightedPoint = this;
                    let n = i?.getBoundingClientRect().top;
                    if (i && n && n < 0) {
                        let t = window.scrollY;
                        window.scrollTo({
                            behavior: "smooth",
                            top: t + n
                        });
                    }
                    return this;
                }
                function o() {
                    let t = this.chart.highlightedPoint, e = (t && t.series) === this ? g(t) : 0, i = this.points, n = i.length;
                    if (i && n) {
                        for(let t = e; t < n; ++t)if (!b(i[t])) return i[t].highlight();
                        for(let t = e; t >= 0; --t)if (!b(i[t])) return i[t].highlight();
                    }
                    return !1;
                }
                t.compose = function(t, s, a) {
                    let h = t.prototype, c = s.prototype, d = a.prototype;
                    h.highlightAdjacentPoint || (h.highlightAdjacentPoint = e, h.highlightAdjacentPointVertical = i, h.highlightAdjacentSeries = n, c.highlight = r, d.keyboardMoveVertical = !0, [
                        "column",
                        "gantt",
                        "pie"
                    ].forEach((t)=>{
                        l[t] && (l[t].prototype.keyboardMoveVertical = !1);
                    }), d.highlightNextValidPoint = o);
                };
            }(w || (w = {})), w;
        }), i(e, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [
            e["Accessibility/AccessibilityComponent.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/Components/SeriesComponent/ForcedMarkers.js"],
            e["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"],
            e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"],
            e["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]
        ], function(t, e, i, n, r, o) {
            let { hideSeriesFromAT: s } = e, { describeSeries: a } = r;
            return class extends t {
                static compose(t, e, r) {
                    n.compose(r), i.compose(r), o.compose(t, e, r);
                }
                init() {
                    this.newDataAnnouncer = new n(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new o(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
                }
                hideTooltipFromATWhenShown() {
                    let t = this;
                    this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
                        this.chart === t.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
                    });
                }
                hideSeriesLabelsFromATWhenShown() {
                    this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
                        this.series.forEach(function(t) {
                            t.labelBySeries && t.labelBySeries.attr("aria-hidden", !0);
                        });
                    });
                }
                onChartRender() {
                    this.chart.series.forEach(function(t) {
                        !1 !== (t.options.accessibility && t.options.accessibility.enabled) && t.visible && 0 !== t.getPointsCollection().length ? a(t) : s(t);
                    });
                }
                getKeyboardNavigation() {
                    return this.keyboardNavigation.getKeyboardNavigationHandler();
                }
                destroy() {
                    this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
                }
            };
        }), i(e, "Accessibility/Components/ZoomComponent.js", [
            e["Accessibility/AccessibilityComponent.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/Utils/HTMLUtilities.js"],
            e["Accessibility/KeyboardNavigationHandler.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r) {
            let { unhideChartElementFromAT: o } = e, { getFakeMouseEvent: s } = i, { attr: a, pick: l } = r;
            return class extends t {
                constructor(){
                    super(...arguments), this.focusedMapNavButtonIx = -1;
                }
                init() {
                    let t = this, e = this.chart;
                    this.proxyProvider.addGroup("zoom", "div"), [
                        "afterShowResetZoom",
                        "afterApplyDrilldown",
                        "drillupall"
                    ].forEach((i)=>{
                        t.addEvent(e, i, function() {
                            t.updateProxyOverlays();
                        });
                    });
                }
                onChartUpdate() {
                    let t = this.chart, e = this;
                    t.mapNavigation && t.mapNavigation.navButtons.forEach((i, n)=>{
                        o(t, i.element), e.setMapNavButtonAttrs(i.element, "accessibility.zoom.mapZoom" + (n ? "Out" : "In"));
                    });
                }
                setMapNavButtonAttrs(t, e) {
                    let i = this.chart;
                    a(t, {
                        tabindex: -1,
                        role: "button",
                        "aria-label": i.langFormat(e, {
                            chart: i
                        })
                    });
                }
                onChartRender() {
                    this.updateProxyOverlays();
                }
                updateProxyOverlays() {
                    let t = this.chart;
                    if (this.proxyProvider.clearGroup("zoom"), t.resetZoomButton && this.createZoomProxyButton(t.resetZoomButton, "resetZoomProxyButton", t.langFormat("accessibility.zoom.resetZoomButton", {
                        chart: t
                    })), t.drillUpButton && t.breadcrumbs && t.breadcrumbs.list) {
                        let e = t.breadcrumbs.list[t.breadcrumbs.list.length - 1];
                        this.createZoomProxyButton(t.drillUpButton, "drillUpProxyButton", t.langFormat("accessibility.drillUpButton", {
                            chart: t,
                            buttonText: t.breadcrumbs.getButtonText(e)
                        }));
                    }
                }
                createZoomProxyButton(t, e, i) {
                    this[e] = this.proxyProvider.addProxyElement("zoom", {
                        click: t
                    }, "button", {
                        "aria-label": i,
                        tabindex: -1
                    });
                }
                getMapZoomNavigation() {
                    let t = this.keyCodes, e = this.chart, i = this;
                    return new n(e, {
                        keyCodeMap: [
                            [
                                [
                                    t.up,
                                    t.down,
                                    t.left,
                                    t.right
                                ],
                                function(t) {
                                    return i.onMapKbdArrow(this, t);
                                }
                            ],
                            [
                                [
                                    t.tab
                                ],
                                function(t, e) {
                                    return i.onMapKbdTab(this, e);
                                }
                            ],
                            [
                                [
                                    t.space,
                                    t.enter
                                ],
                                function() {
                                    return i.onMapKbdClick(this);
                                }
                            ]
                        ],
                        validate: function() {
                            return !!(e.mapView && e.mapNavigation && e.mapNavigation.navButtons.length);
                        },
                        init: function(t) {
                            return i.onMapNavInit(t);
                        }
                    });
                }
                onMapKbdArrow(t, e) {
                    let i = this.chart, n = this.keyCodes, r = i.container, o = e === n.up || e === n.down, a = e === n.left || e === n.up ? 1 : -1, l = (o ? i.plotHeight : i.plotWidth) / 10 * a, h = 10 * Math.random(), c = {
                        x: r.offsetLeft + i.plotLeft + i.plotWidth / 2 + h,
                        y: r.offsetTop + i.plotTop + i.plotHeight / 2 + h
                    }, d = o ? {
                        x: c.x,
                        y: c.y + l
                    } : {
                        x: c.x + l,
                        y: c.y
                    };
                    return [
                        s("mousedown", c),
                        s("mousemove", d),
                        s("mouseup", d)
                    ].forEach((t)=>r.dispatchEvent(t)), t.response.success;
                }
                onMapKbdTab(t, e) {
                    let i = this.chart, n = t.response, r = e.shiftKey, o = r && !this.focusedMapNavButtonIx || !r && this.focusedMapNavButtonIx;
                    if (i.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), o) return i.mapView && i.mapView.zoomBy(), n[r ? "prev" : "next"];
                    this.focusedMapNavButtonIx += r ? -1 : 1;
                    let s = i.mapNavigation.navButtons[this.focusedMapNavButtonIx];
                    return i.setFocusToElement(s.box, s.element), s.setState(2), n.success;
                }
                onMapKbdClick(t) {
                    let e = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
                    return this.fakeClickEvent(e), t.response.success;
                }
                onMapNavInit(t) {
                    let e = this.chart, i = e.mapNavigation.navButtons[0], n = e.mapNavigation.navButtons[1], r = t > 0 ? i : n;
                    e.setFocusToElement(r.box, r.element), r.setState(2), this.focusedMapNavButtonIx = t > 0 ? 0 : 1;
                }
                simpleButtonNavigation(t, e, i) {
                    let r = this.keyCodes, o = this, s = this.chart;
                    return new n(s, {
                        keyCodeMap: [
                            [
                                [
                                    r.tab,
                                    r.up,
                                    r.down,
                                    r.left,
                                    r.right
                                ],
                                function(t, e) {
                                    let i = t === r.tab && e.shiftKey || t === r.left || t === r.up;
                                    return this.response[i ? "prev" : "next"];
                                }
                            ],
                            [
                                [
                                    r.space,
                                    r.enter
                                ],
                                function() {
                                    return l(i(this, s), this.response.success);
                                }
                            ]
                        ],
                        validate: function() {
                            return s[t] && s[t].box && o[e].innerElement;
                        },
                        init: function() {
                            s.setFocusToElement(s[t].box, o[e].innerElement);
                        }
                    });
                }
                getKeyboardNavigation() {
                    return [
                        this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(t, e) {
                            e.zoomOut();
                        }),
                        this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(t, e) {
                            return e.drillUp(), t.response.prev;
                        }),
                        this.getMapZoomNavigation()
                    ];
                }
            };
        }), i(e, "Accessibility/HighContrastMode.js", [
            e["Core/Globals.js"]
        ], function(t) {
            let { doc: e, isMS: i, win: n } = t;
            return {
                isHighContrastModeActive: function() {
                    let t = /(Edg)/.test(n.navigator.userAgent);
                    if (n.matchMedia && t) return n.matchMedia("(-ms-high-contrast: active)").matches;
                    if (i && n.getComputedStyle) {
                        let t = e.createElement("div");
                        t.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", e.body.appendChild(t);
                        let i = (t.currentStyle || n.getComputedStyle(t)).backgroundImage;
                        return e.body.removeChild(t), "none" === i;
                    }
                    return n.matchMedia && n.matchMedia("(forced-colors: active)").matches;
                },
                setHighContrastTheme: function(t) {
                    t.highContrastModeActive = !0;
                    let e = t.options.accessibility.highContrastTheme;
                    t.update(e, !1);
                    let i = e.colors?.length > 1;
                    t.series.forEach(function(t) {
                        let n = e.plotOptions[t.type] || {}, r = i && void 0 !== t.colorIndex ? e.colors[t.colorIndex] : n.color || "window", o = {
                            color: n.color || "windowText",
                            colors: i ? e.colors : [
                                n.color || "windowText"
                            ],
                            borderColor: n.borderColor || "window",
                            fillColor: r
                        };
                        t.update(o, !1), t.points && t.points.forEach(function(t) {
                            t.options && t.options.color && t.update({
                                color: n.color || "windowText",
                                borderColor: n.borderColor || "window"
                            }, !1);
                        });
                    }), t.redraw();
                }
            };
        }), i(e, "Accessibility/HighContrastTheme.js", [], function() {
            return {
                chart: {
                    backgroundColor: "window"
                },
                title: {
                    style: {
                        color: "windowText"
                    }
                },
                subtitle: {
                    style: {
                        color: "windowText"
                    }
                },
                colorAxis: {
                    minColor: "windowText",
                    maxColor: "windowText",
                    stops: [],
                    dataClasses: []
                },
                colors: [
                    "windowText"
                ],
                xAxis: {
                    gridLineColor: "windowText",
                    labels: {
                        style: {
                            color: "windowText"
                        }
                    },
                    lineColor: "windowText",
                    minorGridLineColor: "windowText",
                    tickColor: "windowText",
                    title: {
                        style: {
                            color: "windowText"
                        }
                    }
                },
                yAxis: {
                    gridLineColor: "windowText",
                    labels: {
                        style: {
                            color: "windowText"
                        }
                    },
                    lineColor: "windowText",
                    minorGridLineColor: "windowText",
                    tickColor: "windowText",
                    title: {
                        style: {
                            color: "windowText"
                        }
                    }
                },
                tooltip: {
                    backgroundColor: "window",
                    borderColor: "windowText",
                    style: {
                        color: "windowText"
                    }
                },
                plotOptions: {
                    series: {
                        lineColor: "windowText",
                        fillColor: "window",
                        borderColor: "windowText",
                        edgeColor: "windowText",
                        borderWidth: 1,
                        dataLabels: {
                            connectorColor: "windowText",
                            color: "windowText",
                            style: {
                                color: "windowText",
                                textOutline: "none"
                            }
                        },
                        marker: {
                            lineColor: "windowText",
                            fillColor: "windowText"
                        }
                    },
                    pie: {
                        color: "window",
                        colors: [
                            "window"
                        ],
                        borderColor: "windowText",
                        borderWidth: 1
                    },
                    boxplot: {
                        fillColor: "window"
                    },
                    candlestick: {
                        lineColor: "windowText",
                        fillColor: "window"
                    },
                    errorbar: {
                        fillColor: "window"
                    }
                },
                legend: {
                    backgroundColor: "window",
                    itemStyle: {
                        color: "windowText"
                    },
                    itemHoverStyle: {
                        color: "windowText"
                    },
                    itemHiddenStyle: {
                        color: "#555"
                    },
                    title: {
                        style: {
                            color: "windowText"
                        }
                    }
                },
                credits: {
                    style: {
                        color: "windowText"
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: "windowText"
                    },
                    activeDataLabelStyle: {
                        color: "windowText"
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: "windowText",
                        theme: {
                            fill: "window"
                        }
                    }
                },
                rangeSelector: {
                    buttonTheme: {
                        fill: "window",
                        stroke: "windowText",
                        style: {
                            color: "windowText"
                        },
                        states: {
                            hover: {
                                fill: "window",
                                stroke: "windowText",
                                style: {
                                    color: "windowText"
                                }
                            },
                            select: {
                                fill: "#444",
                                stroke: "windowText",
                                style: {
                                    color: "windowText"
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: "windowText",
                    inputStyle: {
                        backgroundColor: "window",
                        color: "windowText"
                    },
                    labelStyle: {
                        color: "windowText"
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: "window",
                        borderColor: "windowText"
                    },
                    outlineColor: "windowText",
                    maskFill: "transparent",
                    series: {
                        color: "windowText",
                        lineColor: "windowText"
                    },
                    xAxis: {
                        gridLineColor: "windowText"
                    }
                },
                scrollbar: {
                    barBackgroundColor: "#444",
                    barBorderColor: "windowText",
                    buttonArrowColor: "windowText",
                    buttonBackgroundColor: "window",
                    buttonBorderColor: "windowText",
                    rifleColor: "windowText",
                    trackBackgroundColor: "window",
                    trackBorderColor: "windowText"
                }
            };
        }), i(e, "Accessibility/Options/A11yDefaults.js", [], function() {
            return {
                accessibility: {
                    enabled: !0,
                    screenReaderSection: {
                        beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>",
                        afterChartFormat: "{endOfChartMarker}",
                        axisRangeDateFormat: "%Y-%m-%d %H:%M:%S"
                    },
                    series: {
                        descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}",
                        describeSingleSeries: !1,
                        pointDescriptionEnabledThreshold: 200
                    },
                    point: {
                        valueDescriptionFormat: "{xDescription}{separator}{value}.",
                        describeNull: !0
                    },
                    landmarkVerbosity: "all",
                    linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description',
                    highContrastMode: "auto",
                    keyboardNavigation: {
                        enabled: !0,
                        focusBorder: {
                            enabled: !0,
                            hideBrowserFocusOutline: !0,
                            style: {
                                color: "#334eff",
                                lineWidth: 2,
                                borderRadius: 3
                            },
                            margin: 2
                        },
                        order: [
                            "series",
                            "zoom",
                            "rangeSelector",
                            "navigator",
                            "legend",
                            "chartMenu"
                        ],
                        wrapAround: !0,
                        seriesNavigation: {
                            skipNullPoints: !0,
                            pointNavigationEnabledThreshold: !1,
                            rememberPointFocus: !1
                        }
                    },
                    announceNewData: {
                        enabled: !1,
                        minAnnounceInterval: 5e3,
                        interruptUser: !1
                    }
                },
                legend: {
                    accessibility: {
                        enabled: !0,
                        keyboardNavigation: {
                            enabled: !0
                        }
                    }
                },
                exporting: {
                    accessibility: {
                        enabled: !0
                    }
                },
                navigator: {
                    accessibility: {
                        enabled: !0
                    }
                }
            };
        }), i(e, "Accessibility/Options/LangDefaults.js", [], function() {
            return {
                accessibility: {
                    defaultChartTitle: "Chart",
                    chartContainerLabel: "{title}. Highcharts interactive chart.",
                    svgContainerLabel: "Interactive chart",
                    drillUpButton: "{buttonText}",
                    credits: "Chart credits: {creditsStr}",
                    thousandsSep: ",",
                    svgContainerTitle: "",
                    graphicContainerLabel: "",
                    screenReaderSection: {
                        beforeRegionLabel: "",
                        afterRegionLabel: "",
                        annotations: {
                            heading: "Chart annotations summary",
                            descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}",
                            descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}",
                            descriptionNoPoints: "{annotationText}"
                        },
                        endOfChartMarker: "End of interactive chart."
                    },
                    sonification: {
                        playAsSoundButtonText: "Play as sound, {chartTitle}",
                        playAsSoundClickAnnouncement: "Play"
                    },
                    legend: {
                        legendLabelNoTitle: "Toggle series visibility, {chartTitle}",
                        legendLabel: "Chart legend: {legendTitle}",
                        legendItem: "Show {itemName}"
                    },
                    zoom: {
                        mapZoomIn: "Zoom chart",
                        mapZoomOut: "Zoom out chart",
                        resetZoomButton: "Reset zoom"
                    },
                    rangeSelector: {
                        dropdownLabel: "{rangeTitle}",
                        minInputLabel: "Select start date.",
                        maxInputLabel: "Select end date.",
                        clickButtonAnnouncement: "Viewing {axisRangeDescription}"
                    },
                    navigator: {
                        handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}",
                        groupLabel: "Axis zoom",
                        changeAnnouncement: "{axisRangeDescription}"
                    },
                    table: {
                        viewAsDataTableButtonText: "View as data table, {chartTitle}",
                        tableSummary: "Table representation of chart."
                    },
                    announceNewData: {
                        newDataAnnounce: "Updated data for chart {chartTitle}",
                        newSeriesAnnounceSingle: "New data series: {seriesDesc}",
                        newPointAnnounceSingle: "New data point: {pointDesc}",
                        newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}",
                        newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}"
                    },
                    seriesTypeDescriptions: {
                        boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.",
                        arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.",
                        areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.",
                        bubble: "Bubble charts are scatter charts where each data point also has a size value.",
                        columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.",
                        errorbar: "Errorbar series are used to display the variability of the data.",
                        funnel: "Funnel charts are used to display reduction of data in stages.",
                        pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.",
                        waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value."
                    },
                    chartTypes: {
                        emptyChart: "Empty chart",
                        mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.",
                        unknownMap: "Map of unspecified region with {numSeries} data series.",
                        combinationChart: "Combination chart with {numSeries} data series.",
                        defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",
                        defaultMultiple: "Chart with {numSeries} data series.",
                        splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",
                        splineMultiple: "Line chart with {numSeries} lines.",
                        lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",
                        lineMultiple: "Line chart with {numSeries} lines.",
                        columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.",
                        columnMultiple: "Bar chart with {numSeries} data series.",
                        barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.",
                        barMultiple: "Bar chart with {numSeries} data series.",
                        pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.",
                        pieMultiple: "Pie chart with {numSeries} pies.",
                        scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.",
                        scatterMultiple: "Scatter chart with {numSeries} data series.",
                        boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.",
                        boxplotMultiple: "Boxplot with {numSeries} data series.",
                        bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.",
                        bubbleMultiple: "Bubble chart with {numSeries} data series."
                    },
                    axis: {
                        xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}",
                        xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.",
                        yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}",
                        yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.",
                        timeRangeDays: "Data range: {range} days.",
                        timeRangeHours: "Data range: {range} hours.",
                        timeRangeMinutes: "Data range: {range} minutes.",
                        timeRangeSeconds: "Data range: {range} seconds.",
                        rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.",
                        rangeCategories: "Data range: {numCategories} categories."
                    },
                    exporting: {
                        chartMenuLabel: "Chart menu",
                        menuButtonLabel: "View chart menu, {chartTitle}"
                    },
                    series: {
                        summary: {
                            default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                            columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                            bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                            barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",
                            pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.",
                            pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.",
                            scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.",
                            scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.",
                            boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.",
                            boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.",
                            bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",
                            bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",
                            map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.",
                            mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.",
                            mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",
                            mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",
                            mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}."
                        },
                        description: "{description}",
                        xAxisDescription: "X axis, {name}",
                        yAxisDescription: "Y axis, {name}",
                        nullPointValue: "No value",
                        pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}"
                    }
                }
            };
        }), i(e, "Accessibility/Options/DeprecatedOptions.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            let { error: e, pick: i } = t;
            function n(t, e, n) {
                let r, o = t, s = 0;
                for(; s < e.length - 1; ++s)o = o[r = e[s]] = i(o[r], {});
                o[e[e.length - 1]] = n;
            }
            function r(t, i, r, o) {
                function s(t, e) {
                    return e.reduce(function(t, e) {
                        return t[e];
                    }, t);
                }
                let a = s(t.options, i), l = s(t.options, r);
                Object.keys(o).forEach(function(s) {
                    let h = a[s];
                    void 0 !== h && (n(l, o[s], h), e(32, !1, t, {
                        [i.join(".") + "." + s]: r.join(".") + "." + o[s].join(".")
                    }));
                });
            }
            return function(t) {
                (function(t) {
                    let i = t.options.chart, n = t.options.accessibility || {};
                    [
                        "description",
                        "typeDescription"
                    ].forEach(function(r) {
                        i[r] && (n[r] = i[r], e(32, !1, t, {
                            [`chart.${r}`]: `use accessibility.${r}`
                        }));
                    });
                })(t), function(t) {
                    t.axes.forEach(function(i) {
                        let n = i.options;
                        n && n.description && (n.accessibility = n.accessibility || {}, n.accessibility.description = n.description, e(32, !1, t, {
                            "axis.description": "use axis.accessibility.description"
                        }));
                    });
                }(t), t.series && function(t) {
                    let i = {
                        description: [
                            "accessibility",
                            "description"
                        ],
                        exposeElementToA11y: [
                            "accessibility",
                            "exposeAsGroupOnly"
                        ],
                        pointDescriptionFormatter: [
                            "accessibility",
                            "point",
                            "descriptionFormatter"
                        ],
                        skipKeyboardNavigation: [
                            "accessibility",
                            "keyboardNavigation",
                            "enabled"
                        ],
                        "accessibility.pointDescriptionFormatter": [
                            "accessibility",
                            "point",
                            "descriptionFormatter"
                        ]
                    };
                    t.series.forEach(function(r) {
                        Object.keys(i).forEach(function(o) {
                            let s = r.options[o];
                            "accessibility.pointDescriptionFormatter" === o && (s = r.options.accessibility && r.options.accessibility.pointDescriptionFormatter), void 0 !== s && (n(r.options, i[o], "skipKeyboardNavigation" === o ? !s : s), e(32, !1, t, {
                                [`series.${o}`]: "series." + i[o].join(".")
                            }));
                        });
                    });
                }(t), r(t, [
                    "accessibility"
                ], [
                    "accessibility"
                ], {
                    pointDateFormat: [
                        "point",
                        "dateFormat"
                    ],
                    pointDateFormatter: [
                        "point",
                        "dateFormatter"
                    ],
                    pointDescriptionFormatter: [
                        "point",
                        "descriptionFormatter"
                    ],
                    pointDescriptionThreshold: [
                        "series",
                        "pointDescriptionEnabledThreshold"
                    ],
                    pointNavigationThreshold: [
                        "keyboardNavigation",
                        "seriesNavigation",
                        "pointNavigationEnabledThreshold"
                    ],
                    pointValueDecimals: [
                        "point",
                        "valueDecimals"
                    ],
                    pointValuePrefix: [
                        "point",
                        "valuePrefix"
                    ],
                    pointValueSuffix: [
                        "point",
                        "valueSuffix"
                    ],
                    screenReaderSectionFormatter: [
                        "screenReaderSection",
                        "beforeChartFormatter"
                    ],
                    describeSingleSeries: [
                        "series",
                        "describeSingleSeries"
                    ],
                    seriesDescriptionFormatter: [
                        "series",
                        "descriptionFormatter"
                    ],
                    onTableAnchorClick: [
                        "screenReaderSection",
                        "onViewDataTableClick"
                    ],
                    axisRangeDateFormat: [
                        "screenReaderSection",
                        "axisRangeDateFormat"
                    ]
                }), r(t, [
                    "accessibility",
                    "keyboardNavigation"
                ], [
                    "accessibility",
                    "keyboardNavigation",
                    "seriesNavigation"
                ], {
                    skipNullPoints: [
                        "skipNullPoints"
                    ],
                    mode: [
                        "mode"
                    ]
                }), r(t, [
                    "lang",
                    "accessibility"
                ], [
                    "lang",
                    "accessibility"
                ], {
                    legendItem: [
                        "legend",
                        "legendItem"
                    ],
                    legendLabel: [
                        "legend",
                        "legendLabel"
                    ],
                    mapZoomIn: [
                        "zoom",
                        "mapZoomIn"
                    ],
                    mapZoomOut: [
                        "zoom",
                        "mapZoomOut"
                    ],
                    resetZoomButton: [
                        "zoom",
                        "resetZoomButton"
                    ],
                    screenReaderRegionLabel: [
                        "screenReaderSection",
                        "beforeRegionLabel"
                    ],
                    rangeSelectorButton: [
                        "rangeSelector",
                        "buttonText"
                    ],
                    rangeSelectorMaxInput: [
                        "rangeSelector",
                        "maxInputLabel"
                    ],
                    rangeSelectorMinInput: [
                        "rangeSelector",
                        "minInputLabel"
                    ],
                    svgContainerEnd: [
                        "screenReaderSection",
                        "endOfChartMarker"
                    ],
                    viewAsDataTable: [
                        "table",
                        "viewAsDataTableButtonText"
                    ],
                    tableSummary: [
                        "table",
                        "tableSummary"
                    ]
                });
            };
        }), i(e, "Accessibility/Accessibility.js", [
            e["Core/Defaults.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"],
            e["Accessibility/Utils/HTMLUtilities.js"],
            e["Accessibility/A11yI18n.js"],
            e["Accessibility/Components/ContainerComponent.js"],
            e["Accessibility/FocusBorder.js"],
            e["Accessibility/Components/InfoRegionsComponent.js"],
            e["Accessibility/KeyboardNavigation.js"],
            e["Accessibility/Components/LegendComponent.js"],
            e["Accessibility/Components/MenuComponent.js"],
            e["Accessibility/Components/NavigatorComponent.js"],
            e["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"],
            e["Accessibility/ProxyProvider.js"],
            e["Accessibility/Components/RangeSelectorComponent.js"],
            e["Accessibility/Components/SeriesComponent/SeriesComponent.js"],
            e["Accessibility/Components/ZoomComponent.js"],
            e["Accessibility/HighContrastMode.js"],
            e["Accessibility/HighContrastTheme.js"],
            e["Accessibility/Options/A11yDefaults.js"],
            e["Accessibility/Options/LangDefaults.js"],
            e["Accessibility/Options/DeprecatedOptions.js"]
        ], function(t, e, i, n, r, o, s, a, l, h, c, d, u, p, f, g, m, b, y, x, v, w) {
            let { defaultOptions: C } = t, { doc: S } = e, { addEvent: k, extend: A, fireEvent: E, merge: M } = i, { removeElement: T } = n;
            class P {
                constructor(t){
                    this.init(t);
                }
                init(t) {
                    if (this.chart = t, !S.addEventListener) return this.zombie = !0, this.components = {}, void t.renderTo.setAttribute("aria-hidden", !0);
                    w(t), this.proxyProvider = new p(this.chart), this.initComponents(), this.keyboardNavigation = new l(t, this.components);
                }
                initComponents() {
                    let t = this.chart, e = this.proxyProvider, i = t.options.accessibility;
                    this.components = {
                        container: new o,
                        infoRegions: new a,
                        legend: new h,
                        chartMenu: new c,
                        rangeSelector: new f,
                        series: new g,
                        zoom: new m,
                        navigator: new d
                    }, i.customComponents && A(this.components, i.customComponents);
                    let n = this.components;
                    this.getComponentOrder().forEach(function(i) {
                        n[i].initBase(t, e), n[i].init();
                    });
                }
                getComponentOrder() {
                    return this.components ? this.components.series ? [
                        "series"
                    ].concat(Object.keys(this.components).filter((t)=>"series" !== t)) : Object.keys(this.components) : [];
                }
                update() {
                    let t = this.components, e = this.chart, i = e.options.accessibility;
                    E(e, "beforeA11yUpdate"), e.types = this.getChartTypes();
                    let n = i.keyboardNavigation.order;
                    this.proxyProvider.updateGroupOrder(n), this.getComponentOrder().forEach(function(i) {
                        t[i].onChartUpdate(), E(e, "afterA11yComponentUpdate", {
                            name: i,
                            component: t[i]
                        });
                    }), this.keyboardNavigation.update(n), !e.highContrastModeActive && !1 !== i.highContrastMode && (b.isHighContrastModeActive() || !0 === i.highContrastMode) && b.setHighContrastTheme(e), E(e, "afterA11yUpdate", {
                        accessibility: this
                    });
                }
                destroy() {
                    let t = this.chart || {}, e = this.components;
                    Object.keys(e).forEach(function(t) {
                        e[t].destroy(), e[t].destroyBase();
                    }), this.proxyProvider && this.proxyProvider.destroy(), t.announcerContainer && T(t.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), t.renderTo && t.renderTo.setAttribute("aria-hidden", !0), t.focusElement && t.focusElement.removeFocusBorder();
                }
                getChartTypes() {
                    let t = {};
                    return this.chart.series.forEach(function(e) {
                        t[e.type] = 1;
                    }), Object.keys(t);
                }
            }
            return function(t) {
                function e() {
                    this.accessibility && this.accessibility.destroy();
                }
                function i() {
                    this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
                    let t = this.accessibility;
                    t && !t.zombie && (t.proxyProvider.updateProxyElementPositions(), t.getComponentOrder().forEach(function(e) {
                        t.components[e].onChartRender();
                    }));
                }
                function n(t) {
                    let e = t.options.accessibility;
                    e && (e.customComponents && (this.options.accessibility.customComponents = e.customComponents, delete e.customComponents), M(!0, this.options.accessibility, e), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
                }
                function o() {
                    let e = this.accessibility, i = this.options.accessibility, n = this.renderer.boxWrapper.element, r = this.title;
                    if (i && i.enabled) e && !e.zombie ? e.update() : (this.accessibility = e = new t(this), e && !e.zombie && e.update(), "img" === n.getAttribute("role") && n.removeAttribute("role"));
                    else if (e) e.destroy && e.destroy(), delete this.accessibility;
                    else {
                        this.renderTo.setAttribute("role", "img"), this.renderTo.setAttribute("aria-hidden", !1), this.renderTo.setAttribute("aria-label", (r && r.element.textContent || "").replace(/</g, "&lt;")), n.setAttribute("aria-hidden", !0);
                        let t = document.getElementsByClassName("highcharts-description")[0];
                        t && (t.setAttribute("aria-hidden", !1), t.classList.remove("highcharts-linked-description"));
                    }
                }
                function a() {
                    this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
                }
                t.i18nFormat = r.i18nFormat, t.compose = function(t, d, p, m, b, y) {
                    l.compose(t), u.compose(m), h.compose(t, d), c.compose(t), g.compose(t, p, m), r.compose(t), s.compose(t, b), y && f.compose(t, y);
                    let x = t.prototype;
                    x.updateA11yEnabled || (x.updateA11yEnabled = o, k(t, "destroy", e), k(t, "render", i), k(t, "update", n), [
                        "addSeries",
                        "init"
                    ].forEach((e)=>{
                        k(t, e, function() {
                            this.a11yDirty = !0;
                        });
                    }), [
                        "afterApplyDrilldown",
                        "drillupall"
                    ].forEach((e)=>{
                        k(t, e, function() {
                            let t = this.accessibility;
                            t && !t.zombie && t.update();
                        });
                    }), k(p, "update", a), [
                        "update",
                        "updatedData",
                        "remove"
                    ].forEach((t)=>{
                        k(m, t, function() {
                            this.chart.accessibility && (this.chart.a11yDirty = !0);
                        });
                    }));
                };
            }(P || (P = {})), M(!0, C, x, {
                accessibility: {
                    highContrastTheme: y
                },
                lang: v
            }), P;
        }), i(e, "masters/modules/accessibility.src.js", [
            e["Core/Globals.js"],
            e["Accessibility/Accessibility.js"],
            e["Accessibility/AccessibilityComponent.js"],
            e["Accessibility/Utils/ChartUtilities.js"],
            e["Accessibility/Utils/HTMLUtilities.js"],
            e["Accessibility/KeyboardNavigationHandler.js"],
            e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]
        ], function(t, e, i, n, r, o, s) {
            return t.i18nFormat = e.i18nFormat, t.A11yChartUtilities = n, t.A11yHTMLUtilities = r, t.AccessibilityComponent = i, t.KeyboardNavigationHandler = o, t.SeriesAccessibilityDescriber = s, e.compose(t.Chart, t.Legend, t.Point, t.Series, t.SVGElement, t.RangeSelector), t;
        });
    }, t.exports ? (e.default = e, t.exports = e) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}(Pr)), Pr.exports), Or = b(Lr), Dr = {
    exports: {}
};
var jr, Nr = (Rr || (Rr = 1, function(t) {
    var e;
    e = function(t) {
        var e = t ? t._modules : {};
        function i(e, i, n, r) {
            e.hasOwnProperty(i) || (e[i] = r.apply(null, n), "function" == typeof CustomEvent && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
                detail: {
                    path: i,
                    module: e[i]
                }
            })));
        }
        i(e, "Core/Axis/BrokenAxis.js", [
            e["Core/Axis/Stacking/StackItem.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            var i;
            let { addEvent: n, find: r, fireEvent: o, isArray: s, isNumber: a, pick: l } = e;
            return function(e) {
                function i() {
                    void 0 !== this.brokenAxis && this.brokenAxis.setBreaks(this.options.breaks, !1);
                }
                function h() {
                    this.brokenAxis?.hasBreaks && (this.options.ordinal = !1);
                }
                function c() {
                    let t = this.brokenAxis;
                    if (t?.hasBreaks) {
                        let e = this.tickPositions, i = this.tickPositions.info, n = [];
                        for(let i = 0; i < e.length; i++)t.isInAnyBreak(e[i]) || n.push(e[i]);
                        this.tickPositions = n, this.tickPositions.info = i;
                    }
                }
                function d() {
                    this.brokenAxis || (this.brokenAxis = new m(this));
                }
                function u() {
                    let { isDirty: t, options: { connectNulls: e }, points: i, xAxis: n, yAxis: r } = this;
                    if (t) {
                        let t = i.length;
                        for(; t--;){
                            let o = i[t], s = !(null === o.y && !1 === e) && (n?.brokenAxis?.isInAnyBreak(o.x, !0) || r?.brokenAxis?.isInAnyBreak(o.y, !0));
                            o.visible = !s && !1 !== o.options.visible;
                        }
                    }
                }
                function p() {
                    this.drawBreaks(this.xAxis, [
                        "x"
                    ]), this.drawBreaks(this.yAxis, l(this.pointArrayMap, [
                        "y"
                    ]));
                }
                function f(t, e) {
                    let i, n, r, s = this, h = s.points;
                    if (t?.brokenAxis?.hasBreaks) {
                        let c = t.brokenAxis;
                        e.forEach(function(e) {
                            i = c?.breakArray || [], n = t.isXAxis ? t.min : l(s.options.threshold, t.min);
                            let d = t?.options?.breaks?.filter(function(t) {
                                let e = !0;
                                for(let n = 0; n < i.length; n++){
                                    let r = i[n];
                                    if (r.from === t.from && r.to === t.to) {
                                        e = !1;
                                        break;
                                    }
                                }
                                return e;
                            });
                            h.forEach(function(s) {
                                r = l(s["stack" + e.toUpperCase()], s[e]), i.forEach(function(e) {
                                    if (a(n) && a(r)) {
                                        let i = "";
                                        n < e.from && r > e.to || n > e.from && r < e.from ? i = "pointBreak" : (n < e.from && r > e.from && r < e.to || n > e.from && r > e.to && r < e.from) && (i = "pointInBreak"), i && o(t, i, {
                                            point: s,
                                            brk: e
                                        });
                                    }
                                }), d?.forEach(function(e) {
                                    o(t, "pointOutsideOfBreak", {
                                        point: s,
                                        brk: e
                                    });
                                });
                            });
                        });
                    }
                }
                function g() {
                    let e = this.currentDataGrouping, i = e?.gapSize, n = this.points.slice(), r = this.yAxis, o = this.options.gapSize, s = n.length - 1;
                    if (o && s > 0) {
                        let e, a;
                        for("value" !== this.options.gapUnit && (o *= this.basePointRange), i && i > o && i >= this.basePointRange && (o = i); s--;)if (a && !1 !== a.visible || (a = n[s + 1]), e = n[s], !1 !== a.visible && !1 !== e.visible) {
                            if (a.x - e.x > o) {
                                let i = (e.x + a.x) / 2;
                                n.splice(s + 1, 0, {
                                    isNull: !0,
                                    x: i
                                }), r.stacking && this.options.stacking && ((r.stacking.stacks[this.stackKey][i] = new t(r, r.options.stackLabels, !1, i, this.stack)).total = 0);
                            }
                            a = e;
                        }
                    }
                    return this.getGraphPath(n);
                }
                e.compose = function(t, e) {
                    if (!t.keepProps.includes("brokenAxis")) {
                        t.keepProps.push("brokenAxis"), n(t, "init", d), n(t, "afterInit", i), n(t, "afterSetTickPositions", c), n(t, "afterSetOptions", h);
                        let r = e.prototype;
                        r.drawBreaks = f, r.gappedPath = g, n(e, "afterGeneratePoints", u), n(e, "afterRender", p);
                    }
                    return t;
                };
                class m {
                    static isInBreak(t, e) {
                        let i = t.repeat || 1 / 0, n = t.from, r = t.to - t.from, o = e >= n ? (e - n) % i : i - (n - e) % i;
                        return t.inclusive ? o <= r : o < r && 0 !== o;
                    }
                    static lin2Val(t) {
                        let e = this.brokenAxis, i = e && e.breakArray;
                        if (!i || !a(t)) return t;
                        let n, r, o = t;
                        for(r = 0; r < i.length && !((n = i[r]).from >= o); r++)(n.to < o || m.isInBreak(n, o)) && (o += n.len);
                        return o;
                    }
                    static val2Lin(t) {
                        let e = this.brokenAxis, i = e && e.breakArray;
                        if (!i || !a(t)) return t;
                        let n, r, o = t;
                        for(r = 0; r < i.length; r++)if ((n = i[r]).to <= t) o -= n.len;
                        else {
                            if (n.from >= t) break;
                            if (m.isInBreak(n, t)) {
                                o -= t - n.from;
                                break;
                            }
                        }
                        return o;
                    }
                    constructor(t){
                        this.hasBreaks = !1, this.axis = t;
                    }
                    findBreakAt(t, e) {
                        return r(e, function(e) {
                            return e.from < t && t < e.to;
                        });
                    }
                    isInAnyBreak(t, e) {
                        let i, n, r, o = this.axis, s = o.options.breaks || [], h = s.length;
                        if (h && a(t)) {
                            for(; h--;)m.isInBreak(s[h], t) && (i = !0, n || (n = l(s[h].showPoints, !o.isXAxis)));
                            r = i && e ? i && !n : i;
                        }
                        return r;
                    }
                    setBreaks(t, e) {
                        let i = this, n = i.axis, r = s(t) && !!t.length && !!Object.keys(t[0]).length;
                        n.isDirty = i.hasBreaks !== r, i.hasBreaks = r, t !== n.options.breaks && (n.options.breaks = n.userOptions.breaks = t), n.forceRedraw = !0, n.series.forEach(function(t) {
                            t.isDirty = !0;
                        }), r || n.val2lin !== m.val2Lin || (delete n.val2lin, delete n.lin2val), r && (n.userOptions.ordinal = !1, n.lin2val = m.lin2Val, n.val2lin = m.val2Lin, n.setExtremes = function(t, e, r, o, s) {
                            if (i.hasBreaks) {
                                let n, r = this.options.breaks || [];
                                for(; n = i.findBreakAt(t, r);)t = n.to;
                                for(; n = i.findBreakAt(e, r);)e = n.from;
                                e < t && (e = t);
                            }
                            n.constructor.prototype.setExtremes.call(this, t, e, r, o, s);
                        }, n.setAxisTranslation = function() {
                            if (n.constructor.prototype.setAxisTranslation.call(this), i.unitLength = void 0, i.hasBreaks) {
                                let t, e, r, s, h = n.options.breaks || [], c = [], d = [], u = l(n.pointRangePadding, 0), p = 0, f = n.userMin || n.min, g = n.userMax || n.max;
                                h.forEach(function(t) {
                                    e = t.repeat || 1 / 0, a(f) && a(g) && (m.isInBreak(t, f) && (f += t.to % e - f % e), m.isInBreak(t, g) && (g -= g % e - t.from % e));
                                }), h.forEach(function(t) {
                                    if (r = t.from, e = t.repeat || 1 / 0, a(f) && a(g)) {
                                        for(; r - e > f;)r -= e;
                                        for(; r < f;)r += e;
                                        for(s = r; s < g; s += e)c.push({
                                            value: s,
                                            move: "in"
                                        }), c.push({
                                            value: s + t.to - t.from,
                                            move: "out",
                                            size: t.breakSize
                                        });
                                    }
                                }), c.sort(function(t, e) {
                                    return t.value === e.value ? ("in" === t.move ? 0 : 1) - ("in" === e.move ? 0 : 1) : t.value - e.value;
                                }), t = 0, r = f, c.forEach(function(e) {
                                    1 === (t += "in" === e.move ? 1 : -1) && "in" === e.move && (r = e.value), 0 === t && a(r) && (d.push({
                                        from: r,
                                        to: e.value,
                                        len: e.value - r - (e.size || 0)
                                    }), p += e.value - r - (e.size || 0));
                                }), i.breakArray = d, a(f) && a(g) && a(n.min) && (i.unitLength = g - f - p + u, o(n, "afterBreaks"), n.staticScale ? n.transA = n.staticScale : i.unitLength && (n.transA *= (g - n.min + u) / i.unitLength), u && (n.minPixelPadding = n.transA * (n.minPointOffset || 0)), n.min = f, n.max = g);
                            }
                        }), l(e, !0) && n.chart.redraw();
                    }
                }
                e.Additions = m;
            }(i || (i = {})), i;
        }), i(e, "masters/modules/broken-axis.src.js", [
            e["Core/Globals.js"],
            e["Core/Axis/BrokenAxis.js"]
        ], function(t, e) {
            return t.BrokenAxis = t.BrokenAxis || e, t.BrokenAxis.compose(t.Axis, t.Series), t;
        });
    }, t.exports ? (e.default = e, t.exports = e) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}(Dr)), Dr.exports), Ir = b(Nr), Br = {
    exports: {}
};
var Fr, zr = (jr || (jr = 1, function(t) {
    var e;
    e = function(t) {
        var e = t ? t._modules : {};
        function i(e, i, n, r) {
            e.hasOwnProperty(i) || (e[i] = r.apply(null, n), "function" == typeof CustomEvent && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
                detail: {
                    path: i,
                    module: e[i]
                }
            })));
        }
        i(e, "Extensions/Annotations/AnnotationChart.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            var e;
            let { addEvent: i, erase: n, find: r, fireEvent: o, pick: s, wrap: a } = t;
            function l(t, e) {
                let i = this.initAnnotation(t);
                return this.options.annotations.push(i.options), s(e, !0) && (i.redraw(), i.graphic.attr({
                    opacity: 1
                })), i;
            }
            function h() {
                let t = this;
                t.plotBoxClip = this.renderer.clipRect(this.plotBox), t.controlPointsGroup = t.renderer.g("control-points").attr({
                    zIndex: 99
                }).clip(t.plotBoxClip).add(), t.options.annotations.forEach((e, i)=>{
                    if (!t.annotations.some((t)=>t.options === e)) {
                        let n = t.initAnnotation(e);
                        t.options.annotations[i] = n.options;
                    }
                }), t.drawAnnotations(), i(t, "redraw", t.drawAnnotations), i(t, "destroy", function() {
                    t.plotBoxClip.destroy(), t.controlPointsGroup.destroy();
                }), i(t, "exportData", function(e) {
                    let i = t.annotations, n = (this.options.exporting && this.options.exporting.csv || {}).columnHeaderFormatter, r = !e.dataRows[1].xValues, o = t.options.lang && t.options.lang.exportData && t.options.lang.exportData.annotationHeader, s = e.dataRows[0].length, a = t.options.exporting && t.options.exporting.csv && t.options.exporting.csv.annotations && t.options.exporting.csv.annotations.itemDelimiter, l = t.options.exporting && t.options.exporting.csv && t.options.exporting.csv.annotations && t.options.exporting.csv.annotations.join;
                    i.forEach((t)=>{
                        t.options.labelOptions && t.options.labelOptions.includeInDataExport && t.labels.forEach((t)=>{
                            if (t.options.text) {
                                let i = t.options.text;
                                t.points.forEach((t)=>{
                                    let n = t.x, r = t.series.xAxis ? t.series.xAxis.index : -1, o = !1;
                                    if (-1 === r) {
                                        let t = e.dataRows[0].length, s = Array(t);
                                        for(let e = 0; e < t; ++e)s[e] = "";
                                        s.push(i), s.xValues = [], s.xValues[r] = n, e.dataRows.push(s), o = !0;
                                    }
                                    if (o || e.dataRows.forEach((t)=>{
                                        !o && t.xValues && void 0 !== r && n === t.xValues[r] && (l && t.length > s ? t[t.length - 1] += a + i : t.push(i), o = !0);
                                    }), !o) {
                                        let t = e.dataRows[0].length, o = Array(t);
                                        for(let e = 0; e < t; ++e)o[e] = "";
                                        o[0] = n, o.push(i), o.xValues = [], void 0 !== r && (o.xValues[r] = n), e.dataRows.push(o);
                                    }
                                });
                            }
                        });
                    });
                    let h = 0;
                    e.dataRows.forEach((t)=>{
                        h = Math.max(h, t.length);
                    });
                    let c = h - e.dataRows[0].length;
                    for(let t = 0; t < c; t++){
                        let i = function(t) {
                            let e;
                            return n && !1 !== (e = n(t)) ? e : (e = o + " " + t, r ? {
                                columnTitle: e,
                                topLevelColumnTitle: e
                            } : e);
                        }(t + 1);
                        r ? (e.dataRows[0].push(i.topLevelColumnTitle), e.dataRows[1].push(i.columnTitle)) : e.dataRows[0].push(i);
                    }
                });
            }
            function c() {
                this.plotBoxClip.attr(this.plotBox), this.annotations.forEach((t)=>{
                    t.redraw(), t.graphic.animate({
                        opacity: 1
                    }, t.animationConfig);
                });
            }
            function d(t) {
                let e = this.annotations, i = "annotations" === t.coll ? t : r(e, function(e) {
                    return e.options.id === t;
                });
                i && (o(i, "remove"), n(this.options.annotations, i.options), n(e, i), i.destroy());
            }
            function u() {
                this.annotations = [], this.options.annotations || (this.options.annotations = []);
            }
            function p(t) {
                this.chart.hasDraggedAnnotation || t.apply(this, Array.prototype.slice.call(arguments, 1));
            }
            return (e || (e = {})).compose = function(t, e, n) {
                let r = e.prototype;
                if (!r.addAnnotation) {
                    let o = n.prototype;
                    i(e, "afterInit", u), r.addAnnotation = l, r.callbacks.push(h), r.collectionsWithInit.annotations = [
                        l
                    ], r.collectionsWithUpdate.push("annotations"), r.drawAnnotations = c, r.removeAnnotation = d, r.initAnnotation = function(e) {
                        let i = new (t.types[e.type] || t)(this, e);
                        return this.annotations.push(i), i;
                    }, a(o, "onContainerMouseDown", p);
                }
            }, e;
        }), i(e, "Extensions/Annotations/AnnotationDefaults.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            let { defined: e } = t;
            return {
                visible: !0,
                animation: {},
                crop: !0,
                draggable: "xy",
                labelOptions: {
                    align: "center",
                    allowOverlap: !1,
                    backgroundColor: "rgba(0, 0, 0, 0.75)",
                    borderColor: "#000000",
                    borderRadius: 3,
                    borderWidth: 1,
                    className: "highcharts-no-tooltip",
                    crop: !1,
                    formatter: function() {
                        return e(this.y) ? "" + this.y : "Annotation label";
                    },
                    includeInDataExport: !0,
                    overflow: "justify",
                    padding: 5,
                    shadow: !1,
                    shape: "callout",
                    style: {
                        fontSize: "0.7em",
                        fontWeight: "normal",
                        color: "contrast"
                    },
                    useHTML: !1,
                    verticalAlign: "bottom",
                    x: 0,
                    y: -16
                },
                shapeOptions: {
                    stroke: "rgba(0, 0, 0, 0.75)",
                    strokeWidth: 1,
                    fill: "rgba(0, 0, 0, 0.75)",
                    r: 0,
                    snap: 2
                },
                controlPointOptions: {
                    events: {},
                    style: {
                        cursor: "pointer",
                        fill: "#ffffff",
                        stroke: "#000000",
                        "stroke-width": 2
                    },
                    height: 10,
                    symbol: "circle",
                    visible: !1,
                    width: 10
                },
                events: {},
                zIndex: 6
            };
        }), i(e, "Extensions/Annotations/EventEmitter.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { doc: i, isTouchDevice: n } = t, { addEvent: r, fireEvent: o, objectEach: s, pick: a, removeEvent: l } = e;
            return class {
                addEvents() {
                    let t = this, e = function(e) {
                        r(e, n ? "touchstart" : "mousedown", (e)=>{
                            t.onMouseDown(e);
                        }, {
                            passive: !1
                        });
                    };
                    if (e(this.graphic.element), (t.labels || []).forEach((t)=>{
                        t.options.useHTML && t.graphic.text && e(t.graphic.text.element);
                    }), s(t.options.events, (e, i)=>{
                        let n = function(n) {
                            "click" === i && t.cancelClick || e.call(t, t.chart.pointer?.normalize(n), t.target);
                        };
                        -1 === (t.nonDOMEvents || []).indexOf(i) ? (r(t.graphic.element, i, n, {
                            passive: !1
                        }), t.graphic.div && r(t.graphic.div, i, n, {
                            passive: !1
                        })) : r(t, i, n, {
                            passive: !1
                        });
                    }), t.options.draggable && (r(t, "drag", t.onDrag), !t.graphic.renderer.styledMode)) {
                        let e = {
                            cursor: {
                                x: "ew-resize",
                                y: "ns-resize",
                                xy: "move"
                            }[t.options.draggable]
                        };
                        t.graphic.css(e), (t.labels || []).forEach((t)=>{
                            t.options.useHTML && t.graphic.text && t.graphic.text.css(e);
                        });
                    }
                    t.isUpdating || o(t, "add");
                }
                destroy() {
                    this.removeDocEvents(), l(this), this.hcEvents = null;
                }
                mouseMoveToRadians(t, e, i) {
                    let n, r = t.prevChartY - i, o = t.prevChartX - e, s = t.chartY - i, a = t.chartX - e;
                    return this.chart.inverted && (n = o, o = r, r = n, n = a, a = s, s = n), Math.atan2(s, a) - Math.atan2(r, o);
                }
                mouseMoveToScale(t, e, i) {
                    let n = t.prevChartX - e, r = t.prevChartY - i, o = (t.chartX - e || 1) / (n || 1), s = (t.chartY - i || 1) / (r || 1);
                    if (this.chart.inverted) {
                        let t = s;
                        s = o, o = t;
                    }
                    return {
                        x: o,
                        y: s
                    };
                }
                mouseMoveToTranslation(t) {
                    let e, i = t.chartX - t.prevChartX, n = t.chartY - t.prevChartY;
                    return this.chart.inverted && (e = n, n = i, i = e), {
                        x: i,
                        y: n
                    };
                }
                onDrag(t) {
                    if (this.chart.isInsidePlot(t.chartX - this.chart.plotLeft, t.chartY - this.chart.plotTop, {
                        visiblePlotOnly: !0
                    })) {
                        let e = this.mouseMoveToTranslation(t);
                        "x" === this.options.draggable && (e.y = 0), "y" === this.options.draggable && (e.x = 0), this.points.length ? this.translate(e.x, e.y) : (this.shapes.forEach((t)=>t.translate(e.x, e.y)), this.labels.forEach((t)=>t.translate(e.x, e.y))), this.redraw(!1);
                    }
                }
                onMouseDown(t) {
                    if (t.preventDefault && t.preventDefault(), 2 === t.button) return;
                    let e = this, s = e.chart.pointer, l = t?.sourceCapabilities?.firesTouchEvents || !1, h = (t = s?.normalize(t) || t).chartX, c = t.chartY;
                    e.cancelClick = !1, e.chart.hasDraggedAnnotation = !0, e.removeDrag = r(i, n || l ? "touchmove" : "mousemove", function(t) {
                        e.hasDragged = !0, (t = s?.normalize(t) || t).prevChartX = h, t.prevChartY = c, o(e, "drag", t), h = t.chartX, c = t.chartY;
                    }, n || l ? {
                        passive: !1
                    } : void 0), e.removeMouseUp = r(i, n || l ? "touchend" : "mouseup", function() {
                        let t = a(e.target && e.target.annotation, e.target);
                        t && (t.cancelClick = e.hasDragged), e.cancelClick = e.hasDragged, e.chart.hasDraggedAnnotation = !1, e.hasDragged && o(a(t, e), "afterUpdate"), e.hasDragged = !1, e.onMouseUp();
                    }, n || l ? {
                        passive: !1
                    } : void 0);
                }
                onMouseUp() {
                    this.removeDocEvents();
                }
                removeDocEvents() {
                    this.removeDrag && (this.removeDrag = this.removeDrag()), this.removeMouseUp && (this.removeMouseUp = this.removeMouseUp());
                }
            };
        }), i(e, "Extensions/Annotations/ControlPoint.js", [
            e["Extensions/Annotations/EventEmitter.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { merge: i, pick: n } = e;
            return class extends t {
                constructor(t, e, i, r){
                    super(), this.nonDOMEvents = [
                        "drag"
                    ], this.chart = t, this.target = e, this.options = i, this.index = n(i.index, r);
                }
                destroy() {
                    super.destroy(), this.graphic && (this.graphic = this.graphic.destroy()), this.chart = null, this.target = null, this.options = null;
                }
                redraw(t) {
                    this.graphic[t ? "animate" : "attr"](this.options.positioner.call(this, this.target));
                }
                render() {
                    let t = this.chart, e = this.options;
                    this.graphic = t.renderer.symbol(e.symbol, 0, 0, e.width, e.height).add(t.controlPointsGroup).css(e.style), this.setVisibility(e.visible), this.addEvents();
                }
                setVisibility(t) {
                    this.graphic[t ? "show" : "hide"](), this.options.visible = t;
                }
                update(t) {
                    let e = this.chart, n = this.target, r = this.index, o = i(!0, this.options, t);
                    this.destroy(), this.constructor(e, n, o, r), this.render(e.controlPointsGroup), this.redraw();
                }
            };
        }), i(e, "Extensions/Annotations/MockPoint.js", [
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { series: { prototype: i } } = t, { defined: n, fireEvent: r } = e;
            class o {
                static fromPoint(t) {
                    return new o(t.series.chart, null, {
                        x: t.x,
                        y: t.y,
                        xAxis: t.series.xAxis,
                        yAxis: t.series.yAxis
                    });
                }
                static pointToPixels(t, e) {
                    let i, n = t.series, r = n.chart, o = t.plotX || 0, s = t.plotY || 0;
                    return r.inverted && (t.mock ? (o = t.plotY, s = t.plotX) : (o = r.plotWidth - (t.plotY || 0), s = r.plotHeight - (t.plotX || 0))), n && !e && (o += (i = n.getPlotBox()).translateX, s += i.translateY), {
                        x: o,
                        y: s
                    };
                }
                static pointToOptions(t) {
                    return {
                        x: t.x,
                        y: t.y,
                        xAxis: t.series.xAxis,
                        yAxis: t.series.yAxis
                    };
                }
                constructor(t, e, n){
                    this.mock = !0, this.series = {
                        visible: !0,
                        chart: t,
                        getPlotBox: i.getPlotBox
                    }, this.target = e || null, this.options = n, this.applyOptions(this.getOptions());
                }
                applyOptions(t) {
                    this.command = t.command, this.setAxis(t, "x"), this.setAxis(t, "y"), this.refresh();
                }
                getLabelConfig() {
                    return {
                        x: this.x,
                        y: this.y,
                        point: this
                    };
                }
                getOptions() {
                    return this.hasDynamicOptions() ? this.options(this.target) : this.options;
                }
                hasDynamicOptions() {
                    return "function" == typeof this.options;
                }
                isInsidePlot() {
                    let t = this.plotX, e = this.plotY, i = this.series.xAxis, o = this.series.yAxis, s = {
                        x: t,
                        y: e,
                        isInsidePlot: !0,
                        options: {}
                    };
                    return i && (s.isInsidePlot = n(t) && t >= 0 && t <= i.len), o && (s.isInsidePlot = s.isInsidePlot && n(e) && e >= 0 && e <= o.len), r(this.series.chart, "afterIsInsidePlot", s), s.isInsidePlot;
                }
                refresh() {
                    let t = this.series, e = t.xAxis, i = t.yAxis, n = this.getOptions();
                    e ? (this.x = n.x, this.plotX = e.toPixels(n.x, !0)) : (this.x = void 0, this.plotX = n.x), i ? (this.y = n.y, this.plotY = i.toPixels(n.y, !0)) : (this.y = null, this.plotY = n.y), this.isInside = this.isInsidePlot();
                }
                refreshOptions() {
                    let t = this.series, e = t.xAxis, i = t.yAxis;
                    this.x = this.options.x = e ? this.options.x = e.toValue(this.plotX, !0) : this.plotX, this.y = this.options.y = i ? i.toValue(this.plotY, !0) : this.plotY;
                }
                rotate(t, e, i) {
                    if (!this.hasDynamicOptions()) {
                        let n = Math.cos(i), r = Math.sin(i), o = this.plotX - t, s = this.plotY - e;
                        this.plotX = o * n - s * r + t, this.plotY = o * r + s * n + e, this.refreshOptions();
                    }
                }
                scale(t, e, i, n) {
                    if (!this.hasDynamicOptions()) {
                        let r = this.plotX * i, o = this.plotY * n;
                        this.plotX = (1 - i) * t + r, this.plotY = (1 - n) * e + o, this.refreshOptions();
                    }
                }
                setAxis(t, e) {
                    let i = e + "Axis", r = t[i], o = this.series.chart;
                    this.series[i] = "object" == typeof r ? r : n(r) ? o[i][r] || o.get(r) : null;
                }
                toAnchor() {
                    let t = [
                        this.plotX,
                        this.plotY,
                        0,
                        0
                    ];
                    return this.series.chart.inverted && (t[0] = this.plotY, t[1] = this.plotX), t;
                }
                translate(t, e, i, n) {
                    this.hasDynamicOptions() || (this.plotX += i, this.plotY += n, this.refreshOptions());
                }
            }
            return o;
        }), i(e, "Extensions/Annotations/ControlTarget.js", [
            e["Extensions/Annotations/ControlPoint.js"],
            e["Extensions/Annotations/MockPoint.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            var n;
            return function(n) {
                function r() {
                    let e = this.controlPoints, n = this.options.controlPoints || [];
                    n.forEach((r, o)=>{
                        let s = i.merge(this.options.controlPointOptions, r);
                        s.index || (s.index = o), n[o] = s, e.push(new t(this.chart, this, s));
                    });
                }
                function o(t) {
                    let e = t.series.getPlotBox(), n = t.series.chart, r = t.mock ? t.toAnchor() : n.tooltip && n.tooltip.getAnchor.call({
                        chart: t.series.chart
                    }, t) || [
                        0,
                        0,
                        0,
                        0
                    ], o = {
                        x: r[0] + (this.options.x || 0),
                        y: r[1] + (this.options.y || 0),
                        height: r[2] || 0,
                        width: r[3] || 0
                    };
                    return {
                        relativePosition: o,
                        absolutePosition: i.merge(o, {
                            x: o.x + (t.mock ? e.translateX : n.plotLeft),
                            y: o.y + (t.mock ? e.translateY : n.plotTop)
                        })
                    };
                }
                function s() {
                    this.controlPoints.forEach((t)=>t.destroy()), this.chart = null, this.controlPoints = null, this.points = null, this.options = null, this.annotation && (this.annotation = null);
                }
                function a() {
                    let t = this.options;
                    return t.points || t.point && i.splat(t.point);
                }
                function l() {
                    let t, e, i = this.getPointsOptions(), n = this.points, r = i && i.length || 0;
                    for(t = 0; t < r; t++){
                        if (!(e = this.point(i[t], n[t]))) return void (n.length = 0);
                        e.mock && e.refresh(), n[t] = e;
                    }
                    return n;
                }
                function h(t, n) {
                    if (t && t.series) return t;
                    if (!n || null === n.series) {
                        if (i.isObject(t)) n = new e(this.chart, this, t);
                        else if (i.isString(t)) n = this.chart.get(t) || null;
                        else if ("function" == typeof t) {
                            let i = t.call(n, this);
                            n = i.series ? i : new e(this.chart, this, t);
                        }
                    }
                    return n;
                }
                function c(t) {
                    this.controlPoints.forEach((e)=>e.redraw(t));
                }
                function d() {
                    this.controlPoints.forEach((t)=>t.render());
                }
                function u(t, e, i, n, r) {
                    if (this.chart.inverted) {
                        let t = e;
                        e = i, i = t;
                    }
                    this.points.forEach((o, s)=>this.transformPoint(t, e, i, n, r, s), this);
                }
                function p(t, i, n, r, o, s) {
                    let a = this.points[s];
                    a.mock || (a = this.points[s] = e.fromPoint(a)), a[t](i, n, r, o);
                }
                function f(t, e) {
                    this.transform("translate", null, null, t, e);
                }
                function g(t, e, i) {
                    this.transformPoint("translate", null, null, t, e, i);
                }
                n.compose = function(t) {
                    let e = t.prototype;
                    e.addControlPoints || i.merge(!0, e, {
                        addControlPoints: r,
                        anchor: o,
                        destroyControlTarget: s,
                        getPointsOptions: a,
                        linkPoints: l,
                        point: h,
                        redrawControlPoints: c,
                        renderControlPoints: d,
                        transform: u,
                        transformPoint: p,
                        translate: f,
                        translatePoint: g
                    });
                };
            }(n || (n = {})), n;
        }), i(e, "Extensions/Annotations/Controllables/Controllable.js", [
            e["Extensions/Annotations/ControlTarget.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { merge: i } = e;
            class n {
                constructor(t, e, i, n){
                    this.annotation = t, this.chart = t.chart, this.collection = "label" === n ? "labels" : "shapes", this.controlPoints = [], this.options = e, this.points = [], this.index = i, this.itemType = n, this.init(t, e, i);
                }
                attr(...t) {
                    this.graphic.attr.apply(this.graphic, arguments);
                }
                attrsFromOptions(t) {
                    let e, i, n = this.constructor.attrsMap, r = {}, o = this.chart.styledMode;
                    for(e in t)i = n[e], void 0 === n[e] || o && -1 !== [
                        "fill",
                        "stroke",
                        "stroke-width"
                    ].indexOf(i) || (r[i] = t[e]);
                    return r;
                }
                destroy() {
                    this.graphic && (this.graphic = this.graphic.destroy()), this.tracker && (this.tracker = this.tracker.destroy()), this.destroyControlTarget();
                }
                init(t, e, i) {
                    this.annotation = t, this.chart = t.chart, this.options = e, this.points = [], this.controlPoints = [], this.index = i, this.linkPoints(), this.addControlPoints();
                }
                redraw(t) {
                    this.redrawControlPoints(t);
                }
                render(t) {
                    this.options.className && this.graphic && this.graphic.addClass(this.options.className), this.renderControlPoints();
                }
                rotate(t, e, i) {
                    this.transform("rotate", t, e, i);
                }
                scale(t, e, i, n) {
                    this.transform("scale", t, e, i, n);
                }
                setControlPointsVisibility(t) {
                    this.controlPoints.forEach((e)=>{
                        e.setVisibility(t);
                    });
                }
                shouldBeDrawn() {
                    return !!this.points.length;
                }
                translateShape(t, e, i) {
                    let n = this.annotation.chart, r = this.annotation.userOptions, o = n.annotations.indexOf(this.annotation), s = n.options.annotations[o];
                    this.translatePoint(t, e, 0), i && this.translatePoint(t, e, 1), s[this.collection][this.index].point = this.options.point, r[this.collection][this.index].point = this.options.point;
                }
                update(t) {
                    let e = this.annotation, n = i(!0, this.options, t), r = this.graphic.parentGroup, o = this.constructor;
                    this.destroy(), i(!0, this, new o(e, n, this.index, this.itemType)), this.render(r), this.redraw();
                }
            }
            return t.compose(n), n;
        }), i(e, "Extensions/Annotations/Controllables/ControllableDefaults.js", [], function() {
            return {
                defaultMarkers: {
                    arrow: {
                        tagName: "marker",
                        attributes: {
                            id: "arrow",
                            refY: 5,
                            refX: 9,
                            markerWidth: 10,
                            markerHeight: 10
                        },
                        children: [
                            {
                                tagName: "path",
                                attributes: {
                                    d: "M 0 0 L 10 5 L 0 10 Z",
                                    "stroke-width": 0
                                }
                            }
                        ]
                    },
                    "reverse-arrow": {
                        tagName: "marker",
                        attributes: {
                            id: "reverse-arrow",
                            refY: 5,
                            refX: 1,
                            markerWidth: 10,
                            markerHeight: 10
                        },
                        children: [
                            {
                                tagName: "path",
                                attributes: {
                                    d: "M 0 5 L 10 0 L 10 10 Z",
                                    "stroke-width": 0
                                }
                            }
                        ]
                    }
                }
            };
        }), i(e, "Extensions/Annotations/Controllables/ControllablePath.js", [
            e["Extensions/Annotations/Controllables/Controllable.js"],
            e["Extensions/Annotations/Controllables/ControllableDefaults.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { defaultMarkers: r } = e, { addEvent: o, defined: s, extend: a, merge: l, uniqueKey: h } = n, c = p("marker-end"), d = p("marker-start"), u = "rgba(192,192,192," + (i.svg ? 1e-4 : .002) + ")";
            function p(t) {
                return function(e) {
                    this.attr(t, "url(#" + e + ")");
                };
            }
            function f() {
                this.options.defs = l(r, this.options.defs || {});
            }
            function g(t, e) {
                let i = {
                    attributes: {
                        id: t
                    }
                }, n = {
                    stroke: e.color || "none",
                    fill: e.color || "rgba(0, 0, 0, 0.75)"
                };
                i.children = e.children && e.children.map(function(t) {
                    return l(n, t);
                });
                let r = l(!0, {
                    attributes: {
                        markerWidth: 20,
                        markerHeight: 20,
                        refX: 0,
                        refY: 0,
                        orient: "auto"
                    }
                }, e, i), o = this.definition(r);
                return o.id = t, o;
            }
            class m extends t {
                static compose(t, e) {
                    let i = e.prototype;
                    i.addMarker || (o(t, "afterGetContainer", f), i.addMarker = g);
                }
                constructor(t, e, i){
                    super(t, e, i, "shape"), this.type = "path";
                }
                toD() {
                    let t = this.options.d;
                    if (t) return "function" == typeof t ? t.call(this) : t;
                    let e, i = this.points, n = i.length, r = [], o = n, s = i[0], a = o && this.anchor(s).absolutePosition, l = 0;
                    if (a) for(r.push([
                        "M",
                        a.x,
                        a.y
                    ]); ++l < n && o;)e = (s = i[l]).command || "L", a = this.anchor(s).absolutePosition, "M" === e || "L" === e ? r.push([
                        e,
                        a.x,
                        a.y
                    ]) : "Z" === e && r.push([
                        e
                    ]), o = s.series.visible;
                    return o && this.graphic ? this.chart.renderer.crispLine(r, this.graphic.strokeWidth()) : null;
                }
                shouldBeDrawn() {
                    return super.shouldBeDrawn() || !!this.options.d;
                }
                render(t) {
                    let e = this.options, i = this.attrsFromOptions(e);
                    this.graphic = this.annotation.chart.renderer.path([
                        [
                            "M",
                            0,
                            0
                        ]
                    ]).attr(i).add(t), this.tracker = this.annotation.chart.renderer.path([
                        [
                            "M",
                            0,
                            0
                        ]
                    ]).addClass("highcharts-tracker-line").attr({
                        zIndex: 2
                    }).add(t), this.annotation.chart.styledMode || this.tracker.attr({
                        "stroke-linejoin": "round",
                        stroke: u,
                        fill: u,
                        "stroke-width": this.graphic.strokeWidth() + 2 * e.snap
                    }), super.render(), a(this.graphic, {
                        markerStartSetter: d,
                        markerEndSetter: c
                    }), this.setMarkers(this);
                }
                redraw(t) {
                    if (this.graphic) {
                        let e = this.toD(), i = t ? "animate" : "attr";
                        e ? (this.graphic[i]({
                            d: e
                        }), this.tracker[i]({
                            d: e
                        })) : (this.graphic.attr({
                            d: "M 0 -9000000000"
                        }), this.tracker.attr({
                            d: "M 0 -9000000000"
                        })), this.graphic.placed = this.tracker.placed = !!e;
                    }
                    super.redraw(t);
                }
                setMarkers(t) {
                    let e = t.options, i = t.chart, n = i.options.defs, r = e.fill, o = s(r) && "none" !== r ? r : e.stroke;
                    [
                        "markerStart",
                        "markerEnd"
                    ].forEach(function(r) {
                        let s, a, c, d, u = e[r];
                        if (u) {
                            for(c in n)if ((u === ((s = n[c]).attributes && s.attributes.id) || u === s.id) && "marker" === s.tagName) {
                                a = s;
                                break;
                            }
                            a && (d = t[r] = i.renderer.addMarker((e.id || h()) + "-" + u, l(a, {
                                color: o
                            })), t.attr(r, d.getAttribute("id")));
                        }
                    });
                }
            }
            return m.attrsMap = {
                dashStyle: "dashstyle",
                strokeWidth: "stroke-width",
                stroke: "stroke",
                fill: "fill",
                zIndex: "zIndex"
            }, m;
        }), i(e, "Extensions/Annotations/Controllables/ControllableRect.js", [
            e["Extensions/Annotations/Controllables/Controllable.js"],
            e["Extensions/Annotations/Controllables/ControllablePath.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { merge: n } = i;
            class r extends t {
                constructor(t, e, i){
                    super(t, e, i, "shape"), this.type = "rect", this.translate = super.translateShape;
                }
                render(t) {
                    let e = this.attrsFromOptions(this.options);
                    this.graphic = this.annotation.chart.renderer.rect(0, -9000000000, 0, 0).attr(e).add(t), super.render();
                }
                redraw(t) {
                    if (this.graphic) {
                        let e = this.anchor(this.points[0]).absolutePosition;
                        e ? this.graphic[t ? "animate" : "attr"]({
                            x: e.x,
                            y: e.y,
                            width: this.options.width,
                            height: this.options.height
                        }) : this.attr({
                            x: 0,
                            y: -9000000000
                        }), this.graphic.placed = !!e;
                    }
                    super.redraw(t);
                }
            }
            return r.attrsMap = n(e.attrsMap, {
                width: "width",
                height: "height"
            }), r;
        }), i(e, "Extensions/Annotations/Controllables/ControllableCircle.js", [
            e["Extensions/Annotations/Controllables/Controllable.js"],
            e["Extensions/Annotations/Controllables/ControllablePath.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { merge: n } = i;
            class r extends t {
                constructor(t, e, i){
                    super(t, e, i, "shape"), this.type = "circle", this.translate = super.translateShape;
                }
                redraw(t) {
                    if (this.graphic) {
                        let e = this.anchor(this.points[0]).absolutePosition;
                        e ? this.graphic[t ? "animate" : "attr"]({
                            x: e.x,
                            y: e.y,
                            r: this.options.r
                        }) : this.graphic.attr({
                            x: 0,
                            y: -9000000000
                        }), this.graphic.placed = !!e;
                    }
                    super.redraw.call(this, t);
                }
                render(t) {
                    let e = this.attrsFromOptions(this.options);
                    this.graphic = this.annotation.chart.renderer.circle(0, -9000000000, 0).attr(e).add(t), super.render();
                }
                setRadius(t) {
                    this.options.r = t;
                }
            }
            return r.attrsMap = n(e.attrsMap, {
                r: "r"
            }), r;
        }), i(e, "Extensions/Annotations/Controllables/ControllableEllipse.js", [
            e["Extensions/Annotations/Controllables/Controllable.js"],
            e["Extensions/Annotations/Controllables/ControllablePath.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { merge: n, defined: r } = i;
            class o extends t {
                constructor(t, e, i){
                    super(t, e, i, "shape"), this.type = "ellipse";
                }
                init(t, e, i) {
                    r(e.yAxis) && e.points.forEach((t)=>{
                        t.yAxis = e.yAxis;
                    }), r(e.xAxis) && e.points.forEach((t)=>{
                        t.xAxis = e.xAxis;
                    }), super.init(t, e, i);
                }
                render(t) {
                    this.graphic = this.annotation.chart.renderer.createElement("ellipse").attr(this.attrsFromOptions(this.options)).add(t), super.render();
                }
                translate(t, e) {
                    super.translateShape(t, e, !0);
                }
                getDistanceFromLine(t, e, i, n) {
                    return Math.abs((e.y - t.y) * i - (e.x - t.x) * n + e.x * t.y - e.y * t.x) / Math.sqrt((e.y - t.y) * (e.y - t.y) + (e.x - t.x) * (e.x - t.x));
                }
                getAttrs(t, e) {
                    let i = t.x, n = t.y, r = e.x, o = e.y, s = (i + r) / 2, a = Math.sqrt((i - r) * (i - r) / 4 + (n - o) * (n - o) / 4), l = 180 * Math.atan((o - n) / (r - i)) / Math.PI;
                    return s < i && (l += 180), {
                        cx: s,
                        cy: (n + o) / 2,
                        rx: a,
                        ry: this.getRY(),
                        angle: l
                    };
                }
                getRY() {
                    let t = this.getYAxis();
                    return r(t) ? Math.abs(t.toPixels(this.options.ry) - t.toPixels(0)) : this.options.ry;
                }
                getYAxis() {
                    let t = this.options.yAxis;
                    return this.chart.yAxis[t];
                }
                getAbsolutePosition(t) {
                    return this.anchor(t).absolutePosition;
                }
                redraw(t) {
                    if (this.graphic) {
                        let e = this.getAbsolutePosition(this.points[0]), i = this.getAbsolutePosition(this.points[1]), n = this.getAttrs(e, i);
                        e ? this.graphic[t ? "animate" : "attr"]({
                            cx: n.cx,
                            cy: n.cy,
                            rx: n.rx,
                            ry: n.ry,
                            rotation: n.angle,
                            rotationOriginX: n.cx,
                            rotationOriginY: n.cy
                        }) : this.graphic.attr({
                            x: 0,
                            y: -9000000000
                        }), this.graphic.placed = !!e;
                    }
                    super.redraw(t);
                }
                setYRadius(t) {
                    let e = this.annotation.userOptions.shapes;
                    this.options.ry = t, e && e[0] && (e[0].ry = t, e[0].ry = t);
                }
            }
            return o.attrsMap = n(e.attrsMap, {
                ry: "ry"
            }), o;
        }), i(e, "Extensions/Annotations/Controllables/ControllableLabel.js", [
            e["Extensions/Annotations/Controllables/Controllable.js"],
            e["Core/Templating.js"],
            e["Extensions/Annotations/MockPoint.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            let { format: r } = e, { extend: o, isNumber: s, pick: a } = n;
            function l(t, e, i, n, r) {
                let o, a, l = r && r.anchorX, h = r && r.anchorY, c = i / 2;
                return s(l) && s(h) && (o = [
                    [
                        "M",
                        l,
                        h
                    ]
                ], (a = e - h) < 0 && (a = -n - a), a < i && (c = l < t + i / 2 ? a : i - a), h > e + n ? o.push([
                    "L",
                    t + c,
                    e + n
                ]) : h < e ? o.push([
                    "L",
                    t + c,
                    e
                ]) : l < t ? o.push([
                    "L",
                    t,
                    e + n / 2
                ]) : l > t + i && o.push([
                    "L",
                    t + i,
                    e + n / 2
                ])), o || [];
            }
            class h extends t {
                static alignedPosition(t, e) {
                    let i, n, r = t.align, o = t.verticalAlign, s = (e.x || 0) + (t.x || 0), a = (e.y || 0) + (t.y || 0);
                    return "right" === r ? i = 1 : "center" === r && (i = 2), i && (s += (e.width - (t.width || 0)) / i), "bottom" === o ? n = 1 : "middle" === o && (n = 2), n && (a += (e.height - (t.height || 0)) / n), {
                        x: Math.round(s),
                        y: Math.round(a)
                    };
                }
                static compose(t) {
                    t.prototype.symbols.connector = l;
                }
                static justifiedOptions(t, e, i, n) {
                    let r, o = i.align, s = i.verticalAlign, a = e.box ? 0 : e.padding || 0, l = e.getBBox(), h = {
                        align: o,
                        verticalAlign: s,
                        x: i.x,
                        y: i.y,
                        width: e.width,
                        height: e.height
                    }, c = (n.x || 0) - t.plotLeft, d = (n.y || 0) - t.plotTop;
                    return (r = c + a) < 0 && ("right" === o ? h.align = "left" : h.x = (h.x || 0) - r), (r = c + l.width - a) > t.plotWidth && ("left" === o ? h.align = "right" : h.x = (h.x || 0) + t.plotWidth - r), (r = d + a) < 0 && ("bottom" === s ? h.verticalAlign = "top" : h.y = (h.y || 0) - r), (r = d + l.height - a) > t.plotHeight && ("top" === s ? h.verticalAlign = "bottom" : h.y = (h.y || 0) + t.plotHeight - r), h;
                }
                constructor(t, e, i){
                    super(t, e, i, "label");
                }
                translatePoint(t, e) {
                    super.translatePoint(t, e, 0);
                }
                translate(t, e) {
                    let i = this.annotation.chart, n = this.annotation.userOptions, r = i.annotations.indexOf(this.annotation), o = i.options.annotations[r];
                    if (i.inverted) {
                        let i = t;
                        t = e, e = i;
                    }
                    this.options.x += t, this.options.y += e, o[this.collection][this.index].x = this.options.x, o[this.collection][this.index].y = this.options.y, n[this.collection][this.index].x = this.options.x, n[this.collection][this.index].y = this.options.y;
                }
                render(t) {
                    let e = this.options, i = this.attrsFromOptions(e), n = e.style;
                    this.graphic = this.annotation.chart.renderer.label("", 0, -9999, e.shape, null, null, e.useHTML, null, "annotation-label").attr(i).add(t), this.annotation.chart.styledMode || ("contrast" === n.color && (n.color = this.annotation.chart.renderer.getContrast(h.shapesWithoutBackground.indexOf(e.shape) > -1 ? "#FFFFFF" : e.backgroundColor)), this.graphic.css(e.style).shadow(e.shadow)), this.graphic.labelrank = e.labelrank, super.render();
                }
                redraw(t) {
                    let e = this.options, i = this.text || e.format || e.text, n = this.graphic, o = this.points[0];
                    if (!n) return void this.redraw(t);
                    n.attr({
                        text: i ? r(String(i), o.getLabelConfig(), this.annotation.chart) : e.formatter.call(o, this)
                    });
                    let s = this.anchor(o), a = this.position(s);
                    a ? (n.alignAttr = a, a.anchorX = s.absolutePosition.x, a.anchorY = s.absolutePosition.y, n[t ? "animate" : "attr"](a)) : n.attr({
                        x: 0,
                        y: -9999
                    }), n.placed = !!a, super.redraw(t);
                }
                anchor(t) {
                    let e = super.anchor.apply(this, arguments), i = this.options.x || 0, n = this.options.y || 0;
                    return e.absolutePosition.x -= i, e.absolutePosition.y -= n, e.relativePosition.x -= i, e.relativePosition.y -= n, e;
                }
                position(t) {
                    let e, n, r, s, l = this.graphic, c = this.annotation.chart, d = c.tooltip, u = this.points[0], p = this.options, f = t.absolutePosition, g = t.relativePosition, m = u.series.visible && i.prototype.isInsidePlot.call(u);
                    if (l && m) {
                        let { width: t = 0, height: i = 0 } = l;
                        p.distance && d ? e = d.getPosition.call({
                            chart: c,
                            distance: a(p.distance, 16),
                            getPlayingField: d.getPlayingField,
                            pointer: d.pointer
                        }, t, i, {
                            plotX: g.x,
                            plotY: g.y,
                            negative: u.negative,
                            ttBelow: u.ttBelow,
                            h: g.height || g.width
                        }) : p.positioner ? e = p.positioner.call(this) : (n = {
                            x: f.x,
                            y: f.y,
                            width: 0,
                            height: 0
                        }, e = h.alignedPosition(o(p, {
                            width: t,
                            height: i
                        }), n), "justify" === this.options.overflow && (e = h.alignedPosition(h.justifiedOptions(c, l, p, e), n))), p.crop && (r = e.x - c.plotLeft, s = e.y - c.plotTop, m = c.isInsidePlot(r, s) && c.isInsidePlot(r + t, s + i));
                    }
                    return m ? e : null;
                }
            }
            return h.attrsMap = {
                backgroundColor: "fill",
                borderColor: "stroke",
                borderWidth: "stroke-width",
                zIndex: "zIndex",
                borderRadius: "r",
                padding: "padding"
            }, h.shapesWithoutBackground = [
                "connector"
            ], h;
        }), i(e, "Extensions/Annotations/Controllables/ControllableImage.js", [
            e["Extensions/Annotations/Controllables/Controllable.js"],
            e["Extensions/Annotations/Controllables/ControllableLabel.js"]
        ], function(t, e) {
            class i extends t {
                constructor(t, e, i){
                    super(t, e, i, "shape"), this.type = "image", this.translate = super.translateShape;
                }
                render(t) {
                    let e = this.attrsFromOptions(this.options), i = this.options;
                    this.graphic = this.annotation.chart.renderer.image(i.src, 0, -9000000000, i.width, i.height).attr(e).add(t), this.graphic.width = i.width, this.graphic.height = i.height, super.render();
                }
                redraw(t) {
                    if (this.graphic) {
                        let i = this.anchor(this.points[0]), n = e.prototype.position.call(this, i);
                        n ? this.graphic[t ? "animate" : "attr"]({
                            x: n.x,
                            y: n.y
                        }) : this.graphic.attr({
                            x: 0,
                            y: -9000000000
                        }), this.graphic.placed = !!n;
                    }
                    super.redraw(t);
                }
            }
            return i.attrsMap = {
                width: "width",
                height: "height",
                zIndex: "zIndex"
            }, i;
        }), i(e, "Shared/BaseForm.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { addEvent: i, createElement: n } = e;
            return class {
                constructor(t, e){
                    this.iconsURL = e, this.container = this.createPopupContainer(t), this.closeButton = this.addCloseButton();
                }
                createPopupContainer(t, e = "highcharts-popup highcharts-no-tooltip") {
                    return n("div", {
                        className: e
                    }, void 0, t);
                }
                addCloseButton(t = "highcharts-popup-close") {
                    let e = this, r = this.iconsURL, o = n("button", {
                        className: t
                    }, void 0, this.container);
                    return o.style["background-image"] = "url(" + (r.match(/png|svg|jpeg|jpg|gif/gi) ? r : r + "close.svg") + ")", [
                        "click",
                        "touchstart"
                    ].forEach((t)=>{
                        i(o, t, e.closeButtonEvents.bind(e));
                    }), i(document, "keydown", function(t) {
                        "Escape" === t.code && e.closeButtonEvents();
                    }), o;
                }
                closeButtonEvents() {
                    this.closePopup();
                }
                showPopup(e = "highcharts-annotation-toolbar") {
                    let i = this.container, n = this.closeButton;
                    this.type = void 0, i.innerHTML = t.emptyHTML, i.className.indexOf(e) >= 0 && (i.classList.remove(e), i.removeAttribute("style")), i.appendChild(n), i.style.display = "block", i.style.height = "";
                }
                closePopup() {
                    this.container.style.display = "none";
                }
            };
        }), i(e, "Extensions/Annotations/Popup/PopupAnnotations.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { doc: i, isFirefox: n } = t, { createElement: r, isArray: o, isObject: s, objectEach: a, pick: l, stableSort: h } = e;
            function c(t, e, l, d, u, p) {
                let f, g;
                if (!e) return;
                let m = this.addInput, b = this.lang;
                a(d, (i, n)=>{
                    f = "" !== l ? l + "." + n : n, s(i) && (!o(i) || o(i) && s(i[0]) ? ((g = b[n] || n).match(/\d/g) || u.push([
                        !0,
                        g,
                        t
                    ]), c.call(this, t, e, f, i, u, !1)) : u.push([
                        this,
                        f,
                        "annotation",
                        t,
                        i
                    ]));
                }), p && (h(u, (t)=>t[1].match(/format/g) ? -1 : 1), n && u.reverse(), u.forEach((t)=>{
                    !0 === t[0] ? r("span", {
                        className: "highcharts-annotation-title"
                    }, void 0, t[2]).appendChild(i.createTextNode(t[1])) : (t[4] = {
                        value: t[4][0],
                        type: t[4][1]
                    }, m.apply(t[0], t.splice(1)));
                }));
            }
            return {
                addForm: function(t, e, n, o) {
                    if (!t) return;
                    let s = this.container, a = this.lang, l = r("h2", {
                        className: "highcharts-popup-main-title"
                    }, void 0, s);
                    l.appendChild(i.createTextNode(a[e.langKey] || e.langKey || "")), l = r("div", {
                        className: "highcharts-popup-lhs-col highcharts-popup-lhs-full"
                    }, void 0, s);
                    let h = r("div", {
                        className: "highcharts-popup-bottom-row"
                    }, void 0, s);
                    c.call(this, l, t, "", e, [], !0), this.addButton(h, o ? a.addButton || "Add" : a.saveButton || "Save", o ? "add" : "save", s, n);
                },
                addToolbar: function(t, e, n) {
                    let o = this.lang, s = this.container, a = this.showForm, h = "highcharts-annotation-toolbar";
                    -1 === s.className.indexOf(h) && (s.className += " " + h + " highcharts-no-mousewheel"), t && (s.style.top = t.plotTop + 10 + "px");
                    let c = r("p", {
                        className: "highcharts-annotation-label"
                    }, void 0, s);
                    c.setAttribute("aria-label", "Annotation type"), c.appendChild(i.createTextNode(l(o[e.langKey] || e.langKey, e.shapes && e.shapes[0].type, "")));
                    let d = this.addButton(s, o.editButton || "Edit", "edit", s, ()=>{
                        a.call(this, "annotation-edit", t, e, n);
                    });
                    d.className += " highcharts-annotation-edit-button", d.style["background-image"] = "url(" + this.iconsURL + "edit.svg)", d = this.addButton(s, o.removeButton || "Remove", "remove", s, n), d.className += " highcharts-annotation-remove-button", d.style["background-image"] = "url(" + this.iconsURL + "destroy.svg)";
                }
            };
        }), i(e, "Extensions/Annotations/Popup/PopupIndicators.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Globals.js"],
            e["Core/Series/SeriesRegistry.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n) {
            var r, o;
            let { doc: s } = e, { seriesTypes: a } = i, { addEvent: l, createElement: h, defined: c, isArray: d, isObject: u, objectEach: p, stableSort: f } = n;
            (o = r || (r = {}))[o["params.algorithm"] = 0] = "params.algorithm", o[o["params.average"] = 1] = "params.average";
            let g = {
                "algorithm-pivotpoints": [
                    "standard",
                    "fibonacci",
                    "camarilla"
                ],
                "average-disparityindex": [
                    "sma",
                    "ema",
                    "dema",
                    "tema",
                    "wma"
                ]
            };
            function m(t) {
                let e = h("div", {
                    className: "highcharts-popup-lhs-col"
                }, void 0, t), i = h("div", {
                    className: "highcharts-popup-rhs-col"
                }, void 0, t);
                return h("div", {
                    className: "highcharts-popup-rhs-col-wrapper"
                }, void 0, i), {
                    lhsCol: e,
                    rhsCol: i
                };
            }
            function b(e, i, n, r) {
                let o = i.params || i.options.params;
                r.innerHTML = t.emptyHTML, h("h3", {
                    className: "highcharts-indicator-title"
                }, void 0, r).appendChild(s.createTextNode(A(i, n).indicatorFullName)), h("input", {
                    type: "hidden",
                    name: "highcharts-type-" + n,
                    value: n
                }, void 0, r), E.call(this, n, "series", e, r, i, i.linkedParent && i.linkedParent.options.id), o.volumeSeriesID && E.call(this, n, "volume", e, r, i, i.linkedParent && o.volumeSeriesID), x.call(this, e, "params", o, n, r);
            }
            function y(e, i, n, r) {
                function o(t, i) {
                    let n = v.parentNode.children[1];
                    b.call(s, e, t, i, v), n && (n.style.display = "block"), p && t.options && h("input", {
                        type: "hidden",
                        name: "highcharts-id-" + i,
                        value: t.options.id
                    }, void 0, v).setAttribute("highcharts-data-series-id", t.options.id);
                }
                let s = this, a = s.lang, c = i.querySelectorAll(".highcharts-popup-lhs-col")[0], u = i.querySelectorAll(".highcharts-popup-rhs-col")[0], p = "edit" === n, g = p ? e.series : e.options.plotOptions || {};
                if (!e && g) return;
                let m, y = [];
                p || d(g) ? d(g) && (y = k.call(this, g)) : y = S.call(this, g, r), f(y, (t, e)=>{
                    let i = t.indicatorFullName.toLowerCase(), n = e.indicatorFullName.toLowerCase();
                    return i < n ? -1 : i > n ? 1 : 0;
                }), c.children[1] && c.children[1].remove();
                let x = h("ul", {
                    className: "highcharts-indicator-list"
                }, void 0, c), v = u.querySelectorAll(".highcharts-popup-rhs-col-wrapper")[0];
                if (y.forEach((t)=>{
                    let { indicatorFullName: e, indicatorType: i, series: n } = t;
                    m = h("li", {
                        className: "highcharts-indicator-list"
                    }, void 0, x);
                    let r = h("button", {
                        className: "highcharts-indicator-list-item",
                        textContent: e
                    }, void 0, m);
                    [
                        "click",
                        "touchstart"
                    ].forEach((t)=>{
                        l(r, t, function() {
                            o(n, i);
                        });
                    });
                }), y.length > 0) {
                    let { series: t, indicatorType: e } = y[0];
                    o(t, e);
                } else p || (t.setElementHTML(v.parentNode.children[0], a.noFilterMatch || ""), v.parentNode.children[1].style.display = "none");
            }
            function x(t, e, i, n, o) {
                if (!t) return;
                let s = this.addInput;
                p(i, (i, a)=>{
                    let l = e + "." + a;
                    if (c(i) && l) {
                        if (u(i) && (s.call(this, l, n, o, {}), x.call(this, t, l, i, n, o)), l in r) {
                            let r = w.call(this, n, l, o);
                            C.call(this, t, e, r, n, a, i);
                        } else "params.volumeSeriesID" === l || d(i) || s.call(this, l, n, o, {
                            value: i,
                            type: "number"
                        });
                    }
                });
            }
            function v(t, e) {
                let i = this, n = e.querySelectorAll(".highcharts-popup-lhs-col")[0], r = this.lang.clearFilter, o = h("div", {
                    className: "highcharts-input-wrapper"
                }, void 0, n), s = function(e) {
                    y.call(i, t, i.container, "add", e);
                }, a = this.addInput("searchIndicators", "input", o, {
                    value: "",
                    type: "text",
                    htmlFor: "search-indicators",
                    labelClassName: "highcharts-input-search-indicators-label"
                }), c = h("a", {
                    textContent: r
                }, void 0, o);
                a.classList.add("highcharts-input-search-indicators"), c.classList.add("clear-filter-button"), l(a, "input", function() {
                    s(this.value), this.value.length ? c.style.display = "inline-block" : c.style.display = "none";
                }), [
                    "click",
                    "touchstart"
                ].forEach((t)=>{
                    l(c, t, function() {
                        a.value = "", s(""), c.style.display = "none";
                    });
                });
            }
            function w(t, e, i) {
                let n = e.split("."), r = n[n.length - 1], o = "highcharts-" + e + "-type-" + t, a = this.lang;
                h("label", {
                    htmlFor: o
                }, null, i).appendChild(s.createTextNode(a[r] || e));
                let l = h("select", {
                    name: o,
                    className: "highcharts-popup-field",
                    id: "highcharts-select-" + e
                }, null, i);
                return l.setAttribute("id", "highcharts-select-" + e), l;
            }
            function C(t, e, i, n, r, o, a) {
                "series" === e || "volume" === e ? t.series.forEach((t)=>{
                    let n = t.options, r = n.name || n.params ? t.name : n.id || "";
                    "highcharts-navigator-series" !== n.id && n.id !== (a && a.options && a.options.id) && (c(o) || "volume" !== e || "column" !== t.type || (o = n.id), h("option", {
                        value: n.id
                    }, void 0, i).appendChild(s.createTextNode(r)));
                }) : n && r && g[r + "-" + n].forEach((t)=>{
                    h("option", {
                        value: t
                    }, void 0, i).appendChild(s.createTextNode(t));
                }), c(o) && (i.value = o);
            }
            function S(t, e) {
                let i, n = this.chart && this.chart.options.lang, r = n && n.navigation && n.navigation.popup && n.navigation.popup.indicatorAliases, o = [];
                return p(t, (t, n)=>{
                    let s = t && t.options;
                    if (t.params || s && s.params) {
                        let { indicatorFullName: s, indicatorType: a } = A(t, n);
                        if (e) {
                            let n = RegExp(e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"), l = r && r[a] && r[a].join(" ") || "";
                            (s.match(n) || l.match(n)) && (i = {
                                indicatorFullName: s,
                                indicatorType: a,
                                series: t
                            }, o.push(i));
                        } else i = {
                            indicatorFullName: s,
                            indicatorType: a,
                            series: t
                        }, o.push(i);
                    }
                }), o;
            }
            function k(t) {
                let e = [];
                return t.forEach((t)=>{
                    t.is("sma") && e.push({
                        indicatorFullName: t.name,
                        indicatorType: t.type,
                        series: t
                    });
                }), e;
            }
            function A(t, e) {
                let i = t.options, n = a[e] && a[e].prototype.nameBase || e.toUpperCase(), r = e;
                return i && i.type && (r = t.options.type, n = t.name), {
                    indicatorFullName: n,
                    indicatorType: r
                };
            }
            function E(t, e, i, n, r, o) {
                if (!i) return;
                let s = w.call(this, t, e, n);
                C.call(this, i, e, s, void 0, void 0, void 0, r), c(o) && (s.value = o);
            }
            return {
                addForm: function(t, e, i) {
                    let n, r = this.lang;
                    if (!t) return;
                    this.tabs.init.call(this, t);
                    let o = this.container.querySelectorAll(".highcharts-tab-item-content");
                    m(o[0]), v.call(this, t, o[0]), y.call(this, t, o[0], "add"), n = o[0].querySelectorAll(".highcharts-popup-rhs-col")[0], this.addButton(n, r.addButton || "add", "add", n, i), m(o[1]), y.call(this, t, o[1], "edit"), n = o[1].querySelectorAll(".highcharts-popup-rhs-col")[0], this.addButton(n, r.saveButton || "save", "edit", n, i), this.addButton(n, r.removeButton || "remove", "remove", n, i);
                },
                getAmount: function() {
                    let t = 0;
                    return this.series.forEach((e)=>{
                        (e.params || e.options.params) && t++;
                    }), t;
                }
            };
        }), i(e, "Extensions/Annotations/Popup/PopupTabs.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { doc: i } = t, { addEvent: n, createElement: r } = e;
            function o() {
                return r("div", {
                    className: "highcharts-tab-item-content highcharts-no-mousewheel"
                }, void 0, this.container);
            }
            function s(t, e) {
                let n = this.container, o = this.lang, s = "highcharts-tab-item";
                0 === e && (s += " highcharts-tab-disabled");
                let a = r("button", {
                    className: s
                }, void 0, n);
                return a.appendChild(i.createTextNode(o[t + "Button"] || t)), a.setAttribute("highcharts-data-tab-type", t), a;
            }
            function a() {
                let t = this.container, e = t.querySelectorAll(".highcharts-tab-item"), i = t.querySelectorAll(".highcharts-tab-item-content");
                for(let t = 0; t < e.length; t++)e[t].classList.remove("highcharts-tab-item-active"), i[t].classList.remove("highcharts-tab-item-show");
            }
            function l(t, e) {
                let i = this.container.querySelectorAll(".highcharts-tab-item-content");
                t.className += " highcharts-tab-item-active", i[e].className += " highcharts-tab-item-show";
            }
            function h(t) {
                let e = this;
                this.container.querySelectorAll(".highcharts-tab-item").forEach((i, r)=>{
                    (0 !== t || "edit" !== i.getAttribute("highcharts-data-tab-type")) && [
                        "click",
                        "touchstart"
                    ].forEach((t)=>{
                        n(i, t, function() {
                            a.call(e), l.call(e, this, r);
                        });
                    });
                });
            }
            return {
                init: function(t) {
                    if (!t) return;
                    let e = this.indicators.getAmount.call(t), i = s.call(this, "add");
                    s.call(this, "edit", e), o.call(this), o.call(this), h.call(this, e), l.call(this, i, 0);
                }
            };
        }), i(e, "Extensions/Annotations/Popup/Popup.js", [
            e["Shared/BaseForm.js"],
            e["Core/Globals.js"],
            e["Core/Defaults.js"],
            e["Extensions/Annotations/Popup/PopupAnnotations.js"],
            e["Extensions/Annotations/Popup/PopupIndicators.js"],
            e["Extensions/Annotations/Popup/PopupTabs.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s) {
            let { doc: a } = e, { getOptions: l } = i, { addEvent: h, createElement: c, extend: d, fireEvent: u, pick: p } = s;
            class f extends t {
                constructor(t, e, i){
                    super(t, e), this.chart = i, this.lang = (l().lang.navigation || {}).popup || {}, h(this.container, "mousedown", ()=>{
                        let t = i && i.navigationBindings && i.navigationBindings.activeAnnotation;
                        if (t) {
                            t.cancelClick = !0;
                            let e = h(a, "click", ()=>{
                                setTimeout(()=>{
                                    t.cancelClick = !1;
                                }, 0), e();
                            });
                        }
                    });
                }
                addInput(t, e, i, n) {
                    let r = t.split("."), o = r[r.length - 1], s = this.lang, l = "highcharts-" + e + "-" + p(n.htmlFor, o);
                    o.match(/^\d+$/) || c("label", {
                        htmlFor: l,
                        className: n.labelClassName
                    }, void 0, i).appendChild(a.createTextNode(s[o] || o));
                    let h = c("input", {
                        name: l,
                        value: n.value,
                        type: n.type,
                        className: "highcharts-popup-field"
                    }, void 0, i);
                    return h.setAttribute("highcharts-data-name", t), h;
                }
                closeButtonEvents() {
                    if (this.chart) {
                        let t = this.chart.navigationBindings;
                        u(t, "closePopup"), t && t.selectedButtonElement && u(t, "deselectButton", {
                            button: t.selectedButtonElement
                        });
                    } else super.closeButtonEvents();
                }
                addButton(t, e, i, n, r) {
                    let o = c("button", void 0, void 0, t);
                    return o.appendChild(a.createTextNode(e)), r && [
                        "click",
                        "touchstart"
                    ].forEach((t)=>{
                        h(o, t, ()=>(this.closePopup(), r(function(t, e) {
                                let i = Array.prototype.slice.call(t.querySelectorAll("input")), n = Array.prototype.slice.call(t.querySelectorAll("select")), r = t.querySelectorAll("#highcharts-select-series > option:checked")[0], o = t.querySelectorAll("#highcharts-select-volume > option:checked")[0], s = {
                                    actionType: e,
                                    linkedTo: r && r.getAttribute("value") || "",
                                    fields: {}
                                };
                                return i.forEach((t)=>{
                                    let e = t.getAttribute("highcharts-data-name");
                                    t.getAttribute("highcharts-data-series-id") ? s.seriesId = t.value : e ? s.fields[e] = t.value : s.type = t.value;
                                }), n.forEach((t)=>{
                                    let e = t.id;
                                    if ("highcharts-select-series" !== e && "highcharts-select-volume" !== e) {
                                        let i = e.split("highcharts-select-")[1];
                                        s.fields[i] = t.value;
                                    }
                                }), o && (s.fields["params.volumeSeriesID"] = o.getAttribute("value") || ""), s;
                            }(n, i))));
                    }), o;
                }
                showForm(t, e, i, n) {
                    e && (this.showPopup(), "indicators" === t && this.indicators.addForm.call(this, e, i, n), "annotation-toolbar" === t && this.annotations.addToolbar.call(this, e, i, n), "annotation-edit" === t && this.annotations.addForm.call(this, e, i, n), "flag" === t && this.annotations.addForm.call(this, e, i, n, !0), this.type = t, this.container.style.height = this.container.offsetHeight + "px");
                }
            }
            return d(f.prototype, {
                annotations: n,
                indicators: r,
                tabs: o
            }), f;
        }), i(e, "Extensions/Annotations/Popup/PopupComposition.js", [
            e["Core/Globals.js"],
            e["Extensions/Annotations/Popup/Popup.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { composed: n } = t, { addEvent: r, pushUnique: o, wrap: s } = i;
            function a() {
                this.popup && this.popup.closePopup();
            }
            function l(t) {
                this.popup || (this.popup = new e(this.chart.container, this.chart.options.navigation.iconsURL || this.chart.options.stockTools && this.chart.options.stockTools.gui.iconsURL || "https://code.highcharts.com/11.4.8/gfx/stock-icons/", this.chart)), this.popup.showForm(t.formType, this.chart, t.options, t.onSubmit);
            }
            function h(t, e) {
                this.inClass(e.target, "highcharts-popup") || t.apply(this, Array.prototype.slice.call(arguments, 1));
            }
            return {
                compose: function(t, e) {
                    o(n, "Popup") && (r(t, "closePopup", a), r(t, "showPopup", l), s(e.prototype, "onContainerMouseDown", h));
                }
            };
        }), i(e, "Extensions/Annotations/Annotation.js", [
            e["Core/Animation/AnimationUtilities.js"],
            e["Extensions/Annotations/AnnotationChart.js"],
            e["Extensions/Annotations/AnnotationDefaults.js"],
            e["Extensions/Annotations/Controllables/ControllableRect.js"],
            e["Extensions/Annotations/Controllables/ControllableCircle.js"],
            e["Extensions/Annotations/Controllables/ControllableEllipse.js"],
            e["Extensions/Annotations/Controllables/ControllablePath.js"],
            e["Extensions/Annotations/Controllables/ControllableImage.js"],
            e["Extensions/Annotations/Controllables/ControllableLabel.js"],
            e["Extensions/Annotations/ControlPoint.js"],
            e["Extensions/Annotations/ControlTarget.js"],
            e["Extensions/Annotations/EventEmitter.js"],
            e["Extensions/Annotations/MockPoint.js"],
            e["Extensions/Annotations/Popup/PopupComposition.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a, l, h, c, d, u, p, f) {
            let { getDeferredAnimation: g } = t, { destroyObjectProperties: m, erase: b, fireEvent: y, merge: x, pick: v, splat: w } = f;
            function C(t, e) {
                let i = {};
                return [
                    "labels",
                    "shapes"
                ].forEach((n)=>{
                    let r = t[n];
                    r && (e[n] ? i[n] = w(e[n]).map(function(t, e) {
                        return x(r[e], t);
                    }) : i[n] = t[n]);
                }), i;
            }
            class S extends d {
                static compose(t, i, n, r) {
                    e.compose(S, t, n), l.compose(r), s.compose(t, r), i.compose(S, t), p.compose(i, n);
                }
                constructor(t, e){
                    super(), this.coll = "annotations", this.chart = t, this.points = [], this.controlPoints = [], this.coll = "annotations", this.index = -1, this.labels = [], this.shapes = [], this.options = x(this.defaultOptions, e), this.userOptions = e;
                    let i = C(this.options, e);
                    this.options.labels = i.labels, this.options.shapes = i.shapes, this.init(t, this.options);
                }
                addClipPaths() {
                    this.setClipAxes(), this.clipXAxis && this.clipYAxis && this.options.crop && (this.clipRect = this.chart.renderer.clipRect(this.getClipBox()));
                }
                addLabels() {
                    let t = this.options.labels || [];
                    t.forEach((e, i)=>{
                        let n = this.initLabel(e, i);
                        x(!0, t[i], n.options);
                    });
                }
                addShapes() {
                    let t = this.options.shapes || [];
                    t.forEach((e, i)=>{
                        let n = this.initShape(e, i);
                        x(!0, t[i], n.options);
                    });
                }
                destroy() {
                    let t = this.chart, e = function(t) {
                        t.destroy();
                    };
                    this.labels.forEach(e), this.shapes.forEach(e), this.clipXAxis = null, this.clipYAxis = null, b(t.labelCollectors, this.labelCollector), super.destroy(), this.destroyControlTarget(), m(this, t);
                }
                destroyItem(t) {
                    b(this[t.itemType + "s"], t), t.destroy();
                }
                getClipBox() {
                    if (this.clipXAxis && this.clipYAxis) return {
                        x: this.clipXAxis.left,
                        y: this.clipYAxis.top,
                        width: this.clipXAxis.width,
                        height: this.clipYAxis.height
                    };
                }
                initProperties(t, e) {
                    this.setOptions(e);
                    let i = C(this.options, e);
                    this.options.labels = i.labels, this.options.shapes = i.shapes, this.chart = t, this.points = [], this.controlPoints = [], this.coll = "annotations", this.userOptions = e, this.labels = [], this.shapes = [];
                }
                init(t, e, i = this.index) {
                    let n = this.chart, r = this.options.animation;
                    this.index = i, this.linkPoints(), this.addControlPoints(), this.addShapes(), this.addLabels(), this.setLabelCollector(), this.animationConfig = g(n, r);
                }
                initLabel(t, e) {
                    let i = new l(this, x(this.options.labelOptions, {
                        controlPointOptions: this.options.controlPointOptions
                    }, t), e);
                    return i.itemType = "label", this.labels.push(i), i;
                }
                initShape(t, e) {
                    let i = x(this.options.shapeOptions, {
                        controlPointOptions: this.options.controlPointOptions
                    }, t), n = new S.shapesMap[i.type](this, i, e);
                    return n.itemType = "shape", this.shapes.push(n), n;
                }
                redraw(t) {
                    this.linkPoints(), this.graphic || this.render(), this.clipRect && this.clipRect.animate(this.getClipBox()), this.redrawItems(this.shapes, t), this.redrawItems(this.labels, t), this.redrawControlPoints(t);
                }
                redrawItem(t, e) {
                    t.linkPoints(), t.shouldBeDrawn() ? (t.graphic || this.renderItem(t), t.redraw(v(e, !0) && t.graphic.placed), t.points.length && function(t) {
                        let e = t.graphic, i = t.points.some((t)=>!1 !== t.series.visible && !1 !== t.visible);
                        e && (i ? "hidden" === e.visibility && e.show() : e.hide());
                    }(t)) : this.destroyItem(t);
                }
                redrawItems(t, e) {
                    let i = t.length;
                    for(; i--;)this.redrawItem(t[i], e);
                }
                remove() {
                    return this.chart.removeAnnotation(this);
                }
                render() {
                    let t = this.chart.renderer;
                    this.graphic = t.g("annotation").attr({
                        opacity: 0,
                        zIndex: this.options.zIndex,
                        visibility: this.options.visible ? "inherit" : "hidden"
                    }).add(), this.shapesGroup = t.g("annotation-shapes").add(this.graphic), this.options.crop && this.shapesGroup.clip(this.chart.plotBoxClip), this.labelsGroup = t.g("annotation-labels").attr({
                        translateX: 0,
                        translateY: 0
                    }).add(this.graphic), this.addClipPaths(), this.clipRect && this.graphic.clip(this.clipRect), this.renderItems(this.shapes), this.renderItems(this.labels), this.addEvents(), this.renderControlPoints();
                }
                renderItem(t) {
                    t.render("label" === t.itemType ? this.labelsGroup : this.shapesGroup);
                }
                renderItems(t) {
                    let e = t.length;
                    for(; e--;)this.renderItem(t[e]);
                }
                setClipAxes() {
                    let t = this.chart.xAxis, e = this.chart.yAxis, i = (this.options.labels || []).concat(this.options.shapes || []).reduce((i, n)=>{
                        let r = n && (n.point || n.points && n.points[0]);
                        return [
                            t[r && r.xAxis] || i[0],
                            e[r && r.yAxis] || i[1]
                        ];
                    }, []);
                    this.clipXAxis = i[0], this.clipYAxis = i[1];
                }
                setControlPointsVisibility(t) {
                    let e = function(e) {
                        e.setControlPointsVisibility(t);
                    };
                    this.controlPoints.forEach((e)=>{
                        e.setVisibility(t);
                    }), this.shapes.forEach(e), this.labels.forEach(e);
                }
                setLabelCollector() {
                    let t = this;
                    t.labelCollector = function() {
                        return t.labels.reduce(function(t, e) {
                            return e.options.allowOverlap || t.push(e.graphic), t;
                        }, []);
                    }, t.chart.labelCollectors.push(t.labelCollector);
                }
                setOptions(t) {
                    this.options = x(this.defaultOptions, t);
                }
                setVisibility(t) {
                    let e = this.options, i = this.chart.navigationBindings, n = v(t, !e.visible);
                    if (this.graphic.attr("visibility", n ? "inherit" : "hidden"), !n) {
                        let t = function(t) {
                            t.setControlPointsVisibility(n);
                        };
                        this.shapes.forEach(t), this.labels.forEach(t), i.activeAnnotation === this && i.popup && "annotation-toolbar" === i.popup.type && y(i, "closePopup");
                    }
                    e.visible = n;
                }
                update(t, e) {
                    let i = this.chart, n = C(this.userOptions, t), r = i.annotations.indexOf(this), o = x(!0, this.userOptions, t);
                    o.labels = n.labels, o.shapes = n.shapes, this.destroy(), this.initProperties(i, o), this.init(i, o), i.options.annotations[r] = this.options, this.isUpdating = !0, v(e, !0) && i.drawAnnotations(), y(this, "afterUpdate"), this.isUpdating = !1;
                }
            }
            return S.ControlPoint = h, S.MockPoint = u, S.shapesMap = {
                rect: n,
                circle: r,
                ellipse: o,
                path: s,
                image: a
            }, S.types = {}, S.prototype.defaultOptions = i, S.prototype.nonDOMEvents = [
                "add",
                "afterUpdate",
                "drag",
                "remove"
            ], c.compose(S), S;
        }), i(e, "Core/Chart/ChartNavigationComposition.js", [], function() {
            var t;
            return function(t) {
                t.compose = function(t) {
                    return t.navigation || (t.navigation = new e(t)), t;
                };
                class e {
                    constructor(t){
                        this.updates = [], this.chart = t;
                    }
                    addUpdate(t) {
                        this.chart.navigation.updates.push(t);
                    }
                    update(t, e) {
                        this.updates.forEach((i)=>{
                            i.call(this.chart, t, e);
                        });
                    }
                }
                t.Additions = e;
            }(t || (t = {})), t;
        }), i(e, "Extensions/Annotations/NavigationBindingsUtilities.js", [
            e["Core/Utilities.js"]
        ], function(t) {
            let { defined: e, isNumber: i, pick: n } = t, r = {
                backgroundColor: "string",
                borderColor: "string",
                borderRadius: "string",
                color: "string",
                fill: "string",
                fontSize: "string",
                labels: "string",
                name: "string",
                stroke: "string",
                title: "string"
            };
            return {
                annotationsFieldsTypes: r,
                getAssignedAxis: function(t) {
                    return t.filter((t)=>{
                        let e = t.axis.getExtremes(), r = e.min, o = e.max, s = n(t.axis.minPointOffset, 0);
                        return i(r) && i(o) && t.value >= r - s && t.value <= o + s && !t.axis.options.isInternal;
                    })[0];
                },
                getFieldType: function(t, i) {
                    let n = r[t], o = typeof i;
                    return e(n) && (o = n), ({
                        string: "text",
                        number: "number",
                        boolean: "checkbox"
                    })[o];
                }
            };
        }), i(e, "Extensions/Annotations/NavigationBindingsDefaults.js", [
            e["Extensions/Annotations/NavigationBindingsUtilities.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { getAssignedAxis: i } = t, { isNumber: n, merge: r } = e;
            return {
                lang: {
                    navigation: {
                        popup: {
                            simpleShapes: "Simple shapes",
                            lines: "Lines",
                            circle: "Circle",
                            ellipse: "Ellipse",
                            rectangle: "Rectangle",
                            label: "Label",
                            shapeOptions: "Shape options",
                            typeOptions: "Details",
                            fill: "Fill",
                            format: "Text",
                            strokeWidth: "Line width",
                            stroke: "Line color",
                            title: "Title",
                            name: "Name",
                            labelOptions: "Label options",
                            labels: "Labels",
                            backgroundColor: "Background color",
                            backgroundColors: "Background colors",
                            borderColor: "Border color",
                            borderRadius: "Border radius",
                            borderWidth: "Border width",
                            style: "Style",
                            padding: "Padding",
                            fontSize: "Font size",
                            color: "Color",
                            height: "Height",
                            shapes: "Shape options"
                        }
                    }
                },
                navigation: {
                    bindingsClassName: "highcharts-bindings-container",
                    bindings: {
                        circleAnnotation: {
                            className: "highcharts-circle-annotation",
                            start: function(t) {
                                let e = this.chart.pointer?.getCoordinates(t), n = e && i(e.xAxis), o = e && i(e.yAxis), s = this.chart.options.navigation;
                                if (n && o) return this.chart.addAnnotation(r({
                                    langKey: "circle",
                                    type: "basicAnnotation",
                                    shapes: [
                                        {
                                            type: "circle",
                                            point: {
                                                x: n.value,
                                                y: o.value,
                                                xAxis: n.axis.index,
                                                yAxis: o.axis.index
                                            },
                                            r: 5
                                        }
                                    ]
                                }, s.annotationsOptions, s.bindings.circleAnnotation.annotationsOptions));
                            },
                            steps: [
                                function(t, e) {
                                    let i, r = e.options.shapes, o = r && r[0] && r[0].point || {};
                                    if (n(o.xAxis) && n(o.yAxis)) {
                                        let e = this.chart.inverted, n = this.chart.xAxis[o.xAxis].toPixels(o.x), r = this.chart.yAxis[o.yAxis].toPixels(o.y);
                                        i = Math.max(Math.sqrt(Math.pow(e ? r - t.chartX : n - t.chartX, 2) + Math.pow(e ? n - t.chartY : r - t.chartY, 2)), 5);
                                    }
                                    e.update({
                                        shapes: [
                                            {
                                                r: i
                                            }
                                        ]
                                    });
                                }
                            ]
                        },
                        ellipseAnnotation: {
                            className: "highcharts-ellipse-annotation",
                            start: function(t) {
                                let e = this.chart.pointer?.getCoordinates(t), n = e && i(e.xAxis), o = e && i(e.yAxis), s = this.chart.options.navigation;
                                if (n && o) return this.chart.addAnnotation(r({
                                    langKey: "ellipse",
                                    type: "basicAnnotation",
                                    shapes: [
                                        {
                                            type: "ellipse",
                                            xAxis: n.axis.index,
                                            yAxis: o.axis.index,
                                            points: [
                                                {
                                                    x: n.value,
                                                    y: o.value
                                                },
                                                {
                                                    x: n.value,
                                                    y: o.value
                                                }
                                            ],
                                            ry: 1
                                        }
                                    ]
                                }, s.annotationsOptions, s.bindings.ellipseAnnotation.annotationOptions));
                            },
                            steps: [
                                function(t, e) {
                                    let i = e.shapes[0], n = i.getAbsolutePosition(i.points[1]);
                                    i.translatePoint(t.chartX - n.x, t.chartY - n.y, 1), i.redraw(!1);
                                },
                                function(t, e) {
                                    let i = e.shapes[0], n = i.getAbsolutePosition(i.points[0]), r = i.getAbsolutePosition(i.points[1]), o = i.getDistanceFromLine(n, r, t.chartX, t.chartY), s = i.getYAxis(), a = Math.abs(s.toValue(0) - s.toValue(o));
                                    i.setYRadius(a), i.redraw(!1);
                                }
                            ]
                        },
                        rectangleAnnotation: {
                            className: "highcharts-rectangle-annotation",
                            start: function(t) {
                                let e = this.chart.pointer?.getCoordinates(t), n = e && i(e.xAxis), o = e && i(e.yAxis);
                                if (!n || !o) return;
                                let s = n.value, a = o.value, l = n.axis.index, h = o.axis.index, c = this.chart.options.navigation;
                                return this.chart.addAnnotation(r({
                                    langKey: "rectangle",
                                    type: "basicAnnotation",
                                    shapes: [
                                        {
                                            type: "path",
                                            points: [
                                                {
                                                    xAxis: l,
                                                    yAxis: h,
                                                    x: s,
                                                    y: a
                                                },
                                                {
                                                    xAxis: l,
                                                    yAxis: h,
                                                    x: s,
                                                    y: a
                                                },
                                                {
                                                    xAxis: l,
                                                    yAxis: h,
                                                    x: s,
                                                    y: a
                                                },
                                                {
                                                    xAxis: l,
                                                    yAxis: h,
                                                    x: s,
                                                    y: a
                                                },
                                                {
                                                    command: "Z"
                                                }
                                            ]
                                        }
                                    ]
                                }, c.annotationsOptions, c.bindings.rectangleAnnotation.annotationsOptions));
                            },
                            steps: [
                                function(t, e) {
                                    let n = e.options.shapes, r = n && n[0] && n[0].points || [], o = this.chart.pointer?.getCoordinates(t), s = o && i(o.xAxis), a = o && i(o.yAxis);
                                    if (s && a) {
                                        let t = s.value, i = a.value;
                                        r[1].x = t, r[2].x = t, r[2].y = i, r[3].y = i, e.update({
                                            shapes: [
                                                {
                                                    points: r
                                                }
                                            ]
                                        });
                                    }
                                }
                            ]
                        },
                        labelAnnotation: {
                            className: "highcharts-label-annotation",
                            start: function(t) {
                                let e = this.chart.pointer?.getCoordinates(t), n = e && i(e.xAxis), o = e && i(e.yAxis), s = this.chart.options.navigation;
                                if (n && o) return this.chart.addAnnotation(r({
                                    langKey: "label",
                                    type: "basicAnnotation",
                                    labelOptions: {
                                        format: "{y:.2f}",
                                        overflow: "none",
                                        crop: !0
                                    },
                                    labels: [
                                        {
                                            point: {
                                                xAxis: n.axis.index,
                                                yAxis: o.axis.index,
                                                x: n.value,
                                                y: o.value
                                            }
                                        }
                                    ]
                                }, s.annotationsOptions, s.bindings.labelAnnotation.annotationsOptions));
                            }
                        }
                    },
                    events: {},
                    annotationsOptions: {
                        animation: {
                            defer: 0
                        }
                    }
                }
            };
        }), i(e, "Extensions/Annotations/NavigationBindings.js", [
            e["Core/Chart/ChartNavigationComposition.js"],
            e["Core/Defaults.js"],
            e["Core/Templating.js"],
            e["Core/Globals.js"],
            e["Extensions/Annotations/NavigationBindingsDefaults.js"],
            e["Extensions/Annotations/NavigationBindingsUtilities.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s) {
            let { setOptions: a } = e, { format: l } = i, { composed: h, doc: c, win: d } = n, { getAssignedAxis: u, getFieldType: p } = o, { addEvent: f, attr: g, defined: m, fireEvent: b, isArray: y, isFunction: x, isNumber: v, isObject: w, merge: C, objectEach: S, pick: k, pushUnique: A } = s;
            function E() {
                this.chart.navigationBindings && this.chart.navigationBindings.deselectAnnotation();
            }
            function M() {
                this.navigationBindings && this.navigationBindings.destroy();
            }
            function T() {
                let t = this.options;
                t && t.navigation && t.navigation.bindings && (this.navigationBindings = new D(this, t.navigation), this.navigationBindings.initEvents(), this.navigationBindings.initUpdate());
            }
            function P() {
                let t = this.navigationBindings, e = "highcharts-disabled-btn";
                if (this && t) {
                    let i = !1;
                    if (this.series.forEach((t)=>{
                        !t.options.isInternal && t.visible && (i = !0);
                    }), this.navigationBindings && this.navigationBindings.container && this.navigationBindings.container[0]) {
                        let n = this.navigationBindings.container[0];
                        S(t.boundClassNames, (t, r)=>{
                            let o = n.querySelectorAll("." + r);
                            if (o) for(let n = 0; n < o.length; n++){
                                let r = o[n], s = r.className;
                                "normal" === t.noDataState || i ? -1 !== s.indexOf(e) && r.classList.remove(e) : -1 === s.indexOf(e) && (r.className += " " + e);
                            }
                        });
                    }
                }
            }
            function R() {
                this.deselectAnnotation();
            }
            function L() {
                this.selectedButtonElement = null;
            }
            function O(t) {
                let e, i, n = t.prototype.defaultOptions.events && t.prototype.defaultOptions.events.click;
                function r(t) {
                    let e = this, i = e.chart.navigationBindings, r = i.activeAnnotation;
                    n && n.call(e, t), r !== e ? (i.deselectAnnotation(), i.activeAnnotation = e, e.setControlPointsVisibility(!0), b(i, "showPopup", {
                        annotation: e,
                        formType: "annotation-toolbar",
                        options: i.annotationToFields(e),
                        onSubmit: function(t) {
                            if ("remove" === t.actionType) i.activeAnnotation = !1, i.chart.removeAnnotation(e);
                            else {
                                let n = {};
                                i.fieldsToOptions(t.fields, n), i.deselectAnnotation();
                                let r = n.typeOptions;
                                "measure" === e.options.type && (r.crosshairY.enabled = 0 !== r.crosshairY.strokeWidth, r.crosshairX.enabled = 0 !== r.crosshairX.strokeWidth), e.update(n);
                            }
                        }
                    })) : b(i, "closePopup"), t.activeAnnotation = !0;
                }
                C(!0, t.prototype.defaultOptions.events, {
                    click: r,
                    touchstart: function(t) {
                        e = t.touches[0].clientX, i = t.touches[0].clientY;
                    },
                    touchend: function(t) {
                        e && Math.sqrt(Math.pow(e - t.changedTouches[0].clientX, 2) + Math.pow(i - t.changedTouches[0].clientY, 2)) >= 4 || r.call(this, t);
                    }
                });
            }
            class D {
                static compose(t, e) {
                    A(h, "NavigationBindings") && (f(t, "remove", E), O(t), S(t.types, (t)=>{
                        O(t);
                    }), f(e, "destroy", M), f(e, "load", T), f(e, "render", P), f(D, "closePopup", R), f(D, "deselectButton", L), a(r));
                }
                constructor(t, e){
                    this.boundClassNames = void 0, this.chart = t, this.options = e, this.eventsToUnbind = [], this.container = this.chart.container.getElementsByClassName(this.options.bindingsClassName || ""), this.container.length || (this.container = c.getElementsByClassName(this.options.bindingsClassName || ""));
                }
                getCoords(t) {
                    let e = this.chart.pointer?.getCoordinates(t);
                    return [
                        e && u(e.xAxis),
                        e && u(e.yAxis)
                    ];
                }
                initEvents() {
                    let t = this, e = t.chart, i = t.container, r = t.options;
                    t.boundClassNames = {}, S(r.bindings || {}, (e)=>{
                        t.boundClassNames[e.className] = e;
                    }), [].forEach.call(i, (e)=>{
                        t.eventsToUnbind.push(f(e, "click", (i)=>{
                            let n = t.getButtonEvents(e, i);
                            n && !n.button.classList.contains("highcharts-disabled-btn") && t.bindingsButtonClick(n.button, n.events, i);
                        }));
                    }), S(r.events || {}, (e, i)=>{
                        x(e) && t.eventsToUnbind.push(f(t, i, e, {
                            passive: !1
                        }));
                    }), t.eventsToUnbind.push(f(e.container, "click", function(i) {
                        !e.cancelClick && e.isInsidePlot(i.chartX - e.plotLeft, i.chartY - e.plotTop, {
                            visiblePlotOnly: !0
                        }) && t.bindingsChartClick(this, i);
                    })), t.eventsToUnbind.push(f(e.container, n.isTouchDevice ? "touchmove" : "mousemove", function(e) {
                        t.bindingsContainerMouseMove(this, e);
                    }, n.isTouchDevice ? {
                        passive: !1
                    } : void 0));
                }
                initUpdate() {
                    let e = this;
                    t.compose(this.chart).navigation.addUpdate((t)=>{
                        e.update(t);
                    });
                }
                bindingsButtonClick(t, e, i) {
                    let n = this.chart, r = n.renderer.boxWrapper, o = !0;
                    this.selectedButtonElement && (this.selectedButtonElement.classList === t.classList && (o = !1), b(this, "deselectButton", {
                        button: this.selectedButtonElement
                    }), this.nextEvent && (this.currentUserDetails && "annotations" === this.currentUserDetails.coll && n.removeAnnotation(this.currentUserDetails), this.mouseMoveEvent = this.nextEvent = !1)), o ? (this.selectedButton = e, this.selectedButtonElement = t, b(this, "selectButton", {
                        button: t
                    }), e.init && e.init.call(this, t, i), (e.start || e.steps) && n.renderer.boxWrapper.addClass("highcharts-draw-mode")) : (n.stockTools && t.classList.remove("highcharts-active"), r.removeClass("highcharts-draw-mode"), this.nextEvent = !1, this.mouseMoveEvent = !1, this.selectedButton = null);
                }
                bindingsChartClick(t, e) {
                    t = this.chart;
                    let i = this.activeAnnotation, n = this.selectedButton, r = t.renderer.boxWrapper;
                    i && (i.cancelClick || e.activeAnnotation || !e.target.parentNode || function(t, e) {
                        let i = d.Element.prototype, n = i.matches || i.msMatchesSelector || i.webkitMatchesSelector, r = null;
                        if (i.closest) r = i.closest.call(t, e);
                        else do {
                            if (n.call(t, e)) return t;
                            t = t.parentElement || t.parentNode;
                        }while (null !== t && 1 === t.nodeType);
                        return r;
                    }(e.target, ".highcharts-popup") ? i.cancelClick && setTimeout(()=>{
                        i.cancelClick = !1;
                    }, 0) : b(this, "closePopup")), n && n.start && (this.nextEvent ? (this.nextEvent(e, this.currentUserDetails), this.steps && (this.stepIndex++, n.steps[this.stepIndex] ? this.mouseMoveEvent = this.nextEvent = n.steps[this.stepIndex] : (b(this, "deselectButton", {
                        button: this.selectedButtonElement
                    }), r.removeClass("highcharts-draw-mode"), n.end && n.end.call(this, e, this.currentUserDetails), this.nextEvent = !1, this.mouseMoveEvent = !1, this.selectedButton = null))) : (this.currentUserDetails = n.start.call(this, e), this.currentUserDetails && n.steps ? (this.stepIndex = 0, this.steps = !0, this.mouseMoveEvent = this.nextEvent = n.steps[this.stepIndex]) : (b(this, "deselectButton", {
                        button: this.selectedButtonElement
                    }), r.removeClass("highcharts-draw-mode"), this.steps = !1, this.selectedButton = null, n.end && n.end.call(this, e, this.currentUserDetails))));
                }
                bindingsContainerMouseMove(t, e) {
                    this.mouseMoveEvent && this.mouseMoveEvent(e, this.currentUserDetails);
                }
                fieldsToOptions(t, e) {
                    return S(t, (t, i)=>{
                        let n = parseFloat(t), r = i.split("."), o = r.length - 1;
                        if (!v(n) || t.match(/px|em/g) || i.match(/format/g) || (t = n), "undefined" !== t) {
                            let i = e;
                            r.forEach((e, n)=>{
                                if ("__proto__" !== e && "constructor" !== e) {
                                    let s = k(r[n + 1], "");
                                    o === n ? i[e] = t : (i[e] || (i[e] = s.match(/\d/g) ? [] : {}), i = i[e]);
                                }
                            });
                        }
                    }), e;
                }
                deselectAnnotation() {
                    this.activeAnnotation && (this.activeAnnotation.setControlPointsVisibility(!1), this.activeAnnotation = !1);
                }
                annotationToFields(t) {
                    let e = t.options, i = D.annotationsEditable, n = i.nestedOptions, r = k(e.type, e.shapes && e.shapes[0] && e.shapes[0].type, e.labels && e.labels[0] && e.labels[0].type, "label"), o = D.annotationsNonEditable[e.langKey] || [], s = {
                        langKey: e.langKey,
                        type: r
                    };
                    function a(e, i, r, s, h) {
                        let c;
                        r && m(e) && -1 === o.indexOf(i) && ((r.indexOf && r.indexOf(i)) >= 0 || r[i] || !0 === r) && (y(e) ? (s[i] = [], e.forEach((t, e)=>{
                            w(t) ? (s[i][e] = {}, S(t, (t, r)=>{
                                a(t, r, n[i], s[i][e], i);
                            })) : a(t, 0, n[i], s[i], i);
                        })) : w(e) ? (c = {}, y(s) ? (s.push(c), c[i] = {}, c = c[i]) : s[i] = c, S(e, (t, e)=>{
                            a(t, e, 0 === i ? r : n[i], c, i);
                        })) : "format" === i ? s[i] = [
                            l(e, t.labels[0].points[0]).toString(),
                            "text"
                        ] : y(s) ? s.push([
                            e,
                            p(h, e)
                        ]) : s[i] = [
                            e,
                            p(i, e)
                        ]);
                    }
                    return S(e, (t, o)=>{
                        "typeOptions" === o ? (s[o] = {}, S(e[o], (t, e)=>{
                            a(t, e, n, s[o], e);
                        })) : a(t, o, i[r], s, o);
                    }), s;
                }
                getClickedClassNames(t, e) {
                    let i, n = e.target, r = [];
                    for(; n && n.tagName && ((i = g(n, "class")) && (r = r.concat(i.split(" ").map((t)=>[
                            t,
                            n
                        ]))), (n = n.parentNode) !== t););
                    return r;
                }
                getButtonEvents(t, e) {
                    let i, n = this;
                    return this.getClickedClassNames(t, e).forEach((t)=>{
                        n.boundClassNames[t[0]] && !i && (i = {
                            events: n.boundClassNames[t[0]],
                            button: t[1]
                        });
                    }), i;
                }
                update(t) {
                    this.options = C(!0, this.options, t), this.removeEvents(), this.initEvents();
                }
                removeEvents() {
                    this.eventsToUnbind.forEach((t)=>t());
                }
                destroy() {
                    this.removeEvents();
                }
            }
            return D.annotationsEditable = {
                nestedOptions: {
                    labelOptions: [
                        "style",
                        "format",
                        "backgroundColor"
                    ],
                    labels: [
                        "style"
                    ],
                    label: [
                        "style"
                    ],
                    style: [
                        "fontSize",
                        "color"
                    ],
                    background: [
                        "fill",
                        "strokeWidth",
                        "stroke"
                    ],
                    innerBackground: [
                        "fill",
                        "strokeWidth",
                        "stroke"
                    ],
                    outerBackground: [
                        "fill",
                        "strokeWidth",
                        "stroke"
                    ],
                    shapeOptions: [
                        "fill",
                        "strokeWidth",
                        "stroke"
                    ],
                    shapes: [
                        "fill",
                        "strokeWidth",
                        "stroke"
                    ],
                    line: [
                        "strokeWidth",
                        "stroke"
                    ],
                    backgroundColors: [
                        !0
                    ],
                    connector: [
                        "fill",
                        "strokeWidth",
                        "stroke"
                    ],
                    crosshairX: [
                        "strokeWidth",
                        "stroke"
                    ],
                    crosshairY: [
                        "strokeWidth",
                        "stroke"
                    ]
                },
                circle: [
                    "shapes"
                ],
                ellipse: [
                    "shapes"
                ],
                verticalLine: [],
                label: [
                    "labelOptions"
                ],
                measure: [
                    "background",
                    "crosshairY",
                    "crosshairX"
                ],
                fibonacci: [],
                tunnel: [
                    "background",
                    "line",
                    "height"
                ],
                pitchfork: [
                    "innerBackground",
                    "outerBackground"
                ],
                rect: [
                    "shapes"
                ],
                crookedLine: [],
                basicAnnotation: [
                    "shapes",
                    "labelOptions"
                ]
            }, D.annotationsNonEditable = {
                rectangle: [
                    "crosshairX",
                    "crosshairY",
                    "labelOptions"
                ],
                ellipse: [
                    "labelOptions"
                ],
                circle: [
                    "labelOptions"
                ]
            }, D;
        }), i(e, "masters/modules/annotations.src.js", [
            e["Core/Globals.js"],
            e["Extensions/Annotations/Annotation.js"],
            e["Extensions/Annotations/NavigationBindings.js"]
        ], function(t, e, i) {
            return t.Annotation = t.Annotation || e, t.NavigationBindings = t.NavigationBindings || i, t.Annotation.compose(t.Chart, t.NavigationBindings, t.Pointer, t.SVGRenderer), t;
        });
    }, t.exports ? (e.default = e, t.exports = e) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}(Br)), Br.exports), Hr = b(zr), Ur = {
    exports: {}
};
var Wr, Yr = (Fr || (Fr = 1, function(t) {
    var e;
    e = function(t) {
        var e = t ? t._modules : {};
        function i(e, i, n, r) {
            e.hasOwnProperty(i) || (e[i] = r.apply(null, n), "function" == typeof CustomEvent && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
                detail: {
                    path: i,
                    module: e[i]
                }
            })));
        }
        i(e, "Core/Chart/ChartNavigationComposition.js", [], function() {
            var t;
            return function(t) {
                t.compose = function(t) {
                    return t.navigation || (t.navigation = new e(t)), t;
                };
                class e {
                    constructor(t){
                        this.updates = [], this.chart = t;
                    }
                    addUpdate(t) {
                        this.chart.navigation.updates.push(t);
                    }
                    update(t, e) {
                        this.updates.forEach((i)=>{
                            i.call(this.chart, t, e);
                        });
                    }
                }
                t.Additions = e;
            }(t || (t = {})), t;
        }), i(e, "Extensions/Exporting/ExportingDefaults.js", [
            e["Core/Globals.js"]
        ], function(t) {
            let { isTouchDevice: e } = t;
            return {
                exporting: {
                    allowTableSorting: !0,
                    type: "image/png",
                    url: "https://export.highcharts.com/",
                    pdfFont: {
                        normal: void 0,
                        bold: void 0,
                        bolditalic: void 0,
                        italic: void 0
                    },
                    printMaxWidth: 780,
                    scale: 2,
                    buttons: {
                        contextButton: {
                            className: "highcharts-contextbutton",
                            menuClassName: "highcharts-contextmenu",
                            symbol: "menu",
                            titleKey: "contextButtonTitle",
                            menuItems: [
                                "viewFullscreen",
                                "printChart",
                                "separator",
                                "downloadPNG",
                                "downloadJPEG",
                                "downloadPDF",
                                "downloadSVG"
                            ]
                        }
                    },
                    menuItemDefinitions: {
                        viewFullscreen: {
                            textKey: "viewFullscreen",
                            onclick: function() {
                                this.fullscreen && this.fullscreen.toggle();
                            }
                        },
                        printChart: {
                            textKey: "printChart",
                            onclick: function() {
                                this.print();
                            }
                        },
                        separator: {
                            separator: !0
                        },
                        downloadPNG: {
                            textKey: "downloadPNG",
                            onclick: function() {
                                this.exportChart();
                            }
                        },
                        downloadJPEG: {
                            textKey: "downloadJPEG",
                            onclick: function() {
                                this.exportChart({
                                    type: "image/jpeg"
                                });
                            }
                        },
                        downloadPDF: {
                            textKey: "downloadPDF",
                            onclick: function() {
                                this.exportChart({
                                    type: "application/pdf"
                                });
                            }
                        },
                        downloadSVG: {
                            textKey: "downloadSVG",
                            onclick: function() {
                                this.exportChart({
                                    type: "image/svg+xml"
                                });
                            }
                        }
                    }
                },
                lang: {
                    viewFullscreen: "View in full screen",
                    exitFullscreen: "Exit from full screen",
                    printChart: "Print chart",
                    downloadPNG: "Download PNG image",
                    downloadJPEG: "Download JPEG image",
                    downloadPDF: "Download PDF document",
                    downloadSVG: "Download SVG vector image",
                    contextButtonTitle: "Chart context menu"
                },
                navigation: {
                    buttonOptions: {
                        symbolSize: 14,
                        symbolX: 14.5,
                        symbolY: 13.5,
                        align: "right",
                        buttonSpacing: 3,
                        height: 28,
                        verticalAlign: "top",
                        width: 28,
                        symbolFill: "#666666",
                        symbolStroke: "#666666",
                        symbolStrokeWidth: 3,
                        theme: {
                            fill: "#ffffff",
                            padding: 5,
                            stroke: "none",
                            "stroke-linecap": "round"
                        }
                    },
                    menuStyle: {
                        border: "none",
                        borderRadius: "3px",
                        background: "#ffffff",
                        padding: "0.5em"
                    },
                    menuItemStyle: {
                        background: "none",
                        borderRadius: "3px",
                        color: "#333333",
                        padding: "0.5em",
                        fontSize: e ? "0.9em" : "0.8em",
                        transition: "background 250ms, color 250ms"
                    },
                    menuItemHoverStyle: {
                        background: "#f2f2f2"
                    }
                }
            };
        }), i(e, "Extensions/Exporting/ExportingSymbols.js", [], function() {
            var t;
            return function(t) {
                let e = [];
                function i(t, e, i, n) {
                    return [
                        [
                            "M",
                            t,
                            e + 2.5
                        ],
                        [
                            "L",
                            t + i,
                            e + 2.5
                        ],
                        [
                            "M",
                            t,
                            e + n / 2 + .5
                        ],
                        [
                            "L",
                            t + i,
                            e + n / 2 + .5
                        ],
                        [
                            "M",
                            t,
                            e + n - 1.5
                        ],
                        [
                            "L",
                            t + i,
                            e + n - 1.5
                        ]
                    ];
                }
                function n(t, e, i, n) {
                    let r = n / 3 - 2;
                    return [].concat(this.circle(i - r, e, r, r), this.circle(i - r, e + r + 4, r, r), this.circle(i - r, e + 2 * (r + 4), r, r));
                }
                t.compose = function(t) {
                    if (-1 === e.indexOf(t)) {
                        e.push(t);
                        let r = t.prototype.symbols;
                        r.menu = i, r.menuball = n.bind(r);
                    }
                };
            }(t || (t = {})), t;
        }), i(e, "Extensions/Exporting/Fullscreen.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i) {
            let { composed: n } = e, { addEvent: r, fireEvent: o, pushUnique: s } = i;
            function a() {
                this.fullscreen = new l(this);
            }
            class l {
                static compose(t) {
                    s(n, "Fullscreen") && r(t, "beforeRender", a);
                }
                constructor(t){
                    this.chart = t, this.isOpen = !1;
                    let e = t.renderTo;
                    !this.browserProps && ("function" == typeof e.requestFullscreen ? this.browserProps = {
                        fullscreenChange: "fullscreenchange",
                        requestFullscreen: "requestFullscreen",
                        exitFullscreen: "exitFullscreen"
                    } : e.mozRequestFullScreen ? this.browserProps = {
                        fullscreenChange: "mozfullscreenchange",
                        requestFullscreen: "mozRequestFullScreen",
                        exitFullscreen: "mozCancelFullScreen"
                    } : e.webkitRequestFullScreen ? this.browserProps = {
                        fullscreenChange: "webkitfullscreenchange",
                        requestFullscreen: "webkitRequestFullScreen",
                        exitFullscreen: "webkitExitFullscreen"
                    } : e.msRequestFullscreen && (this.browserProps = {
                        fullscreenChange: "MSFullscreenChange",
                        requestFullscreen: "msRequestFullscreen",
                        exitFullscreen: "msExitFullscreen"
                    }));
                }
                close() {
                    let t = this, e = t.chart, i = e.options.chart;
                    o(e, "fullscreenClose", null, function() {
                        t.isOpen && t.browserProps && e.container.ownerDocument instanceof Document && e.container.ownerDocument[t.browserProps.exitFullscreen](), t.unbindFullscreenEvent && (t.unbindFullscreenEvent = t.unbindFullscreenEvent()), e.setSize(t.origWidth, t.origHeight, !1), t.origWidth = void 0, t.origHeight = void 0, i.width = t.origWidthOption, i.height = t.origHeightOption, t.origWidthOption = void 0, t.origHeightOption = void 0, t.isOpen = !1, t.setButtonText();
                    });
                }
                open() {
                    let t = this, e = t.chart, i = e.options.chart;
                    o(e, "fullscreenOpen", null, function() {
                        if (i && (t.origWidthOption = i.width, t.origHeightOption = i.height), t.origWidth = e.chartWidth, t.origHeight = e.chartHeight, t.browserProps) {
                            let i = r(e.container.ownerDocument, t.browserProps.fullscreenChange, function() {
                                t.isOpen ? (t.isOpen = !1, t.close()) : (e.setSize(null, null, !1), t.isOpen = !0, t.setButtonText());
                            }), n = r(e, "destroy", i);
                            t.unbindFullscreenEvent = ()=>{
                                i(), n();
                            };
                            let o = e.renderTo[t.browserProps.requestFullscreen]();
                            o && o.catch(function() {
                                alert("Full screen is not supported inside a frame.");
                            });
                        }
                    });
                }
                setButtonText() {
                    let e = this.chart, i = e.exportDivElements, n = e.options.exporting, r = n && n.buttons && n.buttons.contextButton.menuItems, o = e.options.lang;
                    if (n && n.menuItemDefinitions && o && o.exitFullscreen && o.viewFullscreen && r && i) {
                        let e = i[r.indexOf("viewFullscreen")];
                        e && t.setElementHTML(e, this.isOpen ? o.exitFullscreen : n.menuItemDefinitions.viewFullscreen.text || o.viewFullscreen);
                    }
                }
                toggle() {
                    this.isOpen ? this.close() : this.open();
                }
            }
            return l;
        }), i(e, "Core/HttpUtilities.js", [
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e) {
            let { win: i } = t, { discardElement: n, objectEach: r } = e, o = {
                ajax: function(t) {
                    let e = {
                        json: "application/json",
                        xml: "application/xml",
                        text: "text/plain",
                        octet: "application/octet-stream"
                    }, i = new XMLHttpRequest;
                    function n(e, i) {
                        t.error && t.error(e, i);
                    }
                    if (!t.url) return !1;
                    i.open((t.type || "get").toUpperCase(), t.url, !0), t.headers && t.headers["Content-Type"] || i.setRequestHeader("Content-Type", e[t.dataType || "json"] || e.text), r(t.headers, function(t, e) {
                        i.setRequestHeader(e, t);
                    }), t.responseType && (i.responseType = t.responseType), i.onreadystatechange = function() {
                        let e;
                        if (4 === i.readyState) {
                            if (200 === i.status) {
                                if ("blob" !== t.responseType && (e = i.responseText, "json" === t.dataType)) try {
                                    e = JSON.parse(e);
                                } catch (t) {
                                    if (t instanceof Error) return n(i, t);
                                }
                                return t.success && t.success(e, i);
                            }
                            n(i, i.responseText);
                        }
                    }, t.data && "string" != typeof t.data && (t.data = JSON.stringify(t.data)), i.send(t.data);
                },
                getJSON: function(t, e) {
                    o.ajax({
                        url: t,
                        success: e,
                        dataType: "json",
                        headers: {
                            "Content-Type": "text/plain"
                        }
                    });
                },
                post: function(t, e, o) {
                    let s = new i.FormData;
                    r(e, function(t, e) {
                        s.append(e, t);
                    }), s.append("b64", "true");
                    let { filename: a, type: l } = e;
                    return i.fetch(t, {
                        method: "POST",
                        body: s,
                        ...o
                    }).then((t)=>{
                        t.ok && t.text().then((t)=>{
                            let e = document.createElement("a");
                            e.href = `data:${l};base64,${t}`, e.download = a, e.click(), n(e);
                        });
                    });
                }
            };
            return o;
        }), i(e, "Extensions/Exporting/Exporting.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Chart/Chart.js"],
            e["Core/Chart/ChartNavigationComposition.js"],
            e["Core/Defaults.js"],
            e["Extensions/Exporting/ExportingDefaults.js"],
            e["Extensions/Exporting/ExportingSymbols.js"],
            e["Extensions/Exporting/Fullscreen.js"],
            e["Core/Globals.js"],
            e["Core/HttpUtilities.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a, l, h) {
            var c;
            let { defaultOptions: d } = n, { doc: u, SVG_NS: p, win: f } = a, { addEvent: g, css: m, createElement: b, discardElement: y, extend: x, find: v, fireEvent: w, isObject: C, merge: S, objectEach: k, pick: A, removeEvent: E, uniqueKey: M } = h;
            return function(e) {
                let n, c = [
                    /-/,
                    /^(clipPath|cssText|d|height|width)$/,
                    /^font$/,
                    /[lL]ogical(Width|Height)$/,
                    /^parentRule$/,
                    /^(cssRules|ownerRules)$/,
                    /perspective/,
                    /TapHighlightColor/,
                    /^transition/,
                    /^length$/,
                    /^\d+$/
                ], T = [
                    "fill",
                    "stroke",
                    "strokeLinecap",
                    "strokeLinejoin",
                    "strokeWidth",
                    "textAnchor",
                    "x",
                    "y"
                ];
                e.inlineAllowlist = [];
                let P = [
                    "clipPath",
                    "defs",
                    "desc"
                ];
                function R(t) {
                    let e, i, n = this, r = n.renderer, o = S(n.options.navigation.buttonOptions, t), s = o.onclick, a = o.menuItems, l = o.symbolSize || 12;
                    if (n.btnCount || (n.btnCount = 0), n.exportDivElements || (n.exportDivElements = [], n.exportSVGElements = []), !1 === o.enabled || !o.theme) return;
                    let h = n.styledMode ? {} : o.theme;
                    s ? i = function(t) {
                        t && t.stopPropagation(), s.call(n, t);
                    } : a && (i = function(t) {
                        t && t.stopPropagation(), n.contextMenu(c.menuClassName, a, c.translateX || 0, c.translateY || 0, c.width || 0, c.height || 0, c), c.setState(2);
                    }), o.text && o.symbol ? h.paddingLeft = A(h.paddingLeft, 30) : o.text || x(h, {
                        width: o.width,
                        height: o.height,
                        padding: 0
                    });
                    let c = r.button(o.text, 0, 0, i, h, void 0, void 0, void 0, void 0, o.useHTML).addClass(t.className).attr({
                        title: A(n.options.lang[o._titleKey || o.titleKey], "")
                    });
                    c.menuClassName = t.menuClassName || "highcharts-menu-" + n.btnCount++, o.symbol && (e = r.symbol(o.symbol, Math.round((o.symbolX || 0) - l / 2), Math.round((o.symbolY || 0) - l / 2), l, l, {
                        width: l,
                        height: l
                    }).addClass("highcharts-button-symbol").attr({
                        zIndex: 1
                    }).add(c), n.styledMode || e.attr({
                        stroke: o.symbolStroke,
                        fill: o.symbolFill,
                        "stroke-width": o.symbolStrokeWidth || 1
                    })), c.add(n.exportingGroup).align(x(o, {
                        width: c.width,
                        x: A(o.x, n.buttonOffset)
                    }), !0, "spacingBox"), n.buttonOffset += ((c.width || 0) + o.buttonSpacing) * ("right" === o.align ? -1 : 1), n.exportSVGElements.push(c, e);
                }
                function L() {
                    if (!this.printReverseInfo) return;
                    let { childNodes: t, origDisplay: e, resetParams: i } = this.printReverseInfo;
                    this.moveContainers(this.renderTo), [].forEach.call(t, function(t, i) {
                        1 === t.nodeType && (t.style.display = e[i] || "");
                    }), this.isPrinting = !1, i && this.setSize.apply(this, i), delete this.printReverseInfo, n = void 0, w(this, "afterPrint");
                }
                function O() {
                    let t = u.body, e = this.options.exporting.printMaxWidth, i = {
                        childNodes: t.childNodes,
                        origDisplay: [],
                        resetParams: void 0
                    };
                    this.isPrinting = !0, this.pointer?.reset(void 0, 0), w(this, "beforePrint"), e && this.chartWidth > e && (i.resetParams = [
                        this.options.chart.width,
                        void 0,
                        !1
                    ], this.setSize(e, void 0, !1)), [].forEach.call(i.childNodes, function(t, e) {
                        1 === t.nodeType && (i.origDisplay[e] = t.style.display, t.style.display = "none");
                    }), this.moveContainers(t), this.printReverseInfo = i;
                }
                function D(t) {
                    t.renderExporting(), g(t, "redraw", t.renderExporting), g(t, "destroy", t.destroyExport);
                }
                function j(e, i, n, r, o, s, a) {
                    let l, c = this, d = c.options.navigation, p = c.chartWidth, y = c.chartHeight, v = "cache-" + e, S = Math.max(o, s), k = c[v];
                    k || (c.exportContextMenu = c[v] = k = b("div", {
                        className: e
                    }, {
                        position: "absolute",
                        zIndex: 1e3,
                        padding: S + "px",
                        pointerEvents: "auto",
                        ...c.renderer.style
                    }, c.scrollablePlotArea?.fixedDiv || c.container), l = b("ul", {
                        className: "highcharts-menu"
                    }, c.styledMode ? {} : {
                        listStyle: "none",
                        margin: 0,
                        padding: 0
                    }, k), c.styledMode || m(l, x({
                        MozBoxShadow: "3px 3px 10px #888",
                        WebkitBoxShadow: "3px 3px 10px #888",
                        boxShadow: "3px 3px 10px #888"
                    }, d.menuStyle)), k.hideMenu = function() {
                        m(k, {
                            display: "none"
                        }), a && a.setState(0), c.openMenu = !1, m(c.renderTo, {
                            overflow: "hidden"
                        }), m(c.container, {
                            overflow: "hidden"
                        }), h.clearTimeout(k.hideTimer), w(c, "exportMenuHidden");
                    }, c.exportEvents.push(g(k, "mouseleave", function() {
                        k.hideTimer = f.setTimeout(k.hideMenu, 500);
                    }), g(k, "mouseenter", function() {
                        h.clearTimeout(k.hideTimer);
                    }), g(u, "mouseup", function(t) {
                        c.pointer?.inClass(t.target, e) || k.hideMenu();
                    }), g(k, "click", function() {
                        c.openMenu && k.hideMenu();
                    })), i.forEach(function(e) {
                        if ("string" == typeof e && (e = c.options.exporting.menuItemDefinitions[e]), C(e, !0)) {
                            let i;
                            e.separator ? i = b("hr", void 0, void 0, l) : ("viewData" === e.textKey && c.isDataTableVisible && (e.textKey = "hideData"), i = b("li", {
                                className: "highcharts-menu-item",
                                onclick: function(t) {
                                    t && t.stopPropagation(), k.hideMenu(), "string" != typeof e && e.onclick && e.onclick.apply(c, arguments);
                                }
                            }, void 0, l), t.setElementHTML(i, e.text || c.options.lang[e.textKey]), c.styledMode || (i.onmouseover = function() {
                                m(this, d.menuItemHoverStyle);
                            }, i.onmouseout = function() {
                                m(this, d.menuItemStyle);
                            }, m(i, x({
                                cursor: "pointer"
                            }, d.menuItemStyle || {})))), c.exportDivElements.push(i);
                        }
                    }), c.exportDivElements.push(l, k), c.exportMenuWidth = k.offsetWidth, c.exportMenuHeight = k.offsetHeight);
                    let A = {
                        display: "block"
                    };
                    n + (c.exportMenuWidth || 0) > p ? A.right = p - n - o - S + "px" : A.left = n - S + "px", r + s + (c.exportMenuHeight || 0) > y && "top" !== a.alignOptions?.verticalAlign ? A.bottom = y - r - S + "px" : A.top = r + s - S + "px", m(k, A), m(c.renderTo, {
                        overflow: ""
                    }), m(c.container, {
                        overflow: ""
                    }), c.openMenu = !0, w(c, "exportMenuShown");
                }
                function N(t) {
                    let e, i = t ? t.target : this, n = i.exportSVGElements, r = i.exportDivElements, o = i.exportEvents;
                    n && (n.forEach((t, r)=>{
                        t && (t.onclick = t.ontouchstart = null, i[e = "cache-" + t.menuClassName] && delete i[e], n[r] = t.destroy());
                    }), n.length = 0), i.exportingGroup && (i.exportingGroup.destroy(), delete i.exportingGroup), r && (r.forEach(function(t, e) {
                        t && (h.clearTimeout(t.hideTimer), E(t, "mouseleave"), r[e] = t.onmouseout = t.onmouseover = t.ontouchstart = t.onclick = null, y(t));
                    }), r.length = 0), o && (o.forEach(function(t) {
                        t();
                    }), o.length = 0);
                }
                function I(t, e) {
                    let i = this.getSVGForExport(t, e);
                    t = S(this.options.exporting, t), l.post(t.url, {
                        filename: t.filename ? t.filename.replace(/\//g, "-") : this.getFilename(),
                        type: t.type,
                        width: t.width,
                        scale: t.scale,
                        svg: i
                    }, t.fetchOptions);
                }
                function B() {
                    return this.styledMode && this.inlineStyles(), this.container.innerHTML;
                }
                function F() {
                    let t = this.userOptions.title && this.userOptions.title.text, e = this.options.exporting.filename;
                    return e ? e.replace(/\//g, "-") : ("string" == typeof t && (e = t.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!e || e.length < 5) && (e = "chart"), e);
                }
                function z(t) {
                    let e, i, n = S(this.options, t);
                    n.plotOptions = S(this.userOptions.plotOptions, t && t.plotOptions), n.time = S(this.userOptions.time, t && t.time);
                    let r = b("div", null, {
                        position: "absolute",
                        top: "-9999em",
                        width: this.chartWidth + "px",
                        height: this.chartHeight + "px"
                    }, u.body), o = this.renderTo.style.width, s = this.renderTo.style.height, a = n.exporting.sourceWidth || n.chart.width || /px$/.test(o) && parseInt(o, 10) || (n.isGantt ? 800 : 600), l = n.exporting.sourceHeight || n.chart.height || /px$/.test(s) && parseInt(s, 10) || 400;
                    x(n.chart, {
                        animation: !1,
                        renderTo: r,
                        forExport: !0,
                        renderer: "SVGRenderer",
                        width: a,
                        height: l
                    }), n.exporting.enabled = !1, delete n.data, n.series = [], this.series.forEach(function(t) {
                        (i = S(t.userOptions, {
                            animation: !1,
                            enableMouseTracking: !1,
                            showCheckbox: !1,
                            visible: t.visible
                        })).isInternal || n.series.push(i);
                    });
                    let h = {};
                    this.axes.forEach(function(t) {
                        t.userOptions.internalKey || (t.userOptions.internalKey = M()), t.options.isInternal || (h[t.coll] || (h[t.coll] = !0, n[t.coll] = []), n[t.coll].push(S(t.userOptions, {
                            visible: t.visible,
                            type: t.type,
                            uniqueNames: t.uniqueNames
                        })));
                    }), n.colorAxis = this.userOptions.colorAxis;
                    let c = new this.constructor(n, this.callback);
                    return t && [
                        "xAxis",
                        "yAxis",
                        "series"
                    ].forEach(function(e) {
                        let i = {};
                        t[e] && (i[e] = t[e], c.update(i));
                    }), this.axes.forEach(function(t) {
                        let e = v(c.axes, function(e) {
                            return e.options.internalKey === t.userOptions.internalKey;
                        }), i = t.getExtremes(), n = i.userMin, r = i.userMax;
                        e && (void 0 !== n && n !== e.min || void 0 !== r && r !== e.max) && e.setExtremes(n, r, !0, !1);
                    }), e = c.getChartHTML(), w(this, "getSVG", {
                        chartCopy: c
                    }), e = this.sanitizeSVG(e, n), n = null, c.destroy(), y(r), e;
                }
                function H(t, e) {
                    let i = this.options.exporting;
                    return this.getSVG(S({
                        chart: {
                            borderRadius: 0
                        }
                    }, i.chartOptions, e, {
                        exporting: {
                            sourceWidth: t && t.sourceWidth || i.sourceWidth,
                            sourceHeight: t && t.sourceHeight || i.sourceHeight
                        }
                    }));
                }
                function U() {
                    let t, i = e.inlineAllowlist, n = {}, r = u.createElement("iframe");
                    m(r, {
                        width: "1px",
                        height: "1px",
                        visibility: "hidden"
                    }), u.body.appendChild(r);
                    let o = r.contentWindow && r.contentWindow.document;
                    o && o.body.appendChild(o.createElementNS(p, "svg")), function e(r) {
                        let s, l, h, d, u, p, g = {};
                        if (o && 1 === r.nodeType && -1 === P.indexOf(r.nodeName)) {
                            if (s = f.getComputedStyle(r, null), l = "svg" === r.nodeName ? {} : f.getComputedStyle(r.parentNode, null), !n[r.nodeName]) {
                                t = o.getElementsByTagName("svg")[0], h = o.createElementNS(r.namespaceURI, r.nodeName), t.appendChild(h);
                                let e = f.getComputedStyle(h, null), i = {};
                                for(let t in e)t.length < 1e3 && "string" == typeof e[t] && !/^\d+$/.test(t) && (i[t] = e[t]);
                                n[r.nodeName] = i, "text" === r.nodeName && delete n.text.fill, t.removeChild(h);
                            }
                            for(let t in s)(a.isFirefox || a.isMS || a.isSafari || Object.hasOwnProperty.call(s, t)) && function(t, _e1) {
                                if (d = u = !1, i.length) {
                                    for(p = i.length; p-- && !u;)u = i[p].test(_e1);
                                    d = !u;
                                }
                                for("transform" === _e1 && "none" === t && (d = !0), p = c.length; p-- && !d;){
                                    if (_e1.length > 1e3) throw Error("Input too long");
                                    d = c[p].test(_e1) || "function" == typeof t;
                                }
                                !d && (l[_e1] !== t || "svg" === r.nodeName) && n[r.nodeName][_e1] !== t && (T && -1 === T.indexOf(_e1) ? g[_e1] = t : t && r.setAttribute(_e1.replace(/[A-Z]/g, function(t) {
                                    return "-" + t.toLowerCase();
                                }), t));
                            }(s[t], t);
                            if (m(r, g), "svg" === r.nodeName && r.setAttribute("stroke-width", "1px"), "text" === r.nodeName) return;
                            [].forEach.call(r.children || r.childNodes, e);
                        }
                    }(this.container.querySelector("svg")), t.parentNode.removeChild(t), r.parentNode.removeChild(r);
                }
                function W(t) {
                    let { scrollablePlotArea: e } = this;
                    (e ? [
                        e.fixedDiv,
                        e.scrollingContainer
                    ] : [
                        this.container
                    ]).forEach(function(e) {
                        t.appendChild(e);
                    });
                }
                function Y() {
                    let t = this, e = (e, i, n)=>{
                        t.isDirtyExporting = !0, S(!0, t.options[e], i), A(n, !0) && t.redraw();
                    };
                    t.exporting = {
                        update: function(t, i) {
                            e("exporting", t, i);
                        }
                    }, i.compose(t).navigation.addUpdate((t, i)=>{
                        e("navigation", t, i);
                    });
                }
                function _() {
                    let t = this;
                    t.isPrinting || (n = t, a.isSafari || t.beforePrint(), setTimeout(()=>{
                        f.focus(), f.print(), a.isSafari || setTimeout(()=>{
                            t.afterPrint();
                        }, 1e3);
                    }, 1));
                }
                function X() {
                    let t = this, e = t.options.exporting, i = e.buttons, n = t.isDirtyExporting || !t.exportSVGElements;
                    t.buttonOffset = 0, t.isDirtyExporting && t.destroyExport(), n && !1 !== e.enabled && (t.exportEvents = [], t.exportingGroup = t.exportingGroup || t.renderer.g("exporting-group").attr({
                        zIndex: 3
                    }).add(), k(i, function(e) {
                        t.addButton(e);
                    }), t.isDirtyExporting = !1);
                }
                function G(t, e) {
                    let i = t.indexOf("</svg>") + 6, n = t.substr(i);
                    return t = t.substr(0, i), e && e.exporting && e.exporting.allowHTML && n && (n = '<foreignObject x="0" y="0" width="' + e.chart.width + '" height="' + e.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + n.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", t = t.replace("</svg>", n + "</svg>")), t.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/(fill|stroke)="rgba\(([ \d]+,[ \d]+,[ \d]+),([ \d\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, "\xa0").replace(/&shy;/g, "\xad");
                }
                e.compose = function(t, e) {
                    o.compose(e), s.compose(t);
                    let i = t.prototype;
                    i.exportChart || (i.afterPrint = L, i.exportChart = I, i.inlineStyles = U, i.print = _, i.sanitizeSVG = G, i.getChartHTML = B, i.getSVG = z, i.getSVGForExport = H, i.getFilename = F, i.moveContainers = W, i.beforePrint = O, i.contextMenu = j, i.addButton = R, i.destroyExport = N, i.renderExporting = X, i.callbacks.push(D), g(t, "init", Y), a.isSafari && f.matchMedia("print").addListener(function(t) {
                        n && (t.matches ? n.beforePrint() : n.afterPrint());
                    }), d.exporting = S(r.exporting, d.exporting), d.lang = S(r.lang, d.lang), d.navigation = S(r.navigation, d.navigation));
                };
            }(c || (c = {})), c;
        }), i(e, "masters/modules/exporting.src.js", [
            e["Core/Globals.js"],
            e["Extensions/Exporting/Exporting.js"],
            e["Core/HttpUtilities.js"]
        ], function(t, e, i) {
            return t.HttpUtilities = t.HttpUtilities || i, t.ajax = t.HttpUtilities.ajax, t.getJSON = t.HttpUtilities.getJSON, t.post = t.HttpUtilities.post, e.compose(t.Chart, t.Renderer), t;
        });
    }, t.exports ? (e.default = e, t.exports = e) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}(Ur)), Ur.exports), _r = b(Yr), Xr = {
    exports: {}
};
var Gr, qr = (Wr || (Wr = 1, function(t) {
    var e;
    e = function(t) {
        var e = t ? t._modules : {};
        function i(e, i, n, r) {
            e.hasOwnProperty(i) || (e[i] = r.apply(null, n), "function" == typeof CustomEvent && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
                detail: {
                    path: i,
                    module: e[i]
                }
            })));
        }
        i(e, "Extensions/DownloadURL.js", [
            e["Core/Globals.js"]
        ], function(t) {
            let { isSafari: e, win: i, win: { document: n } } = t, r = i.URL || i.webkitURL || i;
            function o(t) {
                let e = t.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
                if (e && e.length > 3 && i.atob && i.ArrayBuffer && i.Uint8Array && i.Blob && r.createObjectURL) {
                    let t = i.atob(e[3]), n = new i.ArrayBuffer(t.length), o = new i.Uint8Array(n);
                    for(let e = 0; e < o.length; ++e)o[e] = t.charCodeAt(e);
                    return r.createObjectURL(new i.Blob([
                        o
                    ], {
                        type: e[1]
                    }));
                }
            }
            return {
                dataURLtoBlob: o,
                downloadURL: function(t, r) {
                    let s = i.navigator, a = n.createElement("a");
                    if ("string" != typeof t && !(t instanceof String) && s.msSaveOrOpenBlob) return void s.msSaveOrOpenBlob(t, r);
                    if (t = "" + t, s.userAgent.length > 1e3) throw Error("Input too long");
                    let l = /Edge\/\d+/.test(s.userAgent);
                    if ((e && "string" == typeof t && 0 === t.indexOf("data:application/pdf") || l || t.length > 2e6) && !(t = o(t) || "")) throw Error("Failed to convert to blob");
                    if (void 0 !== a.download) a.href = t, a.download = r, n.body.appendChild(a), a.click(), n.body.removeChild(a);
                    else try {
                        if (!i.open(t, "chart")) throw Error("Failed to open window");
                    } catch  {
                        i.location.href = t;
                    }
                }
            };
        }), i(e, "Extensions/OfflineExporting/OfflineExportingDefaults.js", [], function() {
            return {
                libURL: "https://code.highcharts.com/11.4.8/lib/",
                menuItemDefinitions: {
                    downloadPNG: {
                        textKey: "downloadPNG",
                        onclick: function() {
                            this.exportChartLocal();
                        }
                    },
                    downloadJPEG: {
                        textKey: "downloadJPEG",
                        onclick: function() {
                            this.exportChartLocal({
                                type: "image/jpeg"
                            });
                        }
                    },
                    downloadSVG: {
                        textKey: "downloadSVG",
                        onclick: function() {
                            this.exportChartLocal({
                                type: "image/svg+xml"
                            });
                        }
                    },
                    downloadPDF: {
                        textKey: "downloadPDF",
                        onclick: function() {
                            this.exportChartLocal({
                                type: "application/pdf"
                            });
                        }
                    }
                }
            };
        }), i(e, "Extensions/OfflineExporting/OfflineExporting.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Chart/Chart.js"],
            e["Core/Defaults.js"],
            e["Extensions/DownloadURL.js"],
            e["Extensions/Exporting/Exporting.js"],
            e["Core/Globals.js"],
            e["Core/HttpUtilities.js"],
            e["Extensions/OfflineExporting/OfflineExportingDefaults.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o, s, a, l) {
            var h;
            let { defaultOptions: c } = i, { downloadURL: d } = n, { doc: u, win: p } = o, { ajax: f } = s, { addEvent: g, error: m, extend: b, fireEvent: y, merge: x } = l;
            return t.allowedAttributes.push("data-z-index", "fill-opacity", "filter", "rx", "ry", "stroke-dasharray", "stroke-linejoin", "stroke-opacity", "text-anchor", "transform", "version", "viewBox", "visibility", "xmlns", "xmlns:xlink"), t.allowedTags.push("desc", "clippath", "g"), function(e) {
                function i(t, i) {
                    let n = this, s = x(n.options.exporting, t), a = function(t) {
                        !1 === s.fallbackToExportServer ? s.error ? s.error(s, t) : m(28, !0) : n.exportChart(s);
                    };
                    o.isMS && n.styledMode && !r.inlineAllowlist.length && r.inlineAllowlist.push(/^blockSize/, /^border/, /^caretColor/, /^color/, /^columnRule/, /^columnRuleColor/, /^cssFloat/, /^cursor/, /^fill$/, /^fillOpacity/, /^font/, /^inlineSize/, /^length/, /^lineHeight/, /^opacity/, /^outline/, /^parentRule/, /^rx$/, /^ry$/, /^stroke/, /^textAlign/, /^textAnchor/, /^textDecoration/, /^transform/, /^vectorEffect/, /^visibility/, /^x$/, /^y$/), o.isMS && ("application/pdf" === s.type || n.container.getElementsByTagName("image").length && "image/svg+xml" !== s.type) || "application/pdf" === s.type && [].some.call(n.container.getElementsByTagName("image"), function(t) {
                        let e = t.getAttribute("href");
                        return "" !== e && "string" == typeof e && 0 !== e.indexOf("data:");
                    }) ? a(Error("Image type not supported for this chart/browser.")) : n.getSVGForLocalExport(s, i || {}, a, function(t) {
                        t.indexOf("<foreignObject") > -1 && "image/svg+xml" !== s.type && (o.isMS || "application/pdf" === s.type) ? a(Error("Image type not supported for charts with embedded HTML")) : e.downloadSVGLocal(t, b({
                            filename: n.getFilename()
                        }, s), a, ()=>y(n, "exportChartLocalSuccess"));
                    });
                }
                function n(t, e) {
                    let i = u.getElementsByTagName("head")[0], n = u.createElement("script");
                    n.type = "text/javascript", n.src = t, n.onload = e, n.onerror = function() {
                        m("Error loading script " + t);
                    }, i.appendChild(n);
                }
                function s(t, i, n, r) {
                    let o, s, a, l, h = this, c = (t)=>h.sanitizeSVG(t, a), d = ()=>{
                        l && m === f && r(c(s.innerHTML));
                    }, u = (t, e, i)=>{
                        ++m, i.imageElement.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), d();
                    }, p = null, f = 0, m = 0;
                    h.unbindGetSVG = g(h, "getSVG", (t)=>{
                        a = t.chartCopy.options, f = (l = (s = t.chartCopy.container.cloneNode(!0)) && s.getElementsByTagName("image") || []).length;
                    }), h.getSVGForExport(t, i);
                    try {
                        if (!l || !l.length) return void r(c(s.innerHTML));
                        for(let i = 0; i < l.length; i++)(p = (o = l[i]).getAttributeNS("http://www.w3.org/1999/xlink", "href")) ? e.imageToDataUrl(p, "image/png", {
                            imageElement: o
                        }, t.scale, u, n, n, n) : (m++, o.parentNode.removeChild(o), i--, d());
                    } catch (t) {
                        n(t);
                    }
                    h.unbindGetSVG();
                }
                function l(t, i, n, r, o, s, a, l, h) {
                    let c, d = new p.Image, f = ()=>{
                        setTimeout(function() {
                            let e, s = u.createElement("canvas"), l = s.getContext && s.getContext("2d");
                            try {
                                if (l) {
                                    s.height = d.height * r, s.width = d.width * r, l.drawImage(d, 0, 0, s.width, s.height);
                                    try {
                                        e = s.toDataURL(i), o(e, i, n, r);
                                    } catch (e) {
                                        c(t, i, n, r);
                                    }
                                } else a(t, i, n, r);
                            } finally{
                                h && h(t, i, n, r);
                            }
                        }, e.loadEventDeferDelay);
                    }, g = ()=>{
                        l(t, i, n, r), h && h(t, i, n, r);
                    };
                    c = ()=>{
                        d = new p.Image, c = s, d.crossOrigin = "Anonymous", d.onload = f, d.onerror = g, d.src = t;
                    }, d.onload = f, d.onerror = g, d.src = t;
                }
                function h(t) {
                    let i = p.navigator.userAgent, n = i.indexOf("WebKit") > -1 && 0 > i.indexOf("Chrome");
                    try {
                        if (!n && -1 === t.indexOf("<foreignObject")) return e.domurl.createObjectURL(new p.Blob([
                            t
                        ], {
                            type: "image/svg+xml;charset-utf-16"
                        }));
                    } catch (t) {}
                    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(t);
                }
                function v(t, e, i, n) {
                    let r = (Number(t.getAttribute("width")) + 2 * e) * i, o = (Number(t.getAttribute("height")) + 2 * e) * i, s = new p.jspdf.jsPDF(o > r ? "p" : "l", "pt", [
                        r,
                        o
                    ]);
                    [].forEach.call(t.querySelectorAll('*[visibility="hidden"]'), function(t) {
                        t.parentNode.removeChild(t);
                    });
                    let a = t.querySelectorAll("linearGradient");
                    for(let t = 0; t < a.length; t++){
                        let e = a[t].querySelectorAll("stop"), i = 0;
                        for(; i < e.length && "0" === e[i].getAttribute("offset") && "0" === e[i + 1].getAttribute("offset");)e[i].remove(), i++;
                    }
                    [].forEach.call(t.querySelectorAll("tspan"), (t)=>{
                        "\u200B" === t.textContent && (t.textContent = " ", t.setAttribute("dx", -5));
                    }), s.svg(t, {
                        x: 0,
                        y: 0,
                        width: r,
                        height: o,
                        removeInvalid: !0
                    }).then(()=>n(s.output("datauristring")));
                }
                e.CanVGRenderer = {}, e.domurl = p.URL || p.webkitURL || p, e.loadEventDeferDelay = o.isMS ? 150 : 0, e.compose = function(t) {
                    let e = t.prototype;
                    return e.exportChartLocal || (e.getSVGForLocalExport = s, e.exportChartLocal = i, x(!0, c.exporting, a)), t;
                }, e.downloadSVGLocal = function(i, r, o, s) {
                    let a, g, m, b = u.createElement("div"), y = r.type || "image/png", x = (r.filename || "chart") + "." + ("image/svg+xml" === y ? "svg" : y.split("/")[1]), w = r.scale || 1, C = r.libURL || c.exporting.libURL, S = !0, k = r.pdfFont;
                    C = "/" !== C.slice(-1) ? C + "/" : C;
                    let A = (t, e)=>{
                        let i, n, r = (t, e)=>{
                            p.jspdf.jsPDF.API.events.push([
                                "initialized",
                                function() {
                                    this.addFileToVFS(t, e), this.addFont(t, "HighchartsFont", t), this.getFontList().HighchartsFont || this.setFont("HighchartsFont");
                                }
                            ]);
                        };
                        k && (n = t.textContent || "", !/[^\u0000-\u007F\u200B]+/.test(n)) && (k = void 0);
                        let o = [
                            "normal",
                            "italic",
                            "bold",
                            "bolditalic"
                        ], s = ()=>{
                            let t = o.shift();
                            if (!t) return e();
                            let n = k && k[t];
                            n ? f({
                                url: n,
                                responseType: "blob",
                                success: (e, n)=>{
                                    let o = new FileReader;
                                    o.onloadend = function() {
                                        if ("string" == typeof this.result) {
                                            let e = this.result.split(",")[1];
                                            r(t, e), "normal" === t && (i = e);
                                        }
                                        s();
                                    }, o.readAsDataURL(n.response);
                                },
                                error: s
                            }) : (i && r(t, i), s());
                        };
                        s();
                    }, E = ()=>{
                        let e, n;
                        t.setElementHTML(b, i);
                        let r = b.getElementsByTagName("text");
                        [].forEach.call(r, function(t) {
                            for([
                                "fontFamily",
                                "fontSize"
                            ].forEach((e)=>{
                                !function(t, e) {
                                    let i = t;
                                    for(; i && i !== b;){
                                        if (i.style[e]) {
                                            let n = i.style[e];
                                            "fontSize" === e && /em$/.test(n) && (n = Math.round(16 * parseFloat(n)) + "px"), t.style[e] = n;
                                            break;
                                        }
                                        i = i.parentNode;
                                    }
                                }(t, e);
                            }), t.style.fontFamily = k && k.normal ? "HighchartsFont" : String(t.style.fontFamily && t.style.fontFamily.split(" ").splice(-1)), e = t.getElementsByTagName("title"), [].forEach.call(e, function(e) {
                                t.removeChild(e);
                            }), n = t.getElementsByClassName("highcharts-text-outline"); n.length > 0;){
                                let t = n[0];
                                t.parentNode && t.parentNode.removeChild(t);
                            }
                        });
                        let a = b.querySelector("svg");
                        a && A(a, ()=>{
                            v(a, 0, w, (t)=>{
                                try {
                                    d(t, x), s && s();
                                } catch (t) {
                                    o(t);
                                }
                            });
                        });
                    };
                    if ("image/svg+xml" === y) try {
                        void 0 !== p.MSBlobBuilder ? ((g = new p.MSBlobBuilder).append(i), a = g.getBlob("image/svg+xml")) : a = h(i), d(a, x), s && s();
                    } catch (t) {
                        o(t);
                    }
                    else "application/pdf" === y ? p.jspdf && p.jspdf.jsPDF ? E() : (S = !0, n(C + "jspdf.js", function() {
                        n(C + "svg2pdf.js", E);
                    })) : (a = h(i), m = function() {
                        try {
                            e.domurl.revokeObjectURL(a);
                        } catch (t) {}
                    }, l(a, y, {}, w, function(t) {
                        try {
                            d(t, x), s && s();
                        } catch (t) {
                            o(t);
                        }
                    }, function() {
                        if (i.length > 1e8) throw Error("Input too long");
                        let t = u.createElement("canvas"), e = t.getContext("2d"), r = i.match(/^<svg[^>]*\s{,1000}width\s{,1000}=\s{,1000}\"?(\d+)\"?[^>]*>/), a = i.match(/^<svg[^>]*\s{0,1000}height\s{,1000}=\s{,1000}\"?(\d+)\"?[^>]*>/);
                        if (e && r && a) {
                            let l = +r[1] * w, h = +a[1] * w, c = ()=>{
                                p.canvg.Canvg.fromString(e, i).start();
                                try {
                                    d(p.navigator.msSaveOrOpenBlob ? t.msToBlob() : t.toDataURL(y), x), s && s();
                                } catch (t) {
                                    o(t);
                                } finally{
                                    m();
                                }
                            };
                            t.width = l, t.height = h, p.canvg ? c() : (S = !0, n(C + "canvg.js", c));
                        }
                    }, o, o, function() {
                        S && m();
                    }));
                }, e.getScript = n, e.imageToDataUrl = l, e.svgToDataUrl = h, e.svgToPdf = v;
            }(h || (h = {})), h;
        }), i(e, "masters/modules/offline-exporting.src.js", [
            e["Core/Globals.js"],
            e["Extensions/DownloadURL.js"],
            e["Extensions/OfflineExporting/OfflineExporting.js"]
        ], function(t, e, i) {
            return t.dataURLtoBlob = t.dataURLtoBlob || e.dataURLtoBlob, t.downloadSVGLocal = i.downloadSVGLocal, t.downloadURL = t.downloadURL || e.downloadURL, i.compose(t.Chart), t;
        });
    }, t.exports ? (e.default = e, t.exports = e) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}(Xr)), Xr.exports), Vr = b(qr), $r = {
    exports: {}
};
var Kr, Zr = (Gr || (Gr = 1, function(t) {
    var e;
    e = function(t) {
        var e = t ? t._modules : {};
        function i(e, i, n, r) {
            e.hasOwnProperty(i) || (e[i] = r.apply(null, n), "function" == typeof CustomEvent && t.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
                detail: {
                    path: i,
                    module: e[i]
                }
            })));
        }
        i(e, "Extensions/DownloadURL.js", [
            e["Core/Globals.js"]
        ], function(t) {
            let { isSafari: e, win: i, win: { document: n } } = t, r = i.URL || i.webkitURL || i;
            function o(t) {
                let e = t.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
                if (e && e.length > 3 && i.atob && i.ArrayBuffer && i.Uint8Array && i.Blob && r.createObjectURL) {
                    let t = i.atob(e[3]), n = new i.ArrayBuffer(t.length), o = new i.Uint8Array(n);
                    for(let e = 0; e < o.length; ++e)o[e] = t.charCodeAt(e);
                    return r.createObjectURL(new i.Blob([
                        o
                    ], {
                        type: e[1]
                    }));
                }
            }
            return {
                dataURLtoBlob: o,
                downloadURL: function(t, r) {
                    let s = i.navigator, a = n.createElement("a");
                    if ("string" != typeof t && !(t instanceof String) && s.msSaveOrOpenBlob) return void s.msSaveOrOpenBlob(t, r);
                    if (t = "" + t, s.userAgent.length > 1e3) throw Error("Input too long");
                    let l = /Edge\/\d+/.test(s.userAgent);
                    if ((e && "string" == typeof t && 0 === t.indexOf("data:application/pdf") || l || t.length > 2e6) && !(t = o(t) || "")) throw Error("Failed to convert to blob");
                    if (void 0 !== a.download) a.href = t, a.download = r, n.body.appendChild(a), a.click(), n.body.removeChild(a);
                    else try {
                        if (!i.open(t, "chart")) throw Error("Failed to open window");
                    } catch  {
                        i.location.href = t;
                    }
                }
            };
        }), i(e, "Extensions/ExportData/ExportDataDefaults.js", [], function() {
            return {
                exporting: {
                    csv: {
                        annotations: {
                            itemDelimiter: "; ",
                            join: !1
                        },
                        columnHeaderFormatter: null,
                        dateFormat: "%Y-%m-%d %H:%M:%S",
                        decimalPoint: null,
                        itemDelimiter: null,
                        lineDelimiter: "\n"
                    },
                    showTable: !1,
                    useMultiLevelHeaders: !0,
                    useRowspanHeaders: !0,
                    showExportInProgress: !0
                },
                lang: {
                    downloadCSV: "Download CSV",
                    downloadXLS: "Download XLS",
                    exportData: {
                        annotationHeader: "Annotations",
                        categoryHeader: "Category",
                        categoryDatetimeHeader: "DateTime"
                    },
                    viewData: "View data table",
                    hideData: "Hide data table",
                    exportInProgress: "Exporting..."
                }
            };
        }), i(e, "Extensions/ExportData/ExportData.js", [
            e["Core/Renderer/HTML/AST.js"],
            e["Core/Defaults.js"],
            e["Extensions/DownloadURL.js"],
            e["Extensions/ExportData/ExportDataDefaults.js"],
            e["Core/Globals.js"],
            e["Core/Utilities.js"]
        ], function(t, e, i, n, r, o) {
            let { getOptions: s, setOptions: a } = e, { downloadURL: l } = i, { doc: h, win: c } = r, { addEvent: d, defined: u, extend: p, find: f, fireEvent: g, isNumber: m, pick: b } = o;
            function y(t) {
                let e = !!this.options.exporting?.showExportInProgress, i = c.requestAnimationFrame || setTimeout;
                i(()=>{
                    e && this.showLoading(this.options.lang.exportInProgress), i(()=>{
                        try {
                            t.call(this);
                        } finally{
                            e && this.hideLoading();
                        }
                    });
                });
            }
            function x() {
                y.call(this, ()=>{
                    let t = this.getCSV(!0);
                    l(T(t, "text/csv") || "data:text/csv,\ufeff" + encodeURIComponent(t), this.getFilename() + ".csv");
                });
            }
            function v() {
                y.call(this, ()=>{
                    let t = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head>\x3c!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--\x3e<style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
                    l(T(t, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + c.btoa(unescape(encodeURIComponent(t))), this.getFilename() + ".xls");
                });
            }
            function w(t) {
                let e = "", i = this.getDataRows(), n = this.options.exporting.csv, r = b(n.decimalPoint, "," !== n.itemDelimiter && t ? 1.1.toLocaleString()[1] : "."), o = b(n.itemDelimiter, "," === r ? ";" : ","), s = n.lineDelimiter;
                return i.forEach((t, n)=>{
                    let a = "", l = t.length;
                    for(; l--;)"string" == typeof (a = t[l]) && (a = `"${a}"`), "number" == typeof a && "." !== r && (a = a.toString().replace(".", r)), t[l] = a;
                    t.length = i.length ? i[0].length : 0, e += t.join(o), n < i.length - 1 && (e += s);
                }), e;
            }
            function C(t) {
                let e, i, n, r, o, s, a, l = this.hasParallelCoordinates, h = this.time, c = this.options.exporting && this.options.exporting.csv || {}, d = this.xAxis, p = {}, y = [], x = [], v = [], w = this.options.lang.exportData, C = w.categoryHeader, S = w.categoryDatetimeHeader, k = function(e, i, n) {
                    if (c.columnHeaderFormatter) {
                        let t = c.columnHeaderFormatter(e, i, n);
                        if (!1 !== t) return t;
                    }
                    return e ? e.bindAxes ? t ? {
                        columnTitle: n > 1 ? i : e.name,
                        topLevelColumnTitle: e.name
                    } : e.name + (n > 1 ? " (" + i + ")" : "") : e.options.title && e.options.title.text || (e.dateTime ? S : C) : C;
                }, A = function(t, e, i) {
                    let n = {}, r = {};
                    return e.forEach(function(e) {
                        let o = (t.keyToAxis && t.keyToAxis[e] || e) + "Axis", s = m(i) ? t.chart[o][i] : t[o];
                        n[e] = s && s.categories || [], r[e] = s && s.dateTime;
                    }), {
                        categoryMap: n,
                        dateTimeValueAxisMap: r
                    };
                }, E = [], M = 0;
                for(s in this.series.forEach(function(e) {
                    let i, n, r = e.options.keys, s = e.xAxis, a = r || function(t, e) {
                        let i = t.pointArrayMap || [
                            "y"
                        ];
                        return t.data.some((t)=>void 0 !== t.y && t.name) && e && !e.categories && "name" !== t.exportKey ? [
                            "x",
                            ...i
                        ] : i;
                    }(e, s), u = a.length, g = !e.requireSorting && {}, m = d.indexOf(s), y = A(e, a);
                    if (!1 !== e.options.includeInDataExport && !e.options.isInternal && !1 !== e.visible) {
                        for(f(E, function(t) {
                            return t[0] === m;
                        }) || E.push([
                            m,
                            M
                        ]), n = 0; n < u;)o = k(e, a[n], a.length), v.push(o.columnTitle || o), t && x.push(o.topLevelColumnTitle || o), n++;
                        i = {
                            chart: e.chart,
                            autoIncrement: e.autoIncrement,
                            options: e.options,
                            pointArrayMap: e.pointArrayMap,
                            index: e.index
                        }, e.options.data.forEach(function(t, r) {
                            let o, d, f, x = {
                                series: i
                            };
                            l && (y = A(e, a, r)), e.pointClass.prototype.applyOptions.apply(x, [
                                t
                            ]);
                            let v = e.data[r] && e.data[r].name;
                            if (o = (x.x ?? "") + "," + v, n = 0, (!s || "name" === e.exportKey || !l && s && s.hasNames && v) && (o = v), g && (g[o] && (o += "|" + r), g[o] = !0), p[o]) {
                                let t = `${o},${p[o].pointers[e.index]}`, i = o;
                                p[o].pointers[e.index] && (p[t] || (p[t] = [], p[t].xValues = [], p[t].pointers = []), o = t), p[i].pointers[e.index] += 1;
                            } else {
                                p[o] = [], p[o].xValues = [];
                                let t = [];
                                for(let i = 0; i < e.chart.series.length; i++)t[i] = 0;
                                p[o].pointers = t, p[o].pointers[e.index] = 1;
                            }
                            for(p[o].x = x.x, p[o].name = v, p[o].xValues[m] = x.x; n < u;)f = x[d = a[n]], p[o][M + n] = b(y.categoryMap[d][f], y.dateTimeValueAxisMap[d] ? h.dateFormat(c.dateFormat, f) : null, f), n++;
                        }), M += n;
                    }
                }), p)Object.hasOwnProperty.call(p, s) && y.push(p[s]);
                for(r = t ? [
                    x,
                    v
                ] : [
                    v
                ], M = E.length; M--;)e = E[M][0], i = E[M][1], n = d[e], y.sort(function(t, i) {
                    return t.xValues[e] - i.xValues[e];
                }), a = k(n), r[0].splice(i, 0, a), t && r[1] && r[1].splice(i, 0, a), y.forEach(function(t) {
                    let e = t.name;
                    n && !u(e) && (n.dateTime ? (t.x instanceof Date && (t.x = t.x.getTime()), e = h.dateFormat(c.dateFormat, t.x)) : e = n.categories ? b(n.names[t.x], n.categories[t.x], t.x) : t.x), t.splice(i, 0, e);
                });
                return g(this, "exportData", {
                    dataRows: r = r.concat(y)
                }), r;
            }
            function S(t) {
                let e = (t)=>{
                    if (!t.tagName || "#text" === t.tagName) return t.textContent || "";
                    let i = t.attributes, n = `<${t.tagName}`;
                    return i && Object.keys(i).forEach((t)=>{
                        let e = i[t];
                        n += ` ${t}="${e}"`;
                    }), n += ">" + (t.textContent || ""), (t.children || []).forEach((t)=>{
                        n += e(t);
                    }), n += `</${t.tagName}>`;
                };
                return e(this.getTableAST(t));
            }
            function k(t) {
                let e = 0, i = [], n = this.options, r = t ? 1.1.toLocaleString()[1] : ".", o = b(n.exporting.useMultiLevelHeaders, !0), s = this.getDataRows(o), a = o ? s.shift() : null, l = s.shift(), h = function(t, e, i, n) {
                    let o = b(n, ""), s = "highcharts-text" + (e ? " " + e : "");
                    return "number" == typeof o ? (o = o.toString(), "," === r && (o = o.replace(".", r)), s = "highcharts-number") : n || (s = "highcharts-empty"), {
                        tagName: t,
                        attributes: i = p({
                            class: s
                        }, i),
                        textContent: o
                    };
                };
                !1 !== n.exporting.tableCaption && i.push({
                    tagName: "caption",
                    attributes: {
                        class: "highcharts-table-caption"
                    },
                    textContent: b(n.exporting.tableCaption, n.title.text ? n.title.text : "Chart")
                });
                for(let t = 0, i = s.length; t < i; ++t)s[t].length > e && (e = s[t].length);
                i.push(function(t, e, i) {
                    let r, s, a = [], l = 0, c = i || e && e.length, d = 0;
                    if (o && t && e && !function(t, e) {
                        let i = t.length;
                        if (e.length !== i) return !1;
                        for(; i--;)if (t[i] !== e[i]) return !1;
                        return !0;
                    }(t, e)) {
                        let i = [];
                        for(; l < c; ++l)if ((r = t[l]) === t[l + 1]) ++d;
                        else if (d) i.push(h("th", "highcharts-table-topheading", {
                            scope: "col",
                            colspan: d + 1
                        }, r)), d = 0;
                        else {
                            r === e[l] ? n.exporting.useRowspanHeaders ? (s = 2, delete e[l]) : (s = 1, e[l] = "") : s = 1;
                            let t = h("th", "highcharts-table-topheading", {
                                scope: "col"
                            }, r);
                            s > 1 && t.attributes && (t.attributes.valign = "top", t.attributes.rowspan = s), i.push(t);
                        }
                        a.push({
                            tagName: "tr",
                            children: i
                        });
                    }
                    if (e) {
                        let t = [];
                        for(l = 0, c = e.length; l < c; ++l)void 0 !== e[l] && t.push(h("th", null, {
                            scope: "col"
                        }, e[l]));
                        a.push({
                            tagName: "tr",
                            children: t
                        });
                    }
                    return {
                        tagName: "thead",
                        children: a
                    };
                }(a, l, Math.max(e, l.length)));
                let c = [];
                s.forEach(function(t) {
                    let i = [];
                    for(let n = 0; n < e; n++)i.push(h(n ? "td" : "th", null, n ? {} : {
                        scope: "row"
                    }, t[n]));
                    c.push({
                        tagName: "tr",
                        children: i
                    });
                }), i.push({
                    tagName: "tbody",
                    children: c
                });
                let d = {
                    tree: {
                        tagName: "table",
                        id: `highcharts-data-table-${this.index}`,
                        children: i
                    }
                };
                return g(this, "aftergetTableAST", d), d.tree;
            }
            function A() {
                this.toggleDataTable(!1);
            }
            function E(e) {
                let i = (e = b(e, !this.isDataTableVisible)) && !this.dataTableDiv;
                if (i && (this.dataTableDiv = h.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
                    let n = this.dataTableDiv.style, r = n.display;
                    n.display = e ? "block" : "none", e ? (this.dataTableDiv.innerHTML = t.emptyHTML, new t([
                        this.getTableAST()
                    ]).addToDOM(this.dataTableDiv), g(this, "afterViewData", {
                        element: this.dataTableDiv,
                        wasHidden: i || r !== n.display
                    })) : g(this, "afterHideData");
                }
                this.isDataTableVisible = e;
                let n = this.exportDivElements, r = this.options.exporting, o = r && r.buttons && r.buttons.contextButton.menuItems, s = this.options.lang;
                if (r && r.menuItemDefinitions && s && s.viewData && s.hideData && o && n) {
                    let e = n[o.indexOf("viewData")];
                    e && t.setElementHTML(e, this.isDataTableVisible ? s.hideData : s.viewData);
                }
            }
            function M() {
                this.toggleDataTable(!0);
            }
            function T(t, e) {
                let i = c.navigator, n = c.URL || c.webkitURL || c;
                try {
                    if (i.msSaveOrOpenBlob && c.MSBlobBuilder) {
                        let e = new c.MSBlobBuilder;
                        return e.append(t), e.getBlob("image/svg+xml");
                    }
                    return n.createObjectURL(new c.Blob([
                        "\ufeff" + t
                    ], {
                        type: e
                    }));
                } catch (t) {}
            }
            function P() {
                let t = this, e = t.dataTableDiv, i = (t, e)=>t.children[e].textContent, n = (t, e)=>(n, r)=>{
                        let o, s;
                        return o = i(e ? n : r, t), s = i(e ? r : n, t), "" === o || "" === s || isNaN(o) || isNaN(s) ? o.toString().localeCompare(s) : o - s;
                    };
                if (e && t.options.exporting && t.options.exporting.allowTableSorting) {
                    let i = e.querySelector("thead tr");
                    i && i.childNodes.forEach((i)=>{
                        let r = i.closest("table");
                        i.addEventListener("click", function() {
                            let o = [
                                ...e.querySelectorAll("tr:not(thead tr)")
                            ], s = [
                                ...i.parentNode.children
                            ];
                            o.sort(n(s.indexOf(i), t.ascendingOrderInTable = !t.ascendingOrderInTable)).forEach((t)=>{
                                r.appendChild(t);
                            }), s.forEach((t)=>{
                                [
                                    "highcharts-sort-ascending",
                                    "highcharts-sort-descending"
                                ].forEach((e)=>{
                                    t.classList.contains(e) && t.classList.remove(e);
                                });
                            }), i.classList.add(t.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
                        });
                    });
                }
            }
            function R() {
                this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
            }
            function L() {
                this.dataTableDiv?.remove();
            }
            return {
                compose: function(t, e) {
                    let i = t.prototype;
                    if (!i.getCSV) {
                        let r = s().exporting;
                        d(t, "afterViewData", P), d(t, "render", R), d(t, "destroy", L), i.downloadCSV = x, i.downloadXLS = v, i.getCSV = w, i.getDataRows = C, i.getTable = S, i.getTableAST = k, i.hideData = A, i.toggleDataTable = E, i.viewData = M, r && (p(r.menuItemDefinitions, {
                            downloadCSV: {
                                textKey: "downloadCSV",
                                onclick: function() {
                                    this.downloadCSV();
                                }
                            },
                            downloadXLS: {
                                textKey: "downloadXLS",
                                onclick: function() {
                                    this.downloadXLS();
                                }
                            },
                            viewData: {
                                textKey: "viewData",
                                onclick: function() {
                                    y.call(this, this.toggleDataTable);
                                }
                            }
                        }), r.buttons && r.buttons.contextButton.menuItems && r.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), a(n);
                        let { arearange: o, gantt: l, map: h, mapbubble: c, treemap: u, xrange: f } = e.types;
                        o && (o.prototype.keyToAxis = {
                            low: "y",
                            high: "y"
                        }), l && (l.prototype.exportKey = "name", l.prototype.keyToAxis = {
                            start: "x",
                            end: "x"
                        }), h && (h.prototype.exportKey = "name"), c && (c.prototype.exportKey = "name"), u && (u.prototype.exportKey = "name"), f && (f.prototype.keyToAxis = {
                            x2: "x"
                        });
                    }
                }
            };
        }), i(e, "masters/modules/export-data.src.js", [
            e["Core/Globals.js"],
            e["Extensions/DownloadURL.js"],
            e["Extensions/ExportData/ExportData.js"]
        ], function(t, e, i) {
            return t.dataURLtoBlob = t.dataURLtoBlob || e.dataURLtoBlob, t.downloadURL = t.downloadURL || e.downloadURL, i.compose(t.Chart, t.Series), t;
        });
    }, t.exports ? (e.default = e, t.exports = e) : e("undefined" != typeof Highcharts ? Highcharts : void 0);
}($r)), $r.exports), Qr = b(Zr), Jr = {
    exports: {}
};
var to, eo = (Kr || (Kr = 1, "undefined" != typeof self && self, Jr.exports = (to = L, function(t) {
    function e(n) {
        if (i[n]) return i[n].exports;
        var r = i[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return t[n].call(r.exports, r, r.exports, e), r.l = !0, r.exports;
    }
    var i = {};
    return e.m = t, e.c = i, e.d = function(t, i, n) {
        e.o(t, i) || Object.defineProperty(t, i, {
            configurable: !1,
            enumerable: !0,
            get: n
        });
    }, e.n = function(t) {
        var i = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return e.d(i, "a", i), i;
    }, e.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 0);
}([
    function(t, e, i) {
        function n() {
            return n = Object.assign ? Object.assign.bind() : function(t) {
                for(var e = 1; e < arguments.length; e++){
                    var i = arguments[e];
                    for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
                }
                return t;
            }, n.apply(this, arguments);
        }
        function r(t) {
            return l(t) || a(t) || s(t) || o();
        }
        function o() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function s(t, e) {
            if (t) {
                if ("string" == typeof t) return h(t, e);
                var i = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? h(t, e) : void 0;
            }
        }
        function a(t) {
            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }
        function l(t) {
            if (Array.isArray(t)) return h(t);
        }
        function h(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for(var i = 0, n = new Array(e); i < e; i++)n[i] = t[i];
            return n;
        }
        function c(t) {
            return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        Object.defineProperty(e, "__esModule", {
            value: !0
        }), i.d(e, "HighchartsReact", function() {
            return f;
        });
        var d = i(1), u = i.n(d), p = "undefined" != typeof window ? d.useLayoutEffect : d.useEffect, f = Object(d.memo)(Object(d.forwardRef)(function(t, e) {
            var i = Object(d.useRef)(), o = Object(d.useRef)(), s = Object(d.useRef)(t.constructorType), a = Object(d.useRef)(t.highcharts);
            return p(function() {
                function e() {
                    var e = t.highcharts || "object" === ("undefined" == typeof window ? "undefined" : c(window)) && window.Highcharts, n = t.constructorType || "chart";
                    e ? e[n] ? t.options ? o.current = e[n](i.current, t.options, t.callback) : console.warn('The "options" property was not passed.') : console.warn('The "constructorType" property is incorrect or some required module is not imported.') : console.warn('The "highcharts" property was not passed.');
                }
                if (o.current) {
                    if (!1 !== t.allowChartUpdate) {
                        if (t.constructorType !== s.current || t.highcharts !== a.current) s.current = t.constructorType, a.current = t.highcharts, e();
                        else if (!t.immutable && o.current) {
                            var n;
                            (n = o.current).update.apply(n, [
                                t.options
                            ].concat(r(t.updateArgs || [
                                !0,
                                !0
                            ])));
                        } else e();
                    }
                } else e();
            }, [
                t.options,
                t.allowChartUpdate,
                t.updateArgs,
                t.containerProps,
                t.highcharts,
                t.constructorType
            ]), p(function() {
                return function() {
                    o.current && (o.current.destroy(), o.current = null);
                };
            }, []), Object(d.useImperativeHandle)(e, function() {
                return {
                    get chart () {
                        return o.current;
                    },
                    container: i
                };
            }, []), u.a.createElement("div", n({}, t.containerProps, {
                ref: i
            }));
        }));
        e.default = f;
    },
    function(t, e) {
        t.exports = to;
    }
]))), Jr.exports), io = b(eo);
function no(t, e) {
    (function(t) {
        return "string" == typeof t && -1 !== t.indexOf(".") && 1 === parseFloat(t);
    })(t) && (t = "100%");
    const i = function(t) {
        return "string" == typeof t && -1 !== t.indexOf("%");
    }(t);
    return t = 360 === e ? t : Math.min(e, Math.max(0, parseFloat(t))), i && (t = parseInt(String(t * e), 10) / 100), Math.abs(t - e) < 1e-6 ? 1 : t = 360 === e ? (t < 0 ? t % e + e : t % e) / parseFloat(String(e)) : t % e / parseFloat(String(e));
}
function ro(t) {
    return Math.min(1, Math.max(0, t));
}
function oo(t) {
    return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
}
function so(t) {
    return Number(t) <= 1 ? 100 * Number(t) + "%" : t;
}
function ao(t) {
    return 1 === t.length ? "0" + t : String(t);
}
function lo(t, e, i) {
    t = no(t, 255), e = no(e, 255), i = no(i, 255);
    const n = Math.max(t, e, i), r = Math.min(t, e, i);
    let o = 0, s = 0;
    const a = (n + r) / 2;
    if (n === r) s = 0, o = 0;
    else {
        const l = n - r;
        switch(s = a > .5 ? l / (2 - n - r) : l / (n + r), n){
            case t:
                o = (e - i) / l + (e < i ? 6 : 0);
                break;
            case e:
                o = (i - t) / l + 2;
                break;
            case i:
                o = (t - e) / l + 4;
        }
        o /= 6;
    }
    return {
        h: o,
        s: s,
        l: a
    };
}
function ho(t, e, i) {
    return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t + 6 * i * (e - t) : i < .5 ? e : i < 2 / 3 ? t + (e - t) * (2 / 3 - i) * 6 : t;
}
function co(t, e, i) {
    t = no(t, 255), e = no(e, 255), i = no(i, 255);
    const n = Math.max(t, e, i), r = Math.min(t, e, i);
    let o = 0;
    const s = n, a = n - r, l = 0 === n ? 0 : a / n;
    if (n === r) o = 0;
    else {
        switch(n){
            case t:
                o = (e - i) / a + (e < i ? 6 : 0);
                break;
            case e:
                o = (i - t) / a + 2;
                break;
            case i:
                o = (t - e) / a + 4;
        }
        o /= 6;
    }
    return {
        h: o,
        s: l,
        v: s
    };
}
function uo(t, e, i, n) {
    const r = [
        ao(Math.round(t).toString(16)),
        ao(Math.round(e).toString(16)),
        ao(Math.round(i).toString(16))
    ];
    return n && r[0].startsWith(r[0].charAt(1)) && r[1].startsWith(r[1].charAt(1)) && r[2].startsWith(r[2].charAt(1)) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) : r.join("");
}
function po(t, e, i) {
    let n = 1 - t / 255, r = 1 - e / 255, o = 1 - i / 255, s = Math.min(n, r, o);
    return 1 === s ? (n = 0, r = 0, o = 0) : (n = (n - s) / (1 - s) * 100, r = (r - s) / (1 - s) * 100, o = (o - s) / (1 - s) * 100), s *= 100, {
        c: Math.round(n),
        m: Math.round(r),
        y: Math.round(o),
        k: Math.round(s)
    };
}
function fo(t) {
    return go(t) / 255;
}
function go(t) {
    return parseInt(t, 16);
}
const mo = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};
function bo(t) {
    let e = {
        r: 0,
        g: 0,
        b: 0
    }, i = 1, n = null, r = null, o = null, s = !1, a = !1;
    return "string" == typeof t && (t = function(t) {
        if (t = t.trim().toLowerCase(), 0 === t.length) return !1;
        let e = !1;
        if (mo[t]) t = mo[t], e = !0;
        else if ("transparent" === t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        let i = wo.rgb.exec(t);
        if (i) return {
            r: i[1],
            g: i[2],
            b: i[3]
        };
        if (i = wo.rgba.exec(t), i) return {
            r: i[1],
            g: i[2],
            b: i[3],
            a: i[4]
        };
        if (i = wo.hsl.exec(t), i) return {
            h: i[1],
            s: i[2],
            l: i[3]
        };
        if (i = wo.hsla.exec(t), i) return {
            h: i[1],
            s: i[2],
            l: i[3],
            a: i[4]
        };
        if (i = wo.hsv.exec(t), i) return {
            h: i[1],
            s: i[2],
            v: i[3]
        };
        if (i = wo.hsva.exec(t), i) return {
            h: i[1],
            s: i[2],
            v: i[3],
            a: i[4]
        };
        if (i = wo.cmyk.exec(t), i) return {
            c: i[1],
            m: i[2],
            y: i[3],
            k: i[4]
        };
        if (i = wo.hex8.exec(t), i) return {
            r: go(i[1]),
            g: go(i[2]),
            b: go(i[3]),
            a: fo(i[4]),
            format: e ? "name" : "hex8"
        };
        if (i = wo.hex6.exec(t), i) return {
            r: go(i[1]),
            g: go(i[2]),
            b: go(i[3]),
            format: e ? "name" : "hex"
        };
        if (i = wo.hex4.exec(t), i) return {
            r: go(i[1] + i[1]),
            g: go(i[2] + i[2]),
            b: go(i[3] + i[3]),
            a: fo(i[4] + i[4]),
            format: e ? "name" : "hex8"
        };
        if (i = wo.hex3.exec(t), i) return {
            r: go(i[1] + i[1]),
            g: go(i[2] + i[2]),
            b: go(i[3] + i[3]),
            format: e ? "name" : "hex"
        };
        return !1;
    }(t)), "object" == typeof t && (Co(t.r) && Co(t.g) && Co(t.b) ? (e = function(t, e, i) {
        return {
            r: 255 * no(t, 255),
            g: 255 * no(e, 255),
            b: 255 * no(i, 255)
        };
    }(t.r, t.g, t.b), s = !0, a = "%" === String(t.r).substr(-1) ? "prgb" : "rgb") : Co(t.h) && Co(t.s) && Co(t.v) ? (n = so(t.s), r = so(t.v), e = function(t, e, i) {
        t = 6 * no(t, 360), e = no(e, 100), i = no(i, 100);
        const n = Math.floor(t), r = t - n, o = i * (1 - e), s = i * (1 - r * e), a = i * (1 - (1 - r) * e), l = n % 6;
        return {
            r: 255 * [
                i,
                s,
                o,
                o,
                a,
                i
            ][l],
            g: 255 * [
                a,
                i,
                i,
                s,
                o,
                o
            ][l],
            b: 255 * [
                o,
                o,
                a,
                i,
                i,
                s
            ][l]
        };
    }(t.h, n, r), s = !0, a = "hsv") : Co(t.h) && Co(t.s) && Co(t.l) ? (n = so(t.s), o = so(t.l), e = function(t, e, i) {
        let n, r, o;
        if (t = no(t, 360), e = no(e, 100), i = no(i, 100), 0 === e) r = i, o = i, n = i;
        else {
            const s = i < .5 ? i * (1 + e) : i + e - i * e, a = 2 * i - s;
            n = ho(a, s, t + 1 / 3), r = ho(a, s, t), o = ho(a, s, t - 1 / 3);
        }
        return {
            r: 255 * n,
            g: 255 * r,
            b: 255 * o
        };
    }(t.h, n, o), s = !0, a = "hsl") : Co(t.c) && Co(t.m) && Co(t.y) && Co(t.k) && (e = function(t, e, i, n) {
        const r = n / 100;
        return {
            r: 255 * (1 - t / 100) * (1 - r),
            g: 255 * (1 - e / 100) * (1 - r),
            b: 255 * (1 - i / 100) * (1 - r)
        };
    }(t.c, t.m, t.y, t.k), s = !0, a = "cmyk"), Object.prototype.hasOwnProperty.call(t, "a") && (i = t.a)), i = oo(i), {
        ok: s,
        format: t.format || a,
        r: Math.min(255, Math.max(e.r, 0)),
        g: Math.min(255, Math.max(e.g, 0)),
        b: Math.min(255, Math.max(e.b, 0)),
        a: i
    };
}
const yo = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)", xo = "[\\s|\\(]+(" + yo + ")[,|\\s]+(" + yo + ")[,|\\s]+(" + yo + ")\\s*\\)?", vo = "[\\s|\\(]+(" + yo + ")[,|\\s]+(" + yo + ")[,|\\s]+(" + yo + ")[,|\\s]+(" + yo + ")\\s*\\)?", wo = {
    CSS_UNIT: new RegExp(yo),
    rgb: new RegExp("rgb" + xo),
    rgba: new RegExp("rgba" + vo),
    hsl: new RegExp("hsl" + xo),
    hsla: new RegExp("hsla" + vo),
    hsv: new RegExp("hsv" + xo),
    hsva: new RegExp("hsva" + vo),
    cmyk: new RegExp("cmyk" + vo),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Co(t) {
    return "number" == typeof t ? !Number.isNaN(t) : wo.CSS_UNIT.test(t);
}
class So {
    constructor(t = "", e = {}){
        if (t instanceof So) return t;
        "number" == typeof t && (t = function(t) {
            return {
                r: t >> 16,
                g: (65280 & t) >> 8,
                b: 255 & t
            };
        }(t)), this.originalInput = t;
        const i = bo(t);
        this.originalInput = t, this.r = i.r, this.g = i.g, this.b = i.b, this.a = i.a, this.roundA = Math.round(100 * this.a) / 100, this.format = e.format ?? i.format, this.gradientType = e.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = i.ok;
    }
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return !this.isDark();
    }
    getBrightness() {
        const t = this.toRgb();
        return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3;
    }
    getLuminance() {
        const t = this.toRgb();
        let e, i, n;
        const r = t.r / 255, o = t.g / 255, s = t.b / 255;
        return e = r <= .03928 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4), i = o <= .03928 ? o / 12.92 : Math.pow((o + .055) / 1.055, 2.4), n = s <= .03928 ? s / 12.92 : Math.pow((s + .055) / 1.055, 2.4), .2126 * e + .7152 * i + .0722 * n;
    }
    getAlpha() {
        return this.a;
    }
    setAlpha(t) {
        return this.a = oo(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }
    isMonochrome() {
        const { s: t } = this.toHsl();
        return 0 === t;
    }
    toHsv() {
        const t = co(this.r, this.g, this.b);
        return {
            h: 360 * t.h,
            s: t.s,
            v: t.v,
            a: this.a
        };
    }
    toHsvString() {
        const t = co(this.r, this.g, this.b), e = Math.round(360 * t.h), i = Math.round(100 * t.s), n = Math.round(100 * t.v);
        return 1 === this.a ? `hsv(${e}, ${i}%, ${n}%)` : `hsva(${e}, ${i}%, ${n}%, ${this.roundA})`;
    }
    toHsl() {
        const t = lo(this.r, this.g, this.b);
        return {
            h: 360 * t.h,
            s: t.s,
            l: t.l,
            a: this.a
        };
    }
    toHslString() {
        const t = lo(this.r, this.g, this.b), e = Math.round(360 * t.h), i = Math.round(100 * t.s), n = Math.round(100 * t.l);
        return 1 === this.a ? `hsl(${e}, ${i}%, ${n}%)` : `hsla(${e}, ${i}%, ${n}%, ${this.roundA})`;
    }
    toHex(t = !1) {
        return uo(this.r, this.g, this.b, t);
    }
    toHexString(t = !1) {
        return "#" + this.toHex(t);
    }
    toHex8(t = !1) {
        return function(t, e, i, n, r) {
            const o = [
                ao(Math.round(t).toString(16)),
                ao(Math.round(e).toString(16)),
                ao(Math.round(i).toString(16)),
                ao((s = n, Math.round(255 * parseFloat(s)).toString(16)))
            ];
            var s;
            return r && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) && o[3].startsWith(o[3].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
        }(this.r, this.g, this.b, this.a, t);
    }
    toHex8String(t = !1) {
        return "#" + this.toHex8(t);
    }
    toHexShortString(t = !1) {
        return 1 === this.a ? this.toHexString(t) : this.toHex8String(t);
    }
    toRgb() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    }
    toRgbString() {
        const t = Math.round(this.r), e = Math.round(this.g), i = Math.round(this.b);
        return 1 === this.a ? `rgb(${t}, ${e}, ${i})` : `rgba(${t}, ${e}, ${i}, ${this.roundA})`;
    }
    toPercentageRgb() {
        const t = (t)=>`${Math.round(100 * no(t, 255))}%`;
        return {
            r: t(this.r),
            g: t(this.g),
            b: t(this.b),
            a: this.a
        };
    }
    toPercentageRgbString() {
        const t = (t)=>Math.round(100 * no(t, 255));
        return 1 === this.a ? `rgb(${t(this.r)}%, ${t(this.g)}%, ${t(this.b)}%)` : `rgba(${t(this.r)}%, ${t(this.g)}%, ${t(this.b)}%, ${this.roundA})`;
    }
    toCmyk() {
        return {
            ...po(this.r, this.g, this.b)
        };
    }
    toCmykString() {
        const { c: t, m: e, y: i, k: n } = po(this.r, this.g, this.b);
        return `cmyk(${t}, ${e}, ${i}, ${n})`;
    }
    toName() {
        if (0 === this.a) return "transparent";
        if (this.a < 1) return !1;
        const t = "#" + uo(this.r, this.g, this.b, !1);
        for (const [e, i] of Object.entries(mo))if (t === i) return e;
        return !1;
    }
    toString(t) {
        const e = Boolean(t);
        t = t ?? this.format;
        let i = !1;
        const n = this.a < 1 && this.a >= 0;
        return e || !n || !t.startsWith("hex") && "name" !== t ? ("rgb" === t && (i = this.toRgbString()), "prgb" === t && (i = this.toPercentageRgbString()), "hex" !== t && "hex6" !== t || (i = this.toHexString()), "hex3" === t && (i = this.toHexString(!0)), "hex4" === t && (i = this.toHex8String(!0)), "hex8" === t && (i = this.toHex8String()), "name" === t && (i = this.toName()), "hsl" === t && (i = this.toHslString()), "hsv" === t && (i = this.toHsvString()), "cmyk" === t && (i = this.toCmykString()), i || this.toHexString()) : "name" === t && 0 === this.a ? this.toName() : this.toRgbString();
    }
    toNumber() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }
    clone() {
        return new So(this.toString());
    }
    lighten(t = 10) {
        const e = this.toHsl();
        return e.l += t / 100, e.l = ro(e.l), new So(e);
    }
    brighten(t = 10) {
        const e = this.toRgb();
        return e.r = Math.max(0, Math.min(255, e.r - Math.round(-t / 100 * 255))), e.g = Math.max(0, Math.min(255, e.g - Math.round(-t / 100 * 255))), e.b = Math.max(0, Math.min(255, e.b - Math.round(-t / 100 * 255))), new So(e);
    }
    darken(t = 10) {
        const e = this.toHsl();
        return e.l -= t / 100, e.l = ro(e.l), new So(e);
    }
    tint(t = 10) {
        return this.mix("white", t);
    }
    shade(t = 10) {
        return this.mix("black", t);
    }
    desaturate(t = 10) {
        const e = this.toHsl();
        return e.s -= t / 100, e.s = ro(e.s), new So(e);
    }
    saturate(t = 10) {
        const e = this.toHsl();
        return e.s += t / 100, e.s = ro(e.s), new So(e);
    }
    greyscale() {
        return this.desaturate(100);
    }
    spin(t) {
        const e = this.toHsl(), i = (e.h + t) % 360;
        return e.h = i < 0 ? 360 + i : i, new So(e);
    }
    mix(t, e = 50) {
        const i = this.toRgb(), n = new So(t).toRgb(), r = e / 100, o = {
            r: (n.r - i.r) * r + i.r,
            g: (n.g - i.g) * r + i.g,
            b: (n.b - i.b) * r + i.b,
            a: (n.a - i.a) * r + i.a
        };
        return new So(o);
    }
    analogous(t = 6, e = 30) {
        const i = this.toHsl(), n = 360 / e, r = [
            this
        ];
        for(i.h = (i.h - (n * t >> 1) + 720) % 360; --t;)i.h = (i.h + n) % 360, r.push(new So(i));
        return r;
    }
    complement() {
        const t = this.toHsl();
        return t.h = (t.h + 180) % 360, new So(t);
    }
    monochromatic(t = 6) {
        const e = this.toHsv(), { h: i } = e, { s: n } = e;
        let { v: r } = e;
        const o = [], s = 1 / t;
        for(; t--;)o.push(new So({
            h: i,
            s: n,
            v: r
        })), r = (r + s) % 1;
        return o;
    }
    splitcomplement() {
        const t = this.toHsl(), { h: e } = t;
        return [
            this,
            new So({
                h: (e + 72) % 360,
                s: t.s,
                l: t.l
            }),
            new So({
                h: (e + 216) % 360,
                s: t.s,
                l: t.l
            })
        ];
    }
    onBackground(t) {
        const e = this.toRgb(), i = new So(t).toRgb(), n = e.a + i.a * (1 - e.a);
        return new So({
            r: (e.r * e.a + i.r * i.a * (1 - e.a)) / n,
            g: (e.g * e.a + i.g * i.a * (1 - e.a)) / n,
            b: (e.b * e.a + i.b * i.a * (1 - e.a)) / n,
            a: n
        });
    }
    triad() {
        return this.polyad(3);
    }
    tetrad() {
        return this.polyad(4);
    }
    polyad(t) {
        const e = this.toHsl(), { h: i } = e, n = [
            this
        ], r = 360 / t;
        for(let o = 1; o < t; o++)n.push(new So({
            h: (i + o * r) % 360,
            s: e.s,
            l: e.l
        }));
        return n;
    }
    equals(t) {
        const e = new So(t);
        return "cmyk" === this.format || "cmyk" === e.format ? this.toCmykString() === e.toCmykString() : this.toRgbString() === e.toRgbString();
    }
}
function ko(t, e, i = {
    level: "AA",
    size: "small"
}) {
    const n = function(t, e) {
        const i = new So(t), n = new So(e);
        return (Math.max(i.getLuminance(), n.getLuminance()) + .05) / (Math.min(i.getLuminance(), n.getLuminance()) + .05);
    }(t, e);
    switch((i.level ?? "AA") + (i.size ?? "small")){
        case "AAsmall":
        case "AAAlarge":
            return n >= 4.5;
        case "AAlarge":
            return n >= 3;
        case "AAAsmall":
            return n >= 7;
        default:
            return !1;
    }
}
const Ao = ni(ae, Si), Eo = Y(Rt), Mo = Y(Gt), To = Y(ui), Po = oe((t, e)=>yi(t, e) ? Nn([
        t
    ], e) : ie(t, e)), Ro = [
    "var1",
    "var2",
    "var3",
    "var4",
    "var5",
    "var6",
    "var7",
    "var8",
    "var9",
    "var10"
], Lo = "latest_min", Oo = "latest_max", Do = (t)=>Le(ni(pt(On(t.code)), pt(On(t.label))), On), jo = 6048e5, No = 864e5, Io = Symbol.for("constructDateFrom");
function Bo(t, e) {
    return "function" == typeof t ? t(e) : t && "object" == typeof t && Io in t ? t[Io](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Fo(t, e) {
    return Bo(e || t, t);
}
function zo(t, e, i) {
    const n = Fo(t, i?.in);
    return isNaN(e) ? Bo(i?.in || t, NaN) : e ? (n.setDate(n.getDate() + e), n) : n;
}
function Ho(t, e, i) {
    const n = Fo(t, i?.in);
    if (isNaN(e)) return Bo(i?.in || t, NaN);
    if (!e) return n;
    const r = n.getDate(), o = Bo(i?.in || t, n.getTime());
    o.setMonth(n.getMonth() + e + 1, 0);
    return r >= o.getDate() ? o : (n.setFullYear(o.getFullYear(), o.getMonth(), r), n);
}
let Uo = {};
function Wo() {
    return Uo;
}
function Yo(t, e) {
    const i = Wo(), n = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? i.weekStartsOn ?? i.locale?.options?.weekStartsOn ?? 0, r = Fo(t, e?.in), o = r.getDay(), s = (o < n ? 7 : 0) + o - n;
    return r.setDate(r.getDate() - s), r.setHours(0, 0, 0, 0), r;
}
function _o(t, e) {
    return Yo(t, {
        ...e,
        weekStartsOn: 1
    });
}
function Xo(t, e) {
    const i = Fo(t, e?.in), n = i.getFullYear(), r = Bo(i, 0);
    r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
    const o = _o(r), s = Bo(i, 0);
    s.setFullYear(n, 0, 4), s.setHours(0, 0, 0, 0);
    const a = _o(s);
    return i.getTime() >= o.getTime() ? n + 1 : i.getTime() >= a.getTime() ? n : n - 1;
}
function Go(t) {
    const e = Fo(t), i = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
    return i.setUTCFullYear(e.getFullYear()), +t - +i;
}
function qo(t, ...e) {
    const i = Bo.bind(null, t || e.find((t)=>"object" == typeof t));
    return e.map(i);
}
function Vo(t, e) {
    const i = Fo(t, e?.in);
    return i.setHours(0, 0, 0, 0), i;
}
function $o(t, e, i) {
    return Ho(t, 12 * e, i);
}
function Ko(t, e) {
    const i = +Fo(t) - +Fo(e);
    return i < 0 ? -1 : i > 0 ? 1 : i;
}
function Zo(t) {
    var e;
    return !(!((e = t) instanceof Date || "object" == typeof e && "[object Date]" === Object.prototype.toString.call(e)) && "number" != typeof t || isNaN(+Fo(t)));
}
function Qo(t, e) {
    const i = Fo(t, e?.in), n = i.getMonth();
    return i.setFullYear(i.getFullYear(), n + 1, 0), i.setHours(23, 59, 59, 999), i;
}
function Jo(t, e) {
    const i = Fo(t, e?.in);
    return +function(t, e) {
        const i = Fo(t, e?.in);
        return i.setHours(23, 59, 59, 999), i;
    }(i, e) == +Qo(i, e);
}
function ts(t, e, i) {
    const [n, r, o] = qo(i?.in, t, t, e), s = Ko(r, o), a = Math.abs(function(t, e, i) {
        const [n, r] = qo(i?.in, t, e);
        return 12 * (n.getFullYear() - r.getFullYear()) + (n.getMonth() - r.getMonth());
    }(r, o));
    if (a < 1) return 0;
    1 === r.getMonth() && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - s * a);
    let l = Ko(r, o) === -s;
    Jo(n) && 1 === a && 1 === Ko(n, o) && (l = !1);
    const h = s * (a - +l);
    return 0 === h ? 0 : h;
}
function es(t, e) {
    const i = Fo(t, e?.in), n = i.getFullYear();
    return i.setFullYear(n + 1, 0, 0), i.setHours(23, 59, 59, 999), i;
}
function is(t, e) {
    const i = Fo(t, e?.in);
    return i.setFullYear(i.getFullYear(), 0, 1), i.setHours(0, 0, 0, 0), i;
}
const ns = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
function rs(t) {
    return (e = {})=>{
        const i = e.width ? String(e.width) : t.defaultWidth;
        return t.formats[i] || t.formats[t.defaultWidth];
    };
}
const os = {
    date: rs({
        formats: {
            full: "EEEE, MMMM do, y",
            long: "MMMM do, y",
            medium: "MMM d, y",
            short: "MM/dd/yyyy"
        },
        defaultWidth: "full"
    }),
    time: rs({
        formats: {
            full: "h:mm:ss a zzzz",
            long: "h:mm:ss a z",
            medium: "h:mm:ss a",
            short: "h:mm a"
        },
        defaultWidth: "full"
    }),
    dateTime: rs({
        formats: {
            full: "{{date}} 'at' {{time}}",
            long: "{{date}} 'at' {{time}}",
            medium: "{{date}}, {{time}}",
            short: "{{date}}, {{time}}"
        },
        defaultWidth: "full"
    })
}, ss = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
function as(t) {
    return (e, i)=>{
        let n;
        if ("formatting" === (i?.context ? String(i.context) : "standalone") && t.formattingValues) {
            const e = t.defaultFormattingWidth || t.defaultWidth, r = i?.width ? String(i.width) : e;
            n = t.formattingValues[r] || t.formattingValues[e];
        } else {
            const e = t.defaultWidth, r = i?.width ? String(i.width) : t.defaultWidth;
            n = t.values[r] || t.values[e];
        }
        return n[t.argumentCallback ? t.argumentCallback(e) : e];
    };
}
const ls = {
    ordinalNumber: (t, e)=>{
        const i = Number(t), n = i % 100;
        if (n > 20 || n < 10) switch(n % 10){
            case 1:
                return i + "st";
            case 2:
                return i + "nd";
            case 3:
                return i + "rd";
        }
        return i + "th";
    },
    era: as({
        values: {
            narrow: [
                "B",
                "A"
            ],
            abbreviated: [
                "BC",
                "AD"
            ],
            wide: [
                "Before Christ",
                "Anno Domini"
            ]
        },
        defaultWidth: "wide"
    }),
    quarter: as({
        values: {
            narrow: [
                "1",
                "2",
                "3",
                "4"
            ],
            abbreviated: [
                "Q1",
                "Q2",
                "Q3",
                "Q4"
            ],
            wide: [
                "1st quarter",
                "2nd quarter",
                "3rd quarter",
                "4th quarter"
            ]
        },
        defaultWidth: "wide",
        argumentCallback: (t)=>t - 1
    }),
    month: as({
        values: {
            narrow: [
                "J",
                "F",
                "M",
                "A",
                "M",
                "J",
                "J",
                "A",
                "S",
                "O",
                "N",
                "D"
            ],
            abbreviated: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            wide: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ]
        },
        defaultWidth: "wide"
    }),
    day: as({
        values: {
            narrow: [
                "S",
                "M",
                "T",
                "W",
                "T",
                "F",
                "S"
            ],
            short: [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            abbreviated: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            wide: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ]
        },
        defaultWidth: "wide"
    }),
    dayPeriod: as({
        values: {
            narrow: {
                am: "a",
                pm: "p",
                midnight: "mi",
                noon: "n",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
            },
            abbreviated: {
                am: "AM",
                pm: "PM",
                midnight: "midnight",
                noon: "noon",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
            },
            wide: {
                am: "a.m.",
                pm: "p.m.",
                midnight: "midnight",
                noon: "noon",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
            }
        },
        defaultWidth: "wide",
        formattingValues: {
            narrow: {
                am: "a",
                pm: "p",
                midnight: "mi",
                noon: "n",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
            },
            abbreviated: {
                am: "AM",
                pm: "PM",
                midnight: "midnight",
                noon: "noon",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
            },
            wide: {
                am: "a.m.",
                pm: "p.m.",
                midnight: "midnight",
                noon: "noon",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
            }
        },
        defaultFormattingWidth: "wide"
    })
};
function hs(t) {
    return (e, i = {})=>{
        const n = i.width, r = n && t.matchPatterns[n] || t.matchPatterns[t.defaultMatchWidth], o = e.match(r);
        if (!o) return null;
        const s = o[0], a = n && t.parsePatterns[n] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(a) ? function(t, e) {
            for(let i = 0; i < t.length; i++)if (e(t[i])) return i;
            return;
        }(a, (t)=>t.test(s)) : function(t, e) {
            for(const i in t)if (Object.prototype.hasOwnProperty.call(t, i) && e(t[i])) return i;
            return;
        }(a, (t)=>t.test(s));
        let h;
        h = t.valueCallback ? t.valueCallback(l) : l, h = i.valueCallback ? i.valueCallback(h) : h;
        return {
            value: h,
            rest: e.slice(s.length)
        };
    };
}
const cs = {
    ordinalNumber: (ds = {
        matchPattern: /^(\d+)(th|st|nd|rd)?/i,
        parsePattern: /\d+/i,
        valueCallback: (t)=>parseInt(t, 10)
    }, (t, e = {})=>{
        const i = t.match(ds.matchPattern);
        if (!i) return null;
        const n = i[0], r = t.match(ds.parsePattern);
        if (!r) return null;
        let o = ds.valueCallback ? ds.valueCallback(r[0]) : r[0];
        return o = e.valueCallback ? e.valueCallback(o) : o, {
            value: o,
            rest: t.slice(n.length)
        };
    }),
    era: hs({
        matchPatterns: {
            narrow: /^(b|a)/i,
            abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
            wide: /^(before christ|before common era|anno domini|common era)/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
            any: [
                /^b/i,
                /^(a|c)/i
            ]
        },
        defaultParseWidth: "any"
    }),
    quarter: hs({
        matchPatterns: {
            narrow: /^[1234]/i,
            abbreviated: /^q[1234]/i,
            wide: /^[1234](th|st|nd|rd)? quarter/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
            any: [
                /1/i,
                /2/i,
                /3/i,
                /4/i
            ]
        },
        defaultParseWidth: "any",
        valueCallback: (t)=>t + 1
    }),
    month: hs({
        matchPatterns: {
            narrow: /^[jfmasond]/i,
            abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
            wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
            narrow: [
                /^j/i,
                /^f/i,
                /^m/i,
                /^a/i,
                /^m/i,
                /^j/i,
                /^j/i,
                /^a/i,
                /^s/i,
                /^o/i,
                /^n/i,
                /^d/i
            ],
            any: [
                /^ja/i,
                /^f/i,
                /^mar/i,
                /^ap/i,
                /^may/i,
                /^jun/i,
                /^jul/i,
                /^au/i,
                /^s/i,
                /^o/i,
                /^n/i,
                /^d/i
            ]
        },
        defaultParseWidth: "any"
    }),
    day: hs({
        matchPatterns: {
            narrow: /^[smtwf]/i,
            short: /^(su|mo|tu|we|th|fr|sa)/i,
            abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
            wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
            narrow: [
                /^s/i,
                /^m/i,
                /^t/i,
                /^w/i,
                /^t/i,
                /^f/i,
                /^s/i
            ],
            any: [
                /^su/i,
                /^m/i,
                /^tu/i,
                /^w/i,
                /^th/i,
                /^f/i,
                /^sa/i
            ]
        },
        defaultParseWidth: "any"
    }),
    dayPeriod: hs({
        matchPatterns: {
            narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
            any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
        },
        defaultMatchWidth: "any",
        parsePatterns: {
            any: {
                am: /^a/i,
                pm: /^p/i,
                midnight: /^mi/i,
                noon: /^no/i,
                morning: /morning/i,
                afternoon: /afternoon/i,
                evening: /evening/i,
                night: /night/i
            }
        },
        defaultParseWidth: "any"
    })
};
var ds;
const us = {
    code: "en-US",
    formatDistance: (t, e, i)=>{
        let n;
        const r = ns[t];
        return n = "string" == typeof r ? r : 1 === e ? r.one : r.other.replace("{{count}}", e.toString()), i?.addSuffix ? i.comparison && i.comparison > 0 ? "in " + n : n + " ago" : n;
    },
    formatLong: os,
    formatRelative: (t, e, i, n)=>ss[t],
    localize: ls,
    match: cs,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
function ps(t, e) {
    const i = Fo(t, e?.in), n = function(t, e, i) {
        const [n, r] = qo(i?.in, t, e), o = Vo(n), s = Vo(r), a = +o - Go(o), l = +s - Go(s);
        return Math.round((a - l) / No);
    }(i, is(i));
    return n + 1;
}
function fs(t, e) {
    const i = Fo(t, e?.in), n = +_o(i) - +function(t, e) {
        const i = Xo(t, e), n = Bo(t, 0);
        return n.setFullYear(i, 0, 4), n.setHours(0, 0, 0, 0), _o(n);
    }(i);
    return Math.round(n / jo) + 1;
}
function gs(t, e) {
    const i = Fo(t, e?.in), n = i.getFullYear(), r = Wo(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = Bo(e?.in || t, 0);
    s.setFullYear(n + 1, 0, o), s.setHours(0, 0, 0, 0);
    const a = Yo(s, e), l = Bo(e?.in || t, 0);
    l.setFullYear(n, 0, o), l.setHours(0, 0, 0, 0);
    const h = Yo(l, e);
    return +i >= +a ? n + 1 : +i >= +h ? n : n - 1;
}
function ms(t, e) {
    const i = Fo(t, e?.in), n = +Yo(i, e) - +function(t, e) {
        const i = Wo(), n = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, r = gs(t, e), o = Bo(e?.in || t, 0);
        return o.setFullYear(r, 0, n), o.setHours(0, 0, 0, 0), Yo(o, e);
    }(i, e);
    return Math.round(n / jo) + 1;
}
function bs(t, e) {
    return (t < 0 ? "-" : "") + Math.abs(t).toString().padStart(e, "0");
}
const ys = {
    y (t, e) {
        const i = t.getFullYear(), n = i > 0 ? i : 1 - i;
        return bs("yy" === e ? n % 100 : n, e.length);
    },
    M (t, e) {
        const i = t.getMonth();
        return "M" === e ? String(i + 1) : bs(i + 1, 2);
    },
    d: (t, e)=>bs(t.getDate(), e.length),
    a (t, e) {
        const i = t.getHours() / 12 >= 1 ? "pm" : "am";
        switch(e){
            case "a":
            case "aa":
                return i.toUpperCase();
            case "aaa":
                return i;
            case "aaaaa":
                return i[0];
            default:
                return "am" === i ? "a.m." : "p.m.";
        }
    },
    h: (t, e)=>bs(t.getHours() % 12 || 12, e.length),
    H: (t, e)=>bs(t.getHours(), e.length),
    m: (t, e)=>bs(t.getMinutes(), e.length),
    s: (t, e)=>bs(t.getSeconds(), e.length),
    S (t, e) {
        const i = e.length, n = t.getMilliseconds();
        return bs(Math.trunc(n * Math.pow(10, i - 3)), e.length);
    }
}, xs = "midnight", vs = "noon", ws = "morning", Cs = "afternoon", Ss = "evening", ks = "night", As = {
    G: function(t, e, i) {
        const n = t.getFullYear() > 0 ? 1 : 0;
        switch(e){
            case "G":
            case "GG":
            case "GGG":
                return i.era(n, {
                    width: "abbreviated"
                });
            case "GGGGG":
                return i.era(n, {
                    width: "narrow"
                });
            default:
                return i.era(n, {
                    width: "wide"
                });
        }
    },
    y: function(t, e, i) {
        if ("yo" === e) {
            const e = t.getFullYear(), n = e > 0 ? e : 1 - e;
            return i.ordinalNumber(n, {
                unit: "year"
            });
        }
        return ys.y(t, e);
    },
    Y: function(t, e, i, n) {
        const r = gs(t, n), o = r > 0 ? r : 1 - r;
        if ("YY" === e) return bs(o % 100, 2);
        return "Yo" === e ? i.ordinalNumber(o, {
            unit: "year"
        }) : bs(o, e.length);
    },
    R: function(t, e) {
        return bs(Xo(t), e.length);
    },
    u: function(t, e) {
        return bs(t.getFullYear(), e.length);
    },
    Q: function(t, e, i) {
        const n = Math.ceil((t.getMonth() + 1) / 3);
        switch(e){
            case "Q":
                return String(n);
            case "QQ":
                return bs(n, 2);
            case "Qo":
                return i.ordinalNumber(n, {
                    unit: "quarter"
                });
            case "QQQ":
                return i.quarter(n, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "QQQQQ":
                return i.quarter(n, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return i.quarter(n, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    q: function(t, e, i) {
        const n = Math.ceil((t.getMonth() + 1) / 3);
        switch(e){
            case "q":
                return String(n);
            case "qq":
                return bs(n, 2);
            case "qo":
                return i.ordinalNumber(n, {
                    unit: "quarter"
                });
            case "qqq":
                return i.quarter(n, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "qqqqq":
                return i.quarter(n, {
                    width: "narrow",
                    context: "standalone"
                });
            default:
                return i.quarter(n, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    M: function(t, e, i) {
        const n = t.getMonth();
        switch(e){
            case "M":
            case "MM":
                return ys.M(t, e);
            case "Mo":
                return i.ordinalNumber(n + 1, {
                    unit: "month"
                });
            case "MMM":
                return i.month(n, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "MMMMM":
                return i.month(n, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return i.month(n, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    L: function(t, e, i) {
        const n = t.getMonth();
        switch(e){
            case "L":
                return String(n + 1);
            case "LL":
                return bs(n + 1, 2);
            case "Lo":
                return i.ordinalNumber(n + 1, {
                    unit: "month"
                });
            case "LLL":
                return i.month(n, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "LLLLL":
                return i.month(n, {
                    width: "narrow",
                    context: "standalone"
                });
            default:
                return i.month(n, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    w: function(t, e, i, n) {
        const r = ms(t, n);
        return "wo" === e ? i.ordinalNumber(r, {
            unit: "week"
        }) : bs(r, e.length);
    },
    I: function(t, e, i) {
        const n = fs(t);
        return "Io" === e ? i.ordinalNumber(n, {
            unit: "week"
        }) : bs(n, e.length);
    },
    d: function(t, e, i) {
        return "do" === e ? i.ordinalNumber(t.getDate(), {
            unit: "date"
        }) : ys.d(t, e);
    },
    D: function(t, e, i) {
        const n = ps(t);
        return "Do" === e ? i.ordinalNumber(n, {
            unit: "dayOfYear"
        }) : bs(n, e.length);
    },
    E: function(t, e, i) {
        const n = t.getDay();
        switch(e){
            case "E":
            case "EE":
            case "EEE":
                return i.day(n, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "EEEEE":
                return i.day(n, {
                    width: "narrow",
                    context: "formatting"
                });
            case "EEEEEE":
                return i.day(n, {
                    width: "short",
                    context: "formatting"
                });
            default:
                return i.day(n, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    e: function(t, e, i, n) {
        const r = t.getDay(), o = (r - n.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case "e":
                return String(o);
            case "ee":
                return bs(o, 2);
            case "eo":
                return i.ordinalNumber(o, {
                    unit: "day"
                });
            case "eee":
                return i.day(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "eeeee":
                return i.day(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "eeeeee":
                return i.day(r, {
                    width: "short",
                    context: "formatting"
                });
            default:
                return i.day(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    c: function(t, e, i, n) {
        const r = t.getDay(), o = (r - n.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case "c":
                return String(o);
            case "cc":
                return bs(o, e.length);
            case "co":
                return i.ordinalNumber(o, {
                    unit: "day"
                });
            case "ccc":
                return i.day(r, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "ccccc":
                return i.day(r, {
                    width: "narrow",
                    context: "standalone"
                });
            case "cccccc":
                return i.day(r, {
                    width: "short",
                    context: "standalone"
                });
            default:
                return i.day(r, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    i: function(t, e, i) {
        const n = t.getDay(), r = 0 === n ? 7 : n;
        switch(e){
            case "i":
                return String(r);
            case "ii":
                return bs(r, e.length);
            case "io":
                return i.ordinalNumber(r, {
                    unit: "day"
                });
            case "iii":
                return i.day(n, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "iiiii":
                return i.day(n, {
                    width: "narrow",
                    context: "formatting"
                });
            case "iiiiii":
                return i.day(n, {
                    width: "short",
                    context: "formatting"
                });
            default:
                return i.day(n, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    a: function(t, e, i) {
        const n = t.getHours() / 12 >= 1 ? "pm" : "am";
        switch(e){
            case "a":
            case "aa":
                return i.dayPeriod(n, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return i.dayPeriod(n, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return i.dayPeriod(n, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return i.dayPeriod(n, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    b: function(t, e, i) {
        const n = t.getHours();
        let r;
        switch(r = 12 === n ? vs : 0 === n ? xs : n / 12 >= 1 ? "pm" : "am", e){
            case "b":
            case "bb":
                return i.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return i.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return i.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return i.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    B: function(t, e, i) {
        const n = t.getHours();
        let r;
        switch(r = n >= 17 ? Ss : n >= 12 ? Cs : n >= 4 ? ws : ks, e){
            case "B":
            case "BB":
            case "BBB":
                return i.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return i.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return i.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    h: function(t, e, i) {
        if ("ho" === e) {
            let e = t.getHours() % 12;
            return 0 === e && (e = 12), i.ordinalNumber(e, {
                unit: "hour"
            });
        }
        return ys.h(t, e);
    },
    H: function(t, e, i) {
        return "Ho" === e ? i.ordinalNumber(t.getHours(), {
            unit: "hour"
        }) : ys.H(t, e);
    },
    K: function(t, e, i) {
        const n = t.getHours() % 12;
        return "Ko" === e ? i.ordinalNumber(n, {
            unit: "hour"
        }) : bs(n, e.length);
    },
    k: function(t, e, i) {
        let n = t.getHours();
        return 0 === n && (n = 24), "ko" === e ? i.ordinalNumber(n, {
            unit: "hour"
        }) : bs(n, e.length);
    },
    m: function(t, e, i) {
        return "mo" === e ? i.ordinalNumber(t.getMinutes(), {
            unit: "minute"
        }) : ys.m(t, e);
    },
    s: function(t, e, i) {
        return "so" === e ? i.ordinalNumber(t.getSeconds(), {
            unit: "second"
        }) : ys.s(t, e);
    },
    S: function(t, e) {
        return ys.S(t, e);
    },
    X: function(t, e, i) {
        const n = t.getTimezoneOffset();
        if (0 === n) return "Z";
        switch(e){
            case "X":
                return Ms(n);
            case "XXXX":
            case "XX":
                return Ts(n);
            default:
                return Ts(n, ":");
        }
    },
    x: function(t, e, i) {
        const n = t.getTimezoneOffset();
        switch(e){
            case "x":
                return Ms(n);
            case "xxxx":
            case "xx":
                return Ts(n);
            default:
                return Ts(n, ":");
        }
    },
    O: function(t, e, i) {
        const n = t.getTimezoneOffset();
        switch(e){
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + Es(n, ":");
            default:
                return "GMT" + Ts(n, ":");
        }
    },
    z: function(t, e, i) {
        const n = t.getTimezoneOffset();
        switch(e){
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + Es(n, ":");
            default:
                return "GMT" + Ts(n, ":");
        }
    },
    t: function(t, e, i) {
        return bs(Math.trunc(+t / 1e3), e.length);
    },
    T: function(t, e, i) {
        return bs(+t, e.length);
    }
};
function Es(t, e = "") {
    const i = t > 0 ? "-" : "+", n = Math.abs(t), r = Math.trunc(n / 60), o = n % 60;
    return 0 === o ? i + String(r) : i + String(r) + e + bs(o, 2);
}
function Ms(t, e) {
    if (t % 60 == 0) return (t > 0 ? "-" : "+") + bs(Math.abs(t) / 60, 2);
    return Ts(t, e);
}
function Ts(t, e = "") {
    const i = t > 0 ? "-" : "+", n = Math.abs(t);
    return i + bs(Math.trunc(n / 60), 2) + e + bs(n % 60, 2);
}
const Ps = (t, e)=>{
    switch(t){
        case "P":
            return e.date({
                width: "short"
            });
        case "PP":
            return e.date({
                width: "medium"
            });
        case "PPP":
            return e.date({
                width: "long"
            });
        default:
            return e.date({
                width: "full"
            });
    }
}, Rs = (t, e)=>{
    switch(t){
        case "p":
            return e.time({
                width: "short"
            });
        case "pp":
            return e.time({
                width: "medium"
            });
        case "ppp":
            return e.time({
                width: "long"
            });
        default:
            return e.time({
                width: "full"
            });
    }
}, Ls = {
    p: Rs,
    P: (t, e)=>{
        const i = t.match(/(P+)(p+)?/) || [], n = i[1], r = i[2];
        if (!r) return Ps(t, e);
        let o;
        switch(n){
            case "P":
                o = e.dateTime({
                    width: "short"
                });
                break;
            case "PP":
                o = e.dateTime({
                    width: "medium"
                });
                break;
            case "PPP":
                o = e.dateTime({
                    width: "long"
                });
                break;
            default:
                o = e.dateTime({
                    width: "full"
                });
        }
        return o.replace("{{date}}", Ps(n, e)).replace("{{time}}", Rs(r, e));
    }
}, Os = /^D+$/, Ds = /^Y+$/, js = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function Ns(t) {
    return Os.test(t);
}
function Is(t) {
    return Ds.test(t);
}
function Bs(t, e, i) {
    const n = function(t, e, i) {
        const n = "Y" === t[0] ? "years" : "days of the month";
        return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${n} to the input \`${i}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
    }(t, e, i);
    if (console.warn(n), js.includes(t)) throw new RangeError(n);
}
const Fs = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, zs = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Hs = /^'([^]*?)'?$/, Us = /''/g, Ws = /[a-zA-Z]/;
function Ys(t, e, i) {
    const n = Wo(), r = n.locale ?? us, o = n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, s = n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, a = Fo(t, i?.in);
    if (!Zo(a)) throw new RangeError("Invalid time value");
    let l = e.match(zs).map((t)=>{
        const e = t[0];
        if ("p" === e || "P" === e) return (0, Ls[e])(t, r.formatLong);
        return t;
    }).join("").match(Fs).map((t)=>{
        if ("''" === t) return {
            isToken: !1,
            value: "'"
        };
        const e = t[0];
        if ("'" === e) return {
            isToken: !1,
            value: _s(t)
        };
        if (As[e]) return {
            isToken: !0,
            value: t
        };
        if (e.match(Ws)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + e + "`");
        return {
            isToken: !1,
            value: t
        };
    });
    r.localize.preprocessor && (l = r.localize.preprocessor(a, l));
    const h = {
        firstWeekContainsDate: o,
        weekStartsOn: s,
        locale: r
    };
    return l.map((i)=>{
        if (!i.isToken) return i.value;
        const n = i.value;
        (Is(n) || Ns(n)) && Bs(n, e, String(t));
        return (0, As[n[0]])(a, n, r.localize, h);
    }).join("");
}
function _s(t) {
    const e = t.match(Hs);
    return e ? e[1].replace(Us, "'") : t;
}
class Xs {
    subPriority = 0;
    validate(t, e) {
        return !0;
    }
}
class Gs extends Xs {
    constructor(t, e, i, n, r){
        super(), this.value = t, this.validateValue = e, this.setValue = i, this.priority = n, r && (this.subPriority = r);
    }
    validate(t, e) {
        return this.validateValue(t, this.value, e);
    }
    set(t, e, i) {
        return this.setValue(t, e, this.value, i);
    }
}
class qs extends Xs {
    priority = 10;
    subPriority = -1;
    constructor(t, e){
        super(), this.context = t || ((t)=>Bo(e, t));
    }
    set(t, e) {
        return e.timestampIsSet ? t : Bo(t, function(t, e) {
            const i = function(t) {
                return "function" == typeof t && t.prototype?.constructor === t;
            }(e) ? new e(0) : Bo(e, 0);
            return i.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), i.setHours(t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()), i;
        }(t, this.context));
    }
}
class Vs {
    run(t, e, i, n) {
        const r = this.parse(t, e, i, n);
        return r ? {
            setter: new Gs(r.value, this.validate, this.set, this.priority, this.subPriority),
            rest: r.rest
        } : null;
    }
    validate(t, e, i) {
        return !0;
    }
}
const $s = /^(1[0-2]|0?\d)/, Ks = /^(3[0-1]|[0-2]?\d)/, Zs = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, Qs = /^(5[0-3]|[0-4]?\d)/, Js = /^(2[0-3]|[0-1]?\d)/, ta = /^(2[0-4]|[0-1]?\d)/, ea = /^(1[0-1]|0?\d)/, ia = /^(1[0-2]|0?\d)/, na = /^[0-5]?\d/, ra = /^[0-5]?\d/, oa = /^\d/, sa = /^\d{1,2}/, aa = /^\d{1,3}/, la = /^\d{1,4}/, ha = /^-?\d+/, ca = /^-?\d/, da = /^-?\d{1,2}/, ua = /^-?\d{1,3}/, pa = /^-?\d{1,4}/, fa = /^([+-])(\d{2})(\d{2})?|Z/, ga = /^([+-])(\d{2})(\d{2})|Z/, ma = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/, ba = /^([+-])(\d{2}):(\d{2})|Z/, ya = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
function xa(t, e) {
    return t ? {
        value: e(t.value),
        rest: t.rest
    } : t;
}
function va(t, e) {
    const i = e.match(t);
    return i ? {
        value: parseInt(i[0], 10),
        rest: e.slice(i[0].length)
    } : null;
}
function wa(t, e) {
    const i = e.match(t);
    if (!i) return null;
    if ("Z" === i[0]) return {
        value: 0,
        rest: e.slice(1)
    };
    return {
        value: ("+" === i[1] ? 1 : -1) * (36e5 * (i[2] ? parseInt(i[2], 10) : 0) + 6e4 * (i[3] ? parseInt(i[3], 10) : 0) + 1e3 * (i[5] ? parseInt(i[5], 10) : 0)),
        rest: e.slice(i[0].length)
    };
}
function Ca(t) {
    return va(ha, t);
}
function Sa(t, e) {
    switch(t){
        case 1:
            return va(oa, e);
        case 2:
            return va(sa, e);
        case 3:
            return va(aa, e);
        case 4:
            return va(la, e);
        default:
            return va(new RegExp("^\\d{1," + t + "}"), e);
    }
}
function ka(t, e) {
    switch(t){
        case 1:
            return va(ca, e);
        case 2:
            return va(da, e);
        case 3:
            return va(ua, e);
        case 4:
            return va(pa, e);
        default:
            return va(new RegExp("^-?\\d{1," + t + "}"), e);
    }
}
function Aa(t) {
    switch(t){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        default:
            return 0;
    }
}
function Ea(t, e) {
    const i = e > 0, n = i ? e : 1 - e;
    let r;
    if (n <= 50) r = t || 100;
    else {
        const e = n + 50;
        r = t + 100 * Math.trunc(e / 100) - (t >= e % 100 ? 100 : 0);
    }
    return i ? r : 1 - r;
}
function Ma(t) {
    return t % 400 == 0 || t % 4 == 0 && t % 100 != 0;
}
const Ta = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], Pa = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function Ra(t, e, i) {
    const n = Wo(), r = i?.weekStartsOn ?? i?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = Fo(t, i?.in), s = o.getDay(), a = 7 - r;
    return zo(o, e < 0 || e > 6 ? e - (s + a) % 7 : ((e % 7 + 7) % 7 + a) % 7 - (s + a) % 7, i);
}
function La(t, e, i) {
    const n = Fo(t, i?.in), r = function(t, e) {
        const i = Fo(t, e?.in).getDay();
        return 0 === i ? 7 : i;
    }(n, i);
    return zo(n, e - r, i);
}
const Oa = {
    G: new class extends Vs {
        priority = 140;
        parse(t, e, i) {
            switch(e){
                case "G":
                case "GG":
                case "GGG":
                    return i.era(t, {
                        width: "abbreviated"
                    }) || i.era(t, {
                        width: "narrow"
                    });
                case "GGGGG":
                    return i.era(t, {
                        width: "narrow"
                    });
                default:
                    return i.era(t, {
                        width: "wide"
                    }) || i.era(t, {
                        width: "abbreviated"
                    }) || i.era(t, {
                        width: "narrow"
                    });
            }
        }
        set(t, e, i) {
            return e.era = i, t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "R",
            "u",
            "t",
            "T"
        ];
    },
    y: new class extends Vs {
        priority = 130;
        incompatibleTokens = [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ];
        parse(t, e, i) {
            const n = (t)=>({
                    year: t,
                    isTwoDigitYear: "yy" === e
                });
            switch(e){
                case "y":
                    return xa(Sa(4, t), n);
                case "yo":
                    return xa(i.ordinalNumber(t, {
                        unit: "year"
                    }), n);
                default:
                    return xa(Sa(e.length, t), n);
            }
        }
        validate(t, e) {
            return e.isTwoDigitYear || e.year > 0;
        }
        set(t, e, i) {
            const n = t.getFullYear();
            if (i.isTwoDigitYear) {
                const e = Ea(i.year, n);
                return t.setFullYear(e, 0, 1), t.setHours(0, 0, 0, 0), t;
            }
            const r = "era" in e && 1 !== e.era ? 1 - i.year : i.year;
            return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
        }
    },
    Y: new class extends Vs {
        priority = 130;
        parse(t, e, i) {
            const n = (t)=>({
                    year: t,
                    isTwoDigitYear: "YY" === e
                });
            switch(e){
                case "Y":
                    return xa(Sa(4, t), n);
                case "Yo":
                    return xa(i.ordinalNumber(t, {
                        unit: "year"
                    }), n);
                default:
                    return xa(Sa(e.length, t), n);
            }
        }
        validate(t, e) {
            return e.isTwoDigitYear || e.year > 0;
        }
        set(t, e, i, n) {
            const r = gs(t, n);
            if (i.isTwoDigitYear) {
                const e = Ea(i.year, r);
                return t.setFullYear(e, 0, n.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Yo(t, n);
            }
            const o = "era" in e && 1 !== e.era ? 1 - i.year : i.year;
            return t.setFullYear(o, 0, n.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Yo(t, n);
        }
        incompatibleTokens = [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ];
    },
    R: new class extends Vs {
        priority = 130;
        parse(t, e) {
            return ka("R" === e ? 4 : e.length, t);
        }
        set(t, e, i) {
            const n = Bo(t, 0);
            return n.setFullYear(i, 0, 4), n.setHours(0, 0, 0, 0), _o(n);
        }
        incompatibleTokens = [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    u: new class extends Vs {
        priority = 130;
        parse(t, e) {
            return ka("u" === e ? 4 : e.length, t);
        }
        set(t, e, i) {
            return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    Q: new class extends Vs {
        priority = 120;
        parse(t, e, i) {
            switch(e){
                case "Q":
                case "QQ":
                    return Sa(e.length, t);
                case "Qo":
                    return i.ordinalNumber(t, {
                        unit: "quarter"
                    });
                case "QQQ":
                    return i.quarter(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.quarter(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "QQQQQ":
                    return i.quarter(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                default:
                    return i.quarter(t, {
                        width: "wide",
                        context: "formatting"
                    }) || i.quarter(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.quarter(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        }
        validate(t, e) {
            return e >= 1 && e <= 4;
        }
        set(t, e, i) {
            return t.setMonth(3 * (i - 1), 1), t.setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    q: new class extends Vs {
        priority = 120;
        parse(t, e, i) {
            switch(e){
                case "q":
                case "qq":
                    return Sa(e.length, t);
                case "qo":
                    return i.ordinalNumber(t, {
                        unit: "quarter"
                    });
                case "qqq":
                    return i.quarter(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || i.quarter(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "qqqqq":
                    return i.quarter(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                default:
                    return i.quarter(t, {
                        width: "wide",
                        context: "standalone"
                    }) || i.quarter(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || i.quarter(t, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        }
        validate(t, e) {
            return e >= 1 && e <= 4;
        }
        set(t, e, i) {
            return t.setMonth(3 * (i - 1), 1), t.setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    M: new class extends Vs {
        incompatibleTokens = [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ];
        priority = 110;
        parse(t, e, i) {
            const n = (t)=>t - 1;
            switch(e){
                case "M":
                    return xa(va($s, t), n);
                case "MM":
                    return xa(Sa(2, t), n);
                case "Mo":
                    return xa(i.ordinalNumber(t, {
                        unit: "month"
                    }), n);
                case "MMM":
                    return i.month(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.month(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "MMMMM":
                    return i.month(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                default:
                    return i.month(t, {
                        width: "wide",
                        context: "formatting"
                    }) || i.month(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.month(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        }
        validate(t, e) {
            return e >= 0 && e <= 11;
        }
        set(t, e, i) {
            return t.setMonth(i, 1), t.setHours(0, 0, 0, 0), t;
        }
    },
    L: new class extends Vs {
        priority = 110;
        parse(t, e, i) {
            const n = (t)=>t - 1;
            switch(e){
                case "L":
                    return xa(va($s, t), n);
                case "LL":
                    return xa(Sa(2, t), n);
                case "Lo":
                    return xa(i.ordinalNumber(t, {
                        unit: "month"
                    }), n);
                case "LLL":
                    return i.month(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || i.month(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "LLLLL":
                    return i.month(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                default:
                    return i.month(t, {
                        width: "wide",
                        context: "standalone"
                    }) || i.month(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || i.month(t, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        }
        validate(t, e) {
            return e >= 0 && e <= 11;
        }
        set(t, e, i) {
            return t.setMonth(i, 1), t.setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    w: new class extends Vs {
        priority = 100;
        parse(t, e, i) {
            switch(e){
                case "w":
                    return va(Qs, t);
                case "wo":
                    return i.ordinalNumber(t, {
                        unit: "week"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            return e >= 1 && e <= 53;
        }
        set(t, e, i, n) {
            return Yo(function(t, e, i) {
                const n = Fo(t, i?.in), r = ms(n, i) - e;
                return n.setDate(n.getDate() - 7 * r), Fo(n, i?.in);
            }(t, i, n), n);
        }
        incompatibleTokens = [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ];
    },
    I: new class extends Vs {
        priority = 100;
        parse(t, e, i) {
            switch(e){
                case "I":
                    return va(Qs, t);
                case "Io":
                    return i.ordinalNumber(t, {
                        unit: "week"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            return e >= 1 && e <= 53;
        }
        set(t, e, i) {
            return _o(function(t, e, i) {
                const n = Fo(t, i?.in), r = fs(n, i) - e;
                return n.setDate(n.getDate() - 7 * r), n;
            }(t, i));
        }
        incompatibleTokens = [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    d: new class extends Vs {
        priority = 90;
        subPriority = 1;
        parse(t, e, i) {
            switch(e){
                case "d":
                    return va(Ks, t);
                case "do":
                    return i.ordinalNumber(t, {
                        unit: "date"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            const i = Ma(t.getFullYear()), n = t.getMonth();
            return i ? e >= 1 && e <= Pa[n] : e >= 1 && e <= Ta[n];
        }
        set(t, e, i) {
            return t.setDate(i), t.setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    D: new class extends Vs {
        priority = 90;
        subpriority = 1;
        parse(t, e, i) {
            switch(e){
                case "D":
                case "DD":
                    return va(Zs, t);
                case "Do":
                    return i.ordinalNumber(t, {
                        unit: "date"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            return Ma(t.getFullYear()) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
        }
        set(t, e, i) {
            return t.setMonth(0, i), t.setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    E: new class extends Vs {
        priority = 90;
        parse(t, e, i) {
            switch(e){
                case "E":
                case "EE":
                case "EEE":
                    return i.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "EEEEE":
                    return i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "EEEEEE":
                    return i.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                default:
                    return i.day(t, {
                        width: "wide",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        }
        validate(t, e) {
            return e >= 0 && e <= 6;
        }
        set(t, e, i, n) {
            return (t = Ra(t, i, n)).setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    e: new class extends Vs {
        priority = 90;
        parse(t, e, i, n) {
            const r = (t)=>{
                const e = 7 * Math.floor((t - 1) / 7);
                return (t + n.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case "e":
                case "ee":
                    return xa(Sa(e.length, t), r);
                case "eo":
                    return xa(i.ordinalNumber(t, {
                        unit: "day"
                    }), r);
                case "eee":
                    return i.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "eeeee":
                    return i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "eeeeee":
                    return i.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                default:
                    return i.day(t, {
                        width: "wide",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        }
        validate(t, e) {
            return e >= 0 && e <= 6;
        }
        set(t, e, i, n) {
            return (t = Ra(t, i, n)).setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ];
    },
    c: new class extends Vs {
        priority = 90;
        parse(t, e, i, n) {
            const r = (t)=>{
                const e = 7 * Math.floor((t - 1) / 7);
                return (t + n.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case "c":
                case "cc":
                    return xa(Sa(e.length, t), r);
                case "co":
                    return xa(i.ordinalNumber(t, {
                        unit: "day"
                    }), r);
                case "ccc":
                    return i.day(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || i.day(t, {
                        width: "short",
                        context: "standalone"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "ccccc":
                    return i.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "cccccc":
                    return i.day(t, {
                        width: "short",
                        context: "standalone"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                default:
                    return i.day(t, {
                        width: "wide",
                        context: "standalone"
                    }) || i.day(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || i.day(t, {
                        width: "short",
                        context: "standalone"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        }
        validate(t, e) {
            return e >= 0 && e <= 6;
        }
        set(t, e, i, n) {
            return (t = Ra(t, i, n)).setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ];
    },
    i: new class extends Vs {
        priority = 90;
        parse(t, e, i) {
            const n = (t)=>0 === t ? 7 : t;
            switch(e){
                case "i":
                case "ii":
                    return Sa(e.length, t);
                case "io":
                    return i.ordinalNumber(t, {
                        unit: "day"
                    });
                case "iii":
                    return xa(i.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    }), n);
                case "iiiii":
                    return xa(i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    }), n);
                case "iiiiii":
                    return xa(i.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    }), n);
                default:
                    return xa(i.day(t, {
                        width: "wide",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || i.day(t, {
                        width: "narrow",
                        context: "formatting"
                    }), n);
            }
        }
        validate(t, e) {
            return e >= 1 && e <= 7;
        }
        set(t, e, i) {
            return (t = La(t, i)).setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ];
    },
    a: new class extends Vs {
        priority = 80;
        parse(t, e, i) {
            switch(e){
                case "a":
                case "aa":
                case "aaa":
                    return i.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "aaaaa":
                    return i.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                default:
                    return i.dayPeriod(t, {
                        width: "wide",
                        context: "formatting"
                    }) || i.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        }
        set(t, e, i) {
            return t.setHours(Aa(i), 0, 0, 0), t;
        }
        incompatibleTokens = [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ];
    },
    b: new class extends Vs {
        priority = 80;
        parse(t, e, i) {
            switch(e){
                case "b":
                case "bb":
                case "bbb":
                    return i.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "bbbbb":
                    return i.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                default:
                    return i.dayPeriod(t, {
                        width: "wide",
                        context: "formatting"
                    }) || i.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        }
        set(t, e, i) {
            return t.setHours(Aa(i), 0, 0, 0), t;
        }
        incompatibleTokens = [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ];
    },
    B: new class extends Vs {
        priority = 80;
        parse(t, e, i) {
            switch(e){
                case "B":
                case "BB":
                case "BBB":
                    return i.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "BBBBB":
                    return i.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                default:
                    return i.dayPeriod(t, {
                        width: "wide",
                        context: "formatting"
                    }) || i.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || i.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        }
        set(t, e, i) {
            return t.setHours(Aa(i), 0, 0, 0), t;
        }
        incompatibleTokens = [
            "a",
            "b",
            "t",
            "T"
        ];
    },
    h: new class extends Vs {
        priority = 70;
        parse(t, e, i) {
            switch(e){
                case "h":
                    return va(ia, t);
                case "ho":
                    return i.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            return e >= 1 && e <= 12;
        }
        set(t, e, i) {
            const n = t.getHours() >= 12;
            return n && i < 12 ? t.setHours(i + 12, 0, 0, 0) : n || 12 !== i ? t.setHours(i, 0, 0, 0) : t.setHours(0, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "H",
            "K",
            "k",
            "t",
            "T"
        ];
    },
    H: new class extends Vs {
        priority = 70;
        parse(t, e, i) {
            switch(e){
                case "H":
                    return va(Js, t);
                case "Ho":
                    return i.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            return e >= 0 && e <= 23;
        }
        set(t, e, i) {
            return t.setHours(i, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ];
    },
    K: new class extends Vs {
        priority = 70;
        parse(t, e, i) {
            switch(e){
                case "K":
                    return va(ea, t);
                case "Ko":
                    return i.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            return e >= 0 && e <= 11;
        }
        set(t, e, i) {
            return t.getHours() >= 12 && i < 12 ? t.setHours(i + 12, 0, 0, 0) : t.setHours(i, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "h",
            "H",
            "k",
            "t",
            "T"
        ];
    },
    k: new class extends Vs {
        priority = 70;
        parse(t, e, i) {
            switch(e){
                case "k":
                    return va(ta, t);
                case "ko":
                    return i.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            return e >= 1 && e <= 24;
        }
        set(t, e, i) {
            const n = i <= 24 ? i % 24 : i;
            return t.setHours(n, 0, 0, 0), t;
        }
        incompatibleTokens = [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ];
    },
    m: new class extends Vs {
        priority = 60;
        parse(t, e, i) {
            switch(e){
                case "m":
                    return va(na, t);
                case "mo":
                    return i.ordinalNumber(t, {
                        unit: "minute"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            return e >= 0 && e <= 59;
        }
        set(t, e, i) {
            return t.setMinutes(i, 0, 0), t;
        }
        incompatibleTokens = [
            "t",
            "T"
        ];
    },
    s: new class extends Vs {
        priority = 50;
        parse(t, e, i) {
            switch(e){
                case "s":
                    return va(ra, t);
                case "so":
                    return i.ordinalNumber(t, {
                        unit: "second"
                    });
                default:
                    return Sa(e.length, t);
            }
        }
        validate(t, e) {
            return e >= 0 && e <= 59;
        }
        set(t, e, i) {
            return t.setSeconds(i, 0), t;
        }
        incompatibleTokens = [
            "t",
            "T"
        ];
    },
    S: new class extends Vs {
        priority = 30;
        parse(t, e) {
            return xa(Sa(e.length, t), (t)=>Math.trunc(t * Math.pow(10, 3 - e.length)));
        }
        set(t, e, i) {
            return t.setMilliseconds(i), t;
        }
        incompatibleTokens = [
            "t",
            "T"
        ];
    },
    X: new class extends Vs {
        priority = 10;
        parse(t, e) {
            switch(e){
                case "X":
                    return wa(fa, t);
                case "XX":
                    return wa(ga, t);
                case "XXXX":
                    return wa(ma, t);
                case "XXXXX":
                    return wa(ya, t);
                default:
                    return wa(ba, t);
            }
        }
        set(t, e, i) {
            return e.timestampIsSet ? t : Bo(t, t.getTime() - Go(t) - i);
        }
        incompatibleTokens = [
            "t",
            "T",
            "x"
        ];
    },
    x: new class extends Vs {
        priority = 10;
        parse(t, e) {
            switch(e){
                case "x":
                    return wa(fa, t);
                case "xx":
                    return wa(ga, t);
                case "xxxx":
                    return wa(ma, t);
                case "xxxxx":
                    return wa(ya, t);
                default:
                    return wa(ba, t);
            }
        }
        set(t, e, i) {
            return e.timestampIsSet ? t : Bo(t, t.getTime() - Go(t) - i);
        }
        incompatibleTokens = [
            "t",
            "T",
            "X"
        ];
    },
    t: new class extends Vs {
        priority = 40;
        parse(t) {
            return Ca(t);
        }
        set(t, e, i) {
            return [
                Bo(t, 1e3 * i),
                {
                    timestampIsSet: !0
                }
            ];
        }
        incompatibleTokens = "*";
    },
    T: new class extends Vs {
        priority = 20;
        parse(t) {
            return Ca(t);
        }
        set(t, e, i) {
            return [
                Bo(t, i),
                {
                    timestampIsSet: !0
                }
            ];
        }
        incompatibleTokens = "*";
    }
}, Da = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ja = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Na = /^'([^]*?)'?$/, Ia = /''/g, Ba = /\S/, Fa = /[a-zA-Z]/;
function za(t, e, i, n) {
    const r = ()=>Bo(i, NaN), o = Object.assign({}, Wo()), s = o.locale ?? us, a = o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, l = o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0;
    if (!e) return t ? r() : Fo(i, n?.in);
    const h = {
        firstWeekContainsDate: a,
        weekStartsOn: l,
        locale: s
    }, c = [
        new qs(n?.in, i)
    ], d = e.match(ja).map((t)=>{
        const e = t[0];
        if (e in Ls) return (0, Ls[e])(t, s.formatLong);
        return t;
    }).join("").match(Da), u = [];
    for (let i of d){
        Is(i) && Bs(i, e, t), Ns(i) && Bs(i, e, t);
        const n = i[0], o = Oa[n];
        if (o) {
            const { incompatibleTokens: e } = o;
            if (Array.isArray(e)) {
                const t = u.find((t)=>e.includes(t.token) || t.token === n);
                if (t) throw new RangeError(`The format string mustn't contain \`${t.fullToken}\` and \`${i}\` at the same time`);
            } else if ("*" === o.incompatibleTokens && u.length > 0) throw new RangeError(`The format string mustn't contain \`${i}\` and any other token at the same time`);
            u.push({
                token: n,
                fullToken: i
            });
            const a = o.run(t, i, s.match, h);
            if (!a) return r();
            c.push(a.setter), t = a.rest;
        } else {
            if (n.match(Fa)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + n + "`");
            if ("''" === i ? i = "'" : "'" === n && (i = i.match(Na)[1].replace(Ia, "'")), 0 !== t.indexOf(i)) return r();
            t = t.slice(i.length);
        }
    }
    if (t.length > 0 && Ba.test(t)) return r();
    const p = c.map((t)=>t.priority).sort((t, e)=>e - t).filter((t, e, i)=>i.indexOf(t) === e).map((t)=>c.filter((e)=>e.priority === t).sort((t, e)=>e.subPriority - t.subPriority)).map((t)=>t[0]);
    let f = Fo(i, n?.in);
    if (isNaN(+f)) return r();
    const g = {};
    for (const t of p){
        if (!t.validate(f, h)) return r();
        const e = t.set(f, g, h);
        Array.isArray(e) ? (f = e[0], Object.assign(g, e[1])) : f = e;
    }
    return f;
}
const Ha = (t, e)=>{
    const i = za(`${t}`, e, new Date);
    return !!Zo(i) && i;
}, Ua = {
    [ur.value]: {
        tryParse: (t)=>7 === Ai(`${t}`) && Ha(t, "yyyy-MM"),
        formatToCode: (t)=>Ys(t, "yyyy-MM"),
        formatToLabel: (t)=>Ys(t, "MM-yyyy"),
        differenceFunc: ts,
        addFunc: Ho,
        getStartPeriod: (t)=>Zo(t) ? function(t, e) {
                const i = Fo(t, e?.in);
                return i.setDate(1), i.setHours(0, 0, 0, 0), i;
            }(t) : "",
        getEndPeriod: (t)=>Zo(t) ? Qo(t) : "",
        frequencyTypeCode: ur.value,
        dotStatId: ur.dotStatId,
        getLabel: (t)=>"fr" === t ? "Mensuelle" : "Monthly"
    },
    [dr.value]: {
        tryParse: (t)=>7 === Ai(`${t}`) && Ha(t, "yyyy-QQQ"),
        formatToCode: (t)=>Ys(t, "yyyy-QQQ"),
        formatToLabel: (t, e)=>{
            const i = Ys(t, "Q-yyyy");
            return "fr" === e ? `T${i}` : `Q${i}`;
        },
        differenceFunc: function(t, e, i) {
            const n = ts(t, e, i) / 3;
            return (function(t) {
                return (e)=>{
                    const i = (t ? Math[t] : Math.trunc)(e);
                    return 0 === i ? 0 : i;
                };
            })(i?.roundingMethod)(n);
        },
        addFunc: function(t, e, i) {
            return Ho(t, 3 * e, i);
        },
        getStartPeriod: (t)=>Zo(t) ? function(t, e) {
                const i = Fo(t, e?.in), n = i.getMonth(), r = n - n % 3;
                return i.setMonth(r, 1), i.setHours(0, 0, 0, 0), i;
            }(t) : "",
        getEndPeriod: (t)=>Zo(t) ? function(t, e) {
                const i = Fo(t, e?.in), n = i.getMonth(), r = n - n % 3 + 3;
                return i.setMonth(r, 0), i.setHours(23, 59, 59, 999), i;
            }(t) : "",
        frequencyTypeCode: dr.value,
        dotStatId: dr.dotStatId,
        getLabel: (t)=>"fr" === t ? "Trimestrielle" : "Quarterly"
    },
    [cr.value]: {
        tryParse: (t)=>4 === Ai(`${t}`) && Ha(t, "yyyy"),
        formatToCode: (t)=>Ys(t, "yyyy"),
        formatToLabel: (t)=>Ys(t, "yyyy"),
        differenceFunc: function(t, e, i) {
            const [n, r] = qo(i?.in, t, e), o = Ko(n, r), s = Math.abs(function(t, e, i) {
                const [n, r] = qo(i?.in, t, e);
                return n.getFullYear() - r.getFullYear();
            }(n, r));
            n.setFullYear(1584), r.setFullYear(1584);
            const a = o * (s - +(Ko(n, r) === -o));
            return 0 === a ? 0 : a;
        },
        addFunc: $o,
        getStartPeriod: (t)=>Zo(t) ? is(t) : "",
        getEndPeriod: (t)=>Zo(t) ? es(t) : "",
        frequencyTypeCode: cr.value,
        dotStatId: cr.dotStatId,
        getLabel: (t)=>"fr" === t ? "Annuelle" : "Yearly"
    },
    [hr.value]: {
        tryParse: (t)=>{
            const e = Ha(t, "yyyy");
            return !(4 !== Ai(`${t}`) || !e) && e.getFullYear() % 5 == 0 && e;
        },
        formatToCode: (t)=>Ys(t, "yyyy"),
        formatToLabel: (t)=>Ys(t, "yyyy"),
        differenceFunc: (t, e)=>(t.getFullYear() - e.getFullYear()) / 5,
        addFunc: (t, e)=>$o(t, 5 * e),
        getStartPeriod: (t)=>{
            if (Zo(t)) {
                const e = t.getFullYear();
                return t.setFullYear(e - e % 5), is(t);
            }
            return "";
        },
        getEndPeriod: (t)=>{
            if (Zo(t)) {
                const e = t.getFullYear();
                return e % 5 != 0 && t.setFullYear(e + (5 - e % 5)), es(t);
            }
            return "";
        },
        frequencyTypeCode: hr.value,
        dotStatId: hr.dotStatId,
        getLabel: (t)=>"fr" === t ? "Quinquennal" : "Quinquennial"
    }
}, Wa = (t, e)=>{
    const { frequencyTypeCode: i, minCode: n, maxCode: r } = t;
    try {
        const t = jt(i, Ua), { tryParse: o, formatToCode: s, formatToLabel: a, differenceFunc: l, addFunc: h } = t, c = o(n), d = l(o(r), c), u = pi(Rt((t)=>{
            const i = h(c, t);
            return [
                s(i),
                a(i, e)
            ];
        }, Vi(je, d + 1)));
        return {
            codes: ht(u),
            labelByCode: u
        };
    } catch  {
        return {
            codes: [],
            labelByCode: []
        };
    }
}, Ya = "#48A7FF", _a = [
    [
        "#0A4095",
        "#0E51B5",
        "#1162D4",
        "#2379E2",
        "#3690F1",
        "#48A7FF",
        "#73BCFF"
    ],
    [
        "#0A4095",
        "#0E51B5",
        "#1162D4",
        "#3690F1",
        "#48A7FF",
        "#73BCFF"
    ],
    [
        "#0A4095",
        "#0E51B5",
        "#1162D4",
        "#48A7FF",
        "#73BCFF"
    ],
    [
        "#0A4095",
        "#0E51B5",
        "#1162D4",
        "#48A7FF"
    ],
    [
        "#0A4095",
        "#1162D4",
        "#48A7FF"
    ],
    [
        "#0E51B5",
        "#48A7FF"
    ],
    [
        Ya
    ]
], Xa = (t, e)=>{
    const i = parseInt(t.replace("#", ""), 16), n = Math.round(2.55 * e), r = (i >> 16) + n, o = (i >> 8 & 255) + n, s = (255 & i) + n;
    return `#${(16777216 + 65536 * (r < 255 ? r < 1 ? 0 : r : 255) + 256 * (o < 255 ? o < 1 ? 0 : o : 255) + (s < 255 ? s < 1 ? 0 : s : 255)).toString(16).slice(1)}`;
}, Ga = (t)=>new So(t || "black").toHexString(), qa = (t, e)=>{
    const i = Ga(t);
    return Xa(i, e);
}, Va = (t)=>{
    const e = Ga(t);
    return Rt((t)=>Xa(e, 10 * t), Vi(je, 9));
}, $a = (t, e)=>qi((t)=>!ko(t, e), (t)=>t.darken(10), new So(t || "black"), Vi(je, 3)).toHexString(), Ka = (t, e)=>Fi(t % Ai(e), e), Za = (t, e, i, n)=>{
    if (-1 !== di(Do(t), i)) return Ya;
    const r = di(Do(t), e);
    return -1 === r ? null : Ka(r, n);
}, Qa = (t, e)=>Ao(t) || Ao(e) ? [] : Vi(je, Mt(Ai(t), Ai(e))), Ja = (t, e)=>{
    const i = jn(Le(ke(Ci(Array)), jt("colorAxis")), oi({
        colorAxis: (t)=>[
                t
            ]
    }))(e);
    return Le(Se, ji(t), ji(i), jn(()=>!Ao(jt("colorAxis", t)) && !Ao(jt("colorAxis", i)), Le(le([
        "colorAxis",
        0,
        "dataClasses"
    ], Rt((e)=>ji(Ui({}, [
            "colorAxis",
            [
                0
            ],
            "dataClasses",
            e
        ], t), Ui({}, [
            "colorAxis",
            [
                0
            ],
            "dataClasses",
            e
        ], i)), Qa(Ui([], [
        "colorAxis",
        [
            0
        ],
        "dataClasses"
    ], t), Ui([], [
        "colorAxis",
        [
            0
        ],
        "dataClasses"
    ], i)))), he("colorAxis", Rt((e)=>ji(Ui({}, [
            "colorAxis",
            e
        ], t), Ui({}, [
            "colorAxis",
            e
        ], i)), Qa(jt("colorAxis", t), jt("colorAxis", i)))))), jn(()=>!Ao(jt("series", t)) && !Ao(jt("series", i)), he("series", Rt((e)=>ji(Ui({}, [
            "series",
            e
        ], t), Ui({}, [
            "series",
            e
        ], i)), Qa(jt("series", t), jt("series", i))))))({});
}, tl = bi(Ao, qt(!1), Le(ke(Number.isNaN), Number)), el = (t, e)=>tl(t) ? Number(Number(t).toFixed(e)) : t, il = (t, e)=>{
    const i = new So(t || "black"), n = Le(jn(fi(j, 1), qt(1)), jn(Ti(j, 0), qt(0)))(i.getAlpha() + e);
    return i.setAlpha(n).toHex8String();
}, nl = (t, e)=>{
    const i = Ai(t);
    return 0 === i ? [] : e ? Eo((e, n)=>n === i - 1 ? {
            from: Oe(ei(t)),
            name: Fi(1, ei(t))
        } : {
            from: Oe(Fi(n, t)),
            to: Oe(Fi(n + 1, t)),
            name: Fi(1, Fi(n, t))
        }, t) : Yi({
        to: Oe(Oe(t)),
        name: `< ${Oe(Oe(t))}`
    }, Eo((e, n)=>n === i - 1 ? {
            from: Oe(Fi(n, t)),
            name: `> ${Oe(Fi(n, t))}`
        } : {
            from: Oe(Fi(n, t)),
            to: Oe(Fi(n + 1, t)),
            name: `${Oe(Fi(n, t))} - ${Oe(Fi(n + 1, t))}`
        }, t));
}, rl = (t, e)=>Gt((t, i)=>$i(new RegExp(`{${i}}`, "gi"), jt(i, e), t), t ?? "", Ro), ol = (t)=>{
    let { string: e, vars: i, latestMin: n, latestMax: r, mapping: o, replaceMissingVarByBlank: s = !1 } = t;
    return Le($i(new RegExp(`{${Oo}}`, "gi"), r || (s ? "&nbsp;" : "")), $i(new RegExp(`{${Lo}}`, "gi"), n || (s ? "&nbsp;" : "")), Gt((t, e)=>{
        const n = Le(jn(Si, ()=>s ? "&nbsp;" : ""), ki(", "), kt(Ao), Rt(jt(j, o)), Qi("|"), On, jt(e))(i);
        return $i(new RegExp(`{${e}}`, "gi"), n, t);
    }, j, Ro))(e ?? "");
}, sl = ki("|", Rt((t)=>`{${t}}`, Ne(Ro, [
    Lo,
    Oo
]))), al = Pn(new RegExp(sl, "i")), ll = (t, e)=>!(!t || !e) && (t < 540 || e < 350), hl = (t)=>t ? 22 : 0;
"object" == typeof kr && (Hr(kr), Ir(kr), Tr(kr), Or(kr), _r(kr), Vr(kr), Qr(kr));
const cl = React.forwardRef((t, e)=>{
    let { title: i = "", subtitle: n = "", data: r, highlight: o = null, baseline: s = null, hideLegend: a = !1, hideXAxisLabels: l = !1, hideYAxisLabels: h = !1, colorPalette: c, highlightColors: d, width: u, height: p, isSmall: f, formatters: g = {}, fullscreenClose: m = null, isFullScreen: b = !1, tooltipOutside: y, csvExportcolumnHeaderFormatter: x, optionsOverride: v = {} } = t;
    const w = React.useMemo(()=>Eo((t, e)=>{
            const i = Za(t, o, s, d), n = i || Ka(e, c), r = $a(n, "white");
            return {
                name: t.label,
                data: Rt((t)=>((t)=>({
                            y: t.value,
                            __metadata: t.metadata
                        }))(t), t.data),
                type: "line",
                lineWidth: 2.5,
                marker: {
                    symbol: "circle",
                    radius: 3,
                    lineWidth: 2
                },
                states: {
                    hover: {
                        lineWidth: 2.5
                    }
                },
                color: n,
                showInLegend: !0,
                dataLabels: {
                    color: r,
                    textShadow: "0px -1px 3px white, 1px 0px 3px white, 0px 1px 3px white, -1px 0px 3px white, -1px -1px 3px white, 1px -1px 3px white, 1px 1px 3px white, -1px 1px 3px white",
                    textOutline: "none"
                },
                ...i ? {
                    zIndex: 1
                } : {}
            };
        }, r.series), [
        r,
        c,
        d,
        o,
        s
    ]), C = React.useMemo(()=>({
            chart: {
                polar: !0,
                type: "line",
                style: {
                    fontFamily: "'Noto Sans Display', Helvetica, sans-serif"
                },
                height: p,
                animation: !1,
                margin: a ? 40 : void 0,
                marginBottom: !a && f ? 5 : void 0,
                spacing: hl(b),
                events: {
                    fullscreenClose: m
                }
            },
            colors: c,
            title: {
                text: i,
                align: "left",
                margin: 20,
                style: {
                    color: "#101d40",
                    fontWeight: "bold",
                    fontSize: "18px"
                }
            },
            subtitle: {
                text: n,
                align: "left",
                style: {
                    color: "#586179",
                    fontSize: "17px"
                }
            },
            credits: {
                enabled: !1
            },
            pane: {
                startAngle: 0,
                endAngle: 360,
                size: f ? "70%" : "85%"
            },
            xAxis: {
                categories: Rt(jt("label"), r.categories),
                labels: {
                    style: {
                        color: "#586179",
                        fontSize: f ? "13px" : "16px"
                    },
                    enabled: !l
                },
                gridLineColor: "#c2cbd6",
                lineColor: "transparent"
            },
            yAxis: {
                title: {
                    enabled: !1
                },
                gridLineColor: "#c2cbd6",
                lineColor: "#c2cbd6",
                labels: {
                    style: {
                        fontSize: f ? "13px" : "16px",
                        color: "#586179"
                    },
                    enabled: !h
                }
            },
            legend: {
                enabled: !a,
                itemDistance: 10,
                itemStyle: {
                    fontWeight: "normal",
                    color: "#586179",
                    fontSize: f ? "13px" : "16px"
                },
                align: "left",
                symbolWidth: 18,
                x: -7,
                verticalAlign: "top",
                margin: f ? 16 : 24
            },
            plotOptions: {
                series: {
                    animation: !1,
                    pointPadding: 0,
                    groupPadding: 0,
                    events: {
                        mouseOver: (t)=>{
                            t.target.data.forEach((t)=>{
                                t.update({
                                    dataLabels: {
                                        enabled: !0,
                                        ...jt("dataLabels", g)
                                    }
                                }, !1, !1, !1);
                            }), t.target.chart.redraw();
                        },
                        mouseOut: (t)=>{
                            t.target.data.forEach((t)=>{
                                t.update({
                                    dataLabels: {
                                        enabled: !1
                                    }
                                }, !1, !1, !1);
                            }), t.target.chart.redraw();
                        }
                    }
                }
            },
            tooltip: {
                ...jt("tooltip", g),
                outside: y
            },
            series: w,
            exporting: {
                enabled: !1,
                sourceWidth: 600,
                sourceHeight: 400,
                filename: `export-${new Date(Date.now()).toISOString()}`,
                csv: {
                    columnHeaderFormatter: x
                }
            }
        }), [
        i,
        n,
        r,
        w,
        c,
        u,
        p,
        f,
        a,
        l,
        h,
        g,
        m,
        y,
        x
    ]), S = React.useMemo(()=>Ja(C, v), [
        C,
        v
    ]);
    return React.createElement(io, {
        ref: e,
        highcharts: kr,
        options: S,
        immutable: !b
    });
});
cl.propTypes = {
    title: P.string,
    subtitle: P.string,
    data: P.shape({
        categories: P.array.isRequired,
        series: P.array.isRequired,
        areCategoriesDates: P.bool.isRequired,
        areCategoriesNumbers: P.bool.isRequired
    }).isRequired,
    highlight: P.array,
    baseline: P.array,
    hideLegend: P.bool,
    hideXAxisLabels: P.bool,
    hideYAxisLabels: P.bool,
    colorPalette: P.array.isRequired,
    highlightColors: P.array.isRequired,
    width: P.number.isRequired,
    height: P.number.isRequired,
    isSmall: P.bool.isRequired,
    formatters: P.object,
    fullscreenClose: P.func,
    isFullScreen: P.bool,
    tooltipOutside: P.bool,
    csvExportcolumnHeaderFormatter: P.func.isRequired,
    optionsOverride: P.object
};
var dl = React.memo(cl);
"object" == typeof kr && (Hr(kr), Ir(kr), Or(kr), _r(kr), Vr(kr), Qr(kr));
const ul = (t, e, i)=>{
    if (Ao(t) && Ao(e)) return i ? 20 : 32;
}, pl = React.forwardRef((t, e)=>{
    let { data: i, title: n = "", subtitle: r = "", highlight: o = null, baseline: s = null, hideLegend: a = !1, hideXAxisLabels: l = !1, hideYAxisLabels: h = !1, colorPalette: c, highlightColors: d, width: u, height: p, isSmall: f, formatters: g = {}, fullscreenClose: m = null, isFullScreen: b = !1, tooltipOutside: y, csvExportcolumnHeaderFormatter: x, optionsOverride: v = {} } = t;
    const w = i.areCategoriesDates || i.areCategoriesNumbers, C = React.useMemo(()=>Eo((t, e)=>{
            const i = Za(t, o, s, d), n = i || Ka(e, c), r = $a(n, "white");
            return {
                name: t.label,
                data: Rt((t)=>{
                    const e = ((t, e)=>e ? {
                            x: t.metadata.parsedX,
                            y: t.value,
                            __metadata: t.metadata
                        } : {
                            y: t.value,
                            __metadata: t.metadata
                        })(t, w);
                    return e;
                }, t.data),
                type: "spline",
                lineWidth: 2.5,
                marker: {
                    symbol: "circle",
                    radius: 3,
                    lineWidth: 2
                },
                states: {
                    hover: {
                        lineWidth: 2.5
                    }
                },
                color: n,
                dataLabels: {
                    style: {
                        color: r,
                        textShadow: "0px -1px 3px white, 1px 0px 3px white, 0px 1px 3px white, -1px 0px 3px white, -1px -1px 3px white, 1px -1px 3px white, 1px 1px 3px white, -1px 1px 3px white",
                        textOutline: "none"
                    }
                },
                ...i ? {
                    zIndex: 1
                } : {},
                showInLegend: !0
            };
        }, i.series), [
        i,
        w,
        c,
        d,
        o,
        s
    ]), S = React.useMemo(()=>({
            chart: {
                style: {
                    fontFamily: "'Noto Sans Display', Helvetica, sans-serif"
                },
                marginTop: a ? ul(n, r, f) : void 0,
                height: p,
                animation: !1,
                spacing: hl(b),
                events: {
                    fullscreenClose: m
                }
            },
            colors: [
                Oe(c)
            ],
            title: {
                text: n,
                align: "left",
                margin: 20,
                style: {
                    color: "#101d40",
                    fontWeight: "bold",
                    fontSize: "18px"
                }
            },
            subtitle: {
                text: r,
                align: "left",
                style: {
                    color: "#586179",
                    fontSize: "17px"
                }
            },
            credits: {
                enabled: !1
            },
            xAxis: {
                categories: i.areCategoriesDates || i.areCategoriesNumbers ? null : Rt(jt("label"), i.categories),
                ...i.areCategoriesDates ? {
                    type: "datetime"
                } : {},
                labels: {
                    style: {
                        color: "#586179",
                        fontSize: f ? "13px" : "16px"
                    },
                    ...jt("xAxisLabels", g),
                    ...l ? {
                        enabled: !1
                    } : {}
                },
                gridLineColor: "#c2cbd6",
                lineColor: "transparent",
                left: i.areCategoriesDates || i.areCategoriesNumbers ? "10%" : "5%",
                width: i.areCategoriesDates || i.areCategoriesNumbers ? "85%" : "95%",
                tickWidth: 0
            },
            yAxis: {
                title: {
                    enabled: !1
                },
                startOnTick: !1,
                gridLineColor: "#c2cbd6",
                lineColor: "#c2cbd6",
                labels: {
                    style: {
                        fontSize: f ? "13px" : "16px",
                        color: "#586179"
                    },
                    enabled: !h,
                    align: "left",
                    x: 0,
                    y: -4
                }
            },
            legend: {
                enabled: !a,
                itemDistance: 10,
                itemStyle: {
                    fontWeight: "normal",
                    color: "#586179",
                    fontSize: f ? "13px" : "16px"
                },
                align: "left",
                symbolWidth: 18,
                x: -7,
                verticalAlign: "top",
                margin: f ? 26 : 34
            },
            plotOptions: {
                series: {
                    animation: !1,
                    events: {
                        mouseOver: (t)=>{
                            t.target.data.forEach((t)=>{
                                t.update({
                                    dataLabels: {
                                        enabled: !0,
                                        ...jt("dataLabels", g)
                                    }
                                }, !1, !1, !1);
                            }), t.target.chart.redraw();
                        },
                        mouseOut: (t)=>{
                            t.target.data.forEach((t)=>{
                                t.update({
                                    dataLabels: {
                                        enabled: !1
                                    }
                                }, !1, !1, !1);
                            }), t.target.chart.redraw();
                        }
                    }
                }
            },
            tooltip: {
                ...jt("tooltip", g),
                outside: y
            },
            series: C,
            exporting: {
                enabled: !1,
                sourceWidth: 600,
                sourceHeight: 400,
                filename: `export-${new Date(Date.now()).toISOString()}`,
                csv: {
                    columnHeaderFormatter: x
                }
            }
        }), [
        n,
        r,
        i,
        C,
        c,
        u,
        p,
        f,
        a,
        l,
        h,
        g,
        m,
        y,
        x
    ]), k = React.useMemo(()=>Ja(S, v), [
        S,
        v
    ]);
    return React.createElement(io, {
        ref: e,
        highcharts: kr,
        options: k,
        immutable: !b
    });
});
pl.propTypes = {
    title: P.string,
    subtitle: P.string,
    data: P.shape({
        categories: P.array.isRequired,
        series: P.array.isRequired,
        areCategoriesDates: P.bool.isRequired,
        areCategoriesNumbers: P.bool.isRequired
    }).isRequired,
    highlight: P.array,
    baseline: P.array,
    hideLegend: P.bool,
    hideXAxisLabels: P.bool,
    hideYAxisLabels: P.bool,
    colorPalette: P.array.isRequired,
    highlightColors: P.array.isRequired,
    width: P.number.isRequired,
    height: P.number.isRequired,
    isSmall: P.bool.isRequired,
    formatters: P.object,
    fullscreenClose: P.func,
    isFullScreen: P.bool,
    tooltipOutside: P.bool,
    csvExportcolumnHeaderFormatter: P.func.isRequired,
    optionsOverride: P.object
};
var fl = React.memo(pl);
"object" == typeof kr && (Hr(kr), Ir(kr), Or(kr), _r(kr), Vr(kr), Qr(kr));
const gl = (t, e, i, n)=>{
    if (Ao(t) && Ao(e)) return n || i ? 22 : 32;
}, ml = (t, e)=>e ? t ? 10 : 26 : t ? 14 : 34, bl = (t, e)=>t ? e ? {
        top: "7.5%",
        height: "88.9%"
    } : {
        top: "8%",
        height: "88%"
    } : e ? {
        left: "8%",
        width: "89%"
    } : {
        left: "9%",
        width: "87%"
    }, yl = React.forwardRef((t, e)=>{
    let { horizontal: i = !1, title: n = "", subtitle: r = "", data: o, highlight: s = null, baseline: a = null, hideLegend: l = !1, hideXAxisLabels: h = !1, hideYAxisLabels: c = !1, colorPalette: d, highlightColors: u, width: p, height: f, isSmall: g, pivotValue: m = 0, formatters: b = {}, fullscreenClose: y = null, isFullScreen: x = !1, tooltipOutside: v, csvExportcolumnHeaderFormatter: w, optionsOverride: C = {} } = t;
    const S = o.areCategoriesDates || o.areCategoriesNumbers, k = React.useMemo(()=>Eo((t, e)=>{
            const i = Za(t, s, a, u) || Ka(e, d);
            return {
                name: t.label,
                data: Eo((t, e)=>{
                    const i = Fi(e, o.categories), n = Za(i, s, a, u), r = ((t, e)=>e ? {
                            x: t.metadata.parsedX,
                            y: t.value,
                            __metadata: t.metadata
                        } : {
                            y: t.value,
                            __metadata: t.metadata
                        })(t, S);
                    return n ? {
                        name: i.label,
                        color: n,
                        ...r
                    } : {
                        name: i.label,
                        ...r
                    };
                }, t.data),
                color: i,
                showInLegend: !0
            };
        }, o.series), [
        o,
        S,
        d,
        u,
        s,
        a
    ]), A = React.useMemo(()=>({
            chart: {
                type: i ? "bar" : "column",
                style: {
                    fontFamily: "'Noto Sans Display', Helvetica, sans-serif"
                },
                marginTop: l ? gl(n, r, i, g) : void 0,
                height: f,
                animation: !1,
                spacing: hl(x),
                events: {
                    fullscreenClose: y
                }
            },
            colors: d,
            title: {
                text: n,
                align: "left",
                margin: 20,
                style: {
                    color: "#101d40",
                    fontSize: "18px",
                    fontWeight: "bold"
                }
            },
            subtitle: {
                text: r,
                align: "left",
                style: {
                    color: "#586179",
                    fontSize: "17px"
                }
            },
            credits: {
                enabled: !1
            },
            xAxis: {
                categories: o.areCategoriesDates || o.areCategoriesNumbers ? null : Rt(jt("label"), o.categories),
                ...o.areCategoriesDates ? {
                    type: "datetime"
                } : {},
                labels: {
                    style: {
                        color: "#586179",
                        fontSize: g ? "13px" : "16px"
                    },
                    ...jt("xAxisLabels", b),
                    ...h && !i || c && i ? {
                        enabled: !1
                    } : {}
                },
                gridLineColor: "#c2cbd6",
                lineColor: "transparent",
                ...bl(i, o.areCategoriesDates || o.areCategoriesNumbers),
                tickWidth: 0
            },
            yAxis: {
                title: {
                    enabled: !1
                },
                gridLineColor: "#c2cbd6",
                lineColor: "#c2cbd6",
                labels: {
                    style: {
                        fontSize: g ? "13px" : "16px",
                        color: "#586179"
                    },
                    enabled: !i && !c || i && !h,
                    align: "left",
                    ...i ? {
                        x: 4,
                        y: g ? 28 : 35
                    } : {
                        x: 0,
                        y: -4
                    }
                },
                opposite: i
            },
            legend: {
                enabled: !l,
                itemDistance: 10,
                itemStyle: {
                    fontWeight: "normal",
                    color: "#586179",
                    fontSize: g ? "13px" : "16px"
                },
                align: "left",
                squareSymbol: !1,
                symbolRadius: 0,
                symbolWidth: 18,
                x: -7,
                verticalAlign: "top",
                margin: ml(i, g)
            },
            plotOptions: {
                series: {
                    animation: !1,
                    pointPadding: .1,
                    groupPadding: .1,
                    borderWidth: .3,
                    borderColor: "#ffffff",
                    borderRadius: 0,
                    threshold: parseFloat(m) || 0,
                    dataLabels: {
                        ...jt("dataLabels", b)
                    }
                }
            },
            tooltip: {
                ...jt("tooltip", b),
                outside: v
            },
            series: k,
            exporting: {
                enabled: !1,
                sourceWidth: 600,
                sourceHeight: 400,
                filename: `export-${new Date(Date.now()).toISOString()}`,
                csv: {
                    columnHeaderFormatter: w
                }
            }
        }), [
        i,
        n,
        r,
        o,
        k,
        d,
        p,
        f,
        g,
        l,
        h,
        c,
        m,
        b,
        y,
        v,
        w
    ]), E = React.useMemo(()=>Ja(A, C), [
        A,
        C
    ]);
    return React.createElement(io, {
        ref: e,
        highcharts: kr,
        options: E,
        immutable: !x
    });
});
yl.propTypes = {
    horizontal: P.bool,
    title: P.string,
    subtitle: P.string,
    data: P.shape({
        categories: P.array.isRequired,
        series: P.array.isRequired,
        areCategoriesDates: P.bool.isRequired,
        areCategoriesNumbers: P.bool.isRequired
    }).isRequired,
    highlight: P.array,
    baseline: P.array,
    hideLegend: P.bool,
    hideXAxisLabels: P.bool,
    hideYAxisLabels: P.bool,
    colorPalette: P.array.isRequired,
    highlightColors: P.array.isRequired,
    width: P.number.isRequired,
    height: P.number.isRequired,
    isSmall: P.bool.isRequired,
    pivotValue: P.number,
    formatters: P.object,
    fullscreenClose: P.func,
    isFullScreen: P.bool,
    tooltipOutside: P.bool,
    csvExportcolumnHeaderFormatter: P.func.isRequired,
    optionsOverride: P.object
};
var xl = React.memo(yl);
"object" == typeof kr && (Hr(kr), Ir(kr), Or(kr), _r(kr), Vr(kr), Qr(kr));
const vl = (t, e, i, n)=>{
    if (Ao(t) && Ao(e)) return n || i ? 22 : 32;
}, wl = (t, e)=>e ? t ? 10 : 26 : t ? 14 : 34, Cl = (t, e, i)=>e ? i ? {
        left: "10%",
        width: "85%"
    } : {
        left: "5%",
        width: "95%"
    } : t ? {
        top: "8%",
        height: "88%"
    } : {
        left: "9%",
        width: "87%"
    }, Sl = React.forwardRef((t, e)=>{
    let { horizontal: i = !1, area: n = !1, title: r = "", subtitle: o = "", data: s, highlight: a = null, baseline: l = null, hideLegend: h = !1, hideXAxisLabels: c = !1, hideYAxisLabels: d = !1, colorPalette: u, highlightColors: p, width: f, height: g, isSmall: m, stacking: b = ir.percent.value, formatters: y = {}, fullscreenClose: x = null, isFullScreen: v = !1, tooltipOutside: w, csvExportcolumnHeaderFormatter: C, optionsOverride: S = {} } = t;
    const k = React.useMemo(()=>jn(Le(pt(1), Ai), Le(Va, Oe))(u), [
        u
    ]), A = React.useMemo(()=>((t, e, i, n, r)=>{
            const o = li((e)=>Ai(e) <= Ai(t.series), _a);
            return Eo((s, a)=>{
                const l = Ka(a, e);
                return {
                    name: s.label,
                    color: l,
                    marker: {
                        enabled: !1,
                        symbol: "circle",
                        radius: 3,
                        lineWidth: 2,
                        states: {
                            hover: {
                                enabled: !0
                            }
                        }
                    },
                    showInLegend: !0,
                    data: Eo((e, s)=>{
                        const l = Fi(s, t.categories), h = di(Do(l), n), c = -1 === di(Do(l), r) ? null : Ka(a, o), d = -1 === h ? null : Ka(a, Va(Ka(h, i))), u = Ie([
                            [
                                ()=>!ae(c),
                                qt(c)
                            ],
                            [
                                ()=>!ae(d),
                                qt(d)
                            ],
                            [
                                D,
                                qt(null)
                            ]
                        ])(), p = ((t, e)=>e ? {
                                x: t.metadata.parsedX,
                                y: t.value,
                                __metadata: t.metadata
                            } : {
                                y: t.value,
                                __metadata: t.metadata
                            })(e, t.areCategoriesDates || t.areCategoriesNumbers);
                        return u ? {
                            name: l.label,
                            ...p,
                            color: u
                        } : {
                            name: l.label,
                            ...p
                        };
                    }, s.data)
                };
            }, t.series);
        })(s, k, p, a, l), [
        s,
        k,
        p,
        a,
        l
    ]), E = Ie([
        [
            qt(n),
            qt("areaspline")
        ],
        [
            qt(i),
            qt("bar")
        ],
        [
            D,
            qt("column")
        ]
    ])(), M = React.useMemo(()=>({
            chart: {
                type: E,
                style: {
                    fontFamily: "'Noto Sans Display', Helvetica, sans-serif"
                },
                marginTop: h ? vl(r, o, i, m) : void 0,
                height: g,
                animation: !1,
                spacing: hl(v),
                events: {
                    fullscreenClose: x
                }
            },
            colors: k,
            title: {
                text: r,
                align: "left",
                margin: 20,
                style: {
                    color: "#101d40",
                    fontWeight: "bold",
                    fontSize: "18px"
                }
            },
            subtitle: {
                text: o,
                align: "left",
                style: {
                    color: "#586179",
                    fontSize: "17px"
                }
            },
            credits: {
                enabled: !1
            },
            xAxis: {
                categories: n && (s.areCategoriesDates || s.areCategoriesNumbers) ? null : Rt(jt("label"), s.categories),
                ...s.areCategoriesDates ? {
                    type: "datetime"
                } : {},
                labels: {
                    style: {
                        color: "#586179",
                        fontSize: m ? "13px" : "16px"
                    },
                    ...jt("xAxisLabels", y),
                    ...c && !i || d && i ? {
                        enabled: !1
                    } : {}
                },
                gridLineColor: "#c2cbd6",
                lineColor: "transparent",
                ...Cl(i, n, s.areCategoriesDates || s.areCategoriesNumbers),
                tickWidth: 0
            },
            yAxis: {
                title: {
                    enabled: !1
                },
                startOnTick: !1,
                gridLineColor: "#c2cbd6",
                lineColor: "#c2cbd6",
                labels: {
                    style: {
                        fontSize: m ? "13px" : "16px",
                        color: "#586179"
                    },
                    enabled: !i && !d || i && !c,
                    align: "left",
                    ...i ? {
                        x: 4,
                        y: m ? 28 : 35
                    } : {
                        x: 0,
                        y: -4
                    }
                },
                opposite: i,
                reversedStacks: !1
            },
            legend: {
                enabled: !h,
                reversed: !1,
                itemDistance: 10,
                itemStyle: {
                    fontWeight: "normal",
                    color: "#586179",
                    fontSize: m ? "13px" : "16px"
                },
                align: "left",
                squareSymbol: !1,
                symbolRadius: 0,
                symbolWidth: 18,
                x: -7,
                verticalAlign: "top",
                margin: wl(i, m)
            },
            plotOptions: {
                series: {
                    animation: !1,
                    stacking: b || ir.percent.value,
                    pointPadding: .1,
                    groupPadding: .1,
                    borderWidth: .3,
                    borderColor: "#ffffff",
                    borderRadius: 0,
                    dataLabels: {
                        ...jt("dataLabels", y)
                    }
                }
            },
            tooltip: {
                ...jt("tooltip", y),
                outside: w
            },
            series: A,
            exporting: {
                enabled: !1,
                sourceWidth: 600,
                sourceHeight: 400,
                filename: `export-${new Date(Date.now()).toISOString()}`,
                csv: {
                    columnHeaderFormatter: C
                }
            }
        }), [
        i,
        r,
        o,
        s,
        A,
        k,
        f,
        m,
        g,
        h,
        c,
        d,
        b,
        y,
        x,
        w,
        C,
        n,
        E
    ]), T = React.useMemo(()=>Ja(M, S), [
        M,
        S
    ]);
    return React.createElement(io, {
        ref: e,
        highcharts: kr,
        options: T,
        immutable: !v
    });
});
Sl.propTypes = {
    horizontal: P.bool,
    area: P.bool,
    title: P.string,
    subtitle: P.string,
    data: P.shape({
        categories: P.array.isRequired,
        series: P.array.isRequired,
        areCategoriesDates: P.bool.isRequired,
        areCategoriesNumbers: P.bool.isRequired
    }).isRequired,
    highlight: P.array,
    baseline: P.array,
    hideLegend: P.bool,
    hideXAxisLabels: P.bool,
    hideYAxisLabels: P.bool,
    colorPalette: P.array.isRequired,
    highlightColors: P.array.isRequired,
    width: P.number.isRequired,
    height: P.number.isRequired,
    isSmall: P.bool.isRequired,
    stacking: P.string,
    formatters: P.object,
    fullscreenClose: P.func,
    isFullScreen: P.bool,
    tooltipOutside: P.bool,
    csvExportcolumnHeaderFormatter: P.func.isRequired,
    optionsOverride: P.object
};
var kl = React.memo(Sl);
"object" == typeof kr && (Hr(kr), Ir(kr), Or(kr), _r(kr), Vr(kr), Qr(kr), kr.SVGRenderer.prototype.symbols.cross = (t, e, i, n)=>[
        "M",
        t,
        e,
        "L",
        t + i,
        e + n,
        "M",
        t + i,
        e,
        "L",
        t,
        e + n,
        "z"
    ], kr.VMLRenderer && (kr.VMLRenderer.prototype.symbols.cross = kr.SVGRenderer.prototype.symbols.cross));
const Al = [
    "circle",
    "diamond",
    "cross",
    "square",
    "triangle",
    "triangle-down"
], El = (t, e, i)=>{
    if (Ao(t) && Ao(e)) return i ? 20 : 32;
}, Ml = React.forwardRef((t, e)=>{
    let { symbolLayout: i = !1, title: n = "", subtitle: r = "", data: o, highlight: s = null, baseline: a = null, hideLegend: l = !1, hideXAxisLabels: h = !1, hideYAxisLabels: c = !1, colorPalette: d, highlightColors: u, width: p, height: f, isSmall: g, formatters: m = {}, fullscreenClose: b = null, isFullScreen: y = !1, tooltipOutside: x, csvExportcolumnHeaderFormatter: v, optionsOverride: w = {} } = t;
    const C = React.useRef([]), S = o.areCategoriesDates || o.areCategoriesNumbers, k = Oe(d), A = React.useMemo(()=>Eo((t, e)=>{
            const n = Ka(e, Al), r = Za(t, s, a, u) || Ka(e, d);
            return {
                name: t.label,
                data: Eo((t, e)=>{
                    const n = Fi(e, o.categories), r = Za(n, s, a, u), l = ((t, e)=>e ? {
                            x: t.metadata.parsedX,
                            y: t.value,
                            __metadata: t.metadata
                        } : {
                            y: t.value,
                            __metadata: t.metadata
                        })(t, S);
                    return r ? {
                        name: n.label,
                        ...l,
                        color: r,
                        marker: {
                            fillColor: i ? r : il(r, -0.4)
                        }
                    } : {
                        name: n.label,
                        ...l
                    };
                }, t.data),
                color: r,
                showInLegend: !0,
                marker: {
                    symbol: n,
                    lineColor: "cross" === n ? null : "#deeaf1",
                    lineWidth: "cross" === n ? 2 : 1,
                    radius: "cross" === n ? 5 : 6,
                    fillColor: i ? r : il(r, -0.4),
                    states: {
                        hover: {
                            lineWidth: "cross" === n ? 2 : 1,
                            radius: "cross" === n ? 5 : 6
                        }
                    }
                }
            };
        }, o.series), [
        i,
        o,
        S,
        d,
        u,
        s,
        a
    ]), E = React.useMemo(()=>({
            chart: {
                type: "scatter",
                style: {
                    fontFamily: "'Noto Sans Display', Helvetica, sans-serif"
                },
                marginTop: l ? El(n, r, g) : void 0,
                height: f,
                animation: !1,
                spacing: hl(y),
                events: {
                    fullscreenClose: b,
                    render: (t)=>{
                        let { target: e } = t;
                        if (i) {
                            To((t)=>t?.destroy(), C.current);
                            const t = Le((t)=>Le(Rt((t)=>{
                                    const e = kt(ae, t);
                                    return Si(e) ? [] : [
                                        Math.min(...e),
                                        Math.max(...e)
                                    ];
                                }), Rt((e)=>Rt(Fi(e), t)))(Vi(je, Ai(o.categories))), Rt(Le(Rt(jt("y")), jt("data"))))(St(_i(!0, "visible"), e.series));
                            C.current = Eo((i, n)=>{
                                if (Si(t[n])) return null;
                                const r = Hi([
                                    0,
                                    "data",
                                    n,
                                    "x"
                                ], e.series), o = e.xAxis[0]?.toPixels(r), l = e.yAxis[0]?.toPixels(t[n][0]), h = o, c = e.yAxis[0]?.toPixels(t[n][1]), d = Za(i, s, a, u) || k;
                                return e.renderer.path([
                                    "M",
                                    o,
                                    l,
                                    "L",
                                    h,
                                    c
                                ]).attr({
                                    stroke: il(d, -0.6),
                                    "stroke-width": 1,
                                    zIndex: 1
                                }).add();
                            }, o.categories);
                        }
                    }
                }
            },
            colors: d,
            title: {
                text: n,
                align: "left",
                margin: 20,
                style: {
                    color: "#101d40",
                    fontWeight: "bold",
                    fontSize: "18px"
                }
            },
            subtitle: {
                text: r,
                align: "left",
                style: {
                    color: "#586179",
                    fontSize: "17px"
                }
            },
            credits: {
                enabled: !1
            },
            xAxis: {
                categories: o.areCategoriesDates || o.areCategoriesNumbers ? null : Rt(jt("label"), o.categories),
                ...o.areCategoriesDates ? {
                    type: "datetime"
                } : {},
                labels: {
                    style: {
                        color: "#586179",
                        fontSize: g ? "13px" : "16px"
                    },
                    ...jt("xAxisLabels", m),
                    ...h ? {
                        enabled: !1
                    } : {}
                },
                gridLineColor: "#c2cbd6",
                lineColor: "transparent",
                left: o.areCategoriesDates || o.areCategoriesNumbers ? "10%" : "5%",
                width: o.areCategoriesDates || o.areCategoriesNumbers ? "85%" : "95%",
                tickWidth: 0
            },
            yAxis: {
                title: {
                    enabled: !1
                },
                gridLineColor: "#c2cbd6",
                lineColor: "#c2cbd6",
                labels: {
                    style: {
                        fontSize: g ? "13px" : "16px",
                        color: "#586179"
                    },
                    enabled: !c,
                    align: "left",
                    x: 0,
                    y: -4
                }
            },
            legend: {
                enabled: !l,
                itemDistance: 10,
                itemStyle: {
                    fontWeight: "normal",
                    color: "#586179",
                    fontSize: g ? "13px" : "16px"
                },
                align: "left",
                squareSymbol: !1,
                symbolRadius: 0,
                symbolWidth: 18,
                x: -7,
                verticalAlign: "top",
                margin: g ? 26 : 34
            },
            plotOptions: {
                series: {
                    animation: !1,
                    dataLabels: {
                        ...jt("dataLabels", m)
                    }
                },
                scatter: {
                    tooltip: {
                        pointFormat: "{point.name}: {point.y}"
                    }
                }
            },
            tooltip: {
                ...jt("tooltip", m),
                outside: x
            },
            series: A,
            exporting: {
                enabled: !1,
                sourceWidth: 600,
                sourceHeight: 400,
                filename: `export-${new Date(Date.now()).toISOString()}`,
                csv: {
                    columnHeaderFormatter: v
                }
            }
        }), [
        o,
        n,
        r,
        A,
        d,
        p,
        f,
        g,
        l,
        h,
        c,
        m,
        b,
        x,
        v,
        a,
        k,
        u,
        g,
        s,
        i
    ]), M = React.useMemo(()=>Ja(E, w), [
        E,
        w
    ]);
    return React.createElement(io, {
        ref: e,
        highcharts: kr,
        options: M,
        immutable: !y
    });
});
Ml.propTypes = {
    symbolLayout: P.bool,
    title: P.string,
    subtitle: P.string,
    data: P.shape({
        categories: P.array.isRequired,
        series: P.array.isRequired,
        areCategoriesDates: P.bool.isRequired,
        areCategoriesNumbers: P.bool.isRequired
    }).isRequired,
    highlight: P.array,
    baseline: P.array,
    hideLegend: P.bool,
    hideXAxisLabels: P.bool,
    hideYAxisLabels: P.bool,
    colorPalette: P.array.isRequired,
    highlightColors: P.array.isRequired,
    width: P.number.isRequired,
    height: P.number.isRequired,
    isSmall: P.bool.isRequired,
    formatters: P.object,
    fullscreenClose: P.func,
    isFullScreen: P.bool,
    tooltipOutside: P.bool,
    csvExportcolumnHeaderFormatter: P.func.isRequired,
    optionsOverride: P.object
};
var Tl = React.memo(Ml);
"object" == typeof kr && (Hr(kr), Or(kr), _r(kr), Vr(kr), Qr(kr));
const Pl = React.forwardRef((t, e)=>{
    let { title: i = "", subtitle: n = "", data: r, highlight: o = null, baseline: s = null, hideLegend: a = !1, hideXAxisLabels: l = !1, colorPalette: h, highlightColors: c, width: d, height: u, isSmall: p, formatters: f = {}, fullscreenClose: g = null, isFullScreen: m = !1, tooltipOutside: b, csvExportcolumnHeaderFormatter: y, optionsOverride: x = {} } = t;
    const v = React.useMemo(()=>1 === Ai(h) ? Va(Oe(h)) : h, [
        h
    ]), w = React.useMemo(()=>Rt((t)=>({
                name: t.label,
                data: Eo((t, e)=>{
                    const i = Fi(e, r.categories), n = Za(i, o, s, c) || Ka(e, v), a = ((t)=>({
                            y: t.value,
                            __metadata: t.metadata
                        }))(t);
                    return {
                        name: i.label,
                        ...a,
                        color: n
                    };
                }, t.data)
            }), Si(r.series) ? [] : [
            Oe(r.series)
        ]), [
        r,
        v,
        c,
        o,
        s
    ]), C = React.useMemo(()=>({
            chart: {
                type: "pie",
                style: {
                    fontFamily: "'Noto Sans Display', Helvetica, sans-serif"
                },
                height: u,
                animation: !1,
                spacing: hl(m),
                marginLeft: 10,
                marginRight: 10,
                events: {
                    fullscreenClose: g
                }
            },
            title: {
                text: i,
                align: "left",
                margin: 20,
                style: {
                    color: "#101d40",
                    fontWeight: "bold",
                    fontSize: "18px"
                }
            },
            subtitle: {
                text: n,
                align: "left",
                style: {
                    color: "#586179",
                    fontSize: "17px"
                }
            },
            credits: {
                enabled: !1
            },
            legend: {
                itemDistance: 10,
                itemStyle: {
                    fontWeight: "normal",
                    color: "#586179",
                    fontSize: p ? "13px" : "16px"
                },
                align: "left",
                symbolWidth: 18,
                x: -7,
                verticalAlign: "top",
                margin: p ? 16 : 24
            },
            plotOptions: {
                series: {
                    animation: !1,
                    borderWidth: .3,
                    borderColor: "#ffffff",
                    borderRadius: 0
                },
                pie: {
                    dataLabels: {
                        enabled: !l,
                        style: {
                            fontSize: p ? "13px" : "16px",
                            color: "#586179",
                            fontWeight: "normal"
                        }
                    },
                    showInLegend: !a
                }
            },
            tooltip: {
                ...jt("tooltip", f),
                outside: b
            },
            series: w,
            exporting: {
                enabled: !1,
                sourceWidth: 600,
                sourceHeight: 400,
                filename: `export-${new Date(Date.now()).toISOString()}`,
                csv: {
                    columnHeaderFormatter: y
                }
            }
        }), [
        i,
        n,
        w,
        d,
        u,
        p,
        a,
        l,
        f,
        g,
        b,
        y
    ]), S = React.useMemo(()=>Ja(C, x), [
        C,
        x
    ]);
    return React.createElement(io, {
        ref: e,
        highcharts: kr,
        options: S,
        immutable: !m
    });
});
Pl.propTypes = {
    title: P.string,
    subtitle: P.string,
    data: P.shape({
        categories: P.array.isRequired,
        series: P.array.isRequired,
        areCategoriesDates: P.bool.isRequired,
        areCategoriesNumbers: P.bool.isRequired
    }).isRequired,
    highlight: P.array,
    baseline: P.array,
    hideLegend: P.bool,
    hideXAxisLabels: P.bool,
    colorPalette: P.array.isRequired,
    highlightColors: P.array.isRequired,
    width: P.number.isRequired,
    height: P.number.isRequired,
    isSmall: P.bool.isRequired,
    formatters: P.object,
    fullscreenClose: P.func,
    isFullScreen: P.bool,
    tooltipOutside: P.bool,
    csvExportcolumnHeaderFormatter: P.func.isRequired,
    optionsOverride: P.object
};
var Rl = React.memo(Pl);
var Ll = {
    exports: {}
};
function Ol() {}
function Dl() {
    Dl.init.call(this);
}
function jl(t) {
    return void 0 === t._maxListeners ? Dl.defaultMaxListeners : t._maxListeners;
}
function Nl(t, e, i, n) {
    var r, o, s, a;
    if ("function" != typeof i) throw new TypeError('"listener" argument must be a function');
    if ((o = t._events) ? (o.newListener && (t.emit("newListener", e, i.listener ? i.listener : i), o = t._events), s = o[e]) : (o = t._events = new Ol, t._eventsCount = 0), s) {
        if ("function" == typeof s ? s = o[e] = n ? [
            i,
            s
        ] : [
            s,
            i
        ] : n ? s.unshift(i) : s.push(i), !s.warned && (r = jl(t)) && r > 0 && s.length > r) {
            s.warned = !0;
            var l = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + e + " listeners added. Use emitter.setMaxListeners() to increase limit");
            l.name = "MaxListenersExceededWarning", l.emitter = t, l.type = e, l.count = s.length, a = l, "function" == typeof console.warn ? console.warn(a) : console.log(a);
        }
    } else s = o[e] = i, ++t._eventsCount;
    return t;
}
function Il(t, e, i) {
    var n = !1;
    function r() {
        t.removeListener(e, r), n || (n = !0, i.apply(t, arguments));
    }
    return r.listener = i, r;
}
function Bl(t) {
    var e = this._events;
    if (e) {
        var i = e[t];
        if ("function" == typeof i) return 1;
        if (i) return i.length;
    }
    return 0;
}
function Fl(t, e) {
    for(var i = new Array(e); e--;)i[e] = t[e];
    return i;
}
Ol.prototype = Object.create(null), Dl.EventEmitter = Dl, Dl.usingDomains = !1, Dl.prototype.domain = void 0, Dl.prototype._events = void 0, Dl.prototype._maxListeners = void 0, Dl.defaultMaxListeners = 10, Dl.init = function() {
    this.domain = null, Dl.usingDomains && undefined.active, this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = new Ol, this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
}, Dl.prototype.setMaxListeners = function(t) {
    if ("number" != typeof t || t < 0 || isNaN(t)) throw new TypeError('"n" argument must be a positive number');
    return this._maxListeners = t, this;
}, Dl.prototype.getMaxListeners = function() {
    return jl(this);
}, Dl.prototype.emit = function(t) {
    var e, i, n, r, o, s, a, l = "error" === t;
    if (s = this._events) l = l && null == s.error;
    else if (!l) return !1;
    if (a = this.domain, l) {
        if (e = arguments[1], !a) {
            if (e instanceof Error) throw e;
            var h = new Error('Uncaught, unspecified "error" event. (' + e + ")");
            throw h.context = e, h;
        }
        return e || (e = new Error('Uncaught, unspecified "error" event')), e.domainEmitter = this, e.domain = a, e.domainThrown = !1, a.emit("error", e), !1;
    }
    if (!(i = s[t])) return !1;
    var c = "function" == typeof i;
    switch(n = arguments.length){
        case 1:
            !function(t, e, i) {
                if (e) t.call(i);
                else for(var n = t.length, r = Fl(t, n), o = 0; o < n; ++o)r[o].call(i);
            }(i, c, this);
            break;
        case 2:
            !function(t, e, i, n) {
                if (e) t.call(i, n);
                else for(var r = t.length, o = Fl(t, r), s = 0; s < r; ++s)o[s].call(i, n);
            }(i, c, this, arguments[1]);
            break;
        case 3:
            !function(t, e, i, n, r) {
                if (e) t.call(i, n, r);
                else for(var o = t.length, s = Fl(t, o), a = 0; a < o; ++a)s[a].call(i, n, r);
            }(i, c, this, arguments[1], arguments[2]);
            break;
        case 4:
            !function(t, e, i, n, r, o) {
                if (e) t.call(i, n, r, o);
                else for(var s = t.length, a = Fl(t, s), l = 0; l < s; ++l)a[l].call(i, n, r, o);
            }(i, c, this, arguments[1], arguments[2], arguments[3]);
            break;
        default:
            for(r = new Array(n - 1), o = 1; o < n; o++)r[o - 1] = arguments[o];
            !function(t, e, i, n) {
                if (e) t.apply(i, n);
                else for(var r = t.length, o = Fl(t, r), s = 0; s < r; ++s)o[s].apply(i, n);
            }(i, c, this, r);
    }
    return !0;
}, Dl.prototype.addListener = function(t, e) {
    return Nl(this, t, e, !1);
}, Dl.prototype.on = Dl.prototype.addListener, Dl.prototype.prependListener = function(t, e) {
    return Nl(this, t, e, !0);
}, Dl.prototype.once = function(t, e) {
    if ("function" != typeof e) throw new TypeError('"listener" argument must be a function');
    return this.on(t, Il(this, t, e)), this;
}, Dl.prototype.prependOnceListener = function(t, e) {
    if ("function" != typeof e) throw new TypeError('"listener" argument must be a function');
    return this.prependListener(t, Il(this, t, e)), this;
}, Dl.prototype.removeListener = function(t, e) {
    var i, n, r, o, s;
    if ("function" != typeof e) throw new TypeError('"listener" argument must be a function');
    if (!(n = this._events)) return this;
    if (!(i = n[t])) return this;
    if (i === e || i.listener && i.listener === e) 0 == --this._eventsCount ? this._events = new Ol : (delete n[t], n.removeListener && this.emit("removeListener", t, i.listener || e));
    else if ("function" != typeof i) {
        for(r = -1, o = i.length; o-- > 0;)if (i[o] === e || i[o].listener && i[o].listener === e) {
            s = i[o].listener, r = o;
            break;
        }
        if (r < 0) return this;
        if (1 === i.length) {
            if (i[0] = void 0, 0 == --this._eventsCount) return this._events = new Ol, this;
            delete n[t];
        } else !function(t, e) {
            for(var i = e, n = i + 1, r = t.length; n < r; i += 1, n += 1)t[i] = t[n];
            t.pop();
        }(i, r);
        n.removeListener && this.emit("removeListener", t, s || e);
    }
    return this;
}, Dl.prototype.off = function(t, e) {
    return this.removeListener(t, e);
}, Dl.prototype.removeAllListeners = function(t) {
    var e, i;
    if (!(i = this._events)) return this;
    if (!i.removeListener) return 0 === arguments.length ? (this._events = new Ol, this._eventsCount = 0) : i[t] && (0 == --this._eventsCount ? this._events = new Ol : delete i[t]), this;
    if (0 === arguments.length) {
        for(var n, r = Object.keys(i), o = 0; o < r.length; ++o)"removeListener" !== (n = r[o]) && this.removeAllListeners(n);
        return this.removeAllListeners("removeListener"), this._events = new Ol, this._eventsCount = 0, this;
    }
    if ("function" == typeof (e = i[t])) this.removeListener(t, e);
    else if (e) do this.removeListener(t, e[e.length - 1]);
    while (e[0]);
    return this;
}, Dl.prototype.listeners = function(t) {
    var e, i, n = this._events;
    return i = n && (e = n[t]) ? "function" == typeof e ? [
        e.listener || e
    ] : function(t) {
        for(var e = new Array(t.length), i = 0; i < e.length; ++i)e[i] = t[i].listener || t[i];
        return e;
    }(e) : [], i;
}, Dl.listenerCount = function(t, e) {
    return "function" == typeof t.listenerCount ? t.listenerCount(e) : Bl.call(t, e);
}, Dl.prototype.listenerCount = Bl, Dl.prototype.eventNames = function() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
var zl = [], Hl = [], Ul = "undefined" != typeof Uint8Array ? Uint8Array : Array, Wl = !1;
function Yl() {
    Wl = !0;
    for(var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0; e < 64; ++e)zl[e] = t[e], Hl[t.charCodeAt(e)] = e;
    Hl["-".charCodeAt(0)] = 62, Hl["_".charCodeAt(0)] = 63;
}
function _l(t, e, i) {
    for(var n, r, o = [], s = e; s < i; s += 3)n = (t[s] << 16) + (t[s + 1] << 8) + t[s + 2], o.push(zl[(r = n) >> 18 & 63] + zl[r >> 12 & 63] + zl[r >> 6 & 63] + zl[63 & r]);
    return o.join("");
}
function Xl(t) {
    var e;
    Wl || Yl();
    for(var i = t.length, n = i % 3, r = "", o = [], s = 16383, a = 0, l = i - n; a < l; a += s)o.push(_l(t, a, a + s > l ? l : a + s));
    return 1 === n ? (e = t[i - 1], r += zl[e >> 2], r += zl[e << 4 & 63], r += "==") : 2 === n && (e = (t[i - 2] << 8) + t[i - 1], r += zl[e >> 10], r += zl[e >> 4 & 63], r += zl[e << 2 & 63], r += "="), o.push(r), o.join("");
}
function Gl(t, e, i, n, r) {
    var o, s, a = 8 * r - n - 1, l = (1 << a) - 1, h = l >> 1, c = -7, d = i ? r - 1 : 0, u = i ? -1 : 1, p = t[e + d];
    for(d += u, o = p & (1 << -c) - 1, p >>= -c, c += a; c > 0; o = 256 * o + t[e + d], d += u, c -= 8);
    for(s = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; s = 256 * s + t[e + d], d += u, c -= 8);
    if (0 === o) o = 1 - h;
    else {
        if (o === l) return s ? NaN : 1 / 0 * (p ? -1 : 1);
        s += Math.pow(2, n), o -= h;
    }
    return (p ? -1 : 1) * s * Math.pow(2, o - n);
}
function ql(t, e, i, n, r, o) {
    var s, a, l, h = 8 * o - r - 1, c = (1 << h) - 1, d = c >> 1, u = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : o - 1, f = n ? 1 : -1, g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
    for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (e += s + d >= 1 ? u / l : u * Math.pow(2, 1 - d)) * l >= 2 && (s++, l /= 2), s + d >= c ? (a = 0, s = c) : s + d >= 1 ? (a = (e * l - 1) * Math.pow(2, r), s += d) : (a = e * Math.pow(2, d - 1) * Math.pow(2, r), s = 0)); r >= 8; t[i + p] = 255 & a, p += f, a /= 256, r -= 8);
    for(s = s << r | a, h += r; h > 0; t[i + p] = 255 & s, p += f, s /= 256, h -= 8);
    t[i + p - f] |= 128 * g;
}
var Vl = {}.toString, $l = Array.isArray || function(t) {
    return "[object Array]" == Vl.call(t);
};
function Kl() {
    return Ql.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function Zl(t, e) {
    if (Kl() < e) throw new RangeError("Invalid typed array length");
    return Ql.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = Ql.prototype : (null === t && (t = new Ql(e)), t.length = e), t;
}
function Ql(t, e, i) {
    if (!(Ql.TYPED_ARRAY_SUPPORT || this instanceof Ql)) return new Ql(t, e, i);
    if ("number" == typeof t) {
        if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
        return eh(this, t);
    }
    return Jl(this, t, e, i);
}
function Jl(t, e, i, n) {
    if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
    return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function(t, e, i, n) {
        if (e.byteLength, i < 0 || e.byteLength < i) throw new RangeError("'offset' is out of bounds");
        if (e.byteLength < i + (n || 0)) throw new RangeError("'length' is out of bounds");
        e = void 0 === i && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, i) : new Uint8Array(e, i, n);
        Ql.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = Ql.prototype : t = ih(t, e);
        return t;
    }(t, e, i, n) : "string" == typeof e ? function(t, e, i) {
        "string" == typeof i && "" !== i || (i = "utf8");
        if (!Ql.isEncoding(i)) throw new TypeError('"encoding" must be a valid string encoding');
        var n = 0 | oh(e, i);
        t = Zl(t, n);
        var r = t.write(e, i);
        r !== n && (t = t.slice(0, r));
        return t;
    }(t, e, i) : function(t, e) {
        if (rh(e)) {
            var i = 0 | nh(e.length);
            return 0 === (t = Zl(t, i)).length || e.copy(t, 0, 0, i), t;
        }
        if (e) {
            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? Zl(t, 0) : ih(t, e);
            if ("Buffer" === e.type && $l(e.data)) return ih(t, e.data);
        }
        var n;
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }(t, e);
}
function th(t) {
    if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
    if (t < 0) throw new RangeError('"size" argument must not be negative');
}
function eh(t, e) {
    if (th(e), t = Zl(t, e < 0 ? 0 : 0 | nh(e)), !Ql.TYPED_ARRAY_SUPPORT) for(var i = 0; i < e; ++i)t[i] = 0;
    return t;
}
function ih(t, e) {
    var i = e.length < 0 ? 0 : 0 | nh(e.length);
    t = Zl(t, i);
    for(var n = 0; n < i; n += 1)t[n] = 255 & e[n];
    return t;
}
function nh(t) {
    if (t >= Kl()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + Kl().toString(16) + " bytes");
    return 0 | t;
}
function rh(t) {
    return !(null == t || !t._isBuffer);
}
function oh(t, e) {
    if (rh(t)) return t.length;
    if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
    "string" != typeof t && (t = "" + t);
    var i = t.length;
    if (0 === i) return 0;
    for(var n = !1;;)switch(e){
        case "ascii":
        case "latin1":
        case "binary":
            return i;
        case "utf8":
        case "utf-8":
        case void 0:
            return Oh(t).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return 2 * i;
        case "hex":
            return i >>> 1;
        case "base64":
            return Dh(t).length;
        default:
            if (n) return Oh(t).length;
            e = ("" + e).toLowerCase(), n = !0;
    }
}
function sh(t, e, i) {
    var n = !1;
    if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
    if ((void 0 === i || i > this.length) && (i = this.length), i <= 0) return "";
    if ((i >>>= 0) <= (e >>>= 0)) return "";
    for(t || (t = "utf8");;)switch(t){
        case "hex":
            return wh(this, e, i);
        case "utf8":
        case "utf-8":
            return bh(this, e, i);
        case "ascii":
            return xh(this, e, i);
        case "latin1":
        case "binary":
            return vh(this, e, i);
        case "base64":
            return mh(this, e, i);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return Ch(this, e, i);
        default:
            if (n) throw new TypeError("Unknown encoding: " + t);
            t = (t + "").toLowerCase(), n = !0;
    }
}
function ah(t, e, i) {
    var n = t[e];
    t[e] = t[i], t[i] = n;
}
function lh(t, e, i, n, r) {
    if (0 === t.length) return -1;
    if ("string" == typeof i ? (n = i, i = 0) : i > 2147483647 ? i = 2147483647 : i < -2147483648 && (i = -2147483648), i = +i, isNaN(i) && (i = r ? 0 : t.length - 1), i < 0 && (i = t.length + i), i >= t.length) {
        if (r) return -1;
        i = t.length - 1;
    } else if (i < 0) {
        if (!r) return -1;
        i = 0;
    }
    if ("string" == typeof e && (e = Ql.from(e, n)), rh(e)) return 0 === e.length ? -1 : hh(t, e, i, n, r);
    if ("number" == typeof e) return e &= 255, Ql.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? r ? Uint8Array.prototype.indexOf.call(t, e, i) : Uint8Array.prototype.lastIndexOf.call(t, e, i) : hh(t, [
        e
    ], i, n, r);
    throw new TypeError("val must be string, number or Buffer");
}
function hh(t, e, i, n, r) {
    var o, s = 1, a = t.length, l = e.length;
    if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
        if (t.length < 2 || e.length < 2) return -1;
        s = 2, a /= 2, l /= 2, i /= 2;
    }
    function h(t, e) {
        return 1 === s ? t[e] : t.readUInt16BE(e * s);
    }
    if (r) {
        var c = -1;
        for(o = i; o < a; o++)if (h(t, o) === h(e, -1 === c ? 0 : o - c)) {
            if (-1 === c && (c = o), o - c + 1 === l) return c * s;
        } else -1 !== c && (o -= o - c), c = -1;
    } else for(i + l > a && (i = a - l), o = i; o >= 0; o--){
        for(var d = !0, u = 0; u < l; u++)if (h(t, o + u) !== h(e, u)) {
            d = !1;
            break;
        }
        if (d) return o;
    }
    return -1;
}
function ch(t, e, i, n) {
    i = Number(i) || 0;
    var r = t.length - i;
    n ? (n = Number(n)) > r && (n = r) : n = r;
    var o = e.length;
    if (o % 2 != 0) throw new TypeError("Invalid hex string");
    n > o / 2 && (n = o / 2);
    for(var s = 0; s < n; ++s){
        var a = parseInt(e.substr(2 * s, 2), 16);
        if (isNaN(a)) return s;
        t[i + s] = a;
    }
    return s;
}
function dh(t, e, i, n) {
    return jh(Oh(e, t.length - i), t, i, n);
}
function uh(t, e, i, n) {
    return jh(function(t) {
        for(var e = [], i = 0; i < t.length; ++i)e.push(255 & t.charCodeAt(i));
        return e;
    }(e), t, i, n);
}
function ph(t, e, i, n) {
    return uh(t, e, i, n);
}
function fh(t, e, i, n) {
    return jh(Dh(e), t, i, n);
}
function gh(t, e, i, n) {
    return jh(function(t, e) {
        for(var i, n, r, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s)n = (i = t.charCodeAt(s)) >> 8, r = i % 256, o.push(r), o.push(n);
        return o;
    }(e, t.length - i), t, i, n);
}
function mh(t, e, i) {
    return 0 === e && i === t.length ? Xl(t) : Xl(t.slice(e, i));
}
function bh(t, e, i) {
    i = Math.min(t.length, i);
    for(var n = [], r = e; r < i;){
        var o, s, a, l, h = t[r], c = null, d = h > 239 ? 4 : h > 223 ? 3 : h > 191 ? 2 : 1;
        if (r + d <= i) switch(d){
            case 1:
                h < 128 && (c = h);
                break;
            case 2:
                128 == (192 & (o = t[r + 1])) && (l = (31 & h) << 6 | 63 & o) > 127 && (c = l);
                break;
            case 3:
                o = t[r + 1], s = t[r + 2], 128 == (192 & o) && 128 == (192 & s) && (l = (15 & h) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (l < 55296 || l > 57343) && (c = l);
                break;
            case 4:
                o = t[r + 1], s = t[r + 2], a = t[r + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (l = (15 & h) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && l < 1114112 && (c = l);
        }
        null === c ? (c = 65533, d = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), r += d;
    }
    return function(t) {
        var e = t.length;
        if (e <= yh) return String.fromCharCode.apply(String, t);
        var i = "", n = 0;
        for(; n < e;)i += String.fromCharCode.apply(String, t.slice(n, n += yh));
        return i;
    }(n);
}
Ql.TYPED_ARRAY_SUPPORT = void 0 === t.TYPED_ARRAY_SUPPORT || t.TYPED_ARRAY_SUPPORT, Kl(), Ql.poolSize = 8192, Ql._augment = function(t) {
    return t.__proto__ = Ql.prototype, t;
}, Ql.from = function(t, e, i) {
    return Jl(null, t, e, i);
}, Ql.TYPED_ARRAY_SUPPORT && (Ql.prototype.__proto__ = Uint8Array.prototype, Ql.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && Ql[Symbol.species]), Ql.alloc = function(t, e, i) {
    return function(t, e, i, n) {
        return th(e), e <= 0 ? Zl(t, e) : void 0 !== i ? "string" == typeof n ? Zl(t, e).fill(i, n) : Zl(t, e).fill(i) : Zl(t, e);
    }(null, t, e, i);
}, Ql.allocUnsafe = function(t) {
    return eh(null, t);
}, Ql.allocUnsafeSlow = function(t) {
    return eh(null, t);
}, Ql.isBuffer = function(t) {
    return null != t && (!!t._isBuffer || Nh(t) || function(t) {
        return "function" == typeof t.readFloatLE && "function" == typeof t.slice && Nh(t.slice(0, 0));
    }(t));
}, Ql.compare = function(t, e) {
    if (!rh(t) || !rh(e)) throw new TypeError("Arguments must be Buffers");
    if (t === e) return 0;
    for(var i = t.length, n = e.length, r = 0, o = Math.min(i, n); r < o; ++r)if (t[r] !== e[r]) {
        i = t[r], n = e[r];
        break;
    }
    return i < n ? -1 : n < i ? 1 : 0;
}, Ql.isEncoding = function(t) {
    switch(String(t).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return !0;
        default:
            return !1;
    }
}, Ql.concat = function(t, e) {
    if (!$l(t)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (0 === t.length) return Ql.alloc(0);
    var i;
    if (void 0 === e) for(e = 0, i = 0; i < t.length; ++i)e += t[i].length;
    var n = Ql.allocUnsafe(e), r = 0;
    for(i = 0; i < t.length; ++i){
        var o = t[i];
        if (!rh(o)) throw new TypeError('"list" argument must be an Array of Buffers');
        o.copy(n, r), r += o.length;
    }
    return n;
}, Ql.byteLength = oh, Ql.prototype._isBuffer = !0, Ql.prototype.swap16 = function() {
    var t = this.length;
    if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var e = 0; e < t; e += 2)ah(this, e, e + 1);
    return this;
}, Ql.prototype.swap32 = function() {
    var t = this.length;
    if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var e = 0; e < t; e += 4)ah(this, e, e + 3), ah(this, e + 1, e + 2);
    return this;
}, Ql.prototype.swap64 = function() {
    var t = this.length;
    if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var e = 0; e < t; e += 8)ah(this, e, e + 7), ah(this, e + 1, e + 6), ah(this, e + 2, e + 5), ah(this, e + 3, e + 4);
    return this;
}, Ql.prototype.toString = function() {
    var t = 0 | this.length;
    return 0 === t ? "" : 0 === arguments.length ? bh(this, 0, t) : sh.apply(this, arguments);
}, Ql.prototype.equals = function(t) {
    if (!rh(t)) throw new TypeError("Argument must be a Buffer");
    return this === t || 0 === Ql.compare(this, t);
}, Ql.prototype.inspect = function() {
    var t = "";
    return this.length > 0 && (t = this.toString("hex", 0, 50).match(/.{2}/g).join(" "), this.length > 50 && (t += " ... ")), "<Buffer " + t + ">";
}, Ql.prototype.compare = function(t, e, i, n, r) {
    if (!rh(t)) throw new TypeError("Argument must be a Buffer");
    if (void 0 === e && (e = 0), void 0 === i && (i = t ? t.length : 0), void 0 === n && (n = 0), void 0 === r && (r = this.length), e < 0 || i > t.length || n < 0 || r > this.length) throw new RangeError("out of range index");
    if (n >= r && e >= i) return 0;
    if (n >= r) return -1;
    if (e >= i) return 1;
    if (this === t) return 0;
    for(var o = (r >>>= 0) - (n >>>= 0), s = (i >>>= 0) - (e >>>= 0), a = Math.min(o, s), l = this.slice(n, r), h = t.slice(e, i), c = 0; c < a; ++c)if (l[c] !== h[c]) {
        o = l[c], s = h[c];
        break;
    }
    return o < s ? -1 : s < o ? 1 : 0;
}, Ql.prototype.includes = function(t, e, i) {
    return -1 !== this.indexOf(t, e, i);
}, Ql.prototype.indexOf = function(t, e, i) {
    return lh(this, t, e, i, !0);
}, Ql.prototype.lastIndexOf = function(t, e, i) {
    return lh(this, t, e, i, !1);
}, Ql.prototype.write = function(t, e, i, n) {
    if (void 0 === e) n = "utf8", i = this.length, e = 0;
    else if (void 0 === i && "string" == typeof e) n = e, i = this.length, e = 0;
    else {
        if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        e |= 0, isFinite(i) ? (i |= 0, void 0 === n && (n = "utf8")) : (n = i, i = void 0);
    }
    var r = this.length - e;
    if ((void 0 === i || i > r) && (i = r), t.length > 0 && (i < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    n || (n = "utf8");
    for(var o = !1;;)switch(n){
        case "hex":
            return ch(this, t, e, i);
        case "utf8":
        case "utf-8":
            return dh(this, t, e, i);
        case "ascii":
            return uh(this, t, e, i);
        case "latin1":
        case "binary":
            return ph(this, t, e, i);
        case "base64":
            return fh(this, t, e, i);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return gh(this, t, e, i);
        default:
            if (o) throw new TypeError("Unknown encoding: " + n);
            n = ("" + n).toLowerCase(), o = !0;
    }
}, Ql.prototype.toJSON = function() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
var yh = 4096;
function xh(t, e, i) {
    var n = "";
    i = Math.min(t.length, i);
    for(var r = e; r < i; ++r)n += String.fromCharCode(127 & t[r]);
    return n;
}
function vh(t, e, i) {
    var n = "";
    i = Math.min(t.length, i);
    for(var r = e; r < i; ++r)n += String.fromCharCode(t[r]);
    return n;
}
function wh(t, e, i) {
    var n = t.length;
    (!e || e < 0) && (e = 0), (!i || i < 0 || i > n) && (i = n);
    for(var r = "", o = e; o < i; ++o)r += Lh(t[o]);
    return r;
}
function Ch(t, e, i) {
    for(var n = t.slice(e, i), r = "", o = 0; o < n.length; o += 2)r += String.fromCharCode(n[o] + 256 * n[o + 1]);
    return r;
}
function Sh(t, e, i) {
    if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
    if (t + e > i) throw new RangeError("Trying to access beyond buffer length");
}
function kh(t, e, i, n, r, o) {
    if (!rh(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (e > r || e < o) throw new RangeError('"value" argument is out of bounds');
    if (i + n > t.length) throw new RangeError("Index out of range");
}
function Ah(t, e, i, n) {
    e < 0 && (e = 65535 + e + 1);
    for(var r = 0, o = Math.min(t.length - i, 2); r < o; ++r)t[i + r] = (e & 255 << 8 * (n ? r : 1 - r)) >>> 8 * (n ? r : 1 - r);
}
function Eh(t, e, i, n) {
    e < 0 && (e = 4294967295 + e + 1);
    for(var r = 0, o = Math.min(t.length - i, 4); r < o; ++r)t[i + r] = e >>> 8 * (n ? r : 3 - r) & 255;
}
function Mh(t, e, i, n, r, o) {
    if (i + n > t.length) throw new RangeError("Index out of range");
    if (i < 0) throw new RangeError("Index out of range");
}
function Th(t, e, i, n, r) {
    return r || Mh(t, 0, i, 4), ql(t, e, i, n, 23, 4), i + 4;
}
function Ph(t, e, i, n, r) {
    return r || Mh(t, 0, i, 8), ql(t, e, i, n, 52, 8), i + 8;
}
Ql.prototype.slice = function(t, e) {
    var i, n = this.length;
    if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), Ql.TYPED_ARRAY_SUPPORT) (i = this.subarray(t, e)).__proto__ = Ql.prototype;
    else {
        var r = e - t;
        i = new Ql(r, void 0);
        for(var o = 0; o < r; ++o)i[o] = this[o + t];
    }
    return i;
}, Ql.prototype.readUIntLE = function(t, e, i) {
    t |= 0, e |= 0, i || Sh(t, e, this.length);
    for(var n = this[t], r = 1, o = 0; ++o < e && (r *= 256);)n += this[t + o] * r;
    return n;
}, Ql.prototype.readUIntBE = function(t, e, i) {
    t |= 0, e |= 0, i || Sh(t, e, this.length);
    for(var n = this[t + --e], r = 1; e > 0 && (r *= 256);)n += this[t + --e] * r;
    return n;
}, Ql.prototype.readUInt8 = function(t, e) {
    return e || Sh(t, 1, this.length), this[t];
}, Ql.prototype.readUInt16LE = function(t, e) {
    return e || Sh(t, 2, this.length), this[t] | this[t + 1] << 8;
}, Ql.prototype.readUInt16BE = function(t, e) {
    return e || Sh(t, 2, this.length), this[t] << 8 | this[t + 1];
}, Ql.prototype.readUInt32LE = function(t, e) {
    return e || Sh(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
}, Ql.prototype.readUInt32BE = function(t, e) {
    return e || Sh(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
}, Ql.prototype.readIntLE = function(t, e, i) {
    t |= 0, e |= 0, i || Sh(t, e, this.length);
    for(var n = this[t], r = 1, o = 0; ++o < e && (r *= 256);)n += this[t + o] * r;
    return n >= (r *= 128) && (n -= Math.pow(2, 8 * e)), n;
}, Ql.prototype.readIntBE = function(t, e, i) {
    t |= 0, e |= 0, i || Sh(t, e, this.length);
    for(var n = e, r = 1, o = this[t + --n]; n > 0 && (r *= 256);)o += this[t + --n] * r;
    return o >= (r *= 128) && (o -= Math.pow(2, 8 * e)), o;
}, Ql.prototype.readInt8 = function(t, e) {
    return e || Sh(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
}, Ql.prototype.readInt16LE = function(t, e) {
    e || Sh(t, 2, this.length);
    var i = this[t] | this[t + 1] << 8;
    return 32768 & i ? 4294901760 | i : i;
}, Ql.prototype.readInt16BE = function(t, e) {
    e || Sh(t, 2, this.length);
    var i = this[t + 1] | this[t] << 8;
    return 32768 & i ? 4294901760 | i : i;
}, Ql.prototype.readInt32LE = function(t, e) {
    return e || Sh(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
}, Ql.prototype.readInt32BE = function(t, e) {
    return e || Sh(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
}, Ql.prototype.readFloatLE = function(t, e) {
    return e || Sh(t, 4, this.length), Gl(this, t, !0, 23, 4);
}, Ql.prototype.readFloatBE = function(t, e) {
    return e || Sh(t, 4, this.length), Gl(this, t, !1, 23, 4);
}, Ql.prototype.readDoubleLE = function(t, e) {
    return e || Sh(t, 8, this.length), Gl(this, t, !0, 52, 8);
}, Ql.prototype.readDoubleBE = function(t, e) {
    return e || Sh(t, 8, this.length), Gl(this, t, !1, 52, 8);
}, Ql.prototype.writeUIntLE = function(t, e, i, n) {
    (t = +t, e |= 0, i |= 0, n) || kh(this, t, e, i, Math.pow(2, 8 * i) - 1, 0);
    var r = 1, o = 0;
    for(this[e] = 255 & t; ++o < i && (r *= 256);)this[e + o] = t / r & 255;
    return e + i;
}, Ql.prototype.writeUIntBE = function(t, e, i, n) {
    (t = +t, e |= 0, i |= 0, n) || kh(this, t, e, i, Math.pow(2, 8 * i) - 1, 0);
    var r = i - 1, o = 1;
    for(this[e + r] = 255 & t; --r >= 0 && (o *= 256);)this[e + r] = t / o & 255;
    return e + i;
}, Ql.prototype.writeUInt8 = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 1, 255, 0), Ql.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
}, Ql.prototype.writeUInt16LE = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 2, 65535, 0), Ql.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : Ah(this, t, e, !0), e + 2;
}, Ql.prototype.writeUInt16BE = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 2, 65535, 0), Ql.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : Ah(this, t, e, !1), e + 2;
}, Ql.prototype.writeUInt32LE = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 4, 4294967295, 0), Ql.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : Eh(this, t, e, !0), e + 4;
}, Ql.prototype.writeUInt32BE = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 4, 4294967295, 0), Ql.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : Eh(this, t, e, !1), e + 4;
}, Ql.prototype.writeIntLE = function(t, e, i, n) {
    if (t = +t, e |= 0, !n) {
        var r = Math.pow(2, 8 * i - 1);
        kh(this, t, e, i, r - 1, -r);
    }
    var o = 0, s = 1, a = 0;
    for(this[e] = 255 & t; ++o < i && (s *= 256);)t < 0 && 0 === a && 0 !== this[e + o - 1] && (a = 1), this[e + o] = (t / s | 0) - a & 255;
    return e + i;
}, Ql.prototype.writeIntBE = function(t, e, i, n) {
    if (t = +t, e |= 0, !n) {
        var r = Math.pow(2, 8 * i - 1);
        kh(this, t, e, i, r - 1, -r);
    }
    var o = i - 1, s = 1, a = 0;
    for(this[e + o] = 255 & t; --o >= 0 && (s *= 256);)t < 0 && 0 === a && 0 !== this[e + o + 1] && (a = 1), this[e + o] = (t / s | 0) - a & 255;
    return e + i;
}, Ql.prototype.writeInt8 = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 1, 127, -128), Ql.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
}, Ql.prototype.writeInt16LE = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 2, 32767, -32768), Ql.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : Ah(this, t, e, !0), e + 2;
}, Ql.prototype.writeInt16BE = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 2, 32767, -32768), Ql.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : Ah(this, t, e, !1), e + 2;
}, Ql.prototype.writeInt32LE = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 4, 2147483647, -2147483648), Ql.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : Eh(this, t, e, !0), e + 4;
}, Ql.prototype.writeInt32BE = function(t, e, i) {
    return t = +t, e |= 0, i || kh(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), Ql.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : Eh(this, t, e, !1), e + 4;
}, Ql.prototype.writeFloatLE = function(t, e, i) {
    return Th(this, t, e, !0, i);
}, Ql.prototype.writeFloatBE = function(t, e, i) {
    return Th(this, t, e, !1, i);
}, Ql.prototype.writeDoubleLE = function(t, e, i) {
    return Ph(this, t, e, !0, i);
}, Ql.prototype.writeDoubleBE = function(t, e, i) {
    return Ph(this, t, e, !1, i);
}, Ql.prototype.copy = function(t, e, i, n) {
    if (i || (i = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < i && (n = i), n === i) return 0;
    if (0 === t.length || 0 === this.length) return 0;
    if (e < 0) throw new RangeError("targetStart out of bounds");
    if (i < 0 || i >= this.length) throw new RangeError("sourceStart out of bounds");
    if (n < 0) throw new RangeError("sourceEnd out of bounds");
    n > this.length && (n = this.length), t.length - e < n - i && (n = t.length - e + i);
    var r, o = n - i;
    if (this === t && i < e && e < n) for(r = o - 1; r >= 0; --r)t[r + e] = this[r + i];
    else if (o < 1e3 || !Ql.TYPED_ARRAY_SUPPORT) for(r = 0; r < o; ++r)t[r + e] = this[r + i];
    else Uint8Array.prototype.set.call(t, this.subarray(i, i + o), e);
    return o;
}, Ql.prototype.fill = function(t, e, i, n) {
    if ("string" == typeof t) {
        if ("string" == typeof e ? (n = e, e = 0, i = this.length) : "string" == typeof i && (n = i, i = this.length), 1 === t.length) {
            var r = t.charCodeAt(0);
            r < 256 && (t = r);
        }
        if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
        if ("string" == typeof n && !Ql.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
    } else "number" == typeof t && (t &= 255);
    if (e < 0 || this.length < e || this.length < i) throw new RangeError("Out of range index");
    if (i <= e) return this;
    var o;
    if (e >>>= 0, i = void 0 === i ? this.length : i >>> 0, t || (t = 0), "number" == typeof t) for(o = e; o < i; ++o)this[o] = t;
    else {
        var s = rh(t) ? t : Oh(new Ql(t, n).toString()), a = s.length;
        for(o = 0; o < i - e; ++o)this[o + e] = s[o % a];
    }
    return this;
};
var Rh = /[^+\/0-9A-Za-z-_]/g;
function Lh(t) {
    return t < 16 ? "0" + t.toString(16) : t.toString(16);
}
function Oh(t, e) {
    var i;
    e = e || 1 / 0;
    for(var n = t.length, r = null, o = [], s = 0; s < n; ++s){
        if ((i = t.charCodeAt(s)) > 55295 && i < 57344) {
            if (!r) {
                if (i > 56319) {
                    (e -= 3) > -1 && o.push(239, 191, 189);
                    continue;
                }
                if (s + 1 === n) {
                    (e -= 3) > -1 && o.push(239, 191, 189);
                    continue;
                }
                r = i;
                continue;
            }
            if (i < 56320) {
                (e -= 3) > -1 && o.push(239, 191, 189), r = i;
                continue;
            }
            i = 65536 + (r - 55296 << 10 | i - 56320);
        } else r && (e -= 3) > -1 && o.push(239, 191, 189);
        if (r = null, i < 128) {
            if ((e -= 1) < 0) break;
            o.push(i);
        } else if (i < 2048) {
            if ((e -= 2) < 0) break;
            o.push(i >> 6 | 192, 63 & i | 128);
        } else if (i < 65536) {
            if ((e -= 3) < 0) break;
            o.push(i >> 12 | 224, i >> 6 & 63 | 128, 63 & i | 128);
        } else {
            if (!(i < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            o.push(i >> 18 | 240, i >> 12 & 63 | 128, i >> 6 & 63 | 128, 63 & i | 128);
        }
    }
    return o;
}
function Dh(t) {
    return function(t) {
        var e, i, n, r, o, s;
        Wl || Yl();
        var a = t.length;
        if (a % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        o = "=" === t[a - 2] ? 2 : "=" === t[a - 1] ? 1 : 0, s = new Ul(3 * a / 4 - o), n = o > 0 ? a - 4 : a;
        var l = 0;
        for(e = 0, i = 0; e < n; e += 4, i += 3)r = Hl[t.charCodeAt(e)] << 18 | Hl[t.charCodeAt(e + 1)] << 12 | Hl[t.charCodeAt(e + 2)] << 6 | Hl[t.charCodeAt(e + 3)], s[l++] = r >> 16 & 255, s[l++] = r >> 8 & 255, s[l++] = 255 & r;
        return 2 === o ? (r = Hl[t.charCodeAt(e)] << 2 | Hl[t.charCodeAt(e + 1)] >> 4, s[l++] = 255 & r) : 1 === o && (r = Hl[t.charCodeAt(e)] << 10 | Hl[t.charCodeAt(e + 1)] << 4 | Hl[t.charCodeAt(e + 2)] >> 2, s[l++] = r >> 8 & 255, s[l++] = 255 & r), s;
    }(function(t) {
        if ((t = (function(t) {
            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
        })(t).replace(Rh, "")).length < 2) return "";
        for(; t.length % 4 != 0;)t += "=";
        return t;
    }(t));
}
function jh(t, e, i, n) {
    for(var r = 0; r < n && !(r + i >= e.length || r >= t.length); ++r)e[r + i] = t[r];
    return r;
}
function Nh(t) {
    return !!t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
}
function Ih() {
    throw new Error("setTimeout has not been defined");
}
function Bh() {
    throw new Error("clearTimeout has not been defined");
}
var Fh = Ih, zh = Bh;
function Hh(t) {
    if (Fh === setTimeout) return setTimeout(t, 0);
    if ((Fh === Ih || !Fh) && setTimeout) return Fh = setTimeout, setTimeout(t, 0);
    try {
        return Fh(t, 0);
    } catch (e) {
        try {
            return Fh.call(null, t, 0);
        } catch (e) {
            return Fh.call(this, t, 0);
        }
    }
}
"function" == typeof t.setTimeout && (Fh = setTimeout), "function" == typeof t.clearTimeout && (zh = clearTimeout);
var Uh, Wh = [], Yh = !1, _h = -1;
function Xh() {
    Yh && Uh && (Yh = !1, Uh.length ? Wh = Uh.concat(Wh) : _h = -1, Wh.length && Gh());
}
function Gh() {
    if (!Yh) {
        var t = Hh(Xh);
        Yh = !0;
        for(var e = Wh.length; e;){
            for(Uh = Wh, Wh = []; ++_h < e;)Uh && Uh[_h].run();
            _h = -1, e = Wh.length;
        }
        Uh = null, Yh = !1, function(t) {
            if (zh === clearTimeout) return clearTimeout(t);
            if ((zh === Bh || !zh) && clearTimeout) return zh = clearTimeout, clearTimeout(t);
            try {
                return zh(t);
            } catch (e) {
                try {
                    return zh.call(null, t);
                } catch (e) {
                    return zh.call(this, t);
                }
            }
        }(t);
    }
}
function qh(t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)e[i - 1] = arguments[i];
    Wh.push(new Vh(t, e)), 1 !== Wh.length || Yh || Hh(Gh);
}
function Vh(t, e) {
    this.fun = t, this.array = e;
}
Vh.prototype.run = function() {
    this.fun.apply(null, this.array);
};
function $h() {}
var Kh = $h, Zh = $h, Qh = $h, Jh = $h, tc = $h, ec = $h, ic = $h;
var nc = t.performance || {}, rc = nc.now || nc.mozNow || nc.msNow || nc.oNow || nc.webkitNow || function() {
    return (new Date).getTime();
};
var oc = new Date;
var sc, ac = {
    nextTick: qh,
    title: "browser",
    browser: !0,
    env: {},
    argv: [],
    version: "",
    versions: {},
    on: Kh,
    addListener: Zh,
    once: Qh,
    off: Jh,
    removeListener: tc,
    removeAllListeners: ec,
    emit: ic,
    binding: function(t) {
        throw new Error("process.binding is not supported");
    },
    cwd: function() {
        return "/";
    },
    chdir: function(t) {
        throw new Error("process.chdir is not supported");
    },
    umask: function() {
        return 0;
    },
    hrtime: function(t) {
        var e = .001 * rc.call(nc), i = Math.floor(e), n = Math.floor(e % 1 * 1e9);
        return t && (i -= t[0], (n -= t[1]) < 0 && (i--, n += 1e9)), [
            i,
            n
        ];
    },
    platform: "browser",
    release: {},
    config: {},
    uptime: function() {
        return (new Date - oc) / 1e3;
    }
};
sc = "function" == typeof Object.create ? function(t, e) {
    t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    });
} : function(t, e) {
    t.super_ = e;
    var i = function() {};
    i.prototype = e.prototype, t.prototype = new i, t.prototype.constructor = t;
};
var lc = /%[sdj%]/g;
function hc(t) {
    if (!wc(t)) {
        for(var e = [], i = 0; i < arguments.length; i++)e.push(pc(arguments[i]));
        return e.join(" ");
    }
    i = 1;
    for(var n = arguments, r = n.length, o = String(t).replace(lc, function(t) {
        if ("%%" === t) return "%";
        if (i >= r) return t;
        switch(t){
            case "%s":
                return String(n[i++]);
            case "%d":
                return Number(n[i++]);
            case "%j":
                try {
                    return JSON.stringify(n[i++]);
                } catch (t) {
                    return "[Circular]";
                }
            default:
                return t;
        }
    }), s = n[i]; i < r; s = n[++i])vc(s) || !kc(s) ? o += " " + s : o += " " + pc(s);
    return o;
}
function cc(e, i) {
    if (Cc(t.process)) return function() {
        return cc(e, i).apply(this, arguments);
    };
    if (!0 === ac.noDeprecation) return e;
    var n = !1;
    return function() {
        if (!n) {
            if (ac.throwDeprecation) throw new Error(i);
            ac.traceDeprecation ? console.trace(i) : console.error(i), n = !0;
        }
        return e.apply(this, arguments);
    };
}
var dc, uc = {};
function pc(t, e) {
    var i = {
        seen: [],
        stylize: gc
    };
    return arguments.length >= 3 && (i.depth = arguments[2]), arguments.length >= 4 && (i.colors = arguments[3]), xc(e) ? i.showHidden = e : e && function(t, e) {
        if (!e || !kc(e)) return t;
        var i = Object.keys(e), n = i.length;
        for(; n--;)t[i[n]] = e[i[n]];
    }(i, e), Cc(i.showHidden) && (i.showHidden = !1), Cc(i.depth) && (i.depth = 2), Cc(i.colors) && (i.colors = !1), Cc(i.customInspect) && (i.customInspect = !0), i.colors && (i.stylize = fc), mc(i, t, i.depth);
}
function fc(t, e) {
    var i = pc.styles[e];
    return i ? "[" + pc.colors[i][0] + "m" + t + "[" + pc.colors[i][1] + "m" : t;
}
function gc(t, e) {
    return t;
}
function mc(t, e, i) {
    if (t.customInspect && e && Mc(e.inspect) && e.inspect !== pc && (!e.constructor || e.constructor.prototype !== e)) {
        var n = e.inspect(i, t);
        return wc(n) || (n = mc(t, n, i)), n;
    }
    var r = function(t, e) {
        if (Cc(e)) return t.stylize("undefined", "undefined");
        if (wc(e)) {
            var i = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
            return t.stylize(i, "string");
        }
        if (n = e, "number" == typeof n) return t.stylize("" + e, "number");
        var n;
        if (xc(e)) return t.stylize("" + e, "boolean");
        if (vc(e)) return t.stylize("null", "null");
    }(t, e);
    if (r) return r;
    var o = Object.keys(e), s = function(t) {
        var e = {};
        return t.forEach(function(t, i) {
            e[t] = !0;
        }), e;
    }(o);
    if (t.showHidden && (o = Object.getOwnPropertyNames(e)), Ec(e) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return bc(e);
    if (0 === o.length) {
        if (Mc(e)) {
            var a = e.name ? ": " + e.name : "";
            return t.stylize("[Function" + a + "]", "special");
        }
        if (Sc(e)) return t.stylize(RegExp.prototype.toString.call(e), "regexp");
        if (Ac(e)) return t.stylize(Date.prototype.toString.call(e), "date");
        if (Ec(e)) return bc(e);
    }
    var l, h, c = "", d = !1, u = [
        "{",
        "}"
    ];
    (l = e, Array.isArray(l) && (d = !0, u = [
        "[",
        "]"
    ]), Mc(e)) && (c = " [Function" + (e.name ? ": " + e.name : "") + "]");
    return Sc(e) && (c = " " + RegExp.prototype.toString.call(e)), Ac(e) && (c = " " + Date.prototype.toUTCString.call(e)), Ec(e) && (c = " " + bc(e)), 0 !== o.length || d && 0 != e.length ? i < 0 ? Sc(e) ? t.stylize(RegExp.prototype.toString.call(e), "regexp") : t.stylize("[Object]", "special") : (t.seen.push(e), h = d ? function(t, e, i, n, r) {
        for(var o = [], s = 0, a = e.length; s < a; ++s)Pc(e, String(s)) ? o.push(yc(t, e, i, n, String(s), !0)) : o.push("");
        return r.forEach(function(r) {
            r.match(/^\d+$/) || o.push(yc(t, e, i, n, r, !0));
        }), o;
    }(t, e, i, s, o) : o.map(function(n) {
        return yc(t, e, i, s, n, d);
    }), t.seen.pop(), function(t, e, i) {
        var n = t.reduce(function(t, e) {
            return e.indexOf("\n"), t + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0);
        if (n > 60) return i[0] + ("" === e ? "" : e + "\n ") + " " + t.join(",\n  ") + " " + i[1];
        return i[0] + e + " " + t.join(", ") + " " + i[1];
    }(h, c, u)) : u[0] + c + u[1];
}
function bc(t) {
    return "[" + Error.prototype.toString.call(t) + "]";
}
function yc(t, e, i, n, r, o) {
    var s, a, l;
    if ((l = Object.getOwnPropertyDescriptor(e, r) || {
        value: e[r]
    }).get ? a = l.set ? t.stylize("[Getter/Setter]", "special") : t.stylize("[Getter]", "special") : l.set && (a = t.stylize("[Setter]", "special")), Pc(n, r) || (s = "[" + r + "]"), a || (t.seen.indexOf(l.value) < 0 ? (a = vc(i) ? mc(t, l.value, null) : mc(t, l.value, i - 1)).indexOf("\n") > -1 && (a = o ? a.split("\n").map(function(t) {
        return "  " + t;
    }).join("\n").substr(2) : "\n" + a.split("\n").map(function(t) {
        return "   " + t;
    }).join("\n")) : a = t.stylize("[Circular]", "special")), Cc(s)) {
        if (o && r.match(/^\d+$/)) return a;
        (s = JSON.stringify("" + r)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = t.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = t.stylize(s, "string"));
    }
    return s + ": " + a;
}
function xc(t) {
    return "boolean" == typeof t;
}
function vc(t) {
    return null === t;
}
function wc(t) {
    return "string" == typeof t;
}
function Cc(t) {
    return void 0 === t;
}
function Sc(t) {
    return kc(t) && "[object RegExp]" === Tc(t);
}
function kc(t) {
    return "object" == typeof t && null !== t;
}
function Ac(t) {
    return kc(t) && "[object Date]" === Tc(t);
}
function Ec(t) {
    return kc(t) && ("[object Error]" === Tc(t) || t instanceof Error);
}
function Mc(t) {
    return "function" == typeof t;
}
function Tc(t) {
    return Object.prototype.toString.call(t);
}
function Pc(t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
}
function Rc() {
    this.head = null, this.tail = null, this.length = 0;
}
pc.colors = {
    bold: [
        1,
        22
    ],
    italic: [
        3,
        23
    ],
    underline: [
        4,
        24
    ],
    inverse: [
        7,
        27
    ],
    white: [
        37,
        39
    ],
    grey: [
        90,
        39
    ],
    black: [
        30,
        39
    ],
    blue: [
        34,
        39
    ],
    cyan: [
        36,
        39
    ],
    green: [
        32,
        39
    ],
    magenta: [
        35,
        39
    ],
    red: [
        31,
        39
    ],
    yellow: [
        33,
        39
    ]
}, pc.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    regexp: "red"
}, Rc.prototype.push = function(t) {
    var e = {
        data: t,
        next: null
    };
    this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
}, Rc.prototype.unshift = function(t) {
    var e = {
        data: t,
        next: this.head
    };
    0 === this.length && (this.tail = e), this.head = e, ++this.length;
}, Rc.prototype.shift = function() {
    if (0 !== this.length) {
        var t = this.head.data;
        return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
    }
}, Rc.prototype.clear = function() {
    this.head = this.tail = null, this.length = 0;
}, Rc.prototype.join = function(t) {
    if (0 === this.length) return "";
    for(var e = this.head, i = "" + e.data; e = e.next;)i += t + e.data;
    return i;
}, Rc.prototype.concat = function(t) {
    if (0 === this.length) return Ql.alloc(0);
    if (1 === this.length) return this.head.data;
    for(var e = Ql.allocUnsafe(t >>> 0), i = this.head, n = 0; i;)i.data.copy(e, n), n += i.data.length, i = i.next;
    return e;
};
var Lc = Ql.isEncoding || function(t) {
    switch(t && t.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return !0;
        default:
            return !1;
    }
};
function Oc(t) {
    switch(this.encoding = (t || "utf8").toLowerCase().replace(/[-_]/, ""), function(t) {
        if (t && !Lc(t)) throw new Error("Unknown encoding: " + t);
    }(t), this.encoding){
        case "utf8":
            this.surrogateSize = 3;
            break;
        case "ucs2":
        case "utf16le":
            this.surrogateSize = 2, this.detectIncompleteChar = jc;
            break;
        case "base64":
            this.surrogateSize = 3, this.detectIncompleteChar = Nc;
            break;
        default:
            return void (this.write = Dc);
    }
    this.charBuffer = new Ql(6), this.charReceived = 0, this.charLength = 0;
}
function Dc(t) {
    return t.toString(this.encoding);
}
function jc(t) {
    this.charReceived = t.length % 2, this.charLength = this.charReceived ? 2 : 0;
}
function Nc(t) {
    this.charReceived = t.length % 3, this.charLength = this.charReceived ? 3 : 0;
}
Oc.prototype.write = function(t) {
    for(var e = ""; this.charLength;){
        var i = t.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : t.length;
        if (t.copy(this.charBuffer, this.charReceived, 0, i), this.charReceived += i, this.charReceived < this.charLength) return "";
        if (t = t.slice(i, t.length), !((r = (e = this.charBuffer.slice(0, this.charLength).toString(this.encoding)).charCodeAt(e.length - 1)) >= 55296 && r <= 56319)) {
            if (this.charReceived = this.charLength = 0, 0 === t.length) return e;
            break;
        }
        this.charLength += this.surrogateSize, e = "";
    }
    this.detectIncompleteChar(t);
    var n = t.length;
    this.charLength && (t.copy(this.charBuffer, 0, t.length - this.charReceived, n), n -= this.charReceived);
    var r;
    n = (e += t.toString(this.encoding, 0, n)).length - 1;
    if ((r = e.charCodeAt(n)) >= 55296 && r <= 56319) {
        var o = this.surrogateSize;
        return this.charLength += o, this.charReceived += o, this.charBuffer.copy(this.charBuffer, o, 0, o), t.copy(this.charBuffer, 0, 0, o), e.substring(0, n);
    }
    return e;
}, Oc.prototype.detectIncompleteChar = function(t) {
    for(var e = t.length >= 3 ? 3 : t.length; e > 0; e--){
        var i = t[t.length - e];
        if (1 == e && i >> 5 == 6) {
            this.charLength = 2;
            break;
        }
        if (e <= 2 && i >> 4 == 14) {
            this.charLength = 3;
            break;
        }
        if (e <= 3 && i >> 3 == 30) {
            this.charLength = 4;
            break;
        }
    }
    this.charReceived = e;
}, Oc.prototype.end = function(t) {
    var e = "";
    if (t && t.length && (e = this.write(t)), this.charReceived) {
        var i = this.charReceived, n = this.charBuffer, r = this.encoding;
        e += n.slice(0, i).toString(r);
    }
    return e;
}, Fc.ReadableState = Bc;
var Ic = function(t) {
    if (Cc(dc) && (dc = ac.env.NODE_DEBUG || ""), t = t.toUpperCase(), !uc[t]) {
        if (new RegExp("\\b" + t + "\\b", "i").test(dc)) uc[t] = function() {
            var e = hc.apply(null, arguments);
            console.error("%s %d: %s", t, 0, e);
        };
        else uc[t] = function() {};
    }
    return uc[t];
}("stream");
function Bc(t, e) {
    t = t || {}, this.objectMode = !!t.objectMode, e instanceof ud && (this.objectMode = this.objectMode || !!t.readableObjectMode);
    var i = t.highWaterMark, n = this.objectMode ? 16 : 16384;
    this.highWaterMark = i || 0 === i ? i : n, this.highWaterMark = ~~this.highWaterMark, this.buffer = new Rc, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (this.decoder = new Oc(t.encoding), this.encoding = t.encoding);
}
function Fc(t) {
    if (!(this instanceof Fc)) return new Fc(t);
    this._readableState = new Bc(t, this), this.readable = !0, t && "function" == typeof t.read && (this._read = t.read), Dl.call(this);
}
function zc(t, e, i, n, r) {
    var o = function(t, e) {
        var i = null;
        Ql.isBuffer(e) || "string" == typeof e || null == e || t.objectMode || (i = new TypeError("Invalid non-string/buffer chunk"));
        return i;
    }(e, i);
    if (o) t.emit("error", o);
    else if (null === i) e.reading = !1, function(t, e) {
        if (e.ended) return;
        if (e.decoder) {
            var i = e.decoder.end();
            i && i.length && (e.buffer.push(i), e.length += e.objectMode ? 1 : i.length);
        }
        e.ended = !0, Wc(t);
    }(t, e);
    else if (e.objectMode || i && i.length > 0) {
        if (e.ended && !r) {
            var s = new Error("stream.push() after EOF");
            t.emit("error", s);
        } else if (e.endEmitted && r) {
            var a = new Error("stream.unshift() after end event");
            t.emit("error", a);
        } else {
            var l;
            !e.decoder || r || n || (i = e.decoder.write(i), l = !e.objectMode && 0 === i.length), r || (e.reading = !1), l || (e.flowing && 0 === e.length && !e.sync ? (t.emit("data", i), t.read(0)) : (e.length += e.objectMode ? 1 : i.length, r ? e.buffer.unshift(i) : e.buffer.push(i), e.needReadable && Wc(t))), function(t, e) {
                e.readingMore || (e.readingMore = !0, qh(_c, t, e));
            }(t, e);
        }
    } else r || (e.reading = !1);
    return function(t) {
        return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
    }(e);
}
sc(Fc, Dl), Fc.prototype.push = function(t, e) {
    var i = this._readableState;
    return i.objectMode || "string" != typeof t || (e = e || i.defaultEncoding) !== i.encoding && (t = Ql.from(t, e), e = ""), zc(this, i, t, e, !1);
}, Fc.prototype.unshift = function(t) {
    return zc(this, this._readableState, t, "", !0);
}, Fc.prototype.isPaused = function() {
    return !1 === this._readableState.flowing;
}, Fc.prototype.setEncoding = function(t) {
    return this._readableState.decoder = new Oc(t), this._readableState.encoding = t, this;
};
var Hc = 8388608;
function Uc(t, e) {
    return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function(t) {
        return t >= Hc ? t = Hc : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
    }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
}
function Wc(t) {
    var e = t._readableState;
    e.needReadable = !1, e.emittedReadable || (Ic("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? qh(Yc, t) : Yc(t));
}
function Yc(t) {
    Ic("emit readable"), t.emit("readable"), qc(t);
}
function _c(t, e) {
    for(var i = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (Ic("maybeReadMore read 0"), t.read(0), i !== e.length);)i = e.length;
    e.readingMore = !1;
}
function Xc(t) {
    Ic("readable nexttick read 0"), t.read(0);
}
function Gc(t, e) {
    e.reading || (Ic("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), qc(t), e.flowing && !e.reading && t.read(0);
}
function qc(t) {
    var e = t._readableState;
    for(Ic("flow", e.flowing); e.flowing && null !== t.read(););
}
function Vc(t, e) {
    var i;
    return 0 === e.length ? null : (e.objectMode ? i = e.buffer.shift() : !t || t >= e.length ? (i = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : i = function(t, e, i) {
        var n;
        t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : n = t === e.head.data.length ? e.shift() : i ? function(t, e) {
            var i = e.head, n = 1, r = i.data;
            t -= r.length;
            for(; i = i.next;){
                var o = i.data, s = t > o.length ? o.length : t;
                if (s === o.length ? r += o : r += o.slice(0, t), 0 === (t -= s)) {
                    s === o.length ? (++n, i.next ? e.head = i.next : e.head = e.tail = null) : (e.head = i, i.data = o.slice(s));
                    break;
                }
                ++n;
            }
            return e.length -= n, r;
        }(t, e) : function(t, e) {
            var i = Ql.allocUnsafe(t), n = e.head, r = 1;
            n.data.copy(i), t -= n.data.length;
            for(; n = n.next;){
                var o = n.data, s = t > o.length ? o.length : t;
                if (o.copy(i, i.length - t, 0, s), 0 === (t -= s)) {
                    s === o.length ? (++r, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(s));
                    break;
                }
                ++r;
            }
            return e.length -= r, i;
        }(t, e);
        return n;
    }(t, e.buffer, e.decoder), i);
}
function $c(t) {
    var e = t._readableState;
    if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    e.endEmitted || (e.ended = !0, qh(Kc, e, t));
}
function Kc(t, e) {
    t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
}
function Zc(t, e) {
    for(var i = 0, n = t.length; i < n; i++)if (t[i] === e) return i;
    return -1;
}
function Qc() {}
function Jc(t, e, i) {
    this.chunk = t, this.encoding = e, this.callback = i, this.next = null;
}
function td(t, e) {
    Object.defineProperty(this, "buffer", {
        get: cc(function() {
            return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
    }), t = t || {}, this.objectMode = !!t.objectMode, e instanceof ud && (this.objectMode = this.objectMode || !!t.writableObjectMode);
    var i = t.highWaterMark, n = this.objectMode ? 16 : 16384;
    this.highWaterMark = i || 0 === i ? i : n, this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
    var r = !1 === t.decodeStrings;
    this.decodeStrings = !r, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(t) {
        !function(t, e) {
            var i = t._writableState, n = i.sync, r = i.writecb;
            if (function(t) {
                t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
            }(i), e) !function(t, e, i, n, r) {
                --e.pendingcb, i ? qh(r, n) : r(n);
                t._writableState.errorEmitted = !0, t.emit("error", n);
            }(t, i, n, e, r);
            else {
                var o = od(i);
                o || i.corked || i.bufferProcessing || !i.bufferedRequest || rd(t, i), n ? qh(nd, t, i, o, r) : nd(t, i, o, r);
            }
        }(e, t);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new ld(this);
}
function ed(t) {
    if (!(this instanceof ed || this instanceof ud)) return new ed(t);
    this._writableState = new td(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev)), Dl.call(this);
}
function id(t, e, i, n, r, o, s) {
    e.writelen = n, e.writecb = s, e.writing = !0, e.sync = !0, i ? t._writev(r, e.onwrite) : t._write(r, o, e.onwrite), e.sync = !1;
}
function nd(t, e, i, n) {
    i || function(t, e) {
        0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
    }(t, e), e.pendingcb--, n(), ad(t, e);
}
function rd(t, e) {
    e.bufferProcessing = !0;
    var i = e.bufferedRequest;
    if (t._writev && i && i.next) {
        var n = e.bufferedRequestCount, r = new Array(n), o = e.corkedRequestsFree;
        o.entry = i;
        for(var s = 0; i;)r[s] = i, i = i.next, s += 1;
        id(t, e, !0, e.length, r, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new ld(e);
    } else {
        for(; i;){
            var a = i.chunk, l = i.encoding, h = i.callback;
            if (id(t, e, !1, e.objectMode ? 1 : a.length, a, l, h), i = i.next, e.writing) break;
        }
        null === i && (e.lastBufferedRequest = null);
    }
    e.bufferedRequestCount = 0, e.bufferedRequest = i, e.bufferProcessing = !1;
}
function od(t) {
    return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
}
function sd(t, e) {
    e.prefinished || (e.prefinished = !0, t.emit("prefinish"));
}
function ad(t, e) {
    var i = od(e);
    return i && (0 === e.pendingcb ? (sd(t, e), e.finished = !0, t.emit("finish")) : sd(t, e)), i;
}
function ld(t) {
    var e = this;
    this.next = null, this.entry = null, this.finish = function(i) {
        var n = e.entry;
        for(e.entry = null; n;){
            var r = n.callback;
            t.pendingcb--, r(i), n = n.next;
        }
        t.corkedRequestsFree ? t.corkedRequestsFree.next = e : t.corkedRequestsFree = e;
    };
}
Fc.prototype.read = function(t) {
    Ic("read", t), t = parseInt(t, 10);
    var e = this._readableState, i = t;
    if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return Ic("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? $c(this) : Wc(this), null;
    if (0 === (t = Uc(t, e)) && e.ended) return 0 === e.length && $c(this), null;
    var n, r = e.needReadable;
    return Ic("need readable", r), (0 === e.length || e.length - t < e.highWaterMark) && Ic("length less than watermark", r = !0), e.ended || e.reading ? Ic("reading or ended", r = !1) : r && (Ic("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = Uc(i, e))), null === (n = t > 0 ? Vc(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), i !== t && e.ended && $c(this)), null !== n && this.emit("data", n), n;
}, Fc.prototype._read = function(t) {
    this.emit("error", new Error("not implemented"));
}, Fc.prototype.pipe = function(t, e) {
    var i = this, n = this._readableState;
    switch(n.pipesCount){
        case 0:
            n.pipes = t;
            break;
        case 1:
            n.pipes = [
                n.pipes,
                t
            ];
            break;
        default:
            n.pipes.push(t);
    }
    n.pipesCount += 1, Ic("pipe count=%d opts=%j", n.pipesCount, e);
    var r = !e || !1 !== e.end ? s : h;
    function o(t) {
        Ic("onunpipe"), t === i && h();
    }
    function s() {
        Ic("onend"), t.end();
    }
    n.endEmitted ? qh(r) : i.once("end", r), t.on("unpipe", o);
    var a = function(t) {
        return function() {
            var e = t._readableState;
            Ic("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && t.listeners("data").length && (e.flowing = !0, qc(t));
        };
    }(i);
    t.on("drain", a);
    var l = !1;
    function h() {
        Ic("cleanup"), t.removeListener("close", p), t.removeListener("finish", f), t.removeListener("drain", a), t.removeListener("error", u), t.removeListener("unpipe", o), i.removeListener("end", s), i.removeListener("end", h), i.removeListener("data", d), l = !0, !n.awaitDrain || t._writableState && !t._writableState.needDrain || a();
    }
    var c = !1;
    function d(e) {
        Ic("ondata"), c = !1, !1 !== t.write(e) || c || ((1 === n.pipesCount && n.pipes === t || n.pipesCount > 1 && -1 !== Zc(n.pipes, t)) && !l && (Ic("false write response, pause", i._readableState.awaitDrain), i._readableState.awaitDrain++, c = !0), i.pause());
    }
    function u(e) {
        Ic("onerror", e), g(), t.removeListener("error", u), 0 === function(t, e) {
            return t.listeners(e).length;
        }(t, "error") && t.emit("error", e);
    }
    function p() {
        t.removeListener("finish", f), g();
    }
    function f() {
        Ic("onfinish"), t.removeListener("close", p), g();
    }
    function g() {
        Ic("unpipe"), i.unpipe(t);
    }
    return i.on("data", d), function(t, e, i) {
        if ("function" == typeof t.prependListener) return t.prependListener(e, i);
        t._events && t._events[e] ? Array.isArray(t._events[e]) ? t._events[e].unshift(i) : t._events[e] = [
            i,
            t._events[e]
        ] : t.on(e, i);
    }(t, "error", u), t.once("close", p), t.once("finish", f), t.emit("pipe", i), n.flowing || (Ic("pipe resume"), i.resume()), t;
}, Fc.prototype.unpipe = function(t) {
    var e = this._readableState;
    if (0 === e.pipesCount) return this;
    if (1 === e.pipesCount) return t && t !== e.pipes || (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this)), this;
    if (!t) {
        var i = e.pipes, n = e.pipesCount;
        e.pipes = null, e.pipesCount = 0, e.flowing = !1;
        for(var r = 0; r < n; r++)i[r].emit("unpipe", this);
        return this;
    }
    var o = Zc(e.pipes, t);
    return -1 === o || (e.pipes.splice(o, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this)), this;
}, Fc.prototype.on = function(t, e) {
    var i = Dl.prototype.on.call(this, t, e);
    if ("data" === t) !1 !== this._readableState.flowing && this.resume();
    else if ("readable" === t) {
        var n = this._readableState;
        n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && Wc(this) : qh(Xc, this));
    }
    return i;
}, Fc.prototype.addListener = Fc.prototype.on, Fc.prototype.resume = function() {
    var t = this._readableState;
    return t.flowing || (Ic("resume"), t.flowing = !0, function(t, e) {
        e.resumeScheduled || (e.resumeScheduled = !0, qh(Gc, t, e));
    }(this, t)), this;
}, Fc.prototype.pause = function() {
    return Ic("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (Ic("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
}, Fc.prototype.wrap = function(t) {
    var e = this._readableState, i = !1, n = this;
    for(var r in t.on("end", function() {
        if (Ic("wrapped end"), e.decoder && !e.ended) {
            var t = e.decoder.end();
            t && t.length && n.push(t);
        }
        n.push(null);
    }), t.on("data", function(r) {
        (Ic("wrapped data"), e.decoder && (r = e.decoder.write(r)), e.objectMode && null == r) || (e.objectMode || r && r.length) && (n.push(r) || (i = !0, t.pause()));
    }), t)void 0 === this[r] && "function" == typeof t[r] && (this[r] = function(e) {
        return function() {
            return t[e].apply(t, arguments);
        };
    }(r));
    return function(t, e) {
        for(var i = 0, n = t.length; i < n; i++)e(t[i], i);
    }([
        "error",
        "close",
        "destroy",
        "pause",
        "resume"
    ], function(e) {
        t.on(e, n.emit.bind(n, e));
    }), n._read = function(e) {
        Ic("wrapped _read", e), i && (i = !1, t.resume());
    }, n;
}, Fc._fromList = Vc, ed.WritableState = td, sc(ed, Dl), td.prototype.getBuffer = function() {
    for(var t = this.bufferedRequest, e = []; t;)e.push(t), t = t.next;
    return e;
}, ed.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
}, ed.prototype.write = function(t, e, i) {
    var n = this._writableState, r = !1;
    return "function" == typeof e && (i = e, e = null), Ql.isBuffer(t) ? e = "buffer" : e || (e = n.defaultEncoding), "function" != typeof i && (i = Qc), n.ended ? function(t, e) {
        var i = new Error("write after end");
        t.emit("error", i), qh(e, i);
    }(this, i) : function(t, e, i, n) {
        var r = !0, o = !1;
        return null === i ? o = new TypeError("May not write null values to stream") : Ql.isBuffer(i) || "string" == typeof i || void 0 === i || e.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (t.emit("error", o), qh(n, o), r = !1), r;
    }(this, n, t, i) && (n.pendingcb++, r = function(t, e, i, n, r) {
        i = function(t, e, i) {
            t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = Ql.from(e, i));
            return e;
        }(e, i, n), Ql.isBuffer(i) && (n = "buffer");
        var o = e.objectMode ? 1 : i.length;
        e.length += o;
        var s = e.length < e.highWaterMark;
        s || (e.needDrain = !0);
        if (e.writing || e.corked) {
            var a = e.lastBufferedRequest;
            e.lastBufferedRequest = new Jc(i, n, r), a ? a.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
        } else id(t, e, !1, o, i, n, r);
        return s;
    }(this, n, t, e, i)), r;
}, ed.prototype.cork = function() {
    this._writableState.corked++;
}, ed.prototype.uncork = function() {
    var t = this._writableState;
    t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || rd(this, t));
}, ed.prototype.setDefaultEncoding = function(t) {
    if ("string" == typeof t && (t = t.toLowerCase()), !([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
    return this._writableState.defaultEncoding = t, this;
}, ed.prototype._write = function(t, e, i) {
    i(new Error("not implemented"));
}, ed.prototype._writev = null, ed.prototype.end = function(t, e, i) {
    var n = this._writableState;
    "function" == typeof t ? (i = t, t = null, e = null) : "function" == typeof e && (i = e, e = null), null != t && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function(t, e, i) {
        e.ending = !0, ad(t, e), i && (e.finished ? qh(i) : t.once("finish", i));
        e.ended = !0, t.writable = !1;
    }(this, n, i);
}, sc(ud, Fc);
for(var hd = Object.keys(ed.prototype), cd = 0; cd < hd.length; cd++){
    var dd = hd[cd];
    ud.prototype[dd] || (ud.prototype[dd] = ed.prototype[dd]);
}
function ud(t) {
    if (!(this instanceof ud)) return new ud(t);
    Fc.call(this, t), ed.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", pd);
}
function pd() {
    this.allowHalfOpen || this._writableState.ended || qh(fd, this);
}
function fd(t) {
    t.end();
}
function gd(t) {
    this.afterTransform = function(e, i) {
        return function(t, e, i) {
            var n = t._transformState;
            n.transforming = !1;
            var r = n.writecb;
            if (!r) return t.emit("error", new Error("no writecb in Transform class"));
            n.writechunk = null, n.writecb = null, null != i && t.push(i);
            r(e);
            var o = t._readableState;
            o.reading = !1, (o.needReadable || o.length < o.highWaterMark) && t._read(o.highWaterMark);
        }(t, e, i);
    }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null, this.writeencoding = null;
}
function md(t) {
    if (!(this instanceof md)) return new md(t);
    ud.call(this, t), this._transformState = new gd(this);
    var e = this;
    this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.once("prefinish", function() {
        "function" == typeof this._flush ? this._flush(function(t) {
            bd(e, t);
        }) : bd(e);
    });
}
function bd(t, e) {
    if (e) return t.emit("error", e);
    var i = t._writableState, n = t._transformState;
    if (i.length) throw new Error("Calling transform done when ws.length != 0");
    if (n.transforming) throw new Error("Calling transform done when still transforming");
    return t.push(null);
}
function yd(t) {
    if (!(this instanceof yd)) return new yd(t);
    md.call(this, t);
}
function xd() {
    Dl.call(this);
}
sc(md, ud), md.prototype.push = function(t, e) {
    return this._transformState.needTransform = !1, ud.prototype.push.call(this, t, e);
}, md.prototype._transform = function(t, e, i) {
    throw new Error("Not implemented");
}, md.prototype._write = function(t, e, i) {
    var n = this._transformState;
    if (n.writecb = i, n.writechunk = t, n.writeencoding = e, !n.transforming) {
        var r = this._readableState;
        (n.needTransform || r.needReadable || r.length < r.highWaterMark) && this._read(r.highWaterMark);
    }
}, md.prototype._read = function(t) {
    var e = this._transformState;
    null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
}, sc(yd, md), yd.prototype._transform = function(t, e, i) {
    i(null, t);
}, sc(xd, Dl), xd.Readable = Fc, xd.Writable = ed, xd.Duplex = ud, xd.Transform = md, xd.PassThrough = yd, xd.Stream = xd, xd.prototype.pipe = function(t, e) {
    var i = this;
    function n(e) {
        t.writable && !1 === t.write(e) && i.pause && i.pause();
    }
    function r() {
        i.readable && i.resume && i.resume();
    }
    i.on("data", n), t.on("drain", r), t._isStdio || e && !1 === e.end || (i.on("end", s), i.on("close", a));
    var o = !1;
    function s() {
        o || (o = !0, t.end());
    }
    function a() {
        o || (o = !0, "function" == typeof t.destroy && t.destroy());
    }
    function l(t) {
        if (h(), 0 === Dl.listenerCount(this, "error")) throw t;
    }
    function h() {
        i.removeListener("data", n), t.removeListener("drain", r), i.removeListener("end", s), i.removeListener("close", a), i.removeListener("error", l), t.removeListener("error", l), i.removeListener("end", h), i.removeListener("close", h), t.removeListener("close", h);
    }
    return i.on("error", l), t.on("error", l), i.on("end", h), i.on("close", h), t.on("close", h), t.emit("pipe", i), t;
};
var vd, wd = y(Object.freeze({
    __proto__: null,
    Duplex: ud,
    PassThrough: yd,
    Readable: Fc,
    Stream: xd,
    Transform: md,
    Writable: ed,
    default: xd
}));
var Cd = (vd || (vd = 1, Ll.exports = function t() {
    var e = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : {};
    function i() {
        var i = e.URL || e.webkitURL || null, n = t.toString();
        return a.BLOB_URL || (a.BLOB_URL = i.createObjectURL(new Blob([
            "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
            "(",
            n,
            ")();"
        ], {
            type: "text/javascript"
        })));
    }
    var n = !e.document && !!e.postMessage, r = e.IS_PAPA_WORKER || !1, o = {}, s = 0, a = {};
    if (a.parse = h, a.unparse = c, a.RECORD_SEP = String.fromCharCode(30), a.UNIT_SEP = String.fromCharCode(31), a.BYTE_ORDER_MARK = "\ufeff", a.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        a.BYTE_ORDER_MARK
    ], a.WORKERS_SUPPORTED = !n && !!e.Worker, a.NODE_STREAM_INPUT = 1, a.LocalChunkSize = 10485760, a.RemoteChunkSize = 5242880, a.DefaultDelimiter = ",", a.Parser = x, a.ParserHandle = b, a.NetworkStreamer = u, a.FileStreamer = p, a.StringStreamer = f, a.ReadableStreamStreamer = g, "undefined" == typeof PAPA_BROWSER_CONTEXT && (a.DuplexStreamStreamer = m), e.jQuery) {
        var l = e.jQuery;
        l.fn.parse = function(t) {
            var i = t.config || {}, n = [];
            return this.each(function(t) {
                if ("INPUT" !== l(this).prop("tagName").toUpperCase() || "file" !== l(this).attr("type").toLowerCase() || !e.FileReader || !this.files || 0 === this.files.length) return !0;
                for(var r = 0; r < this.files.length; r++)n.push({
                    file: this.files[r],
                    inputElem: this,
                    instanceConfig: l.extend({}, i)
                });
            }), r(), this;
            function r() {
                if (0 !== n.length) {
                    var e = n[0];
                    if (M(t.before)) {
                        var i = t.before(e.file, e.inputElem);
                        if ("object" == typeof i) {
                            if ("abort" === i.action) return void o("AbortError", e.file, e.inputElem, i.reason);
                            if ("skip" === i.action) return void s();
                            "object" == typeof i.config && (e.instanceConfig = l.extend(e.instanceConfig, i.config));
                        } else if ("skip" === i) return void s();
                    }
                    var r = e.instanceConfig.complete;
                    e.instanceConfig.complete = function(t) {
                        M(r) && r(t, e.file, e.inputElem), s();
                    }, a.parse(e.file, e.instanceConfig);
                } else M(t.complete) && t.complete();
            }
            function o(e, i, n, r) {
                M(t.error) && t.error({
                    name: e
                }, i, n, r);
            }
            function s() {
                n.splice(0, 1), r();
            }
        };
    }
    function h(t, i) {
        var n = (i = i || {}).dynamicTyping || !1;
        if (M(n) && (i.dynamicTypingFunction = n, n = {}), i.dynamicTyping = n, i.transform = !!M(i.transform) && i.transform, i.worker && a.WORKERS_SUPPORTED) {
            var r = v();
            return r.userStep = i.step, r.userChunk = i.chunk, r.userComplete = i.complete, r.userError = i.error, i.step = M(i.step), i.chunk = M(i.chunk), i.complete = M(i.complete), i.error = M(i.error), delete i.worker, void r.postMessage({
                input: t,
                config: i,
                workerId: r.id
            });
        }
        var o = null;
        return t === a.NODE_STREAM_INPUT && "undefined" == typeof PAPA_BROWSER_CONTEXT ? (o = new m(i)).getStream() : ("string" == typeof t ? (t = s(t), o = i.download ? new u(i) : new f(i)) : !0 === t.readable && M(t.read) && M(t.on) ? o = new g(i) : (e.File && t instanceof File || t instanceof Object) && (o = new p(i)), o.stream(t));
        function s(t) {
            return 65279 === t.charCodeAt(0) ? t.slice(1) : t;
        }
    }
    function c(t, e) {
        var i = !1, n = !0, r = ",", o = "\r\n", s = '"', l = s + s, h = !1, c = null, d = !1;
        p();
        var u = new RegExp(y(s), "g");
        if ("string" == typeof t && (t = JSON.parse(t)), Array.isArray(t)) {
            if (!t.length || Array.isArray(t[0])) return f(null, t, h);
            if ("object" == typeof t[0]) return f(c || Object.keys(t[0]), t, h);
        } else if ("object" == typeof t) return "string" == typeof t.data && (t.data = JSON.parse(t.data)), Array.isArray(t.data) && (t.fields || (t.fields = t.meta && t.meta.fields || c), t.fields || (t.fields = Array.isArray(t.data[0]) ? t.fields : "object" == typeof t.data[0] ? Object.keys(t.data[0]) : []), Array.isArray(t.data[0]) || "object" == typeof t.data[0] || (t.data = [
            t.data
        ])), f(t.fields || [], t.data || [], h);
        throw new Error("Unable to serialize unrecognized input");
        function p() {
            if ("object" == typeof e) {
                if ("string" != typeof e.delimiter || a.BAD_DELIMITERS.filter(function(t) {
                    return -1 !== e.delimiter.indexOf(t);
                }).length || (r = e.delimiter), ("boolean" == typeof e.quotes || "function" == typeof e.quotes || Array.isArray(e.quotes)) && (i = e.quotes), "boolean" != typeof e.skipEmptyLines && "string" != typeof e.skipEmptyLines || (h = e.skipEmptyLines), "string" == typeof e.newline && (o = e.newline), "string" == typeof e.quoteChar && (s = e.quoteChar), "boolean" == typeof e.header && (n = e.header), Array.isArray(e.columns)) {
                    if (0 === e.columns.length) throw new Error("Option columns is empty");
                    c = e.columns;
                }
                void 0 !== e.escapeChar && (l = e.escapeChar + s), ("boolean" == typeof e.escapeFormulae || e.escapeFormulae instanceof RegExp) && (d = e.escapeFormulae instanceof RegExp ? e.escapeFormulae : /^[=+\-@\t\r].*$/);
            }
        }
        function f(t, e, i) {
            var s = "";
            "string" == typeof t && (t = JSON.parse(t)), "string" == typeof e && (e = JSON.parse(e));
            var a = Array.isArray(t) && t.length > 0, l = !Array.isArray(e[0]);
            if (a && n) {
                for(var h = 0; h < t.length; h++)h > 0 && (s += r), s += g(t[h], h);
                e.length > 0 && (s += o);
            }
            for(var c = 0; c < e.length; c++){
                var d = a ? t.length : e[c].length, u = !1, p = a ? 0 === Object.keys(e[c]).length : 0 === e[c].length;
                if (i && !a && (u = "greedy" === i ? "" === e[c].join("").trim() : 1 === e[c].length && 0 === e[c][0].length), "greedy" === i && a) {
                    for(var f = [], m = 0; m < d; m++){
                        var b = l ? t[m] : m;
                        f.push(e[c][b]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var y = 0; y < d; y++){
                        y > 0 && !p && (s += r);
                        var x = a && l ? t[y] : y;
                        s += g(e[c][x], y);
                    }
                    c < e.length - 1 && (!i || d > 0 && !p) && (s += o);
                }
            }
            return s;
        }
        function g(t, e) {
            if (null == t) return "";
            if (t.constructor === Date) return JSON.stringify(t).slice(1, 25);
            var n = !1;
            d && "string" == typeof t && d.test(t) && (t = "'" + t, n = !0);
            var o = t.toString().replace(u, l);
            return (n = n || !0 === i || "function" == typeof i && i(t, e) || Array.isArray(i) && i[e] || m(o, a.BAD_DELIMITERS) || o.indexOf(r) > -1 || " " === o.charAt(0) || " " === o.charAt(o.length - 1)) ? s + o + s : o;
        }
        function m(t, e) {
            for(var i = 0; i < e.length; i++)if (t.indexOf(e[i]) > -1) return !0;
            return !1;
        }
    }
    function d(t) {
        function i(t) {
            var e = A(t);
            e.chunkSize = parseInt(e.chunkSize), t.step || t.chunk || (e.chunkSize = null), this._handle = new b(e), this._handle.streamer = this, this._config = e;
        }
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, i.call(this, t), this.parseChunk = function(t, i) {
            if (this.isFirstChunk && M(this._config.beforeFirstChunk)) {
                var n = this._config.beforeFirstChunk(t);
                void 0 !== n && (t = n);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var o = this._partialLine + t;
            this._partialLine = "";
            var s = this._handle.parse(o, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var l = s.meta.cursor;
                this._finished || (this._partialLine = o.substring(l - this._baseIndex), this._baseIndex = l), s && s.data && (this._rowCount += s.data.length);
                var h = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (r) e.postMessage({
                    results: s,
                    workerId: a.WORKER_ID,
                    finished: h
                });
                else if (M(this._config.chunk) && !i) {
                    if (this._config.chunk(s, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    s = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(s.data), this._completeResults.errors = this._completeResults.errors.concat(s.errors), this._completeResults.meta = s.meta), this._completed || !h || !M(this._config.complete) || s && s.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), h || s && s.meta.paused || this._nextChunk(), s;
            }
            this._halted = !0;
        }, this._sendError = function(t) {
            M(this._config.error) ? this._config.error(t) : r && this._config.error && e.postMessage({
                workerId: a.WORKER_ID,
                error: t,
                finished: !1
            });
        };
    }
    function u(t) {
        var e;
        function i(t) {
            var e = t.getResponseHeader("Content-Range");
            return null === e ? -1 : parseInt(e.substring(e.lastIndexOf("/") + 1));
        }
        (t = t || {}).chunkSize || (t.chunkSize = a.RemoteChunkSize), d.call(this, t), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(t) {
            this._input = t, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (e = new XMLHttpRequest, this._config.withCredentials && (e.withCredentials = this._config.withCredentials), n || (e.onload = E(this._chunkLoaded, this), e.onerror = E(this._chunkError, this)), e.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var t = this._config.downloadRequestHeaders;
                    for(var i in t)e.setRequestHeader(i, t[i]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    e.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
                }
                try {
                    e.send(this._config.downloadRequestBody);
                } catch (t) {
                    this._chunkError(t.message);
                }
                n && 0 === e.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === e.readyState && (e.status < 200 || e.status >= 400 ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : e.responseText.length, this._finished = !this._config.chunkSize || this._start >= i(e), this.parseChunk(e.responseText)));
        }, this._chunkError = function(t) {
            var i = e.statusText || t;
            this._sendError(new Error(i));
        };
    }
    function p(t) {
        var e, i;
        (t = t || {}).chunkSize || (t.chunkSize = a.LocalChunkSize), d.call(this, t);
        var n = "undefined" != typeof FileReader;
        this.stream = function(t) {
            this._input = t, i = t.slice || t.webkitSlice || t.mozSlice, n ? ((e = new FileReader).onload = E(this._chunkLoaded, this), e.onerror = E(this._chunkError, this)) : e = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var t = this._input;
            if (this._config.chunkSize) {
                var r = Math.min(this._start + this._config.chunkSize, this._input.size);
                t = i.call(t, this._start, r);
            }
            var o = e.readAsText(t, this._config.encoding);
            n || this._chunkLoaded({
                target: {
                    result: o
                }
            });
        }, this._chunkLoaded = function(t) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(t.target.result);
        }, this._chunkError = function() {
            this._sendError(e.error);
        };
    }
    function f(t) {
        var e;
        t = t || {}, d.call(this, t), this.stream = function(t) {
            return e = t, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var t, i = this._config.chunkSize;
                return i ? (t = e.substring(0, i), e = e.substring(i)) : (t = e, e = ""), this._finished = !e, this.parseChunk(t);
            }
        };
    }
    function g(t) {
        t = t || {}, d.call(this, t);
        var e = [], i = !0, n = !1;
        this.pause = function() {
            d.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            d.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(t) {
            this._input = t, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            n && 1 === e.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), e.length ? this.parseChunk(e.shift()) : i = !0;
        }, this._streamData = E(function(t) {
            try {
                e.push("string" == typeof t ? t : t.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(e.shift()));
            } catch (t) {
                this._streamError(t);
            }
        }, this), this._streamError = E(function(t) {
            this._streamCleanUp(), this._sendError(t);
        }, this), this._streamEnd = E(function() {
            this._streamCleanUp(), n = !0, this._streamData("");
        }, this), this._streamCleanUp = E(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function m(t) {
        var e = wd.Duplex, i = A(t), n = !0, r = !1, o = [], s = null;
        this._onCsvData = function(t) {
            var e = t.data;
            s.push(e) || this._handle.paused() || this._handle.pause();
        }, this._onCsvComplete = function() {
            s.push(null);
        }, i.step = E(this._onCsvData, this), i.complete = E(this._onCsvComplete, this), d.call(this, i), this._nextChunk = function() {
            r && 1 === o.length && (this._finished = !0), o.length ? o.shift()() : n = !0;
        }, this._addToParseQueue = function(t, e) {
            o.push(E(function() {
                if (this.parseChunk("string" == typeof t ? t : t.toString(i.encoding)), M(e)) return e();
            }, this)), n && (n = !1, this._nextChunk());
        }, this._onRead = function() {
            this._handle.paused() && this._handle.resume();
        }, this._onWrite = function(t, e, i) {
            this._addToParseQueue(t, i);
        }, this._onWriteComplete = function() {
            r = !0, this._addToParseQueue("");
        }, this.getStream = function() {
            return s;
        }, (s = new e({
            readableObjectMode: !0,
            decodeStrings: !1,
            read: E(this._onRead, this),
            write: E(this._onWrite, this)
        })).once("finish", E(this._onWriteComplete, this));
    }
    function b(t) {
        var e, i, n, r = Math.pow(2, 53), o = -r, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, l = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, h = this, c = 0, d = 0, u = !1, p = !1, f = [], g = {
            data: [],
            errors: [],
            meta: {}
        };
        if (M(t.step)) {
            var m = t.step;
            t.step = function(e) {
                if (g = e, C()) w();
                else {
                    if (w(), 0 === g.data.length) return;
                    c += e.data.length, t.preview && c > t.preview ? i.abort() : (g.data = g.data[0], m(g, h));
                }
            };
        }
        function b(e) {
            return "greedy" === t.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function v(t) {
            if (s.test(t)) {
                var e = parseFloat(t);
                if (e > o && e < r) return !0;
            }
            return !1;
        }
        function w() {
            return g && n && (L("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + a.DefaultDelimiter + "'"), n = !1), t.skipEmptyLines && (g.data = g.data.filter(function(_t1) {
                return !b(_t1);
            })), C() && S(), T();
        }
        function C() {
            return t.header && 0 === f.length;
        }
        function S() {
            if (g) {
                if (Array.isArray(g.data[0])) {
                    for(var e = 0; C() && e < g.data.length; e++)g.data[e].forEach(i);
                    g.data.splice(0, 1);
                } else g.data.forEach(i);
            }
            function i(e, i) {
                M(t.transformHeader) && (e = t.transformHeader(e, i)), f.push(e);
            }
        }
        function k(e) {
            return t.dynamicTypingFunction && void 0 === t.dynamicTyping[e] && (t.dynamicTyping[e] = t.dynamicTypingFunction(e)), !0 === (t.dynamicTyping[e] || t.dynamicTyping);
        }
        function E(t, e) {
            return k(t) ? "true" === e || "TRUE" === e || "false" !== e && "FALSE" !== e && (v(e) ? parseFloat(e) : l.test(e) ? new Date(e) : "" === e ? null : e) : e;
        }
        function T() {
            if (!g || !t.header && !t.dynamicTyping && !t.transform) return g;
            function e(e, i) {
                var n, r = t.header ? {} : [];
                for(n = 0; n < e.length; n++){
                    var o = n, s = e[n];
                    t.header && (o = n >= f.length ? "__parsed_extra" : f[n]), t.transform && (s = t.transform(s, o)), s = E(o, s), "__parsed_extra" === o ? (r[o] = r[o] || [], r[o].push(s)) : r[o] = s;
                }
                return t.header && (n > f.length ? L("FieldMismatch", "TooManyFields", "Too many fields: expected " + f.length + " fields but parsed " + n, d + i) : n < f.length && L("FieldMismatch", "TooFewFields", "Too few fields: expected " + f.length + " fields but parsed " + n, d + i)), r;
            }
            var i = 1;
            return !g.data.length || Array.isArray(g.data[0]) ? (g.data = g.data.map(e), i = g.data.length) : g.data = e(g.data, 0), t.header && g.meta && (g.meta.fields = f), d += i, g;
        }
        function P(e, i, n, r, o) {
            var s, l, h, c;
            o = o || [
                ",",
                "\t",
                "|",
                ";",
                a.RECORD_SEP,
                a.UNIT_SEP
            ];
            for(var d = 0; d < o.length; d++){
                var u = o[d], p = 0, f = 0, g = 0;
                h = void 0;
                for(var m = new x({
                    comments: r,
                    delimiter: u,
                    newline: i,
                    preview: 10
                }).parse(e), y = 0; y < m.data.length; y++)if (n && b(m.data[y])) g++;
                else {
                    var v = m.data[y].length;
                    f += v, void 0 !== h ? v > 0 && (p += Math.abs(v - h), h = v) : h = v;
                }
                m.data.length > 0 && (f /= m.data.length - g), (void 0 === l || p <= l) && (void 0 === c || f > c) && f > 1.99 && (l = p, s = u, c = f);
            }
            return t.delimiter = s, {
                successful: !!s,
                bestDelimiter: s
            };
        }
        function R(t, e) {
            t = t.substring(0, 1048576);
            var i = new RegExp(y(e) + "([^]*?)" + y(e), "gm"), n = (t = t.replace(i, "")).split("\r"), r = t.split("\n"), o = r.length > 1 && r[0].length < n[0].length;
            if (1 === n.length || o) return "\n";
            for(var s = 0, a = 0; a < n.length; a++)"\n" === n[a][0] && s++;
            return s >= n.length / 2 ? "\r\n" : "\r";
        }
        function L(t, e, i, n) {
            var r = {
                type: t,
                code: e,
                message: i
            };
            void 0 !== n && (r.row = n), g.errors.push(r);
        }
        this.parse = function(r, o, s) {
            var l = t.quoteChar || '"';
            if (t.newline || (t.newline = R(r, l)), n = !1, t.delimiter) M(t.delimiter) && (t.delimiter = t.delimiter(r), g.meta.delimiter = t.delimiter);
            else {
                var h = P(r, t.newline, t.skipEmptyLines, t.comments, t.delimitersToGuess);
                h.successful ? t.delimiter = h.bestDelimiter : (n = !0, t.delimiter = a.DefaultDelimiter), g.meta.delimiter = t.delimiter;
            }
            var c = A(t);
            return t.preview && t.header && c.preview++, e = r, i = new x(c), g = i.parse(e, o, s), w(), u ? {
                meta: {
                    paused: !0
                }
            } : g || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return u;
        }, this.pause = function() {
            u = !0, i.abort(), e = M(t.chunk) ? "" : e.substring(i.getCharIndex());
        }, this.resume = function() {
            h.streamer._halted ? (u = !1, h.streamer.parseChunk(e, !0)) : setTimeout(h.resume, 3);
        }, this.aborted = function() {
            return p;
        }, this.abort = function() {
            p = !0, i.abort(), g.meta.aborted = !0, M(t.complete) && t.complete(g), e = "";
        };
    }
    function y(t) {
        return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function x(t) {
        var e, i = (t = t || {}).delimiter, n = t.newline, r = t.comments, o = t.step, s = t.preview, l = t.fastMode, h = e = void 0 === t.quoteChar || null === t.quoteChar ? '"' : t.quoteChar;
        if (void 0 !== t.escapeChar && (h = t.escapeChar), ("string" != typeof i || a.BAD_DELIMITERS.indexOf(i) > -1) && (i = ","), r === i) throw new Error("Comment character same as delimiter");
        !0 === r ? r = "#" : ("string" != typeof r || a.BAD_DELIMITERS.indexOf(r) > -1) && (r = !1), "\n" !== n && "\r" !== n && "\r\n" !== n && (n = "\n");
        var c = 0, d = !1;
        this.parse = function(a, u, p) {
            if ("string" != typeof a) throw new Error("Input must be a string");
            var f = a.length, g = i.length, m = n.length, b = r.length, x = M(o);
            c = 0;
            var v = [], w = [], C = [], S = 0;
            if (!a) return q();
            if (t.header && !u) {
                var k = a.split(n)[0].split(i), A = "_", E = [], T = {}, P = !1;
                for(var R in k){
                    var L = k[R];
                    M(t.transformHeader) && (L = t.transformHeader(L, R));
                    var O = L, D = T[L] || 0;
                    for(D > 0 && (P = !0, O = L + A + D), T[L] = D + 1; E.includes(O);)O = O + A + D;
                    E.push(O);
                }
                if (P) {
                    var j = a.split(n);
                    j[0] = E.join(i), a = j.join(n);
                }
            }
            if (l || !1 !== l && -1 === a.indexOf(e)) {
                for(var N = a.split(n), I = 0; I < N.length; I++){
                    if (C = N[I], c += C.length, I !== N.length - 1) c += n.length;
                    else if (p) return q();
                    if (!r || C.substring(0, b) !== r) {
                        if (x) {
                            if (v = [], Y(C.split(i)), V(), d) return q();
                        } else Y(C.split(i));
                        if (s && I >= s) return v = v.slice(0, s), q(!0);
                    }
                }
                return q();
            }
            for(var B = a.indexOf(i, c), F = a.indexOf(n, c), z = new RegExp(y(h) + y(e), "g"), H = a.indexOf(e, c);;)if (a[c] !== e) {
                if (r && 0 === C.length && a.substring(c, c + b) === r) {
                    if (-1 === F) return q();
                    c = F + m, F = a.indexOf(n, c), B = a.indexOf(i, c);
                } else if (-1 !== B && (B < F || -1 === F)) C.push(a.substring(c, B)), c = B + g, B = a.indexOf(i, c);
                else {
                    if (-1 === F) break;
                    if (C.push(a.substring(c, F)), G(F + m), x && (V(), d)) return q();
                    if (s && v.length >= s) return q(!0);
                }
            } else for(H = c, c++;;){
                if (-1 === (H = a.indexOf(e, H + 1))) return p || w.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: v.length,
                    index: c
                }), X();
                if (H === f - 1) return X(a.substring(c, H).replace(z, e));
                if (e !== h || a[H + 1] !== h) {
                    if (e === h || 0 === H || a[H - 1] !== h) {
                        -1 !== B && B < H + 1 && (B = a.indexOf(i, H + 1)), -1 !== F && F < H + 1 && (F = a.indexOf(n, H + 1));
                        var U = _(-1 === F ? B : Math.min(B, F));
                        if (a.substr(H + 1 + U, g) === i) {
                            C.push(a.substring(c, H).replace(z, e)), c = H + 1 + U + g, a[H + 1 + U + g] !== e && (H = a.indexOf(e, c)), B = a.indexOf(i, c), F = a.indexOf(n, c);
                            break;
                        }
                        var W = _(F);
                        if (a.substring(H + 1 + W, H + 1 + W + m) === n) {
                            if (C.push(a.substring(c, H).replace(z, e)), G(H + 1 + W + m), B = a.indexOf(i, c), H = a.indexOf(e, c), x && (V(), d)) return q();
                            if (s && v.length >= s) return q(!0);
                            break;
                        }
                        w.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: v.length,
                            index: c
                        }), H++;
                    }
                } else H++;
            }
            return X();
            function Y(t) {
                v.push(t), S = c;
            }
            function _(t) {
                var e = 0;
                if (-1 !== t) {
                    var i = a.substring(H + 1, t);
                    i && "" === i.trim() && (e = i.length);
                }
                return e;
            }
            function X(t) {
                return p || (void 0 === t && (t = a.substring(c)), C.push(t), c = f, Y(C), x && V()), q();
            }
            function G(t) {
                c = t, Y(C), C = [], F = a.indexOf(n, c);
            }
            function q(t) {
                return {
                    data: v,
                    errors: w,
                    meta: {
                        delimiter: i,
                        linebreak: n,
                        aborted: d,
                        truncated: !!t,
                        cursor: S + (u || 0)
                    }
                };
            }
            function V() {
                o(q()), v = [], w = [];
            }
        }, this.abort = function() {
            d = !0;
        }, this.getCharIndex = function() {
            return c;
        };
    }
    function v() {
        if (!a.WORKERS_SUPPORTED) return !1;
        var t = i(), n = new e.Worker(t);
        return n.onmessage = w, n.id = s++, o[n.id] = n, n;
    }
    function w(t) {
        var e = t.data, i = o[e.workerId], n = !1;
        if (e.error) i.userError(e.error, e.file);
        else if (e.results && e.results.data) {
            var r = {
                abort: function() {
                    n = !0, C(e.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: S,
                resume: S
            };
            if (M(i.userStep)) {
                for(var s = 0; s < e.results.data.length && (i.userStep({
                    data: e.results.data[s],
                    errors: e.results.errors,
                    meta: e.results.meta
                }, r), !n); s++);
                delete e.results;
            } else M(i.userChunk) && (i.userChunk(e.results, r, e.file), delete e.results);
        }
        e.finished && !n && C(e.workerId, e.results);
    }
    function C(t, e) {
        var i = o[t];
        M(i.userComplete) && i.userComplete(e), i.terminate(), delete o[t];
    }
    function S() {
        throw new Error("Not implemented.");
    }
    function k(t) {
        var i = t.data;
        if (void 0 === a.WORKER_ID && i && (a.WORKER_ID = i.workerId), "string" == typeof i.input) e.postMessage({
            workerId: a.WORKER_ID,
            results: a.parse(i.input, i.config),
            finished: !0
        });
        else if (e.File && i.input instanceof File || i.input instanceof Object) {
            var n = a.parse(i.input, i.config);
            n && e.postMessage({
                workerId: a.WORKER_ID,
                results: n,
                finished: !0
            });
        }
    }
    function A(t) {
        if ("object" != typeof t || null === t) return t;
        var e = Array.isArray(t) ? [] : {};
        for(var i in t)e[i] = A(t[i]);
        return e;
    }
    function E(t, e) {
        return function() {
            t.apply(e, arguments);
        };
    }
    function M(t) {
        return "function" == typeof t;
    }
    return r && (e.onmessage = k), u.prototype = Object.create(d.prototype), u.prototype.constructor = u, p.prototype = Object.create(d.prototype), p.prototype.constructor = p, f.prototype = Object.create(f.prototype), f.prototype.constructor = f, g.prototype = Object.create(d.prototype), g.prototype.constructor = g, "undefined" == typeof PAPA_BROWSER_CONTEXT && (m.prototype = Object.create(d.prototype), m.prototype.constructor = m), a;
}()), Ll.exports), Sd = b(Cd);
const kd = Le(pi, Rt((t)=>{
    let [e, i] = t;
    return [
        On(`${e}`),
        i
    ];
}), kt(Le(Ti(j, 2), Ai, kt(ae)))), Ad = {
    categories: [],
    series: [],
    otherDimensions: [],
    areCategoriesDates: !1,
    areCategoriesNumbers: !1,
    codeLabelMapping: {}
}, Ed = (t)=>Sd.parse(t, {
        dynamicTyping: !0,
        skipEmptyLines: !0,
        transform: (t)=>t.trim()
    }), Md = Le((t)=>{
    if (Ao(t)) return [];
    const e = Ai(kt(ae, Oe(t)));
    return Rt((t)=>Ai(t) === e ? t : Ai(t) > e ? Ke(e, t) : Ne(t, Vi(qt(null), e - Ai(t))), t);
}, jt("data")), Td = (t)=>Le(Md, Wi([
        "data"
    ]), Ed)(t ?? ""), Pd = (t)=>Le(jn(Ao, qt([])), jt("data"), Ed)(t ?? ""), Rd = (t)=>{
    let { data: e, parsingHelperData: i, ...n } = t;
    if (Ao(e)) return {
        categories: [],
        series: [],
        otherDimensions: [],
        ...n
    };
    return {
        categories: Rt((t)=>({
                code: `${t}`,
                label: Hi([
                    "xDimensionLabelByCode",
                    t
                ], i)
            }), Rt(Oe, Te(e))),
        series: Eo((t, n)=>{
            const r = Rt(Fi(n + 1), Te(e));
            return {
                code: `${t}`,
                label: Hi([
                    "yDimensionLabelByCode",
                    `${t}`
                ], i),
                data: r
            };
        }, Te(Oe(e))),
        otherDimensions: Rt((t)=>{
            let [e, i] = t;
            return {
                code: `${e}`,
                label: i
            };
        }, Ln(i.otherDimensionsLabelByCode)),
        ...n
    };
}, Ld = (t, e, i, n, r)=>(o)=>{
        let { data: s, ...a } = o;
        if (((t, e, i, n, r, o)=>(i !== tr.map || n !== nr.dotStat.value) && !(!ae(r) && !ae(o)) && (!(2 !== Ai(t) || !yi(i, [
                tr.bar,
                tr.row,
                tr.line,
                tr.pie
            ])) || !(2 !== Ai(Oe(t)) || !yi(i, [
                tr.stackedBar,
                tr.stackedRow
            ])) || (2 !== Ai(Oe(t)) || !yi(i, [
                tr.line,
                tr.radar
            ])) && e))(s, i, t, e, n, r)) {
            const t = Rt(Oe, s), e = Eo((t, e)=>Yi(t, Rt(Fi(e + 1), Te(s))), Te(Oe(s))), i = Yi(t, e);
            if (mi("parsingHelperData", a)) return {
                data: i,
                parsingHelperData: {
                    xDimensionLabelByCode: a.parsingHelperData.yDimensionLabelByCode,
                    yDimensionLabelByCode: a.parsingHelperData.xDimensionLabelByCode,
                    otherDimensionsLabelByCode: a.parsingHelperData.otherDimensionsLabelByCode
                },
                ...zi([
                    "parsingHelperData"
                ], a)
            };
            return {
                data: i,
                ...a
            };
        }
        return {
            data: s,
            ...a
        };
    }, Od = (t, e, i, n)=>{
    if (Ao(t) && Ao(e) && Ao(i?.dimensions)) return {};
    const r = Le(Li, Rt(Le(Rt((t)=>{
        let { labels: e } = t;
        return jt(n, e) || jt("en", e) || jt(Oe(ht(e)), e) || "";
    }), jt("members"))), kt(mi("timeRange")))(i?.dimensions || []), o = kd(Td(t)), s = kd(Td(e));
    return Le(Ii(r), Ii(o))(s);
}, Dd = (t)=>(e)=>{
        let { categories: i, series: n, ...r } = e;
        if (Ao(t)) return {
            categories: i,
            series: n,
            ...r
        };
        const o = St((t)=>li((e)=>Do(e)(t), n), Qi("|", t)), s = Mo((t, e, i)=>{
            const n = di((t)=>Do(t)(e), t);
            return Bi(n, i, t);
        }, n, o);
        return {
            categories: i,
            series: s,
            ...r
        };
    }, jd = (t, e, i)=>(n)=>{
        let { data: r, parsingHelperData: o, areCategoriesDates: s, areCategoriesNumbers: a, ...l } = n;
        const h = !e || e === or.asc.value || s || a ? re : Fe, c = s || a ? rr.categoriesCode.value : t;
        if (c === rr.categoriesLabel.value || c === rr.categoriesCode.value) {
            const t = c === rr.categoriesLabel.value ? (t)=>Hi([
                    "xDimensionLabelByCode",
                    t
                ], o) : je;
            return {
                data: Yi(Oe(r), Ki(h(Le(t, Oe)), Te(r))),
                parsingHelperData: o,
                areCategoriesDates: s,
                areCategoriesNumbers: a,
                ...l
            };
        }
        if (c === rr.seriesValue.value) {
            const t = Rt(On, ht(o.yDimensionLabelByCode)), e = Rt(On, ne(o.yDimensionLabelByCode)), n = (i)=>Le(jn(pt(-1), ()=>di(pt(i), e)), ()=>di(pt(i), t))(), c = Le(jn(Si, qt([
                0
            ])), kt(pt(-1)), Rt(n), Qi("|"), On)(i);
            return {
                data: Yi(Oe(r), Ki(h(Le(Ri, Gi(c), Rt(jt("value")), Te)), Te(r))),
                parsingHelperData: o,
                areCategoriesDates: s,
                areCategoriesNumbers: a,
                ...l
            };
        }
        return {
            data: r,
            parsingHelperData: o,
            areCategoriesDates: s,
            areCategoriesNumbers: a,
            ...l
        };
    }, Nd = (t, e, i)=>(t)=>{
        const n = i || yi(e, er);
        if (n) return {
            ...t,
            areCategoriesDates: !1
        };
        const r = Le(Rt(Oe), Te, jt("data"))(t), { isSuccessful: o, dates: s, dateFormat: a } = ((t)=>{
            const e = Oe(t), i = jt(hr.value, Ua);
            if (i.tryParse(e)) {
                const e = Rt(i.tryParse, t);
                if (Ai(e) > 2 && !Kt(pt(!1), e)) return {
                    isSuccessful: !0,
                    dates: Rt((t)=>t.getTime(), e),
                    dateFormat: hr.value
                };
            }
            const n = jt(cr.value, Ua);
            if (n.tryParse(e)) {
                const e = Rt(n.tryParse, t);
                if (!Kt(pt(!1), e)) return {
                    isSuccessful: !0,
                    dates: Rt((t)=>t.getTime(), e),
                    dateFormat: cr.value
                };
            }
            const r = jt(ur.value, Ua);
            if (r.tryParse(e)) {
                const e = Rt(r.tryParse, t);
                if (!Kt(pt(!1), e)) return {
                    isSuccessful: !0,
                    dates: Rt((t)=>t.getTime(), e),
                    dateFormat: ur.value
                };
            }
            const o = jt(dr.value, Ua);
            if (o.tryParse(e)) {
                const e = Rt(o.tryParse, t);
                if (!Kt(pt(!1), e)) return {
                    isSuccessful: !0,
                    dates: Rt((t)=>t.getTime(), e),
                    dateFormat: dr.value
                };
            }
            return {
                isSuccessful: !1,
                dates: null,
                dateFormat: null
            };
        })(r);
        if (o) {
            const e = n ? t.data : Le(Yi(Oe(t.data)), Eo((t, e)=>Yi(Oe(t), Rt((t)=>le([
                        "metadata",
                        "parsedX"
                    ], Fi(e, s), t), Te(t)))), Te, jt("data"))(t);
            return {
                ...t,
                data: e,
                areCategoriesDates: !0,
                categoriesDateFomat: a
            };
        }
        return {
            ...t,
            areCategoriesDates: !1
        };
    }, Id = (t, e)=>(i)=>{
        if (i.areCategoriesDates || e || yi(t, er)) return {
            ...i,
            areCategoriesNumbers: !1
        };
        const n = Le(Rt(Oe), Te, jt("data"))(i);
        if (Q(tl, n)) {
            const t = Rt(Number, n), e = Le(Yi(Oe(i.data)), Eo((e, i)=>Yi(Oe(e), Rt((e)=>le([
                        "metadata",
                        "parsedX"
                    ], Fi(i, t), e), Te(e)))), Te, jt("data"))(i);
            return {
                ...i,
                data: e,
                areCategoriesNumbers: !0
            };
        }
        return {
            ...i,
            areCategoriesNumbers: !1
        };
    }, Bd = (t)=>he("codeLabelMapping", Le(pi, Rt((t)=>{
        let { code: e, label: i } = t;
        return [
            On(e),
            i
        ];
    }))(Dn([
        jt("categories", t),
        jt("series", t),
        jt("otherDimensions", t)
    ])), t), Fd = (t)=>{
    let { data: e, ...i } = t;
    const n = Oe(e), r = Rt((t)=>Yi(Oe(t), Rt((t)=>({
                value: t
            }), Te(t))), Te(e));
    return {
        data: Yi(n, r),
        ...i
    };
}, zd = (t)=>{
    let { staticCsvData: e, chartType: i, dataSourceType: n, pivotData: r, csvCodeLabelMappingProjectLevel: o, csvCodeLabelMapping: s, sortBy: a, sortOrder: l, sortSeries: h, yAxisOrderOverride: c, forceXAxisToBeTreatedAsCategories: d, vars: u, lang: p } = t;
    return Ao(e) ? Ad : Le(Bd, _e("rawCodeLabelMapping"), ((t, e, i)=>(n)=>{
            if (n.areCategoriesDates && yi(n.categoriesDateFomat, [
                hr.value,
                cr.value
            ]) && !e && !yi(t, er)) return n;
            if (n.areCategoriesDates && yi(n.categoriesDateFomat, [
                ur.value,
                dr.value
            ])) {
                const r = jt(n.categoriesDateFomat, Ua);
                return Le(jn(()=>e || yi(t, er), Le(_e("categoriesDateFomat"), he("areCategoriesDates", !1))), oi({
                    categories: Rt((t)=>{
                        if (mi(t.code, n.rawCodeLabelMapping)) return t;
                        const e = r.tryParse(t.code);
                        return he("label", r.formatToLabel(e, i), t);
                    })
                }))(n);
            }
            return Le(_e("categoriesDateFomat"), he("areCategoriesDates", !1))(n);
        })(i, d, p), Dd(c), Rd, jd(a, l, h), Id(i, d), Nd(0, i, d), Fd, ((t, e)=>(i)=>{
            let { data: n, ...r } = i;
            const o = Od(t, e, null, null), s = pi(Rt(Le((t)=>[
                    `${t}`,
                    Xi(`${t}`, On(`${t}`), o)
                ], Oe), Te(n))), a = Le(pi, Rt((t)=>[
                    `${t}`,
                    Xi(`${t}`, On(`${t}`), o)
                ]), Te, Oe)(n);
            return {
                data: n,
                rawCodeLabelMapping: o,
                parsingHelperData: {
                    xDimensionLabelByCode: s,
                    yDimensionLabelByCode: a,
                    otherDimensionsLabelByCode: o
                },
                ...r
            };
        })(o, s), Ld(i, n, r), ((t)=>(e)=>{
            const i = Oe(e), n = di(yi(j, Rt((t)=>`{${t}}`, Ro)), i);
            if (-1 === n) return {
                data: e
            };
            const r = Fi(n, i), o = Le(jn(()=>0 === n, Qi("|")), On, jt($i(/{|}/g, "", r)))(t), s = n + 1 + di(yi(j, Rt((t)=>`{${t}}`, Ro)), qe(n + 1, i)), a = s > n ? Fi(s, i) : null, l = a ? Le(On, jt($i(/{|}/g, "", a)))(t) : null;
            return {
                data: Le((t)=>{
                    if (!a) {
                        const i = 0 === n ? t : Rt(We(n, 1), t);
                        return Yi(0 === n ? Oe(e) : Le(We(n, 1), Oe)(e), i);
                    }
                    if (0 === n) {
                        const i = Rt(We(s, 1), t);
                        return Yi(Le(We(s, 1), Oe)(e), i);
                    }
                    const i = Rt(Le(We(s - 1, 1), We(n, 1)), t);
                    return Yi(Le(We(s - 1, 1), We(n, 1), Oe)(e), i);
                }, St((t)=>{
                    const e = On(`${Fi(n, t)}`), i = 0 === n ? yi(e, o) : pt(e, o);
                    if (!a) return i;
                    const r = On(`${Fi(s, t)}`), h = pt(r, l);
                    return i && h;
                }))(Te(e)),
                varsThatCauseNewPreParsedDataFetch: a ? {
                    [$i(/{|}/g, "", Fi(n, i))]: 0 === n ? ki("|", o) : o,
                    [$i(/{|}/g, "", Fi(s, i))]: l
                } : {
                    [$i(/{|}/g, "", Fi(n, i))]: 0 === n ? ki("|", o) : o
                }
            };
        })(u), Td)(e);
}, Hd = (t)=>({
        Accept: "application/vnd.sdmx.data+json;version=1.0",
        "Accept-Language": Ao(t) ? "en" : Rn(t)
    }), Ud = async function(t, e) {
    let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    const n = await fetch(((t)=>{
        const e = new URL(t);
        return e.searchParams.set("dimensionAtObservation", "AllDimensions"), e.href;
    })(t), {
        headers: Hd(e),
        signal: AbortSignal.timeout(i.timeout || 15e3),
        ..._e("timeout", i)
    });
    if (n.status >= 200 && n.status < 300) return n.json();
    if (404 === n.status) try {
        const t = await n.text();
        if (yi("NoResultsFound", t) || yi("NoRecordsFound", t) || yi("No Results Found", t)) return {
            data: {
                dataSets: [
                    {}
                ]
            },
            meta: {
                schema: ""
            }
        };
    } catch (t) {
        throw new Error(Si(n.statusText) ? n.status : n.statusText);
    }
    let r = Si(n.statusText) ? n.status : n.statusText;
    try {
        const t = await n.text();
        r = Si(t) ? r : t;
    } catch  {}
    throw new Error(r);
}, Wd = (t, e, i)=>Le(jn(()=>!Ao(i), Ni(i)), pi, Rt((t)=>[
            t.id,
            Ui(Xi(jt("id", t), "name", t), [
                "names",
                e
            ], t)
        ]))(t), Yd = Zt([
    _i(!0, "isTimeDimension"),
    _i("TIME_PERIOD", "role"),
    Le(yi("TIME_PERIOD"), Xi([], "roles"))
]), _d = Pi(/(\d{4})-(\d{2})/), Xd = Rt((t)=>{
    if (Yd(t)) return !Si(_d(Oe(t.values).id)) ? oi({
        values: Rt((t)=>{
            const [e, i, n] = _d(t.id);
            return {
                id: t.id,
                name: `${n}-${i}`
            };
        })
    }, t) : t;
    return t;
}), Gd = (t)=>{
    let { chartType: e, mapCountryDimension: i, dotStatUrlHasLastNObservationsEqOne: n, dotStatCodeLabelMapping: r, csvCodeLabelMappingProjectLevel: o, lang: s, dotStatStructure: a, dimensionCodeUsedWhenOnlyOneDimensionHasMoreThanOneMember: l, dotStatXAxisDimension: h, dotStatYAxisDimension: c } = t;
    return (t)=>{
        const d = Hi([
            "data",
            "dataSets",
            0,
            "observations"
        ], t), u = Le(St(mi("values")), Hi([
            "data",
            "structure",
            "dimensions",
            "observation"
        ]))(t), p = Le(jn(()=>n, kt(Yd)), St(Le(fi(j, 1), Ai, jt("values"))))(u), [f, g] = Xd(((t, e, i)=>{
            let { chartType: n, mapCountryDimension: r, dotStatUrlHasLastNObservationsEqOne: o, dimensionCodeUsedWhenOnlyOneDimensionHasMoreThanOneMember: s, dotStatXAxisDimension: a, dotStatYAxisDimension: l } = i;
            if (!ae(a) && !ae(l)) {
                const e = li(_i(a, "id"), t), i = li(_i(l, "id"), t);
                if (e && i) return [
                    e,
                    i
                ];
            }
            const h = Le(jn(Si, qt(t)), jn(()=>o, kt(Yd)))(t), c = (t, e)=>{
                const i = kt(_i(e, "id"), t);
                return Ao(s) ? Oe(i) : li(Le(pt(On(s)), On, jt("id")), i) || Oe(i);
            };
            if (n === tr.map) {
                const t = li(Le(bi(()=>Ao(r), yi(j, [
                    "COU",
                    "COUNTRY",
                    "LOC",
                    "LOCATION",
                    "REF_AREA"
                ]), pt(On(r))), jt("id")), h);
                if (t) return [
                    t,
                    Oe(kt(_i(t.id, "id"), e)) || c(h, t.id)
                ];
            }
            if (Ai(e) >= 2) return [
                Oe(e),
                Fi(1, e)
            ];
            if (1 === Ai(e)) {
                const t = Oe(e);
                return [
                    t,
                    c(h, t.id)
                ];
            }
            return [
                Oe(h),
                Fi(1, h)
            ];
        })(u, p, {
            chartType: e,
            mapCountryDimension: i,
            dotStatUrlHasLastNObservationsEqOne: n,
            dimensionCodeUsedWhenOnlyOneDimensionHasMoreThanOneMember: l,
            dotStatXAxisDimension: h,
            dotStatYAxisDimension: c
        })), m = li(Yd, u), b = kt(Le(yi(j, [
            f.id,
            g.id
        ]), jt("id")), u), y = Le(Rt((t)=>({
                id: t.id,
                name: t.name,
                memberCodes: Rt(jt("id"), t.values)
            })), St(Le(fi(j, 1), Ai, jt("values"))), jn(()=>n, kt(Yd)))(b), x = Ai(ht(d)), v = Vi(()=>({
                value: null
            }), Ai(g.values)), w = Xi(Ai(u) - 1, "keyPosition", f), C = Xi(Ai(u) - 1, "keyPosition", g), S = m ? Xi(Ai(u) - 1, "keyPosition", m) : -1, k = m && n, A = Le((t)=>{
            const e = Rt(jt("id"), f.values), i = Rt(Oe, t), n = Ue(e, i);
            if (Si(n)) return t;
            const r = Vi(()=>({
                    value: null
                }), Ai(Oe(t)) - 1), o = Rt((t)=>Yi(t, r), n);
            return Ne(t, o);
        }, Rt((t)=>{
            let [e, i] = t;
            return Yi(e, i);
        }), Ln, Gt((t, e)=>{
            let [i, [n]] = e;
            const r = Qi(":", i), o = ((t)=>Le(jt("id"), Fi(t))(f.values))(parseInt(Fi(w, r), 10)), s = parseInt(Fi(C, r), 10), a = jn(()=>k, (t)=>{
                const e = ((t)=>Le(jt("id"), Fi(t))(m?.values || []))(parseInt(Fi(S, r), 10));
                return he("metadata", {
                    timeCode: e
                }, t);
            })({
                value: n
            });
            return mi(o, t) ? oi({
                [o]: Ei(s, a)
            }, t) : he(o, Ei(s, a, v), t);
        }, {}))(Ln(d)), E = Le(Ri, Rt(Le(Ai, kt(Le(ae, jt("value"))), Te)))(A), M = Od(o, r, a, s), T = Wd(g.values, s, M), P = {
            xDimensionLabelByCode: Wd(f.values, s, M),
            yDimensionLabelByCode: T,
            otherDimensionsLabelByCode: Le(Gt((t, e)=>Ii(t, Wd(e.values, s, M)), {}))(b)
        }, R = k ? Le(()=>{
            const t = Le(kt(ae), Rt(Hi([
                "metadata",
                "timeCode"
            ])), Dn, Rt(Te))(A), e = Zi(je, t);
            return {
                latestYMin: Oe(e),
                latestYMax: ei(e)
            };
        })() : {}, L = Ne([
            "Category"
        ], Rt(jt("id"), jt("values", g)));
        return {
            data: Yi(L, A),
            parsingHelperData: P,
            dotStatInfo: {
                unusedDimensions: y,
                totalNumberOfDataPoint: x,
                numberOfUsedDataPoint: E
            },
            ...R
        };
    };
}, qd = {
    small: {
        size: "15px",
        borderSize: "3px"
    },
    medium: {
        size: "25px",
        borderSize: "4px"
    },
    large: {
        size: "50px",
        borderSize: "5px"
    }
}, Vd = (t)=>{
    let { size: e = "medium" } = t;
    return React.createElement("div", {
        style: {
            borderRadius: "50%",
            width: qd[e].size,
            height: qd[e].size,
            maxWidth: qd[e].size,
            maxHeight: qd[e].size,
            border: `${qd[e].borderSize} solid rgba(189,189,189,0.25)`,
            borderLeftColor: "#002060",
            borderTopColor: "#002060"
        },
        className: "cb-spinner-animation"
    });
};
Vd.propTypes = {
    size: P.oneOf([
        "small",
        "medium",
        "large"
    ])
};
const $d = (t, e, i, n)=>tl(t) ? !tl(e) || Number(e) < 0 || Number(e) > 100 ? kr.numberFormat(t, -1, i, n) : kr.numberFormat(t, el(t, e) === el(t, 0) ? 0 : e, i, n) : t, Kd = (t)=>{
    let { chartType: e, mapColorValueSteps: i, maxNumberOfDecimals: n, noThousandsSeparator: r, codeLabelMapping: o, decimalPoint: s, areCategoriesNumbers: a, areCategoriesDates: l, categoriesDateFomat: h, lang: c } = t;
    const d = tl(n), u = s || pr.point.value, p = e === tr.map && !Ao(i) && Q(Le(pt(2), Ai), i), f = {
        formatter: function() {
            return $d(this.point.value || this.point.z || this.point.y, d ? n : -1, u, r ? "" : null);
        }
    }, g = l ? jt(h, Ua) : null;
    return {
        dataLabels: f,
        tooltip: {
            formatter: function(t) {
                const s = `${t.options.headerFormat}${t.options.pointFormat}`, l = this.point.y ?? this.point.value ?? this.point.z, h = this.point.__metadata?.timeCode, d = h ? jt(h, o) : null, f = p ? Fi(1, li(Le(pt(`${l}`), Oe), i) || []) || l : $d(l, n, u, r ? "" : null), m = e === tr.map ? this.point.name : this.series.name;
                return Le(Le((t)=>$i("{series.name}", m, t), (t)=>{
                    const i = e === tr.pie ? this.point.name : this.point.category ?? this.series.name, o = d ? ` - ${d}` : "";
                    return yi(e, er) ? $i("{point.key}", `${i}${o}`, t) : ae(g) ? $i("{point.key}", a ? `${$d(i, n, u, r ? "" : null)}${o}` : `${i}${o}`, t) : $i("{point.key}", g.formatToLabel(i, c), t);
                }), $i("{point.color}", this.color), $i("{point.y}", f))(s);
            }
        },
        xAxisLabels: g && !yi(e, er) ? {
            formatter: function() {
                return g.formatToLabel(this.value, c);
            }
        } : {}
    };
}, Zd = (t)=>{
    let { height: e = "100%", children: i = null } = t;
    return React.createElement("div", {
        style: {
            minHeight: "inherit",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: e
        }
    }, i);
};
Zd.propTypes = {
    height: P.oneOfType([
        P.string,
        P.number
    ]),
    children: P.oneOfType([
        P.arrayOf(P.node),
        P.node
    ])
};
const Qd = async function(t) {
    let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return (async (t)=>{
        if (t.status >= 200 && t.status < 300) return t.json();
        let e = null;
        try {
            e = await t.json();
        } catch (e) {
            throw new Error(t.statusText);
        }
        throw mi("error", e) ? new Error(jt("error", e)) : new Error(t.statusText);
    })(await fetch(t, e));
}, Jd = ()=>React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 256 256"
    }, React.createElement("path", {
        d: "M46,180c0,12.13,8.07,22,18,22a16.24,16.24,0,0,0,11.67-5.28,6,6,0,0,1,8.66,8.3A28.06,28.06,0,0,1,64,214c-16.54,0-30-15.25-30-34s13.46-34,30-34a28.06,28.06,0,0,1,20.33,9,6,6,0,0,1-8.66,8.3A16.23,16.23,0,0,0,64,158C54.07,158,46,167.86,46,180Zm81.05-6.77c-10.86-3.13-13.41-4.69-13-7.91a6.59,6.59,0,0,1,2.88-5.08c5.6-3.79,17.66-1.82,21.45-.84a6,6,0,0,0,3.06-11.6c-2-.53-20.1-5-31.21,2.48a18.61,18.61,0,0,0-8.08,13.54c-1.8,14.19,12.26,18.25,21.57,20.94,12.12,3.5,14.78,5.33,14.2,9.76a6.85,6.85,0,0,1-3,5.34c-5.61,3.73-17.48,1.64-21.19.62A6,6,0,0,0,110.48,212a59.41,59.41,0,0,0,14.68,2c5.49,0,11.54-.95,16.36-4.14a18.89,18.89,0,0,0,8.31-13.81C151.84,180.39,136.92,176.08,127.05,173.22Zm83-26.88a6,6,0,0,0-7.67,3.63L188,190.15,173.65,150a6,6,0,1,0-11.3,4l20,56a6,6,0,0,0,11.3,0l20-56A6,6,0,0,0,210,146.34ZM214,88v24a6,6,0,1,1-12,0V94H152a6,6,0,0,1-6-6V38H56a2,2,0,0,0-2,2v72a6,6,0,1,1-12,0V40A14,14,0,0,1,56,26h96a6,6,0,0,1,4.24,1.76l56,56A6,6,0,0,1,214,88Zm-20.49-6L158,46.48V82Z"
    })), tu = ()=>React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 256 256"
    }, React.createElement("path", {
        d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z"
    })), eu = ()=>React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 256 256"
    }, React.createElement("path", {
        d: "M60,146H44a6,6,0,0,0-6,6v56a6,6,0,0,0,12,0V198H60a26,26,0,0,0,0-52Zm0,40H50V158H60a14,14,0,0,1,0,28Zm162,14.87a6,6,0,0,1-1.67,4.15A28.06,28.06,0,0,1,200,214c-16.54,0-30-15.25-30-34s13.46-34,30-34a27.43,27.43,0,0,1,15.36,4.77,6,6,0,0,1-6.72,9.95A15.25,15.25,0,0,0,200,158c-9.93,0-18,9.87-18,22s8.07,22,18,22a15.75,15.75,0,0,0,10-3.73V190h-2a6,6,0,0,1,0-12h8a6,6,0,0,1,6,6ZM154,152v56a6,6,0,0,1-4.17,5.71A5.78,5.78,0,0,1,148,214a6,6,0,0,1-4.88-2.51L114,170.72V208a6,6,0,0,1-12,0V152a6,6,0,0,1,10.88-3.49L142,189.28V152a6,6,0,0,1,12,0ZM48,118a6,6,0,0,0,6-6V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50v18a6,6,0,0,0,12,0V88a6,6,0,0,0-1.76-4.24l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40v72A6,6,0,0,0,48,118ZM158,46.48,193.52,82H158Z"
    })), iu = ()=>React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 256 256"
    }, React.createElement("path", {
        d: "M212.24,83.75l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40v72a6,6,0,0,0,12,0V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50v18a6,6,0,1,0,12,0V88A6,6,0,0,0,212.24,83.75ZM158,46.48,193.52,82H158ZM85.83,196.05a18.85,18.85,0,0,1-8.3,13.81C72.71,213.05,66.66,214,61.16,214a59.38,59.38,0,0,1-14.67-2,6,6,0,0,1,3.23-11.56c3.71,1,15.58,3.11,21.19-.62a6.85,6.85,0,0,0,3-5.34c.57-4.43-2.08-6.26-14.2-9.76-9.31-2.69-23.37-6.75-21.57-20.94a18.61,18.61,0,0,1,8.08-13.54c11.11-7.49,29.18-3,31.2-2.48a6,6,0,0,1-3,11.6c-3.79-1-15.85-2.95-21.45.84a6.59,6.59,0,0,0-2.88,5.08c-.41,3.22,2.14,4.78,13,7.91C72.93,176.08,87.85,180.39,85.83,196.05Zm63.82-42-20,56a6,6,0,0,1-11.3,0l-20-56a6,6,0,1,1,11.3-4L124,190.15,138.35,150a6,6,0,0,1,11.3,4ZM214,184v16.87a6,6,0,0,1-1.67,4.15A28.06,28.06,0,0,1,192,214c-16.54,0-30-15.25-30-34s13.46-34,30-34a27.43,27.43,0,0,1,15.36,4.77,6,6,0,0,1-6.72,10A15.25,15.25,0,0,0,192,158c-9.92,0-18,9.87-18,22s8.08,22,18,22a15.7,15.7,0,0,0,10-3.74V190h-2a6,6,0,0,1,0-12h8A6,6,0,0,1,214,184Z"
    })), nu = ()=>React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 256 256"
    }, React.createElement("path", {
        d: "M214,48V88a6,6,0,0,1-12,0V54H168a6,6,0,0,1,0-12h40A6,6,0,0,1,214,48ZM88,202H54V168a6,6,0,0,0-12,0v40a6,6,0,0,0,6,6H88a6,6,0,0,0,0-12Zm120-40a6,6,0,0,0-6,6v34H168a6,6,0,0,0,0,12h40a6,6,0,0,0,6-6V168A6,6,0,0,0,208,162ZM88,42H48a6,6,0,0,0-6,6V88a6,6,0,0,0,12,0V54H88a6,6,0,0,0,0-12Z"
    })), ru = ()=>React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 256 256"
    }, React.createElement("path", {
        d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z"
    }));
function ou() {
    return "undefined" != typeof window;
}
function su(t) {
    return hu(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function au(t) {
    var e;
    return (null == t || null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function lu(t) {
    var e;
    return null == (e = (hu(t) ? t.ownerDocument : t.document) || window.document) ? void 0 : e.documentElement;
}
function hu(t) {
    return !!ou() && (t instanceof Node || t instanceof au(t).Node);
}
function cu(t) {
    return !!ou() && (t instanceof Element || t instanceof au(t).Element);
}
function du(t) {
    return !!ou() && (t instanceof HTMLElement || t instanceof au(t).HTMLElement);
}
function uu(t) {
    return !(!ou() || "undefined" == typeof ShadowRoot) && (t instanceof ShadowRoot || t instanceof au(t).ShadowRoot);
}
function pu(t) {
    const { overflow: e, overflowX: i, overflowY: n, display: r } = xu(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + n + i) && ![
        "inline",
        "contents"
    ].includes(r);
}
function fu(t) {
    return [
        "table",
        "td",
        "th"
    ].includes(su(t));
}
function gu(t) {
    return [
        ":popover-open",
        ":modal"
    ].some((e)=>{
        try {
            return t.matches(e);
        } catch (t) {
            return !1;
        }
    });
}
function mu(t) {
    const e = bu(), i = cu(t) ? xu(t) : t;
    return "none" !== i.transform || "none" !== i.perspective || !!i.containerType && "normal" !== i.containerType || !e && !!i.backdropFilter && "none" !== i.backdropFilter || !e && !!i.filter && "none" !== i.filter || [
        "transform",
        "perspective",
        "filter"
    ].some((t)=>(i.willChange || "").includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>(i.contain || "").includes(t));
}
function bu() {
    return !("undefined" == typeof CSS || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function yu(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes(su(t));
}
function xu(t) {
    return au(t).getComputedStyle(t);
}
function vu(t) {
    return cu(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.scrollX,
        scrollTop: t.scrollY
    };
}
function wu(t) {
    if ("html" === su(t)) return t;
    const e = t.assignedSlot || t.parentNode || uu(t) && t.host || lu(t);
    return uu(e) ? e.host : e;
}
function Cu(t) {
    const e = wu(t);
    return yu(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : du(e) && pu(e) ? e : Cu(e);
}
function Su(t, e, i) {
    var n;
    void 0 === e && (e = []), void 0 === i && (i = !0);
    const r = Cu(t), o = r === (null == (n = t.ownerDocument) ? void 0 : n.body), s = au(r);
    if (o) {
        const t = function(t) {
            return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
        }(s);
        return e.concat(s, s.visualViewport || [], pu(r) ? r : [], t && i ? Su(t) : []);
    }
    return e.concat(r, Su(r, [], i));
}
function ku(t) {
    let e = t.activeElement;
    for(; null != (null == (i = e) || null == (i = i.shadowRoot) ? void 0 : i.activeElement);){
        var i;
        e = e.shadowRoot.activeElement;
    }
    return e;
}
function Au(t, e) {
    if (!t || !e) return !1;
    const i = null == e.getRootNode ? void 0 : e.getRootNode();
    if (t.contains(e)) return !0;
    if (i && uu(i)) {
        let i = e;
        for(; i;){
            if (t === i) return !0;
            i = i.parentNode || i.host;
        }
    }
    return !1;
}
function Eu() {
    const t = navigator.userAgentData;
    return null != t && t.platform ? t.platform : navigator.platform;
}
function Mu() {
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? t.brands.map((t)=>{
        let { brand: e, version: i } = t;
        return e + "/" + i;
    }).join(" ") : navigator.userAgent;
}
function Tu(t) {
    return !Mu().includes("jsdom/") && (!Ru() && 0 === t.width && 0 === t.height || Ru() && 1 === t.width && 1 === t.height && 0 === t.pressure && 0 === t.detail && "mouse" === t.pointerType || t.width < 1 && t.height < 1 && 0 === t.pressure && 0 === t.detail && "touch" === t.pointerType);
}
function Pu() {
    return /apple/i.test(navigator.vendor);
}
function Ru() {
    const t = /android/i;
    return t.test(Eu()) || t.test(Mu());
}
function Lu(t, e) {
    const i = [
        "mouse",
        "pen"
    ];
    return e || i.push("", void 0), i.includes(t);
}
function Ou(t) {
    return (null == t ? void 0 : t.ownerDocument) || document;
}
function Du(t, e) {
    if (null == e) return !1;
    if ("composedPath" in t) return t.composedPath().includes(e);
    const i = t;
    return null != i.target && e.contains(i.target);
}
function ju(t) {
    return "composedPath" in t ? t.composedPath()[0] : t.target;
}
const Nu = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function Iu(t) {
    return du(t) && t.matches(Nu);
}
function Bu(t) {
    t.preventDefault(), t.stopPropagation();
}
const Fu = Math.min, zu = Math.max, Hu = Math.round, Uu = Math.floor, Wu = (t)=>({
        x: t,
        y: t
    }), Yu = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
}, _u = {
    start: "end",
    end: "start"
};
function Xu(t, e, i) {
    return zu(t, Fu(e, i));
}
function Gu(t, e) {
    return "function" == typeof t ? t(e) : t;
}
function qu(t) {
    return t.split("-")[0];
}
function Vu(t) {
    return t.split("-")[1];
}
function $u(t) {
    return "x" === t ? "y" : "x";
}
function Ku(t) {
    return "y" === t ? "height" : "width";
}
function Zu(t) {
    return [
        "top",
        "bottom"
    ].includes(qu(t)) ? "y" : "x";
}
function Qu(t) {
    return $u(Zu(t));
}
function Ju(t) {
    return t.replace(/start|end/g, (t)=>_u[t]);
}
function tp(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>Yu[t]);
}
function ep(t) {
    const { x: e, y: i, width: n, height: r } = t;
    return {
        width: n,
        height: r,
        top: i,
        left: e,
        right: e + n,
        bottom: i + r,
        x: e,
        y: i
    };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ var ip = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
].join(","), np = "undefined" == typeof Element, rp = np ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, op = !np && Element.prototype.getRootNode ? function(t) {
    var e;
    return null == t || null === (e = t.getRootNode) || void 0 === e ? void 0 : e.call(t);
} : function(t) {
    return null == t ? void 0 : t.ownerDocument;
}, sp = function t(e, i) {
    var n;
    void 0 === i && (i = !0);
    var r = null == e || null === (n = e.getAttribute) || void 0 === n ? void 0 : n.call(e, "inert");
    return "" === r || "true" === r || i && e && t(e.parentNode);
}, ap = function t(e, i, n) {
    for(var r = [], o = Array.from(e); o.length;){
        var s = o.shift();
        if (!sp(s, !1)) {
            if ("SLOT" === s.tagName) {
                var a = s.assignedElements(), l = t(a.length ? a : s.children, !0, n);
                n.flatten ? r.push.apply(r, l) : r.push({
                    scopeParent: s,
                    candidates: l
                });
            } else {
                rp.call(s, ip) && n.filter(s) && (i || !e.includes(s)) && r.push(s);
                var h = s.shadowRoot || "function" == typeof n.getShadowRoot && n.getShadowRoot(s), c = !sp(h, !1) && (!n.shadowRootFilter || n.shadowRootFilter(s));
                if (h && c) {
                    var d = t(!0 === h ? s.children : h.children, !0, n);
                    n.flatten ? r.push.apply(r, d) : r.push({
                        scopeParent: s,
                        candidates: d
                    });
                } else o.unshift.apply(o, s.children);
            }
        }
    }
    return r;
}, lp = function(t) {
    return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, hp = function(t) {
    if (!t) throw new Error("No node provided");
    return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || function(t) {
        var e, i = null == t || null === (e = t.getAttribute) || void 0 === e ? void 0 : e.call(t, "contenteditable");
        return "" === i || "true" === i;
    }(t)) && !lp(t) ? 0 : t.tabIndex;
}, cp = function(t, e) {
    return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
}, dp = function(t) {
    return "INPUT" === t.tagName;
}, up = function(t) {
    return function(t) {
        return dp(t) && "radio" === t.type;
    }(t) && !function(t) {
        if (!t.name) return !0;
        var e, i = t.form || op(t), n = function(t) {
            return i.querySelectorAll('input[type="radio"][name="' + t + '"]');
        };
        if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) e = n(window.CSS.escape(t.name));
        else try {
            e = n(t.name);
        } catch (t) {
            return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", t.message), !1;
        }
        var r = function(t, e) {
            for(var i = 0; i < t.length; i++)if (t[i].checked && t[i].form === e) return t[i];
        }(e, t.form);
        return !r || r === t;
    }(t);
}, pp = function(t) {
    var e = t.getBoundingClientRect(), i = e.width, n = e.height;
    return 0 === i && 0 === n;
}, fp = function(t, e) {
    var i = e.displayCheck, n = e.getShadowRoot;
    if ("hidden" === getComputedStyle(t).visibility) return !0;
    var r = rp.call(t, "details>summary:first-of-type") ? t.parentElement : t;
    if (rp.call(r, "details:not([open]) *")) return !0;
    if (i && "full" !== i && "legacy-full" !== i) {
        if ("non-zero-area" === i) return pp(t);
    } else {
        if ("function" == typeof n) {
            for(var o = t; t;){
                var s = t.parentElement, a = op(t);
                if (s && !s.shadowRoot && !0 === n(s)) return pp(t);
                t = t.assignedSlot ? t.assignedSlot : s || a === t.ownerDocument ? s : a.host;
            }
            t = o;
        }
        if (function(t) {
            var e, i, n, r, o = t && op(t), s = null === (e = o) || void 0 === e ? void 0 : e.host, a = !1;
            if (o && o !== t) for(a = !!(null !== (i = s) && void 0 !== i && null !== (n = i.ownerDocument) && void 0 !== n && n.contains(s) || null != t && null !== (r = t.ownerDocument) && void 0 !== r && r.contains(t)); !a && s;){
                var l, h, c;
                a = !(null === (h = s = null === (l = o = op(s)) || void 0 === l ? void 0 : l.host) || void 0 === h || null === (c = h.ownerDocument) || void 0 === c || !c.contains(s));
            }
            return a;
        }(t)) return !t.getClientRects().length;
        if ("legacy-full" !== i) return !0;
    }
    return !1;
}, gp = function(t, e) {
    return !(e.disabled || sp(e) || function(t) {
        return dp(t) && "hidden" === t.type;
    }(e) || fp(e, t) || function(t) {
        return "DETAILS" === t.tagName && Array.prototype.slice.apply(t.children).some(function(t) {
            return "SUMMARY" === t.tagName;
        });
    }(e) || function(t) {
        if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName)) for(var e = t.parentElement; e;){
            if ("FIELDSET" === e.tagName && e.disabled) {
                for(var i = 0; i < e.children.length; i++){
                    var n = e.children.item(i);
                    if ("LEGEND" === n.tagName) return !!rp.call(e, "fieldset[disabled] *") || !n.contains(t);
                }
                return !0;
            }
            e = e.parentElement;
        }
        return !1;
    }(e));
}, mp = function(t, e) {
    return !(up(e) || hp(e) < 0 || !gp(t, e));
}, bp = function(t) {
    var e = parseInt(t.getAttribute("tabindex"), 10);
    return !!(isNaN(e) || e >= 0);
}, yp = function t(e) {
    var i = [], n = [];
    return e.forEach(function(e, r) {
        var o = !!e.scopeParent, s = o ? e.scopeParent : e, a = function(t, e) {
            var i = hp(t);
            return i < 0 && e && !lp(t) ? 0 : i;
        }(s, o), l = o ? t(e.candidates) : s;
        0 === a ? o ? i.push.apply(i, l) : i.push(s) : n.push({
            documentOrder: r,
            tabIndex: a,
            item: e,
            isScope: o,
            content: l
        });
    }), n.sort(cp).reduce(function(_t1, e) {
        return e.isScope ? _t1.push.apply(_t1, e.content) : _t1.push(e.content), _t1;
    }, []).concat(i);
}, xp = function(t, e) {
    var i;
    return i = (e = e || {}).getShadowRoot ? ap([
        t
    ], e.includeContainer, {
        filter: mp.bind(null, e),
        flatten: !1,
        getShadowRoot: e.getShadowRoot,
        shadowRootFilter: bp
    }) : function(t, e, i) {
        if (sp(t)) return [];
        var n = Array.prototype.slice.apply(t.querySelectorAll(ip));
        return e && rp.call(t, ip) && n.unshift(t), n.filter(i);
    }(t, e.includeContainer, mp.bind(null, e)), yp(i);
}, vp = function(t, e) {
    if (e = e || {}, !t) throw new Error("No node provided");
    return !1 !== rp.call(t, ip) && mp(e, t);
};
function wp(t, e, i) {
    let { reference: n, floating: r } = t;
    const o = Zu(e), s = Qu(e), a = Ku(s), l = qu(e), h = "y" === o, c = n.x + n.width / 2 - r.width / 2, d = n.y + n.height / 2 - r.height / 2, u = n[a] / 2 - r[a] / 2;
    let p;
    switch(l){
        case "top":
            p = {
                x: c,
                y: n.y - r.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: n.y + n.height
            };
            break;
        case "right":
            p = {
                x: n.x + n.width,
                y: d
            };
            break;
        case "left":
            p = {
                x: n.x - r.width,
                y: d
            };
            break;
        default:
            p = {
                x: n.x,
                y: n.y
            };
    }
    switch(Vu(e)){
        case "start":
            p[s] -= u * (i && h ? -1 : 1);
            break;
        case "end":
            p[s] += u * (i && h ? -1 : 1);
    }
    return p;
}
async function Cp(t, e) {
    var i;
    void 0 === e && (e = {});
    const { x: n, y: r, platform: o, rects: s, elements: a, strategy: l } = t, { boundary: h = "clippingAncestors", rootBoundary: c = "viewport", elementContext: d = "floating", altBoundary: u = !1, padding: p = 0 } = Gu(e, t), f = function(t) {
        return "number" != typeof t ? function(t) {
            return {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                ...t
            };
        }(t) : {
            top: t,
            right: t,
            bottom: t,
            left: t
        };
    }(p), g = a[u ? "floating" === d ? "reference" : "floating" : d], m = ep(await o.getClippingRect({
        element: null == (i = await (null == o.isElement ? void 0 : o.isElement(g))) || i ? g : g.contextElement || await (null == o.getDocumentElement ? void 0 : o.getDocumentElement(a.floating)),
        boundary: h,
        rootBoundary: c,
        strategy: l
    })), b = "floating" === d ? {
        ...s.floating,
        x: n,
        y: r
    } : s.reference, y = await (null == o.getOffsetParent ? void 0 : o.getOffsetParent(a.floating)), x = await (null == o.isElement ? void 0 : o.isElement(y)) && await (null == o.getScale ? void 0 : o.getScale(y)) || {
        x: 1,
        y: 1
    }, v = ep(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: a,
        rect: b,
        offsetParent: y,
        strategy: l
    }) : b);
    return {
        top: (m.top - v.top + f.top) / x.y,
        bottom: (v.bottom - m.bottom + f.bottom) / x.y,
        left: (m.left - v.left + f.left) / x.x,
        right: (v.right - m.right + f.right) / x.x
    };
}
const Sp = function(t) {
    return void 0 === t && (t = 0), {
        name: "offset",
        options: t,
        async fn (e) {
            var i, n;
            const { x: r, y: o, placement: s, middlewareData: a } = e, l = await async function(t, e) {
                const { placement: i, platform: n, elements: r } = t, o = await (null == n.isRTL ? void 0 : n.isRTL(r.floating)), s = qu(i), a = Vu(i), l = "y" === Zu(i), h = [
                    "left",
                    "top"
                ].includes(s) ? -1 : 1, c = o && l ? -1 : 1, d = Gu(e, t);
                let { mainAxis: u, crossAxis: p, alignmentAxis: f } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return a && "number" == typeof f && (p = "end" === a ? -1 * f : f), l ? {
                    x: p * c,
                    y: u * h
                } : {
                    x: u * h,
                    y: p * c
                };
            }(e, t);
            return s === (null == (i = a.offset) ? void 0 : i.placement) && null != (n = a.arrow) && n.alignmentOffset ? {} : {
                x: r + l.x,
                y: o + l.y,
                data: {
                    ...l,
                    placement: s
                }
            };
        }
    };
};
function kp(t) {
    const e = xu(t);
    let i = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
    const r = du(t), o = r ? t.offsetWidth : i, s = r ? t.offsetHeight : n, a = Hu(i) !== o || Hu(n) !== s;
    return a && (i = o, n = s), {
        width: i,
        height: n,
        $: a
    };
}
function Ap(t) {
    return cu(t) ? t : t.contextElement;
}
function Ep(t) {
    const e = Ap(t);
    if (!du(e)) return Wu(1);
    const i = e.getBoundingClientRect(), { width: n, height: r, $: o } = kp(e);
    let s = (o ? Hu(i.width) : i.width) / n, a = (o ? Hu(i.height) : i.height) / r;
    return s && Number.isFinite(s) || (s = 1), a && Number.isFinite(a) || (a = 1), {
        x: s,
        y: a
    };
}
const Mp = Wu(0);
function Tp(t) {
    const e = au(t);
    return bu() && e.visualViewport ? {
        x: e.visualViewport.offsetLeft,
        y: e.visualViewport.offsetTop
    } : Mp;
}
function Pp(t, e, i, n) {
    void 0 === e && (e = !1), void 0 === i && (i = !1);
    const r = t.getBoundingClientRect(), o = Ap(t);
    let s = Wu(1);
    e && (n ? cu(n) && (s = Ep(n)) : s = Ep(t));
    const a = function(t, e, i) {
        return void 0 === e && (e = !1), !(!i || e && i !== au(t)) && e;
    }(o, i, n) ? Tp(o) : Wu(0);
    let l = (r.left + a.x) / s.x, h = (r.top + a.y) / s.y, c = r.width / s.x, d = r.height / s.y;
    if (o) {
        const t = au(o), e = n && cu(n) ? au(n) : n;
        let i = t, r = i.frameElement;
        for(; r && n && e !== i;){
            const t = Ep(r), e = r.getBoundingClientRect(), n = xu(r), o = e.left + (r.clientLeft + parseFloat(n.paddingLeft)) * t.x, s = e.top + (r.clientTop + parseFloat(n.paddingTop)) * t.y;
            l *= t.x, h *= t.y, c *= t.x, d *= t.y, l += o, h += s, i = au(r), r = i.frameElement;
        }
    }
    return ep({
        width: c,
        height: d,
        x: l,
        y: h
    });
}
const Rp = [
    ":popover-open",
    ":modal"
];
function Lp(t) {
    return Rp.some((e)=>{
        try {
            return t.matches(e);
        } catch (t) {
            return !1;
        }
    });
}
function Op(t) {
    return Pp(lu(t)).left + vu(t).scrollLeft;
}
function Dp(t, e, i) {
    let n;
    if ("viewport" === e) n = function(t, e) {
        const i = au(t), n = lu(t), r = i.visualViewport;
        let o = n.clientWidth, s = n.clientHeight, a = 0, l = 0;
        if (r) {
            o = r.width, s = r.height;
            const t = bu();
            (!t || t && "fixed" === e) && (a = r.offsetLeft, l = r.offsetTop);
        }
        return {
            width: o,
            height: s,
            x: a,
            y: l
        };
    }(t, i);
    else if ("document" === e) n = function(t) {
        const e = lu(t), i = vu(t), n = t.ownerDocument.body, r = zu(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), o = zu(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
        let s = -i.scrollLeft + Op(t);
        const a = -i.scrollTop;
        return "rtl" === xu(n).direction && (s += zu(e.clientWidth, n.clientWidth) - r), {
            width: r,
            height: o,
            x: s,
            y: a
        };
    }(lu(t));
    else if (cu(e)) n = function(t, e) {
        const i = Pp(t, !0, "fixed" === e), n = i.top + t.clientTop, r = i.left + t.clientLeft, o = du(t) ? Ep(t) : Wu(1);
        return {
            width: t.clientWidth * o.x,
            height: t.clientHeight * o.y,
            x: r * o.x,
            y: n * o.y
        };
    }(e, i);
    else {
        const i = Tp(t);
        n = {
            ...e,
            x: e.x - i.x,
            y: e.y - i.y
        };
    }
    return ep(n);
}
function jp(t, e) {
    const i = wu(t);
    return !(i === e || !cu(i) || yu(i)) && ("fixed" === xu(i).position || jp(i, e));
}
function Np(t, e, i) {
    const n = du(e), r = lu(e), o = "fixed" === i, s = Pp(t, !0, o, e);
    let a = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const l = Wu(0);
    if (n || !n && !o) {
        if (("body" !== su(e) || pu(r)) && (a = vu(e)), n) {
            const t = Pp(e, !0, o, e);
            l.x = t.x + e.clientLeft, l.y = t.y + e.clientTop;
        } else r && (l.x = Op(r));
    }
    return {
        x: s.left + a.scrollLeft - l.x,
        y: s.top + a.scrollTop - l.y,
        width: s.width,
        height: s.height
    };
}
function Ip(t, e) {
    return du(t) && "fixed" !== xu(t).position ? e ? e(t) : t.offsetParent : null;
}
function Bp(t, e) {
    const i = au(t);
    if (!du(t) || Lp(t)) return i;
    let n = Ip(t, e);
    for(; n && fu(n) && "static" === xu(n).position;)n = Ip(n, e);
    return n && ("html" === su(n) || "body" === su(n) && "static" === xu(n).position && !mu(n)) ? i : n || function(t) {
        let e = wu(t);
        for(; du(e) && !yu(e);){
            if (mu(e)) return e;
            if (gu(e)) return null;
            e = wu(e);
        }
        return null;
    }(t) || i;
}
const Fp = {
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { elements: e, rect: i, offsetParent: n, strategy: r } = t;
        const o = "fixed" === r, s = lu(n), a = !!e && Lp(e.floating);
        if (n === s || a && o) return i;
        let l = {
            scrollLeft: 0,
            scrollTop: 0
        }, h = Wu(1);
        const c = Wu(0), d = du(n);
        if ((d || !d && !o) && (("body" !== su(n) || pu(s)) && (l = vu(n)), du(n))) {
            const t = Pp(n);
            h = Ep(n), c.x = t.x + n.clientLeft, c.y = t.y + n.clientTop;
        }
        return {
            width: i.width * h.x,
            height: i.height * h.y,
            x: i.x * h.x - l.scrollLeft * h.x + c.x,
            y: i.y * h.y - l.scrollTop * h.y + c.y
        };
    },
    getDocumentElement: lu,
    getClippingRect: function(t) {
        let { element: e, boundary: i, rootBoundary: n, strategy: r } = t;
        const o = [
            ..."clippingAncestors" === i ? function(t, e) {
                const i = e.get(t);
                if (i) return i;
                let n = Su(t, [], !1).filter((t)=>cu(t) && "body" !== su(t)), r = null;
                const o = "fixed" === xu(t).position;
                let s = o ? wu(t) : t;
                for(; cu(s) && !yu(s);){
                    const e = xu(s), i = mu(s);
                    i || "fixed" !== e.position || (r = null), (o ? !i && !r : !i && "static" === e.position && r && [
                        "absolute",
                        "fixed"
                    ].includes(r.position) || pu(s) && !i && jp(t, s)) ? n = n.filter((t)=>t !== s) : r = e, s = wu(s);
                }
                return e.set(t, n), n;
            }(e, this._c) : [].concat(i),
            n
        ], s = o[0], a = o.reduce((t, i)=>{
            const n = Dp(e, i, r);
            return t.top = zu(n.top, t.top), t.right = Fu(n.right, t.right), t.bottom = Fu(n.bottom, t.bottom), t.left = zu(n.left, t.left), t;
        }, Dp(e, s, r));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    getOffsetParent: Bp,
    getElementRects: async function(t) {
        const e = this.getOffsetParent || Bp, i = this.getDimensions;
        return {
            reference: Np(t.reference, await e(t.floating), t.strategy),
            floating: {
                x: 0,
                y: 0,
                ...await i(t.floating)
            }
        };
    },
    getClientRects: function(t) {
        return Array.from(t.getClientRects());
    },
    getDimensions: function(t) {
        const { width: e, height: i } = kp(t);
        return {
            width: e,
            height: i
        };
    },
    getScale: Ep,
    isElement: cu,
    isRTL: function(t) {
        return "rtl" === xu(t).direction;
    }
};
function zp(t, e, i, n) {
    void 0 === n && (n = {});
    const { ancestorScroll: r = !0, ancestorResize: o = !0, elementResize: s = "function" == typeof ResizeObserver, layoutShift: a = "function" == typeof IntersectionObserver, animationFrame: l = !1 } = n, h = Ap(t), c = r || o ? [
        ...h ? Su(h) : [],
        ...Su(e)
    ] : [];
    c.forEach((t)=>{
        r && t.addEventListener("scroll", i, {
            passive: !0
        }), o && t.addEventListener("resize", i);
    });
    const d = h && a ? function(t, e) {
        let i, n = null;
        const r = lu(t);
        function o() {
            var t;
            clearTimeout(i), null == (t = n) || t.disconnect(), n = null;
        }
        return function s(a, l) {
            void 0 === a && (a = !1), void 0 === l && (l = 1), o();
            const { left: h, top: c, width: d, height: u } = t.getBoundingClientRect();
            if (a || e(), !d || !u) return;
            const p = {
                rootMargin: -Uu(c) + "px " + -Uu(r.clientWidth - (h + d)) + "px " + -Uu(r.clientHeight - (c + u)) + "px " + -Uu(h) + "px",
                threshold: zu(0, Fu(1, l)) || 1
            };
            let f = !0;
            function g(t) {
                const e = t[0].intersectionRatio;
                if (e !== l) {
                    if (!f) return s();
                    e ? s(!1, e) : i = setTimeout(()=>{
                        s(!1, 1e-7);
                    }, 100);
                }
                f = !1;
            }
            try {
                n = new IntersectionObserver(g, {
                    ...p,
                    root: r.ownerDocument
                });
            } catch (t) {
                n = new IntersectionObserver(g, p);
            }
            n.observe(t);
        }(!0), o;
    }(h, i) : null;
    let u, p = -1, f = null;
    s && (f = new ResizeObserver((t)=>{
        let [n] = t;
        n && n.target === h && f && (f.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(()=>{
            var t;
            null == (t = f) || t.observe(e);
        })), i();
    }), h && !l && f.observe(h), f.observe(e));
    let g = l ? Pp(t) : null;
    return l && function e() {
        const n = Pp(t);
        !g || n.x === g.x && n.y === g.y && n.width === g.width && n.height === g.height || i();
        g = n, u = requestAnimationFrame(e);
    }(), i(), ()=>{
        var t;
        c.forEach((t)=>{
            r && t.removeEventListener("scroll", i), o && t.removeEventListener("resize", i);
        }), null == d || d(), null == (t = f) || t.disconnect(), f = null, l && cancelAnimationFrame(u);
    };
}
const Hp = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: n, placement: r } = e, { mainAxis: o = !0, crossAxis: s = !1, limiter: a = {
                fn: (t)=>{
                    let { x: e, y: i } = t;
                    return {
                        x: e,
                        y: i
                    };
                }
            }, ...l } = Gu(t, e), h = {
                x: i,
                y: n
            }, c = await Cp(e, l), d = Zu(qu(r)), u = $u(d);
            let p = h[u], f = h[d];
            if (o) {
                const t = "y" === u ? "bottom" : "right";
                p = Xu(p + c["y" === u ? "top" : "left"], p, p - c[t]);
            }
            if (s) {
                const t = "y" === d ? "bottom" : "right";
                f = Xu(f + c["y" === d ? "top" : "left"], f, f - c[t]);
            }
            const g = a.fn({
                ...e,
                [u]: p,
                [d]: f
            });
            return {
                ...g,
                data: {
                    x: g.x - i,
                    y: g.y - n
                }
            };
        }
    };
}, Up = function(t) {
    return void 0 === t && (t = {}), {
        name: "flip",
        options: t,
        async fn (e) {
            var i, n;
            const { placement: r, middlewareData: o, rects: s, initialPlacement: a, platform: l, elements: h } = e, { mainAxis: c = !0, crossAxis: d = !0, fallbackPlacements: u, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: f = "none", flipAlignment: g = !0, ...m } = Gu(t, e);
            if (null != (i = o.arrow) && i.alignmentOffset) return {};
            const b = qu(r), y = qu(a) === a, x = await (null == l.isRTL ? void 0 : l.isRTL(h.floating)), v = u || (y || !g ? [
                tp(a)
            ] : function(t) {
                const e = tp(t);
                return [
                    Ju(t),
                    e,
                    Ju(e)
                ];
            }(a));
            u || "none" === f || v.push(...function(t, e, i, n) {
                const r = Vu(t);
                let o = function(t, e, i) {
                    const n = [
                        "left",
                        "right"
                    ], r = [
                        "right",
                        "left"
                    ], o = [
                        "top",
                        "bottom"
                    ], s = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return i ? e ? r : n : e ? n : r;
                        case "left":
                        case "right":
                            return e ? o : s;
                        default:
                            return [];
                    }
                }(qu(t), "start" === i, n);
                return r && (o = o.map((t)=>t + "-" + r), e && (o = o.concat(o.map(Ju)))), o;
            }(a, g, f, x));
            const w = [
                a,
                ...v
            ], C = await Cp(e, m), S = [];
            let k = (null == (n = o.flip) ? void 0 : n.overflows) || [];
            if (c && S.push(C[b]), d) {
                const t = function(t, e, i) {
                    void 0 === i && (i = !1);
                    const n = Vu(t), r = Qu(t), o = Ku(r);
                    let s = "x" === r ? n === (i ? "end" : "start") ? "right" : "left" : "start" === n ? "bottom" : "top";
                    return e.reference[o] > e.floating[o] && (s = tp(s)), [
                        s,
                        tp(s)
                    ];
                }(r, s, x);
                S.push(C[t[0]], C[t[1]]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: S
                }
            ], !S.every((t)=>t <= 0)) {
                var A, E;
                const t = ((null == (A = o.flip) ? void 0 : A.index) || 0) + 1, e = w[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let i = null == (E = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : E.placement;
                if (!i) switch(p){
                    case "bestFit":
                        {
                            var M;
                            const t = null == (M = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : M[0];
                            t && (i = t);
                            break;
                        }
                    case "initialPlacement":
                        i = a;
                }
                if (r !== i) return {
                    reset: {
                        placement: i
                    }
                };
            }
            return {};
        }
    };
}, Wp = (t, e, i)=>{
    const n = new Map, r = {
        platform: Fp,
        ...i
    }, o = {
        ...r.platform,
        _c: n
    };
    return (async (t, e, i)=>{
        const { placement: n = "bottom", strategy: r = "absolute", middleware: o = [], platform: s } = i, a = o.filter(Boolean), l = await (null == s.isRTL ? void 0 : s.isRTL(e));
        let h = await s.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }), { x: c, y: d } = wp(h, n, l), u = n, p = {}, f = 0;
        for(let i = 0; i < a.length; i++){
            const { name: o, fn: g } = a[i], { x: m, y: b, data: y, reset: x } = await g({
                x: c,
                y: d,
                initialPlacement: n,
                placement: u,
                strategy: r,
                middlewareData: p,
                rects: h,
                platform: s,
                elements: {
                    reference: t,
                    floating: e
                }
            });
            c = null != m ? m : c, d = null != b ? b : d, p = {
                ...p,
                [o]: {
                    ...p[o],
                    ...y
                }
            }, x && f <= 50 && (f++, "object" == typeof x && (x.placement && (u = x.placement), x.rects && (h = !0 === x.rects ? await s.getElementRects({
                reference: t,
                floating: e,
                strategy: r
            }) : x.rects), { x: c, y: d } = wp(h, u, l)), i = -1);
        }
        return {
            x: c,
            y: d,
            placement: u,
            strategy: r,
            middlewareData: p
        };
    })(t, e, {
        ...r,
        platform: o
    });
};
var Yp = "undefined" != typeof document ? React.useLayoutEffect : React.useEffect;
function _p(t, e) {
    if (t === e) return !0;
    if (typeof t != typeof e) return !1;
    if ("function" == typeof t && t.toString() === e.toString()) return !0;
    let i, n, r;
    if (t && e && "object" == typeof t) {
        if (Array.isArray(t)) {
            if (i = t.length, i !== e.length) return !1;
            for(n = i; 0 != n--;)if (!_p(t[n], e[n])) return !1;
            return !0;
        }
        if (r = Object.keys(t), i = r.length, i !== Object.keys(e).length) return !1;
        for(n = i; 0 != n--;)if (!({}).hasOwnProperty.call(e, r[n])) return !1;
        for(n = i; 0 != n--;){
            const i = r[n];
            if (("_owner" !== i || !t.$$typeof) && !_p(t[i], e[i])) return !1;
        }
        return !0;
    }
    return t != t && e != e;
}
function Xp(t) {
    if ("undefined" == typeof window) return 1;
    return (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Gp(t, e) {
    const i = Xp(t);
    return Math.round(e * i) / i;
}
function qp(t) {
    const e = React.useRef(t);
    return Yp(()=>{
        e.current = t;
    }), e;
}
const Vp = (t, e)=>({
        ...Hp(t),
        options: [
            t,
            e
        ]
    }), $p = (t, e)=>({
        ...Up(t),
        options: [
            t,
            e
        ]
    });
function Kp(t) {
    return React.useMemo(()=>t.every((t)=>null == t) ? null : (e)=>{
            t.forEach((t)=>{
                "function" == typeof t ? t(e) : null != t && (t.current = e);
            });
        }, t);
}
const Zp = {
    ...React
}, Qp = Zp.useInsertionEffect || ((t)=>t());
function Jp(t) {
    const e = React.useRef(()=>{});
    return Qp(()=>{
        e.current = t;
    }), React.useCallback(function() {
        for(var t = arguments.length, i = new Array(t), n = 0; n < t; n++)i[n] = arguments[n];
        return null == e.current ? void 0 : e.current(...i);
    }, []);
}
var tf = "undefined" != typeof document ? React.useLayoutEffect : React.useEffect;
function ef() {
    return ef = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, ef.apply(this, arguments);
}
let nf = !1, rf = 0;
const of = ()=>"floating-ui-" + Math.random().toString(36).slice(2, 6) + rf++;
const sf = Zp.useId || function() {
    const [t, e] = React.useState(()=>nf ? of() : void 0);
    return tf(()=>{
        null == t && e(of());
    }, []), React.useEffect(()=>{
        nf = !0;
    }, []), t;
};
const af = React.createContext(null), lf = React.createContext(null), hf = ()=>{
    var t;
    return (null == (t = React.useContext(af)) ? void 0 : t.id) || null;
}, cf = ()=>React.useContext(lf);
function df(t) {
    return "data-floating-ui-" + t;
}
function uf(t) {
    const e = React.useRef(t);
    return tf(()=>{
        e.current = t;
    }), e;
}
const pf = df("safe-polygon");
function ff(t, e, i) {
    return i && !Lu(i) ? 0 : "number" == typeof t ? t : null == t ? void 0 : t[e];
}
let gf = 0;
function mf(t, e) {
    void 0 === e && (e = {});
    const { preventScroll: i = !1, cancelPrevious: n = !0, sync: r = !1 } = e;
    n && cancelAnimationFrame(gf);
    const o = ()=>null == t ? void 0 : t.focus({
            preventScroll: i
        });
    r ? o() : gf = requestAnimationFrame(o);
}
function bf(t, e) {
    let i = t.filter((t)=>{
        var i;
        return t.parentId === e && (null == (i = t.context) ? void 0 : i.open);
    }), n = i;
    for(; n.length;)n = t.filter((t)=>{
        var e;
        return null == (e = n) ? void 0 : e.some((e)=>{
            var i;
            return t.parentId === e.id && (null == (i = t.context) ? void 0 : i.open);
        });
    }), i = i.concat(n);
    return i;
}
let yf = new WeakMap, xf = new WeakSet, vf = {}, wf = 0;
const Cf = (t)=>t && (t.host || Cf(t.parentNode)), Sf = (t, e)=>e.map((e)=>{
        if (t.contains(e)) return e;
        const i = Cf(e);
        return t.contains(i) ? i : null;
    }).filter((t)=>null != t);
function kf(t, e, i) {
    void 0 === e && (e = !1), void 0 === i && (i = !1);
    const n = Ou(t[0]).body;
    return function(t, e, i, n) {
        const r = "data-floating-ui-inert", o = n ? "inert" : i ? "aria-hidden" : null, s = Sf(e, t), a = new Set, l = new Set(s), h = [];
        vf[r] || (vf[r] = new WeakMap);
        const c = vf[r];
        return s.forEach(function t(e) {
            e && !a.has(e) && (a.add(e), e.parentNode && t(e.parentNode));
        }), function t(e) {
            e && !l.has(e) && [].forEach.call(e.children, (e)=>{
                if ("script" !== su(e)) {
                    if (a.has(e)) t(e);
                    else {
                        const t = o ? e.getAttribute(o) : null, i = null !== t && "false" !== t, n = (yf.get(e) || 0) + 1, s = (c.get(e) || 0) + 1;
                        yf.set(e, n), c.set(e, s), h.push(e), 1 === n && i && xf.add(e), 1 === s && e.setAttribute(r, ""), !i && o && e.setAttribute(o, "true");
                    }
                }
            });
        }(e), a.clear(), wf++, ()=>{
            h.forEach((t)=>{
                const e = (yf.get(t) || 0) - 1, i = (c.get(t) || 0) - 1;
                yf.set(t, e), c.set(t, i), e || (!xf.has(t) && o && t.removeAttribute(o), xf.delete(t)), i || t.removeAttribute(r);
            }), wf--, wf || (yf = new WeakMap, yf = new WeakMap, xf = new WeakSet, vf = {});
        };
    }(t.concat(Array.from(n.querySelectorAll("[aria-live]"))), n, e, i);
}
const Af = ()=>({
        getShadowRoot: !0,
        displayCheck: "function" == typeof ResizeObserver && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function Ef(t, e) {
    const i = xp(t, Af());
    "prev" === e && i.reverse();
    const n = i.indexOf(ku(Ou(t)));
    return i.slice(n + 1)[0];
}
function Mf() {
    return Ef(document.body, "next");
}
function Tf() {
    return Ef(document.body, "prev");
}
function Pf(t, e) {
    const i = e || t.currentTarget, n = t.relatedTarget;
    return !n || !Au(i, n);
}
function Rf(t) {
    xp(t, Af()).forEach((t)=>{
        t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
    });
}
function Lf(t) {
    t.querySelectorAll("[data-tabindex]").forEach((t)=>{
        const e = t.dataset.tabindex;
        delete t.dataset.tabindex, e ? t.setAttribute("tabindex", e) : t.removeAttribute("tabindex");
    });
}
const Of = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
function Df(t) {
    "Tab" === t.key && (t.target, clearTimeout(undefined));
}
const jf = React.forwardRef(function(t, e) {
    const [i, n] = React.useState();
    tf(()=>(Pu() && n("button"), document.addEventListener("keydown", Df), ()=>{
            document.removeEventListener("keydown", Df);
        }), []);
    const r = {
        ref: e,
        tabIndex: 0,
        role: i,
        "aria-hidden": !i || void 0,
        [df("focus-guard")]: "",
        style: Of
    };
    return React.createElement("span", ef({}, t, r));
}), Nf = React.createContext(null), If = df("portal");
function Bf(t) {
    const { children: e, id: i, root: n, preserveTabOrder: r = !0 } = t, o = function(t) {
        void 0 === t && (t = {});
        const { id: e, root: i } = t, n = sf(), r = Ff(), [o, s] = React.useState(null), a = React.useRef(null);
        return tf(()=>()=>{
                null == o || o.remove(), queueMicrotask(()=>{
                    a.current = null;
                });
            }, [
            o
        ]), tf(()=>{
            if (!n) return;
            if (a.current) return;
            const t = e ? document.getElementById(e) : null;
            if (!t) return;
            const i = document.createElement("div");
            i.id = n, i.setAttribute(If, ""), t.appendChild(i), a.current = i, s(i);
        }, [
            e,
            n
        ]), tf(()=>{
            if (null === i) return;
            if (!n) return;
            if (a.current) return;
            let t = i || (null == r ? void 0 : r.portalNode);
            t && !cu(t) && (t = t.current), t = t || document.body;
            let o = null;
            e && (o = document.createElement("div"), o.id = e, t.appendChild(o));
            const l = document.createElement("div");
            l.id = n, l.setAttribute(If, ""), t = o || t, t.appendChild(l), a.current = l, s(l);
        }, [
            e,
            i,
            n,
            r
        ]), o;
    }({
        id: i,
        root: n
    }), [s, a] = React.useState(null), l = React.useRef(null), h = React.useRef(null), c = React.useRef(null), d = React.useRef(null), u = null == s ? void 0 : s.modal, p = null == s ? void 0 : s.open, f = !!s && !s.modal && s.open && r && !(!n && !o);
    return React.useEffect(()=>{
        if (o && r && !u) return o.addEventListener("focusin", t, !0), o.addEventListener("focusout", t, !0), ()=>{
            o.removeEventListener("focusin", t, !0), o.removeEventListener("focusout", t, !0);
        };
        function t(t) {
            if (o && Pf(t)) ("focusin" === t.type ? Lf : Rf)(o);
        }
    }, [
        o,
        r,
        u
    ]), React.useEffect(()=>{
        o && (p || Lf(o));
    }, [
        p,
        o
    ]), React.createElement(Nf.Provider, {
        value: React.useMemo(()=>({
                preserveTabOrder: r,
                beforeOutsideRef: l,
                afterOutsideRef: h,
                beforeInsideRef: c,
                afterInsideRef: d,
                portalNode: o,
                setFocusManagerState: a
            }), [
            r,
            o
        ])
    }, f && o && React.createElement(jf, {
        "data-type": "outside",
        ref: l,
        onFocus: (t)=>{
            if (Pf(t, o)) {
                var e;
                null == (e = c.current) || e.focus();
            } else {
                const t = Tf() || (null == s ? void 0 : s.refs.domReference.current);
                null == t || t.focus();
            }
        }
    }), f && o && React.createElement("span", {
        "aria-owns": o.id,
        style: Of
    }), o && ReactDOM.createPortal(e, o), f && o && React.createElement(jf, {
        "data-type": "outside",
        ref: h,
        onFocus: (t)=>{
            if (Pf(t, o)) {
                var e;
                null == (e = d.current) || e.focus();
            } else {
                const e = Mf() || (null == s ? void 0 : s.refs.domReference.current);
                null == e || e.focus(), (null == s ? void 0 : s.closeOnFocusOut) && (null == s || s.onOpenChange(!1, t.nativeEvent, "focus-out"));
            }
        }
    }));
}
const Ff = ()=>React.useContext(Nf), zf = "data-floating-ui-focusable";
const Hf = 20;
let Uf = [];
function Wf(t) {
    Uf = Uf.filter((t)=>t.isConnected);
    let e = t;
    if (e && "body" !== su(e)) {
        if (!vp(e, Af())) {
            const t = xp(e, Af())[0];
            t && (e = t);
        }
        Uf.push(e), Uf.length > Hf && (Uf = Uf.slice(-Hf));
    }
}
function Yf() {
    return Uf.slice().reverse().find((t)=>t.isConnected);
}
const _f = React.forwardRef(function(t, e) {
    return React.createElement("button", ef({}, t, {
        type: "button",
        ref: e,
        tabIndex: -1,
        style: Of
    }));
});
function Xf(t) {
    const { context: e, children: i, disabled: n = !1, order: r = [
        "content"
    ], guards: o = !0, initialFocus: s = 0, returnFocus: a = !0, restoreFocus: l = !1, modal: h = !0, visuallyHiddenDismiss: c = !1, closeOnFocusOut: d = !0 } = t, { open: u, refs: p, nodeId: f, onOpenChange: g, events: m, dataRef: b, floatingId: y, elements: { domReference: x, floating: v } } = e, w = "number" == typeof s && s < 0, C = !!(S = x) && "combobox" === S.getAttribute("role") && Iu(S) && w;
    var S;
    const k = "undefined" == typeof HTMLElement || !("inert" in HTMLElement.prototype) || o, A = uf(r), E = uf(s), M = uf(a), T = cf(), P = Ff(), R = React.useRef(null), L = React.useRef(null), O = React.useRef(!1), D = React.useRef(!1), j = React.useRef(-1), N = null != P, I = (B = v) ? B.hasAttribute(zf) ? B : B.querySelector("[" + zf + "]") || B : null;
    var B;
    const F = Jp(function(t) {
        return void 0 === t && (t = I), t ? xp(t, Af()) : [];
    }), z = Jp((t)=>{
        const e = F(t);
        return A.current.map((t)=>x && "reference" === t ? x : I && "floating" === t ? I : e).filter(Boolean).flat();
    });
    function H(t) {
        return !n && c && h ? React.createElement(_f, {
            ref: "start" === t ? R : L,
            onClick: (t)=>g(!1, t.nativeEvent)
        }, "string" == typeof c ? c : "Dismiss") : null;
    }
    React.useEffect(()=>{
        if (n) return;
        if (!h) return;
        function t(t) {
            if ("Tab" === t.key) {
                Au(I, ku(Ou(I))) && 0 === F().length && !C && Bu(t);
                const e = z(), i = ju(t);
                "reference" === A.current[0] && i === x && (Bu(t), t.shiftKey ? mf(e[e.length - 1]) : mf(e[1])), "floating" === A.current[1] && i === I && t.shiftKey && (Bu(t), mf(e[0]));
            }
        }
        const e = Ou(I);
        return e.addEventListener("keydown", t), ()=>{
            e.removeEventListener("keydown", t);
        };
    }, [
        n,
        x,
        I,
        h,
        A,
        C,
        F,
        z
    ]), React.useEffect(()=>{
        if (!n && v) return v.addEventListener("focusin", t), ()=>{
            v.removeEventListener("focusin", t);
        };
        function t(t) {
            const e = ju(t), i = F().indexOf(e);
            -1 !== i && (j.current = i);
        }
    }, [
        n,
        v,
        F
    ]), React.useEffect(()=>{
        if (!n && d) return v && du(x) ? (x.addEventListener("focusout", e), x.addEventListener("pointerdown", t), v.addEventListener("focusout", e), ()=>{
            x.removeEventListener("focusout", e), x.removeEventListener("pointerdown", t), v.removeEventListener("focusout", e);
        }) : void 0;
        function t() {
            D.current = !0, setTimeout(()=>{
                D.current = !1;
            });
        }
        function e(t) {
            const e = t.relatedTarget;
            queueMicrotask(()=>{
                const i = !(Au(x, e) || Au(v, e) || Au(e, v) || Au(null == P ? void 0 : P.portalNode, e) || null != e && e.hasAttribute(df("focus-guard")) || T && (bf(T.nodesRef.current, f).find((t)=>{
                    var i, n;
                    return Au(null == (i = t.context) ? void 0 : i.elements.floating, e) || Au(null == (n = t.context) ? void 0 : n.elements.domReference, e);
                }) || (function(t, e) {
                    var i;
                    let n = [], r = null == (i = t.find((t)=>t.id === e)) ? void 0 : i.parentId;
                    for(; r;){
                        const e = t.find((t)=>t.id === r);
                        r = null == e ? void 0 : e.parentId, e && (n = n.concat(e));
                    }
                    return n;
                })(T.nodesRef.current, f).find((t)=>{
                    var i, n;
                    return (null == (i = t.context) ? void 0 : i.elements.floating) === e || (null == (n = t.context) ? void 0 : n.elements.domReference) === e;
                })));
                if (l && i && ku(Ou(I)) === Ou(I).body) {
                    du(I) && I.focus();
                    const t = j.current, e = F(), i = e[t] || e[e.length - 1] || I;
                    du(i) && i.focus();
                }
                !C && h || !e || !i || D.current || e === Yf() || (O.current = !0, g(!1, t, "focus-out"));
            });
        }
    }, [
        n,
        x,
        v,
        I,
        h,
        f,
        T,
        P,
        g,
        d,
        l,
        F,
        C
    ]), React.useEffect(()=>{
        var t;
        if (n) return;
        const e = Array.from((null == P || null == (t = P.portalNode) ? void 0 : t.querySelectorAll("[" + df("portal") + "]")) || []);
        if (v) {
            const t = [
                v,
                ...e,
                R.current,
                L.current,
                A.current.includes("reference") || C ? x : null
            ].filter((t)=>null != t), i = h || C ? kf(t, k, !k) : kf(t);
            return ()=>{
                i();
            };
        }
    }, [
        n,
        x,
        v,
        h,
        A,
        P,
        C,
        k
    ]), tf(()=>{
        if (n || !du(I)) return;
        const t = ku(Ou(I));
        queueMicrotask(()=>{
            const e = z(I), i = E.current, n = ("number" == typeof i ? e[i] : i.current) || I, r = Au(I, t);
            w || r || !u || mf(n, {
                preventScroll: n === I
            });
        });
    }, [
        n,
        u,
        I,
        w,
        z,
        E
    ]), tf(()=>{
        if (n || !I) return;
        let t = !1;
        const e = Ou(I), i = ku(e);
        let r = b.current.openEvent;
        function o(e) {
            let { open: i, reason: n, event: o, nested: s } = e;
            i && (r = o), "escape-key" === n && p.domReference.current && Wf(p.domReference.current), "hover" === n && "mouseleave" === o.type && (O.current = !0), "outside-press" === n && (s ? (O.current = !1, t = !0) : O.current = !(function(t) {
                return !(0 !== t.mozInputSource || !t.isTrusted) || (Ru() && t.pointerType ? "click" === t.type && 1 === t.buttons : 0 === t.detail && !t.pointerType);
            }(o) || Tu(o)));
        }
        Wf(i), m.on("openchange", o);
        const s = e.createElement("span");
        return s.setAttribute("tabindex", "-1"), s.setAttribute("aria-hidden", "true"), Object.assign(s.style, Of), N && x && x.insertAdjacentElement("afterend", s), ()=>{
            m.off("openchange", o);
            const i = ku(e), n = Au(v, i) || T && bf(T.nodesRef.current, f).some((t)=>{
                var e;
                return Au(null == (e = t.context) ? void 0 : e.elements.floating, i);
            });
            (n || r && [
                "click",
                "mousedown"
            ].includes(r.type)) && p.domReference.current && Wf(p.domReference.current);
            const a = "boolean" == typeof M.current ? Yf() || s : M.current.current || s;
            queueMicrotask(()=>{
                M.current && !O.current && du(a) && (a === i || i === e.body || n) && a.focus({
                    preventScroll: t
                }), s.remove();
            });
        };
    }, [
        n,
        v,
        I,
        M,
        b,
        p,
        m,
        T,
        f,
        N,
        x
    ]), React.useEffect(()=>{
        queueMicrotask(()=>{
            O.current = !1;
        });
    }, [
        n
    ]), tf(()=>{
        if (!n && P) return P.setFocusManagerState({
            modal: h,
            closeOnFocusOut: d,
            open: u,
            onOpenChange: g,
            refs: p
        }), ()=>{
            P.setFocusManagerState(null);
        };
    }, [
        n,
        P,
        h,
        u,
        g,
        p,
        d
    ]), tf(()=>{
        if (n) return;
        if (!I) return;
        if ("function" != typeof MutationObserver) return;
        if (w) return;
        const t = ()=>{
            const t = I.getAttribute("tabindex"), e = F(), i = ku(Ou(v)), n = e.indexOf(i);
            -1 !== n && (j.current = n), A.current.includes("floating") || i !== p.domReference.current && 0 === e.length ? "0" !== t && I.setAttribute("tabindex", "0") : "-1" !== t && I.setAttribute("tabindex", "-1");
        };
        t();
        const e = new MutationObserver(t);
        return e.observe(I, {
            childList: !0,
            subtree: !0,
            attributes: !0
        }), ()=>{
            e.disconnect();
        };
    }, [
        n,
        v,
        I,
        p,
        A,
        F,
        w
    ]);
    const U = !n && k && (!h || !C) && (N || h);
    return React.createElement(React.Fragment, null, U && React.createElement(jf, {
        "data-type": "inside",
        ref: null == P ? void 0 : P.beforeInsideRef,
        onFocus: (t)=>{
            if (h) {
                const t = z();
                mf("reference" === r[0] ? t[0] : t[t.length - 1]);
            } else if (null != P && P.preserveTabOrder && P.portalNode) {
                if (O.current = !1, Pf(t, P.portalNode)) {
                    const t = Mf() || x;
                    null == t || t.focus();
                } else {
                    var e;
                    null == (e = P.beforeOutsideRef.current) || e.focus();
                }
            }
        }
    }), !C && H("start"), i, H("end"), U && React.createElement(jf, {
        "data-type": "inside",
        ref: null == P ? void 0 : P.afterInsideRef,
        onFocus: (t)=>{
            if (h) mf(z()[0]);
            else if (null != P && P.preserveTabOrder && P.portalNode) {
                if (d && (O.current = !0), Pf(t, P.portalNode)) {
                    const t = Tf() || x;
                    null == t || t.focus();
                } else {
                    var e;
                    null == (e = P.afterOutsideRef.current) || e.focus();
                }
            }
        }
    }));
}
function Gf(t) {
    return du(t.target) && "BUTTON" === t.target.tagName;
}
function qf(t) {
    return Iu(t);
}
const Vf = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
}, $f = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
}, Kf = (t)=>{
    var e, i;
    return {
        escapeKey: "boolean" == typeof t ? t : null != (e = null == t ? void 0 : t.escapeKey) && e,
        outsidePress: "boolean" == typeof t ? t : null == (i = null == t ? void 0 : t.outsidePress) || i
    };
};
function Zf(t) {
    const { open: e = !1, onOpenChange: i, elements: n } = t, r = sf(), o = React.useRef({}), [s] = React.useState(()=>(function() {
            const t = new Map;
            return {
                emit (e, i) {
                    var n;
                    null == (n = t.get(e)) || n.forEach((t)=>t(i));
                },
                on (e, i) {
                    t.set(e, [
                        ...t.get(e) || [],
                        i
                    ]);
                },
                off (e, i) {
                    var n;
                    t.set(e, (null == (n = t.get(e)) ? void 0 : n.filter((t)=>t !== i)) || []);
                }
            };
        })()), a = null != hf(), [l, h] = React.useState(n.reference), c = Jp((t, e, n)=>{
        o.current.openEvent = t ? e : void 0, s.emit("openchange", {
            open: t,
            event: e,
            reason: n,
            nested: a
        }), null == i || i(t, e, n);
    }), d = React.useMemo(()=>({
            setPositionReference: h
        }), []), u = React.useMemo(()=>({
            reference: l || n.reference || null,
            floating: n.floating || null,
            domReference: n.reference
        }), [
        l,
        n.reference,
        n.floating
    ]);
    return React.useMemo(()=>({
            dataRef: o,
            open: e,
            onOpenChange: c,
            elements: u,
            events: s,
            floatingId: r,
            refs: d
        }), [
        e,
        c,
        u,
        s,
        r,
        d
    ]);
}
function Qf(t) {
    void 0 === t && (t = {});
    const { nodeId: e } = t, i = Zf({
        ...t,
        elements: {
            reference: null,
            floating: null,
            ...t.elements
        }
    }), n = t.rootContext || i, r = n.elements, [o, s] = React.useState(null), [a, l] = React.useState(null), h = (null == r ? void 0 : r.domReference) || o, c = React.useRef(null), d = cf();
    tf(()=>{
        h && (c.current = h);
    }, [
        h
    ]);
    const u = function(t) {
        void 0 === t && (t = {});
        const { placement: e = "bottom", strategy: i = "absolute", middleware: n = [], platform: r, elements: { reference: o, floating: s } = {}, transform: a = !0, whileElementsMounted: l, open: h } = t, [c, d] = React.useState({
            x: 0,
            y: 0,
            strategy: i,
            placement: e,
            middlewareData: {},
            isPositioned: !1
        }), [u, p] = React.useState(n);
        _p(u, n) || p(n);
        const [f, g] = React.useState(null), [m, b] = React.useState(null), y = React.useCallback((t)=>{
            t !== C.current && (C.current = t, g(t));
        }, []), x = React.useCallback((t)=>{
            t !== S.current && (S.current = t, b(t));
        }, []), v = o || f, w = s || m, C = React.useRef(null), S = React.useRef(null), k = React.useRef(c), A = null != l, E = qp(l), M = qp(r), T = qp(h), P = React.useCallback(()=>{
            if (!C.current || !S.current) return;
            const t = {
                placement: e,
                strategy: i,
                middleware: u
            };
            M.current && (t.platform = M.current), Wp(C.current, S.current, t).then((t)=>{
                const e = {
                    ...t,
                    isPositioned: !1 !== T.current
                };
                R.current && !_p(k.current, e) && (k.current = e, ReactDOM.flushSync(()=>{
                    d(e);
                }));
            });
        }, [
            u,
            e,
            i,
            M,
            T
        ]);
        Yp(()=>{
            !1 === h && k.current.isPositioned && (k.current.isPositioned = !1, d((t)=>({
                    ...t,
                    isPositioned: !1
                })));
        }, [
            h
        ]);
        const R = React.useRef(!1);
        Yp(()=>(R.current = !0, ()=>{
                R.current = !1;
            }), []), Yp(()=>{
            if (v && (C.current = v), w && (S.current = w), v && w) {
                if (E.current) return E.current(v, w, P);
                P();
            }
        }, [
            v,
            w,
            P,
            E,
            A
        ]);
        const L = React.useMemo(()=>({
                reference: C,
                floating: S,
                setReference: y,
                setFloating: x
            }), [
            y,
            x
        ]), O = React.useMemo(()=>({
                reference: v,
                floating: w
            }), [
            v,
            w
        ]), D = React.useMemo(()=>{
            const t = {
                position: i,
                left: 0,
                top: 0
            };
            if (!O.floating) return t;
            const e = Gp(O.floating, c.x), n = Gp(O.floating, c.y);
            return a ? {
                ...t,
                transform: "translate(" + e + "px, " + n + "px)",
                ...Xp(O.floating) >= 1.5 && {
                    willChange: "transform"
                }
            } : {
                position: i,
                left: e,
                top: n
            };
        }, [
            i,
            a,
            O.floating,
            c.x,
            c.y
        ]);
        return React.useMemo(()=>({
                ...c,
                update: P,
                refs: L,
                elements: O,
                floatingStyles: D
            }), [
            c,
            P,
            L,
            O,
            D
        ]);
    }({
        ...t,
        elements: {
            ...r,
            ...a && {
                reference: a
            }
        }
    }), p = React.useCallback((t)=>{
        const e = cu(t) ? {
            getBoundingClientRect: ()=>t.getBoundingClientRect(),
            contextElement: t
        } : t;
        l(e), u.refs.setReference(e);
    }, [
        u.refs
    ]), f = React.useCallback((t)=>{
        (cu(t) || null === t) && (c.current = t, s(t)), (cu(u.refs.reference.current) || null === u.refs.reference.current || null !== t && !cu(t)) && u.refs.setReference(t);
    }, [
        u.refs
    ]), g = React.useMemo(()=>({
            ...u.refs,
            setReference: f,
            setPositionReference: p,
            domReference: c
        }), [
        u.refs,
        f,
        p
    ]), m = React.useMemo(()=>({
            ...u.elements,
            domReference: h
        }), [
        u.elements,
        h
    ]), b = React.useMemo(()=>({
            ...u,
            ...n,
            refs: g,
            elements: m,
            nodeId: e
        }), [
        u,
        g,
        m,
        e,
        n
    ]);
    return tf(()=>{
        n.dataRef.current.floatingContext = b;
        const t = null == d ? void 0 : d.nodesRef.current.find((t)=>t.id === e);
        t && (t.context = b);
    }), React.useMemo(()=>({
            ...u,
            context: b,
            refs: g,
            elements: m
        }), [
        u,
        g,
        m,
        b
    ]);
}
function Jf(t, e) {
    void 0 === e && (e = {});
    const { open: i, onOpenChange: n, events: r, dataRef: o, elements: s } = t, { enabled: a = !0, visibleOnly: l = !0 } = e, h = React.useRef(!1), c = React.useRef(), d = React.useRef(!0);
    React.useEffect(()=>{
        if (!a) return;
        const t = au(s.domReference);
        function e() {
            !i && du(s.domReference) && s.domReference === ku(Ou(s.domReference)) && (h.current = !0);
        }
        function n() {
            d.current = !0;
        }
        return t.addEventListener("blur", e), t.addEventListener("keydown", n, !0), ()=>{
            t.removeEventListener("blur", e), t.removeEventListener("keydown", n, !0);
        };
    }, [
        s.domReference,
        i,
        a
    ]), React.useEffect(()=>{
        if (a) return r.on("openchange", t), ()=>{
            r.off("openchange", t);
        };
        function t(t) {
            let { reason: e } = t;
            "reference-press" !== e && "escape-key" !== e || (h.current = !0);
        }
    }, [
        r,
        a
    ]), React.useEffect(()=>()=>{
            clearTimeout(c.current);
        }, []);
    const u = React.useMemo(()=>({
            onPointerDown (t) {
                Tu(t.nativeEvent) || (d.current = !1);
            },
            onMouseLeave () {
                h.current = !1;
            },
            onFocus (t) {
                if (h.current) return;
                const e = ju(t.nativeEvent);
                if (l && cu(e)) try {
                    if (Pu() && Eu().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints) throw Error();
                    if (!e.matches(":focus-visible")) return;
                } catch (t) {
                    if (!d.current && !Iu(e)) return;
                }
                n(!0, t.nativeEvent, "focus");
            },
            onBlur (t) {
                h.current = !1;
                const e = t.relatedTarget, i = t.nativeEvent, r = cu(e) && e.hasAttribute(df("focus-guard")) && "outside" === e.getAttribute("data-type");
                c.current = window.setTimeout(()=>{
                    var t;
                    const a = ku(s.domReference ? s.domReference.ownerDocument : document);
                    (e || a !== s.domReference) && (Au(null == (t = o.current.floatingContext) ? void 0 : t.refs.floating.current, a) || Au(s.domReference, a) || r || n(!1, i, "focus"));
                });
            }
        }), [
        o,
        s.domReference,
        n,
        l
    ]);
    return React.useMemo(()=>a ? {
            reference: u
        } : {}, [
        a,
        u
    ]);
}
const tg = "active", eg = "selected";
function ig(t, e, i) {
    const n = new Map, r = "item" === i;
    let o = t;
    if (r && t) {
        const { [tg]: e, [eg]: i, ...n } = t;
        o = n;
    }
    return {
        ..."floating" === i && {
            tabIndex: -1,
            [zf]: ""
        },
        ...o,
        ...e.map((e)=>{
            const n = e ? e[i] : null;
            return "function" == typeof n ? t ? n(t) : null : n;
        }).concat(t).reduce((t, e)=>e ? (Object.entries(e).forEach((e)=>{
                let [i, o] = e;
                var s;
                r && [
                    tg,
                    eg
                ].includes(i) || (0 === i.indexOf("on") ? (n.has(i) || n.set(i, []), "function" == typeof o && (null == (s = n.get(i)) || s.push(o), t[i] = function() {
                    for(var t, e = arguments.length, r = new Array(e), o = 0; o < e; o++)r[o] = arguments[o];
                    return null == (t = n.get(i)) ? void 0 : t.map((t)=>t(...r)).find((t)=>void 0 !== t);
                })) : t[i] = o);
            }), t) : t, {})
    };
}
const ng = new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        !1
    ]
]);
const rg = (t)=>t.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (t, e)=>(e ? "-" : "") + t.toLowerCase());
function og(t, e) {
    return "function" == typeof t ? t(e) : t;
}
function sg(t, e) {
    void 0 === e && (e = {});
    const { open: i, elements: { floating: n } } = t, { duration: r = 250 } = e, o = ("number" == typeof r ? r : r.close) || 0, [s, a] = React.useState("unmounted"), l = function(t, e) {
        const [i, n] = React.useState(t);
        return t && !i && n(!0), React.useEffect(()=>{
            if (!t && i) {
                const t = setTimeout(()=>n(!1), e);
                return ()=>clearTimeout(t);
            }
        }, [
            t,
            i,
            e
        ]), i;
    }(i, o);
    return l || "close" !== s || a("unmounted"), tf(()=>{
        if (n) {
            if (i) {
                a("initial");
                const t = requestAnimationFrame(()=>{
                    a("open");
                });
                return ()=>{
                    cancelAnimationFrame(t);
                };
            }
            a("close");
        }
    }, [
        i,
        n
    ]), {
        isMounted: l,
        status: s
    };
}
function ag(t, e) {
    const [i, n] = t;
    let r = !1;
    const o = e.length;
    for(let t = 0, s = o - 1; t < o; s = t++){
        const [o, a] = e[t] || [
            0,
            0
        ], [l, h] = e[s] || [
            0,
            0
        ];
        a >= n != h >= n && i <= (l - o) * (n - a) / (h - a) + o && (r = !r);
    }
    return r;
}
function lg(t) {
    void 0 === t && (t = {});
    const { buffer: e = .5, blockPointerEvents: i = !1, requireIntent: n = !0 } = t;
    let r, o = !1, s = null, a = null, l = performance.now();
    const h = (t)=>{
        let { x: i, y: h, placement: c, elements: d, onClose: u, nodeId: p, tree: f } = t;
        return function(t) {
            function g() {
                clearTimeout(r), u();
            }
            if (clearTimeout(r), !d.domReference || !d.floating || null == c || null == i || null == h) return;
            const { clientX: m, clientY: b } = t, y = [
                m,
                b
            ], x = ju(t), v = "mouseleave" === t.type, w = Au(d.floating, x), C = Au(d.domReference, x), S = d.domReference.getBoundingClientRect(), k = d.floating.getBoundingClientRect(), A = c.split("-")[0], E = i > k.right - k.width / 2, M = h > k.bottom - k.height / 2, T = function(t, e) {
                return t[0] >= e.x && t[0] <= e.x + e.width && t[1] >= e.y && t[1] <= e.y + e.height;
            }(y, S), P = k.width > S.width, R = k.height > S.height, L = (P ? S : k).left, O = (P ? S : k).right, D = (R ? S : k).top, j = (R ? S : k).bottom;
            if (w && (o = !0, !v)) return;
            if (C && (o = !1), C && !v) return void (o = !0);
            if (v && cu(t.relatedTarget) && Au(d.floating, t.relatedTarget)) return;
            if (f && bf(f.nodesRef.current, p).some((t)=>{
                let { context: e } = t;
                return null == e ? void 0 : e.open;
            })) return;
            if ("top" === A && h >= S.bottom - 1 || "bottom" === A && h <= S.top + 1 || "left" === A && i >= S.right - 1 || "right" === A && i <= S.left + 1) return g();
            let N = [];
            switch(A){
                case "top":
                    N = [
                        [
                            L,
                            S.top + 1
                        ],
                        [
                            L,
                            k.bottom - 1
                        ],
                        [
                            O,
                            k.bottom - 1
                        ],
                        [
                            O,
                            S.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    N = [
                        [
                            L,
                            k.top + 1
                        ],
                        [
                            L,
                            S.bottom - 1
                        ],
                        [
                            O,
                            S.bottom - 1
                        ],
                        [
                            O,
                            k.top + 1
                        ]
                    ];
                    break;
                case "left":
                    N = [
                        [
                            k.right - 1,
                            j
                        ],
                        [
                            k.right - 1,
                            D
                        ],
                        [
                            S.left + 1,
                            D
                        ],
                        [
                            S.left + 1,
                            j
                        ]
                    ];
                    break;
                case "right":
                    N = [
                        [
                            S.right - 1,
                            j
                        ],
                        [
                            S.right - 1,
                            D
                        ],
                        [
                            k.left + 1,
                            D
                        ],
                        [
                            k.left + 1,
                            j
                        ]
                    ];
            }
            if (!ag([
                m,
                b
            ], N)) {
                if (o && !T) return g();
                if (!v && n) {
                    const e = function(t, e) {
                        const i = performance.now(), n = i - l;
                        if (null === s || null === a || 0 === n) return s = t, a = e, l = i, null;
                        const r = t - s, o = e - a, h = Math.sqrt(r * r + o * o);
                        return s = t, a = e, l = i, h / n;
                    }(t.clientX, t.clientY);
                    if (null !== e && e < .1) return g();
                }
                ag([
                    m,
                    b
                ], function(t) {
                    let [i, n] = t;
                    switch(A){
                        case "top":
                            return [
                                [
                                    P ? i + e / 2 : E ? i + 4 * e : i - 4 * e,
                                    n + e + 1
                                ],
                                [
                                    P ? i - e / 2 : E ? i + 4 * e : i - 4 * e,
                                    n + e + 1
                                ],
                                [
                                    k.left,
                                    E || P ? k.bottom - e : k.top
                                ],
                                [
                                    k.right,
                                    E ? P ? k.bottom - e : k.top : k.bottom - e
                                ]
                            ];
                        case "bottom":
                            return [
                                [
                                    P ? i + e / 2 : E ? i + 4 * e : i - 4 * e,
                                    n - e
                                ],
                                [
                                    P ? i - e / 2 : E ? i + 4 * e : i - 4 * e,
                                    n - e
                                ],
                                [
                                    k.left,
                                    E || P ? k.top + e : k.bottom
                                ],
                                [
                                    k.right,
                                    E ? P ? k.top + e : k.bottom : k.top + e
                                ]
                            ];
                        case "left":
                            {
                                const t = [
                                    i + e + 1,
                                    R ? n + e / 2 : M ? n + 4 * e : n - 4 * e
                                ], r = [
                                    i + e + 1,
                                    R ? n - e / 2 : M ? n + 4 * e : n - 4 * e
                                ];
                                return [
                                    [
                                        M || R ? k.right - e : k.left,
                                        k.top
                                    ],
                                    [
                                        M ? R ? k.right - e : k.left : k.right - e,
                                        k.bottom
                                    ],
                                    t,
                                    r
                                ];
                            }
                        case "right":
                            return [
                                [
                                    i - e,
                                    R ? n + e / 2 : M ? n + 4 * e : n - 4 * e
                                ],
                                [
                                    i - e,
                                    R ? n - e / 2 : M ? n + 4 * e : n - 4 * e
                                ],
                                [
                                    M || R ? k.left + e : k.right,
                                    k.top
                                ],
                                [
                                    M ? R ? k.left + e : k.right : k.left + e,
                                    k.bottom
                                ]
                            ];
                    }
                }([
                    i,
                    h
                ])) ? !o && n && (r = window.setTimeout(g, 40)) : g();
            }
        };
    };
    return h.__options = {
        blockPointerEvents: i
    }, h;
}
const hg = (t)=>{
    let { placement: e = "bottom", modal: i, offsetConfig: n = 0, open: r, setOpen: o, openTrigger: s = "click" } = t;
    const [a, l] = React.useState(!1), h = Qf({
        placement: e,
        open: r ?? a,
        onOpenChange: o ?? l,
        whileElementsMounted: zp,
        middleware: [
            (c = n, {
                ...Sp(c),
                options: [
                    c,
                    d
                ]
            }),
            $p({
                crossAxis: yi("-", e),
                fallbackAxisSideDirection: "end"
            }),
            Vp()
        ]
    });
    var c, d;
    const { context: u } = h, { isMounted: p, styles: f } = function(t, e) {
        void 0 === e && (e = {});
        const { initial: i = {
            opacity: 0
        }, open: n, close: r, common: o, duration: s = 250 } = e, a = t.placement, l = a.split("-")[0], h = React.useMemo(()=>({
                side: l,
                placement: a
            }), [
            l,
            a
        ]), c = "number" == typeof s, d = (c ? s : s.open) || 0, u = (c ? s : s.close) || 0, [p, f] = React.useState(()=>({
                ...og(o, h),
                ...og(i, h)
            })), { isMounted: g, status: m } = sg(t, {
            duration: s
        }), b = uf(i), y = uf(n), x = uf(r), v = uf(o);
        return tf(()=>{
            const t = og(b.current, h), e = og(x.current, h), i = og(v.current, h), n = og(y.current, h) || Object.keys(t).reduce((t, e)=>(t[e] = "", t), {});
            if ("initial" === m && f((e)=>({
                    transitionProperty: e.transitionProperty,
                    ...i,
                    ...t
                })), "open" === m && f({
                transitionProperty: Object.keys(n).map(rg).join(","),
                transitionDuration: d + "ms",
                ...i,
                ...n
            }), "close" === m) {
                const n = e || t;
                f({
                    transitionProperty: Object.keys(n).map(rg).join(","),
                    transitionDuration: u + "ms",
                    ...i,
                    ...n
                });
            }
        }, [
            u,
            x,
            b,
            y,
            v,
            d,
            m,
            h
        ]), {
            isMounted: g,
            styles: p
        };
    }(u), g = function(t, e) {
        void 0 === e && (e = {});
        const { open: i, onOpenChange: n, dataRef: r, events: o, elements: s } = t, { enabled: a = !0, delay: l = 0, handleClose: h = null, mouseOnly: c = !1, restMs: d = 0, move: u = !0 } = e, p = cf(), f = hf(), g = uf(h), m = uf(l), b = uf(i), y = React.useRef(), x = React.useRef(-1), v = React.useRef(), w = React.useRef(-1), C = React.useRef(!0), S = React.useRef(!1), k = React.useRef(()=>{}), A = React.useRef(!1), E = React.useCallback(()=>{
            var t;
            const e = null == (t = r.current.openEvent) ? void 0 : t.type;
            return (null == e ? void 0 : e.includes("mouse")) && "mousedown" !== e;
        }, [
            r
        ]);
        React.useEffect(()=>{
            if (a) return o.on("openchange", t), ()=>{
                o.off("openchange", t);
            };
            function t(t) {
                let { open: e } = t;
                e || (clearTimeout(x.current), clearTimeout(w.current), C.current = !0, A.current = !1);
            }
        }, [
            a,
            o
        ]), React.useEffect(()=>{
            if (!a) return;
            if (!g.current) return;
            if (!i) return;
            function t(t) {
                E() && n(!1, t, "hover");
            }
            const e = Ou(s.floating).documentElement;
            return e.addEventListener("mouseleave", t), ()=>{
                e.removeEventListener("mouseleave", t);
            };
        }, [
            s.floating,
            i,
            n,
            a,
            g,
            E
        ]);
        const M = React.useCallback(function(t, e, i) {
            void 0 === e && (e = !0), void 0 === i && (i = "hover");
            const r = ff(m.current, "close", y.current);
            r && !v.current ? (clearTimeout(x.current), x.current = window.setTimeout(()=>n(!1, t, i), r)) : e && (clearTimeout(x.current), n(!1, t, i));
        }, [
            m,
            n
        ]), T = Jp(()=>{
            k.current(), v.current = void 0;
        }), P = Jp(()=>{
            if (S.current) {
                const t = Ou(s.floating).body;
                t.style.pointerEvents = "", t.removeAttribute(pf), S.current = !1;
            }
        }), R = Jp(()=>!!r.current.openEvent && [
                "click",
                "mousedown"
            ].includes(r.current.openEvent.type));
        React.useEffect(()=>{
            if (a && cu(s.domReference)) {
                var t;
                const n = s.domReference;
                return i && n.addEventListener("mouseleave", l), null == (t = s.floating) || t.addEventListener("mouseleave", l), u && n.addEventListener("mousemove", e, {
                    once: !0
                }), n.addEventListener("mouseenter", e), n.addEventListener("mouseleave", o), ()=>{
                    var t;
                    i && n.removeEventListener("mouseleave", l), null == (t = s.floating) || t.removeEventListener("mouseleave", l), u && n.removeEventListener("mousemove", e), n.removeEventListener("mouseenter", e), n.removeEventListener("mouseleave", o);
                };
            }
            function e(t) {
                if (clearTimeout(x.current), C.current = !1, c && !Lu(y.current) || d > 0 && !ff(m.current, "open")) return;
                const e = ff(m.current, "open", y.current);
                e ? x.current = window.setTimeout(()=>{
                    b.current || n(!0, t, "hover");
                }, e) : i || n(!0, t, "hover");
            }
            function o(t) {
                if (R()) return;
                k.current();
                const e = Ou(s.floating);
                if (clearTimeout(w.current), A.current = !1, g.current && r.current.floatingContext) {
                    i || clearTimeout(x.current), v.current = g.current({
                        ...r.current.floatingContext,
                        tree: p,
                        x: t.clientX,
                        y: t.clientY,
                        onClose () {
                            P(), T(), R() || M(t, !0, "safe-polygon");
                        }
                    });
                    const n = v.current;
                    return e.addEventListener("mousemove", n), void (k.current = ()=>{
                        e.removeEventListener("mousemove", n);
                    });
                }
                ("touch" !== y.current || !Au(s.floating, t.relatedTarget)) && M(t);
            }
            function l(t) {
                R() || r.current.floatingContext && (null == g.current || g.current({
                    ...r.current.floatingContext,
                    tree: p,
                    x: t.clientX,
                    y: t.clientY,
                    onClose () {
                        P(), T(), R() || M(t);
                    }
                })(t));
            }
        }, [
            s,
            a,
            t,
            c,
            d,
            u,
            M,
            T,
            P,
            n,
            i,
            b,
            p,
            m,
            g,
            r,
            R
        ]), tf(()=>{
            var t;
            if (a && i && null != (t = g.current) && t.__options.blockPointerEvents && E()) {
                S.current = !0;
                const t = s.floating;
                if (cu(s.domReference) && t) {
                    var e;
                    const i = Ou(s.floating).body;
                    i.setAttribute(pf, "");
                    const n = s.domReference, r = null == p || null == (e = p.nodesRef.current.find((t)=>t.id === f)) || null == (e = e.context) ? void 0 : e.elements.floating;
                    return r && (r.style.pointerEvents = ""), i.style.pointerEvents = "none", n.style.pointerEvents = "auto", t.style.pointerEvents = "auto", ()=>{
                        i.style.pointerEvents = "", n.style.pointerEvents = "", t.style.pointerEvents = "";
                    };
                }
            }
        }, [
            a,
            i,
            f,
            s,
            p,
            g,
            E
        ]), tf(()=>{
            i || (y.current = void 0, A.current = !1, T(), P());
        }, [
            i,
            T,
            P
        ]), React.useEffect(()=>()=>{
                T(), clearTimeout(x.current), clearTimeout(w.current), P();
            }, [
            a,
            s.domReference,
            T,
            P
        ]);
        const L = React.useMemo(()=>{
            function t(t) {
                y.current = t.pointerType;
            }
            return {
                onPointerDown: t,
                onPointerEnter: t,
                onMouseMove (t) {
                    const { nativeEvent: e } = t;
                    function r() {
                        C.current || b.current || n(!0, e, "hover");
                    }
                    c && !Lu(y.current) || i || 0 === d || A.current && t.movementX ** 2 + t.movementY ** 2 < 2 || (clearTimeout(w.current), "touch" === y.current ? r() : (A.current = !0, w.current = window.setTimeout(r, d)));
                }
            };
        }, [
            c,
            n,
            i,
            b,
            d
        ]), O = React.useMemo(()=>({
                onMouseEnter () {
                    clearTimeout(x.current);
                },
                onMouseLeave (t) {
                    R() || M(t.nativeEvent, !1);
                }
            }), [
            M,
            R
        ]);
        return React.useMemo(()=>a ? {
                reference: L,
                floating: O
            } : {}, [
            a,
            L,
            O
        ]);
    }(u, {
        handleClose: lg()
    }), m = function(t, e) {
        void 0 === e && (e = {});
        const { open: i, onOpenChange: n, dataRef: r, elements: { domReference: o } } = t, { enabled: s = !0, event: a = "click", toggle: l = !0, ignoreMouse: h = !1, keyboardHandlers: c = !0, stickIfOpen: d = !0 } = e, u = React.useRef(), p = React.useRef(!1), f = React.useMemo(()=>({
                onPointerDown (t) {
                    u.current = t.pointerType;
                },
                onMouseDown (t) {
                    const e = u.current;
                    0 === t.button && "click" !== a && (Lu(e, !0) && h || (!i || !l || r.current.openEvent && d && "mousedown" !== r.current.openEvent.type ? (t.preventDefault(), n(!0, t.nativeEvent, "click")) : n(!1, t.nativeEvent, "click")));
                },
                onClick (t) {
                    const e = u.current;
                    "mousedown" === a && u.current ? u.current = void 0 : Lu(e, !0) && h || (!i || !l || r.current.openEvent && d && "click" !== r.current.openEvent.type ? n(!0, t.nativeEvent, "click") : n(!1, t.nativeEvent, "click"));
                },
                onKeyDown (t) {
                    u.current = void 0, t.defaultPrevented || !c || Gf(t) || (" " !== t.key || qf(o) || (t.preventDefault(), p.current = !0), "Enter" === t.key && n(!i || !l, t.nativeEvent, "click"));
                },
                onKeyUp (t) {
                    t.defaultPrevented || !c || Gf(t) || qf(o) || " " === t.key && p.current && (p.current = !1, n(!i || !l, t.nativeEvent, "click"));
                }
            }), [
            r,
            o,
            a,
            h,
            c,
            n,
            i,
            d,
            l
        ]);
        return React.useMemo(()=>s ? {
                reference: f
            } : {}, [
            s,
            f
        ]);
    }(u), b = Jf(u), y = function(t, e) {
        void 0 === e && (e = {});
        const { open: i, onOpenChange: n, elements: r, dataRef: o } = t, { enabled: s = !0, escapeKey: a = !0, outsidePress: l = !0, outsidePressEvent: h = "pointerdown", referencePress: c = !1, referencePressEvent: d = "pointerdown", ancestorScroll: u = !1, bubbles: p, capture: f } = e, g = cf(), m = Jp("function" == typeof l ? l : ()=>!1), b = "function" == typeof l ? m : l, y = React.useRef(!1), x = React.useRef(!1), { escapeKey: v, outsidePress: w } = Kf(p), { escapeKey: C, outsidePress: S } = Kf(f), k = React.useRef(!1), A = Jp((t)=>{
            var e;
            if (!i || !s || !a || "Escape" !== t.key) return;
            if (k.current) return;
            const r = null == (e = o.current.floatingContext) ? void 0 : e.nodeId, l = g ? bf(g.nodesRef.current, r) : [];
            if (!v && (t.stopPropagation(), l.length > 0)) {
                let t = !0;
                if (l.forEach((e)=>{
                    var i;
                    null == (i = e.context) || !i.open || e.context.dataRef.current.__escapeKeyBubbles || (t = !1);
                }), !t) return;
            }
            n(!1, function(t) {
                return "nativeEvent" in t;
            }(t) ? t.nativeEvent : t, "escape-key");
        }), E = Jp((t)=>{
            var e;
            const i = ()=>{
                var e;
                A(t), null == (e = ju(t)) || e.removeEventListener("keydown", i);
            };
            null == (e = ju(t)) || e.addEventListener("keydown", i);
        }), M = Jp((t)=>{
            var e;
            const i = y.current;
            y.current = !1;
            const s = x.current;
            if (x.current = !1, "click" === h && s) return;
            if (i) return;
            if ("function" == typeof b && !b(t)) return;
            const a = ju(t), l = "[" + df("inert") + "]", c = Ou(r.floating).querySelectorAll(l);
            let d = cu(a) ? a : null;
            for(; d && !yu(d);){
                const t = wu(d);
                if (yu(t) || !cu(t)) break;
                d = t;
            }
            if (c.length && cu(a) && !a.matches("html,body") && !Au(a, r.floating) && Array.from(c).every((t)=>!Au(d, t))) return;
            if (du(a) && R) {
                const e = a.clientWidth > 0 && a.scrollWidth > a.clientWidth, i = a.clientHeight > 0 && a.scrollHeight > a.clientHeight;
                let n = i && t.offsetX > a.clientWidth;
                if (i && "rtl" === xu(a).direction && (n = t.offsetX <= a.offsetWidth - a.clientWidth), n || e && t.offsetY > a.clientHeight) return;
            }
            const u = null == (e = o.current.floatingContext) ? void 0 : e.nodeId, p = g && bf(g.nodesRef.current, u).some((e)=>{
                var i;
                return Du(t, null == (i = e.context) ? void 0 : i.elements.floating);
            });
            if (Du(t, r.floating) || Du(t, r.domReference) || p) return;
            const f = g ? bf(g.nodesRef.current, u) : [];
            if (f.length > 0) {
                let t = !0;
                if (f.forEach((e)=>{
                    var i;
                    null == (i = e.context) || !i.open || e.context.dataRef.current.__outsidePressBubbles || (t = !1);
                }), !t) return;
            }
            n(!1, t, "outside-press");
        }), T = Jp((t)=>{
            var e;
            const i = ()=>{
                var e;
                M(t), null == (e = ju(t)) || e.removeEventListener(h, i);
            };
            null == (e = ju(t)) || e.addEventListener(h, i);
        });
        React.useEffect(()=>{
            if (!i || !s) return;
            o.current.__escapeKeyBubbles = v, o.current.__outsidePressBubbles = w;
            let t = -1;
            function e(t) {
                n(!1, t, "ancestor-scroll");
            }
            function l() {
                window.clearTimeout(t), k.current = !0;
            }
            function c() {
                t = window.setTimeout(()=>{
                    k.current = !1;
                }, bu() ? 5 : 0);
            }
            const d = Ou(r.floating);
            a && (d.addEventListener("keydown", C ? E : A, C), d.addEventListener("compositionstart", l), d.addEventListener("compositionend", c)), b && d.addEventListener(h, S ? T : M, S);
            let p = [];
            return u && (cu(r.domReference) && (p = Su(r.domReference)), cu(r.floating) && (p = p.concat(Su(r.floating))), !cu(r.reference) && r.reference && r.reference.contextElement && (p = p.concat(Su(r.reference.contextElement)))), p = p.filter((t)=>{
                var e;
                return t !== (null == (e = d.defaultView) ? void 0 : e.visualViewport);
            }), p.forEach((t)=>{
                t.addEventListener("scroll", e, {
                    passive: !0
                });
            }), ()=>{
                a && (d.removeEventListener("keydown", C ? E : A, C), d.removeEventListener("compositionstart", l), d.removeEventListener("compositionend", c)), b && d.removeEventListener(h, S ? T : M, S), p.forEach((t)=>{
                    t.removeEventListener("scroll", e);
                }), window.clearTimeout(t);
            };
        }, [
            o,
            r,
            a,
            b,
            h,
            i,
            n,
            u,
            s,
            v,
            w,
            A,
            C,
            E,
            M,
            S,
            T
        ]), React.useEffect(()=>{
            y.current = !1;
        }, [
            b,
            h
        ]);
        const P = React.useMemo(()=>({
                onKeyDown: A,
                [Vf[d]]: (t)=>{
                    c && n(!1, t.nativeEvent, "reference-press");
                }
            }), [
            A,
            n,
            c,
            d
        ]), R = React.useMemo(()=>({
                onKeyDown: A,
                onMouseDown () {
                    x.current = !0;
                },
                onMouseUp () {
                    x.current = !0;
                },
                [$f[h]]: ()=>{
                    y.current = !0;
                }
            }), [
            A,
            h
        ]);
        return React.useMemo(()=>s ? {
                reference: P,
                floating: R
            } : {}, [
            s,
            P,
            R
        ]);
    }(u), x = function(t, e) {
        var i;
        void 0 === e && (e = {});
        const { open: n, floatingId: r } = t, { enabled: o = !0, role: s = "dialog" } = e, a = null != (i = ng.get(s)) ? i : s, l = sf(), h = null != hf(), c = React.useMemo(()=>"tooltip" === a || "label" === s ? {
                ["aria-" + ("label" === s ? "labelledby" : "describedby")]: n ? r : void 0
            } : {
                "aria-expanded": n ? "true" : "false",
                "aria-haspopup": "alertdialog" === a ? "dialog" : a,
                "aria-controls": n ? r : void 0,
                ..."listbox" === a && {
                    role: "combobox"
                },
                ..."menu" === a && {
                    id: l
                },
                ..."menu" === a && h && {
                    role: "menuitem"
                },
                ..."select" === s && {
                    "aria-autocomplete": "none"
                },
                ..."combobox" === s && {
                    "aria-autocomplete": "list"
                }
            }, [
            a,
            r,
            h,
            n,
            l,
            s
        ]), d = React.useMemo(()=>{
            const t = {
                id: r,
                ...a && {
                    role: a
                }
            };
            return "tooltip" === a || "label" === s ? t : {
                ...t,
                ..."menu" === a && {
                    "aria-labelledby": l
                }
            };
        }, [
            a,
            r,
            l,
            s
        ]), u = React.useCallback((t)=>{
            let { active: e, selected: i } = t;
            const n = {
                role: "option",
                ...e && {
                    id: r + "-option"
                }
            };
            switch(s){
                case "select":
                    return {
                        ...n,
                        "aria-selected": e && i
                    };
                case "combobox":
                    return {
                        ...n,
                        ...e && {
                            "aria-selected": !0
                        }
                    };
            }
            return {};
        }, [
            r,
            s
        ]);
        return React.useMemo(()=>o ? {
                reference: c,
                floating: d,
                item: u
            } : {}, [
            o,
            c,
            d,
            u
        ]);
    }(u, {
        role: "hover" === s ? "tooltip" : "menu"
    }), v = function(t) {
        void 0 === t && (t = []);
        const e = t.map((t)=>null == t ? void 0 : t.reference), i = t.map((t)=>null == t ? void 0 : t.floating), n = t.map((t)=>null == t ? void 0 : t.item), r = React.useCallback((e)=>ig(e, t, "reference"), e), o = React.useCallback((e)=>ig(e, t, "floating"), i), s = React.useCallback((e)=>ig(e, t, "item"), n);
        return React.useMemo(()=>({
                getReferenceProps: r,
                getFloatingProps: o,
                getItemProps: s
            }), [
            r,
            o,
            s
        ]);
    }("hover" === s ? [
        g,
        b,
        y,
        x
    ] : [
        m,
        y,
        x
    ]);
    return React.useMemo(()=>({
            open: a,
            setOpen: l,
            ...v,
            ...h,
            modal: i,
            transitionStyles: f,
            isMounted: p
        }), [
        a,
        l,
        v,
        h,
        i,
        f,
        p
    ]);
}, cg = React.createContext(null), dg = (t)=>{
    let { children: e, modal: i = !0, ...n } = t;
    const r = hg({
        modal: i,
        ...n
    });
    return React.createElement(cg.Provider, {
        value: r
    }, e);
};
dg.propTypes = {
    children: P.oneOfType([
        P.arrayOf(P.node),
        P.node
    ]).isRequired,
    modal: P.bool
};
const ug = React.forwardRef((t, e)=>{
    let { children: i, ...n } = t;
    const r = React.useContext(cg), o = i.ref, s = Kp([
        r.refs.setReference,
        e,
        o
    ]);
    return React.cloneElement(i, r.getReferenceProps({
        ref: s,
        ...n,
        ...i.props,
        "data-state": r.open ? "open" : "closed"
    }));
});
ug.propTypes = {
    children: P.oneOfType([
        P.arrayOf(P.node),
        P.node
    ]).isRequired
};
const pg = React.forwardRef((t, e)=>{
    let { style: i = {}, tooltipContainerId: n, ...r } = t;
    const { context: o, ...s } = React.useContext(cg), a = Kp([
        s.refs.setFloating,
        e
    ]);
    return s.isMounted ? React.createElement(Bf, {
        id: n
    }, React.createElement(Xf, {
        context: o,
        modal: s.modal,
        order: [
            "reference",
            "content"
        ]
    }, React.createElement("div", g({
        ref: a,
        style: {
            ...s.floatingStyles,
            ...i
        }
    }, s.getFloatingProps(r)), React.createElement("div", {
        style: {
            ...s.transitionStyles
        }
    }, r.children)))) : null;
});
pg.propTypes = {
    tooltipContainerId: P.string,
    style: P.object,
    children: P.oneOfType([
        P.arrayOf(P.node),
        P.node
    ]).isRequired
};
const fg = (t)=>{
    let { chartRef: e, parsedTitle: i, parsedSubtitle: n, onDownloadData: r = null, onExpandChart: o = null, isInIframe: s, hideExpand: a, openChartFullScreen: l, definition: h, noteAndSource: c, noteAndSourceShouldBeDisplayedInTooltip: d, tooltipContainerId: u, isSmall: p, exportDisabled: f = !1 } = t;
    const [g, m] = React.useState(!1), b = Le(jn(()=>(o || !s) && !a, Yi({
        label: "Expand",
        content: React.createElement(nu, null),
        disabled: f,
        onSelect: ()=>{
            o ? o() : l(), m(!1);
        }
    })))([
        {
            label: "CSV",
            content: React.createElement(Jd, null),
            disabled: f,
            onSelect: ()=>{
                e.current?.chart.downloadCSV && (e.current?.chart.downloadCSV(), r && r()), m(!1);
            }
        },
        {
            label: "PNG",
            content: React.createElement(eu, null),
            disabled: f,
            onSelect: ()=>{
                e.current?.chart.exportChartLocal(void 0, {
                    title: {
                        text: i
                    },
                    subtitle: {
                        text: n
                    },
                    ...Ao(i) && Ao(n) ? {} : {
                        chart: {
                            marginTop: void 0
                        }
                    }
                }), r && r(), m(!1);
            }
        },
        {
            label: "SVG",
            content: React.createElement(iu, null),
            disabled: f,
            onSelect: ()=>{
                e.current?.chart.exportChartLocal({
                    type: "image/svg+xml"
                }, {
                    title: {
                        text: i
                    },
                    subtitle: {
                        text: n
                    },
                    ...Ao(i) && Ao(n) ? {} : {
                        chart: {
                            marginTop: void 0
                        }
                    }
                }), r && r(), m(!1);
            }
        }
    ]);
    return React.createElement(dg, {
        placement: "bottom-end",
        offsetConfig: p ? 4 : 8,
        open: g,
        setOpen: m
    }, React.createElement(ug, null, React.createElement("div", {
        className: "cb-tool",
        style: {
            marginLeft: p ? "4px" : "8px"
        },
        role: "button",
        tabIndex: 0,
        "aria-label": "Toolbox"
    }, React.createElement("div", {
        style: {
            display: "flex",
            transform: g ? "rotate(180deg)" : "rotate(0deg)",
            transition: "all 250ms"
        }
    }, React.createElement(tu, null)))), React.createElement(pg, {
        tooltipContainerId: u
    }, React.createElement("div", {
        className: "cb-toolbox " + (p ? "cb-small" : "")
    }, (d || !ae(h)) && p && React.createElement(dg, {
        placement: "left-start",
        offsetConfig: p ? 4 : 8,
        openTrigger: "hover"
    }, React.createElement(ug, null, React.createElement("div", {
        "aria-label": "Info",
        className: "cb-tool",
        role: "button",
        tabIndex: 0
    }, React.createElement(ru, null))), React.createElement(pg, {
        tooltipContainerId: u
    }, React.createElement("div", {
        className: "cb-floating cb-tooltip",
        dangerouslySetInnerHTML: {
            __html: d ? ki("", [
                h,
                c
            ]) : h
        }
    }))), Rt((t)=>React.createElement("div", {
            key: t.label,
            "aria-label": t.label,
            className: "cb-tool " + (t.disabled ? "cb-disabled" : ""),
            disabled: !0,
            role: "button",
            tabIndex: 0,
            onClick: t.onSelect,
            onKeyDown: (e)=>{
                "Enter" === e.key && (e.preventDefault(), t.onSelect());
            }
        }, t.content), b))));
};
fg.propTypes = {
    chartRef: P.object.isRequired,
    parsedTitle: P.string.isRequired,
    parsedSubtitle: P.string.isRequired,
    onDownloadData: P.func,
    onExpandChart: P.func,
    isInIframe: P.bool.isRequired,
    hideExpand: P.bool.isRequired,
    openChartFullScreen: P.func.isRequired,
    definition: P.string,
    noteAndSource: P.string,
    noteAndSourceShouldBeDisplayedInTooltip: P.bool.isRequired,
    tooltipContainerId: P.string,
    isSmall: P.bool.isRequired,
    exportDisabled: P.bool
};
const gg = ()=>React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 256 256"
    }, React.createElement("path", {
        d: "M126,136v64a6,6,0,0,1-12,0V150.49L44.24,220.24a6,6,0,0,1-8.48-8.48L105.51,142H56a6,6,0,0,1,0-12h64A6,6,0,0,1,126,136ZM208,34H80A14,14,0,0,0,66,48V96a6,6,0,0,0,12,0V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2V176a2,2,0,0,1-2,2H160a6,6,0,0,0,0,12h48a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Z"
    })), mg = (t)=>{
    let { title: e, subtitle: i, definition: n = null, noteAndSource: r = null, canTitleAndSubtitleBeDisplayed: o, noteAndSourceShouldBeDisplayedInTooltip: s, hideToolbox: a, exportDisabled: l, onDownloadData: h = null, onExpandChart: c = null, hideExpand: d, openChartFullScreen: u, tooltipContainerId: p, displayActionButton: f, actionButtonLabel: g, onActionButtonClick: m, isSmall: b, isFontLoaded: y, chartRef: x } = t;
    const [v, w] = React.useState(!1);
    return React.useEffect(()=>{
        w(window.location !== window.parent.location);
    }, []), React.createElement("div", {
        style: {
            display: "flex",
            marginBottom: b ? "2px" : "5px"
        }
    }, React.createElement("div", {
        style: {
            flex: "1 1 auto"
        }
    }, !Si(e) && o && React.createElement("div", {
        className: "cb-title " + (y ? "cb-font-loaded" : ""),
        dangerouslySetInnerHTML: {
            __html: e
        }
    }), !Si(i) && o && React.createElement("div", {
        className: "cb-subtitle " + (y ? "cb-font-loaded" : ""),
        dangerouslySetInnerHTML: {
            __html: i
        }
    })), !a && React.createElement("div", {
        style: {
            display: "flex",
            alignItems: "flex-start",
            flexWrap: "nowrap"
        }
    }, f && React.createElement("div", {
        role: "button",
        "aria-label": g,
        className: "cb-tool",
        tabIndex: 0,
        onClick: m,
        onKeyDown: (t)=>{
            "Enter" === t.key && (m(), t.stopPropagation());
        },
        style: {
            marginLeft: "4px"
        }
    }, React.createElement(gg, null)), (s || !ae(n)) && !b && React.createElement(dg, {
        placement: "bottom-end",
        offsetConfig: 8,
        openTrigger: "hover"
    }, React.createElement(ug, null, React.createElement("div", {
        "aria-label": "Info",
        className: "cb-tool",
        style: {
            marginLeft: "8px"
        },
        role: "button",
        tabIndex: 0
    }, React.createElement(ru, null))), React.createElement(pg, {
        tooltipContainerId: p
    }, React.createElement("div", {
        className: "cb-floating cb-tooltip",
        dangerouslySetInnerHTML: {
            __html: s ? ki("", [
                n,
                r
            ]) : n
        }
    }))), React.createElement(fg, {
        chartRef: x,
        parsedTitle: e,
        parsedSubtitle: i,
        onDownloadData: h,
        onExpandChart: c,
        isInIframe: v,
        hideExpand: d,
        openChartFullScreen: u,
        definition: n,
        noteAndSource: r,
        noteAndSourceShouldBeDisplayedInTooltip: s,
        tooltipContainerId: p,
        isSmall: b,
        exportDisabled: l
    })));
};
mg.propTypes = {
    title: P.string.isRequired,
    subtitle: P.string.isRequired,
    definition: P.string,
    noteAndSource: P.string,
    canTitleAndSubtitleBeDisplayed: P.bool.isRequired,
    noteAndSourceShouldBeDisplayedInTooltip: P.bool.isRequired,
    hideToolbox: P.bool.isRequired,
    exportDisabled: P.bool.isRequired,
    onDownloadData: P.func,
    onExpandChart: P.func,
    hideExpand: P.bool.isRequired,
    openChartFullScreen: P.func.isRequired,
    tooltipContainerId: P.string,
    displayActionButton: P.bool.isRequired,
    actionButtonLabel: P.string.isRequired,
    onActionButtonClick: P.func.isRequired,
    isSmall: P.bool.isRequired,
    isFontLoaded: P.bool.isRequired,
    chartRef: P.object.isRequired
};
var bg, yg = {
    exports: {}
};
var xg = (bg || (bg = 1, function(t) {
    !function() {
        function e(t, e) {
            document.addEventListener ? t.addEventListener("scroll", e, !1) : t.attachEvent("scroll", e);
        }
        function i(t) {
            this.g = document.createElement("div"), this.g.setAttribute("aria-hidden", "true"), this.g.appendChild(document.createTextNode(t)), this.h = document.createElement("span"), this.i = document.createElement("span"), this.m = document.createElement("span"), this.j = document.createElement("span"), this.l = -1, this.h.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;", this.i.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;", this.j.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;", this.m.style.cssText = "display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;", this.h.appendChild(this.m), this.i.appendChild(this.j), this.g.appendChild(this.h), this.g.appendChild(this.i);
        }
        function n(t, e) {
            t.g.style.cssText = "max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:" + e + ";";
        }
        function r(t) {
            var e = t.g.offsetWidth, i = e + 100;
            return t.j.style.width = i + "px", t.i.scrollLeft = i, t.h.scrollLeft = t.h.scrollWidth + 100, t.l !== e && (t.l = e, !0);
        }
        function o(t, i) {
            function n() {
                var t = o;
                r(t) && null !== t.g.parentNode && i(t.l);
            }
            var o = t;
            e(t.h, n), e(t.i, n), r(t);
        }
        function s(t, e, i) {
            e = e || {}, i = i || window, this.family = t, this.style = e.style || "normal", this.weight = e.weight || "normal", this.stretch = e.stretch || "normal", this.context = i;
        }
        var a = null, l = null, h = null, c = null;
        function d(t) {
            return null === c && (c = !!t.document.fonts), c;
        }
        function u(t, e) {
            var i = t.style, n = t.weight;
            if (null === h) {
                var r = document.createElement("div");
                try {
                    r.style.font = "condensed 100px sans-serif";
                } catch (t) {}
                h = "" !== r.style.font;
            }
            return [
                i,
                n,
                h ? t.stretch : "",
                "100px",
                e
            ].join(" ");
        }
        s.prototype.load = function(t, e) {
            var r = this, s = t || "BESbswy", h = 0, c = e || 3e3, p = (new Date).getTime();
            return new Promise(function(t, e) {
                if (d(r.context) && !function(t) {
                    return null === l && (d(t) && /Apple/.test(window.navigator.vendor) ? (t = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent), l = !!t && 603 > parseInt(t[1], 10)) : l = !1), l;
                }(r.context)) {
                    var f = new Promise(function(t, e) {
                        !function i() {
                            (new Date).getTime() - p >= c ? e(Error(c + "ms timeout exceeded")) : r.context.document.fonts.load(u(r, '"' + r.family + '"'), s).then(function(e) {
                                1 <= e.length ? t() : setTimeout(i, 25);
                            }, e);
                        }();
                    }), g = new Promise(function(t, e) {
                        h = setTimeout(function() {
                            e(Error(c + "ms timeout exceeded"));
                        }, c);
                    });
                    Promise.race([
                        g,
                        f
                    ]).then(function() {
                        clearTimeout(h), t(r);
                    }, e);
                } else !function(t) {
                    document.body ? t() : document.addEventListener ? document.addEventListener("DOMContentLoaded", function e() {
                        document.removeEventListener("DOMContentLoaded", e), t();
                    }) : document.attachEvent("onreadystatechange", function e() {
                        "interactive" != document.readyState && "complete" != document.readyState || (document.detachEvent("onreadystatechange", e), t());
                    });
                }(function() {
                    function l() {
                        var e;
                        (e = -1 != m && -1 != b || -1 != m && -1 != y || -1 != b && -1 != y) && ((e = m != b && m != y && b != y) || (null === a && (e = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent), a = !!e && (536 > parseInt(e[1], 10) || 536 === parseInt(e[1], 10) && 11 >= parseInt(e[2], 10))), e = a && (m == x && b == x && y == x || m == v && b == v && y == v || m == w && b == w && y == w)), e = !e), e && (null !== C.parentNode && C.parentNode.removeChild(C), clearTimeout(h), t(r));
                    }
                    var d = new i(s), f = new i(s), g = new i(s), m = -1, b = -1, y = -1, x = -1, v = -1, w = -1, C = document.createElement("div");
                    C.dir = "ltr", n(d, u(r, "sans-serif")), n(f, u(r, "serif")), n(g, u(r, "monospace")), C.appendChild(d.g), C.appendChild(f.g), C.appendChild(g.g), r.context.document.body.appendChild(C), x = d.g.offsetWidth, v = f.g.offsetWidth, w = g.g.offsetWidth, function t() {
                        if ((new Date).getTime() - p >= c) null !== C.parentNode && C.parentNode.removeChild(C), e(Error(c + "ms timeout exceeded"));
                        else {
                            var i = r.context.document.hidden;
                            !0 !== i && void 0 !== i || (m = d.g.offsetWidth, b = f.g.offsetWidth, y = g.g.offsetWidth, l()), h = setTimeout(t, 50);
                        }
                    }(), o(d, function(t) {
                        m = t, l();
                    }), n(d, u(r, '"' + r.family + '",sans-serif')), o(f, function(t) {
                        b = t, l();
                    }), n(f, u(r, '"' + r.family + '",serif')), o(g, function(t) {
                        y = t, l();
                    }), n(g, u(r, '"' + r.family + '",monospace'));
                });
            });
        }, t.exports = s;
    }();
}(yg)), yg.exports), vg = b(xg);

const wg = Xi({
    component: ()=>null,
    props: {}
}, j, {
    [tr.line]: {
        component: fl,
        props: {}
    },
    [tr.bar]: {
        component: xl,
        props: {}
    },
    [tr.row]: {
        component: xl,
        props: {
            horizontal: !0
        }
    },
    [tr.stackedBar]: {
        component: kl,
        props: {}
    },
    [tr.stackedRow]: {
        component: kl,
        props: {
            horizontal: !0
        }
    },
    [tr.stackedArea]: {
        component: kl,
        props: {
            area: !0
        }
    },
    [tr.map]: {
        component: React.lazy(()=>(parcelRequire("hog0o"))),
        props: {}
    },
    [tr.symbol]: {
        component: Tl,
        props: {
            symbolLayout: !0
        }
    },
    [tr.scatter]: {
        component: Tl,
        props: {}
    },
    [tr.radar]: {
        component: dl,
        props: {}
    },
    [tr.pie]: {
        component: Rl,
        props: {}
    }
}), Cg = (t)=>{
    let { type: e, data: i } = t;
    document.dispatchEvent(new CustomEvent("cbDebugInfoSent", {
        detail: {
            type: e,
            data: i
        }
    }));
}, Sg = (t)=>{
    let { id: e = "temp-id", dataSourceType: i = nr.csv.value, dotStatUrl: n = "", dotStatLang: r = "en", dotStatXAxisDimension: o, dotStatYAxisDimension: s, dotStatStructure: a, staticCsvData: l = "", forceXAxisToBeTreatedAsCategories: h = !1, csvCodeLabelMappingProjectLevel: c = null, csvCodeLabelMapping: d = null, dotStatCodeLabelMapping: u = null, dimensionCodeUsedWhenOnlyOneDimensionHasMoreThanOneMember: p = null, decimalPoint: f = pr.point.value, preParsedData: m = null, pivotData: b = !1, chartType: y, width: x, height: v, title: w = null, subtitle: C = null, definition: S = null, note: k = null, source: A = null, highlight: E = "", baseline: M = "", colorPalette: T, smallerColorPalettes: P = [], paletteStartingColor: R = null, paletteStartingColorOverride: L = null, highlightColors: O, sortBy: D = rr.none.value, sortOrder: j = or.asc.value, sortSeries: N = "", yAxisOrderOverride: I = "", maxNumberOfDecimals: B = "", noThousandsSeparator: F = !1, mapCountryDimension: z = "", displayFooterAsTooltip: H = !1, displayActionButton: U = !1, actionButtonLabel: W = "", onExpandChart: Y = null, hideExpand: _ = !1, onDownloadData: X = null, onDataReady: G = null, vars: q, lang: V, hideTitle: $ = !1, hideSubtitle: K = !1, hideToolbox: Z = !1, tooltipContainerId: Q, isSmall: J, debug: tt = !1, ...et } = t;
    const it = wg(y), nt = it.component, rt = React.useRef(null), [ot, st] = React.useState(null), [at, lt] = React.useState(i === nr.dotStat.value && !Ao(n)), [ct, dt] = React.useState(null), [ut, ft] = React.useState(null), [gt, mt] = React.useState(m), bt = React.useMemo(()=>((t, e)=>Gt((t, i)=>{
                const n = Xi("", i, e);
                return $i(new RegExp(`{${i}}`, "gi"), On($i(/\|/g, "+", `${n}`)), t);
            }, t, Ro))(n, q), [
        n,
        q
    ]), yt = React.useMemo(()=>{
        if (Ao(bt) || i === nr.csv.value) return !1;
        return "1" === new URL(bt).searchParams.get("lastNObservations");
    }, [
        bt,
        i
    ]);
    React.useEffect(()=>{
        if (Ao(bt) || i === nr.csv.value) gt || (lt(!1), dt(null), ft(null), st(null));
        else if (i === nr.dotStatSnapshot.value) {
            if (gt) return;
            lt(!0), dt(null), ft(null);
            (async ()=>{
                try {
                    const t = await Qd(`${fr}/api/public/chartConfig/${e}?preParsedDataOnly&lang=${Rn(V)}`);
                    mt(jt("preParsedData", t)), lt(!1);
                } catch (t) {
                    lt(!1), dt(yr.generic), mt(null);
                }
            })();
        } else {
            lt(!0), dt(null), ft(null);
            (async ()=>{
                try {
                    rt.current = `${bt}|${r}`, tt && Cg({
                        type: br,
                        data: {}
                    });
                    const t = await Ud(bt, r);
                    rt.current === `${bt}|${r}` && (mt(null), st(t), lt(!1));
                } catch (t) {
                    lt(!1), dt(yr.generic), st(null), tt && Cg({
                        type: gr,
                        data: {
                            error: t.message
                        }
                    });
                }
            })();
        }
    }, [
        i,
        bt,
        r,
        gt,
        e,
        V,
        tt
    ]);
    const xt = React.useMemo(()=>{
        if (i === nr.csv.value) return null;
        if (!0 === gt?.dotStatServerFetchFailed) return dt(yr.generic), null;
        if (!0 === gt?.dotStatResponseWasEmpty) return ft(yr.noData), {
            ...Ad,
            codeLabelMapping: gt.codeLabelMapping
        };
        if (!ae(gt)) return gt;
        try {
            if (!ot) return null;
            if (((t)=>!mi("observations", Hi([
                    "data",
                    "dataSets",
                    0
                ], t)))(ot)) {
                ft(yr.noData);
                const t = Od(c, u, a, r);
                return {
                    ...Ad,
                    codeLabelMapping: t
                };
            }
            return dt(null), ft(null), ((t)=>{
                let { sdmxJson: e, lang: i, dotStatStructure: n, dotStatCodeLabelMapping: r, csvCodeLabelMappingProjectLevel: o, dotStatUrlHasLastNObservationsEqOne: s, mapCountryDimension: a, pivotData: l, chartType: h, dataSourceType: c, sortBy: d, sortOrder: u, sortSeries: p = "", yAxisOrderOverride: f, forceXAxisToBeTreatedAsCategories: g, dimensionCodeUsedWhenOnlyOneDimensionHasMoreThanOneMember: m, dotStatXAxisDimension: b, dotStatYAxisDimension: y } = t;
                return e ? Le(Bd, Dd(f), Rd, jd(d, u, p), Id(h, g), Nd(0, h, g), Ld(h, c, l, b, y), Gd({
                    chartType: h,
                    mapCountryDimension: a,
                    dotStatUrlHasLastNObservationsEqOne: s,
                    dotStatCodeLabelMapping: r,
                    csvCodeLabelMappingProjectLevel: o,
                    lang: i,
                    dotStatStructure: n,
                    dimensionCodeUsedWhenOnlyOneDimensionHasMoreThanOneMember: m,
                    dotStatXAxisDimension: b,
                    dotStatYAxisDimension: y
                }))(e) : null;
            })({
                sdmxJson: ot,
                lang: r,
                dotStatStructure: a,
                dotStatCodeLabelMapping: u,
                csvCodeLabelMappingProjectLevel: c,
                dimensionCodeUsedWhenOnlyOneDimensionHasMoreThanOneMember: p,
                dotStatUrlHasLastNObservationsEqOne: yt,
                mapCountryDimension: z,
                pivotData: b,
                chartType: y,
                dataSourceType: i,
                sortBy: D,
                sortOrder: j,
                sortSeries: N,
                yAxisOrderOverride: I,
                forceXAxisToBeTreatedAsCategories: h,
                dotStatXAxisDimension: o,
                dotStatYAxisDimension: s
            });
        } catch (t) {
            return dt(yr.generic), Ad;
        }
    }, [
        i,
        y,
        yt,
        z,
        b,
        ot,
        r,
        a,
        D,
        j,
        N,
        I,
        u,
        c,
        p,
        gt,
        h,
        o,
        s
    ]), vt = React.useMemo(()=>{
        if (i === nr.dotStat.value || i === nr.dotStatSnapshot.value) return null;
        if (!Ao(gt) && i === nr.csv.value) return gt;
        try {
            const t = zd({
                staticCsvData: l,
                chartType: y,
                dataSourceType: i,
                pivotData: b,
                csvCodeLabelMappingProjectLevel: c,
                csvCodeLabelMapping: d,
                sortBy: D,
                sortOrder: j,
                sortSeries: N,
                yAxisOrderOverride: I,
                forceXAxisToBeTreatedAsCategories: h,
                vars: q,
                lang: V
            });
            return dt(null), ft(null), t;
        } catch (t) {
            return dt(yr.generic), Ad;
        }
    }, [
        i,
        gt,
        y,
        d,
        c,
        b,
        D,
        j,
        N,
        l,
        q,
        I,
        h,
        V
    ]), wt = React.useMemo(()=>i === nr.dotStat.value || i === nr.dotStatSnapshot.value ? xt : vt, [
        i,
        xt,
        vt
    ]);
    React.useEffect(()=>{
        if (G && wt && G(wt), Ao(wt)) return;
        if (at) return dt(null), void (tt && Cg({
            type: br,
            data: {}
        }));
        const t = Ai(wt.categories), e = Ai(wt.series);
        if (t * e > 15e3) return dt(yr.generic), void (tt && Cg({
            type: mr,
            data: {
                numberOfCategory: t,
                numberOfSeries: e
            }
        }));
        tt && (Ao(wt?.dotStatInfo) ? Cg({
            type: br,
            data: {}
        }) : Cg({
            type: gr,
            data: wt.dotStatInfo
        }));
    }, [
        wt,
        G,
        tt,
        at
    ]);
    const [Ct, St] = React.useState(V);
    React.useEffect(()=>St(V), [
        V
    ]), React.useEffect(()=>{
        if (gt) {
            const { varsThatCauseNewPreParsedDataFetch: t } = gt;
            if (Le(Kt(pt(!0)), Rt((e)=>On(t[e] ?? "") !== $i(/\+/g, "|", On(q[e] ?? ""))))(ht(t || {})) || V !== Ct) {
                const t = Le(ki("/"), ti((t)=>"-" === t), Rt((t)=>Si(t) ? "-" : t), ne)(q), i = `${e}${Si(t) ? "" : `/${t}`}`;
                lt(!0), dt(null), ft(null);
                (async ()=>{
                    try {
                        rt.current = i;
                        const t = await Qd(`${fr}/api/public/chartConfig/${i}?preParsedDataOnly&lang=${Rn(V)}`);
                        rt.current === i && (mt(jt("preParsedData", t)), lt(!1));
                    } catch (t) {
                        dt(yr.generic), lt(!1);
                    }
                })();
            }
        }
    }, [
        e,
        q,
        V,
        Ct,
        gt
    ]);
    const [At, Et] = React.useState(null), [Mt, Tt] = React.useState(null), [Pt, Lt] = React.useState(v), Ot = React.useMemo(()=>{
        const t = kt(ni(pt("<p></p>"), Ao), [
            ol({
                string: k,
                vars: q,
                latestMin: wt?.latestYMin,
                latestMax: wt?.latestYMax,
                mapping: wt?.codeLabelMapping
            }),
            ol({
                string: A,
                vars: q,
                latestMin: wt?.latestYMin,
                latestMax: wt?.latestYMax,
                mapping: wt?.codeLabelMapping
            })
        ]);
        return Si(t) ? null : ki("", t);
    }, [
        k,
        A,
        q,
        wt?.latestYMin,
        wt?.latestYMax,
        wt?.codeLabelMapping
    ]), Dt = React.useMemo(()=>{
        const t = ol({
            string: S,
            vars: q,
            latestMin: wt?.latestYMin,
            latestMax: wt?.latestYMax,
            mapping: wt?.codeLabelMapping
        });
        return ni(pt("<p></p>"), Ao)(t) ? null : t;
    }, [
        S,
        q,
        wt?.latestYMin,
        wt?.latestYMax,
        wt?.codeLabelMapping
    ]), Nt = React.useRef(null), It = React.useRef(null), Bt = React.useMemo(()=>$ ? "" : ol({
            string: w,
            vars: q,
            latestMin: wt?.latestYMin,
            latestMax: wt?.latestYMax,
            mapping: wt?.codeLabelMapping,
            replaceMissingVarByBlank: !0
        }), [
        w,
        q,
        wt?.latestYMin,
        wt?.latestYMax,
        wt?.codeLabelMapping,
        $
    ]), Ft = React.useMemo(()=>K ? "" : ol({
            string: C,
            vars: q,
            latestMin: wt?.latestYMin,
            latestMax: wt?.latestYMax,
            mapping: wt?.codeLabelMapping,
            replaceMissingVarByBlank: !0
        }), [
        C,
        q,
        wt?.latestYMin,
        wt?.latestYMax,
        wt?.codeLabelMapping,
        K
    ]), zt = !(React.useMemo(()=>al(w) || al(C), [
        w,
        C
    ]) && at), Ht = (()=>{
        const [t, e] = React.useState(!1);
        return React.useEffect(()=>{
            (async ()=>{
                const t = [
                    new vg("Noto Sans", {
                        weight: 400
                    }).load(),
                    new vg("Noto Sans", {
                        weight: 600
                    }).load(),
                    new vg("Noto Sans", {
                        weight: 800
                    }).load(),
                    new vg("Noto Sans Display", {
                        weight: 400
                    }).load(),
                    new vg("Noto Sans Display", {
                        weight: 500
                    }).load()
                ];
                try {
                    await Promise.all(t), e(!0);
                } catch  {}
            })();
        }, []), t;
    })();
    React.useEffect(()=>{
        const t = !H && v - It.current.clientHeight >= 280;
        Et(Nt.current.clientHeight), Tt(t ? It.current.clientHeight : 0), Lt(t ? v - Nt.current.clientHeight - It.current.clientHeight : v - Nt.current.clientHeight);
    }, [
        x,
        v,
        Bt,
        Ft,
        k,
        A,
        H
    ]);
    const Ut = React.useMemo(()=>Le(kt(Si), Qi("|"))(rl(E, q)), [
        E,
        q
    ]), Wt = React.useMemo(()=>Le(kt(Si), Qi("|"))(rl(M, q)), [
        M,
        q
    ]), { mapColorValueSteps: Yt } = et, _t = React.useMemo(()=>Kd({
            chartType: y,
            mapColorValueSteps: Yt,
            maxNumberOfDecimals: B,
            noThousandsSeparator: F,
            codeLabelMapping: wt?.codeLabelMapping,
            decimalPoint: f,
            areCategoriesNumbers: wt?.areCategoriesNumbers,
            areCategoriesDates: wt?.areCategoriesDates,
            categoriesDateFomat: wt?.categoriesDateFomat,
            lang: V
        }), [
        y,
        Yt,
        B,
        F,
        wt?.codeLabelMapping,
        f,
        wt?.areCategoriesNumbers,
        wt?.areCategoriesDates,
        wt?.categoriesDateFomat,
        V
    ]), Xt = React.useRef(null), qt = Ai(wt?.categories || []) * Ai(wt?.series || []), Vt = !at && ae(ut) && ae(ct) && !ae(wt) && qt <= 15e3, [$t, Zt] = React.useState(!1), [Qt, Jt] = React.useState(0);
    React.useEffect(()=>{
        Jt(window.screen.height);
    }, []);
    const te = React.useCallback(()=>{
        Zt(!1);
    }, []), ee = !ae(Ot) && (0 === Mt || H), ie = React.useMemo(()=>Ao(Bt) && Ao(Ft) ? ()=>!1 : (t)=>("xAxis" === t?.coll || y === tr.pie && !t) && (Ao(Ft) ? `${Jn(Bt)}"\n"Category` : Ao(Bt) ? `${Jn(Ft)}"\n"Category` : `${Jn(Bt)}"\n"${Jn(Ft)}"\n"Category`), [
        Bt,
        Ft,
        y
    ]), re = React.useMemo(()=>((t, e, i, n, r)=>{
            if (!Ao(e)) return li((t)=>Ai(t) <= i, [
                t,
                ...e
            ]) || t;
            const o = r || n;
            if (o) {
                const e = di(pt(o), t);
                if (-1 !== e) return Le(Dn, Re, Ji(e))(t);
            }
            return t;
        })(T, P, Ai(y === tr.pie ? wt?.categories : wt?.series || []), R, L), [
        T,
        P,
        wt?.series,
        wt?.categories,
        y,
        R,
        L
    ]), oe = React.useCallback(()=>{
        document.dispatchEvent(new CustomEvent("cbChartActionButtonClicked", {
            detail: {
                chartId: e || ""
            }
        }));
    }, [
        e
    ]), se = !($t || !Ao(Q));
    return React.createElement("div", null, React.createElement("div", {
        ref: Nt,
        style: ae(At) ? {
            width: x,
            position: "fixed",
            visibility: "hidden"
        } : {}
    }, !(Ao(Bt) && Ao(Ft) && Z) && React.createElement(mg, {
        title: Bt,
        subtitle: Ft,
        definition: Dt,
        noteAndSource: Ot,
        canTitleAndSubtitleBeDisplayed: zt,
        noteAndSourceShouldBeDisplayedInTooltip: ee,
        hideToolbox: Z,
        exportDisabled: !Vt,
        onDownloadData: X,
        onExpandChart: Y,
        hideExpand: _,
        openChartFullScreen: ()=>{
            Zt(!0), Xt.current?.chart.fullscreen.open();
        },
        displayActionButton: U,
        actionButtonLabel: W,
        onActionButtonClick: oe,
        tooltipContainerId: Q,
        isSmall: J,
        isFontLoaded: Ht,
        chartRef: Xt
    })), !Vt && React.createElement(Zd, {
        height: Pt
    }, at && React.createElement(Vd, null), !ae(ct) && ct, !ae(ut) && ut), !ae(Mt) && Pt && Vt && React.createElement(React.Suspense, {
        fallback: React.createElement(Zd, {
            height: Pt
        }, React.createElement(Vd, null))
    }, React.createElement(nt, g({}, it.props, {
        ref: Xt,
        width: x,
        height: $t ? Qt : Pt,
        title: $t ? Bt : "",
        subtitle: $t ? Ft : "",
        data: wt,
        highlight: Ut,
        baseline: Wt,
        colorPalette: re,
        highlightColors: O,
        formatters: _t,
        fullscreenClose: te,
        isFullScreen: $t,
        tooltipOutside: se,
        csvExportcolumnHeaderFormatter: ie,
        isSmall: J
    }, et))), React.createElement("div", {
        ref: It,
        className: "cb-footer " + (Ht ? "cb-font-loaded" : ""),
        style: ae(Mt) || 0 === Mt ? {
            width: x,
            position: "fixed",
            visibility: "hidden"
        } : {}
    }, React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: Ot
        }
    })));
};
Sg.propTypes = {
    id: P.string,
    dataSourceType: P.string,
    dotStatUrl: P.string,
    dotStatLang: P.string,
    dotStatXAxisDimension: P.string,
    dotStatYAxisDimension: P.string,
    dotStatStructure: P.object,
    staticCsvData: P.string,
    forceXAxisToBeTreatedAsCategories: P.bool,
    csvCodeLabelMappingProjectLevel: P.string,
    csvCodeLabelMapping: P.string,
    dotStatCodeLabelMapping: P.string,
    dimensionCodeUsedWhenOnlyOneDimensionHasMoreThanOneMember: P.string,
    decimalPoint: P.string,
    preParsedData: P.object,
    pivotData: P.bool,
    chartType: P.oneOf(ne(tr)).isRequired,
    width: P.number.isRequired,
    height: P.number.isRequired,
    title: P.string,
    subtitle: P.string,
    definition: P.string,
    note: P.string,
    source: P.string,
    highlight: P.string,
    baseline: P.string,
    colorPalette: P.array.isRequired,
    smallerColorPalettes: P.array,
    paletteStartingColor: P.string,
    paletteStartingColorOverride: P.string,
    highlightColors: P.array.isRequired,
    sortBy: P.string,
    sortOrder: P.string,
    sortSeries: P.string,
    yAxisOrderOverride: P.string,
    maxNumberOfDecimals: P.string,
    noThousandsSeparator: P.bool,
    mapCountryDimension: P.string,
    displayFooterAsTooltip: P.bool,
    displayActionButton: P.bool,
    actionButtonLabel: P.string,
    onExpandChart: P.func,
    hideExpand: P.bool,
    onDownloadData: P.func,
    onDataReady: P.func,
    vars: P.object.isRequired,
    lang: P.string.isRequired,
    hideTitle: P.bool,
    hideSubtitle: P.bool,
    hideToolbox: P.bool,
    tooltipContainerId: P.string,
    isSmall: P.bool.isRequired,
    debug: P.bool
};
var kg = React.memo(Sg);
const Ag = (t, e, i, n)=>i ? Le((t)=>`${t}px`, jn(()=>n, F(33)), jn(()=>!e && !Ao(t), F(18)))(51) : Le((t)=>`${t}px`, jn(()=>n, F(33)), jn(()=>!Ao(t), F(18)))(43), Eg = (t)=>{
    let { label: e = null, hideTitle: i = !1, isStandalone: n = !1, frequencies: r = [] } = t;
    return React.createElement("div", {
        style: {
            flex: "1",
            minWidth: "200px",
            minHeight: Ag(e, i, n, Ai(r) > 1)
        }
    });
};
Eg.propTypes = {
    label: P.string,
    hideTitle: P.bool,
    isStandalone: P.bool,
    frequencies: P.array
};

const Mg = React.lazy(()=>(parcelRequire("3YXTy")));

const Tg = React.lazy(()=>(parcelRequire("9CTJZ"))), Pg = {
    [lr.timeSlider.value]: Mg,
    [lr.select.value]: Tg
}, Rg = jt(j, Pg), Lg = (t)=>{
    let { controls: e = [], vars: i, changeVar: n, codeLabelMapping: r = null, lang: o, isSmall: s } = t;
    const a = React.useMemo(()=>St((t)=>mi(t.type, lr), e), [
        e
    ]);
    return Si(a) ? null : React.createElement(React.Fragment, null, React.createElement("div", {
        className: "cb-controls-separator " + (s ? "cb-small" : "")
    }), React.createElement("div", {
        className: "cb-controls " + (s ? "cb-small" : ""),
        style: {
            display: "flex",
            flexWrap: "wrap"
        }
    }, Rt((t)=>{
        const e = Rg(t.type);
        return React.createElement(React.Suspense, {
            key: t.id,
            fallback: React.createElement(Eg, t)
        }, React.createElement(e, g({
            key: t.id,
            vars: i,
            changeVar: n,
            codeLabelMapping: r,
            lang: o
        }, zi([
            "codeLabelMapping"
        ], t))));
    }, e)));
};
Lg.propTypes = {
    controls: P.array,
    vars: P.object.isRequired,
    changeVar: P.func.isRequired,
    codeLabelMapping: P.object,
    lang: P.string.isRequired,
    isSmall: P.bool.isRequired
};
const Og = (t)=>{
    Ao(t) || document.dispatchEvent(new CustomEvent("cbTrackingEvent", {
        detail: {
            event: "chart_view",
            chart_id: t,
            chart_techno: "chart_builder",
            chart_type: "visualisation",
            chart_url: `https://oecdch.art/${t}`
        }
    }));
}, Dg = (t)=>{
    let { width: e = null, height: i = null, vars: n, changeVar: r, controls: o = [], hideControls: s = !1, lang: a = "default", ...l } = t;
    const { width: h, height: c, ref: d } = Vn(), { width: u, height: p, ref: f } = Vn(), m = React.useMemo(()=>ll(h, c), [
        h,
        c
    ]), [b, y] = React.useState(null), x = React.useMemo(()=>Ao(o) || s ? null : (t)=>{
            y(jt("codeLabelMapping", t));
        }, [
        o,
        s
    ]);
    return React.useEffect(()=>{
        Og(l.id);
    }, [
        l.id
    ]), React.createElement("div", {
        style: {
            width: "100%",
            maxWidth: e || "100%",
            height: "unset"
        }
    }, React.createElement("div", {
        ref: d,
        style: {
            position: "relative",
            width: "100%",
            height: i
        }
    }, React.createElement("div", {
        style: {
            position: "relative",
            width: "0px",
            height: "0px",
            overflow: "visible"
        }
    }, c && React.createElement("div", {
        className: "cb-container " + (m ? "cb-small" : ""),
        style: {
            width: h,
            height: c,
            boxSizing: "border-box"
        }
    }, React.createElement("div", {
        ref: f,
        style: {
            wdth: "100%",
            height: "100%"
        }
    }, p && React.createElement(kg, g({
        width: u,
        height: p,
        vars: n,
        lang: a,
        onDataReady: x,
        isSmall: m
    }, l)))))), !Ao(o) && !s && React.createElement(Lg, {
        controls: o,
        vars: n,
        changeVar: r,
        codeLabelMapping: b,
        lang: a,
        isSmall: m
    }));
};
Dg.propTypes = {
    width: P.oneOfType([
        P.string,
        P.number
    ]),
    height: P.oneOfType([
        P.string,
        P.number
    ]),
    vars: P.object.isRequired,
    changeVar: P.func.isRequired,
    controls: P.array,
    hideControls: P.bool,
    lang: P.string
};
const jg = (t)=>{
    let { width: e = null, vars: i, changeVar: n, controls: r = [], hideControls: o = !1, lang: s = "default", ...a } = t;
    const { width: l, height: h, ref: c } = Vn(), { width: d, height: u, ref: p } = Vn(), { height: f, ref: m } = Vn(), b = React.useMemo(()=>h ? h - f > 280 ? h - f : h : null, [
        h,
        f
    ]), y = React.useMemo(()=>ll(l, h), [
        l,
        h
    ]), [x, v] = React.useState(null), w = React.useMemo(()=>Ao(r) || o ? null : (t)=>{
            v(jt("codeLabelMapping", t));
        }, [
        r,
        o
    ]);
    return React.useEffect(()=>{
        Og(a.id);
    }, [
        a.id
    ]), React.createElement("div", {
        ref: c,
        style: {
            position: "relative",
            width: "100%",
            maxWidth: e || "100%",
            height: "100%"
        }
    }, React.createElement("div", {
        style: {
            position: "relative",
            width: "0px",
            height: "0px",
            overflow: "visible"
        }
    }, b && React.createElement("div", {
        className: "cb-container " + (y ? "cb-small" : ""),
        style: {
            width: l,
            height: b,
            boxSizing: "border-box"
        }
    }, React.createElement("div", {
        ref: p,
        style: {
            wdth: "100%",
            height: "100%"
        }
    }, u && React.createElement(kg, g({
        width: d,
        height: u,
        vars: i,
        lang: s,
        onDataReady: w,
        isSmall: y
    }, zi([
        "height"
    ], a)))))), React.createElement("div", {
        ref: m,
        style: {
            position: "relative",
            top: b && h !== b ? b : "-1000px",
            visibility: b && h !== b ? "visible" : "hidden"
        }
    }, !Ao(r) && !o && React.createElement(Lg, {
        controls: r,
        vars: i,
        changeVar: n,
        codeLabelMapping: x,
        lang: s,
        isSmall: y
    })));
};
jg.propTypes = {
    width: P.oneOfType([
        P.string,
        P.number
    ]),
    vars: P.object.isRequired,
    changeVar: P.func.isRequired,
    controls: P.array,
    hideControls: P.bool,
    lang: P.string
};
const Ng = (t)=>{
    let { height: e = null, var1: i = null, var2: n = null, var3: r = null, var4: o = null, var5: s = null, var6: a = null, var7: l = null, var8: h = null, var9: c = null, var10: d = null, var1DefaultValue: u = null, var2DefaultValue: p = null, var3DefaultValue: f = null, var4DefaultValue: m = null, var5DefaultValue: b = null, var6DefaultValue: y = null, var7DefaultValue: x = null, var8DefaultValue: v = null, var9DefaultValue: w = null, var10DefaultValue: C = null, ...S } = t;
    const k = e ? Dg : jg, [A, E] = React.useState({
        var1: Ao(i) ? u ?? "" : decodeURI(i),
        var2: Ao(n) ? p ?? "" : decodeURI(n),
        var3: Ao(r) ? f ?? "" : decodeURI(r),
        var4: Ao(o) ? m ?? "" : decodeURI(o),
        var5: Ao(s) ? b ?? "" : decodeURI(s),
        var6: Ao(a) ? y ?? "" : decodeURI(a),
        var7: Ao(l) ? x ?? "" : decodeURI(l),
        var8: Ao(h) ? v ?? "" : decodeURI(h),
        var9: Ao(c) ? w ?? "" : decodeURI(c),
        var10: Ao(d) ? C ?? "" : decodeURI(d)
    });
    React.useEffect(()=>{
        E({
            var1: Ao(i) ? u ?? "" : decodeURI(i),
            var2: Ao(n) ? p ?? "" : decodeURI(n),
            var3: Ao(r) ? f ?? "" : decodeURI(r),
            var4: Ao(o) ? m ?? "" : decodeURI(o),
            var5: Ao(s) ? b ?? "" : decodeURI(s),
            var6: Ao(a) ? y ?? "" : decodeURI(a),
            var7: Ao(l) ? x ?? "" : decodeURI(l),
            var8: Ao(h) ? v ?? "" : decodeURI(h),
            var9: Ao(c) ? w ?? "" : decodeURI(c),
            var10: Ao(d) ? C ?? "" : decodeURI(d)
        });
    }, [
        i,
        n,
        r,
        o,
        s,
        a,
        l,
        h,
        c,
        d,
        u,
        p,
        f,
        m,
        b,
        y,
        x,
        v,
        w,
        C
    ]);
    const M = React.useCallback((t, e)=>{
        E(he(t, e));
    }, []);
    return React.createElement(k, g({
        height: e,
        vars: A,
        changeVar: M
    }, S));
};
Ng.propTypes = {
    height: P.oneOfType([
        P.string,
        P.number
    ]),
    var1: P.string,
    var2: P.string,
    var3: P.string,
    var4: P.string,
    var5: P.string,
    var6: P.string,
    var7: P.string,
    var8: P.string,
    var9: P.string,
    var10: P.string,
    var1DefaultValue: P.string,
    var2DefaultValue: P.string,
    var3DefaultValue: P.string,
    var4DefaultValue: P.string,
    var5DefaultValue: P.string,
    var6DefaultValue: P.string,
    var7DefaultValue: P.string,
    var8DefaultValue: P.string,
    var9DefaultValue: P.string,
    var10DefaultValue: P.string
};
const Ig = (t)=>{
    let { chartId: e, language: i, ...n } = t;
    const [r, o] = React.useState(null), [s, a] = React.useState(null), [l, h] = React.useState({
        chartConfig: null,
        isLoading: !0,
        hasFetchFailed: !1
    }), c = React.useRef(null);
    React.useEffect(()=>{
        o(e);
    }, [
        e
    ]), React.useEffect(()=>{
        a(i);
    }, [
        i
    ]);
    const d = React.useMemo(()=>Gt((t, e)=>ae(jt(e, n)) ? t : he(e, jt(e, n), t), {}, Ro), [
        ...Rt(jt(j, n), Ro)
    ]), u = React.useCallback(async (t, e, i)=>{
        try {
            h(Le(he("chartConfig", null), he("isLoading", !0)));
            const n = Le(ki("/"), ti((t)=>"-" === t), Rt((t)=>Ao(jt(t, i)) ? "-" : jt(t, i)))(Ro), r = e ? `?lang=${Rn(e)}` : "", o = `${t}${Si(n) ? "" : `/${n}`}${r}`;
            c.current = o;
            const s = await Qd(`${fr}/api/public/chartConfig/${o}`);
            o === c.current && h(Le(he("hasFetchFailed", !1), he("chartConfig", s), he("isLoading", !1)));
        } catch  {
            h(Le(he("hasFetchFailed", !0), he("isLoading", !1)));
        }
    }, []);
    React.useEffect(()=>{
        e && (r === e && s === i || u(e, i, d));
    }, [
        r,
        e,
        s,
        i,
        d,
        u,
        l.chartConfig
    ]);
    const p = React.useMemo(()=>Gt((t, e)=>he(e, ae(jt(e, d)) ? Xi(null, e, l.chartConfig) : $i(/\+/g, "|", jt(e, d)), t), {}, Ro), [
        l.chartConfig,
        d
    ]);
    return e ? l.isLoading || l.hasFetchFailed || mi("error", l.chartConfig) ? React.createElement(Zd, null, l.isLoading ? React.createElement(Vd, null) : React.createElement("div", {
        className: "cb-container"
    }, mi("error", l.chartConfig) ? l.chartConfig.error : yr.generic)) : React.createElement(Ng, g({}, zi(Ro, l.chartConfig), p, zi([
        ...Ro
    ], n))) : null;
};
Ig.propTypes = {
    chartId: P.string.isRequired,
    ...pi(Rt((t)=>[
            t,
            P.string
        ], Ro))
};
class Bg extends React.Component {
    constructor(t){
        super(t), this.state = {
            hasError: !1
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: !0
        };
    }
    componentDidCatch() {}
    render() {
        const { state: t, props: { fallback: e, children: i } } = this;
        return t.hasError ? e : i;
    }
}
Bg.propTypes = {
    fallback: P.oneOfType([
        P.arrayOf(P.node),
        P.node
    ]),
    children: P.oneOfType([
        P.arrayOf(P.node),
        P.node
    ])
};
const Fg = (t)=>{
    let { width: e = null, height: i = null, lazyLoad: n = !0, displayActionButton: r = !1, hideTitle: o = !1, hideSubtitle: s = !1, hideToolbox: a = !1, ...l } = t;
    const h = React.useMemo(()=>tl(e) ? Number(e) : e, [
        e
    ]), c = React.useMemo(()=>tl(i) ? Number(i) : null, [
        i
    ]), d = React.useMemo(()=>!0 === r || "true" === r || "" === r, [
        r
    ]), u = React.useMemo(()=>!0 === o || "true" === o || "" === o, [
        o
    ]), p = React.useMemo(()=>!0 === s || "true" === s || "" === s, [
        s
    ]), f = React.useMemo(()=>!0 === a || "true" === a || "" === a, [
        a
    ]);
    return !1 === n || "false" === n ? React.createElement(Bg, {
        fallback: React.createElement(Zd, null, yr.generic)
    }, React.createElement(Ig, g({
        width: h,
        height: c,
        displayActionButton: d,
        hideTitle: u,
        hideSubtitle: p,
        hideToolbox: f
    }, l))) : React.createElement(Bg, {
        fallback: React.createElement(Zd, null, yr.generic)
    }, React.createElement(O.LazyLoadComponent, {
        placeholder: React.createElement("div", {
            style: c ? {
                minHeight: c
            } : {
                height: "100%"
            }
        })
    }, React.createElement(Ig, g({
        width: h,
        height: c,
        displayActionButton: d,
        hideTitle: u,
        hideSubtitle: p,
        hideToolbox: f
    }, l))));
};
Fg.propTypes = {
    chartId: P.string.isRequired,
    ...pi(Rt((t)=>[
            t,
            P.string
        ], Ro)),
    width: P.oneOfType([
        P.string,
        P.number
    ]),
    height: P.oneOfType([
        P.string,
        P.number
    ]),
    lazyLoad: P.oneOfType([
        P.bool,
        P.string
    ]),
    language: P.string,
    displayActionButton: P.oneOfType([
        P.bool,
        P.string
    ]),
    actionButtonLabel: P.string,
    hideTitle: P.bool,
    hideSubtitle: P.bool,
    hideToolbox: P.bool,
    tooltipContainerId: P.string
};

const zg = React.lazy(()=>(parcelRequire("3YXTy")));

const Hg = React.lazy(()=>(parcelRequire("9CTJZ"))), Ug = {
    [lr.select.value]: Hg,
    [lr.selectChart.value]: Hg,
    [lr.timeSlider.value]: zg
}, Wg = jt(j, Ug), Yg = (t)=>{
    const [e, ...i] = Dn(Pd(t));
    return Le(Mo((t, e, i)=>he(Fi(i, Ro), e, t), j, i), he("chartId", e))({});
}, _g = (t)=>{
    let { id: e = "", dataComponentId: i = "", type: n, codeLabelMapping: r, hideTitle: o = !1, ...s } = t;
    const a = Wg(n), l = React.useMemo(()=>({
            var1: s.var1,
            var2: s.var2,
            var3: s.var3,
            var4: s.var4,
            var5: s.var5,
            var6: s.var6,
            var7: s.var7,
            var8: s.var8,
            var9: s.var9,
            var10: s.var10
        }), [
        s.var1,
        s.var2,
        s.var3,
        s.var4,
        s.var5,
        s.var6,
        s.var7,
        s.var8,
        s.var9,
        s.var10
    ]), [h, c] = React.useState(l);
    React.useEffect(()=>{
        c(l);
    }, [
        l
    ]);
    const d = React.useMemo(()=>{
        if (Ao(r)) return {};
        if (n === lr.selectChart.value) {
            const t = Rt((t)=>Ai(t) <= 2 ? t : [
                    ki("|", xi(t)),
                    ei(t)
                ], Pd(r));
            return kd(t);
        }
        return kd(Td(r));
    }, [
        r,
        n
    ]), [u, p] = React.useState(()=>Ie([
            [
                pt(lr.select.value),
                qt({
                    [s.varName]: l[s.varName] || s.varDefaultValue || "",
                    ...s.displayStars ? {
                        [s.starsVarName]: l[s.starsVarName] || ""
                    } : {}
                })
            ],
            [
                pt(lr.selectChart.value),
                qt(Yg(s.varDefaultValue || ""))
            ],
            [
                pt(lr.timeSlider.value),
                qt({
                    [s.minVarName]: l[s.minVarName] || s.minVarDefaultValue || "",
                    ...s.isRange ? {
                        [s.maxVarName]: l[s.maxVarName] || s.maxVarDefaultValue || ""
                    } : {}
                })
            ],
            [
                D,
                qt({})
            ]
        ])(n)), f = React.useCallback((t, e)=>{
        n !== lr.selectChart.value ? p(he(t, e)) : p(Yg(e));
    }, [
        n
    ]), m = React.useRef(!0);
    return React.useEffect(()=>{
        ui((t)=>{
            let [r, o] = t;
            (o || n !== lr.selectChart.value) && document.dispatchEvent(new CustomEvent("cbControlValueChange", {
                detail: {
                    controlId: e || "",
                    dataComponentId: i || "",
                    varName: r,
                    varValue: "-" === o ? "" : o,
                    isInitialChange: m.current
                }
            }));
        }, Ln(u)), m.current = !1;
    }, [
        e,
        i,
        u,
        n
    ]), React.useEffect(()=>{
        n === lr.select.value && (l[s.varName] && l[s.varName] !== h[s.varName] && f(s.varName, l[s.varName]), s.displayStars && l[s.starsVarName] && l[s.starsVarName] !== h[s.starsVarName] && f(s.starsVarName, l[s.starsVarName])), n === lr.timeSlider.value && (l[s.minVarName] && l[s.minVarName] !== h[s.minVarName] && f(s.minVarName, l[s.minVarName]), l[s.maxVarName] && l[s.maxVarName] !== h[s.maxVarName] && f(s.maxVarName, l[s.maxVarName]));
    }, [
        n,
        l,
        h,
        f,
        s.varName,
        s.minVarName,
        s.maxVarName,
        s.displayStars,
        s.starsVarName
    ]), React.createElement(React.Suspense, {
        fallback: React.createElement(Eg, g({}, s, {
            hideTitle: o,
            isStandalone: !0
        }))
    }, React.createElement(a, g({
        vars: u,
        changeVar: f,
        codeLabelMapping: d,
        type: n
    }, zi([
        "codeLabelMapping"
    ], s), {
        hideTitle: o,
        isStandalone: !0
    })));
};
_g.propTypes = {
    id: P.string,
    dataComponentId: P.string,
    hideTitle: P.bool,
    type: P.string.isRequired,
    codeLabelMapping: P.string.isRequired
};
const Xg = (t)=>{
    let { controlId: e, dataComponentId: i = "", hideTitle: n = !1, initialValue: r = null, language: o = null, ...s } = t;
    const [a, l] = React.useState(null), [h, c] = React.useState(null), [d, u] = React.useState({
        controlConfig: null,
        isLoading: !0,
        hasFetchFailed: !1
    }), p = React.useRef(null);
    React.useEffect(()=>{
        l(e);
    }, [
        e
    ]), React.useEffect(()=>{
        c(o);
    }, [
        o
    ]);
    const f = React.useCallback(async (t, e)=>{
        try {
            u(Le(he("controlConfig", null), he("isLoading", !0)));
            const i = `${t}${e ? `?lang=${Rn(e)}` : ""}`;
            p.current = i;
            const n = await Qd(`${fr}/api/public/control/${i}`);
            i === p.current && u(Le(he("hasFetchFailed", !1), he("controlConfig", n), he("isLoading", !1)));
        } catch  {
            u(Le(he("hasFetchFailed", !0), he("isLoading", !1)));
        }
    }, []);
    React.useEffect(()=>{
        e && (a === e && h === o || f(e, o));
    }, [
        a,
        e,
        h,
        o,
        f
    ]);
    const m = React.useMemo(()=>!0 === n || "true" === n || "" === n, [
        n
    ]);
    return e ? d.isLoading || d.hasFetchFailed ? React.createElement(Eg, {
        hideTitle: m,
        isStandalone: !0
    }) : React.createElement(_g, g({
        id: e,
        dataComponentId: i,
        hideTitle: m,
        initialValue: r
    }, d.controlConfig, s)) : null;
};
Xg.propTypes = {
    controlId: P.string.isRequired,
    dataComponentId: P.string,
    hideTitle: P.bool,
    initialValue: P.string,
    language: P.string,
    ...pi(Rt((t)=>[
            t,
            P.string
        ], Ro))
}, customElements.define("oecd-chart", p(Fg, React, ReactDOM, {
    dashStyleAttributes: !0
})), customElements.define("oecd-control", p(Xg, React, ReactDOM, {
    dashStyleAttributes: !0
}));

});
parcelRegister("hog0o", function(module, exports) {


module.exports = (parcelRequire("8qyMX"))((parcelRequire("kg4TJ")).resolve("ltOxm")).then(()=>parcelRequire('a5ZyG'));

});

parcelRegister("3YXTy", function(module, exports) {


module.exports = (parcelRequire("8qyMX"))((parcelRequire("kg4TJ")).resolve("k81OU")).then(()=>parcelRequire('3Gx97'));

});

parcelRegister("9CTJZ", function(module, exports) {


module.exports = (parcelRequire("8qyMX"))((parcelRequire("kg4TJ")).resolve("eWAqa")).then(()=>parcelRequire('ibXaN'));

});


})();
//# sourceMappingURL=oecd-chart-latest.453f0488.js.map
